(function(global, factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else {
    global.CRDUtils = factory();
  }
})(this, function() {
  'use strict';

  return {};
});
;
"use strict";
var ArrayUtils = (function () {
    function ArrayUtils() {
    }
    ArrayUtils.joinDistinct = function (attr) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var retorno = new Array();
        var attrUniq = new Array();
        args.forEach(function (arg) {
            arg.forEach(function (item) {
                if (!_.contains(attrUniq, item[attr])) {
                    attrUniq.push(item[attr]);
                    retorno.push(item);
                }
            });
        });
        return retorno;
    };
    return ArrayUtils;
}());
//# sourceMappingURL=array-utils.js.map;
"use strict";
var CompareToBuilder = (function () {
    function CompareToBuilder() {
        this.comparison = 0;
    }
    CompareToBuilder.prototype.append = function (lhs, rhs) {
        if (this.comparison != 0) {
            return this;
        }
        if (lhs === rhs) {
            return this;
        }
        if (lhs == undefined) {
            this.comparison = -1;
            return this;
        }
        if (rhs == undefined) {
            this.comparison = 1;
            return this;
        }
        this.comparison = this.compareTo(lhs, rhs);
        return this;
    };
    CompareToBuilder.prototype.build = function () {
        return this.comparison;
    };
    CompareToBuilder.prototype.compareTo = function (lhs, rhs) {
        if (lhs < rhs) {
            return -1;
        }
        if (lhs > rhs) {
            return 1;
        }
        return 0;
    };
    return CompareToBuilder;
}());
//# sourceMappingURL=compare-to-builder.js.map;
(function(global, factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['moment'], factory);
  } else {
    global.CRDUtils.Conversor = factory(moment);
  }
})(this, function(moment) {
  'use strict';

  function dateToString(valor) {
    return valor ? moment(valor).format('YYYY-MM-DD') : null;
  }

  function stringToDate(valor) {
    return valor ? moment(valor).toDate() : null;
  }

  var conversor = {
    dateToString: dateToString,
    stringToDate: stringToDate
  };

  return conversor;
});
;
"use strict";
var ConverterParameterObjectToUrlUtils = (function () {
    function ConverterParameterObjectToUrlUtils() {
    }
    ConverterParameterObjectToUrlUtils.atributoCodigo = function (data) {
        return data ? data.codigo : undefined;
    };
    ConverterParameterObjectToUrlUtils.atributoCodigoArray = function (data) {
        return ConverterParameterObjectToUrlUtils.extrairAtributo(data, 'codigo');
    };
    ConverterParameterObjectToUrlUtils.atributoEnumName = function (data) {
        return data ? data.enumName : undefined;
    };
    ConverterParameterObjectToUrlUtils.atributoEnumNameNumero = function (data) {
        return ConverterParameterObjectToUrlUtils.extrairAtributosObjetoEnumName(data);
    };
    ConverterParameterObjectToUrlUtils.atributoEnumCodigoNumero = function (data) {
        return ConverterParameterObjectToUrlUtils.extrairAtributosObjetoEnumName(data);
    };
    ConverterParameterObjectToUrlUtils.atributoEnumNameArray = function (data) {
        return ConverterParameterObjectToUrlUtils.extrairAtributo(data, 'enumName');
    };
    ConverterParameterObjectToUrlUtils.atributoIdBacen = function (data) {
        return data ? data.idBacen : undefined;
    };
    ConverterParameterObjectToUrlUtils.atributoIdBacenArray = function (data) {
        return ConverterParameterObjectToUrlUtils.extrairAtributo(data, 'idBacen');
    };
    ConverterParameterObjectToUrlUtils.atributoPK = function (data) {
        return data ? data.pk : undefined;
    };
    ConverterParameterObjectToUrlUtils.atributoPKArray = function (data) {
        return ConverterParameterObjectToUrlUtils.extrairAtributo(data, 'pk');
    };
    ConverterParameterObjectToUrlUtils.boolean = function (data) {
        return data ? 'true' : 'false';
    };
    ConverterParameterObjectToUrlUtils.atributoBoolean = function (data) {
        return data === undefined ? undefined : (data ? 'true' : 'false');
    };
    ConverterParameterObjectToUrlUtils.date = function (data) {
        return data ? data.toISOString().substring(0, 10) : undefined;
    };
    ConverterParameterObjectToUrlUtils.number = function (data) {
        return data || data === 0 ? data : undefined;
    };
    ConverterParameterObjectToUrlUtils.numberArray = function (data) {
        return ConverterParameterObjectToUrlUtils.toArray(data);
    };
    ConverterParameterObjectToUrlUtils.string = function (data) {
        return data ? data : undefined;
    };
    ConverterParameterObjectToUrlUtils.extrairAtributo = function (data, campo) {
        if (_.isEmpty(data)) {
            return undefined;
        }
        var valores = _.pluck(data, campo);
        _.sortBy(valores);
        return valores;
    };
    ConverterParameterObjectToUrlUtils.extrairAtributosObjetoEnumName = function (data) {
        var valores = new Array();
        if (_.isEmpty(data)) {
            return undefined;
        }
        if (data === undefined) {
            return undefined;
        }
        data.forEach(function (item) {
            var pk = item.pk;
            var tipo = item.tipo.enumName;
            var numero = item.numero;
            valores.push({ pk: pk, tipo: tipo, numero: numero });
        });
        return valores;
    };
    ConverterParameterObjectToUrlUtils.toArray = function (data) {
        if (_.isEmpty(data)) {
            return undefined;
        }
        if (_.isArray(data)) {
            return data;
        }
        return [data];
    };
    return ConverterParameterObjectToUrlUtils;
}());
//# sourceMappingURL=converter-parameter-object-to-url-utils.js.map;
"use strict";
var ConverterParameterUrlToObjectUtils = (function () {
    function ConverterParameterUrlToObjectUtils() {
    }
    ConverterParameterUrlToObjectUtils.atributoCodigo = function (data) {
        return data ? { codigo: data } : undefined;
    };
    ConverterParameterUrlToObjectUtils.atributoCodigoArray = function (data) {
        return ConverterParameterUrlToObjectUtils.criarAtributo(data, 'codigo');
    };
    ConverterParameterUrlToObjectUtils.atributoEnumName = function (data) {
        return data ? { enumName: data } : undefined;
    };
    ConverterParameterUrlToObjectUtils.atributoEnumNameArray = function (data) {
        return ConverterParameterUrlToObjectUtils.criarAtributo(data, 'enumName');
    };
    ConverterParameterUrlToObjectUtils.atributoIdBacen = function (data) {
        return data ? { idBacen: data } : undefined;
    };
    ConverterParameterUrlToObjectUtils.atributoBoolean = function (data) {
        return data === "true";
    };
    ConverterParameterUrlToObjectUtils.atributoIdBacenArray = function (data) {
        return ConverterParameterUrlToObjectUtils.criarAtributo(data, 'idBacen');
    };
    ConverterParameterUrlToObjectUtils.atributoPK = function (data) {
        return data ? { pk: parseInt(data) } : undefined;
    };
    ConverterParameterUrlToObjectUtils.atributoPKArray = function (data) {
        return ConverterParameterUrlToObjectUtils.criarAtributo(data, 'pk', parseInt);
    };
    ConverterParameterUrlToObjectUtils.boolean = function (data) {
        var ehstringTrue = typeof data === 'string' && data === 'true';
        var ehBooleanTrue = typeof data === 'boolean' && data;
        return ehstringTrue || ehBooleanTrue;
    };
    ConverterParameterUrlToObjectUtils.date = function (data) {
        return data ? new Date(data + 'T00:00:00.000') : undefined;
    };
    ConverterParameterUrlToObjectUtils.number = function (data) {
        return data || data === 0 ? data * 1 : undefined;
    };
    ConverterParameterUrlToObjectUtils.numberArray = function (data) {
        return ConverterParameterUrlToObjectUtils.toArray(data);
    };
    ConverterParameterUrlToObjectUtils.string = function (data) {
        return data ? data : undefined;
    };
    ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos = function (filtro) {
        var arrayValues = _.values(filtro);
        return !_.isEmpty(_.compact(arrayValues));
    };
    ConverterParameterUrlToObjectUtils.criarAtributo = function (data, campo, parse) {
        if (!data || _.isEmpty(data)) {
            return undefined;
        }
        var arrayData = _.isArray(data) ? data : data.split(',');
        return _.map(arrayData, function (value) {
            var result = {};
            result[campo] = parse ? parse(value) : value;
            return result;
        });
    };
    ConverterParameterUrlToObjectUtils.toArray = function (data) {
        if (_.isEmpty(data)) {
            return undefined;
        }
        if (_.isArray(data)) {
            return data;
        }
        return [data];
    };
    return ConverterParameterUrlToObjectUtils;
}());
//# sourceMappingURL=converter-parameter-url-to-object-utils.js.map;
"use strict";
var DataTableUtils = (function () {
    function DataTableUtils() {
    }
    DataTableUtils.createFunctionServerData = function ($scope, items) {
        function serverData(sSource, aoData, fnCallback) {
            var draw = aoData[DataTableUtils.DRAW].value;
            var order = aoData[DataTableUtils.ORDER].value;
            var start = draw === 1 ? 0 : aoData[DataTableUtils.START].value;
            var length = aoData[DataTableUtils.LENGTH].value;
            var records = {
                data: items.slice(start, start + length),
                draw: draw,
                recordsFiltered: items.length,
                recordsTotal: items.length
            };
            fnCallback(records);
            $scope.$safeApply();
        }
        return serverData;
    };
    return DataTableUtils;
}());
DataTableUtils.DRAW = 0;
DataTableUtils.ORDER = 2;
DataTableUtils.START = 3;
DataTableUtils.LENGTH = 4;
//# sourceMappingURL=datatable-utils.js.map;
(function($, moment) {
  'use strict';

  $.fn.dataTable.ext.errMode = 'none';
  $.fn.dataTable.moment('DD/MM/YYYY HH:mm:ss');

  $.fn.dataTable.ext.type.order['type-data-base-pre'] = typeDataBasePre;
  $.fn.dataTable.ext.type.order['type-data-base-vigencia-pre'] = typeDataBaseVigenciaPre;

  function typeDataBasePre(item) {
    if (item) {
      var dataBase;
      if (/^\d{2}\/\d{4}$/.test(item)) {
        dataBase = moment(item, 'MM/YYYY').endOf('month');
      } else {
        dataBase = moment(item, 'DD/MM/YYYY');
      }
      return dataBase;
    }
    return item;
  }

  function typeDataBaseVigenciaPre(item) {
    var dataBase = item ? item.split(' a')[0] : item;
    return typeDataBasePre(dataBase);
  }
})(jQuery, moment);
;
"use strict";
var DateUtil = (function () {
    function DateUtil() {
    }
    DateUtil.calcularAno = function (data, n) {
        var newDate = new Date(data.getTime());
        newDate.setFullYear(newDate.getFullYear() + n);
        return newDate;
    };
    DateUtil.calcularDia = function (data, n) {
        var newDate = new Date(data.getTime());
        newDate.setDate(newDate.getDate() + n);
        return newDate;
    };
    DateUtil.calcularMes = function (data, n) {
        var newDate = new Date(data.getTime());
        newDate.setMonth(newDate.getMonth() + n);
        return newDate;
    };
    DateUtil.isMaiorQue = function (a, b, podeSerIgual) {
        if (!a || !b) {
            return false;
        }
        var aInt = parseInt(a.toISOString().slice(0, 10).replace(/-/g, ""));
        var bInt = parseInt(b.toISOString().slice(0, 10).replace(/-/g, ""));
        return aInt > bInt || (podeSerIgual && aInt === bInt);
    };
    DateUtil.isMenorQue = function (a, b, podeSerIgual) {
        if (!a || !b) {
            return false;
        }
        var aInt = parseInt(a.toISOString().slice(0, 10).replace(/-/g, ""));
        var bInt = parseInt(b.toISOString().slice(0, 10).replace(/-/g, ""));
        return aInt < bInt || (podeSerIgual && aInt === bInt);
    };
    DateUtil.isDiferente = function (a, b) {
        if (!a || !b) {
            return false;
        }
        var aInt = parseInt(a.toISOString().slice(0, 10).replace(/-/g, ""));
        var bInt = parseInt(b.toISOString().slice(0, 10).replace(/-/g, ""));
        return aInt !== bInt;
    };
    return DateUtil;
}());
//# sourceMappingURL=DateUtil.js.map;
"use strict";
var DocumentoUtil = (function () {
    function DocumentoUtil() {
    }
    DocumentoUtil.filtrarPorSistemaNegocio = function (documentos, sistemasNegocio) {
        if (documentos == undefined || documentos.length == 0 || sistemasNegocio == undefined || sistemasNegocio.length == 0) {
            return documentos;
        }
        else {
            var sisPKs_1 = sistemasNegocio != undefined ? _.map(sistemasNegocio, function (sis) { return sis.pk; }) : new Array();
            return _.filter(documentos, function (documento) {
                return (documento.sistemaNegocio != undefined && _.contains(sisPKs_1, documento.sistemaNegocio.pk)) || documento.sistemaNegocio == undefined;
            });
        }
    };
    return DocumentoUtil;
}());
//# sourceMappingURL=documento-util.js.map;
"use strict";
var FileUtils = (function () {
    function FileUtils() {
    }
    FileUtils.separarAntigosENovos = function (files) {
        var antigos = [];
        var novos = [];
        _.each(files, function (arq) {
            if (FileUtils.isFile(arq)) {
                novos.push(arq);
            }
            else {
                antigos.push(arq);
            }
        });
        return { antigos: antigos, novos: novos };
    };
    FileUtils.isFile = function (elemento) {
        return elemento instanceof File;
    };
    return FileUtils;
}());
//# sourceMappingURL=file-utils.js.map;
"use strict";
var FiltrarCriticaQualidadeUtil = (function () {
    function FiltrarCriticaQualidadeUtil() {
    }
    FiltrarCriticaQualidadeUtil.filtrar = function (criticas, sistemasNegocio, documentos) {
        if (_.isEmpty(sistemasNegocio) && _.isEmpty(documentos)) {
            return criticas;
        }
        var sisPKs = sistemasNegocio != undefined ? _.map(sistemasNegocio, function (sis) { return sis.pk; }) : new Array();
        var docPKs = documentos != undefined ? _.map(documentos, function (doc) { return doc.pk; }) : new Array();
        return _.filter(criticas, function (critica) {
            var crqSIS = critica.sistemaNegocio != undefined ? critica.sistemaNegocio.pk : 0;
            var crqDOC = critica.documentos != undefined ? _.map(critica.documentos, function (doc) { return doc.pk; }) : new Array();
            var crqDOCSIS = critica.documentos != undefined ? _.map(critica.documentos, function (doc) { return (doc.sistemaNegocio != undefined ? doc.sistemaNegocio.pk : null); }) : new Array();
            if (!_.isEmpty(docPKs)) {
                for (var i = 0; i < docPKs.length; i++) {
                    if (_.contains(crqDOC, docPKs[i])) {
                        return true;
                    }
                }
                for (var i = 0; i < sisPKs.length; i++) {
                    if (crqSIS == sisPKs[i]
                        && _.isEmpty(crqDOC)) {
                        return true;
                    }
                }
            }
            else {
                for (var i = 0; i < sisPKs.length; i++) {
                    if (crqSIS == sisPKs[i]
                        || _.contains(crqDOCSIS, sisPKs[i])) {
                        return true;
                    }
                }
            }
            return false;
        });
    };
    FiltrarCriticaQualidadeUtil.filtrarTipoCritica = function (tiposCritica, paraCriticaAutomatica) {
        if (paraCriticaAutomatica === undefined || paraCriticaAutomatica === null) {
            return tiposCritica;
        }
        return _.filter(tiposCritica, function (tipoCritica) { return tipoCritica.paraCriticaAutomatica === paraCriticaAutomatica; });
    };
    return FiltrarCriticaQualidadeUtil;
}());
//# sourceMappingURL=filtrar-critica-qualidade-util.js.map;
"use strict";
var FormataDataPeriodicidade = (function () {
    function FormataDataPeriodicidade() {
    }
    FormataDataPeriodicidade.formatoPelaPeriodicidade = function (periodicidade) {
        if (periodicidade && periodicidade.codigo >= 6 && periodicidade.codigo != 11) {
            return FormataDataPeriodicidade.MES_ANO;
        }
        else {
            return FormataDataPeriodicidade.DIA_MES_ANO;
        }
    };
    FormataDataPeriodicidade.formatoDataPorGrupoPeriodidicade = function (grupoPeriodicidade) {
        if ('MENSAL_OU_MAIOR' === grupoPeriodicidade) {
            return FormataDataPeriodicidade.MES_ANO;
        }
        return FormataDataPeriodicidade.DIA_MES_ANO;
    };
    FormataDataPeriodicidade.formatoPelaMenorPeriodicidade = function (periodicidades) {
        var periodicidade = periodicidades ? _.min(periodicidades, function (periodicidade) { return periodicidade.codigo; }) : undefined;
        return FormataDataPeriodicidade.formatoPelaPeriodicidade(periodicidade);
    };
    return FormataDataPeriodicidade;
}());
FormataDataPeriodicidade.DIA_MES_ANO = {
    mascara: '99/99/9999',
    formato: 'dd/MM/yyyy',
    placeholder: 'dd/mm/aaaa',
    exibeCalendario: true,
    normatizar: function (data) { return data; }
};
FormataDataPeriodicidade.MES_ANO = {
    mascara: '99/9999',
    formato: 'MM/yyyy',
    placeholder: 'mm/aaaa',
    exibeCalendario: false,
    normatizar: function (data) {
        if (data) {
            var newDate = new Date(data.getFullYear(), data.getMonth() + 1, 0);
            return newDate.toString() === data.toString() ? data : newDate;
        }
        else {
            return data;
        }
    }
};
//# sourceMappingURL=formata-data-periodicidade.js.map;
(function(global, factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['_'], factory);
  } else {
    global.CRDUtils.FormatoData = factory(_);
  }
})(this, function(_) {
  'use strict';

  function Formato(format, mask, mode, presentPopup, placeholder, message) {
    this.format = format;
    this.mask = mask;
    this.mode = mode;
    this.presentPopup = presentPopup;
    this.placeholder = placeholder;
    this.message = message;
  }

  Formato.prototype.isMonthly = function() {
    return /^MM\/yyyy$/.test(this.format);
  };

  function FormatoDiaMesAno(codigo) {
    Formato.call(this, 'dd/MM/yyyy', '99/99/9999', 'day', true, 'dd/mm/aaaa', 'Selecione o último dia do período da data-base desejada');
    this.codigo = codigo;
  }

  FormatoDiaMesAno.prototype = new Formato();
  FormatoDiaMesAno.prototype.constructor = FormatoDiaMesAno;

  function FormatoMesAno(codigo) {
    Formato.call(this, 'MM/yyyy', '99/9999', 'month', true, 'mm/aaaa', '');
    this.codigo = codigo;
  }

  FormatoMesAno.prototype = new Formato();
  FormatoMesAno.prototype.constructor = FormatoMesAno;

  var ANUAL = new FormatoMesAno(10);
  var BIMESTRAL = new FormatoMesAno(7);
  var DIARIA = new FormatoDiaMesAno(3);
  var EVENTUAL = new FormatoDiaMesAno(2);
  var MENSAL = new FormatoMesAno(6);
  var NAO_APLICA = new FormatoDiaMesAno(1);
  var QUINZENAL = new FormatoDiaMesAno(5);
  var REGRA = new FormatoMesAno(11);
  var SEMANAL = new FormatoDiaMesAno(4);
  var SEMESTRAL = new FormatoMesAno(9);
  var TRIMESTRAL = new FormatoMesAno(8);
  var VALUES = [ANUAL, BIMESTRAL, DIARIA, EVENTUAL, MENSAL, NAO_APLICA, QUINZENAL, REGRA, SEMANAL, SEMESTRAL, TRIMESTRAL];

  function findCodigo(codigo) {
    return _.find(VALUES, function findInValuesByPeriodicidadeCodigo(periodicidade) {
      return codigo === periodicidade.codigo;
    });
  }

  var formatoData = {
    ANUAL: ANUAL,
    BIMESTRAL: BIMESTRAL,
    DIARIA: DIARIA,
    EVENTUAL: EVENTUAL,
    MENSAL: MENSAL,
    NAO_APLICA: NAO_APLICA,
    QUINZENAL: QUINZENAL,
    REGRA: REGRA,
    SEMANAL: SEMANAL,
    SEMESTRAL: SEMESTRAL,
    TRIMESTRAL: TRIMESTRAL,
    findCodigo: findCodigo
  };

  return formatoData;
});
;
"use strict";
var FormularioUtils = (function () {
    function FormularioUtils() {
    }
    FormularioUtils.reset = function (formulario, $scope) {
        formulario.resetDate = new Date().getTime();
        formulario.$setUntouched();
        formulario.$setPristine();
    };
    FormularioUtils.setPristine = function (formulario) {
        setTimeout(function () { return FormularioUtils.setPristineNoWait(formulario); }, 500);
    };
    FormularioUtils.setPristineNoWait = function (formulario) {
        angular.forEach(formulario, function (field, name) {
            if (typeof name === 'string' && !name.match('^[\$]')) {
                field.$pristine = true;
                field.$dirty = false;
            }
        });
        formulario.$pristine = true;
        formulario.$dirty = false;
    };
    return FormularioUtils;
}());
//# sourceMappingURL=formulario-utils.js.map;
"use strict";
var ObjectUtils = (function () {
    function ObjectUtils() {
    }
    ObjectUtils.possuiSomenteAKey = function (obj, key) {
        var keys = Object.keys(obj);
        return keys.length === 1 && keys[0] === key;
    };
    ObjectUtils.todosOsItensPossuemSomenteAKey = function (objs, key) {
        return objs.reduce(function (sum, obj) { return sum && ObjectUtils.possuiSomenteAKey(obj, key); }, true);
    };
    ObjectUtils.nullToEmpty = function (obj) {
        return _.isEmpty(obj) ? {} : obj;
    };
    ObjectUtils.removerAtributosUndefinedEmptyNull = function (parameters) {
        return _.pick(parameters, function (value) {
            return _.isArray(value)
                ? !_.isEmpty(value)
                : !_.isUndefined(value) && !_.isNull(value) && !_.isEmpty(String.prototype.trim.call(value));
        });
    };
    return ObjectUtils;
}());
//# sourceMappingURL=object-utils.js.map;
(function(global, factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['_', 'moment', 'CRDUtils.Conversor'], factory);
  } else {
    global.CRDUtils.ParametrosUrl = factory(_, moment, CRDUtils.Conversor);
  }
})(this, function(_, moment, conversor) {
  'use strict';

  function ObjetoMap(chave) {
    this.chave = chave;
  }

  ObjetoMap.prototype.converterValor = function converterValor(valor) {
    var response = {};
    response[this.chave] = valor;
    return response;
  };

  ObjetoMap.prototype.extrair = function(valor) {
    if (valor) {
      return this.converterValor(valor);
    }
    return valor;
  };

  ObjetoMap.prototype.extrairArray = function(itens) {
    var vm = this;
    var response = [];
    if (itens) {
      if (Array.isArray(itens)) {
        itens.forEach(function(item) {
          response.push(vm.converterValor(item));
        });
      } else {
        response.push(vm.converterValor(itens));
      }
    }
    return response;
  };

  ObjetoMap.prototype.criar = function(valor) {
    if (valor) {
      return valor[this.chave];
    }
    return valor;
  };

  ObjetoMap.prototype.criarArray = function(itens) {
    var vm = this;

    var response;
    if (itens) {
      if (Array.isArray(itens)) {
        response = _.collect(itens, function(value) {
          return value[vm.chave];
        });
      } else {
        response = [itens[vm.chave]];
      }
    }

    return response;
  };

  var Data = {
    criar: function criarData(data) {
      return data ? conversor.dateToString(data) : undefined;
    },
    extrair: function extrairData(data) {
      return ehData(data) ? conversor.stringToDate(data) : undefined;
    }
  };

  var Boolean = {
    extrair: function extrairBoolean(valor) {
      var ehStringTrue = typeof valor === 'string' && valor === 'true';
      var ehBooleanTrue = typeof valor === 'boolean' && valor;
      return ehStringTrue || ehBooleanTrue;
    }
  };

  function ehData(valor) {
    return /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(valor);
  }

  function criarArrayObjetoPk(lista) {
    return _.collect(lista, function(value) {
      return {
        pk: value.pk
      };
    });
  }

  var objetoPk = new ObjetoMap('pk');
  var objetoCodigo = new ObjetoMap('codigo');
  var objetoEnumName = new ObjetoMap('enumName');
  var objetoIdBacen = new ObjetoMap('idBacen');

  var Extrator = {
    arrayObjetoCodigo: function(valor) {
      return objetoCodigo.extrairArray(valor);
    },
    arrayObjetoPk: function(valor) {
      return objetoPk.extrairArray(valor);
    },
    data: function(valor) {
      return Data.extrair(valor);
    },
    objetoCodigo: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoCodigo.extrair(valor);
    },
    enumName: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoEnumName.extrair(valor);
    },
    objetoIdBacen: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoIdBacen.extrair(valor);
    },
    objetoPk: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoPk.extrair(valor);
    },
    toBoolean: function(valor) {
      return Boolean.extrair(valor);
    },

    string: function(valor) {
      if (!valor) {
        return null;
      }
      return valor;
    },

    number: function(valor) {
      if (!valor) {
        return null;
      }
      return valor;
    }
  };

  var Criador = {
    arrayCodigo: function(valor) {
      return objetoCodigo.criarArray(valor);
    },
    arrayObjetoPk: function(lista) {
      return criarArrayObjetoPk(lista);
    },
    arrayPk: function(valor) {
      return objetoPk.criarArray(valor);
    },
    codigo: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoCodigo.criar(valor);
    },
    data: function(valor) {
      return Data.criar(valor);
    },
    enumName: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoEnumName.criar(valor);
    },
    idBacen: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoIdBacen.criar(valor);
    },
    pk: function(valor) {
      if (!valor) {
        return null;
      }
      return objetoPk.criar(valor);
    },
    string: function(valor) {
      if (!valor) {
        return null;
      }
      return valor;
    },
    number: function(valor) {
      if (!valor) {
        return null;
      }
      return valor;
    }
  };

  return {
    Criador: Criador,
    Extrator: Extrator
  };
});
;
CRDUtils.Role = (function(_) {
  'use strict';

  function Role(codigo, nome) {
    this.codigo = codigo;
    this.nome = nome;
  }

  var ADMINISTRADOR = new Role('SCRD005', 'Administrador');
  var AUDITOR_OBSERVANCIA = new Role('SCRD006', 'Agente de auditoria de observância');
  var CURADOR = new Role('SCRD004', 'Agente de curadoria');
  var CURADOR_MASTER = new Role('SCRD003', 'Agente de curadoria administrador');
  var ENTIDADE_SUPERVISIONADA = new Role('SCRD002', 'Entidade supervisionada');
  var PUBLICO_EXTERNO_GERAL = new Role('SCRD007', 'Supervisor');
  var SOMENTE_PROPRIO_CRD = new Role('SCRD000', 'Somente o prório CRD');
  var UNIDADE_BACEN = new Role('SCRD001', 'Unidades Bacen');
  var FUNCI = new Role('FUNCI', 'Qualquer funcionário do BACEN');

  var values = [ADMINISTRADOR, AUDITOR_OBSERVANCIA, CURADOR, CURADOR_MASTER,
    ENTIDADE_SUPERVISIONADA, PUBLICO_EXTERNO_GERAL, SOMENTE_PROPRIO_CRD, UNIDADE_BACEN, FUNCI
  ];

  function findByCodigo(codigo) {
    return _.find(values, function(role) {
      return codigo === role.codigo;
    });
  }

  return {
    ADMINISTRADOR: ADMINISTRADOR,
    AUDITOR_OBSERVANCIA: AUDITOR_OBSERVANCIA,
    CURADOR: CURADOR,
    CURADOR_MASTER: CURADOR_MASTER,
    ENTIDADE_SUPERVISIONADA: ENTIDADE_SUPERVISIONADA,
    PUBLICO_EXTERNO_GERAL: PUBLICO_EXTERNO_GERAL,
    SOMENTE_PROPRIO_CRD: SOMENTE_PROPRIO_CRD,
    UNIDADE_BACEN: UNIDADE_BACEN,
    FUNCI: FUNCI,
    findByCodigo: findByCodigo
  };
})(_);
;
(function(angular) {
  'use strict';

  angular.module('crd', [
    'angularMoment',
    'datatables',
    'ngFileSaver',
    'ngStorage',
    'serverGrid',
    'traverson',
    'ui.router'
  ]);
})(angular);
;
(function (angular) {
  'use strict';
  window.ace.define('ace/mode/bccalculadora', function (require, exports, module) {
    var oop = require("ace/lib/oop");
    var TextMode = require("ace/mode/text").Mode;
    var BcCalculadoraHighlightRules = require("ace/mode/bccalculadora_highlight_rules").BcCalculadoraHighlightRules;

    var Mode = function () {
      this.HighlightRules = BcCalculadoraHighlightRules;
    };
    oop.inherits(Mode, TextMode);

    (function () {
      // Extra logic goes here. (see below)
      this.$id = 'ace/mode/bccalculadora';
    }).call(Mode.prototype);

    exports.Mode = Mode;
  });

  window.ace.define('ace/mode/bccalculadora_highlight_rules', function (require, exports, module) {

    var oop = require("ace/lib/oop");
    var TextHighlightRules = require("ace/mode/text_highlight_rules").TextHighlightRules;

    var BcCalculadoraHighlightRules = function () {

      this.$rules = new TextHighlightRules().getRules();
    }

    oop.inherits(BcCalculadoraHighlightRules, TextHighlightRules);

    exports.BcCalculadoraHighlightRules = BcCalculadoraHighlightRules;
  });
})(angular);
;
(function (angular) {
  'use strict';
  
  ace.define("ace/snippets/bccalculadora.snippets", ["require", "exports", "module"], function (require, exports, module) {
    module.exports = [
      '# forin\nsnippet forin\n\tfor (${1:\\$item} in ${2:\\$colecao}) {\n\t  ${3}\n\t}\n',
      '# for\nsnippet for\n\tfor (\\$i = 0; \\$i<= \\$tamanho; \\$i = \\$i + 1) {\n\t  ${3}\n\t}\n',
      '# if\nsnippet if\n\tif (${1:\\$condicao}) {\n\t  ${2}\n\t}\n',
      '# if ... else\nsnippet ife\n\tif (${1:\\$condicao}) {\n\t  ${2}\n\t} else {\n\t  ${3}\n\t}\n',

      '# $IDBACEN\nsnippet IDBACEN\n\t\\$IDBACEN\n',
      '# $DATABASE\nsnippet DATABASE\n\t\\$DATABASE\n',
      '# $DATA_CORRENTE\nsnippet DATA_CORRENTE\n\t\\$DATA_CORRENTE\n',
    ].join('');
  });

  ace.define("ace/snippets/bccalculadora", ["require", "exports", "module", "ace/snippets/bccalculadora.snippets"], function (require, exports, module) {
    "use strict";
    exports.snippetText = require("./bccalculadora.snippets");
    exports.scope = "bccalculadora";
  });

  (function () {
    ace.require(["ace/snippets/bccalculadora"], function (m) {
      if (typeof module == "object" && typeof exports == "object" && module) {
        module.exports = m;
      }
    });
  })();
})();
;
(function (angular) {
  'use strict';

  /**
   * Binds a ACE Editor widget
   */
  angular
    .module('crd')
    .directive('crdFormulaEditor', ['CrdFormulaEditorService',CrdFormulaEditorDirective]);

  function CrdFormulaEditorDirective(crdFormulaEditorService) {
    if (angular.isUndefined(window.ace)) {
      throw new Error('crd-formula-editor precisa da biblioteca ace para funcionar');
    }

    const snippets = crdFormulaEditorService.getSnippets();

    var defaultOpts = {
      showGutter: true,
      useWrapMode: false,
      useSoftTabs: true,
      tabSize: 2,
    };

    /**
     * Sets editor options such as the wrapping mode or the syntax checker.
     *
     * The supported options are:
     *
     *   <ul>
     *     <li>showGutter</li>
     *     <li>useWrapMode</li>
     *     <li>useSoftTabs</li>
     *     <li>tabSize</li>
     *   </ul>
     *
     * @param editor
     * @param session ACE editor session
     * @param {object} opts Options to be set
     */
    var setOptions = function (editor, session, opts) {
      editor.setTheme('ace/theme/eclipse');
      session.setMode('ace/mode/bccalculadora');
      ace.config.loadModule('ace/snippets/bccalculadora');

      editor.renderer.setShowGutter(opts.showGutter);
      session.setUseWrapMode(opts.useWrapMode);
      session.setUseSoftTabs(opts.useSoftTabs);
      session.setTabSize(opts.tabSize);
      editor.setBehavioursEnabled(true);
      editor.setOptions({
        enableBasicAutocompletion: true,
        enableSnippets: true,
        enableEmmet: true,
        enableLiveAutocompletion: true,
        maxLines: Infinity,
        minLines: 3
      });

      registerSnippets();
    };

    function registerSnippets() {
      ace.config.loadModule('ace/ext/language_tools', function () {
        var snippetManager = ace.require("ace/snippets").snippetManager;
        var config = ace.require("ace/config");

        config.loadModule("ace/snippets/bccalculadora", function (module) {
          if (module) {
            snippetManager.files.bccalculadora = module;
            module.snippets = snippetManager.parseSnippetFile(module.snippetText);
            snippetManager.register(module.snippets, module.scope);
            snippetManager.register(snippets, module.scope);
          }
        });
      });
    }

    function createEditor(element) {
      var editor = window.ace.edit(element);

      return editor;
    }

    return {
      restrict: 'E',
      require: 'ngModel',
      link: function (scope, elm, attrs, ngModel) {
        elm.addClass('crd-formula-editor');

        /**
         * Corresponds the uiAceConfig ACE configuration.
         * @type object
         */
        var options = defaultOpts || {};

        /**
         * uiAceConfig merged with user options via json in attribute or data binding
         * @type object
         */
        var opts = angular.extend({}, options, scope.$eval(attrs.opts));

        /**
         * ACE editor
         * @type object
         */
        var editor = createEditor(elm[0]);

        /**
         * ACE editor session.
         * @type object
         * @see [EditSession]{@link http://ace.c9.io/#nav=api&api=edit_session}
         */
        var session = editor.getSession();

        /**
         * Reference to a change listener created by the listener factory.
         * @function
         * @see listenerFactory.onChange
         */
        var onChangeListener;

        /**
         * Reference to a blur listener created by the listener factory.
         * @function
         * @see listenerFactory.onBlur
         */
        var onBlurListener;

        /**
         * Calls a callback by checking its existing. The argument list
         * is variable and thus this function is relying on the arguments
         * object.
         * @throws {Error} If the callback isn't a function
         */
        var executeUserCallback = function () {

          /**
           * The callback function grabbed from the array-like arguments
           * object. The first argument should always be the callback.
           *
           * @see [arguments]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions_and_function_scope/arguments}
           * @type {*}
           */
          var callback = arguments[0];

          /**
           * Arguments to be passed to the callback. These are taken
           * from the array-like arguments object. The first argument
           * is stripped because that should be the callback function.
           *
           * @see [arguments]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions_and_function_scope/arguments}
           * @type {Array}
           */
          var args = Array.prototype.slice.call(arguments, 1);

          if (angular.isDefined(callback)) {
            scope.$evalAsync(function () {
              if (angular.isFunction(callback)) {
                callback(args);
              } else {
                throw new Error('crd-formula-editor use a function as callback.');
              }
            });
          }
        };

        /**
         * Listener factory. Until now only change listeners can be created.
         * @type object
         */
        var listenerFactory = {
          /**
           * Creates a change listener which propagates the change event
           * and the editor session to the callback from the user option
           * onChange. It might be exchanged during runtime, if this
           * happens the old listener will be unbound.
           *
           * @param callback callback function defined in the user options
           * @see onChangeListener
           */
          onChange: function (callback) {
            return function (e) {
              var newValue = session.getValue();

              if (ngModel && newValue !== ngModel.$viewValue &&
                // HACK make sure to only trigger the apply outside of the
                // digest loop 'cause ACE is actually using this callback
                // for any text transformation !
                !scope.$$phase && !scope.$root.$$phase) {
                scope.$evalAsync(function () {
                  ngModel.$setViewValue(newValue);
                });
              }

              executeUserCallback(callback, e, editor);
            };
          },
          /**
           * Creates a blur listener which propagates the editor session
           * to the callback from the user option onBlur. It might be
           * exchanged during runtime, if this happens the old listener
           * will be unbound.
           *
           * @param callback callback function defined in the user options
           * @see onBlurListener
           */
          onBlur: function (callback) {
            return function () {
              executeUserCallback(callback, editor);
            };
          }
        };

        attrs.$observe('readonly', function (value) {
          var isReadonly = !!value || value === '';

          editor.setOptions({ readOnly: isReadonly, highlightActiveLine: !isReadonly, highlightGutterLine: !isReadonly });
          editor.renderer.$cursorLayer.element.style.display = isReadonly ? "none" : "block";
        });

        // Value Blind
        if (ngModel) {
          ngModel.$formatters.push(function (value) {
            if (angular.isUndefined(value) || value === null) {
              return '';
            } else if (angular.isObject(value) || angular.isArray(value)) {
              throw new Error('crd-formula-editor cannot use an object or an array as a model');
            }
            return value;
          });

          ngModel.$render = function () {
            session.setValue(ngModel.$viewValue);
          };
        }

        // Listen for option updates
        var updateOptions = function (current, previous) {
          if (current === previous) return;
          opts = angular.extend({}, options, scope.$eval(attrs.opts));

          opts.callbacks = [opts.onLoad];
          if (opts.onLoad !== options.onLoad) {
            // also call the global onLoad handler
            opts.callbacks.unshift(options.onLoad);
          }

          // EVENTS

          // unbind old change listener
          session.removeListener('change', onChangeListener);

          // bind new change listener
          onChangeListener = listenerFactory.onChange(opts.onChange);
          session.on('change', onChangeListener);

          // unbind old blur listener
          //session.removeListener('blur', onBlurListener);
          editor.removeListener('blur', onBlurListener);

          // bind new blur listener
          onBlurListener = listenerFactory.onBlur(opts.onBlur);
          editor.on('blur', onBlurListener);

          setOptions(editor, session, opts);
        };

        scope.$watch(attrs.opts, updateOptions, /* deep watch */ true);

        // set the options here, even if we try to watch later, if this
        // line is missing things go wrong (and the tests will also fail)
        updateOptions(options);

        elm.on('$destroy', function () {
          editor.session.$stopWorker();
          editor.destroy();
        });

        scope.$watch(function () {
          return [elm[0].offsetWidth, elm[0].offsetHeight];
        }, function () {
          editor.resize();
          editor.renderer.updateFull();
        }, true);

      }
    };
  }
})(angular);
;
"use strict";
var CrdFormulaEditorService = (function () {
    function CrdFormulaEditorService($q, bcCalcladoraApiService) {
        this.$q = $q;
        this.bcCalcladoraApiService = bcCalcladoraApiService;
        this.callAndSaveSnippets();
    }
    CrdFormulaEditorService.prototype.getSnippets = function () {
        var value = localStorage.getItem(CrdFormulaEditorService.KEY_STORAGE_SNIPPETS);
        return (JSON.parse(value || "{}"));
    };
    CrdFormulaEditorService.prototype.callAndSaveSnippets = function () {
        if (localStorage.getItem(CrdFormulaEditorService.KEY_STORAGE_SNIPPETS)) {
            return;
        }
        this.bcCalcladoraApiService.funcao().then(function (resource) {
            var snippets = resource
                .filter(function (funcao) { return _.size(funcao.snippets) > 0; })
                .map(function (funcao) {
                var index = 1;
                var content = funcao.sintaxe.replace(/\$([A-z0-9_]*)/g, function (_) { return '${' + index++ + ':\\' + _ + '}'; });
                return funcao.snippets.map(function (snippet) { return { 'tabTrigger': snippet, 'name': snippet, 'content': content }; });
            })
                .flat();
            localStorage.setItem(CrdFormulaEditorService.KEY_STORAGE_SNIPPETS, JSON.stringify(snippets));
        });
    };
    return CrdFormulaEditorService;
}());
CrdFormulaEditorService.KEY_STORAGE_SNIPPETS = 'crd-bc-calculadora-editor-snippets';
CrdFormulaEditorService.$inject = ['$q', 'BcCalcladoraApiService'];
angular.module('crd').service('CrdFormulaEditorService', CrdFormulaEditorService);
//# sourceMappingURL=crd-formula-editor-service.js.map;
"use strict";
var CRDInputRadioController = (function () {
    function CRDInputRadioController() {
    }
    CRDInputRadioController.prototype.$onInit = function () { };
    CRDInputRadioController.prototype.itensNotEmpty = function () {
        if (this.itens != null) {
            return true;
        }
        return false;
    };
    return CRDInputRadioController;
}());
CRDInputRadioController.$inject = [];
angular.module('crd').controller('CRDInputRadioController', CRDInputRadioController);
//# sourceMappingURL=crd-input-radio-controller.js.map;
"use strict";
var CRDInputRadioDirective = (function () {
    function CRDInputRadioDirective() {
        this.controller = 'CRDInputRadioController';
        this.controllerAs = 'crdInputRadioCtrl';
        this.name = 'crdInputRadio';
        this.priority = 0;
        this.require = ['crdInputRadio', 'ngModel'];
        this.restrict = 'E';
        this.scope = true;
        this.templateUrl = 'scripts/crd/components/form/crd-input-radio/crd-input-radio-tpl.html';
    }
    CRDInputRadioDirective.prototype.link = function (scope, element, attributes, controller, transclude) {
        var crdInputRadioCtrl = controller[0];
        var ngModelCtrl = controller[1];
        ngModelCtrl.$render = function () {
            crdInputRadioCtrl.valorSelecionado = ngModelCtrl.$viewValue;
            crdInputRadioCtrl.name = attributes.name;
            crdInputRadioCtrl.ngChange = attributes.ngChange;
            crdInputRadioCtrl.id = attributes.id;
            scope.$watch('crdInputRadioCtrl.valorSelecionado', function (newValue) {
                ngModelCtrl.$setViewValue(newValue);
            });
            scope.$watch(attributes.itens, function (newValue) {
                crdInputRadioCtrl.itens = newValue;
            });
            scope.$watch(attributes.ngReadonly, function (newValue) {
                crdInputRadioCtrl.ngReadonly = newValue;
            });
            scope.$watch(attributes.ngDisabled, function (newValue) {
                crdInputRadioCtrl.ngDisabled = newValue;
            });
        };
    };
    CRDInputRadioDirective.instance = function () {
        return new CRDInputRadioDirective();
    };
    return CRDInputRadioDirective;
}());
CRDInputRadioDirective.$inject = [];
angular.module('crd').directive('crdInputRadio', CRDInputRadioDirective.instance);
//# sourceMappingURL=crd-input-radio-directive.js.map;
"use strict";
var CrdInputToggleSwitchController = (function () {
    function CrdInputToggleSwitchController() {
    }
    CrdInputToggleSwitchController.prototype.observerChange = function ($event, newValue) {
    };
    CrdInputToggleSwitchController.prototype.$onInit = function () { };
    return CrdInputToggleSwitchController;
}());
CrdInputToggleSwitchController.$inject = [];
angular.module('crd').controller('CrdInputToggleSwitchController', CrdInputToggleSwitchController);
//# sourceMappingURL=crd-input-toggle-switch-controller.js.map;
"use strict";
var CrdInputToggleSwitchDirective = (function () {
    function CrdInputToggleSwitchDirective() {
        this.controller = 'CrdInputToggleSwitchController';
        this.controllerAs = 'crdInputToggleSwitchCtlr';
        this.name = 'crdInputToggleSwitch';
        this.priority = 0;
        this.require = ['crdInputToggleSwitch', 'ngModel'];
        this.restrict = 'E';
        this.scope = true;
        this.templateUrl = 'scripts/crd/components/form/crd-input-toggle-switch/crd-input-toggle-switch-tpl.html';
    }
    CrdInputToggleSwitchDirective.prototype.link = function (scope, element, attributes, controller, transclude) {
        var crdInputToggleSwitchCtlr = controller[0];
        var ngModelCtrl = controller[1];
        ngModelCtrl.$render = function () {
            crdInputToggleSwitchCtlr.value = ngModelCtrl.$viewValue;
            scope.$watch('crdInputToggleSwitchCtlr.value', function (newValue) {
                ngModelCtrl.$setViewValue(newValue);
            });
            scope.$watch(attributes.name, function (newValue) {
                crdInputToggleSwitchCtlr.name = newValue || (new Date().getTime() + Math.random()).toString();
            });
        };
    };
    CrdInputToggleSwitchDirective.instance = function () {
        return new CrdInputToggleSwitchDirective();
    };
    return CrdInputToggleSwitchDirective;
}());
CrdInputToggleSwitchDirective.$inject = [];
angular.module('crd').directive('crdInputToggleSwitch', CrdInputToggleSwitchDirective.instance);
//# sourceMappingURL=crd-input-toggle-switch-directive.js.map;
"use strict";
var AbstractSelecionarController = (function () {
    function AbstractSelecionarController(campoPK) {
        this.campoPK = campoPK;
        this.itens = [];
    }
    AbstractSelecionarController.prototype.$onInit = function () {
        this.loading = false;
        this.podeVerBotaoLimpar = false;
        this.multiplos = false;
        this.noResults = false;
    };
    AbstractSelecionarController.prototype.carregar = function (filtros) {
        var _this = this;
        var f = angular.extend(ObjectUtils.nullToEmpty(_.clone(filtros)), { quantidadePorPagina: 99999 });
        return this.buscarItens(f).then(function (resource) {
            _this.itens = resource.data.content;
            return resource;
        });
    };
    AbstractSelecionarController.prototype.limpar = function () {
        this.value = undefined;
        this.noResults = false;
        this.loading = false;
    };
    AbstractSelecionarController.prototype.pesquisar = function (texto) {
        var _this = this;
        if (!this.podePesquisar(texto)) {
            this.itens.length = 0;
            return;
        }
        return this.buscarItens({ texto: texto }).then(function (resource) {
            _this.itens = resource.data.content;
            return resource;
        });
    };
    AbstractSelecionarController.prototype.setValue = function (newValue) {
        var _this = this;
        if (!newValue || _.isEmpty(newValue)) {
            this.value = newValue;
            return;
        }
        if (this.multiplos && ObjectUtils.todosOsItensPossuemSomenteAKey(newValue, this.campoPK)) {
            var filtros = this.criarFiltroParaValor(ConverterParameterObjectToUrlUtils.extrairAtributo(newValue, this.campoPK));
            filtros.quantidadePorPagina = 5;
            this.buscarItens(filtros).then(function (resource) {
                _this.value = resource.data.content;
            });
            return;
        }
        if (!this.multiplos && ObjectUtils.possuiSomenteAKey(newValue, this.campoPK)) {
            var filtros = this.criarFiltroParaValor(ConverterParameterObjectToUrlUtils.extrairAtributo([newValue], this.campoPK));
            filtros.quantidadePorPagina = 1;
            this.buscarItens(filtros).then(function (resource) {
                _this.value = resource.data.content[0];
            });
            return;
        }
        this.value = newValue;
    };
    AbstractSelecionarController.prototype.buscarItens = function (filtros) {
        var _this = this;
        var filtrosTratados = this.tratarFiltro(filtros);
        this.loading = true;
        return this.buscar(filtrosTratados).then(function (resource) {
            _this.noResults = !resource.data.hasContent;
            _this.loading = false;
            return resource;
        });
    };
    AbstractSelecionarController.prototype.tratarFiltro = function (filtros) {
        return angular.extend(this.filtroPadrao(), ObjectUtils.removerAtributosUndefinedEmptyNull(_.clone(filtros)));
    };
    AbstractSelecionarController.prototype.podePesquisar = function (texto) {
        return !(!texto || /^\s*$/.test(texto)) && texto.length >= 2;
    };
    return AbstractSelecionarController;
}());
//# sourceMappingURL=abstract-selecionar-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdCriticaQualidadeSelecionarController = (function (_super) {
    __extends(CrdCriticaQualidadeSelecionarController, _super);
    function CrdCriticaQualidadeSelecionarController(criticaQualidadeApiService) {
        var _this = _super.call(this, 'pk') || this;
        _this.criticaQualidadeApiService = criticaQualidadeApiService;
        return _this;
    }
    CrdCriticaQualidadeSelecionarController.prototype.buscar = function (filtros) {
        return this.criticaQualidadeApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdCriticaQualidadeSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { criticas: value };
    };
    CrdCriticaQualidadeSelecionarController.prototype.filtroPadrao = function () {
        return { numeroPagina: 0, quantidadePorPagina: 20 };
    };
    return CrdCriticaQualidadeSelecionarController;
}(AbstractSelecionarController));
CrdCriticaQualidadeSelecionarController.$inject = ['CriticaQualidadeApiService'];
angular.module('crd').controller('CrdCriticaQualidadeSelecionarController', CrdCriticaQualidadeSelecionarController);
//# sourceMappingURL=crd-critica-qualidade-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdCriticaQualidadeSelecionar', CrdCriticaQualidadeSelecionarDirective);

  function CrdCriticaQualidadeSelecionarDirective() {
    var directive = {
      controller: 'CrdCriticaQualidadeSelecionarController',
      controllerAs: 'crdCrqSelCtrl',
      link: postLink,
      require: ['crdCriticaQualidadeSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/components/form/selecionar/crd-critica-qualidade-selecionar/crd-critica-qualidade-selecionar-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      var crdCrqSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdCrqSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdCrqSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdCrqSelCtrl.filtros = newValue;
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
          crdCrqSelCtrl.setValue(newValue);
      });

      $scope.$watch('crdCrqSelCtrl.value', function(newValue) {
        crdCrqSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdDocumentoSelecionarNovoController = (function (_super) {
    __extends(CrdDocumentoSelecionarNovoController, _super);
    function CrdDocumentoSelecionarNovoController(documentoApiService) {
        var _this = _super.call(this, 'pk') || this;
        _this.documentoApiService = documentoApiService;
        return _this;
    }
    CrdDocumentoSelecionarNovoController.prototype.buscar = function (filtros) {
        return this.documentoApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdDocumentoSelecionarNovoController.prototype.criarFiltroParaValor = function (value) {
        return { documentos: value };
    };
    CrdDocumentoSelecionarNovoController.prototype.filtroPadrao = function () {
        return { numeroPagina: 0, quantidadePorPagina: 10, ordenacaoCampo: 'CODIGO', ordenacaoDirecao: 'ASC' };
    };
    return CrdDocumentoSelecionarNovoController;
}(AbstractSelecionarController));
CrdDocumentoSelecionarNovoController.$inject = ['documentoApiService'];
angular.module('crd').controller('CrdDocumentoSelecionarNovoController', CrdDocumentoSelecionarNovoController);
//# sourceMappingURL=crd-documento-selecionar-novo-controller.js.map;
(function (angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdDocumentoSelecionarNovo', CrdDocumentoSelecionarNovoDirective);

  function CrdDocumentoSelecionarNovoDirective() {
    var directive = {
      controller: 'CrdDocumentoSelecionarNovoController',
      controllerAs: 'crdDocumentoSelecionarNovoCtrl',
      link: postLink,
      require: ['crdDocumentoSelecionarNovo', 'ngModel'],
      restrict: 'E',
      templateUrl: templateUrl
    };

    return directive;

    function templateUrl($element, $attributes) {
      return $attributes.multiplos === 'true'
        ? 'scripts/crd/components/form/selecionar/crd-documento-selecionar/crd-documento-selecionar-novo-multiplo-tpl.html'
        : 'scripts/crd/components/form/selecionar/crd-documento-selecionar/crd-documento-selecionar-novo-tpl.html';
    }

    function postLink($scope, $element, $attributes, controllers) {
      var crdDocumentoSelecionarNovoCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdDocumentoSelecionarNovoCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function (newValue) {
        crdDocumentoSelecionarNovoCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function (newValue, oldValue) {
        if (!_.isEmpty(newValue) && newValue.sistemasNegocio) {
          crdDocumentoSelecionarNovoCtrl.filtros = newValue;
          crdDocumentoSelecionarNovoCtrl.carregar(crdDocumentoSelecionarNovoCtrl.filtros);
        }
        crdDocumentoSelecionarNovoCtrl.itens = []
      }, true);

      $scope.$watch($attributes.ngModel, function (newValue) {
        crdDocumentoSelecionarNovoCtrl.setValue(newValue);
      });

      $scope.$watch('crdDocumentoSelecionarNovoCtrl.value', function (newValue) {
        crdDocumentoSelecionarNovoCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdEntidadeSupervisionadaSelecionarController = (function (_super) {
    __extends(CrdEntidadeSupervisionadaSelecionarController, _super);
    function CrdEntidadeSupervisionadaSelecionarController(entidadeSupervisionadaApiService) {
        var _this = _super.call(this, 'idBacen') || this;
        _this.entidadeSupervisionadaApiService = entidadeSupervisionadaApiService;
        return _this;
    }
    CrdEntidadeSupervisionadaSelecionarController.prototype.buscar = function (filtros) {
        return this.entidadeSupervisionadaApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdEntidadeSupervisionadaSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { entidadesSupervisionada: value };
    };
    CrdEntidadeSupervisionadaSelecionarController.prototype.filtroPadrao = function () {
        return {
            segmentosExcluidos: ['024'],
            numeroPagina: 0,
            quantidadePorPagina: 5,
            ordenacaoCampo: 'CNPJ',
            ordenacaoDirecao: 'ASC'
        };
    };
    return CrdEntidadeSupervisionadaSelecionarController;
}(AbstractSelecionarController));
CrdEntidadeSupervisionadaSelecionarController.$inject = ['EntidadeSupervisionadaApiService'];
angular.module('crd').controller('CrdEntidadeSupervisionadaSelecionarController', CrdEntidadeSupervisionadaSelecionarController);
//# sourceMappingURL=crd-entidade-supervisionada-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdEntidadeSupervisionadaSelecionar', CrdEntidadeSupervisionadaSelecionar);

  function CrdEntidadeSupervisionadaSelecionar() {
    var directive = {
      controller: 'CrdEntidadeSupervisionadaSelecionarController',
      controllerAs: 'crdEntidadeSupervisionadaSelCtrl',
      link: postLink,
      require: ['crdEntidadeSupervisionadaSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: templateUrl
    };

    return directive;

    function templateUrl($element, $attributes) {
      return $attributes.multiplos === 'true'
        ? 'scripts/crd/components/form/selecionar/crd-entidade-supervisionada-selecionar/crd-entidade-supervisionada-selecionar-multiplo-tpl.html'
        : 'scripts/crd/components/form/selecionar/crd-entidade-supervisionada-selecionar/crd-entidade-supervisionada-selecionar-tpl.html';
    }

    function postLink($scope, $element, $attributes, controllers) {
      var crdEntidadeSupervisionadaSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdEntidadeSupervisionadaSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdEntidadeSupervisionadaSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdEntidadeSupervisionadaSelCtrl.filtros = newValue;
        crdEntidadeSupervisionadaSelCtrl.carregar(crdEntidadeSupervisionadaSelCtrl.filtros);
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
        crdEntidadeSupervisionadaSelCtrl.setValue(newValue);
      });

      $scope.$watch($attributes.ngDisabled, function(newValue) {
        crdEntidadeSupervisionadaSelCtrl.disabled = newValue;
      });

      $scope.$watch('crdEntidadeSupervisionadaSelCtrl.value', function(newValue) {
        crdEntidadeSupervisionadaSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdExcecaoQualidadeSelecionarController = (function (_super) {
    __extends(CrdExcecaoQualidadeSelecionarController, _super);
    function CrdExcecaoQualidadeSelecionarController(excecaoQualidadeApiService) {
        var _this = _super.call(this, 'pk') || this;
        _this.excecaoQualidadeApiService = excecaoQualidadeApiService;
        return _this;
    }
    CrdExcecaoQualidadeSelecionarController.prototype.buscar = function (filtros) {
        return this.excecaoQualidadeApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdExcecaoQualidadeSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { excecoesId: value };
    };
    CrdExcecaoQualidadeSelecionarController.prototype.filtroPadrao = function () {
        return { numeroPagina: 0, quantidadePorPagina: 20 };
    };
    return CrdExcecaoQualidadeSelecionarController;
}(AbstractSelecionarController));
CrdExcecaoQualidadeSelecionarController.$inject = ['ExcecaoQualidadeApiService'];
angular.module('crd').controller('CrdExcecaoQualidadeSelecionarController', CrdExcecaoQualidadeSelecionarController);
//# sourceMappingURL=crd-excecao-qualidade-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdExcecaoQualidadeSelecionar', CrdExcecaoQualidadeSelecionarDirective);

  function CrdExcecaoQualidadeSelecionarDirective() {
    var directive = {
      controller: 'CrdExcecaoQualidadeSelecionarController',
      controllerAs: 'crdExqSelCtrl',
      link: postLink,
      require: ['crdExcecaoQualidadeSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/components/form/selecionar/crd-excecao-qualidade-selecionar/crd-excecao-qualidade-selecionar-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      var crdExqSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdExqSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdExqSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdExqSelCtrl.filtros = newValue;
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
          crdExqSelCtrl.setValue(newValue);
      });

      $scope.$watch('crdExqSelCtrl.value', function(newValue) {
        crdExqSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdSegmentoSelecionarController = (function (_super) {
    __extends(CrdSegmentoSelecionarController, _super);
    function CrdSegmentoSelecionarController(segmentoApiService) {
        var _this = _super.call(this, 'codigo') || this;
        _this.segmentoApiService = segmentoApiService;
        return _this;
    }
    CrdSegmentoSelecionarController.prototype.buscar = function (filtros) {
        return this.segmentoApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdSegmentoSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { codigos: value };
    };
    CrdSegmentoSelecionarController.prototype.filtroPadrao = function () {
        return { numeroPagina: 0, quantidadePorPagina: 10, ordenacaoCampo: 'DESCRICAO', ordenacaoDirecao: 'ASC' };
    };
    return CrdSegmentoSelecionarController;
}(AbstractSelecionarController));
CrdSegmentoSelecionarController.$inject = ['segmentoApiService'];
angular.module('crd').controller('CrdSegmentoSelecionarController', CrdSegmentoSelecionarController);
//# sourceMappingURL=crd-segmento-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdSegmentoSelecionar', CrdSegmentoSelecionarDirective);

  function CrdSegmentoSelecionarDirective() {
    var directive = {
      controller: 'CrdSegmentoSelecionarController',
      controllerAs: 'crdSegSelCtrl',
      link: postLink,
      require: ['crdSegmentoSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: templateUrl
    };

    return directive;

    function templateUrl($element, $attributes) {
      return $attributes.multiplos === 'true'
        ? 'scripts/crd/components/form/selecionar/crd-segmento-selecionar/crd-segmento-selecionar-multiplo-tpl.html'
        : 'scripts/crd/components/form/selecionar/crd-segmento-selecionar/crd-segmento-selecionar-tpl.html';
    }

    function postLink($scope, $element, $attributes, controllers) {
      var crdSegSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdSegSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdSegSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdSegSelCtrl.filtros = newValue;
        crdSegSelCtrl.carregar(crdSegSelCtrl.filtros);
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
        crdSegSelCtrl.setValue(newValue);
      });

      $scope.$watch('crdSegSelCtrl.value', function(newValue) {
        crdSegSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });

      $scope.$watch($attributes.ngDisabled, function(newValue) {
        crdSegSelCtrl.disabled = newValue;
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdSistemaNegocioSelecionarController = (function (_super) {
    __extends(CrdSistemaNegocioSelecionarController, _super);
    function CrdSistemaNegocioSelecionarController(sistemaNegocioApiService) {
        var _this = _super.call(this, 'pk') || this;
        _this.sistemaNegocioApiService = sistemaNegocioApiService;
        return _this;
    }
    CrdSistemaNegocioSelecionarController.prototype.buscar = function (filtros) {
        return this.sistemaNegocioApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdSistemaNegocioSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { sistemasNegocio: value };
    };
    CrdSistemaNegocioSelecionarController.prototype.filtroPadrao = function () {
        return { numeroPagina: 0, quantidadePorPagina: 10, ordenacaoCampo: 'SIGLA', ordenacaoDirecao: 'ASC' };
    };
    return CrdSistemaNegocioSelecionarController;
}(AbstractSelecionarController));
CrdSistemaNegocioSelecionarController.$inject = ['sistemaNegocioApiService'];
angular.module('crd').controller('CrdSistemaNegocioSelecionarController', CrdSistemaNegocioSelecionarController);
//# sourceMappingURL=crd-sistema-negocio-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdSistemaNegocioSelecionar', CrdSistemaNegocioSelecionarDirective);

  function CrdSistemaNegocioSelecionarDirective() {
    var directive = {
      controller: 'CrdSistemaNegocioSelecionarController',
      controllerAs: 'crdSistemaNegocioSelCtrl',
      link: postLink,
      require: ['crdSistemaNegocioSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: templateUrl
    };

    return directive;

    function templateUrl($element, $attributes) {
      return $attributes.multiplos === 'true'
        ? 'scripts/crd/components/form/selecionar/crd-sistema-negocio-selecionar/crd-sistema-negocio-selecionar-multiplo-tpl.html'
        : 'scripts/crd/components/form/selecionar/crd-sistema-negocio-selecionar/crd-sistema-negocio-selecionar-tpl.html';
    }

    function postLink($scope, $element, $attributes, controllers) {
      var crdSistemaNegocioSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdSistemaNegocioSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdSistemaNegocioSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdSistemaNegocioSelCtrl.filtros = newValue;
        crdSistemaNegocioSelCtrl.carregar(crdSistemaNegocioSelCtrl.filtros);
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
        crdSistemaNegocioSelCtrl.setValue(newValue);
      });

      $scope.$watch('crdSistemaNegocioSelCtrl.value', function(newValue) {
        crdSistemaNegocioSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdSituacaoPjSelecionarController = (function (_super) {
    __extends(CrdSituacaoPjSelecionarController, _super);
    function CrdSituacaoPjSelecionarController(situacaoPJApiService) {
        var _this = _super.call(this, 'codigo') || this;
        _this.situacaoPJApiService = situacaoPJApiService;
        return _this;
    }
    CrdSituacaoPjSelecionarController.prototype.buscar = function (filtros) {
        return this.situacaoPJApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdSituacaoPjSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { codigos: value };
    };
    CrdSituacaoPjSelecionarController.prototype.filtroPadrao = function () {
        return { vigente: true, numeroPagina: 0, quantidadePorPagina: 10, ordenacaoCampo: 'CODIGO', ordenacaoDirecao: 'ASC' };
    };
    return CrdSituacaoPjSelecionarController;
}(AbstractSelecionarController));
CrdSituacaoPjSelecionarController.$inject = ['SituacaoPJApiService'];
angular.module('crd').controller('CrdSituacaoPjSelecionarController', CrdSituacaoPjSelecionarController);
//# sourceMappingURL=crd-situacao-pj-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdSituacaoPjSelecionar', CrdSituacaoPjSelecionarDirective);

  function CrdSituacaoPjSelecionarDirective() {
    var directive = {
      controller: 'CrdSituacaoPjSelecionarController',
      controllerAs: 'crdSituacaoPjSelCtrl',
      link: postLink,
      require: ['crdSituacaoPjSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: templateUrl
    };

    return directive;

    function templateUrl($element, $attributes) {
      return $attributes.multiplos === 'true'
        ? 'scripts/crd/components/form/selecionar/crd-situacao-pj-selecionar/crd-situacao-pj-selecionar-multiplo-tpl.html'
        : 'scripts/crd/components/form/selecionar/crd-situacao-pj-selecionar/crd-situacao-pj-selecionar-tpl.html';
    }

    function postLink($scope, $element, $attributes, controllers) {
      var crdSituacaoPjSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdSituacaoPjSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdSituacaoPjSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdSituacaoPjSelCtrl.filtros = newValue;
        crdSituacaoPjSelCtrl.carregar(crdSituacaoPjSelCtrl.filtros);
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
        crdSituacaoPjSelCtrl.setValue(newValue);
      });

      $scope.$watch('crdSituacaoPjSelCtrl.value', function(newValue) {
        crdSituacaoPjSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdValidacaoPreProcessamentoSelecionarController = (function (_super) {
    __extends(CrdValidacaoPreProcessamentoSelecionarController, _super);
    function CrdValidacaoPreProcessamentoSelecionarController(validacaoPreProcessamentoApiService) {
        var _this = _super.call(this, 'pk') || this;
        _this.validacaoPreProcessamentoApiService = validacaoPreProcessamentoApiService;
        return _this;
    }
    CrdValidacaoPreProcessamentoSelecionarController.prototype.buscar = function (filtros) {
        return this.validacaoPreProcessamentoApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdValidacaoPreProcessamentoSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { pks: value };
    };
    CrdValidacaoPreProcessamentoSelecionarController.prototype.filtroPadrao = function () {
        return { faseExecucaos: ['POS_EXTRACAO'], modoExecucaos: ['SELECIONAVEL'], numeroPagina: 0, quantidadePorPagina: 10, ordenacaoCampo: 'CODIGO', ordenacaoDirecao: 'ASC' };
    };
    return CrdValidacaoPreProcessamentoSelecionarController;
}(AbstractSelecionarController));
CrdValidacaoPreProcessamentoSelecionarController.$inject = ['ValidacaoPreProcessamentoApiService'];
angular.module('crd').controller('CrdValidacaoPreProcessamentoSelecionarController', CrdValidacaoPreProcessamentoSelecionarController);
//# sourceMappingURL=crd-validacao-pre-processamento-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdValidacaoPreProcessamentoSelecionar', CrdValidacaoPreProcessamentoSelecionar);

  function CrdValidacaoPreProcessamentoSelecionar() {
    var directive = {
      controller: 'CrdValidacaoPreProcessamentoSelecionarController',
      controllerAs: 'crdValidacaoPreProcessamentoSelCtrl',
      link: postLink,
      require: ['crdValidacaoPreProcessamentoSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: templateUrl
    };

    return directive;

    function templateUrl($element, $attributes) {
      return $attributes.multiplos === 'true'
        ? 'scripts/crd/components/form/selecionar/crd-validacao-pre-processamento-selecionar/crd-validacao-pre-processamento-selecionar-multiplo-tpl.html'
        : 'scripts/crd/components/form/selecionar/crd-validacao-pre-processamento-selecionar/crd-validacao-pre-processamento-selecionar-tpl.html';
    }

    function postLink($scope, $element, $attributes, controllers) {
      var crdValidacaoPreProcessamentoSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdValidacaoPreProcessamentoSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdValidacaoPreProcessamentoSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdValidacaoPreProcessamentoSelCtrl.filtros = newValue;
        crdValidacaoPreProcessamentoSelCtrl.carregar(crdValidacaoPreProcessamentoSelCtrl.filtros);
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
        crdValidacaoPreProcessamentoSelCtrl.setValue(newValue);
      });

      $scope.$watch('crdValidacaoPreProcessamentoSelCtrl.value', function(newValue) {
        crdValidacaoPreProcessamentoSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdValidacaoProcessamentoSelecionarUnicoController = (function (_super) {
    __extends(CrdValidacaoProcessamentoSelecionarUnicoController, _super);
    function CrdValidacaoProcessamentoSelecionarUnicoController(validacaoProcessamentoApiService, $scope) {
        var _this = _super.call(this, 'nome') || this;
        _this.validacaoProcessamentoApiService = validacaoProcessamentoApiService;
        _this.$scope = $scope;
        return _this;
    }
    CrdValidacaoProcessamentoSelecionarUnicoController.prototype.atualizarNome = function (nome) {
        this.parametroNome.nome = nome;
        console.log('Nome Atualizado:', this.parametroNome.nome);
    };
    CrdValidacaoProcessamentoSelecionarUnicoController.prototype.buscar = function (filtros) {
        console.log("Filtros" + filtros);
        this.consultaFiltro = {
            nome: filtros.texto,
            numeroPagina: filtros.numeroPagina,
            quantidadePorPagina: filtros.quantidadePorPagina
        };
        console.log("Nome" + filtros.texto);
        return this.validacaoProcessamentoApiService.pesquisarParaSelecaoUnico(this.consultaFiltro, true);
    };
    CrdValidacaoProcessamentoSelecionarUnicoController.prototype.ngOnInit = function () {
        var _this = this;
        console.log("ParametroNome" + this.parametroNome);
        this.$scope.$watch('crdValidacaoProcessamentoSelecionarUnicoController.parametroNome.nome', function (newValue) {
            if (newValue) {
                if (_this.parametroNome) {
                    _this.parametroNome.nome = newValue;
                }
            }
        });
        console.log("ParametroNome" + this.parametroNome);
    };
    CrdValidacaoProcessamentoSelecionarUnicoController.prototype.criarFiltroParaValor = function (value) {
        return { nome: value };
    };
    CrdValidacaoProcessamentoSelecionarUnicoController.prototype.filtroPadrao = function () {
        return { numeroPagina: 0, quantidadePorPagina: 20 };
    };
    return CrdValidacaoProcessamentoSelecionarUnicoController;
}(AbstractSelecionarController));
CrdValidacaoProcessamentoSelecionarUnicoController.$inject = ['ValidacaoProcessamentoApiService', '$scope'];
angular.module('crd').controller('CrdValidacaoProcessamentoSelecionarUnicoController', CrdValidacaoProcessamentoSelecionarUnicoController);
//# sourceMappingURL=crd-validacao-processamento-selecionar-unico-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdValidacaoProcessamentoSelecionarUnico', CrdValidacaoProcessamentoSelecionarUnicoDirective);

  function CrdValidacaoProcessamentoSelecionarUnicoDirective() {
    var directive = {
      controller: 'CrdValidacaoProcessamentoSelecionarUnicoController',
      controllerAs: 'crdValidacaoProcessamentoSelecionarUnicoController',
      link: postLink,
      require: ['crdValidacaoProcessamentoSelecionarUnico', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/components/form/selecionar/crd-validacao-processamento-selecionar-unico/crd-validacao-processamento-selecionar-unico-tpl.html'
    };

    return directive;
  }

    function postLink($scope, $element, $attributes, controllers) {
      var crdValidacaoProcessamentoSelecionarUnicoController = controllers[0];
      var ngModelCtrl = controllers[1];

      crdValidacaoProcessamentoSelecionarUnicoController.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdValidacaoProcessamentoSelecionarUnicoController.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdValidacaoProcessamentoSelecionarUnicoController.filtros = newValue;
        crdValidacaoProcessamentoSelecionarUnicoController.carregar(crdValidacaoProcessamentoSelecionarUnicoController.filtros)
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
          crdValidacaoProcessamentoSelecionarUnicoController.setValue(newValue);
      });

      $scope.$watch('crdValidacaoProcessamentoSelecionarUnicoController.value', function(newValue) {
        crdValidacaoProcessamentoSelecionarUnicoController.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
})(angular);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CrdValidacaoProcessamentoSelecionarController = (function (_super) {
    __extends(CrdValidacaoProcessamentoSelecionarController, _super);
    function CrdValidacaoProcessamentoSelecionarController(validacaoProcessamentoApiService) {
        var _this = _super.call(this, 'pk') || this;
        _this.validacaoProcessamentoApiService = validacaoProcessamentoApiService;
        return _this;
    }
    CrdValidacaoProcessamentoSelecionarController.prototype.buscar = function (filtros) {
        return this.validacaoProcessamentoApiService.pesquisarParaSelecao(filtros, true);
    };
    CrdValidacaoProcessamentoSelecionarController.prototype.criarFiltroParaValor = function (value) {
        return { validacaoProcessamento: value };
    };
    CrdValidacaoProcessamentoSelecionarController.prototype.filtroPadrao = function () {
        return { numeroPagina: 0, quantidadePorPagina: 10, ordenacaoCampo: 'CODIGO', ordenacaoDirecao: 'ASC' };
    };
    return CrdValidacaoProcessamentoSelecionarController;
}(AbstractSelecionarController));
CrdValidacaoProcessamentoSelecionarController.$inject = ['ValidacaoProcessamentoApiService'];
angular.module('crd').controller('CrdValidacaoProcessamentoSelecionarController', CrdValidacaoProcessamentoSelecionarController);
//# sourceMappingURL=crd-validacao-processamento-selecionar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdValidacaoProcessamentoSelecionar', CrdValidacaoProcessamentoSelecionarDirective);

  function CrdValidacaoProcessamentoSelecionarDirective() {
    var directive = {
      controller: 'CrdValidacaoProcessamentoSelecionarController',
      controllerAs: 'crdValpSelCtrl',
      link: postLink,
      require: ['crdValidacaoProcessamentoSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/components/form/selecionar/crd-validacao-processamento-selecionar/crd-validacao-processamento-selecionar-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      var crdValpSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      crdValpSelCtrl.onChange = $attributes.ngChange;

      $scope.$watch($attributes.multiplos, function(newValue) {
        crdValpSelCtrl.multiplos = newValue;
      });

      $scope.$watch($attributes.filtros, function(newValue) {
        crdValpSelCtrl.filtros = newValue;
        crdValpSelCtrl.carregar(crdValpSelCtrl.filtros)
      }, true);

      $scope.$watch($attributes.ngModel, function(newValue) {
          crdValpSelCtrl.setValue(newValue);
      });

      $scope.$watch('crdValpSelCtrl.value', function(newValue) {
        crdValpSelCtrl.podeVerBotaoLimpar = !_.isEmpty(newValue);
        ngModelCtrl.$setViewValue(newValue);
      });
    }
  }
})(angular);
;
"use strict";
var CrdModalAjudaPreenchimentoController = (function () {
    function CrdModalAjudaPreenchimentoController($uibModal) {
        this.$uibModal = $uibModal;
    }
    CrdModalAjudaPreenchimentoController.prototype.abrirModal = function () {
        var _self = this;
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: this.templateUrl,
            controller: 'CrdModalAjudaPreenchimentoModalController',
            controllerAs: 'crdModalAjudaPreenchimentoModalCtl',
            bindToController: true,
            keyboard: true,
            size: this.size || 'lg'
        });
    };
    CrdModalAjudaPreenchimentoController.prototype.$onInit = function () { };
    return CrdModalAjudaPreenchimentoController;
}());
CrdModalAjudaPreenchimentoController.$inject = ['$uibModal'];
angular.module('crd').controller('CrdModalAjudaPreenchimentoController', CrdModalAjudaPreenchimentoController);
//# sourceMappingURL=crd-modal-ajuda-preenchimento-controller.js.map;
"use strict";
var CrdModalAjudaPreenchimentoDirective = (function () {
    function CrdModalAjudaPreenchimentoDirective() {
        this.controller = 'CrdModalAjudaPreenchimentoController';
        this.controllerAs = 'crdModalAjudaPreenchimentoCtlr';
        this.name = 'crdModalAjudaPreenchimento';
        this.priority = 0;
        this.require = ['crdModalAjudaPreenchimento'];
        this.restrict = 'E';
        this.scope = {
            size: '@',
            templateUrl: '@'
        };
        this.bindToController = true;
        this.templateUrl = 'scripts/crd/components/modals/crd-modal-ajuda-preenchimento/crd-modal-ajuda-preenchimento-tpl.html';
    }
    CrdModalAjudaPreenchimentoDirective.prototype.link = function (scope, element, attributes, controller, transclude) {
        var crdModalAjudaPreenchimentoCtlr = controller[0];
    };
    CrdModalAjudaPreenchimentoDirective.instance = function () {
        return new CrdModalAjudaPreenchimentoDirective();
    };
    return CrdModalAjudaPreenchimentoDirective;
}());
CrdModalAjudaPreenchimentoDirective.$inject = [];
angular.module('crd').directive('crdModalAjudaPreenchimento', CrdModalAjudaPreenchimentoDirective.instance);
//# sourceMappingURL=crd-modal-ajuda-preenchimento-directive.js.map;
"use strict";
var CrdModalAjudaPreenchimentoModalController = (function () {
    function CrdModalAjudaPreenchimentoModalController($uibModalInstance) {
        this.$uibModalInstance = $uibModalInstance;
    }
    CrdModalAjudaPreenchimentoModalController.prototype.cancelar = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    CrdModalAjudaPreenchimentoModalController.prototype.$onInit = function () { };
    return CrdModalAjudaPreenchimentoModalController;
}());
CrdModalAjudaPreenchimentoModalController.$inject = ['$uibModalInstance'];
angular.module('crd').controller('CrdModalAjudaPreenchimentoModalController', CrdModalAjudaPreenchimentoModalController);
//# sourceMappingURL=crd-modal-ajuda-preenchimento-modal-controller.js.map;
"use strict";
var AbstractPaginaConsultaController = (function () {
    function AbstractPaginaConsultaController($stateParams, $scope, feedbackService) {
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
    }
    AbstractPaginaConsultaController.prototype.$onInit = function () {
        var _this = this;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        return this.dadosParaConstruir(this.$stateParams).then(function (response) {
            _this.exibirResultadoPesquisa();
        });
    };
    AbstractPaginaConsultaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    AbstractPaginaConsultaController.prototype.navegarNaGrid = function (dadosFormulario, pagination) {
        var consultaFiltro = this.converterDadosDoFormToConsultaFiltro(dadosFormulario);
        consultaFiltro.numeroPagina = pagination.number;
        consultaFiltro.quantidadePorPagina = pagination.size;
        consultaFiltro.ordenacaoCampo = pagination.sortField;
        consultaFiltro.ordenacaoDirecao = pagination.sortDirection;
        return this.consultarRecurso(consultaFiltro);
    };
    AbstractPaginaConsultaController.prototype.consultar = function (dadosFormulario) {
        var _this = this;
        this.limparMensagens();
        var consultaFiltro = this.converterDadosDoFormToConsultaFiltro(dadosFormulario);
        consultaFiltro.ordenacaoCampo = undefined;
        consultaFiltro.ordenacaoDirecao = undefined;
        return this.consultarRecurso(consultaFiltro).then(function (response) {
            if (response.status === 200 && response.data) {
                _this.exibirResultadoPesquisa();
            }
        });
    };
    AbstractPaginaConsultaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    AbstractPaginaConsultaController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    AbstractPaginaConsultaController.prototype.resetFormulario = function (dadosFormulario, form) {
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        this.limparDadosFormulario(dadosFormulario);
        FormularioUtils.reset(form, this.$scope);
    };
    return AbstractPaginaConsultaController;
}());
//# sourceMappingURL=abstract-pagina-consulta-controller.js.map;
"use strict";
var AbstractConsultaFiltro = (function () {
    function AbstractConsultaFiltro() {
    }
    return AbstractConsultaFiltro;
}());
//# sourceMappingURL=abstract-consulta-filtro.js.map;
"use strict";
var PaginaUtil = (function () {
    function PaginaUtil() {
    }
    PaginaUtil.paginaContent = function (items, pagination) {
        var page = pagination.number || 0;
        var size = pagination.size || 10;
        var start = ((page + 1) * size) - size;
        var end = start + size;
        return items.slice(start, end);
    };
    return PaginaUtil;
}());
//# sourceMappingURL=pagina-util.js.map;
"use strict";
var Pagina = (function () {
    function Pagina(content, totalElements, page, size, sort) {
        this.content = content;
        this.contentSize = content.length;
        this.totalElements = totalElements;
        this.number = page;
        this.size = size;
        this.totalPages = Math.ceil(totalElements / size);
        this.hasContent = this.contentSize > 0;
        this.hasNext = this.number + 1 < this.totalPages;
        this.hasPrevious = this.number > 0;
        this.empty = !this.hasContent;
        this.first = !this.hasPrevious;
        this.last = !this.hasNext;
        this.sort = sort;
    }
    return Pagina;
}());
//# sourceMappingURL=pagina.js.map;
"use strict";
var Sort = (function () {
    function Sort() {
    }
    return Sort;
}());
//# sourceMappingURL=sort.js.map;
"use strict";
var Mensagem = (function () {
    function Mensagem() {
    }
    return Mensagem;
}());
//# sourceMappingURL=mensagem.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(angularChartConfiguration);

  angularChartConfiguration.$inject = ['ChartJsProvider'];

  function angularChartConfiguration(ChartJsProvider) {
    ChartJsProvider.setOptions({
      chartColors: ['#1570A6', '#125E8C', '#4C4E47', '#357FB0', '#5E6357', '#39B2EE', '#4AC4F1', '#A8C6D7', '#9B967F', '#6AA3C5', '#4790B5', '#63A059']
    });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(httpProviderDefaultsConfiguration);

  var TIME_OUT = 5000;

  httpProviderDefaultsConfiguration.$inject = ['$httpProvider'];

  function httpProviderDefaultsConfiguration($httpProvider) {
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.timeout = TIME_OUT;
    $httpProvider.defaults.headers.post = {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=UTF-8'
    };
    $httpProvider.defaults.headers.put = {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=UTF-8'
    };
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(interceptorsConfiguration);

  interceptorsConfiguration.$inject = ['$httpProvider'];

  function interceptorsConfiguration($httpProvider) {
    $httpProvider.interceptors.push('httpLoggerInterceptor');
    $httpProvider.interceptors.push('httpErrorInterceptador');
    $httpProvider.interceptors.push('httpNocacheInterceptor');
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(adminRouteConfiguration);

  adminRouteConfiguration.$inject = ['$stateProvider'];

  function adminRouteConfiguration($stateProvider) {
    $stateProvider
      .state('admin', {
        abstract: true,
        template: '<ui-view></ui-view>'
      })
      .state('changelog', {
        parent: 'admin',
        template: '<section class="container-fluid changelog"> <ng-include src="\'views/CHANGELOG.html\'"></ng-include> <section>',
        url: '/changelog'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(anotacaoRouteConfiguration);

  anotacaoRouteConfiguration.$inject = ['$stateProvider'];

  function anotacaoRouteConfiguration($stateProvider) {
    $stateProvider
      .state('anotacao-listar', {
        controller: 'AnotacaoListarController',
        controllerAs: 'anotacaoListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6011',
          label: 'anotacoes',
          titulo: 'Pesquisa de anotações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/anotacao/anotacao-listar-tpl.html',
        url: '/anotacoes?operador&unidade&conglomerado&dataFim&dataInicio&documento&idBacen&refOutros&refQualidade&refTempestividade&sistemaNegocio'
      })
      .state('anotacoes-incluir', {
        controller: 'AnotacaoIncluirController',
        controllerAs: 'anotacaoIncluirCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6012',
          label: 'anotação',
          titulo: 'Anotaçao'
        },
        parent: 'admin',
        templateUrl: 'views/anotacao/anotacao-incluir-tpl.html',
        url: '/anotacoes/incluir'
      })
      .state('anotacoes-detalhar', {
        controller: 'AnotacaoDetalharController',
        controllerAs: 'anotacaoDetalharCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6013',
          label: 'anotação',
          titulo: 'Anotaçao'
        },
        parent: 'admin',
        templateUrl: 'views/anotacao/anotacao-detalhar-tpl.html',
        url: '/anotacoes/:id/detalhar?dataBase&telaRetorno&telaRetornoPainel'
      })
      .state('anotacoes-detalhar-historico', {
        controller: 'AnotacaoDetalharHistoricoController',
        controllerAs: 'anotacaoDetalharCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6015',
          label: 'anotação',
          titulo: 'Anotaçao'
        },
        parent: 'admin',
        templateUrl: 'views/anotacao/anotacao-detalhar-tpl.html',
        url: '/anotacoes/:id/historico/:historico/detalhar'
      })
      .state('anotacoes-alterar', {
        controller: 'AnotacaoAlterarController',
        controllerAs: 'anotacaoAlterarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6012',
          label: 'anotação',
          titulo: 'Anotaçao'
        },
        parent: 'admin',
        templateUrl: 'views/anotacao/anotacao-alterar-tpl.html',
        url: '/anotacoes/:id/alterar'
      })
      .state('anotacoes-historico', {
        controller: 'AnotacaoListarHistoricoController',
        controllerAs: 'anotacaoHistoricoCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6014',
          label: 'anotação',
          titulo: 'Anotaçao'
        },
        parent: 'admin',
        templateUrl: 'views/anotacao/anotacao-listar-historico-pesquisa-tpl.html',
        url: '/anotacoes/:id/historico'
      })
      .state('anotacoes-excluir', {
        controller: 'AnotacaoExcluirController',
        controllerAs: 'anotacaoExcluirCtrl',
        parent: 'admin',
        template: '',
        url: '/anotacoes/:id/excluir'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(atrasoSubstituicaoRouteConfiguration);

    atrasoSubstituicaoRouteConfiguration.$inject = ['$stateProvider', '$urlRouterProvider'];

  function atrasoSubstituicaoRouteConfiguration($stateProvider) {
    $stateProvider
      .state('atraso-substituicoes-listar', {
        controller: 'AtrasoSubstituicaoListarController',
        controllerAs: 'atrasoSubstituicaoListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW8013',
          label: 'Atrasos e substituições',
          titulo: 'Relatório de atrasos e substituições'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/atraso-substituicao/atraso-substituicao-listar-tpl.html',
        url: '/atraso-substituicoes?extrairPor&instituicao&conglomerado&cooperativaCentral&grupoPeriodicidade&sistemasNegocio&documentos&dataBaseInicio&dataBaseFim'
      });
  }
})(angular);
;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('auditoria-observancia-pesquisa', {
        controller: 'AuditoriaObservanciaPesquisaController',
        controllerAs: 'paoPqrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4061',
            label: 'Pesquisa de procedimentos da auditoria de observ�ncia',
            titulo: 'Pesquisa de procedimentos da auditoria de observ�ncia'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/auditoria-observancia/auditoria-observancia-pesquisa/auditoria-observancia-pesquisa-tpl.html',
        url: '/auditoria-observancia?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&instituicao&tipo&abertoSim&abertoNao&tipos&referencias&situacoes&periodoAcaoInicio&periodoAcaoFim&dataCriticaInicio&dataCriticaFim'
    })
        .state('auditoria-observancia-detalhar', {
        controller: 'AuditoriaObservanciaDetalheController',
        controllerAs: 'paoDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4064',
            label: 'Detalhar procedimento da auditoria de observ�ncia',
            titulo: 'Detalhar procedimento da auditoria de observ�ncia'
        },
        parent: 'admin',
        templateUrl: 'views/auditoria-observancia/auditoria-observancia-detalhe/auditoria-observancia-detalhe-tpl.html',
        url: '/auditoria-observancia/:pk/detalhar'
    })
        .state('auditoria-observancia-alterar', {
        controller: 'AuditoriaObservanciaAlterarController',
        controllerAs: 'paoAltCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4063',
            label: 'Alterar procedimento da auditoria de observ�ncia',
            titulo: 'Alterar procedimento da auditoria de observ�ncia'
        },
        parent: 'admin',
        templateUrl: 'views/auditoria-observancia/auditoria-observancia-alterar/auditoria-observancia-alterar-tpl.html',
        url: '/auditoria-observancia/:pk/alterar'
    })
        .state('auditoria-observancia-incluir', {
        controller: 'AuditoriaObservanciaIncluirController',
        controllerAs: 'paoIcrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4062',
            label: 'Incluir procedimento da auditoria de observ�ncia',
            titulo: 'Incluir procedimento da auditoria de observ�ncia'
        },
        parent: 'admin',
        templateUrl: 'views/auditoria-observancia/auditoria-observancia-incluir/auditoria-observancia-incluir-tpl.html',
        url: '/auditoria-observancia/incluir/:idbacen?telaRetorno'
    });
});
//# sourceMappingURL=auditoria-observancia-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('campo-situacao-monitorada-listar', {
        controller: 'CampoSituacaoMonitoradaPesquisaController',
        controllerAs: 'campoSituacaoMonitoradaPesquisaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5051',
            label: 'campo-situacao-monitorada',
            titulo: 'Campos - SQM'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/campo-situacao-monitorada/campo-situacao-monitorada-pesquisa/campo-situacao-monitorada-pesquisa-tpl.html',
        url: '/campo-situacao-monitorada?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&sistemaNegocio&documento&campo&situacao'
    })
        .state('campo-situacao-monitorada-incluir', {
        controller: 'CampoSituacaoMonitoradaIncluirController',
        controllerAs: 'campoSituacaoMonitoradaIncluirCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5052',
            label: 'campo-situacao-monitorada',
            titulo: 'Criar campo - SMQ'
        },
        parent: 'admin',
        templateUrl: 'views/campo-situacao-monitorada/campo-situacao-monitorada-incluir/campo-situacao-monitorada-incluir-tpl.html',
        url: '/campo-situacao-monitorada/incluir'
    })
        .state('campo-situacao-monitorada-desativar', {
        controller: 'CampoSituacaoMonitoradaDesativarController',
        controllerAs: 'campoSituacaoMonitoradaDesativarCtrl',
        parent: 'admin',
        template: '',
        url: '/campo-situacao-monitorada/:pk/desativar'
    })
        .state('campo-situacao-monitorada-detalhar', {
        controller: 'CampoSituacaoMonitoradaDetalharController',
        controllerAs: 'campoSituacaoMonitoradaDetalharCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5053',
            label: 'campo-situacao-monitorada',
            titulo: 'Detalhar campo - SMQ'
        },
        parent: 'admin',
        templateUrl: 'views/campo-situacao-monitorada/campo-situacao-monitorada-detalhe/campo-situacao-monitorada-detalhe-tpl.html',
        url: '/campo-situacao-monitorada/:pk/detalhar'
    })
        .state('campo-situacao-monitorada-alterar', {
        controller: 'CampoSituacaoMonitoradaAlterarController',
        controllerAs: 'campoSituacaoMonitoradaAlterarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5054',
            label: 'campo-situacao-monitorada',
            titulo: 'Alterar campo - SMQ'
        },
        parent: 'admin',
        templateUrl: 'views/campo-situacao-monitorada/campo-situacao-monitorada-alterar/campo-situacao-monitorada-alterar-tpl.html',
        url: '/campo-situacao-monitorada/:pk/alterar'
    });
});
//# sourceMappingURL=campo-situacao-monitorada-route-config.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(comunicacaoEnviadaRouteConfiguration);

  comunicacaoEnviadaRouteConfiguration.$inject = ['$stateProvider'];

  function comunicacaoEnviadaRouteConfiguration($stateProvider) {
    $stateProvider
      .state('comunicacoes-enviadas', {
        controller: 'ComunicacoesEnviadasListarController',
        controllerAs: 'comEnvLtrCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7041',
          label: 'Comunicações',
          titulo: 'Comunicações enviadas por atraso'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/comunicacoes-enviadas/comunicacoes-enviadas-listar-tpl.html',
        url: '/comunicacoes-enviadas?dataBaseFim&dataBaseInicio&documentos&envioFim&envioInicio&idBacen&segmentos&sistemasNegocio&grupoPeriodicidade&origem&situacao&isPesquisaRealizada&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(conformidadeRouterConfig);

  conformidadeRouterConfig.$inject = ['$stateProvider'];

  function conformidadeRouterConfig($stateProvider) {
    $stateProvider
      .state('conformidade-listar', {
        controller: 'ConformidadeListarController',
        controllerAs: 'conformidadeListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5021',
          label: 'Conformidade',
          titulo: 'Pesquisa das conformidades.'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/conformidade/conformidade-listar-tpl.html',
        url: '/conformidade?jaPesquisado&aberta&documentos&fechada&dataFim&dataInicio&sistemasNegocio'
      })
      .state('conformidade-detalhar', {
        controller: 'ConformidadeDetalharController',
        controllerAs: 'conformidadeDetalharCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5023',
          label: 'Conformidade',
          titulo: 'conformidade.'
        },
        parent: 'admin',
        templateUrl: 'views/conformidade/conformidade-detalhar-tpl.html',
        url: '/conformidade/:id/detalhar'
      })
      .state('conformidade-incluir', {
        controller: 'ConformidadeIncluirController',
        controllerAs: 'conformidadeIncluirCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5022',
          label: 'Conformidade',
          titulo: 'Solicitar nova conformidade.'
        },
        parent: 'admin',
        templateUrl: 'views/conformidade/conformidade-incluir-tpl.html',
        url: '/conformidade/incluir?dataFinal&documentos&sistemasNegocio'
      })
      .state('conformidade-confirmar-inclusao', {
        controller: 'ConformidadeConfirmarInclusaoController',
        controllerAs: 'conformidadeConfirmarInclusaoCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5024',
          label: 'Conformidade',
          titulo: 'Confirmar nova conformidade.'
        },
        parent: 'admin',
        templateUrl: 'views/conformidade/conformidade-confirmar-inclusao-tpl.html',
        url: '/conformidade/confirmar-inclusao?dataFinal&documentos&sistemasNegocio'
      })
      .state('conformidade-dar-conformidade', {
        controller: 'ConformidadeDarConformidadeController',
        controllerAs: 'conformidadeDarConformidadeCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5025',
          label: 'Conformidade',
          titulo: 'Dar Conformidade.'
        },
        parent: 'admin',
        templateUrl: 'views/conformidade/conformidade-dar-conformidade-tpl.html',
        url: '/conformidade/:id/dar-conformidade'
      });
  }
})(angular);
;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('critica-qualidade-pesquisa', {
        controller: 'CriticaQualidadePesquisaController',
        controllerAs: 'crqPqrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4061',
            label: 'Pesquisa de criticas de qualidade',
            titulo: 'Pesquisa de criticas de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/critica-qualidade/critica-qualidade-pesquisa/critica-qualidade-pesquisa-tpl.html',
        url: '/critica-qualidade?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&manual&automatica&criticas&sistemasNegocio&documentos&segmentos&tipos&vigenciaInicio&vigenciaFim'
    })
        .state('critica-qualidade-automatica-detalhar', {
        controller: 'CriticaQualidadeAutomaticaDetalheController',
        controllerAs: 'crqAutomaticaDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4064',
            label: 'Detalhar criticas de qualidade automatica',
            titulo: 'Detalhar criticas de qualidade automatica'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-detalhe/critica-qualidade-automatica-detalhe-tpl.html',
        url: '/critica-qualidade-automatica/:pk/detalhar?voltar'
    })
        .state('critica-qualidade-manual-detalhar', {
        controller: 'CriticaQualidadeManualDetalheController',
        controllerAs: 'crqManualDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4064',
            label: 'Detalhar criticas de qualidade manual',
            titulo: 'Detalhar criticas de qualidade manual'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-detalhe/critica-qualidade-manual-detalhe-tpl.html',
        url: '/critica-qualidade-manual/:pk/detalhar?voltar'
    })
        .state('critica-qualidade-automatica-alterar', {
        controller: 'CriticaQualidadeAutomaticaAlterarController',
        controllerAs: 'crqAutomaticaAltCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4063',
            label: 'Alterar criticas de qualidade automatica',
            titulo: 'Alterar criticas de qualidade automatica'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-alterar/critica-qualidade-automatica-alterar-tpl.html',
        url: '/critica-qualidade-automatica/:pk/alterar'
    })
        .state('critica-qualidade-manual-alterar', {
        controller: 'CriticaQualidadeManualAlterarController',
        controllerAs: 'crqManualAltCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4063',
            label: 'Alterar criticas de qualidade manual',
            titulo: 'Alterar criticas de qualidade manual'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-alterar/critica-qualidade-manual-alterar-tpl.html',
        url: '/critica-qualidade-manual/:pk/alterar'
    })
        .state('critica-qualidade-automatica-clonar', {
        controller: 'CriticaQualidadeAutomaticaIncluirController',
        controllerAs: 'crqAutoIcrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4065',
            label: 'Clonar crítica de qualidade automatica',
            titulo: 'Clonar críticas de qualidade automatica'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-incluir/critica-qualidade-automatica-incluir-tpl.html',
        url: '/critica-qualidade-automatica/:pk/clonar'
    })
        .state('critica-qualidade-manual-clonar', {
        controller: 'CriticaQualidadeManualIncluirController',
        controllerAs: 'crqManualIcrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4065',
            label: 'Clonar cr�tica de qualidade manual',
            titulo: 'Clonar cr�ticas de qualidade manual'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-incluir/critica-qualidade-manual-incluir-tpl.html',
        url: '/critica-qualidade-manual/:pk/clonar'
    })
        .state('critica-qualidade-automatica-incluir', {
        controller: 'CriticaQualidadeAutomaticaIncluirController',
        controllerAs: 'crqAutoIcrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4062',
            label: 'Incluir criticas de qualidade automatica',
            titulo: 'Incluir criticas de qualidade automatica'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-incluir/critica-qualidade-automatica-incluir-tpl.html',
        url: '/critica-qualidade-automatica/incluir'
    })
        .state('critica-qualidade-manual-incluir', {
        controller: 'CriticaQualidadeManualIncluirController',
        controllerAs: 'crqManualIcrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4062',
            label: 'Incluir criticas de qualidade manual',
            titulo: 'Incluir criticas de qualidade manual'
        },
        parent: 'admin',
        templateUrl: 'views/critica-qualidade/critica-qualidade-incluir/critica-qualidade-manual-incluir-tpl.html',
        url: '/critica-qualidade-manual/incluir'
    });
});
//# sourceMappingURL=critica-qualidade-route-config.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(curadorSistemaNegocioRouteConfig);

  curadorSistemaNegocioRouteConfig.$inject = ['$stateProvider'];

  function curadorSistemaNegocioRouteConfig($stateProvider) {
    $stateProvider
      .state('curador-sistema-negocio-listar', {
        controller: 'CuradorSistemaNegocioListarController',
        controllerAs: 'curadorSistemaNegocioListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6021',
          label: 'agentes de curadoria',
          titulo: 'Pesquisa de agentes de curadoria'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/curador-sistema-negocio/curador-sistema-negocio-listar-tpl.html',
        url: '/curador-sistema-negocio?sistemaNegocio&unidade&operador'
      })
      .state('curador-sistema-negocio-incluir', {
        controller: 'CuradorSistemaNegocioIncluirController',
        controllerAs: 'curadorSistemaNegocioIncluirCtrl',
        informacaoPagina: {
          codigo: 'CRDFW6022',
          label: 'agentes de curadoria',
          titulo: 'Adicionar autorização de agente de curadoria'
        },
        parent: 'admin',
        templateUrl: 'views/curador-sistema-negocio/curador-sistema-negocio-incluir-tpl.html',
        url: '/curador-sistema-negocio/incluir'
      })
      .state('curador-sistema-negocio-excluir', {
        controller: 'CuradorSistemaNegocioExcluirController',
        controllerAs: 'curadorSistemaNegocioExcluirCtrl',
        parent: 'admin',
        template: '',
        url: '/curador-sistema-negocio/:id/excluir'
      });
  }
})(angular);
;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('dashboard', {
        controller: 'DashboardController',
        controllerAs: 'dashCtrl',
        informacaoPagina: {
            codigo: 'CRDFW0000',
            label: 'Mural de Avisos',
            titulo: 'Mural de Avisos'
        },
        parent: 'admin',
        templateUrl: 'views/dashboard/dashboard-tpl.html',
        url: '/dashboard?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
    });
});
//# sourceMappingURL=dashboard-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('dispensa-listar', {
        controller: 'DispensaListarController',
        controllerAs: 'dispensaListarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5041',
            label: 'Pesquisa dispensa documentos',
            titulo: 'Pesquisa dispensa documentos',
            outros: {
                acoes: {
                    incluir: 'Incluir dispensa',
                    detalhar: 'Detalhar dispensa',
                    alterar: 'Alterar dispensa',
                    desativar: 'Desativa dispensa',
                    voltar: "/dispensa"
                },
                links: {
                    incluir: "#/dispensa/incluir",
                    detalhar: "dispensa-detalhar({id: r.pk})",
                    alterar: "dispensa-alterar({id: r.pk})",
                    desativar: "#/dispensa/:id/desativar"
                },
                isDocumentoZerado: false
            }
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/dispensa/dispensa-listar-tpl.html',
        url: '/dispensa?jaPesquisado?dataFim&dataInicio&documento&instituicao&sistemaNegocio&situacaoDispensa&grupoPeriodicidade&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&isDocumentoZerado'
    })
        .state('dispensa-incluir', {
        controller: 'DispensaIncluirController',
        controllerAs: 'dispensaIncluirCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5042',
            label: 'Dados da dispensa do documento',
            titulo: 'Dispensa de documentos',
            outros: {
                labelConfirma: 'Incluir dispensa',
                acoes: {
                    voltar: '/dispensa'
                },
                isDocumentoZerado: false
            }
        },
        parent: 'admin',
        templateUrl: 'views/dispensa/dispensa-incluir-tpl.html',
        url: '/dispensa/incluir'
    })
        .state('dispensa-detalhar', {
        controller: 'DispensaDetalharController',
        controllerAs: 'dispensaDetalharCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5042',
            label: 'Detalhar dispensa documentos',
            titulo: 'Detalhar dispensa documentos',
            outros: {
                header: 'Dispensa de documentos',
                dados: 'Dados da dispensa de documentos',
                acoes: {
                    voltar: '/dispensa',
                    desativar: 'Desativar dispensa',
                    alterar: "dispensa-alterar({id: dispensaDetalharCtrl.dispensa.pk})"
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/dispensa/dispensa-detalhar-tpl.html',
        url: '/dispensa/:id/detalhar'
    })
        .state('dispensa-detalhar-eso', {
        controller: 'EsperadosDetalheController',
        controllerAs: 'esoDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5043',
            label: 'Detalhar documento esperado da dispensa',
            titulo: 'Detalhar documento esperado da dispensa',
            outros: {
                header: 'Documento esperado da dispensa de documentos',
                dados: 'Dados do documento esperado da dispensa',
                acoes: {
                    voltar: '/dispensa'
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/esperados/views/esperados-detalhe/esperados-detalhe-tpl.html',
        url: '/dispensa/:pk/esperado/:esoPk'
    })
        .state('dispensa-alterar', {
        controller: 'DispensaAlterarController',
        controllerAs: 'dispensaAlterarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5042',
            label: 'Alterar dispensa documentos',
            titulo: 'Alterar dispensa documentos',
            outros: {
                labelConfirma: 'Alterar dispensa',
                header: 'Dispensa de documentos',
                dados: 'Dados da dispensa de documentos',
                acoes: {
                    voltar: '/dispensa'
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/dispensa/dispensa-alterar-tpl.html',
        url: '/dispensa/:id/alterar'
    });
});
//# sourceMappingURL=dispensa-route-config.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(documentoNaoEntregueImpedidoRouteConfiguration);

  documentoNaoEntregueImpedidoRouteConfiguration.$inject = ['$stateProvider'];

  function documentoNaoEntregueImpedidoRouteConfiguration($stateProvider) {
    $stateProvider
      .state('documento-nao-entregue-impedido', {
        controller: 'DocumentoNaoEntregueImpedidoListarController',
        controllerAs: 'documentoNaoEntregueImpedidoListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7032',
          label: 'Documento',
          titulo: 'Documentos impedidos'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento-nao-entregue/documento-nao-entregue-impedido-listar-tpl.html',
        url: '/documento-nao-entregue-impedido?isPesquisaRealizada&cobranca&documentos&excecoes&idBacen&segmentos&sistemasNegocio'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(documentoNaoEntregueRouteConfiguration);

  documentoNaoEntregueRouteConfiguration.$inject = ['$stateProvider'];

  function documentoNaoEntregueRouteConfiguration($stateProvider) {
    $stateProvider
      .state('documento-nao-entregue', {
        controller: 'DocumentoNaoEntregueListarController',
        controllerAs: 'documentoNaoEntregueListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7031',
          label: 'Documento',
          titulo: 'Consulta Documento Não Entregue'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento-nao-entregue/documento-nao-entregue-listar-tpl.html',
        url: '/documento-nao-entregue?isPesquisaRealizada&cobranca&documentos&excecoes&idBacen&segmentos&sistemasNegocio'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(documentoRouteConfiguration);

  documentoRouteConfiguration.$inject = ['$stateProvider', '$urlRouterProvider'];

  function documentoRouteConfiguration($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/documento/:documentoPk/', '/documento/:documentoPk/dados-gerais-detalhar');

    $stateProvider
      .state('documento-listar', {
        controller: 'DocumentoListarController',
        controllerAs: 'documentoLtrCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5011',
          label: 'Documento',
          titulo: 'Pesquisar documentos'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento/documento-listar/documento-listar-tpl.html',
        url: '/documentos?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&documento&sistemaNegocio&unidade&operador'
      })
      .state('documento-incluir', {
        controller: 'DocumentoIncluirController',
        controllerAs: 'documentoIncluirCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5012',
          label: 'Documento',
          titulo: 'Novo documento'
        },
        parent: 'admin',
        templateUrl: 'views/documento/documento-incluir/documento-incluir-tpl.html',
        url: '/documento-incluir'
      })
      .state('documento', {
        abstract: true,
        parent: 'admin',
        templateUrl: 'views/documento/documento-template-tpl.html',
        url: '/documento/:documentoPk'
      })
      .state('documento.dados-gerais-detalhar', {
        controller: 'DocumentoDetalharController',
        controllerAs: 'documentoDetalharCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5013',
          label: 'Documento',
          titulo: 'Documento detalhar dados gerais'
        },
        parent: 'documento',
        templateUrl: 'views/documento/documento-detalhar/documento-detalhar-tpl.html',
        url: '/dados-gerais-detalhar'
      })
      .state('documento.dados-gerais-alterar', {
        controller: 'DocumentoAlterarController',
        controllerAs: 'documentoAlterarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5012',
          label: 'Documento',
          titulo: 'Documento alterar dados gerais'
        },
        parent: 'documento',
        templateUrl: 'views/documento/documento-alterar/documento-alterar-tpl.html',
        url: '/dados-gerais-alterar'
      })
      .state('documento.equipe-gestora-listar', {
        controller: 'EquipeGestoraDocumentoListarController',
        controllerAs: 'egdLtrCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5014',
          label: 'Equipe gestora do documento',
          titulo: 'Equipe gestora do documento'
        },
        parent: 'documento',
        templateUrl: 'views/documento/equipe-gestora-documento/equipe-gestora-documento-listar-tpl.html',
        url: '/equipes-gestora?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
      })
      .state('documento.informacao-cadastral-listar', {
        controller: 'InformacaoCadastralDocumentoListarController',
        controllerAs: 'incLtrCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5017',
          label: 'Outras informações para o documento',
          titulo: 'Outras informações para o documento'
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento/informacao-cadastral-documento/informacao-cadastral-documento-listar-tpl.html',
        url: '/informacoes-cadastrais?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
      })
      .state('documento.normativo-documento-listar', {
        controller: 'NormativoDocumentoListarController',
        controllerAs: 'norLtrCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5016',
          label: 'Normativos do documento',
          titulo: 'Normativos do documento'
        },
        parent: 'documento',
        templateUrl: 'views/documento/normativo-documento/normativo-documento-listar-tpl.html',
        url: '/normmativos?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
      })
      .state('documento.administracao-documento-detalhar', {
        controller: 'AdministracaoDocumentoDetalharController',
        controllerAs: 'adoDtlCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5018',
          label: 'Documento',
          titulo: 'Documento detalhar dados gerais'
        },
        parent: 'documento',
        templateUrl: 'views/documento/administracao-documento/administracao-documento-detalhar-tpl.html',
        url: '/administracao-documento-detalhar'
      })
      .state('documento.administracao-documento-manutencao', {
        controller: 'AdministracaoDocumentoManutencaoController',
        controllerAs: 'adoManCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5019',
          label: 'Documento',
          titulo: 'Documento manter administração do documento'
        },
        parent: 'documento',
        templateUrl: 'views/documento/administracao-documento/administracao-documento-manutencao-tpl.html',
        url: '/administracao-documento-manutencao/'
      })
      .state('documento.parametros-de-cobranca-listar', {
        controller: 'ParametrosDeCobrancaListarController',
        controllerAs: 'parametrosDeCobrancaLstCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7011',
          label: 'Documento',
          titulo: 'Documento'
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento/parametros-de-cobranca-listar/parametros-de-cobranca-listar-tpl.html',
        url: '/parametros-de-cobranca'
      })
      .state('documento.parametros-de-cobranca-incluir', {
        controller: 'ParametrosDeCobrancaIncluirController',
        controllerAs: 'parametrosDeCobrancaIncCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7016',
          label: 'Documento',
          titulo: 'Documento'
        },
        parent: 'documento',
        templateUrl: 'views/documento/parametros-de-cobranca-incluir/parametros-de-cobranca-incluir-tpl.html',
        url: '/parametros-de-cobranca/:id/montar-tela-incluir'
      })
      .state('documento.parametros-de-cobranca-alterar', {
        controller: 'ParametrosDeCobrancaAlterarController',
        controllerAs: 'parametrosDeCobrancaAltCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7017',
          label: 'Documento',
          titulo: 'Documento'
        },
        parent: 'documento',
        templateUrl: 'views/documento/parametros-de-cobranca-alterar/parametros-de-cobranca-alterar-tpl.html',
        url: '/parametros-de-cobranca/:id/montar-tela-alterar'
      })
      .state('documento.parametros-de-cobranca-detalhar', {
        controller: 'ParametrosDeCobrancaDetalharController',
        controllerAs: 'parametrosDeCobrancaDtlCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7013',
          label: 'Documento',
          titulo: 'Documento'
        },
        parent: 'documento',
        templateUrl: 'views/documento/parametros-de-cobranca-detalhar/parametros-de-cobranca-detalhar-tpl.html',
        url: '/parametros-de-cobranca/:id/detalhe'
      })
      .state('documento.parametros-de-cobranca-excluir', {
        controller: 'ParametrosDeCobrancaExcluirController',
        controllerAs: 'parametrosDeCobrancaExcCtrl',
        parent: 'documento',
        templateUrl: '',
        url: '/parametros-de-cobranca/:id/excluir'
      })
      .state('documento.responsavel-documento-listar', {
        controller: 'ResponsavelDocumentoListarController',
        controllerAs: 'redLtrCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5015',
          label: 'Responsável pelo documento',
          titulo: 'Responsável pelo documento'
        },
        parent: 'documento',
        templateUrl: 'views/documento/responsavel-documento/responsavel-documento-listar-tpl.html',
        url: '/responsaveis?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
      })
      .state('documento.leiautes-consultar', {
        controller: 'LeiauteDocumentoListarController',
        controllerAs: 'ldLtrCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5020',
          label: 'Leiautes de entrada',
          titulo: 'Leiautes de entrada',
          outros: {
            activeTab: 'documento.leiautes'
          }
        },
        parent: 'documento',
        reloadOnSearch: false,
        templateUrl: 'views/documento/leiaute-documento/views/leiaute-documento-listar/leiaute-documento-listar-tpl.html',
        url: '/leiautes?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
      })
      .state('documento.leiautes-incluir', {
        controller: 'LeiauteDocumentoInclusaoController',
        controllerAs: 'ldInclusaoCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5020',
          label: 'Leiautes de entrada',
          titulo: 'Incluir leiaute de entrada',
          outros: { activeTab: 'documento.leiautes' }
        },
        templateUrl: 'views/documento/leiaute-documento/views/leiaute-documento-inclusao/leiaute-documento-inclusao-tpl.html',
        url: '/leiautes/incluir'
      })
      .state('documento.leiautes-alterar', {
        controller: 'LeiauteDocumentoAlteracaoController',
        controllerAs: 'ldAlteracaoCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5020',
          label: 'Leiautes de entrada',
          titulo: 'Alterar leiaute de entrada',
          outros: { activeTab: 'documento.leiautes' }
        },
        templateUrl: 'views/documento/leiaute-documento/views/leiaute-documento-alteracao/leiaute-documento-alteracao-tpl.html',
        url: '/leiautes/:leiautePk/alterar'
      })
      .state('documento.leiautes-detalhar', {
        controller: 'LeiauteDocumentoDetalheController',
        controllerAs: 'ldDetalheCtrl',
        informacaoPagina: {
          codigo: 'CRDFW5020',
          label: 'Leiautes de entrada',
          titulo: 'Detalhar leiaute de entrada',
          outros: { activeTab: 'documento.leiautes' }
        },
        templateUrl: 'views/documento/leiaute-documento/views/leiaute-documento-detalhe/leiaute-documento-detalhe-tpl.html',
        url: '/leiautes/:leiautePk/detalhar'
      });
  }
})(angular);
;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('documento-zerado-listar', {
        controller: 'DispensaListarController',
        controllerAs: 'dispensaListarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5041',
            label: 'Pesquisa documentos zerados',
            titulo: 'Pesquisa de documentos zerados',
            outros: {
                acoes: {
                    incluir: 'Incluir documento zerado',
                    detalhar: 'Detalhar documento zerado',
                    alterar: 'Alterar documento zerado',
                    desativar: 'Desativar documento zerado',
                    voltar: "/documento-zerado"
                },
                links: {
                    incluir: "#/documento-zerado/incluir",
                    detalhar: "documento-zerado-detalhar({id: r.pk})",
                    alterar: "documento-zerado-alterar({id: r.pk})",
                    desativar: "#/documento-zerado/:id/desativar"
                },
                isDocumentoZerado: true
            }
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/dispensa/dispensa-listar-tpl.html',
        url: '/documento-zerado?jaPesquisado?dataFim&dataInicio&documento&instituicao&sistemaNegocio&situacaoDispensa&grupoPeriodicidade&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&isDocumentoZerado'
    })
        .state('documento-zerado-incluir', {
        controller: 'DispensaIncluirController',
        controllerAs: 'dispensaIncluirCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5042',
            label: 'Dados do documento zerado',
            titulo: 'Documento zerado',
            outros: {
                labelConfirma: 'Incluir documento zerado',
                acoes: {
                    voltar: '/documento-zerado'
                },
                isDocumentoZerado: true
            }
        },
        parent: 'admin',
        templateUrl: 'views/dispensa/dispensa-incluir-tpl.html',
        url: '/documento-zerado/incluir'
    })
        .state('documento-zerado-detalhar', {
        controller: 'DispensaDetalharController',
        controllerAs: 'dispensaDetalharCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5042',
            label: 'Detalhar documento zerado',
            titulo: 'Detalhar documento zerado',
            outros: {
                header: 'Documento zerado',
                dados: 'Dados do documento zerado',
                acoes: {
                    labelConfirma: 'Alterar documento zerado',
                    voltar: '/documento-zerado',
                    desativar: 'Desativar documento zerado',
                    alterar: "documento-zerado-alterar({id: dispensaDetalharCtrl.dispensa.pk})"
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/dispensa/dispensa-detalhar-tpl.html',
        url: '/documento-zerado/:id/detalhar'
    })
        .state('documento-zerado-alterar', {
        controller: 'DispensaAlterarController',
        controllerAs: 'dispensaAlterarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5042',
            label: 'Alterar documento zerado',
            titulo: 'Alterar documento zerado',
            outros: {
                labelConfirma: 'Alterar documento zerado',
                header: 'Documento zerado',
                dados: 'Dados do documento zerado',
                acoes: {
                    voltar: '/documento-zerado'
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/dispensa/dispensa-alterar-tpl.html',
        url: '/documento-zerado/:id/alterar'
    });
});
//# sourceMappingURL=documento-zerado-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('entidade-supervisionada-controle-pesquisa', {
        controller: 'EntidadeSupervisionadaControlePesquisaController',
        controllerAs: 'ecoPqrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5061',
            label: 'Pesquisa de inclusão/exclusão manual em esperados',
            titulo: 'Pesquisa de inclusão/exclusão manual em esperados'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/entidade-supervisionada-controle/pesquisa/entidade-supervisionada-controle-pesquisa-tpl.html',
        url: '/entidade-supervisionada-controle?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&grupoPeriodicidade&documento&sistemaNegocio&instituicao&dataBaseInicio&dataBaseFim&situacao'
    })
        .state('entidade-supervisionada-controle-detalhar', {
        controller: 'EntidadeSupervisionadaControleDetalharController',
        controllerAs: 'ecoDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5063',
            label: 'Detalhar inclusão/exclusão manual em esperados',
            titulo: 'Detalhar inclusão/exclusão manual em esperados',
            outros: {
                header: 'Inclusão/exclusão manual em esperados',
                dados: 'Dados da Inclusão/exclusão manual',
                acoes: {
                    voltar: '/entidade-supervisionada-controle',
                    desativar: 'Desativar inclusão/exclusão manual',
                    alterar: "entidade-supervisionada-controle-alterar({id: ecoDtlCtrl.entidadeSupervisionadaControle.pk})"
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/entidade-supervisionada-controle/detalhar/entidade-supervisionada-controle-detalhar-tpl.html',
        url: '/entidade-supervisionada-controle/:pk/detalhar'
    })
        .state('entidade-supervisionada-controle-detalhar-eso', {
        controller: 'EsperadosDetalheController',
        controllerAs: 'esoDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5065',
            label: 'Detalhar documento esperado da inclusão/exclusão manual em esperados',
            titulo: 'Detalhar documento esperado da inclusão/exclusão manual em esperados',
            outros: {
                header: 'Documento esperado da inclusão/exclusão manual em esperados',
                dados: 'Dados do documento esperado da inclusão/exclusão manual',
                acoes: {
                    voltar: '/entidade-supervisionada-controle'
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/esperados/views/esperados-detalhe/esperados-detalhe-tpl.html',
        url: '/entidade-supervisionada-controle/:pk/esperado/:esoPk'
    })
        .state('entidade-supervisionada-controle-alterar', {
        controller: 'EntidadeSupervisionadaControleAlterarController',
        controllerAs: 'ecoAltCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5064',
            label: 'Alterar inclusão/exclusão manual',
            titulo: 'Alterar inclusão/exclusão manual',
            outros: {
                labelConfirma: 'Alterar inclusão/exclusão manual',
                header: 'Inclusão/exclusão manual em esperados',
                dados: 'Inclusão/exclusão manual em esperados',
                acoes: {
                    voltar: '/entidade-supervisionada-controle'
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/entidade-supervisionada-controle/alterar/entidade-supervisionada-controle-alterar-tpl.html',
        url: '/entidade-supervisionada-controle/:pk/alterar'
    })
        .state('entidade-supervisionada-controle-incluir', {
        controller: 'EntidadeSupervisionadaControleIncluirController',
        controllerAs: 'ecoInclCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5062',
            label: 'Incluir inclusão/exclusão manual',
            titulo: 'Incluir inclusão/exclusão manual',
            outros: {
                labelConfirma: 'Incluir inclusão/exclusão manual',
                header: 'Inclusão/exclusão manual em esperados',
                dados: 'Inclusão/exclusão manual em esperados',
                acoes: {
                    voltar: '/entidade-supervisionada-controle'
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/entidade-supervisionada-controle/incluir/entidade-supervisionada-controle-incluir-tpl.html',
        url: '/entidade-supervisionada-controle/incluir'
    });
    ;
});
//# sourceMappingURL=entidade-supervisionada-controle-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('esperados-processados-listar', {
        controller: 'EsperadosProcessadosListarController',
        controllerAs: 'esperadosProcessadosLtrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5031',
            label: 'Processamento de esperados e processados',
            titulo: 'Pesquisa de esperados e processados'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/esperados-processados/esperados-processados-listar-tpl.html',
        url: '/esperados-processados?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&sistemasNegocio&documentos&instituicao&dataBaseInicio&dataBaseFim&situacaoEntidadeObrigada&gruposSituacaoEntradaArquivo&situacoesSubstituicao&dataInicioDeProcessamento&dataFimDeProcessamento&protocoloRecebimento&processado&isPesquisaRealizada&grupoPeriodicidade&tipoResultado&segmentos'
    })
        .state('esperados-processados-detalhar', {
        controller: 'EsperadosProcessadosDetalharController',
        controllerAs: 'esperadosProcessadosDtlrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5032',
            label: 'Detalhes do processamento do documento',
            titulo: 'Detalhes do processamento do documento'
        },
        parent: 'admin',
        templateUrl: 'views/esperados-processados/detalhamento/esperados-processados-detalhar-tpl.html',
        url: '/processado/:entradaArquivoPK/detalhar'
    })
        .state('esperados-processados-detalhar-eso', {
        controller: 'EsperadosDetalheController',
        controllerAs: 'esoDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5033',
            label: 'Detalhes do documento esperado do processamento do documento',
            titulo: 'Detalhes do documento esperado do processamento do documento',
            outros: {
                acoes: {
                    voltar: '/processado'
                }
            }
        },
        parent: 'admin',
        templateUrl: 'views/esperados/views/esperados-detalhe/esperados-detalhe-tpl.html',
        url: '/documento-esperado/:entradaArquivoPK/detalhar-esperado-processado'
    });
});
//# sourceMappingURL=esperados-processados-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('excecoes-qualidade-listar', {
        controller: 'ExcecaoQualidadePesquisaController',
        controllerAs: 'excecaoQualidadeListarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4071',
            label: 'excecao-qualidade',
            titulo: 'Exce��o de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/excecao-qualidade/excecao-qualidade-pesquisa/excecao-qualidade-pesquisa-tpl.html',
        url: '/excecoes-qualidade?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&ativa&inativa&documentos&segmento&sistemaNegocio&excecoesId&critica&instituicao'
    })
        .state('excecoes-qualidade-incluir', {
        controller: 'ExcecaoQualidadeIncluirController',
        controllerAs: 'excecaoQualidadeIncluirCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4072',
            label: 'excecao-qualidade',
            titulo: 'Criar uma exce��o de qualidade'
        },
        parent: 'admin',
        templateUrl: 'views/excecao-qualidade/excecao-qualidade-incluir/excecao-qualidade-incluir-tpl.html',
        url: '/excecoes-qualidade/incluir?indicioPk&voltar&voltarParametros'
    })
        .state('excecoes-qualidade-desativar', {
        controller: 'ExcecaoQualidadeDesativarController',
        controllerAs: 'excecaoQualidadeDesativarCtrl',
        parent: 'admin',
        template: '',
        url: '/excecoes-qualidade/:id/desativar'
    })
        .state('excecoes-qualidade-detalhar', {
        controller: 'ExcecaoQualidadeDetalheController',
        controllerAs: 'excecaoQualidadeDetalharCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4074',
            label: 'excecao-qualidade',
            titulo: 'Detalhar exce��o de Qualidade'
        },
        parent: 'admin',
        templateUrl: 'views/excecao-qualidade/excecao-qualidade-detalhe/excecao-qualidade-detalhe-tpl.html',
        url: '/excecoes-qualidade/:id/detalhar'
    })
        .state('excecoes-qualidade-alterar', {
        controller: 'ExcecaoQualidadeAlterarController',
        controllerAs: 'excecaoQualidadeAlterarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4073',
            label: 'excecao-qualidade',
            titulo: 'Alterar exce��o de Qualidade'
        },
        parent: 'admin',
        templateUrl: 'views/excecao-qualidade/excecao-qualidade-alterar/excecao-qualidade-alterar-tpl.html',
        url: '/excecoes-qualidade/:id/alterar'
    });
});
//# sourceMappingURL=excecao-qualidade-route-config.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(excecaoRouteConfiguration);

  excecaoRouteConfiguration.$inject = ['$stateProvider'];

  function excecaoRouteConfiguration($stateProvider) {
    $stateProvider
      .state('excecoes-listar', {
        controller: 'ExcecaoListarController',
        controllerAs: 'excecaoListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7021',
          label: 'Exceção',
          titulo: 'Exceção de cobrança de atraso'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/excecao/excecao-listar-tpl.html',
        url: '/excecoes?jaPesquisado&ativa&codigos&dataBase&documento&idBacen&inativa&sistemaNegocio'
      })
      .state('excecoes-incluir', {
        controller: 'ExcecaoIncluirController',
        controllerAs: 'excecaoIncluirCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7022',
          label: 'exceção',
          titulo: 'Criar uma exceção de cobrança de atraso'
        },
        parent: 'admin',
        templateUrl: 'views/excecao/excecao-incluir-tpl.html',
        url: '/excecoes/incluir'
      })
      .state('excecoes-desativar', {
        controller: 'ExcecaoDesativarController',
        controllerAs: 'excecaoDesativarCtrl',
        parent: 'admin',
        template: '',
        url: '/excecoes/:id/desativar'
      })
      .state('excecoes-detalhar', {
        controller: 'ExcecaoDetalharController',
        controllerAs: 'excecaoDetalharCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7023',
          label: 'Exceção',
          titulo: 'Excecao'
        },
        parent: 'admin',
        templateUrl: 'views/excecao/excecao-detalhar-tpl.html',
        url: '/excecoes/:id/detalhar'
      })
      .state('excecoes-alterar', {
        controller: 'ExcecaoAlterarController',
        controllerAs: 'excecaoAlterarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW7022',
          label: 'exceção',
          titulo: 'Exceção'
        },
        parent: 'admin',
        templateUrl: 'views/excecao/excecao-alterar-tpl.html',
        url: '/excecoes/:id/alterar'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(indiceDesempenhoCaptacaoRouteConfiguration);

  indiceDesempenhoCaptacaoRouteConfiguration.$inject = ['$stateProvider'];

  function indiceDesempenhoCaptacaoRouteConfiguration($stateProvider) {
    $stateProvider
      .state('indice-desempenho-captacao', {
        controller: 'IndiceDesempenhoCaptacaoListarController',
        controllerAs: 'iDCIListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW8041',
          label: 'IDCI',
          titulo: 'Pesquisa de IDCI - Índice de desempenho da captação de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-desempenho-captacao/indice-desempenho-captacao-listar-tpl.html',
        url: '/indice-desempenho-captacao?baseCalculo'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(indiceRegularidadeFornecimentoRouteConfiguration);

  indiceRegularidadeFornecimentoRouteConfiguration.$inject = ['$stateProvider'];

  function indiceRegularidadeFornecimentoRouteConfiguration($stateProvider) {
    $stateProvider
      .state('indice-desempenho-fornecedores', {
        controller: 'IndiceDesempenhoFornecedoresListarController',
        controllerAs: 'iDFIListarCtrl',
        informacaoPagina: {
          codigo: 'CRDFW8031',
          label: 'IDFI',
          titulo: 'Pesquisa de IDFI - Índice de desempenho dos fornecedores de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-desempenho-fornecedores/indice-desempenho-fornecedores-listar-tpl.html',
        url: '/indice-desempenho-fornecedores?baseCalculoInicio&baseCalculoFim'
      });
  }
})(angular);
;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('indice-qualidade-fornecimento-listar', {
        controller: 'IndiceQualidadeFornecimentoListarController',
        controllerAs: 'iQFIListarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8051',
            label: 'Pesquisa de IQFI - Índice de qualidade no fornecimento de informações',
            titulo: 'Pesquisa de IQFI - Índice de qualidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-qualidade-fornecimento/indice-qualidade-fornecimento-listar-tpl.html',
        url: '/indice-qualidade-fornecimento?baseCalculo&segmentos&conglomerado&bancaria&naoBancaria&indiceInferior&indiceSuperior&instituicao&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&telaRetornoPainel'
    })
        .state('indice-qualidade-fornecimento-entidade-supervisionada', {
        controller: 'IndiceQualidadeFornecimentoDetalheController',
        controllerAs: 'iQFIDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8052',
            label: 'Pesquisa por Entidade Supervisionada',
            titulo: 'Pesquisa de IQFI por Entidade Supervisionada - Índice de qualidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-qualidade-fornecimento/indice-qualidade-fornecimento-detalhe-tpl.html',
        url: '/indice-qualidade-fornecimento/:instituicao/entidade-supervisionada?baseCalculoFim&baseCalculoInicio&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('indice-qualidade-fornecimento-conglomerado', {
        controller: 'IndiceQualidadeFornecimentoDetalheController',
        controllerAs: 'iQFIDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8053',
            label: 'Pesquisa por Conglomerado',
            titulo: 'Pesquisa de IQFI por Conglomerado - Índice de qualidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-qualidade-fornecimento/indice-qualidade-fornecimento-detalhe-tpl.html',
        url: '/indice-qualidade-fornecimento/:conglomerado/conglomerado?baseCalculoFim&baseCalculoInicio&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('indice-qualidade-fornecimento-entidade-supervisionada-conglomerado', {
        controller: 'IndiceQualidadeFornecimentoDetalheController',
        controllerAs: 'iQFIDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8053',
            label: 'Pesquisa por Conglomerado',
            titulo: 'Pesquisa de IQFI por Conglomerado - Índice de qualidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-qualidade-fornecimento/indice-qualidade-fornecimento-detalhe-tpl.html',
        url: '/indice-qualidade-fornecimento/:instituicao/:conglomerado/conglomerado?baseCalculoFim&baseCalculoInicio&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    });
});
//# sourceMappingURL=indice-qualidade-fornecimento-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('indice-regularidade-fornecimento-listar', {
        controller: 'IndiceRegularidadeFornecimentoListarController',
        controllerAs: 'iRFIListarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8021',
            label: 'Pesquisa de IRFI - Índice de regularidade no fornecimento de informações',
            titulo: 'Pesquisa de IRFI - Índice de regularidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-regularidade-fornecimento/indice-regularidade-fornecimento-listar-tpl.html',
        url: '/indice-regularidade-fornecimento?baseCalculo&segmentos&conglomerado&bancaria&naoBancaria&indiceInferior&indiceSuperior&instituicao&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&telaRetornoPainel'
    })
        .state('indice-regularidade-fornecimento-entidade-supervisionada', {
        controller: 'IndiceRegularidadeFornecimentoDetalheController',
        controllerAs: 'iRFIDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8022',
            label: 'Pesquisa por Entidade Supervisionada',
            titulo: 'Pesquisa de IRFI por Entidade Supervisionada - Índice de regularidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-regularidade-fornecimento/indice-regularidade-fornecimento-detalhe-tpl.html',
        url: '/indice-regularidade-fornecimento/:instituicao/es?baseCalculoFim&baseCalculoInicio&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('indice-regularidade-fornecimento-conglomerado', {
        controller: 'IndiceRegularidadeFornecimentoDetalheController',
        controllerAs: 'iRFIDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8023',
            label: 'Pesquisa por Conglomerado',
            titulo: 'Pesquisa de IRFI por Conglomerado - Índice de regularidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-regularidade-fornecimento/indice-regularidade-fornecimento-detalhe-tpl.html',
        url: '/indice-regularidade-fornecimento/:conglomerado/conglomerado?baseCalculoFim&baseCalculoInicio&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('indice-regularidade-fornecimento-entidade-supervisionada-conglomerado', {
        controller: 'IndiceRegularidadeFornecimentoDetalheController',
        controllerAs: 'iRFIDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW8023',
            label: 'Pesquisa por Conglomerado',
            titulo: 'Pesquisa de IRFI por Conglomerado - Índice de regularidade no fornecimento de informações'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indice-regularidade-fornecimento/indice-regularidade-fornecimento-detalhe-tpl.html',
        url: '/indice-regularidade-fornecimento/:instituicao/:conglomerado/conglomerado?baseCalculoFim&baseCalculoInicio&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    });
});
//# sourceMappingURL=indice-regularidade-fornecimento-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('painel-auditoria-observancia', {
        controller: 'PainelAuditoriaObservanciaController',
        controllerAs: 'painelAuditoriaObservanciaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5041',
            label: 'Painel de Auditoria de Observancia',
            titulo: 'Painel de Auditoria de Observancia'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-auditoria-observancia/painel-auditoria-observancia-tpl.html',
        url: '/painel-auditoria-observancia/:idbacen/painel?telaRetornoPainel'
    });
});
//# sourceMappingURL=painel-auditoria-observancia-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('porta-lateral-qualidade-importacao', {
        controller: 'PortaLateralQualidadeImportacaoController',
        controllerAs: 'plqImportacaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4051',
            label: 'Importação de fator faixa qualidade',
            titulo: 'Importação de fator faixa qualidade'
        },
        parent: 'admin',
        templateUrl: 'views/porta-lateral-qualidade/porta-lateral-qualidade-importacao-tpl.html',
        url: '/porta-lateral-qualidade-importacao'
    })
        .state('porta-lateral-qualidade-controle-da-importacao', {
        controller: 'PortaLateralQualidadeControleDaImportacaoController',
        controllerAs: 'plqControleDaImportacaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4052',
            label: 'Controle importação de fator faixa qualidade',
            titulo: 'Controle importação de fator faixa qualidade'
        },
        parent: 'admin',
        templateUrl: 'views/porta-lateral-qualidade/porta-lateral-qualidade-controle-da-importacao-tpl.html',
        url: '/porta-lateral-qualidade-controle-da-importacao'
    });
});
//# sourceMappingURL=porta-lateral-qualidade-route-config.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('porta-lateral-tempestividade-importacao', {
        controller: 'PortaLateralTempestividadeImportacaoController',
        controllerAs: 'pltImportacaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW7051',
            label: 'Importação de fator faixa tempestividade',
            titulo: 'Importação de fator faixa tempestividade'
        },
        parent: 'admin',
        templateUrl: 'views/porta-lateral-tempestividade/porta-lateral-tempestividade-importacao-tpl.html',
        url: '/porta-lateral-tempestividade-importacao'
    })
        .state('porta-lateral-tempestividade-controle-da-importacao', {
        controller: 'PortaLateralTempestividadeControleDaImportacaoController',
        controllerAs: 'pltControleDaImportacaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW7052',
            label: 'Controle importação de fator faixa tempestividade',
            titulo: 'Controle importação de fator faixa tempestividade'
        },
        parent: 'admin',
        templateUrl: 'views/porta-lateral-tempestividade/porta-lateral-tempestividade-controle-da-importacao-tpl.html',
        url: '/porta-lateral-tempestividade-controle-da-importacao'
    });
});
//# sourceMappingURL=porta-lateral-tempestividade-route-config.js.map;
(function() {
  'use strict';

  angular
    .module('crd')
    .config(routerConfiguration);

  routerConfiguration.$inject = ['$urlRouterProvider'];

  function routerConfiguration($urlRouterProvider) {
    $urlRouterProvider.when('', 'dashboard');
    $urlRouterProvider.when('/', 'dashboard');
    $urlRouterProvider.otherwise('/404');
  }
})();
;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('situacao-monitorada-pesquisa', {
        controller: 'SituacaoMonitoradaPesquisaController',
        controllerAs: 'smqPqrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4081',
            label: 'Pesquisa de situações monitoradas de qualidade',
            titulo: 'Pesquisa de situações monitoradas de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/situacao-monitorada/situacao-monitorada-pesquisa/situacao-monitorada-pesquisa-tpl.html',
        url: '/situacao-monitorada?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&instituicao&tipoResultado&sistemaNegocio&documento&segmento&database&possuiCriticaSim&possuiCriticaNao&campoMonitorado'
    })
        .state('situacao-monitorada-detalhar', {
        controller: 'SituacaoMonitoradaDetalheController',
        controllerAs: 'smqDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4082',
            label: 'Detalhar situações monitoradas de qualidade',
            titulo: 'Detalhar situações monitoradas de qualidade'
        },
        parent: 'admin',
        templateUrl: 'views/situacao-monitorada/situacao-monitorada-detalhe/situacao-monitorada-detalhe-tpl.html',
        url: '/situacao-monitorada/campo/:campoPk/critica/:criticaPk/detalhar?database&instituicao&documentoPk'
    });
});
//# sourceMappingURL=situacao-monitorada-route-config.js.map;
"use strict";
//# sourceMappingURL=state-provider-crd.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(statusRouteConfiguration);

  statusRouteConfiguration.$inject = ['$stateProvider'];

  function statusRouteConfiguration($stateProvider) {
    $stateProvider
      .state('status-404', {
        informacaoPagina: {
          codigo: 'CRDFW0000',
          label: 'erro',
          titulo: 'Erro'
        },
        parent: 'admin',
        templateUrl: 'views/template/status/404-tpl.html',
        url: '/404'
      })
      .state('status-500', {
        controller: 'Status500Controller',
        controllerAs: 'status500Ctrl',
        informacaoPagina: {
          codigo: 'CRDFW0000',
          label: 'erro',
          titulo: 'Erro'
        },
        parent: 'admin',
        templateUrl: 'views/template/status/500-tpl.html',
        url: '/500'
      });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .config(storageConfiguration);

  storageConfiguration.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

  function storageConfiguration($localStorageProvider, $sessionStorageProvider) {
    var prefix = 'crd-';
    $localStorageProvider.setKeyPrefix(prefix);
    $sessionStorageProvider.setKeyPrefix(prefix);
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .constant('constantes', {
      OPCOES_REFERENCIA_ANOTACAO: [{
        id: 'refTempestividade',
        nome: 'Tempestividade'
      }, {
        id: 'refQualidade',
        nome: 'Qualidade'
      }, {
        id: 'refOutros',
        nome: 'Outros'
      }],

      ROOT_URL: '/crd/rest'
    });
})(angular);
;
(function(angular, Role) {
  'use strict';

  angular
    .module('crd')
    .constant('roles', Role);
})(angular, CRDUtils.Role);
;

(function (angular) {
  'use strict';

  angular.module('crd').controller('CrdAnexoController', CrdAnexoController);
  CrdAnexoController.$inject = [
    'DTOptionsBuilder',
    'DTColumnDefBuilder',
    'feedbackService',
    '$window'
  ];

  function CrdAnexoController(DTOptionsBuilder, DTColumnDefBuilder, feedbackService, $window) {
    var vm = this;

    vm.anexo = vm.ngModel || null;
    vm.configuracaoFlow = configuracaoFlow;
    vm.onFileSelect = onFileSelect;
    vm.downloadAnexoLocal = downloadAnexoLocal;    // para arquivos recém-carregados (sem pk)

    vm.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(0).withOption('bSortable', false),
      DTColumnDefBuilder.newColumnDef(1).withOption('bSortable', false)
    ];
    vm.dtOptions = DTOptionsBuilder.newOptions().withDOM('<"dataTables_controls"tip>');

    // ---- utilitários ----
    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function formatDataDDMMAAAAHHMM(date) {
      var dd = pad2(date.getDate());
      var mm = pad2(date.getMonth() + 1);
      var yyyy = date.getFullYear();
      var HH = pad2(date.getHours());
      var MM = pad2(date.getMinutes());
      return dd + mm + yyyy + HH + MM;
    }

    function gerarNomeAnexoComCnpj(cnpj) {

      var cnpjDigits = somenteDigitos(cnpj);
      if (!cnpjDigits || cnpjDigits.length !== 8) {
        feedbackService.erro('CNPJ da ES inválido ou não disponível.');
        cnpjDigits = 'CNPJ_INDEFINIDO';
      }
      return 'Irregularidades_' + cnpjDigits + '_' + formatDataDDMMAAAAHHMM(new Date()) + '_S.pdf';
    }

    function somenteDigitos(str) {
      return (str || '').toString().replace(/\D+/g, '');
    }

    function onFileSelect($file) {

      var file = $file.file;
      if (file.type !== 'application/pdf') {
        feedbackService.erro('Só é permitido anexar arquivos em PDF!');
        return;
      }

      if (file.size > 41943040) { // Tamanho máximo de bytes do PDF - 40mb
        feedbackService.erro('Só é permitido anexar arquivos de até 40 MB de tamanho!');
        return;
      }

      var nomeFormatado = gerarNomeAnexoComCnpj(vm.cnpjEs);
      vm.anexo = {
        pk: null,
        nomeArquivo: nomeFormatado,
        type: file.type,
        size: file.size,
        file: file
      };
      fireAnexosAlterados();
    }

    function downloadAnexoLocal(anexo) {
      var blob = anexo.file;
      var url = $window.URL.createObjectURL(blob);
      try {
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = anexo.nomeArquivo; // garante extensão
        document.body.appendChild(a);
        a.click();
      } finally {
        $window.URL.revokeObjectURL(url);
      }
    }

    function fireAnexosAlterados() {
      if (typeof vm.onAnexosAlterados === 'function') {
        vm.onAnexosAlterados();
      }
    }

    function configuracaoFlow() {
      return {
        target: '',
        testChunks: false,
        singleFile: true
      };
    }
  }

})(angular);
;
(function (angular, s) {
  'use strict';

  angular
    .module('crd')
    .directive('crdAnexo', crdAnexoDirective);

  function crdAnexoDirective() {
    var directive = {
      controller: 'CrdAnexoController',
      controllerAs: 'crdAnexoCtrl',
      link: postLink,
      require: ['crdAnexo', 'ngModel'],
      restrict: 'E',
      scope: {
        cnpjEs: '<',
        cnpjES: '<',
        exibirSubstituir: '<',
        download: "&",
        onAnexosAlterados: "&"
      },
      templateUrl: 'scripts/crd/directives/anexo/crd-anexo-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {

      var crdAnexoCtrl = controllers[0];
      var ngModelCrtl = controllers[1];

      crdAnexoCtrl.onAnexosAlterados = $scope.onAnexosAlterados;
      crdAnexoCtrl.cnpjEs = $scope.cnpjEs || $scope.cnpjES;
      crdAnexoCtrl.exibirSubstituir = $scope.exibirSubstituir

      ngModelCrtl.$render = function () {
        crdAnexoCtrl.anexo = ngModelCrtl.$viewValue;
      };

      $scope.$watchCollection('crdAnexoCtrl.anexo', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          ngModelCrtl.$setViewValue(newValue);
        }
      });
    }
  }
})(angular, s);
;
(function (angular) {
  'use strict';

  angular.module('crd').controller('CrdAnexosController', CrdAnexosControllerController);
  CrdAnexosControllerController.$inject = ['DTOptionsBuilder', 'DTColumnDefBuilder', 'feedbackService'];

  function CrdAnexosControllerController(DTOptionsBuilder, DTColumnDefBuilder, feedbackService) {
    var vm = this;
    vm.anexos = [];
    vm.configuracaoFlow = configuracaoFlow;
    vm.onFileSelect = onFileSelect;
    vm.removeAnexo = removeAnexo;
    vm.downloadAnexo = downloadAnexo;
    vm.processarDownload = undefined;
    vm.permitirRemoverSalvos = undefined;
    vm.usuarioPerfilES = undefined;
    vm.onAnexosAlterados = undefined;
    vm.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(0).withOption('bSortable', false),
      DTColumnDefBuilder.newColumnDef(1).withOption('bSortable', false)
    ];
    vm.dtOptions = DTOptionsBuilder.newOptions().withDOM('<"dataTables_controls"tip>');

    function downloadAnexo(id) {
      if (vm.processarDownload !== undefined) {
        return vm.processarDownload({ id: id });
      } else {
        return null;
      }
    }

    function onFileSelect($file) {

      if (vm.usuarioPerfilEs && $file.file.type !== "application/pdf") {
        feedbackService.erro('Só é permitido anexar arquivos em PDF!');
        return;
      }

      vm.anexos.push($file.file);
      fireAnexosAlterados();
    }

    function fireAnexosAlterados() {
      if (vm.onAnexosAlterados) vm.onAnexosAlterados();
    }

    function configuracaoFlow() {
      return {
        target: '',
        testChunks: false
      };
    }

    function removeAnexo(anexo, files) {
      vm.anexoAltarado = true;
      var arqCancelar = null;
      _.each(files, function (file) {
        if (file.file === anexo) {
          arqCancelar = file;
        }
      });

      if (arqCancelar) {
        arqCancelar.cancel();
      }
      vm.anexos.splice(vm.anexos.indexOf(anexo), 1);
      fireAnexosAlterados();
    }

  }
})(angular);
;
(function (angular, s) {
  'use strict';

  angular
    .module('crd')
    .directive('crdAnexos', crdAnexosDirective);

  function crdAnexosDirective() {
    var directive = {
      controller: 'CrdAnexosController',
      controllerAs: 'crdAnexosCtrl',
      link: postLink,
      require: ['crdAnexos', 'ngModel'],
      restrict: 'E',
      scope: {
        download: "&",
        onAnexosAlterados: "&"
      },
      templateUrl: 'scripts/crd/directives/anexos/crd-anexos-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      var crdAnexosCtrl = controllers[0];
      var ngModelCrtl = controllers[1];

      crdAnexosCtrl.permitirRemoverSalvos = angular.isDefined($attributes.permitirRemoverSalvos) ? s.toBoolean($attributes.permitirRemoverSalvos) : true;
      crdAnexosCtrl.usuarioPerfilEs =  s.toBoolean($attributes.usuarioPerfilEs);
      crdAnexosCtrl.processarDownload = $scope.download;
      crdAnexosCtrl.onAnexosAlterados = $scope.onAnexosAlterados;

      ngModelCrtl.$render = function() {
        crdAnexosCtrl.anexos = ngModelCrtl.$viewValue;
      };

      $scope.$watchCollection('crdAnexosCtrl.anexos', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          ngModelCrtl.$setViewValue(newValue);
        }
      });
    }
  }
})(angular, s);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdAuditoriaData', crdAuditoriaDataDirective);

  function crdAuditoriaDataDirective() {
    var directive = {
      link: postLink,
      restrict: 'E',
      scope: {},
      templateUrl: 'scripts/crd/directives/auditoria-data/crd-auditoria-data-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $scope.$parent.$watch($attributes.data, function(newVal) {
        if (newVal) {
          $scope.dataHoraFormatada = moment(newVal).format('DD/MM/YYYY HH:mm:ss');
        }
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdAuditoriaDetalhar', crdAuditoriaDetalharDirective);

  function crdAuditoriaDetalharDirective() {
    var directive = {
      link: postLink,
      restrict: 'E',
      templateUrl: 'scripts/crd/directives/auditoria-detalhar/crd-auditoria-detalhar-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $scope.$watch($attributes.criador, function(newVal) {
        if (newVal) {
          $scope.criador = newVal;
        }
      });

      $scope.$watch($attributes.atualizador, function(newVal) {
        if (newVal) {
          $scope.atualizador = newVal;
        }
      });

      $scope.$watch($attributes.auditoria, function(newVal) {
        $scope.auditoria = newVal;
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('autoExpand', autoExpandDirective);

  function autoExpandDirective() {
    return {
      restrict: 'A',
      link: function(scope, element) {
        var textarea = element[0];

        function ajustarAltura() {
          textarea.style.height = 'auto';
          textarea.style.height = textarea.scrollHeight + 'px';
        }

        element.on('input', ajustarAltura);

        scope.$watch(function() {
          return textarea.value;
        }, ajustarAltura);
      }
    };
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdBooleanLabel', crdBooleanLabel);

  function crdBooleanLabel() {
    var directive = {
      link: postLink,
      restrict: 'E'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $scope.$watch($attributes.value, function(newValue) {
        $element.html(newValue ? 'Sim' : 'Não');
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdCalendarioController', CrdCalendarioControllerController);

  function CrdCalendarioControllerController() {
    var vm = this;

    vm.options = {};
    vm.limpar = limpar;
    vm.open = openPopup;
    vm.isModoMensal = isModoMensal;
    vm.popup = {
      isOpen: false,
      options: {
        showWeeks: false,
        startingDay: 0
      },
      showButtonBar: false
    };

    function limpar() {
      vm.value = null;
    }

    function isModoMensal() {
      return vm.options.format === 'MM/yyyy';
    }

    function openPopup($event, popup) {
      $event.preventDefault();
      $event.stopPropagation();
      if (isModoMensal()) {
        popup.options.minMode = 'month';
        popup.options.datepickerMode = 'month';
      } else {
        popup.options.minMode = 'day';
        popup.options.datepickerMode = undefined;
      }
      popup.isOpen = true;
    }
  }
})(angular);
;
(function (angular, s) {
  'use strict';

  angular
    .module('crd')
    .directive('crdCalendario', crdCalendarioDirective);

  function crdCalendarioDirective() {
    var directive = {
      controller: 'CrdCalendarioController',
      controllerAs: 'crdCalCtrl',
      link: postLink,
      require: ['crdCalendario', 'ngModel', '^form'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/directives/calendario/crd-calendario-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      var inputElement = $element.find('input');
      var crdCalCtrl = controllers[0];
      var ngModelCrtl = controllers[1];
      var formCrtl = controllers[2];

      inputElement.on('blur', marcarComoTocado);
      $scope.$on('$destroy', function() {
        inputElement.off('blur', marcarComoTocado);
      });

      function marcarComoTocado() {
        $scope.$evalAsync(function() {
          ngModelCrtl.$setTouched();
        });
      }

      crdCalCtrl.exibirBotaoLimpar = angular.isDefined($attributes.exibirBotaoLimpar) ? s.toBoolean($attributes.exibirBotaoLimpar) : true;

      $scope.$watch(function(){return formCrtl.resetDate}, function (newValue, oldValue) {
        if (newValue !== oldValue ) {
          crdCalCtrl.limpar();
        }
      });

      $scope.$watch($attributes.exibirBotaoSelecionar, function (newValue, oldValue) {
        crdCalCtrl.exibirBotaoSelecionar = angular.isDefined(newValue) ? s.toBoolean(newValue) : true;
      });

      $scope.$watch('crdCalCtrl.value', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          //alterado pois esta setando valor pra o componete não possiblitado limpar
          if (newValue && crdCalCtrl.isModoMensal()){ 
            ngModelCrtl.$setViewValue(new Date(newValue.getFullYear(), newValue.getMonth() + 1, 0));
          }else{
            ngModelCrtl.$setViewValue(newValue);
          }
        }
      });

      ngModelCrtl.$render = function() {
        if(ngModelCrtl.$modelValue && crdCalCtrl.isModoMensal()){
          // para modo mensal, o calendario retorna o 1 dia do mes, mas usa-se o ultimo.
          crdCalCtrl.value = new Date(ngModelCrtl.$modelValue.getFullYear(), ngModelCrtl.$modelValue.getMonth(), 1);
        }else {
          crdCalCtrl.value = ngModelCrtl.$modelValue;
        }
      };

      $scope.$watch($attributes.minDate, function (newValue) {
        if (newValue) {
          crdCalCtrl.options.minDate = newValue;
        }
      });

      $scope.$watch($attributes.maxDate, function (newValue) {
        if (newValue) {
          crdCalCtrl.options.maxDate = newValue;
        }
      });

      $scope.$watch($attributes.format, function(newValue) {
        crdCalCtrl.options.format = newValue || 'dd/MM/yyyy';
        ngModelCrtl.$render();
      });

      $scope.$watch($attributes.ngDisabled, function (newValue) {
        crdCalCtrl.options.ngDisabled = newValue;
      });

      $scope.$watch($attributes.mask, function (newValue) {
        crdCalCtrl.options.mask = newValue || '99/99/9999';
        inputElement.inputmask({
          mask: crdCalCtrl.options.mask
        });
      });

      $attributes.$observe('placeholder', function (newValue) {
        if (newValue) {
          crdCalCtrl.options.placeholder = newValue;
        }
      });
    }
  }
})(angular, s);
;
(function(angular) {
  'use strict';

  var TAMANHO_MAXIMO = 8;

  angular
    .module('crd')
    .controller('CrdConglomeradoSelecionarController', CrdConglomeradoSelecionarController);

  CrdConglomeradoSelecionarController.$inject = ['$q', '$scope', 'conglomeradoApiService'];

  function CrdConglomeradoSelecionarController($q, $scope, conglomeradoApiService) {
    var vm = this;
    vm.limpar = limpar;
    vm.remover = remover;
    vm.carregarConglomerado = carregarConglomerado;
    vm.pesquisarPeloValorDigitado = pesquisarPeloValorDigitado;
    vm.onSelect = onSelect;
    vm.onBlur = onBlur;

    function carregarConglomerado(conglomerado) {
      var deferred = $q.defer();
      if (conglomerado) {
        return conglomeradoApiService.recuperar(conglomerado.codigo)
          .then(successCarregar);
      }

      deferred.resolve(successCarregar(conglomerado));
      return deferred.promise;

      function successCarregar(resource) {
        setConglomerado(resource);
      }
    }

    function pesquisarPeloValorDigitado(valorDigitado) {
      var valor = valorDigitado.replace(/\./g, '').substring(0, TAMANHO_MAXIMO)
        .toUpperCase();

      return conglomeradoApiService
        .buscarPorParteCodigo(valor)
        .then(successAoPesquisarInstituicoes);

      function successAoPesquisarInstituicoes(resource) {
        return resource._embedded.resultado;
      }
    }

    function onBlur() {
      if (!vm.conglomerado){
        limpar();
      }
    }

    function limpar() {
      vm.conglomeradoLabel = null;
      vm.noResults = false;
      remover();
    }

    function remover() {
      vm.conglomerado = null;
      vm.aoRemover();
    }

    function setConglomerado(conglomerado) {
      vm.conglomerado = conglomerado;
      if (conglomerado && conglomerado.nome) {
        vm.conglomeradoLabel = conglomerado.codigo;
      } else {
        vm.conglomeradoLabel = null;
      }
    }

    function onSelect($item) {
      setConglomerado($item);
    }

    $scope.$watch(function(){
      return vm.conglomeradoLabel
    }, function(newValue) {
      if (newValue === '') {
        limpar();
      }
    });
  }
})(angular);
;
(function(angular, KeyCode) {
  'use strict';

  angular
    .module('crd')
    .directive('crdConglomeradoSelecionar', CrdConglomeradoSelecionarDirective);

  function CrdConglomeradoSelecionarDirective() {
    var directive = {
      controller: 'CrdConglomeradoSelecionarController',
      controllerAs: 'crdConglomeradoSelCtrl',
      link: postLink,
      require: ['crdConglomeradoSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/directives/conglomerado/crd-conglomerado-selecionar-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      var crdConglomeradoSelCtrl = controllers[0];
      var ngModelCtrl = controllers[1];

      ngModelCtrl.$render = ngModelCtrlRender;
      crdConglomeradoSelCtrl.aoRemover = aoRemover;

      adjustVerticalScroll();

      function adjustVerticalScroll() {
        var AJUSTE_SCROLL = 26;

        $element.bind('keydown', function(evt) {
          switch (evt.which) {
            case KeyCode.DOWN: {
              var $menu = $element.find('ul.dropdown-menu');
              var $itemActive = $menu.find('li.active');

              $menu[0].scrollTop = ($itemActive.index() + 1) * AJUSTE_SCROLL;
              break;
            }
            case KeyCode.BACKSPACE:
              break;
            case KeyCode.CLEAR: {
              crdConglomeradoSelCtrl.remover();
              break;
            }
            default:
              break;
          }
        });

        $element.bind('keyup', function(evt) {
          if (evt.which === KeyCode.UP) {
            var $menu = $element.find('ul.dropdown-menu');
            var $itemActive = $menu.find('li.active');

            $menu[0].scrollTop = $itemActive.index() * AJUSTE_SCROLL;
          }
        });
      }

      function aoRemover() {
        if ($attributes.aoRemover) {
          $attributes.aoRemover();
        }
      }

      function ngModelCtrlRender() {
        return crdConglomeradoSelCtrl.carregarConglomerado(ngModelCtrl.$viewValue)
          .then(function() {
              if ( ngModelCtrl.$viewValue ){
                angular.extend(ngModelCtrl.$viewValue, crdConglomeradoSelCtrl.conglomerado);
              }
          });
      }

      $scope.$watch('crdConglomeradoSelCtrl.conglomerado.codigo', function(newValue) {
        if (_.propertyOf(ngModelCtrl.$viewValue)('codigo') !== newValue) {
          ngModelCtrl.$setViewValue(crdConglomeradoSelCtrl.conglomerado);
        }
      });
    }
  }
})(angular, KeyCode);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('crdDataBaseInformativoController', CrdDataBaseInformativoController);

  CrdDataBaseInformativoController.$inject = ['periodicidadeService'];

  function CrdDataBaseInformativoController(periodicidadeService) {
    var vm = this;
    vm.carregar = carregar;
    vm.mensagem = '';

    function carregar(documento) {
      var options = periodicidadeService.formatoData(documento);
      vm.mensagem = options.message;
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdDataBaseInformativo', crdDataBaseInformativoDirective);

  function crdDataBaseInformativoDirective() {
    var directive = {
      controller: 'crdDataBaseInformativoController',
      controllerAs: 'crddbInfoCrtl',
      link: postLink,
      require: 'crdDataBaseInformativo',
      restrict: 'E',
      templateUrl: 'scripts/crd/directives/data-base-informativo/crd-data-base-informativo-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      validateAttributes($attributes);

      $scope.$watch($attributes.documento, function(newValue) {
        controller.carregar(newValue);
      });
    }

    function validateAttributes(attributes) {
      if (!attributes.documento) {
        throw Error('O atributo "documento" deve ser informado.');
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdDataBaseLabelController', CrdDataBaseLabelController);

  CrdDataBaseLabelController.$inject = ['periodicidadeService'];

  function CrdDataBaseLabelController(periodicidadeService) {
    var vm = this;
    vm.configurarFormatoDataBase = configurarFormatoDataBase;

    function configurarFormatoDataBase(documento) {
      vm.formato = 'dd/MM/yyyy';
      if (documento) {
        vm.formato = periodicidadeService.formatoData(documento).format;
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdDataBaseLabel', crdDataBaseLabelDirective);

  function crdDataBaseLabelDirective() {
    var directive = {
      controller: 'CrdDataBaseLabelController',
      controllerAs: 'crdDBLabelCtrl',
      link: postLink,
      require: 'crdDataBaseLabel',
      restrict: 'E',
      scope: {},
      templateUrl: 'scripts/crd/directives/data-base-label/crd-data-base-label-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, $controller) {
      $controller.data = $attributes.data;
      $scope.$parent.$watch($attributes.data, function(newVal) {
        if (newVal) {
          $controller.dataBase = newVal;
        }
      });

      $scope.$parent.$watch($attributes.documento, function(newValue) {
        $controller.configurarFormatoDataBase(newValue);
      });
    }
  }
})(angular);
;
(function(angular, moment) {
  'use strict';

  var FORMATO_YYYYMMDD = 'YYYY-MM-DD';
  var optionsDatepicker = {
    allowInvalid: true
  };

  angular
    .module('crd')
    .directive('crdDataBase', crdDataBaseDirective);

  crdDataBaseDirective.$inject = ['extrairDocumentoMenorPeriodicidadeService', 'periodicidadeService'];

  function crdDataBaseDirective(extrairDocumentoMenorPeriodicidadeService, periodicidadeService) {
    var directive = {
      link: postLink,
      require: ['ngModel', '^form'],
      restrict: 'E',
      scope: {
        documento: '=',
        minDate: '=',
        disabled: '=ngDisabled'
      },
      templateUrl: 'scripts/crd/directives/data-base/crd-data-base-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      validarAttributes($attributes);
      var ngModelCrtl = controllers[0];
      var formCrtl = controllers[1];

      var self = $scope;
      var configuracoesPopup = {
        isOpen: false,
        options: {
          showWeeks: false,
          startingDay: 0
        },
        showButtonBar: false
      };

      self.popup = configuracoesPopup;
      self.optionsDatepicker = optionsDatepicker;
      self.openPopup = openPopup;
      self.limpar = limpar;

      $scope.$watch(function(){return formCrtl.resetDate}, function (newValue, oldValue) {
        if (newValue !== oldValue ) {
          limpar();
        }
      });

      self.$watch('value', function watchValue(newValue, oldValue) {
        if (newValue !== oldValue) {
          var valorNormalizado = normalizarValue(newValue, self.options);
          ngModelCrtl.$setViewValue(valorNormalizado);
        }
      });

      self.$watchCollection('documento', function watchDocumento(newValue) {
        alterarOpcoesConformeDocumento(newValue);
      });

      ngModelCrtl.$render = function() {
        self.value = ngModelCrtl.$modelValue;
      };

      function limpar() {
        self.value = null;
      }

      function alterarOpcoesConformeDocumento(documento) {
        extrairDocumentoMenorPeriodicidadeService(documento)
          .then(function(documentoMenorPeriodicidade) {
            self.options = periodicidadeService.formatoData(documentoMenorPeriodicidade);
            if (existeVigencia(documentoMenorPeriodicidade)) {
              var vigencia = documentoMenorPeriodicidade.vigencia;
              self.options.minDate = tratarDataMinima(self.minDate, vigencia);
              self.options.maxDate = tratarDataMaxima(vigencia);
            }
            self.value = normalizarValue(self.value, self.options);
            aplicarMascara($element, self.options.mask);
            return;
          });
      }

      function openPopup($event, popup) {
        $event.preventDefault();
        $event.stopPropagation();

        if (self.options && isModoMensal(self.options.format)) {
          popup.options.minMode = 'month';
          popup.options.datepickerMode = 'month';
        } else {
          popup.options.minMode = 'day';
          popup.options.datepickerMode = undefined;
        }

        popup.isOpen = true;
      }
    }
  }

  function isModoMensal(format) {
    return format === 'MM/yyyy';
  }

  function tratarDataMaxima(vigencia) {
    return vigencia.fim ? moment(vigencia.fim).toDate() : null;
  }

  function tratarDataMinima(minDate, vigencia) {
    var dataMinima;
    if (minDate) {
      var minDateScope = moment(minDate);
      var vigeniaInicial = moment(vigencia.inicio);
      dataMinima = vigeniaInicial.diff(minDateScope, 'days') > 0 ? vigeniaInicial.toDate() : minDateScope.toDate();
    } else {
      dataMinima = vigencia.inicio;
    }
    return moment(dataMinima).toDate();
  }

  function existeVigencia(documentoMenorPeriodicidade) {
    return documentoMenorPeriodicidade && documentoMenorPeriodicidade.vigencia;
  }

  function normalizarValue(valor, options) {
    var valorNormalizado = valor;
    if (valor && options) {
      if (options.isMonthly()){
        if (!verificaSeEData(valor) && (valor + "").length === 7) {
          // Corrige uma situa��o em que um valor de periodicidade mensal n�o � submetido corretamente como data (ex.: 04/2019).
          // Para reproduzir: digite 05/2019, selecione com o mouse o 5 e altere para 4
          var valorSplit = valor.split("/");
          if (valorSplit.length === 2) {
            valor = moment(valorSplit[0] + "/01/" + valorSplit[1]).toDate();
            valorNormalizado = valor
          }
        }
        if(verificaSeEData(valor) && !verificarSeValorEstaNormalizado(valor)) {
          valorNormalizado = ultimoDiaDoMes(valorNormalizado).toDate();
        }
      }
    }
    return valorNormalizado;
  }

  function ultimoDiaDoMes(data) {
    return moment.utc(data).endOf('month');
  }

  function verificarSeValorEstaNormalizado(valor) {
    var valorNormalizadoFormatado = moment(ultimoDiaDoMes(valor).format(FORMATO_YYYYMMDD));
    var valorFormatado = moment(valor).format(FORMATO_YYYYMMDD);
    return valorNormalizadoFormatado.isSame(valorFormatado);
  }



  function verificaSeEData(data) {
    return angular.isDate(data) && !isNaN(data.getTime());
  }

  function validarAttributes($attributes) {
    if (!$attributes.documento) {
      throw Error('O atributo "documento" deve ser informado.');
    }
  }

  function aplicarMascara($element, mascara) {
    $element.find('input').inputmask({
      mask: mascara
    });
  }
})(angular, moment);
;
(function(angular, _) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdDocumentoSelecionarController', CrdDocumentoSelecionarController);

  CrdDocumentoSelecionarController.$inject = ['documentoApiService'];

  function CrdDocumentoSelecionarController(documentoApiService) {
    var vm = this;

    inicializarDocumentos();
    vm.carregarDocumentosPorSistemaNegocio = carregarDocumentosPorSistemaNegocio;

    function carregarDocumentosPorSistemaNegocio(sistemaNegocio, somenteAtivos, tipoDispensa) {
      if (angular.isObject(sistemaNegocio) && sistemaNegocio.pk) {
        vm.loading = true;

        if (!_.isEmpty(tipoDispensa)) {
          return buscarDocumentoAtivosDispensaveisPorSistemaNegocio(sistemaNegocio, tipoDispensa);
        }

        if (somenteAtivos) {
          return buscarDocumentoAtivoPorSistemaNegocio(sistemaNegocio);
        }
        return buscarTodosDocumentosPorSistemaNegocio(sistemaNegocio);
      } else if (angular.isArray(sistemaNegocio) && sistemaNegocio.length > 0) {
        vm.loading = true;
        var snPks = _.map(sistemaNegocio, function(value) {
          return value.pk;
        });

        return documentoApiService
          .buscarPorSistemasNegocio(snPks)
          .then(successBuscarPorSistemaNegocio);
      } else {
        return inicializarDocumentos();
      }
    }

    function buscarTodosDocumentosPorSistemaNegocio(sistemaNegocio) {
      return documentoApiService.buscarPorSistemaNegocio(sistemaNegocio.pk)
        .then(successBuscarPorSistemaNegocio);
    }

    function buscarDocumentoAtivoPorSistemaNegocio(sistemaNegocio) {
      return documentoApiService.buscarAtivosPorSistemaNegocio(sistemaNegocio.pk)
        .then(successBuscarPorSistemaNegocio);
    }

    function buscarDocumentoAtivosDispensaveisPorSistemaNegocio(sistemaNegocio, tipoDispensa) {
      var tds = ConverterParameterObjectToUrlUtils.atributoEnumNameArray(tipoDispensa);
      return documentoApiService.buscarAtivosDispensaveisPorSistemaNegocio(sistemaNegocio.pk, tds)
      .then(function(resource) {
        vm.loading = false;
        vm.documentos = resource._embedded.resultado;
        vm.noResults = vm.documentos.length === 0;
      });
    }

    function successBuscarPorSistemaNegocio(resource) {
      vm.loading = false;
      vm.documentos = resource;
      vm.noResults = vm.documentos.length === 0;
    }

    function inicializarDocumentos() {
      vm.documentos = [];
      vm.selecionado = null;
    }
  }
})(angular, _);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdDocumentoSelecionar', crdDocumentoSelecionarDirective);

  crdDocumentoSelecionarDirective.$inject = [];

  function crdDocumentoSelecionarDirective() {
    var directive = {
      controller: 'CrdDocumentoSelecionarController',
      controllerAs: 'crdDocumentoSelecionarCtrl',
      link: postLink,
      require: ['ngModel', 'crdDocumentoSelecionar'],
      restrict: 'E',
      templateUrl: templateUrl
    };
    return directive;

    function templateUrl(element, attributes) {
      if (attributes.multiplos) {
        return 'scripts/crd/directives/documento/crd-documento-selecionar-multiplos-tpl.html';
      }
      return 'scripts/crd/directives/documento/crd-documento-selecionar-tpl.html';
    }

    function postLink(scope, element, attributes, controllers) {
      validateAttributes(attributes);

      var controller = controllers[1];
      var ngModelController = controllers[0];

      scope.$watch(attributes.sistemaNegocio, function(newValue) {
        var documentosAtivos = false;

        if (angular.isUndefined(attributes.ativo)) {
          documentosAtivos = true;
        }

        controller.carregarDocumentosPorSistemaNegocio(newValue, documentosAtivos, controller.tiposDispensa);
      });

      scope.$watch(attributes.ngModel, function(newValue) {
        scope.selecionado = newValue;
      });

      scope.$watch(attributes.tiposDispensa, function(newValue) {
        controller.tiposDispensa = newValue;
      });

      scope.$watch(attributes.itens, function(newValue) {
        if (newValue) {
          scope.itens = newValue;
        }
      });

      scope.$watch('selecionado', function(newValue) {
        var valor = newValue;
        if (angular.isArray(valor) && valor.length === 0) {
          valor = null;
        }
        ngModelController.$setViewValue(valor);
      });
    }

    function validateAttributes(attributes) {
      if (!attributes.sistemaNegocio) {
        throw Error('O atributo "sistema-negocio" deve ser informado, para a diretiva crd-documento-selecionar.');
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdEnumLabel', crdEnumLabelDirective);

  function crdEnumLabelDirective() {
    var directive = {
      link: postLink,
      restrict: 'E',
      templateUrl: 'scripts/crd/directives/enum-label/crd-enum-label-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $scope.$watch($attributes.codigo, function atualizarSelecionado(newValue) {
        var itens = $scope.$eval($attributes.itens);
        $scope.crdEnum = _.find(itens, function(item) {
          return item.codigo === newValue;
        });
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdInstituicaoController', CrdInstituicaoController);

  CrdInstituicaoController.$inject = ['instituicaoApiService'];

  function CrdInstituicaoController(instituicaoApiService) {
    var vm = this;

    vm.carregarInstituicao = carregarInstituicao;
    vm.setMarcacao = setMarcacao;

    function setMarcacao(marcacao) {
      vm.marcacaoLabel = marcacao ? '* ' : '';
    }

    function setInstituicao(instituicao) {
      vm.instituicao = instituicao;
      if (angular.isDefined(instituicao.nome)) {
        vm.instituicaoLabel = instituicao.label;
      }
    }

    function carregarInstituicao(idBacen) {
      if (angular.isDefined(idBacen)) {
        instituicaoApiService
          .carregar(idBacen)
          .then(function successCarregar(resource) {
            return setInstituicao(resource);
          });
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdInstituicao', function crdInstituicaoDirective() {
      var directive = {
        controller: 'CrdInstituicaoController',
        controllerAs: 'crdInstituicaoCtrl',
        link: postLink,
        require: 'crdInstituicao',
        restrict: 'A',
        scope: true,
        templateUrl: 'scripts/crd/directives/instituicao/crd-instituicao-tpl.html'
      };

      return directive;

      function postLink($scope, $element, $attributes, controller) {
        $scope.$watch($attributes.idbacen, function(newValue) {
          controller.carregarInstituicao(newValue);
        });

        $scope.$watch($attributes.marcacao, function(newValue) {
          controller.setMarcacao(newValue);
        });
      }
    });
})(angular);
;
(function(angular, _) {
  'use strict';

  var KEY_CODE_ENTER = 13;
  var CODIGO_SEGMENTO_FUNDOS_INVESTIMENTO = '024';
  var QUANTIDADE_MINIMA_ITENS_POR_PAGINA = 5;

  angular
    .module('crd')
    .controller('CrdInstituicaoSelecionarController', CrdInstituicaoSelecionarController);

  CrdInstituicaoSelecionarController.$inject = ['$q', '$scope', '$transclude', 'instituicaoApiService', 'instituicaoModalSelecionar', 'feedbackService'];

  function CrdInstituicaoSelecionarController($q, $scope, $transclude, instituicaoApiService, instituicaoModalSelecionar, feedbackService) {
    var vm = this;
    vm.limpar = limpar;
    vm.remover = remover;
    vm.carregarInstituicao = carregarInstituicao;
    vm.pesquisarPeloValorDigitado = pesquisarPeloValorDigitado;
    vm.abrirModalPesquisa = abrirModalPesquisa;
    vm.onSelect = onSelect;
    vm.onBlur = onBlur;
    vm.keyup = keyup;
    vm.ignorarCodigosSegmento = [CODIGO_SEGMENTO_FUNDOS_INVESTIMENTO];  // este atributo será ignorado por padrão
    vm.buscarTodosSegmentos = false;
    vm.quantidadeItensPorPagina = QUANTIDADE_MINIMA_ITENS_POR_PAGINA;
    vm.possuiNoResultContainer = $transclude.isSlotFilled('noResultContainer');

    function carregarInstituicao(instituicao) {
      var deferred = $q.defer();

      limpar();
      if (_.isObject(instituicao) && !_.isUndefined(instituicao.idBacen) && !_.isEmpty(instituicao.idBacen) && _.isEmpty(instituicao.nome)) {
        return instituicaoApiService
          .carregar(instituicao.idBacen)
          .then(successCarregar)
          .catch(erroCarregarInstituicao);
      }

      deferred.resolve(successCarregar(instituicao));
      return deferred.promise;

      function successCarregar(resource) {
        return setInstituicao(resource);
      }

      function erroCarregarInstituicao(response) {
        limpar();
        var mensagem = response && response.data && response.data.mensagem
          ? response.data.mensagem
          : 'Essa entidade supervisionada não está cadastrada no CRD.';
        feedbackService.erro(mensagem);
      }
    }

    function pesquisarPeloValorDigitado(valorDigitado) {
      var arraySegmentosExcluidos;

      if(vm.buscarTodosSegmentos) {
        arraySegmentosExcluidos = [];
      } else {
        arraySegmentosExcluidos = vm.ignorarCodigosSegmento;
      }

      var filtro = {
        texto: valorDigitado,
        segmentosExcluidos: arraySegmentosExcluidos,
        quantidadePorPagina: vm.quantidadeItensPorPagina
      }
      return instituicaoApiService.pesquisar(filtro).then(function(resource) {
        return resource._embedded.content;
      });
    }

    function abrirModalPesquisa() {
      var modalInstance = instituicaoModalSelecionar.open();
      return modalInstance
        .result
        .then(function successOnSelect(instituicaoSelecionada) {
          return setInstituicao(instituicaoSelecionada);
        });
    }

    function limpar() {
      vm.instituicaoLabel = null;
      vm.noResults = false;
      remover();
    }

    function remover() {
      vm.instituicao = null;
      vm.aoRemover();
    }

    function onBlur() {
      if (!vm.instituicao){
        limpar();
      }
    }

    function keyup($event) {
      if (event.keyCode !== KEY_CODE_ENTER){
        remover();
      }
    }

    function setInstituicao(instituicao) {
      vm.instituicao = instituicao;
      if (instituicao && instituicao.nome) {
        vm.instituicaoLabel = instituicao.label;
      }
    }

    function onSelect($item) {
      setInstituicao($item);
    }

    $scope.$watch(function() {
      return vm.instituicaoLabel;
    }, function(newValue) {
      if (newValue === '') {
        limpar();
      }
    });
  }
})(angular, _);
;
(function(angular, _, $, KeyCode) {
  'use strict';

  angular
    .module('crd')
    .directive('crdInstituicaoSelecionar', crdInstituicaoSelecionarDirective);

  function crdInstituicaoSelecionarDirective() {
    var directive = {
      controller: 'CrdInstituicaoSelecionarController',
      controllerAs: 'crdInsSelCrtl',
      link: postLink,
      require: ['crdInstituicaoSelecionar', 'ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/directives/instituicao/crd-instituicao-selecionar-tpl.html',
      transclude: {
        noResultContainer: '?noResultContainer',
      }
    };

    return directive;

    function postLink($scope, $element, $attributes, controllers) {
      var crdInsSelCrtl = controllers[0];
      var ngModelCtrl = controllers[1];

      ngModelCtrl.$render = ngModelCtrlRender;
      crdInsSelCrtl.aoRemover = aoRemover;

      $attributes.$observe("disabled", function(newVal){
        $scope.disabled = newVal === "true";
      });

      preencherAtributos();

      adjustVerticalScroll();

      function adjustVerticalScroll() {
        var AJUSTE_SCROLL = 26;

        $element.bind('keydown', function(evt) {
          switch (evt.which) {
            case KeyCode.DOWN: {
              var $menu = $element.find('ul.dropdown-menu');
              var $itemActive = $menu.find('li.active');

              $menu[0].scrollTop = ($itemActive.index() + 1) * AJUSTE_SCROLL;
              break;
            }
            case KeyCode.BACKSPACE:
              break;
            case KeyCode.CLEAR: {
              crdInsSelCrtl.remover();
              break;
            }
            default:
              break;
          }
        });
        $element.bind('keyup', function(evt) {
          if (evt.which === KeyCode.UP) {
            var $menu = $element.find('ul.dropdown-menu');
            var $itemActive = $menu.find('li.active');

            $menu[0].scrollTop = $itemActive.index() * AJUSTE_SCROLL;
          }
        });
      }

      function aoRemover() {
        if ($attributes.aoRemover) {
          $attributes.aoRemover();
        }
      }

      function ngModelCtrlRender() {
        return crdInsSelCrtl.carregarInstituicao(ngModelCtrl.$viewValue)
          .then(function() {
             if ( ngModelCtrl.$viewValue ){
                angular.extend(ngModelCtrl.$viewValue, crdInsSelCrtl.instituicao);
             }
          });
      }

      $scope.$watch('crdInsSelCrtl.instituicao.idBacen', function(newValue) {
        if (_.propertyOf(ngModelCtrl.$viewValue)('idBacen') !== newValue) {
          ngModelCtrl.$setViewValue(crdInsSelCrtl.instituicao);
        }
      });

      function preencherAtributos() {
        if(!!$attributes.buscarTodosSegmentos) {
          crdInsSelCrtl.buscarTodosSegmentos = $attributes.buscarTodosSegmentos
        }

        if(!!$attributes.ignorarCodigosSegmento) {
          var codigosSegmento = [];
          $attributes.ignorarCodigosSegmento.split(',').forEach(function(codigo) {
            codigosSegmento.push(codigo.trim());
          });
          crdInsSelCrtl.ignorarCodigosSegmento = codigosSegmento;
        }

        if(!!$attributes.quantidadeItensPorPagina) {
          crdInsSelCrtl.quantidadeItensPorPagina = $attributes.quantidadeItensPorPagina
        }
      }
    }
  }
})(angular, _, jQuery, KeyCode);
;
(function(angular, HttpStatus) {
  'use strict';

  var POSICAO_COLUNA_ACOES = 2;
  var QUANTIDADE_MAXIMA_INTEGER = 2147483647;

  angular
    .module('crd')
    .controller('InstituicaoModalSelecionarController', InstituicaoModalSelecionarController);

  InstituicaoModalSelecionarController.$inject = ['$uibModalInstance', 'constantes', 'DTColumnDefBuilder',
    'DTOptionsBuilder', 'instituicaoApiService', 'feedbackService'];

  function InstituicaoModalSelecionarController($uibModalInstance, constantes, DTColumnDefBuilder,
      DTOptionsBuilder, instituicaoApiService, feedbackService) {
    var vm = this;

    // Declarando as funções
    vm.pesquisar = pesquisar;
    vm.selecionar = selecionar;
    vm.cancel = cancelar;
    vm.fecharInclusao = fecharInclusao;
    vm.salvarNova = salvarNova;
    vm.idBacenInvalido = idBacenInvalido;

    // Declarando as variáveis
    vm.nome = "";
    vm.isIncluirAtivo = false;
    vm.novaInstituicao = "";
    vm.definicoesMascara = {
      maskDefinitions: {
        'A': /[zZ]/
      }
    }

    activate();

    function activate() {
      configurarDataTable();
      pesquisar();
    }

    function configurarDataTable() {
      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('order', [0, 'asc'])
        .withDOM('<"dataTables_controls"tip>');

      vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(POSICAO_COLUNA_ACOES).notSortable()
      ];
    }

    function pesquisar(nome) {
      vm.instituicoes = {};
      feedbackService.limpar();
      var filtro = {
        texto: nome,
        quantidadePorPagina: QUANTIDADE_MAXIMA_INTEGER
      }
      if (nome) {
        instituicaoApiService
          .pesquisar(filtro)
          .then(function (resource) {
            if(resource._embedded.contentSize == 0) {
              vm.isIncluirAtivo = true;
            } else {
              vm.instituicoes = resource._embedded.content;
              fecharInclusao();
            }
          });
      }
    }

    function selecionar(instituicao) {
      $uibModalInstance.close(instituicao);
      vm.isIncluirAtivo = false;
      feedbackService.limpar();
    }

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
      fecharInclusao();
      feedbackService.limpar();
    }

    function fecharInclusao(deveLimparFeedback) {
      vm.isIncluirAtivo = false;
      vm.novaInstituicao = "";
      if (deveLimparFeedback) {
        feedbackService.limpar();
      }
    }

    function salvarNova() {
      instituicaoApiService.incluir(vm.novaInstituicao)
        .then(function(response) {
          if(response.status === HttpStatus.CREATED) {
            feedbackService.sucesso('Entidade supervisionada incluída com sucesso!');
            fecharInclusao();
          }
        });
    }

    function idBacenInvalido() {
      var regex = /([zZ]\d{7})/g;

      return !regex.test(vm.novaInstituicao)
    }
  }
})(angular, httpStatusCode);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .factory('instituicaoModalSelecionar', instituicaoModalSelecionar);

  instituicaoModalSelecionar.$inject = ['$uibModal'];

  function instituicaoModalSelecionar($uibModal) {
    var service = {
      open: open
    };

    return service;

    function open() {
      return $uibModal.open({
        animation: true,
        backdrop: 'static',
        controller: 'InstituicaoModalSelecionarController',
        controllerAs: 'instituicaoModalSelecionarCtrl',
        size: 'lg',
        templateUrl: 'scripts/crd/directives/instituicao/instituicao-modal-selecionar-tpl.html'
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdPeriodoController', CrdPeriodoController);

  function CrdPeriodoController() {
    var vm = this;
    vm.setPeriodo = setPeriodo;
    vm.formato = 'dd/MM/yyyy';

    function setPeriodo(value) {
      vm.periodo = value;
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdPeriodo', crdPeriodo);

  function crdPeriodo() {
    var directive = {
      controller: 'CrdPeriodoController',
      controllerAs: 'crdPeriodoCtrl',
      link: postLink,
      require: 'crdPeriodo',
      restrict: 'E',
      templateUrl: 'scripts/crd/directives/periodo/crd-periodo-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      $scope.$watch($attributes.periodo, function(newValue) {
        controller.setPeriodo(newValue);
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';
  angular
    .module('crd')
    .directive('crdRestrictTo', crdRestrictTo);

  crdRestrictTo.$inject = [];

  function crdRestrictTo() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var re = RegExp($attributes.crdRestrictTo);
      var exclude = /Backspace|Enter|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|ArrowLeft|Left|ArrowRight|Right/;

      $element[0].addEventListener('keydown', function(event) {
        if (!exclude.test(event.key) && !re.test(event.key)) {
          event.preventDefault();
        }
      });
    }
  }
})(angular);
;
(function(angular, _) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdSegmentoController', CrdSegmentoController);

  CrdSegmentoController.$inject = ['instituicaoApiService', 'segmentoApiService'];

  function CrdSegmentoController(instituicaoApiService, segmentoApiService) {
    var vm = this;
    vm.carregarSegmentoDaInstituicao = carregarSegmentoDaInstituicao;
    vm.carregarSegmentoPorCodigo = carregarSegmentoPorCodigo;

    function carregarSegmentoDaInstituicao(idBacen) {
      if (!_.isUndefined(idBacen) && !_.isEmpty(idBacen)) {
        instituicaoApiService
          .carregar(idBacen)
          .then(successCarregar);
      }

      function successCarregar(resource) {
        carregarSegmentoPorCodigo(resource.segmento);
      }
    }

    function carregarSegmentoPorCodigo(codigo) {
      if (!_.isUndefined(codigo) && !_.isEmpty(codigo)) {
        segmentoApiService
          .buscarPorCodigo(codigo)
          .then(successOnCarregar);
      }

      function successOnCarregar(resource) {
        vm.segmento = resource;
      }
    }
  }
})(angular, _);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdSegmento', crdSegmentoDirective);

  function crdSegmentoDirective() {
    var directive = {
      controller: 'CrdSegmentoController',
      controllerAs: 'crdSegCtrl',
      link: postLink,
      require: 'crdSegmento',
      restrict: 'E',
      templateUrl: 'scripts/crd/directives/segmento/crd-segmento-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      $scope.$watch($attributes.idbacen, function(newValue) {
        controller.carregarSegmentoDaInstituicao(newValue);
      });

      $scope.$watch($attributes.codigo, function(newValue) {
        controller.carregarSegmentoPorCodigo(newValue);
      });
    }
  }
})(angular);
;
(function(angular, _) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdEmailServidorMultiselectController', CrdEmailServidorMultiselectController);

    CrdEmailServidorMultiselectController.$inject = ['$q', '$scope', 'emailServidorApiService'];

  function CrdEmailServidorMultiselectController($q, $scope, emailServidorApiService) {
    var vm = this;
    vm.limpar = null;

    $scope.obterSugestoesDeEmailBcb = function (textoParaBusca) {
     return emailServidorApiService.buscarOpcoesParaSelecaoDoEmailDoServidor(textoParaBusca)
      .then(function (emailsSugeridos) {
          return emailsSugeridos
      });
    };

    /*$scope.validarDominio = function (emailsDigitados) {
      var DOMINIO = "@bcb.gov.br";

      return !!(emailsDigitados && emailsDigitados.length &&
        emailsDigitados.some(function (email) {
          return typeof email === "string" && email.indexOf("@") >= 0 &&
            email.substring(email.indexOf("@")).toLowerCase() === DOMINIO;
        }));
    }*/

    $scope.validarDominio = function (emailsDigitados) {
      var DOMINIO = "@bcb.gov.br";
      if (emailsDigitados && emailsDigitados.length) {
        for (var i in emailsDigitados) {
          if (emailsDigitados && emailsDigitados[i] && emailsDigitados[i].indexOf && emailsDigitados[i].indexOf("@") >= 0) {
            if (emailsDigitados[i].substring(emailsDigitados[i].indexOf("@"), emailsDigitados[i].length).toLowerCase() !== DOMINIO) {
              return false;
            }
          }
        }
      }
      return true;
    }

  }
})(angular, _);
;
(function(angular, _, $, KeyCode) {
  'use strict';

  angular
    .module('crd')
    .directive('crdEmailServidorMultiselect', crdEmailServidorMultiselectDirective);

  function crdEmailServidorMultiselectDirective() {
    var directive = {
      controller: 'CrdEmailServidorMultiselectController',
      controllerAs: 'crdEmailServidorMultiselectController',
      link: postLink,
      require: ['^?crdEmailServidorMultiselectController', '^?ngModel'],
      restrict: 'E',
      scope: true,
      templateUrl: 'scripts/crd/directives/selecao-email/crd-email-servidor-multiselect-tpl.html',
      transclude: {
        noResultContainer: '?noResultContainer',
      }
    };

    return directive;

    function postLink() {}

  }
})(angular, _, jQuery, KeyCode);
;
"use strict";
var CrdSelecaoUnicaController = (function () {
    function CrdSelecaoUnicaController() {
    }
    CrdSelecaoUnicaController.prototype.$onInit = function () { };
    CrdSelecaoUnicaController.prototype.desmarcarOutros = function (item) {
        _.forEach(this.itens, function (element) {
            if (element.enumName !== item.enumName) {
                element.checked = false;
            }
        });
        this.checked = _.find(this.itens, function (element) { return element.checked; });
    };
    CrdSelecaoUnicaController.prototype.marcarSelecionado = function (itens) {
        var _this = this;
        _.forEach(itens, function (element) {
            element.checked = _this.checked && _this.checked.enumName === element.enumName;
        });
    };
    return CrdSelecaoUnicaController;
}());
CrdSelecaoUnicaController.$inject = [];
angular.module('crd').controller('CrdSelecaoUnicaController', CrdSelecaoUnicaController);
//# sourceMappingURL=crd-selecao-unica-controller.js.map;
"use strict";
var CrdSelecaoUnicaDirective = (function () {
    function CrdSelecaoUnicaDirective() {
        this.controller = 'CrdSelecaoUnicaController';
        this.controllerAs = 'crdSelecaoUnicaCtlr';
        this.name = 'crdSelecaoUnica';
        this.priority = 0;
        this.require = ['crdSelecaoUnica', 'ngModel'];
        this.restrict = 'E';
        this.scope = true;
        this.templateUrl = 'scripts/crd/directives/selecao-unica/crd-selecao-unica-tpl.html';
    }
    CrdSelecaoUnicaDirective.prototype.link = function (scope, element, attributes, controller, transclude) {
        var crdSelecaoUnicaCtlr = controller[0];
        var ngModelCtrl = controller[1];
        ngModelCtrl.$render = function () {
            crdSelecaoUnicaCtlr.checked = ngModelCtrl.$viewValue;
            scope.$watch('crdSelecaoUnicaCtlr.checked', function (newValue) {
                ngModelCtrl.$setViewValue(newValue);
            });
            scope.$watch(attributes.itens, function (newValue) {
                crdSelecaoUnicaCtlr.itens = newValue;
                crdSelecaoUnicaCtlr.marcarSelecionado(crdSelecaoUnicaCtlr.itens);
            });
            scope.$watch(attributes.name, function (newValue) {
                crdSelecaoUnicaCtlr.name = newValue || new Date().getTime().toString();
            });
            scope.$watch(attributes.ngDisabled, function (newValue) {
                crdSelecaoUnicaCtlr.ngDisabled = newValue;
            });
        };
    };
    CrdSelecaoUnicaDirective.instance = function () {
        return new CrdSelecaoUnicaDirective();
    };
    return CrdSelecaoUnicaDirective;
}());
CrdSelecaoUnicaDirective.$inject = [];
angular.module('crd').directive('crdSelecaoUnica', CrdSelecaoUnicaDirective.instance);
//# sourceMappingURL=crd-selecao-unica-directive.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdUsuarioAplicacao', CrdUsuarioAplicacaoDirective);

  CrdUsuarioAplicacaoDirective.$inject = ['$filter'];

  function CrdUsuarioAplicacaoDirective($filter) {
    var directive = {
      link: postLink,
      restrict: 'E',
      scope: {
        usuario: '='
      },
      templateUrl: 'scripts/crd/directives/usuario-aplicacao/crd-usuario-aplicacao-tpl.html'
    };

    return directive;

    function postLink($scope) {
      $scope.$watch('usuario', function(newVal) {
        if (newVal) {
          $scope.usuario.matriculaFormatada = $filter('matriculaFormatada')($scope.usuario.matricula);
        }
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('crdRoleController', CrdRoleController);

  CrdRoleController.$inject = ['$scope', 'roles'];

  function CrdRoleController($scope, roles) {
    var vm = this;
    vm.role = roles.findByCodigo($scope.codigo);
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdRole', crdRolesDirective);

  function crdRolesDirective() {
    var directive = {
      controller: 'crdRoleController',
      link: postLink,
      require: 'crdRole',
      restrict: 'E',
      scope: {
        codigo: '='
      }
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      validateAttributes($attributes);
      if (controller.role) {
        $element.append('<span class="label label-default-clean">' + controller.role.nome + '</span>');
      }
    }

    function validateAttributes(attributes) {
      if (!attributes.codigo) {
        throw Error('O atributo "codigo" é obrigatório.');
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('zeroLeftPadInput', zeroLeftPadInputDirective);

  function zeroLeftPadInputDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        padLength: '@'
      },
      link: function(scope, element, attrs, ngModelCtrl) {
        var digits = '';
        var getMaxLength = function() {
          return parseInt(scope.padLength, 10) || 9;
        };

        function padLeft(str, length) {
          while (str.length < length) {
            str = '0' + str;
          }
          return str;
        }

        function render() {
          var padded = padLeft(digits, getMaxLength());
          element.val(padded);
          ngModelCtrl.$setViewValue(padded);
        }

        element.on('keydown', function(event) {
          var key = event.key;

          if (key === 'Backspace') {
            digits = digits.slice(0, -1);
            event.preventDefault();
          } else if (/^\d$/.test(key) && digits.length < getMaxLength()) {
            digits += key;
            event.preventDefault();
          } else if (['Tab', 'ArrowLeft', 'ArrowRight'].indexOf(key) === -1) {
            event.preventDefault();
          }

          render();
          scope.$applyAsync();
        });

        ngModelCtrl.$formatters.push(function(modelValue) {
          var length = getMaxLength();
          var strValue = modelValue != null ? String(modelValue) : '';
          digits = strValue.replace(/\D/g, '').slice(0, length);
          return padLeft(digits, length);
        });

        ngModelCtrl.$parsers.push(function(viewValue) {
          return digits;
        });

        scope.$evalAsync(function() {
          var modelValue = ngModelCtrl.$modelValue;
          if (modelValue != null) {
            digits = String(modelValue).replace(/\D/g, '').slice(0, getMaxLength());
            render();
          }
        });
      }
    };
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .filter('cnpj', cnpjFilter);

  function cnpjFilter() {
    var TAMANHO = 8;
    var INICIO = 0;
    var PRIMEIRA_PARTE = 2;
    var SEGUNDA_PARTE = 5;

    return function(input) {
      if (input && input.length && input.length === TAMANHO) {
        return input.substring(INICIO, PRIMEIRA_PARTE)
        + '.' + input.substring(PRIMEIRA_PARTE, SEGUNDA_PARTE)
        + '.' + input.substring(SEGUNDA_PARTE, TAMANHO);
      }

      return input;
    };
  }
})(angular);
;
(function(angular, _) {
  'use strict';

  var MAX_SAFE_INTEGER= Number.MAX_SAFE_INTEGER || 9007199254740991;

  angular
    .module('crd')
    .filter('extrairDocumentoMenorPeriodicidade', extrairDocumentoMenorPeriodicidade);

  function extrairDocumentoMenorPeriodicidade() {
    return function(documento) {
      var documentoMenorPeriodicidade;
      if (angular.isArray(documento)) {
        documentoMenorPeriodicidade = getDocumentoMenorPeriodicidade(documento);
      } else if (angular.isObject(documento)) {
        documentoMenorPeriodicidade = documento;
      }

      return documentoMenorPeriodicidade;
    };
  }

  function getDocumentoMenorPeriodicidade(documentos) {
    var menorPeriodicidade = MAX_SAFE_INTEGER;
    var documentoMenor = null;
    _.each(documentos, function(doc) {
      var periodicidade = doc.menorPeriodicidade;
      if (periodicidade.codigo < menorPeriodicidade) {
        menorPeriodicidade = periodicidade.codigo;
        documentoMenor = doc;
      }
    });

    return documentoMenor;
  }
})(angular, _);
;
(function(angular, s) {
  'use strict';

  angular
    .module('crd')
    .filter('html', HtmlFilter);

  function HtmlFilter() {
    return function(input) {
      return s.replaceAll(input, '\n', '<br/>');
    };
  }
})(angular, s);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .filter('matriculaFormatada', matriculaFormatadaFilter);

  function matriculaFormatadaFilter() {
    var TAMANHO = 8;
    var INICIO = 0;
    var PRIMEIRA_PARTE = 1;
    var SEGUNDA_PARTE = 4;
    var TERCEIRA_PARTE = 7;

    return function(input) {
      if (input && input.length && input.length === TAMANHO) {
        return input.substring(INICIO, PRIMEIRA_PARTE)
        + '.' + input.substring(PRIMEIRA_PARTE, SEGUNDA_PARTE)
        + '.' + input.substring(SEGUNDA_PARTE, TERCEIRA_PARTE)
        + '-' + input.substring(TERCEIRA_PARTE);
      }
      return input;
    };
  }
})(angular);
;
(function(angular, HttpStatus, s) {
  'use strict';

  angular
    .module('crd')
    .factory('httpErrorInterceptador', httpErrorInterceptador);

  httpErrorInterceptador.$inject = ['$location', '$q', '$rootScope', '$window'];

  function httpErrorInterceptador($location, $q, $rootScope, $window) {

    var redirecionandoLogin = false;

    return {
      responseError: responseError
    };

    function redirectLogin() {
      if (redirecionandoLogin) return;
      redirecionandoLogin = true;
      $window.location.replace('/crd/rest/dologin');
    }

    function responseError(response) {

      //PRIORIDADE MÁXIMA: sessão inválida
      if (
        response.status === 401 ||
        response.status === 403 ||
        response.status === -1
      ) {
        redirectLogin();
        return $q.reject(response);
      }

      // demais casos
      if (s.isBlank(response.data) || !angular.fromJson(response.data).notInterceptable) {

        if (response.status === HttpStatus.PRECONDITION_FAILED) {
          $rootScope.$broadcast('uiFbViolacoes', response.data);

        } else if (response.status === HttpStatus.NOT_FOUND) {
          $location.path('/404');

        } else if (response.status === HttpStatus.LOCKED) {
          $rootScope.$broadcast('uiFbAlerta', response.data.mensagem);

        } else if (s.startsWith(response.status, '50')) {
          $location.path('/500');
          $rootScope.paginaStatus = {
            codigo: 500,
            data: angular.fromJson(response.data)
          };
        }
      }

      return $q.reject(response);
    }
  }
})(angular, httpStatusCode, s);
;
(function(angular) {
  'use strict';

  var SEPARADOR = '->';

  angular
    .module('crd')
    .factory('httpLoggerInterceptor', httpLoggerInterceptor);

  httpLoggerInterceptor.$inject = ['$log', '$q'];

  function httpLoggerInterceptor($log, $q) {
    var service = {
      request: onRequest,
      requestError: onRequestError,
      response: onResponse,
      responseError: onResponseError
    };

    return service;

    function onRequest(config) {
      $log.debug(config.method, SEPARADOR, config.url);
      return config;
    }

    function onRequestError(rejection) {
      $log.error('Erro no request', SEPARADOR, rejection);
      return $q.reject(rejection);
    }

    function onResponse(response) {
      // $log.debug('Retorno chamanda', SEPARADOR, response);
      return response;
    }

    function onResponseError(rejection) {
      $log.error('Erro ao solicitar recurso', SEPARADOR, rejection);
      return $q.reject(rejection);
    }
  }
})(angular);
;
"use strict";
var HttpNocacheInterceptor = (function () {
    function HttpNocacheInterceptor() {
    }
    HttpNocacheInterceptor.prototype.request = function (config) {
        var url = config.url;
        if (url.indexOf('-tpl.html') > -1) {
            config.url = url + "?v=2026-11-03T08-44-71";
        }
        return config;
    };
    HttpNocacheInterceptor.Factory = function () {
        return new HttpNocacheInterceptor();
    };
    return HttpNocacheInterceptor;
}());
HttpNocacheInterceptor.$inject = [];
angular.module('crd').factory('httpNocacheInterceptor', HttpNocacheInterceptor.Factory);
//# sourceMappingURL=http-nocache-interceptor-service.js.map;
"use strict";
//# sourceMappingURL=atraso-painel-resource.js.map;
"use strict";
//# sourceMappingURL=base-normativas-da-critica-resource.js.map;
"use strict";
//# sourceMappingURL=campo-situacao-monitorada-resource.js.map;
"use strict";
//# sourceMappingURL=documento-resource.js.map;
"use strict";
//# sourceMappingURL=enum-com-codigo-e-nome-resource.js.map;
"use strict";
//# sourceMappingURL=enum-com-codigo-resource.js.map;
"use strict";
//# sourceMappingURL=formato-data-resource.js.map;
"use strict";
//# sourceMappingURL=hate-oas.js.map;
"use strict";
//# sourceMappingURL=indice-painel-resource.js.map;
"use strict";
//# sourceMappingURL=instituicao-resource.js.map;
"use strict";
//# sourceMappingURL=menor-tipo-periodicidade-resource.js.map;
"use strict";
//# sourceMappingURL=motivo-desconsiderar-incidente-resource.js.map;
"use strict";
//# sourceMappingURL=page-resource.js.map;
"use strict";
//# sourceMappingURL=periodo-resource.js.map;
"use strict";
//# sourceMappingURL=pessoa-resource.js.map;
"use strict";
//# sourceMappingURL=segmento-resource.js.map;
"use strict";
//# sourceMappingURL=sistema-negocio-resource.js.map;
"use strict";
//# sourceMappingURL=situacao-entrada-arquivo-resource.js.map;
"use strict";
//# sourceMappingURL=tipos-pequenos.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .run(AmMomentRun);

  AmMomentRun.$inject = ['amMoment'];

  function AmMomentRun(amMoment) {
    amMoment.changeLocale('pt-br');
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .run(angularUIRun);

  angularUIRun.$inject = ['$rootScope', '$state', '$stateParams'];

  function angularUIRun($rootScope, $state, $stateParams) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
  }
})(angular);
;
(function(angular) {
  'use strict';

  var TAMANHO_PAGINA_5 = 5;
  var TAMANHO_PAGINA_10 = 10;
  var TAMANHO_PAGINA_20 = 20;
  var TAMANHO_PAGINA_30 = 30;
  var TAMANHO_PAGINA_50 = 50;
  var TAMANHO_PAGINA_100 = 100;
  var TAMANHO_PAGINA_500 = 500;
  var TAMANHO_PAGINA_1000 = 1000;

  var DATA_TABLES_DOM = '<"dataTables_controls"ipltpr>';

  var DATA_TABLES_LENGTH_MENU = [TAMANHO_PAGINA_5, TAMANHO_PAGINA_10, TAMANHO_PAGINA_20, TAMANHO_PAGINA_30,
    TAMANHO_PAGINA_50, TAMANHO_PAGINA_100, TAMANHO_PAGINA_500, TAMANHO_PAGINA_1000
  ];

  var DATA_TABLES_LANGUAGE = {
    oAria: {
      sSortAscending: ': Ordenar colunas de forma ascendente',
      sSortDescending: ': Ordenar colunas de forma descendente'
    },
    oPaginate: {
      sFirst: 'Primeiro',
      sLast: 'Último',
      sNext: 'Próximo',
      sPrevious: 'Anterior'
    },
    sEmptyTable: 'Não há resultados para os dados de pesquisa',
    // sInfo: 'Mostrando de _START_ até _END_ de _TOTAL_ resultados',
    sInfo: 'Total: _TOTAL_ resultados',
    // sInfoEmpty: 'Mostrando 0 até 0 de 0 resultados',
    sInfoEmpty: 'Total: 0 resultados',
    sInfoFiltered: '(Filtrados de _MAX_ resultados)',
    sInfoPostFix: '',
    sInfoThousands: '.',
    sLengthMenu: 'Resultados por página: _MENU_',
    sLoadingRecords: 'Carregando...',
    sProcessing: 'Processando...',
    sSearch: 'Pesquisar',
    sZeroRecords: 'Não há resultados para os dados de pesquisa'
  };

  var DATA_TABLES_ORDER = [];

  angular
    .module('crd')
    .run(datatablesRun);

  datatablesRun.$inject = ['DTDefaultOptions'];

  function datatablesRun(DTDefaultOptions) {
    DTDefaultOptions.setDOM(DATA_TABLES_DOM);
    DTDefaultOptions.setDisplayLength(TAMANHO_PAGINA_10);
    DTDefaultOptions.setLanguage(DATA_TABLES_LANGUAGE);
    DTDefaultOptions.setOption('bAutoWidth', false);
    DTDefaultOptions.setOption('filter', false);
    DTDefaultOptions.setOption('lengthMenu', DATA_TABLES_LENGTH_MENU);
    DTDefaultOptions.setOption('order', DATA_TABLES_ORDER);
    DTDefaultOptions.setOption('paginationType', 'simple_numbers');
    DTDefaultOptions.setOption('stateSave', true);
    DTDefaultOptions.setOption('formatNumber', function(toFormat) {
      return new Intl.NumberFormat('pt-BR').format(toFormat);
    });
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .run(SearchParamsCache);

  var SEP = '?';

  SearchParamsCache.$inject = ['$location', '$rootScope', '$state', 'locationStorageService'];

  /**
   * Salvar e recuperar os parâmetros das telas de pesquisa.
   *
   * Verificações de URL
   * urlPath === oldUrlPath && $state.current.searchSave => salva parâmetros
   * urlPath !== oldUrlPath && params => não recuperar parâmetros
   * urlPath !== oldUrlPath && !params => recuperar parâmetros
   */
  function SearchParamsCache($location, $rootScope, $state, locationStorageService) {
    $rootScope.$on('$locationChangeSuccess', locationChangeSuccess);

    function locationChangeSuccess(event, url, oldUrl) {
      var urlPath = url.split(SEP)[0];
      var oldUrlPath = oldUrl.split(SEP)[0];

      if (urlPath === oldUrlPath && $state.current.searchSave) {
        locationStorageService.add($location);
      } else if (!ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos($location.search())) {
        var location = locationStorageService.get($location.path());
        if (angular.isDefined(location) && angular.isDefined(location.params)) {
          $location.search(location.params);
        }
      }
    }
  }
})(angular);
;
"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var AbstractAPISerivce = (function () {
    function AbstractAPISerivce(httpService, locationService, Blob, FileSaver) {
        this.httpService = httpService;
        this.locationService = locationService;
        this.Blob = Blob;
        this.FileSaver = FileSaver;
    }
    AbstractAPISerivce.prototype.alterarRecurso = function (path, data, args) {
        var payload = data instanceof FormData ? data : ObjectUtils.removerAtributosUndefinedEmptyNull(data);
        var config = __assign({}, args);
        if (data instanceof FormData) {
            config.headers = __assign({ 'Content-Type': undefined }, (config.headers || {}));
            config.transformRequest = angular.identity;
        }
        return this.httpService.put(AbstractAPISerivce.ROOT_URL + path, payload, config);
    };
    AbstractAPISerivce.prototype.alterarEstadoRecurso = function (path, data, args) {
        var payload = data instanceof FormData ? data : ObjectUtils.removerAtributosUndefinedEmptyNull(data);
        var config = __assign({}, args);
        if (data instanceof FormData) {
            config.headers = __assign({ 'Content-Type': undefined }, (config.headers || {}));
            config.transformRequest = angular.identity;
        }
        return this.httpService.patch(AbstractAPISerivce.ROOT_URL + path, payload, config);
    };
    AbstractAPISerivce.prototype.baixarArquivo = function (path, queryParameters) {
        var _this = this;
        var config = {
            responseType: 'arraybuffer',
            params: ObjectUtils.removerAtributosUndefinedEmptyNull(queryParameters)
        };
        return this.httpService.get(AbstractAPISerivce.ROOT_URL + path, config).then(function (response) {
            APIUtils.downloadFile(_this.FileSaver, _this.Blob, response);
            return response;
        });
    };
    AbstractAPISerivce.prototype.buscarRecurso = function (path, queryParameters, args) {
        var config = __assign({ params: ObjectUtils.removerAtributosUndefinedEmptyNull(queryParameters) }, args);
        return this.httpService.get(AbstractAPISerivce.ROOT_URL + path, config);
    };
    AbstractAPISerivce.prototype.excluirRecurso = function (path, data, args) {
        var payload = data instanceof FormData ? data : ObjectUtils.removerAtributosUndefinedEmptyNull(data);
        var config = __assign({}, args);
        if (data instanceof FormData) {
            config.headers = __assign({ 'Content-Type': undefined }, (config.headers || {}));
            config.transformRequest = angular.identity;
        }
        return this.httpService["delete"](AbstractAPISerivce.ROOT_URL + path, config);
    };
    AbstractAPISerivce.prototype.incluirRecurso = function (path, data, args) {
        var payload = data instanceof FormData ? data : ObjectUtils.removerAtributosUndefinedEmptyNull(data);
        var config = __assign({}, args);
        if (data instanceof FormData) {
            config.headers = __assign({ 'Content-Type': undefined }, (config.headers || {}));
            config.transformRequest = angular.identity;
        }
        return this.httpService.post(AbstractAPISerivce.ROOT_URL + path, payload, config);
    };
    AbstractAPISerivce.prototype.pesquisarRecurso = function (path, queryParameters) {
        var config = {
            params: ObjectUtils.removerAtributosUndefinedEmptyNull(queryParameters)
        };
        this.locationService.search(config.params);
        return this.httpService.get(AbstractAPISerivce.ROOT_URL + path, config);
    };
    return AbstractAPISerivce;
}());
AbstractAPISerivce.ROOT_URL = "/crd/rest";
//# sourceMappingURL=abstract-api-service.js.map;
"use strict";
var AdministracaoDocumentoApiServiceImpl = (function () {
    function AdministracaoDocumentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            detalhar: 'crd-administracao-documento-detalhar',
            incluir: 'crd-administracao-documento-criar',
            montarTelaIncluir: 'crd-administracao-documento-montar-tela-incluir',
            raiz: 'crd-administracao-documento-raiz'
        };
    }
    AdministracaoDocumentoApiServiceImpl.prototype.montarTelaIncluir = function (documento) {
        return this.apiService.get([this.API.raiz, this.API.montarTelaIncluir], { documento: documento });
    };
    AdministracaoDocumentoApiServiceImpl.prototype.incluir = function (adminstracaoDocumento) {
        return this.apiService.post([this.API.raiz, this.API.incluir], {}, adminstracaoDocumento);
    };
    AdministracaoDocumentoApiServiceImpl.prototype.detalhar = function (documento) {
        return this.apiService.get([this.API.raiz, this.API.detalhar], { documento: documento });
    };
    return AdministracaoDocumentoApiServiceImpl;
}());
AdministracaoDocumentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('AdministracaoDocumentoApiService', AdministracaoDocumentoApiServiceImpl);
//# sourceMappingURL=administracao-documento-api-service.js.map;
(function(angular) {
  'use strict';

  var API = {
    alterar: 'anotacoes-alterar',
    criar: 'anotacoes-criar',
    detalhar: 'anotacoes-detalhar',
    detalharHistorico: 'anotacoes-detalhar-historico',
    downloadAnexo: 'anotacoes-download-anexo',
    excluir: 'anotacoes-excluir',
    gerarXLSX: 'anotacoes-gerar-xlsx',
    pesquisar: 'anotacoes-pesquisar',
    pesquisarHistorico: 'anotacoes-historico',
    raiz: 'anotacoes-raiz',
    telaCriar: 'anotacoes-tela-criar',
    telaPesquisar: 'anotacoes-tela-pesquisar'
  };

  var CONFIG_COM_ARQUIVO = {
    cache: false,
    contentType: false,
    headers: {
      'Accept': 'application/json, multipart/form-data, */*',
      'Content-Type': undefined
    },
    processData: false
  };

  angular
    .module('crd')
    .factory('anotacaoApiService', anotacaoApiService);

  anotacaoApiService.$inject = ['$http', 'apiService'];

  function anotacaoApiService($http, apiService) {
    var service = {
      alterar: alterar,
      criar: criar,
      detalhar: detalhar,
      detalharHistorico: detalharHistorico,
      downloadAnexo: downloadAnexo,
      excluir: excluir,
      gerarXLSX: gerarXLSX,
      pesquisar: pesquisar,
      pesquisarHistorico: pesquisarHistorico,
      telaCriar: telaCriar,
      telaPesquisar: telaPesquisar
    };

    return service;

    function alterar(url, anotacao, anexos, arquivos) {
      var payload = new FormData();
      payload.append('anotacao', new Blob([JSON.stringify(anotacao)], {type: 'application/json;charset=UTF-8'}));
      payload.append('arquivos', new Blob([JSON.stringify(arquivos)], {type: 'application/json;charset=UTF-8'}));

      appendArquivos(payload, anexos);
      return $http.post(url, payload, CONFIG_COM_ARQUIVO);
    }

    function appendArquivos(payload, anexos) {
      if (!_.isEmpty(anexos)) {
        _.forEach(anexos, function(anexo) {
          payload.append('anexos', anexo);
        });
      }
    }

    function criar(url, anotacao, anexos) {
      var payload = new FormData();
      payload.append('anotacao', new Blob([JSON.stringify(anotacao)], {type: 'application/json;charset=UTF-8'}));

      appendArquivos(payload, anexos);
      return $http.post(url, payload, CONFIG_COM_ARQUIVO);
    }

    function detalhar(id) {
      var parameters = {
        id: id
      };
      return apiService.get([API.raiz, API.detalhar], parameters);
    }

    function detalharHistorico(idAnotacao, idHistorico) {
      var parameters = {
        historico: idHistorico,
        id: idAnotacao
      };
      return apiService.get([API.raiz, API.detalharHistorico], parameters);
    }

    function pesquisarHistorico(id) {
      var parameters = {
        id: id
      };
      return apiService.get([API.raiz, API.pesquisarHistorico], parameters);
    }

    function excluir(pk) {
      var parameters = {
        id: pk
      };
      var payload = {};
      return apiService.post([API.raiz, API.excluir], parameters, payload);
    }

    function gerarXLSX(parameters) {
      return apiService.getFile([API.raiz, API.gerarXLSX], parameters);
    }

    function downloadAnexo(parameters) {
      return apiService.getFile([API.raiz, API.downloadAnexo], parameters);
    }

    function pesquisar(parameters) {
      return apiService.get([API.raiz, API.pesquisar], parameters);
    }

    function telaCriar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaCriar], parameters);
    }

    function telaPesquisar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }
  }
})(angular);
;
(function(angular, TraversonJsonHalAdapter, _, s, urltemplate) {
  'use strict';

  angular
    .module('crd')
    .factory('apiService', apiService);

  apiService.$inject = ['$q', '$http', 'constantes', 'downloadFileService', 'traverson'];

  function apiService($q, $http, constantes, downloadFileService, traverson) {
    var crdAPI = activate();
    var service = {
      get: get,
      getHttp: getHttp,
      getFile: getFile,
      post: post,
      postHttp: postHttp
    };

    return service;

    function activate() {
      traverson.registerMediaType(TraversonJsonHalAdapter.mediaType, TraversonJsonHalAdapter);
      return traverson
        .from(constantes.ROOT_URL)
        .jsonHal()
        .useAngularHttp();
    }

    /**
     * @param {Array} follow Veja a documentação do traverson
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#following-links e
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#pass-a-link-array.
     * @param {Object} parameters Veja a documentação do traverson
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#configuring-traverson--the-request-builder-object.
     *
     * @returns {*} Uma promessa contendo o retorno da api no servidor.
     */
    function get(follow, parameters) {
      var request = newRequest(follow)
        .withTemplateParameters(removerUndefinedAndEmptyAndNull(parameters))
        .getResource();

      return request.result;
    }

    function getHttp(path, parameters) {
      parameters = removerUndefinedAndEmptyAndNull(parameters);
      return $http.get(constantes.ROOT_URL + path, parameters);
    }

    function postHttp(path, payload, config) {
      var parameters = payload instanceof FormData ? payload : removerUndefinedAndEmptyAndNull(payload);
      return $http.post(constantes.ROOT_URL + path, parameters, config);
    }

    /**
     * @param {Array} follow Veja a documentação do traverson
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#following-links e
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#pass-a-link-array.
     * @param {Object} parameters Veja a documentação do traverson
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#configuring-traverson--the-request-builder-object.
     * @param {Object} payload Veja a documentação do traverson
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#post-put-delete-and-patch.
     *
     * @returns {*} Uma promessa contendo o retorno da api no servidor.
     */
    function post(follow, parameters, payload) {
      var request = newRequest(follow)
        .withTemplateParameters(removerUndefinedAndEmptyAndNull(parameters))
        .post(removerUndefinedAndEmptyAndNull(payload));

      return request.result;
    }

    function getFile(follow, parameters) {
      var deferred = $q.defer();

      link(follow).then(successOnLink);

      function successOnLink(linkTemplate) {
        var url = urltemplate.parse(linkTemplate.href).expand(parameters);

        downloadFileService.getFile(url).then(function successOnDownloadFile() {
          deferred.resolve();
        });
      }

      return deferred.promise;
    }

    /**
     * @param {Array} follow Veja a documentação do traverson
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#following-links e
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#pass-a-link-array.
     *
     * @returns {*} Uma promessa contendo o template link solicitado.
     */
    function link(follow) {
      var lastFollow = follow.pop();
      return get(follow, null).then(successOnGet);

      function successOnGet(resource) {
        var templateLink = resource._links[lastFollow];
        return templateLink;
      }
    }

    /**
     *
     * @param {Array} follow Veja a documentação do traverson
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#following-links e
     *  https://github.com/basti1302/traverson/blob/master/user-guide.markdown#pass-a-link-array.
     *
     * @returns {*} Traverson newRequest create.
     */
    function newRequest(follow) {
      var requestOptions = {
        headers: {
          'Accept': 'application/hal+json, application/hal+json;charset=UTF-8, application/json, text/plain, */*',
          'content-type': 'application/hal+json;charset=UTF-8'
        }
      };

      var request = crdAPI.newRequest();
      if (!_.isNull(follow)) {
        request.follow(follow);
      }

      return request.withRequestOptions(requestOptions);
    }

    function removerUndefinedAndEmptyAndNull(parameters) {
      return ObjectUtils.removerAtributosUndefinedEmptyNull(parameters);
    }
  }
})(angular, TraversonJsonHalAdapter, _, s, urltemplate);
;
"use strict";
var APIUtils = (function () {
    function APIUtils() {
    }
    APIUtils.downloadFile = function (FileSaver, Blob, response) {
        var type = response.headers ? response.headers('Content-Type') || '' : '';
        var fileName = APIUtils.factoryFileName(response);
        var blob = new Blob([response.data], { type: type });
        FileSaver.saveAs(blob, fileName);
    };
    APIUtils.factoryFileName = function (response) {
        var contentDisposition = response.headers ? response.headers('content-disposition') || '' : '';
        var matches = /filename=([^;]+)/ig.exec(contentDisposition);
        var fileName = (matches ? matches[1] : undefined || 'arquivo-nao-nomeado').trim();
        return fileName.replace(/[<>:"\/\\|?*]+/g, '_');
    };
    return APIUtils;
}());
//# sourceMappingURL=api-utils.js.map;
(function(angular) {
  'use strict';

  var API = {
    raiz: 'app-info',
    downloadManualAjuda: 'manual-ajuda'
  };

  angular
    .module('crd')
    .factory('appInfoApiService', appInfoApiService);

  appInfoApiService.$inject = ['apiService'];

  function appInfoApiService(apiService) {
    var service = {
      get: get,
      downloadManualAjuda: downloadManualAjuda
    };

    return service;

    function get() {
      var parameters = null;
      return apiService.get([API.raiz], parameters);
    }

    function downloadManualAjuda() {
      return apiService.getFile([API.downloadManualAjuda]);
    }
  }
})(angular);
;
"use strict";
var AuditoriaObservanciaApiServiceImpl = (function () {
    function AuditoriaObservanciaApiServiceImpl(apiService, $http) {
        this.apiService = apiService;
        this.$http = $http;
        this.API = {
            pesquisar: 'crd-auditoria-observancia-pesquisar',
            raiz: 'crd-auditoria-observancia-raiz',
            excluir: 'crd-auditoria-observancia-excluir',
            executarAcao: 'crd-auditoria-observancia-acao',
            incluir: 'crd-auditoria-observancia-incluir',
            gerarExcel: 'crd-auditoria-observancia-pesquisar-excel',
            montarTelaPesquisa: 'crd-auditoria-observancia-montar-tela-pesquisa',
            montarTelaDetalhe: 'crd-auditoria-observancia-montar-tela-detalhe',
            montarTelaAlterar: 'crd-auditoria-observancia-montar-tela-alteracao',
            montarTelaIncluir: 'crd-auditoria-observancia-montar-tela-inclusao'
        };
    }
    AuditoriaObservanciaApiServiceImpl.prototype.buscarSumulaApontamentoAPS = function (url, filtro) {
        var config = {
            params: ObjectUtils.removerAtributosUndefinedEmptyNull(filtro)
        };
        return this.$http.get(url, config);
    };
    AuditoriaObservanciaApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    AuditoriaObservanciaApiServiceImpl.prototype.executarAcao = function (pk, tipoAcao, dados) {
        return this.apiService.post([this.API.raiz, this.API.executarAcao], { pk: pk, tipoAcao: tipoAcao }, dados);
    };
    AuditoriaObservanciaApiServiceImpl.prototype.excluir = function (pk) {
        return this.apiService.post([this.API.raiz, this.API.excluir], { pk: pk });
    };
    AuditoriaObservanciaApiServiceImpl.prototype.incluir = function (url, crq) {
        return this.$http.post(url, crq);
    };
    AuditoriaObservanciaApiServiceImpl.prototype.gerarExcel = function (filtro) {
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], filtro);
    };
    AuditoriaObservanciaApiServiceImpl.prototype.montarTelaDetalhe = function (pk) {
        return this.apiService.get([this.API.raiz, this.API.montarTelaDetalhe], { pk: pk });
    };
    AuditoriaObservanciaApiServiceImpl.prototype.montarTelaAlterar = function (pk) {
        return this.apiService.get([this.API.raiz, this.API.montarTelaAlterar], { pk: pk });
    };
    AuditoriaObservanciaApiServiceImpl.prototype.montarTelaIncluir = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaIncluir]);
    };
    AuditoriaObservanciaApiServiceImpl.prototype.montarTelaPesquisa = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaPesquisa]);
    };
    return AuditoriaObservanciaApiServiceImpl;
}());
AuditoriaObservanciaApiServiceImpl.$inject = ['apiService', '$http'];
angular.module('crd').service('AuditoriaObservanciaApiService', AuditoriaObservanciaApiServiceImpl);
//# sourceMappingURL=auditoria-observancia-api-service.js.map;
"use strict";
var CampoSituacaoMonitoradaApiServiceImpl = (function () {
    function CampoSituacaoMonitoradaApiServiceImpl(apiService, $http) {
        this.apiService = apiService;
        this.$http = $http;
        this.API = {
            alterar: 'crd-campo-situacao-monitorada-alterar',
            incluir: 'crd-campo-situacao-monitorada-incluir',
            desativar: 'crd-campo-situacao-monitorada-desativar',
            montarTelaDetalhe: 'crd-campo-situacao-monitorada-detalhar',
            gerarExcel: 'crd-campo-situacao-monitorada-gerar-xls',
            pesquisar: 'crd-campo-situacao-monitorada-pesquisar',
            pesquisarAtivos: 'crd-campo-situacao-monitorada-pesquisar-ativos',
            pesquisarPorSistemaNegocio: 'crd-campo-situacao-monitorada-pesquisar-por-sistema-negocio',
            raiz: 'crd-campo-situacao-monitorada-raiz',
            montarTelaAlterar: 'crd-campo-situacao-monitorada-montar-tela-alterar',
            montarTelaIncluir: 'crd-campo-situacao-monitorada-montar-tela-incluir',
            montarTelaPesquisa: 'crd-campo-situacao-monitorada-montar-tela-pesquisar'
        };
    }
    CampoSituacaoMonitoradaApiServiceImpl.prototype.alterar = function (pk, campoSituacaoMonitorada) {
        var parameters = { pk: pk };
        var payload = campoSituacaoMonitorada;
        return this.apiService.post([this.API.raiz, this.API.alterar], parameters, payload);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.incluir = function (campoSituacaoMonitorada) {
        var parameters = null;
        var payload = campoSituacaoMonitorada;
        return this.apiService.post([this.API.raiz, this.API.incluir], parameters, payload);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.desativar = function (pk) {
        var parameters = {
            pk: pk
        };
        var payload = {};
        return this.apiService.post([this.API.raiz, this.API.desativar], parameters, payload);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.montarTelaAlterar = function (pk) {
        var parameters = {
            pk: pk
        };
        return this.apiService.get([this.API.raiz, this.API.montarTelaAlterar], parameters);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.montarTelaDetalhe = function (pk) {
        var parameters = {
            pk: pk
        };
        return this.apiService.get([this.API.raiz, this.API.montarTelaDetalhe], parameters);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.gerarExcel = function (parameters) {
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], parameters);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.pesquisar = function (parameters) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], parameters);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.pesquisarAtivos = function (parameters) {
        return this.apiService.get([this.API.raiz, this.API.pesquisarAtivos], parameters);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.pesquisarPorSistemaNegocio = function (parameters) {
        return this.apiService.get([this.API.raiz, this.API.pesquisarPorSistemaNegocio], parameters);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.montarTelaIncluir = function () {
        var parameters = null;
        return this.apiService.get([this.API.raiz, this.API.montarTelaIncluir], parameters);
    };
    CampoSituacaoMonitoradaApiServiceImpl.prototype.montarTelaPesquisa = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaPesquisa]);
    };
    return CampoSituacaoMonitoradaApiServiceImpl;
}());
CampoSituacaoMonitoradaApiServiceImpl.$inject = ['apiService', '$http'];
angular.module('crd').service('CampoSituacaoMonitoradaApiService', CampoSituacaoMonitoradaApiServiceImpl);
//# sourceMappingURL=campo-situacao-monitorada-api-service.js.map;
(function(angular) {
  'use strict';

  var API = {
    gerarCobrancaAvulsa: 'gerar-cobranca-avulsa',
    gerarCobrancaEmLote: 'gerar-cobranca-lote',
    raiz: 'cobranca-raiz'
  };

  angular
    .module('crd')
    .factory('cobrancaApiService', cobrancaApiService);

  cobrancaApiService.$inject = ['apiService'];

  function cobrancaApiService(apiService) {
    var service = {
      gerarCobrancaAvulsa: gerarCobrancaAvulsa,
      gerarCobrancaEmLote: gerarCobrancaEmLote
    };

    return service;

    function gerarCobrancaAvulsa(cobrancaSelecionada, filtro, emailsDestinatarios) {
      var parameters = null;
      var playLoad = {
        documentoSelecionadoAvulso: cobrancaSelecionada,
        emailDestinatarios: emailsDestinatarios,
        filtro: filtro
      };
      return apiService.post([API.raiz, API.gerarCobrancaAvulsa], parameters, playLoad);
    }

    function gerarCobrancaEmLote(cobrancasSelecionadasComDestinatario, cobrancasSelecionadasSemDestinatario, filtro) {
      var parameters = null;
      var playLoad = {
        cobrancasSelecionadasComDestinatario: cobrancasSelecionadasComDestinatario,
        cobrancasSelecionadasSemDestinatario: cobrancasSelecionadasSemDestinatario,
        filtro: filtro
      };
      return apiService.post([API.raiz, API.gerarCobrancaEmLote], parameters, playLoad);
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  var API = {
    gerarXLS: 'comunicacao-gerar-xls',
    pesquisar: 'comunicacao-pesquisar',
    detalhar: 'comunicacao-detalhar',
    raiz: 'comunicacao-raiz',
    telaPesquisar: 'comunicacao-tela-pesquisar',
    excluir: 'comunicacao-excluir',
    buscarInformacoesComunicacao: 'comunicacao-informacoes'
  };

  angular
    .module('crd')
    .factory('comunicacaoApiService', comunicacaoApiService);

  comunicacaoApiService.$inject = ['apiService'];

  function comunicacaoApiService(apiService) {
    var service = {
      gerarXLS: gerarXLS,
      pesquisar: pesquisar,
      detalhar: detalhar,
      telaPesquisar: telaPesquisar,
      excluir: excluir,
      buscarInformacoesComunicacao: buscarInformacoesComunicacao
    };

    return service;

    function gerarXLS(parameters) {
      return apiService.getFile([API.raiz, API.gerarXLS], parameters);
    }

    function pesquisar(parameters) {
      return apiService.get([API.raiz, API.pesquisar], parameters);
    }

    function detalhar(parameters) {
      return apiService.get([API.raiz, API.detalhar], parameters);
    }

    function telaPesquisar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }

    function buscarInformacoesComunicacao(parameters) {
      return apiService.get([API.raiz, API.buscarInformacoesComunicacao], parameters);
    }

    function excluir(comunicacaoId, body) {
      return apiService.postHttp('/comunicacoes/' + comunicacaoId + '/excluir/', body);
    }
  }
})(angular);
;
(function (angular) {
  'use strict';

  var API = {
    detalhar: 'crd-conformidade-detalhar',
    gerarXlsx: 'crd-conformidade-gerar-xlsx',
    incluir: 'crd-conformidade-incluir',
    darConformidade: 'crd-conformidade-dar-conformidade',
    montarTelaDarConformidade: 'crd-conformidade-montar-tela-dar-conformidade',
    pesquisar: 'crd-conformidade-pesquisar',
    raiz: 'crd-conformidade-raiz',
    telaConfirmarInclusao: 'crd-conformidade-montar-tela-confirmacao-inclusao',
    telaIncluir: 'crd-conformidade-montar-tela-incluir',
    telaPesquisar: 'crd-conformidade-tela-pesquisar'
  };

  angular
    .module('crd')
    .factory('conformidadeApiService', conformidadeApiService);

  conformidadeApiService.$inject = ['apiService'];

  function conformidadeApiService(apiService) {
    var service = {
      detalhar: detalhar,
      gerarXlsx: gerarXlsx,
      incluir: incluir,
      darConformidade: darConformidade,
      montarTelaConfirmacao: montarTelaConfirmacao,
      montarTelaDarConformidade: montarTelaDarConformidade,
      montarTelaIncluir: montarTelaIncluir,
      montarTelaPesquisar: montarTelaPesquisar,
      pesquisar: pesquisar
    };

    return service;

    function incluir(conformidade) {
      var parameters = null;

      return apiService.post([API.raiz, API.incluir], parameters, conformidade);
    }

    function montarTelaIncluir(parameters) {
      return apiService.get([API.raiz, API.telaIncluir], parameters);
    }

    function montarTelaConfirmacao(parameters) {
      return apiService.get([API.raiz, API.telaConfirmarInclusao], parameters);
    }

    function montarTelaPesquisar(parameters) {
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }

    function pesquisar(parameters) {
      return apiService.get([API.raiz, API.pesquisar], parameters);
    }

    function montarTelaDarConformidade(id) {
      var parameters = {
        pk: id
      };
      return apiService.get([API.raiz, API.montarTelaDarConformidade], parameters);
    }

    function darConformidade(pk, conformidade) {
      var parameters = {
        pk: pk
      };
      return apiService.post([API.raiz, API.darConformidade], parameters, conformidade);
    }

    function detalhar(id) {
      var parameters = {
        pk: id
      };
      return apiService.get([API.raiz, API.detalhar], parameters);
    }

    function gerarXlsx(parameters) {
      return apiService.getFile([API.raiz, API.gerarXlsx], parameters);
    }
  }
})(angular);

;
(function(angular) {
  'use strict';

  var API = {
    buscarPorParteCodigo: 'conglomerado-por-parte-codigo',
    raiz: 'conglomerado-raiz',
    recuperar: 'recuperar'
  };

  angular
    .module('crd')
    .factory('conglomeradoApiService', conglomeradoApiService);

  conglomeradoApiService.$inject = ['apiService'];

  function conglomeradoApiService(apiService) {
    var service = {
      buscarPorParteCodigo: buscarPorParteCodigo,
      recuperar: recuperar
    };

    return service;

    function buscarPorParteCodigo(parteCodigo) {
      var parameters = {
        parteCodigo: parteCodigo
      };
      return apiService.get([API.raiz, API.buscarPorParteCodigo], parameters);
    }

    function recuperar(codigo) {
      var parameters = {
        codigo: codigo
      };
      return apiService.get([API.raiz, API.recuperar], parameters);
    }
  }
})(angular);
;
"use strict";
var CriticaQualidadeApiServiceImpl = (function () {
    function CriticaQualidadeApiServiceImpl(apiService, $http) {
        this.apiService = apiService;
        this.$http = $http;
        this.API = {
            pesquisar: 'crd-critica-qualidade-pesquisar',
            raiz: 'crd-critica-qualidade-raiz',
            excluir: 'crd-critica-qualidade-excluir',
            alterar: 'crd-critica-qualidade-alterar',
            incluir: 'crd-critica-qualidade-incluir',
            gerarExcel: 'crd-critica-qualidade-pesquisar-excel',
            montarTelaPesquisa: 'crd-critica-qualidade-montar-tela-pesquisa',
            montarTelaDetalhe: 'crd-critica-qualidade-montar-tela-detalhe',
            montarTelaAlterar: 'crd-critica-qualidade-montar-tela-alteracao',
            montarTelaIncluir: 'crd-critica-qualidade-montar-tela-inclusao',
            obterCodigoSiglaDocumento: 'obter-codigo-sigla-documento'
        };
    }
    CriticaQualidadeApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    CriticaQualidadeApiServiceImpl.prototype.excluir = function (pk) {
        return this.apiService.post([this.API.raiz, this.API.excluir], { pk: pk });
    };
    CriticaQualidadeApiServiceImpl.prototype.incluir = function (url, crq) {
        return this.$http.post(url, crq);
    };
    CriticaQualidadeApiServiceImpl.prototype.alterar = function (pk, crq) {
        return this.apiService.post([this.API.raiz, this.API.alterar], { pk: pk }, crq);
    };
    CriticaQualidadeApiServiceImpl.prototype.gerarExcel = function (filtro) {
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], filtro);
    };
    CriticaQualidadeApiServiceImpl.prototype.montarTelaDetalhe = function (pk) {
        return this.apiService.get([this.API.raiz, this.API.montarTelaDetalhe], { pk: pk });
    };
    CriticaQualidadeApiServiceImpl.prototype.montarTelaAlterar = function (pk, automatica) {
        var parameters = {
            pk: pk,
            automatica: automatica
        };
        return this.apiService.get([this.API.raiz, this.API.montarTelaAlterar], parameters);
    };
    CriticaQualidadeApiServiceImpl.prototype.montarTelaIncluir = function (pk, automatica) {
        var parameters = {
            pk: pk,
            automatica: automatica
        };
        return this.apiService.get([this.API.raiz, this.API.montarTelaIncluir], parameters);
    };
    CriticaQualidadeApiServiceImpl.prototype.montarTelaPesquisa = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaPesquisa]);
    };
    CriticaQualidadeApiServiceImpl.prototype.pesquisarParaSelecao = function (filtro, ignoreLoadingBar) {
        return this.apiService.getHttp('/critica-qualidade/pesquisar-para-selecao', { params: filtro, ignoreLoadingBar: ignoreLoadingBar });
    };
    CriticaQualidadeApiServiceImpl.prototype.obterCodigoSiglaDocumento = function (codigoDocumento) {
        return this.apiService.postHttp("/critica-qualidade/obter-codigo-sigla-documento/" + codigoDocumento);
    };
    return CriticaQualidadeApiServiceImpl;
}());
CriticaQualidadeApiServiceImpl.$inject = ['apiService', '$http'];
angular.module('crd').service('CriticaQualidadeApiService', CriticaQualidadeApiServiceImpl);
//# sourceMappingURL=critica-qualidade-api-service.js.map;
(function(angular) {
  'use strict';

  var API = {
    criar: 'curador-sistema-negocio-incluir',
    excluir: 'curador-sistema-negocio-excluir',
    pesquisar: 'curador-sistema-negocio-pesquisar',
    pesquisarAgentesPorUnidade: 'curador-sistema-negocio-pesquisar-agentes-por-unidade',
    raiz: 'curador-sistema-negocio-raiz',
    telaCriar: 'curador-sistema-negocio-montar-tela-criar',
    telaPesquisa: 'curador-sistema-negocio-montar-tela-pesquisa'
  };

  angular
    .module('crd')
    .factory('curadorSistemaNegocioApiService', curadorSistemaNegocioApiService);

  curadorSistemaNegocioApiService.$inject = ['apiService'];

  function curadorSistemaNegocioApiService(apiService) {
    var service = {
      criar: criar,
      excluir: excluir,
      montarTelaCriar: montarTelaCriar,
      montarTelaPesquisa: montarTelaPesquisa,
      pesquisar: pesquisar,
      pesquisarAgentesPorUnidade: pesquisarAgentesPorUnidade
    };

    return service;

    function criar(curadorSistemaNegocio) {
      var parameters = null;
      return apiService.post([API.raiz, API.criar], parameters, curadorSistemaNegocio);
    }

    function excluir(pk) {
      var parameters = {
        id: pk
      };
      var payload = {};
      return apiService.post([API.raiz, API.excluir], parameters, payload);
    }

    function montarTelaCriar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaCriar], parameters);
    }

    function montarTelaPesquisa() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisa], parameters);
    }

    function pesquisar(parameters) {
      return apiService.get([API.raiz, API.pesquisar], parameters);
    }

    function pesquisarAgentesPorUnidade(unidade) {
      var parameters = {
        unidade: unidade
      };
      var payload = {};
      return apiService.get([API.raiz, API.pesquisarAgentesPorUnidade], parameters, payload);
    }
  }
})(angular);
;
"use strict";
var DispensaApiServiceImpl = (function () {
    function DispensaApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API_DISPENSA = {
            detalhar: 'crd-entidade-supervisionada-dispensada-detalhar',
            gerarXlsx: 'crd-entidade-supervisionada-dispensada-excel',
            pesquisar: 'crd-entidade-supervisionada-dispensada-pesquisar',
            alterar: 'crd-entidade-supervisionada-dispensada-alterar',
            incluir: 'crd-entidade-supervisionada-dispensada-incluir',
            validar: 'crd-entidade-supervisionada-dispensada-validar',
            telaIncluir: 'crd-entidade-supervisionada-dispensada-montar-incluir',
            desativar: 'crd-entidade-supervisionada-dispensada-desativar',
            confirmar: 'crd-entidade-supervisionada-dispensada-confirmar',
            raiz: 'crd-entidade-supervisionada-dispensada-raiz',
            telaPesquisar: 'crd-entidade-supervisionada-dispensada-montar-pesquisar'
        };
    }
    DispensaApiServiceImpl.prototype.montarTelaPesquisar = function () {
        return this.apiService.get([this.API_DISPENSA.raiz, this.API_DISPENSA.telaPesquisar]);
    };
    DispensaApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API_DISPENSA.raiz, this.API_DISPENSA.pesquisar], filtro);
    };
    DispensaApiServiceImpl.prototype.montarTelaIncluir = function (isDocumentoZerado) {
        var parameters = {
            isDocumentoZerado: isDocumentoZerado
        };
        return this.apiService.get([this.API_DISPENSA.raiz, this.API_DISPENSA.telaIncluir], parameters);
    };
    DispensaApiServiceImpl.prototype.incluir = function (dispensaFormatada) {
        return this.apiService.post([this.API_DISPENSA.raiz, this.API_DISPENSA.incluir], {}, dispensaFormatada);
    };
    DispensaApiServiceImpl.prototype.validar = function (dispensaFormatada) {
        return this.apiService.post([this.API_DISPENSA.raiz, this.API_DISPENSA.validar], {}, dispensaFormatada);
    };
    DispensaApiServiceImpl.prototype.confirmar = function (dispensaFormatada) {
        return this.apiService.get([this.API_DISPENSA.raiz, this.API_DISPENSA.confirmar], dispensaFormatada);
    };
    DispensaApiServiceImpl.prototype.detalhar = function (id) {
        var parameters = {
            id: id
        };
        return this.apiService.get([this.API_DISPENSA.raiz, this.API_DISPENSA.detalhar], parameters);
    };
    DispensaApiServiceImpl.prototype.desativar = function (pk) {
        var parameters = {
            id: pk
        };
        return this.apiService.post([this.API_DISPENSA.raiz, this.API_DISPENSA.desativar], parameters, {});
    };
    DispensaApiServiceImpl.prototype.alterar = function (pk, dispensaFormatada) {
        var parameters = {
            id: pk
        };
        return this.apiService.post([this.API_DISPENSA.raiz, this.API_DISPENSA.alterar], parameters, dispensaFormatada);
    };
    DispensaApiServiceImpl.prototype.gerarXlsx = function (filtro) {
        return this.apiService.getFile([this.API_DISPENSA.raiz, this.API_DISPENSA.gerarXlsx], filtro);
    };
    return DispensaApiServiceImpl;
}());
DispensaApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('dispensaApiService', DispensaApiServiceImpl);
//# sourceMappingURL=dispensa-api-service.js.map;
(function (angular) {
  'use strict';

  var API = {
    buscarAtivosDispensaveisPorSistemaNegocio: 'documentos-ativos-dispensaveis-por-sistema-negocio',
    buscarAtivosPorSistemaNegocio: 'documentos-ativos-por-sistema-negocio',
    buscarPorCodigo: 'documentos-por-codigo',
    buscarPorSistemaNegocio: 'documentos-por-sistema-negocio',
    buscarPorSistemasNegocio: 'documentos-por-sistemas-negocio',
    buscarTodos: 'documentos-todos',
    buscarPorCritica: 'documentos-por-critica',
    gerarXLS: 'documentos-gerar-xlsx',
    pesquisar: 'documentos-pesquisar',
    pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk: 'documentos-ativos-por-periodicidade-minima-e-sistema-negocio',
    raiz: 'documentos-raiz',
    recuperar: 'documentos-recuperar',
    telaPesquisar: 'documentos-tela-pesquisar',
    montarTelaIncluir: 'crd-documentos-montar-tela-incluir',
    montarTelaGeral: 'crd-documentos-montar-tela-geral',
    criar: 'crd-documentos-criar',
    detalhar: 'crd-documentos-detalhar',
    montarTelaAlterar: 'crd-documentos-montar-tela-alterar',
    alterar: 'crd-documentos-alterar',
    ativar: 'crd-documentos-ativar',
    excluir: 'crd-documentos-excluir',
    encerrar: 'crd-documentos-encerrar'
  };

  angular
    .module('crd')
    .factory('documentoApiService', documentoApiService);

  documentoApiService.$inject = ['$q', 'apiService', 'documentoStorageService'];

  function documentoApiService($q, apiService, documentoStorageService) {
    var service = {
      buscarAtivosDispensaveisPorSistemaNegocio: buscarAtivosDispensaveisPorSistemaNegocio,
      buscarAtivosPorSistemaNegocio: buscarAtivosPorSistemaNegocio,
      buscarPorCodigo: buscarPorCodigo,
      buscarPorSistemaNegocio: buscarPorSistemaNegocio,
      buscarPorCritica: buscarPorCritica,
      buscarPorSistemasNegocio: buscarPorSistemasNegocio,
      gerarXLS: gerarXLS,
      pesquisar: pesquisar,
      pesquisarPorPeriodicidadeESistemaNegocioPk: pesquisarPorPeriodicidadeESistemaNegocioPk,
      pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk: pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk,
      recuperar: recuperar,
      telaPesquisar: telaPesquisar,
      montarTelaIncluir: montarTelaIncluir,
      criar: criar,
      montarTelaGeral: montarTelaGeral,
      detalhar: detalhar,
      montarTelaAlterar: montarTelaAlterar,
      alterar: alterar,
      ativar: ativar,
      excluir: excluir,
      encerrar: encerrar,
      pesquisarParaSelecao: pesquisarParaSelecao
    };

    return service;

    function ativar(pk) {
      var parameters = { pk: pk };
      var payload = {};
      return apiService.post([API.raiz, API.ativar], parameters, payload);
    }

    function excluir(pk) {
      var parameters = { pk: pk };
      var payload = {};
      return apiService.post([API.raiz, API.excluir], parameters, payload);
    }

    function buscarPorCodigo(codigo) {
      var deferred = $q.defer();

      inicializarStorage().then(function () {
        var documento = documentoStorageService.getByCodigo(codigo);
        deferred.resolve(documento);
      });

      return deferred.promise;
    }

    function buscarPorSistemaNegocio(sistemaNegocioPk) {
      var deferred = $q.defer();

      inicializarStorage().then(function () {
        var documentos = documentoStorageService.findBySistemaNegocioPk(sistemaNegocioPk);
        deferred.resolve(documentos);
      });

      return deferred.promise;
    }

    function buscarPorCritica(criticaPk) {
      return apiService.get([API.raiz, API.buscarPorCritica], { pk: criticaPk });
    }

    function buscarPorSistemasNegocio(sistemaNegocioPk) {
      var deferred = $q.defer();

      inicializarStorage().then(function () {
        var documentos = documentoStorageService.findBySistemasNegocioPk(sistemaNegocioPk);
        deferred.resolve(documentos);
      });

      return deferred.promise;
    }

    function buscarAtivosPorSistemaNegocio(sistemaNegocioPk) {
      var deferred = $q.defer();

      inicializarStorage().then(function () {
        var documentos = documentoStorageService.findBySistemaNegocioPk(sistemaNegocioPk);
        deferred.resolve(documentos);
      });

      return deferred.promise;
    }

    function buscarAtivosDispensaveisPorSistemaNegocio(sistemaNegocioPk, tiposDispensa) {
      var parameters = {
        sistemaNegocioPk: sistemaNegocioPk,
        tiposDispensa: tiposDispensa
      };

      return apiService.get([API.raiz, API.buscarAtivosDispensaveisPorSistemaNegocio], parameters);
    }

    function detalhar(pk) {
      return apiService.get([API.raiz, API.detalhar], { pk: pk });
    }

    function montarTelaAlterar(pk) {
      return apiService.get([API.raiz, API.montarTelaAlterar], { pk: pk });
    }

    function recuperar(pk) {
      var deferred = $q.defer();

      inicializarStorage().then(function () {
        var documentos = documentoStorageService.getByPk(pk);
        deferred.resolve(documentos);
      });

      return deferred.promise;
    }

    function inicializarStorage() {
      var deferred = $q.defer();
      if (documentoStorageService.inicializado()) {
        deferred.resolve();
      } else {
        apiService
          .get([API.raiz, API.buscarTodos], null)
          .then(function (resource) {
            var resultado = resource._embedded.resultado;
            documentoStorageService.limpar();
            documentoStorageService.addAll(resultado);
            deferred.resolve();
          });
      }

      return deferred.promise;
    }

    function telaPesquisar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }

    function pesquisar(parameters) {
      return apiService.get([API.raiz, API.pesquisar], parameters);
    }

    function pesquisarPorPeriodicidadeESistemaNegocioPk(parameters) {
      return apiService.getHttp('/documento/documentos', { params: parameters });
    }

    function pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(sistemaNegocioPk, periodicidadeMinima) {
      return apiService.get([API.raiz, API.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk], {
        periodicidade: periodicidadeMinima,
        sistemaNegocioPk: sistemaNegocioPk
      });
    }

    function gerarXLS(parameters) {
      return apiService.getFile([API.raiz, API.gerarXLS], parameters);
    }

    function montarTelaIncluir() {
      return apiService.get([API.raiz, API.montarTelaIncluir]);
    }

    function montarTelaGeral(pk) {
      var parameters = {
        pk: pk
      };

      return apiService.get([API.raiz, API.montarTelaGeral], parameters);
    }

    function criar(documento) {
      var parameters = null;
      var payload = documento;
      return apiService.post([API.raiz, API.criar], parameters, payload);
    }

    function alterar(pk, documento) {
      var parameters = { pk: pk };
      var payload = documento;
      return apiService.post([API.raiz, API.alterar], parameters, payload);
    }

    function encerrar(pk, encerrarDocumento) {
      var parameters = { pk: pk };
      var payload = encerrarDocumento;
      return apiService.post([API.raiz, API.encerrar], parameters, payload);
    }

    function pesquisarParaSelecao(filtro, ignoreLoadingBar) {
      return apiService.getHttp('/documento/pesquisar-para-selecao', { params: filtro, ignoreLoadingBar: ignoreLoadingBar});
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  var API = {
    pesquisarDocumentoNaoEntregue: 'pesquisar-documento-nao-entregue',
    pesquisarDocumentoNaoEntregueDetalhe: 'pesquisar-documento-nao-entregue-detalhe',
    pesquisarDocumentoNaoEntregueXLSX: 'pesquisar-documento-nao-entregue-xlsx',
    raiz: 'documento-nao-entregue-raiz',
    telaPesquisar: 'documento-nao-entregue-tela-pesquisar'
  };

  angular
    .module('crd')
    .factory('documentoNaoEntregueApiService', documentoNaoEntregue);

  documentoNaoEntregue.$inject = ['apiService'];

  function documentoNaoEntregue(apiService) {
    var service = {
      pesquisarDocumentoNaoEntregue: pesquisarDocumentoNaoEntregue,
      pesquisarDocumentoNaoEntregueDetalhe: pesquisarDocumentoNaoEntregueDetalhe,
      pesquisarDocumentoNaoEntregueXLSX: pesquisarDocumentoNaoEntregueXLSX,
      telaPesquisar: telaPesquisar
    };

    return service;

    function pesquisarDocumentoNaoEntregue(parameters) {
      return apiService.get([API.raiz, API.pesquisarDocumentoNaoEntregue], parameters);
    }

    function pesquisarDocumentoNaoEntregueDetalhe(parameters) {
      return apiService.get([API.raiz, API.pesquisarDocumentoNaoEntregueDetalhe], parameters);
    }

    function pesquisarDocumentoNaoEntregueXLSX(parameters) {
      return apiService.getFile([API.raiz, API.pesquisarDocumentoNaoEntregueXLSX], parameters);
    }

    function telaPesquisar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  var API = {
    pesquisarDocumentoNaoEntregue: 'pesquisar-documento-nao-entregue',
    pesquisarDocumentoNaoEntregueDetalhe: 'pesquisar-documento-nao-entregue-detalhe',
    pesquisarDocumentoNaoEntregueXLSX: 'pesquisar-documento-nao-entregue-xlsx',
    raiz: 'documento-nao-entregue-impedido-raiz',
    telaPesquisar: 'documento-nao-entregue-tela-pesquisar'
  };

  angular
    .module('crd')
    .factory('documentoNaoEntregueImpedidoApiService', documentoNaoEntregueImpedido);

  documentoNaoEntregueImpedido.$inject = ['apiService'];

  function documentoNaoEntregueImpedido(apiService) {
    var service = {
      pesquisarDocumentoNaoEntregue: pesquisarDocumentoNaoEntregue,
      pesquisarDocumentoNaoEntregueDetalhe: pesquisarDocumentoNaoEntregueDetalhe,
      pesquisarDocumentoNaoEntregueXLSX: pesquisarDocumentoNaoEntregueXLSX,
      telaPesquisar: telaPesquisar
    };

    return service;

    function pesquisarDocumentoNaoEntregue(parameters) {
      return apiService.get([API.raiz, API.pesquisarDocumentoNaoEntregue], parameters);
    }

    function pesquisarDocumentoNaoEntregueDetalhe(parameters) {
      return apiService.get([API.raiz, API.pesquisarDocumentoNaoEntregueDetalhe], parameters);
    }

    function pesquisarDocumentoNaoEntregueXLSX(parameters) {
      return apiService.getFile([API.raiz, API.pesquisarDocumentoNaoEntregueXLSX], parameters);
    }

    function telaPesquisar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }
  }
})(angular);
;
(function (angular, _) {
  'use strict';

  angular
    .module('crd')
    .factory('emailServidorApiService', emailServidorApiService);

  emailServidorApiService.$inject = ['apiService'];

  function emailServidorApiService(apiService) {
    return {
      buscarOpcoesParaSelecaoDoEmailDoServidor: buscarOpcoesParaSelecaoDoEmailDoServidor
    };

    function buscarOpcoesParaSelecaoDoEmailDoServidor(textoParaBusca) {
      return apiService.getHttp("/consulta-servidores/buscar-opcoes-para-selecao-email-servidor", { params: { email: textoParaBusca } });
    }
  }

})(angular, _);
;
"use strict";
var EntidadeSupervisionadaControleApiServiceImpl = (function () {
    function EntidadeSupervisionadaControleApiServiceImpl(apiService, $http) {
        this.apiService = apiService;
        this.$http = $http;
        this.API = {
            alterar: 'crd-entidade-supervisionada-controle-alterar',
            detalhar: 'crd-entidade-supervisionada-controle-detalhar',
            desativar: 'crd-entidade-supervisionada-controle-desativar',
            paraDesativar: 'crd-entidade-supervisionada-controle-para-desativar',
            paraIncluir: 'crd-entidade-supervisionada-controle-para-incluir',
            gerarExcel: 'crd-entidade-supervisionada-controle-excel',
            incluir: 'crd-entidade-supervisionada-controle-incluir',
            montarTelaAlterar: 'crd-entidade-supervisionada-controle-montar-alterar',
            montarTelaIncluir: 'crd-entidade-supervisionada-controle-montar-incluir',
            montarTelaPesquisa: 'crd-entidade-supervisionada-controle-montar-pesquisar',
            pesquisar: 'crd-entidade-supervisionada-controle-pesquisar',
            raiz: 'crd-entidade-supervisionada-controle-raiz',
            telaIncluir: 'crd-entidade-supervisionada-controle-montar-incluir'
        };
    }
    EntidadeSupervisionadaControleApiServiceImpl.prototype.alterar = function (id, dados) {
        return this.apiService.post([this.API.raiz, this.API.alterar], { id: id }, dados);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.incluir = function (eco) {
        return this.apiService.post([this.API.raiz, this.API.incluir], {}, eco);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.detalhar = function (id) {
        var parameters = { id: id };
        return this.apiService.get([this.API.raiz, this.API.detalhar], parameters);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.gerarExcel = function (filtro) {
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], filtro);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.desativar = function (id) {
        var parameters = { id: id };
        return this.apiService.post([this.API.raiz, this.API.desativar], parameters, {});
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.paraDesativar = function (id) {
        var parameters = { id: id };
        return this.apiService.get([this.API.raiz, this.API.paraDesativar], parameters, {});
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.paraIncluir = function (dados) {
        var parameters = {};
        return this.apiService.post([this.API.raiz, this.API.paraIncluir], parameters, dados);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.montarTelaAlterar = function (id) {
        var parameters = { id: id };
        return this.apiService.get([this.API.raiz, this.API.montarTelaAlterar], parameters);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.montarTelaIncluir = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaIncluir]);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.montarTelaPesquisa = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaPesquisa]);
    };
    EntidadeSupervisionadaControleApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    return EntidadeSupervisionadaControleApiServiceImpl;
}());
EntidadeSupervisionadaControleApiServiceImpl.$inject = ['apiService', '$http'];
angular.module('crd').service('entidadeSupervisionadaControleApiService', EntidadeSupervisionadaControleApiServiceImpl);
//# sourceMappingURL=entidade-supervisionada-controle-api-service.js.map;
"use strict";
var EntradaArquivoApiServiceImpl = (function () {
    function EntradaArquivoApiServiceImpl(apiService) {
        this.apiService = apiService;
    }
    EntradaArquivoApiServiceImpl.prototype.detalhar = function (entradaArquivoPK) {
        var parameters = {};
        return this.apiService.getHttp("/entrada-arquivo/" + entradaArquivoPK + "/detalhar", { params: parameters });
    };
    EntradaArquivoApiServiceImpl.prototype.detalharOcorrencia = function (entradaArquivoPK, parameters) {
        return this.apiService.getHttp("/entrada-arquivo/" + entradaArquivoPK + "/detalhar/ocorrencia", { params: parameters });
    };
    EntradaArquivoApiServiceImpl.prototype.reprocessar = function (entradaArquivoPK) {
        var payload = {};
        return this.apiService.postHttp("/entrada-arquivo/" + entradaArquivoPK + "/reprocessar", payload);
    };
    EntradaArquivoApiServiceImpl.prototype.paraReprocessar = function (entradaArquivoPK) {
        var parameters = {};
        return this.apiService.getHttp("/entrada-arquivo/" + entradaArquivoPK + "/para-reprocessar", { params: parameters });
    };
    EntradaArquivoApiServiceImpl.prototype.reprocessarEmLote = function (entradasArquivosPK) {
        var parameters = {};
        return this.apiService.postHttp("/entrada-arquivo/" + entradasArquivosPK + "/reprocessar-em-lote", { params: parameters });
    };
    EntradaArquivoApiServiceImpl.prototype.buscarEntradasArquivosPorIdenficador = function (entradaArquivoPorIdentificadorEsperado) {
        return this.apiService.postHttp("/entrada-arquivo/entrada-arquivo-por-identificador", entradaArquivoPorIdentificadorEsperado);
    };
    return EntradaArquivoApiServiceImpl;
}());
EntradaArquivoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('EntradaArquivoApiService', EntradaArquivoApiServiceImpl);
//# sourceMappingURL=entrada-arquivo-api-service.js.map;
"use strict";
var EquipeGestoraDocumentoApiServiceImpl = (function () {
    function EquipeGestoraDocumentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            alterar: 'crd-equipe-gestora-documento-alterar',
            criar: 'crd-equipe-gestora-documento-criar',
            excluir: 'crd-equipe-gestora-documento-excluir',
            montarTelaManutencao: 'crd-equipe-gestora-documento-montar-tela-manutencao',
            pesquisar: 'crd-equipe-gestora-documento-pesquisar',
            raiz: 'crd-equipe-gestora-documento-raiz'
        };
    }
    EquipeGestoraDocumentoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    EquipeGestoraDocumentoApiServiceImpl.prototype.montarTelaManutencao = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaManutencao]);
    };
    EquipeGestoraDocumentoApiServiceImpl.prototype.criar = function (equipeGestoraDocumento) {
        return this.apiService.post([this.API.raiz, this.API.criar], {}, equipeGestoraDocumento);
    };
    EquipeGestoraDocumentoApiServiceImpl.prototype.alterar = function (pk, equipeGestoraDocumento) {
        return this.apiService.post([this.API.raiz, this.API.alterar], { pk: pk }, equipeGestoraDocumento);
    };
    EquipeGestoraDocumentoApiServiceImpl.prototype.excluir = function (pk) {
        return this.apiService.post([this.API.raiz, this.API.excluir], { pk: pk });
    };
    return EquipeGestoraDocumentoApiServiceImpl;
}());
EquipeGestoraDocumentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('EquipeGestoraDocumentoApiService', EquipeGestoraDocumentoApiServiceImpl);
//# sourceMappingURL=equipe-gestora-documento-api-service.js.map;
"use strict";
var EsperadoProcessadoApiServiceImpl = (function () {
    function EsperadoProcessadoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            detalhar: 'crd-consulta-esperado-processado-detalhar',
            gerarXlsx: 'crd-consulta-esperado-processado-gerar-xlsx',
            pesquisar: 'crd-consulta-esperado-processado-pesquisar',
            raiz: 'crd-consulta-esperado-processado',
            paraReprocessarEmLote: 'crd-consulta-esperado-processado-para-reprocessar-em-lote',
            telaPesquisar: 'crd-consulta-esperado-processado-tela-pesquisar'
        };
    }
    EsperadoProcessadoApiServiceImpl.prototype.montarTelaPesquisa = function () {
        return this.apiService.get([this.API.raiz, this.API.telaPesquisar]);
    };
    EsperadoProcessadoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    EsperadoProcessadoApiServiceImpl.prototype.gerarXlsx = function (filtro) {
        return this.apiService.getFile([this.API.raiz, this.API.gerarXlsx], filtro);
    };
    EsperadoProcessadoApiServiceImpl.prototype.paraReprocessarEmLote = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.paraReprocessarEmLote], filtro);
    };
    return EsperadoProcessadoApiServiceImpl;
}());
EsperadoProcessadoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('EsperadoProcessadoApiService', EsperadoProcessadoApiServiceImpl);
//# sourceMappingURL=esperado-processado-api-service.js.map;
(function(angular) {
  'use strict';

  var API = {
    alterar: 'excecoes-alterar',
    consultar: 'excecoes-consultar',
    criar: 'excecoes-criar',
    desativar: 'excecoes-desativar',
    detalhar: 'excecoes-detalhar',
    gerarXLS: 'excecoes-gerar-xls',
    pesquisar: 'excecoes-pesquisar',
    raiz: 'excecoes-raiz',
    telaCriar: 'excecoes-tela-criar',
    telaPesquisar: 'excecoes-tela-pesquisar'
  };

  angular
    .module('crd')
    .factory('excecaoApiService', excecaoApiService);

  excecaoApiService.$inject = ['apiService'];

  function excecaoApiService(apiService) {
    var service = {
      alterar: alterar,
      consultar: consultar,
      criar: criar,
      desativar: desativar,
      detalhar: detalhar,
      gerarXLSX: gerarXLSX,
      pesquisar: pesquisar,
      telaCriar: telaCriar,
      telaPesquisar: telaPesquisar
    };

    return service;

    function alterar(pk, excecao) {
      var parameters = {
        id: pk
      };
      var payload = excecao;
      return apiService.post([API.raiz, API.alterar], parameters, payload);
    }

    function consultar(pk) {
      var parameters = {
        id: pk
      };
      return apiService.get([API.raiz, API.consultar], parameters);
    }

    function criar(excecao) {
      var parameters = null;
      var payload = excecao;
      return apiService.post([API.raiz, API.criar], parameters, payload);
    }

    function desativar(pk) {
      var parameters = {
        id: pk
      };
      var payload = {};
      return apiService.post([API.raiz, API.desativar], parameters, payload);
    }

    function detalhar(id) {
      var parameters = {
        id: id
      };
      return apiService.get([API.raiz, API.detalhar], parameters);
    }

    function gerarXLSX(parameters) {
      return apiService.getFile([API.raiz, API.gerarXLS], parameters);
    }

    function pesquisar(parameters) {
      return apiService.get([API.raiz, API.pesquisar], parameters);
    }

    function telaCriar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaCriar], parameters);
    }

    function telaPesquisar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }
  }
})(angular);
;
"use strict";
var ExcecaoQualidadeApiServiceImpl = (function () {
    function ExcecaoQualidadeApiServiceImpl(apiService, $http) {
        this.apiService = apiService;
        this.$http = $http;
        this.API = {
            alterar: 'crd-excecao-qualidade-alterar',
            incluir: 'crd-excecao-qualidade-criar',
            desativar: 'crd-excecao-qualidade-desativar',
            montarTelaDetalhe: 'crd-excecao-qualidade-detalhar',
            gerarExcel: 'crd-excecao-qualidade-gerar-xls',
            pesquisar: 'crd-excecao-qualidade-pesquisar',
            raiz: 'crd-excecao-qualidade-raiz',
            montarTelaIncluir: 'crd-excecao-qualidade-tela-criar',
            montarTelaPesquisa: 'crd-excecao-qualidade-tela-pesquisar'
        };
    }
    ExcecaoQualidadeApiServiceImpl.prototype.alterar = function (pk, excecao) {
        var parameters = {
            id: pk
        };
        var payload = excecao;
        return this.apiService.post([this.API.raiz, this.API.alterar], parameters, payload);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.incluir = function (excecao) {
        var parameters = null;
        var payload = excecao;
        return this.apiService.post([this.API.raiz, this.API.incluir], parameters, payload);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.desativar = function (pk) {
        var parameters = {
            id: pk
        };
        var payload = {};
        return this.apiService.post([this.API.raiz, this.API.desativar], parameters, payload);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.montarTelaDetalhe = function (id) {
        var parameters = {
            id: id
        };
        return this.apiService.get([this.API.raiz, this.API.montarTelaDetalhe], parameters);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.gerarExcel = function (parameters) {
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], parameters);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.pesquisar = function (parameters) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], parameters);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.montarTelaIncluir = function (parameters) {
        return this.apiService.get([this.API.raiz, this.API.montarTelaIncluir], parameters);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.montarTelaPesquisa = function () {
        var parameters = null;
        return this.apiService.get([this.API.raiz, this.API.montarTelaPesquisa], parameters);
    };
    ExcecaoQualidadeApiServiceImpl.prototype.pesquisarParaSelecao = function (filtro, ignoreLoadingBar) {
        return this.apiService.getHttp('/excecao-qualidade/pesquisar-para-selecao', { params: filtro, ignoreLoadingBar: ignoreLoadingBar });
    };
    return ExcecaoQualidadeApiServiceImpl;
}());
ExcecaoQualidadeApiServiceImpl.$inject = ['apiService', '$http'];
angular.module('crd').service('ExcecaoQualidadeApiService', ExcecaoQualidadeApiServiceImpl);
//# sourceMappingURL=excecao-qualidade-api-service.js.map;
(function(angular) {
  'use strict';

  var API = {
    pesquisarIdci: 'indice-desempenho-captacao-pesquisar',
    pesquisarIdciExcel: 'indice-desempenho-captacao-pesquisar-excel',
    pesquisarIdciMemoriaExcel: 'indice-desempenho-captacao-memoria-excel',
    raiz: 'indice-desempenho-captacao-raiz',
    tela: 'indice-desempenho-captacao-tela'
  };

  angular
    .module('crd')
    .factory('indiceDesempenhoCaptacaoApiService', indiceDesempenhoCaptacaoApiService);

  indiceDesempenhoCaptacaoApiService.$inject = ['apiService'];

  function indiceDesempenhoCaptacaoApiService(apiService) {
    var service = {
      pesquisarIdci: pesquisarIdci,
      pesquisarIdciExcel: pesquisarIdciExcel,
      pesquisarIdciMemoriaExcel: pesquisarIdciMemoriaExcel,
      raiz: raiz,
      tela: tela
    };

    return service;

    function pesquisarIdci(parameters) {
      return apiService.get([API.raiz, API.pesquisarIdci], parameters);
    }

    function raiz() {
      var parameters = null;
      return apiService.get([API.raiz], parameters);
    }

    function tela() {
      var parameters = null;
      return apiService.get([API.raiz, API.tela], parameters);
    }

    function pesquisarIdciExcel(parameters) {
      return apiService.getFile([API.raiz, API.pesquisarIdciExcel], parameters);
    }

    function pesquisarIdciMemoriaExcel(parameters) {
      return apiService.getFile([API.raiz, API.pesquisarIdciMemoriaExcel], parameters);
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  var API = {
    pesquisarIdfi: 'indice-desempenho-fornecedores-pesquisar',
    pesquisarIdfiExcel: 'indice-desempenho-fornecedores-pesquisar-excel',
    pesquisarIdfiMemoriaExcel: 'indice-desempenho-fornecedores-memoria-excel',
    raiz: 'indice-desempenho-fornecedores-raiz',
    telaPesquisar: 'indice-desempenho-fornecedores-tela-pesquisar'
  };

  angular
    .module('crd')
    .factory('indiceDesempenhoFornecedoresApiService', indiceDesempenhoFornecedoresApiService);

  indiceDesempenhoFornecedoresApiService.$inject = ['apiService'];

  function indiceDesempenhoFornecedoresApiService(apiService) {
    var service = {
      pesquisarIdfi: pesquisarIdfi,
      pesquisarIdfiExcel: pesquisarIdfiExcel,
      pesquisarIdfiMemoriaExcel: pesquisarIdfiMemoriaExcel,
      telaPesquisar: telaPesquisar
    };

    return service;

    function pesquisarIdfi(parameters) {
      return apiService.get([API.raiz, API.pesquisarIdfi], parameters);
    }

    function telaPesquisar() {
      var parameters = null;
      return apiService.get([API.raiz, API.telaPesquisar], parameters);
    }

    function pesquisarIdfiExcel(parameters) {
      return apiService.getFile([API.raiz, API.pesquisarIdfiExcel], parameters);
    }

    function pesquisarIdfiMemoriaExcel(parameters) {
      return apiService.getFile([API.raiz, API.pesquisarIdfiMemoriaExcel], parameters);
    }
  }
})(angular);
;
"use strict";
var IndiceQualidadeFornecimentoApiServiceImpl = (function () {
    function IndiceQualidadeFornecimentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API_IQFI = {
            pesquisar: 'indice-qualidade-fornecimento-pesquisar',
            raiz: 'indice-qualidade-fornecimento-raiz',
            telaPesquisar: 'indice-qualidade-fornecimento-montar-pesquisar',
            telaDetalhePesquisar: 'indice-qualidade-fornecimento-tela-detalhe-pesquisar',
            gerarXlsx: 'indice-qualidade-fornecimento-gerar-xlsx',
            pesquisarIqfiDetalheInstituicao: 'indice-qualidade-fornecimento-pesquisar-detalhe-instituicao',
            pesquisarIqfiDetalheInstituicaoExcel: 'indice-qualidade-fornecimento-pesquisar-detalhe-instituicao-excel',
            pesquisarIqfiDetalheConglomerado: 'indice-qualidade-fornecimento-pesquisar-detalhe-conglomerado',
            pesquisarIqfiDetalheConglomeradoExcel: 'indice-qualidade-fornecimento-pesquisar-detalhe-conglomerado-excel',
            pesquisarIqfiMemoriaExcel: 'indice-qualidade-fornecimento-memoria-excel'
        };
    }
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.montarTelaPesquisar = function () {
        return this.apiService.get([this.API_IQFI.raiz, this.API_IQFI.telaPesquisar]);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API_IQFI.raiz, this.API_IQFI.pesquisar], filtro);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.pesquisarIqfiDetalheConglomerado = function (parameters) {
        return this.apiService.get([this.API_IQFI.raiz, this.API_IQFI.pesquisarIqfiDetalheConglomerado], parameters);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.pesquisarIqfiDetalheConglomeradoExcel = function (parameters) {
        return this.apiService.getFile([this.API_IQFI.raiz, this.API_IQFI.pesquisarIqfiDetalheConglomeradoExcel], parameters);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.pesquisarIqfiDetalheInstituicao = function (parameters) {
        return this.apiService.get([this.API_IQFI.raiz, this.API_IQFI.pesquisarIqfiDetalheInstituicao], parameters);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.pesquisarIqfiDetalheInstituicaoExcel = function (parameters) {
        return this.apiService.getFile([this.API_IQFI.raiz, this.API_IQFI.pesquisarIqfiDetalheInstituicaoExcel], parameters);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.telaDetalhePesquisar = function (parameters) {
        return this.apiService.get([this.API_IQFI.raiz, this.API_IQFI.telaDetalhePesquisar], parameters);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.gerarXlsx = function (filtro) {
        return this.apiService.getFile([this.API_IQFI.raiz, this.API_IQFI.gerarXlsx], filtro);
    };
    IndiceQualidadeFornecimentoApiServiceImpl.prototype.pesquisarIqfiMemoriaExcel = function (pk) {
        var parameters = {
            iqfi: pk
        };
        return this.apiService.getFile([this.API_IQFI.raiz, this.API_IQFI.pesquisarIqfiMemoriaExcel], parameters);
    };
    return IndiceQualidadeFornecimentoApiServiceImpl;
}());
IndiceQualidadeFornecimentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('indiceQualidadeFornecimentoApiService', IndiceQualidadeFornecimentoApiServiceImpl);
//# sourceMappingURL=indice-qualidade-fornecimento-api-service.js.map;
"use strict";
var IndiceRegularidadeFornecimentoApiServiceImpl = (function () {
    function IndiceRegularidadeFornecimentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API_IRFI = {
            pesquisar: 'indice-regularidade-fornecimento-pesquisar',
            raiz: 'indice-regularidade-fornecimento-raiz',
            telaPesquisar: 'indice-regularidade-fornecimento-tela-pesquisar',
            telaDetalhePesquisar: 'indice-regularidade-fornecimento-tela-detalhe-pesquisar',
            gerarXlsx: 'indice-regularidade-fornecimento-pesquisar-excel',
            pesquisarIrfiDetalheInstituicao: 'indice-regularidade-fornecimento-pesquisar-es',
            pesquisarIrfiDetalheInstituicaoExcel: 'indice-regularidade-fornecimento-pesquisar-es-excel',
            pesquisarIrfiDetalheConglomerado: 'indice-regularidade-fornecimento-pesquisar-conglomerado',
            pesquisarIrfiDetalheConglomeradoExcel: 'indice-regularidade-fornecimento-pesquisar-conglomerado-excel',
            pesquisarIrfiMemoriaExcel: 'indice-regularidade-fornecimento-memoria-excel'
        };
    }
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.montarTelaPesquisar = function () {
        return this.apiService.get([this.API_IRFI.raiz, this.API_IRFI.telaPesquisar]);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API_IRFI.raiz, this.API_IRFI.pesquisar], filtro);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.pesquisarIrfiDetalheConglomerado = function (parameters) {
        return this.apiService.get([this.API_IRFI.raiz, this.API_IRFI.pesquisarIrfiDetalheConglomerado], parameters);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.pesquisarIrfiDetalheConglomeradoExcel = function (parameters) {
        return this.apiService.getFile([this.API_IRFI.raiz, this.API_IRFI.pesquisarIrfiDetalheConglomeradoExcel], parameters);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.pesquisarIrfiDetalheInstituicao = function (parameters) {
        return this.apiService.get([this.API_IRFI.raiz, this.API_IRFI.pesquisarIrfiDetalheInstituicao], parameters);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.pesquisarIrfiDetalheInstituicaoExcel = function (parameters) {
        return this.apiService.getFile([this.API_IRFI.raiz, this.API_IRFI.pesquisarIrfiDetalheInstituicaoExcel], parameters);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.telaDetalhePesquisar = function (parameters) {
        return this.apiService.get([this.API_IRFI.raiz, this.API_IRFI.telaDetalhePesquisar], parameters);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.gerarXlsx = function (filtro) {
        return this.apiService.getFile([this.API_IRFI.raiz, this.API_IRFI.gerarXlsx], filtro);
    };
    IndiceRegularidadeFornecimentoApiServiceImpl.prototype.pesquisarIrfiMemoriaExcel = function (pk) {
        var parameters = {
            irfi: pk
        };
        return this.apiService.getFile([this.API_IRFI.raiz, this.API_IRFI.pesquisarIrfiMemoriaExcel], parameters);
    };
    return IndiceRegularidadeFornecimentoApiServiceImpl;
}());
IndiceRegularidadeFornecimentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('indiceRegularidadeFornecimentoApiService', IndiceRegularidadeFornecimentoApiServiceImpl);
//# sourceMappingURL=indice-regularidade-fornecimento-api-service.js.map;
"use strict";
//# sourceMappingURL=indicio-qualidade-api-service.js.map;
"use strict";
var InformacaoCadastralDocumentoApiServiceImpl = (function () {
    function InformacaoCadastralDocumentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            alterar: 'crd-informacao-cadastral-documento-alterar',
            criar: 'crd-informacao-cadastral-documento-criar',
            excluir: 'crd-informacao-cadastral-documento-excluir',
            pesquisar: 'crd-informacao-cadastral-documento-pesquisar',
            raiz: 'crd-informacao-cadastral-documento-raiz'
        };
    }
    InformacaoCadastralDocumentoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    InformacaoCadastralDocumentoApiServiceImpl.prototype.alterar = function (pk, informacaoCadastralDocumento) {
        return this.apiService.post([this.API.raiz, this.API.alterar], { pk: pk }, informacaoCadastralDocumento);
    };
    InformacaoCadastralDocumentoApiServiceImpl.prototype.criar = function (informacaoCadastralDocumento) {
        return this.apiService.post([this.API.raiz, this.API.criar], {}, informacaoCadastralDocumento);
    };
    InformacaoCadastralDocumentoApiServiceImpl.prototype.excluir = function (pk) {
        return this.apiService.post([this.API.raiz, this.API.excluir], { pk: pk });
    };
    return InformacaoCadastralDocumentoApiServiceImpl;
}());
InformacaoCadastralDocumentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('InformacaoCadastralDocumentoApiService', InformacaoCadastralDocumentoApiServiceImpl);
//# sourceMappingURL=informacao-cadastral-documento-api-service.js.map;
(function(angular, _) {
  'use strict';

  var API = {
    buscarPorIdBacen: 'instituicoes-por-idbacen',
    pesquisar: 'instituicoes-pesquisar',
    buscarEmailDoServidor: 'buscar-opcoes-para-selecao-email-servidor',
    incluir: 'instituicoes-incluir',
    raiz: 'instituicoes-raiz',
    consultaServidoresRaiz: 'crd-consulta-servidores-raiz'
  };

  angular
    .module('crd')
    .factory('instituicaoApiService', instituicaoApiService);

  instituicaoApiService.$inject = ['$q', 'apiService', 'instituicaoStorageService'];

  function instituicaoApiService($q, apiService, instituicaoStorageService) {
    var service = {
      pesquisar: pesquisar,
      carregar: carregar,
      incluir: incluir
    };

    return service;

    function carregar(idBacen) {
      var deferred = $q.defer();
      if (instituicaoStorageService.exist(idBacen)) {
        deferred.resolve(instituicaoStorageService.getByIdBacen(idBacen));
      } else {
        var parameters = {
          idBacen: idBacen
        };

        apiService
          .get([API.raiz, API.buscarPorIdBacen], parameters)
          .then(successOnBuscarPorIdBacen, errorOnBuscarPorIdBacen);
      }

      return deferred.promise;

      function successOnBuscarPorIdBacen(resource) {
        instituicaoStorageService.add(resource);
        deferred.resolve(resource);
      }

      function errorOnBuscarPorIdBacen(response) {
        deferred.reject(response);
      }
    }

    function pesquisar(filtro) {
      return apiService
        .get([API.raiz, API.pesquisar], filtro);
    }

    function incluir(idBacen) {
      var payload = {
        idBacen: idBacen
      };

      return apiService.post([API.raiz, API.incluir], null, payload);
    }
  }
})(angular, _);
;
"use strict";
var LeiauteDocumentoApiServiceImpl = (function () {
    function LeiauteDocumentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            pesquisar: 'crd-leiaute-documento-pesquisar',
            raiz: 'crd-leiaute-documento-raiz'
        };
    }
    LeiauteDocumentoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    LeiauteDocumentoApiServiceImpl.prototype.paraIncluir = function (documento) {
        return this.apiService.get([this.API.raiz, 'crd-leiaute-documento-formulario'], { documento: documento });
    };
    LeiauteDocumentoApiServiceImpl.prototype.detalhar = function (documento, pk) {
        return this.apiService.get([this.API.raiz, 'crd-leiaute-documento-detalhar'], { documento: documento, pk: pk });
    };
    LeiauteDocumentoApiServiceImpl.prototype.paraAlterar = function (documento, pk) {
        return this.apiService.get([this.API.raiz, 'crd-leiaute-documento-para-alterar'], { documento: documento, pk: pk });
    };
    LeiauteDocumentoApiServiceImpl.prototype.incluir = function (documento, dados) {
        return this.apiService.post([this.API.raiz, 'crd-leiaute-documento-incluir'], { documento: documento }, this.prepararDados(dados));
    };
    LeiauteDocumentoApiServiceImpl.prototype.alterar = function (documento, pk, dados) {
        return this.apiService.post([this.API.raiz, 'crd-leiaute-documento-alterar'], { documento: documento, pk: pk }, this.prepararDados(dados));
    };
    LeiauteDocumentoApiServiceImpl.prototype.excluir = function (documento, pk) {
        return this.apiService.post([this.API.raiz, 'crd-leiaute-documento-excluir'], { documento: documento, pk: pk });
    };
    LeiauteDocumentoApiServiceImpl.prototype.prepararDados = function (dados) {
        return {
            documento: dados.documento,
            descricao: dados.descricao,
            textoExplicativo: dados.textoExplicativo,
            vigenciaInicio: ConverterParameterObjectToUrlUtils.date(dados.vigenciaInicio),
            vigenciaFim: ConverterParameterObjectToUrlUtils.date(dados.vigenciaFim),
            caminhoArquivoXSD: dados.caminhoArquivoXSD,
            localizacaoData: dados.localizacaoData
        };
    };
    return LeiauteDocumentoApiServiceImpl;
}());
LeiauteDocumentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('LeiauteDocumentoApiService', LeiauteDocumentoApiServiceImpl);
//# sourceMappingURL=leiaute-documento-api-service.js.map;
"use strict";
var NormativoDocumentoApiServiceImpl = (function () {
    function NormativoDocumentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            alterar: 'crd-normativo-documento-alterar',
            criar: 'crd-normativo-documento-criar',
            excluir: 'crd-normativo-documento-excluir',
            pesquisar: 'crd-normativo-documento-pesquisar',
            raiz: 'crd-normativo-documento-raiz'
        };
    }
    NormativoDocumentoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    NormativoDocumentoApiServiceImpl.prototype.alterar = function (pk, normativoDocumento) {
        return this.apiService.post([this.API.raiz, this.API.alterar], { pk: pk }, normativoDocumento);
    };
    NormativoDocumentoApiServiceImpl.prototype.criar = function (normativoDocumento) {
        return this.apiService.post([this.API.raiz, this.API.criar], {}, normativoDocumento);
    };
    NormativoDocumentoApiServiceImpl.prototype.excluir = function (pk) {
        return this.apiService.post([this.API.raiz, this.API.excluir], { pk: pk });
    };
    return NormativoDocumentoApiServiceImpl;
}());
NormativoDocumentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('NormativoDocumentoApiService', NormativoDocumentoApiServiceImpl);
//# sourceMappingURL=normativo-documento-api-service.js.map;
"use strict";
var PainelAuditoriaObservanciaServiceImpl = (function () {
    function PainelAuditoriaObservanciaServiceImpl(apiService) {
        this.apiService = apiService;
        this.API_PAINEL = {
            montarPainel: 'painel-auditoria-observancia-montar-painel',
            raiz: 'painel-auditoria-observancia-raiz'
        };
    }
    PainelAuditoriaObservanciaServiceImpl.prototype.montarPainel = function (idbacen) {
        var parameters = {
            idbacen: idbacen
        };
        return this.apiService.get([this.API_PAINEL.raiz, this.API_PAINEL.montarPainel], parameters);
    };
    return PainelAuditoriaObservanciaServiceImpl;
}());
PainelAuditoriaObservanciaServiceImpl.$inject = ['apiService'];
;
angular.module('crd').service('PainelAuditoriaObservanciaApiService', PainelAuditoriaObservanciaServiceImpl);
//# sourceMappingURL=painel-auditoria-observancia-service.js.map;
"use strict";
var ParametrosCobrancaApiServiceImpl = (function () {
    function ParametrosCobrancaApiServiceImpl(apiService, $http) {
        this.apiService = apiService;
        this.$http = $http;
        this.API = {
            detalhar: 'parametros-cobranca-detalhar',
            pesquisar: 'parametros-cobranca-pesquisar',
            montarTelaIncluir: 'parametros-cobranca-montar-tela-incluir',
            montarTeladetalhar: 'parametros-cobranca-montar-tela-alterar',
            incluir: 'parametros-cobranca-criar',
            alterar: 'parametros-cobranca-alterar',
            excluir: 'parametros-cobranca-excluir',
            raiz: 'parametros-cobranca-raiz'
        };
    }
    ParametrosCobrancaApiServiceImpl.prototype.detalhar = function (id) {
        var parameters = {
            id: id
        };
        return this.apiService.get([this.API.raiz, this.API.detalhar], parameters);
    };
    ParametrosCobrancaApiServiceImpl.prototype.incluir = function (parametroCobranca) {
        var parameters = null;
        var payload = parametroCobranca;
        return this.apiService.post([this.API.raiz, this.API.incluir], { type: 'application/json;charset=UTF-8' }, payload);
    };
    ParametrosCobrancaApiServiceImpl.prototype.alterar = function (id, parametroCobranca) {
        var parameters = {
            id: id
        };
        var payload = parametroCobranca;
        return this.apiService.post([this.API.raiz, this.API.alterar], parameters, payload);
    };
    ParametrosCobrancaApiServiceImpl.prototype.excluir = function (id) {
        var parameters = {
            id: id
        };
        var payload = {};
        return this.apiService.post([this.API.raiz, this.API.excluir], parameters, payload);
    };
    ParametrosCobrancaApiServiceImpl.prototype.pesquisar = function (parameters) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], parameters);
    };
    ParametrosCobrancaApiServiceImpl.prototype.montarTelaIncluir = function (id) {
        var parameters = {
            id: id
        };
        return this.apiService.get([this.API.raiz, this.API.montarTelaIncluir], parameters);
    };
    ParametrosCobrancaApiServiceImpl.prototype.montarTeladetalhar = function (id) {
        var parameters = {
            id: id
        };
        return this.apiService.get([this.API.raiz, this.API.montarTeladetalhar], parameters);
    };
    return ParametrosCobrancaApiServiceImpl;
}());
ParametrosCobrancaApiServiceImpl.$inject = ['apiService', '$http'];
angular.module('crd').service('ParametrosCobrancaApiService', ParametrosCobrancaApiServiceImpl);
//# sourceMappingURL=parametros-cobranca-api-service.js.map;
"use strict";
var PortaLateralQualidadeApiServiceImpl = (function () {
    function PortaLateralQualidadeApiServiceImpl($http, apiService) {
        this.$http = $http;
        this.apiService = apiService;
        this.API = {
            gerarExcel: 'crd-porta-lateral-qualidade-gerar-excel',
            importar: 'crd-porta-lateral-qualidade-importar',
            montarTelaImportacao: 'crd-porta-lateral-qualidade-montar-tela-importacao',
            raiz: 'crd-porta-lateral-qualidade-raiz'
        };
        this.CONFIG_COM_ARQUIVO = {
            cache: false,
            contentType: false,
            headers: {
                'Accept': 'application/json, multipart/form-data, */*',
                'Content-Type': undefined
            },
            processData: false
        };
    }
    PortaLateralQualidadeApiServiceImpl.prototype.gerarExcel = function () {
        var parameters = null;
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], parameters);
    };
    PortaLateralQualidadeApiServiceImpl.prototype.importar = function (url, arquivo) {
        var payload = new FormData();
        payload.append('arquivo', arquivo);
        return this.$http.post(url, payload, this.CONFIG_COM_ARQUIVO);
    };
    PortaLateralQualidadeApiServiceImpl.prototype.montarTelaImportacao = function () {
        var parameters = null;
        return this.apiService.get([this.API.raiz, this.API.montarTelaImportacao], parameters);
    };
    return PortaLateralQualidadeApiServiceImpl;
}());
PortaLateralQualidadeApiServiceImpl.$inject = ['$http', 'apiService'];
angular.module('crd').service('PortaLateralQualidadeApiService', PortaLateralQualidadeApiServiceImpl);
//# sourceMappingURL=porta-lateral-qualidade-api-service.js.map;
"use strict";
var PortaLateralTempestividadeApiServiceImpl = (function () {
    function PortaLateralTempestividadeApiServiceImpl($http, apiService) {
        this.$http = $http;
        this.apiService = apiService;
        this.API = {
            gerarExcel: 'crd-porta-lateral-tempestividade-gerar-excel',
            importar: 'crd-porta-lateral-tempestividade-importar',
            montarTelaImportacao: 'crd-porta-lateral-tempestividade-montar-tela-importacao',
            raiz: 'crd-porta-lateral-tempestividade-raiz'
        };
        this.CONFIG_COM_ARQUIVO = {
            cache: false,
            contentType: false,
            headers: {
                'Accept': 'application/json, multipart/form-data, */*',
                'Content-Type': undefined
            },
            processData: false
        };
    }
    PortaLateralTempestividadeApiServiceImpl.prototype.gerarExcel = function () {
        var parameters = null;
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], parameters);
    };
    PortaLateralTempestividadeApiServiceImpl.prototype.importar = function (url, arquivo) {
        var payload = new FormData();
        payload.append('arquivo', arquivo);
        return this.$http.post(url, payload, this.CONFIG_COM_ARQUIVO);
    };
    PortaLateralTempestividadeApiServiceImpl.prototype.montarTelaImportacao = function () {
        var parameters = null;
        return this.apiService.get([this.API.raiz, this.API.montarTelaImportacao], parameters);
    };
    return PortaLateralTempestividadeApiServiceImpl;
}());
PortaLateralTempestividadeApiServiceImpl.$inject = ['$http', 'apiService'];
angular.module('crd').service('PortaLateralTempestividadeApiService', PortaLateralTempestividadeApiServiceImpl);
//# sourceMappingURL=porta-lateral-tempestividade-api-service.js.map;
"use strict";
var ResponsavelDocumentoApiServiceImpl = (function () {
    function ResponsavelDocumentoApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            alterar: 'crd-responsavel-documento-alterar',
            criar: 'crd-responsavel-documento-criar',
            excluir: 'crd-responsavel-documento-excluir',
            pesquisar: 'crd-responsavel-documento-pesquisar',
            raiz: 'crd-responsavel-documento-raiz',
            todosResponsaveis: 'crd-responsavel-documento-todos-responsaveis-pelo-envio-de-informacoes'
        };
    }
    ResponsavelDocumentoApiServiceImpl.prototype.alterar = function (pk, responsavelDocumento) {
        return this.apiService.post([this.API.raiz, this.API.alterar], { pk: pk }, responsavelDocumento);
    };
    ResponsavelDocumentoApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    ResponsavelDocumentoApiServiceImpl.prototype.criar = function (responsavelDocumento) {
        return this.apiService.post([this.API.raiz, this.API.criar], {}, responsavelDocumento);
    };
    ResponsavelDocumentoApiServiceImpl.prototype.excluir = function (pk) {
        return this.apiService.post([this.API.raiz, this.API.excluir], { pk: pk });
    };
    ResponsavelDocumentoApiServiceImpl.prototype.todosResponsaveisPeloEnvioDeInformacoes = function () {
        return this.apiService.get([this.API.raiz, this.API.todosResponsaveis]);
    };
    return ResponsavelDocumentoApiServiceImpl;
}());
ResponsavelDocumentoApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('ResponsavelDocumentoApiService', ResponsavelDocumentoApiServiceImpl);
//# sourceMappingURL=responsavel-documento-api-service.js.map;
(function(angular) {
  'use strict';

  var API = {
    buscarPorCodigo: 'segmentos-por-codigo',
    buscarTodos: 'segmentos-todos',
    buscarPorCritica: 'segmentos-por-critica',
    raiz: 'segmentos-raiz'
  };

  angular
    .module('crd')
    .factory('segmentoApiService', segmentoApiService);

  segmentoApiService.$inject = ['$q', 'apiService', 'segmentoStorageService'];

  function segmentoApiService($q, apiService, segmentoStorageService) {
    var service = {
      buscarPorCodigo: buscarPorCodigo,
      buscarTodos: buscarTodos,
      buscarPorCritica: buscarPorCritica,
      pesquisarParaSelecao: pesquisarParaSelecao
    };

    return service;

    function pesquisarParaSelecao(filtro, ignoreLoadingBar) {
      return apiService.getHttp('/segmento/pesquisar-para-selecao', { params: filtro, ignoreLoadingBar: ignoreLoadingBar})
    }

    function buscarTodos() {
      var deferred = $q.defer();

      inicializarStorage().then(function() {
        var segmentos = segmentoStorageService.getAll();
        deferred.resolve(segmentos);
      });

      return deferred.promise;
    }

    function buscarPorCodigo(codigo) {
      var deferred = $q.defer();

      inicializarStorage().then(function() {
        var segmentos = segmentoStorageService.findByCodigo(codigo);
        deferred.resolve(segmentos);
      });

      return deferred.promise;
    }

    function buscarPorCritica(criticaPk) {
      return apiService.get([API.raiz, API.buscarPorCritica], { pk: criticaPk });
    }

    function inicializarStorage() {
      var deferred = $q.defer();
      if (segmentoStorageService.inicializado()) {
        deferred.resolve();
      } else {
        apiService
          .get([API.raiz, API.buscarTodos], null)
          .then(function(resource) {
            var resultado = resource._embedded.resultado;
            segmentoStorageService.limpar();
            segmentoStorageService.addAll(resultado);
            deferred.resolve();
          });
      }

      return deferred.promise;
    }
  }
})(angular);
;
(function(angular) {
  'use strict';
  angular
    .module('crd')
    .factory('sistemaNegocioApiService', sistemaNegocioApiService);

  sistemaNegocioApiService.$inject = ['apiService'];

  function sistemaNegocioApiService(apiService) {
    var service = {
      pesquisarParaSelecao: pesquisarParaSelecao,
      obterComDocsAtivosPeriodicidadeDiferenteMenorDiaria: obterComDocsAtivosPeriodicidadeDiferenteMenorDiaria
    };

    return service;

    function obterComDocsAtivosPeriodicidadeDiferenteMenorDiaria() {
      return apiService.getHttp('/sistema-negocio/obter-com-docs-ativos-periodicidade-diferente-menor-diaria', {});
    }

    function pesquisarParaSelecao(filtro, ignoreLoadingBar) {
      return apiService.getHttp('/sistema-negocio/pesquisar-para-selecao', { params: filtro, ignoreLoadingBar: ignoreLoadingBar});
    }
  }
})(angular);
;
"use strict";
var SituacaoMonitoradaApiServiceImpl = (function () {
    function SituacaoMonitoradaApiServiceImpl(apiService) {
        this.apiService = apiService;
        this.API = {
            raiz: 'crd-situacao-monitorada-raiz',
            pesquisar: 'crd-situacao-monitorada-pesquisar',
            gerarExcel: 'crd-situacao-monitorada-pesquisar-excel',
            montarTelaPesquisa: 'crd-situacao-monitorada-montar-tela-pesquisa',
            montarTelaDetalhe: 'crd-situacao-monitorada-detalhar'
        };
    }
    SituacaoMonitoradaApiServiceImpl.prototype.pesquisar = function (filtro) {
        return this.apiService.get([this.API.raiz, this.API.pesquisar], filtro);
    };
    SituacaoMonitoradaApiServiceImpl.prototype.montarTelaPesquisa = function () {
        return this.apiService.get([this.API.raiz, this.API.montarTelaPesquisa]);
    };
    SituacaoMonitoradaApiServiceImpl.prototype.gerarExcel = function (filtro) {
        return this.apiService.getFile([this.API.raiz, this.API.gerarExcel], filtro);
    };
    SituacaoMonitoradaApiServiceImpl.prototype.montarTelaDetalhe = function (campoPk, criticaPk, database, instituicao, documentoPk) {
        var parameters = {
            campoPk: campoPk,
            criticaPk: criticaPk,
            database: database,
            instituicao: instituicao,
            documentoPk: documentoPk
        };
        return this.apiService.get([this.API.raiz, this.API.montarTelaDetalhe], parameters);
    };
    return SituacaoMonitoradaApiServiceImpl;
}());
SituacaoMonitoradaApiServiceImpl.$inject = ['apiService'];
angular.module('crd').service('SituacaoMonitoradaApiService', SituacaoMonitoradaApiServiceImpl);
//# sourceMappingURL=situacao-monitorada-qualidade-api-service.js.map;
"use strict";
var DataTablesConfigurationImpl = (function () {
    function DataTablesConfigurationImpl($compile, DTColumnBuilder, DTOptionsBuilder) {
        this.$compile = $compile;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTOptionsBuilder = DTOptionsBuilder;
    }
    DataTablesConfigurationImpl.prototype.columnAcoesBuilder = function (fn) {
        return this.columnBuilder(null).withClass('coluna-acoes').renderWith(fn);
    };
    DataTablesConfigurationImpl.prototype.columnBuilder = function (property, ordenacaoCampo) {
        var _this = this;
        var columnBuilder = this.DTColumnBuilder
            .newColumn(property)
            .withOption('ordenacaoCampo', ordenacaoCampo)
            .withClass('text-left');
        columnBuilder.visible = function (visible) {
            columnBuilder.bVisible = visible;
            return _this;
        };
        columnBuilder.sortable = function (sortable) {
            columnBuilder.bSortable = sortable;
            return _this;
        };
        columnBuilder.tooltip = function (fn) {
            columnBuilder.withOption('createdCell', function (td, cellData, rowData, row, col) {
                var value = fn(rowData);
                if (value) {
                    $(td).attr('title', value);
                }
            });
            return _this;
        };
        columnBuilder.sortable(!!ordenacaoCampo);
        return columnBuilder;
    };
    DataTablesConfigurationImpl.prototype.optionsBuilder = function (config, realizarPesquisa) {
        var _this = this;
        var optionsBuilder = this.DTOptionsBuilder.newOptions()
            .withOption('processing', false)
            .withOption('searching', false)
            .withOption('stateSave', false)
            .withOption('deferRender', false)
            .withOption('deferLoading', config.trazerResultadoInicial ? null : 0)
            .withOption('serverSide', true)
            .withDataProp('content')
            .withFnServerData(function (sSource, aoData, fnCallback, oSettings) {
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = draw === 1 ? 0 : aoData[3].value;
            var length = aoData[4].value;
            var search = aoData[5].value;
            var paginacao = {
                numeroPagina: start / length,
                quantidadePorPagina: length,
                ordenacaoCampo: order && order[0] ? oSettings.aoColumns[order[0].column].ordenacaoCampo : null,
                ordenacaoDirecao: order && order[0] ? order[0].dir : null
            };
            realizarPesquisa(paginacao).then(function (resultado) {
                optionsBuilder.withOption('deferLoading', null);
                fnCallback({
                    content: resultado._embedded.content,
                    draw: draw,
                    recordsFiltered: resultado._embedded.totalElements,
                    recordsTotal: resultado._embedded.totalElements
                });
                return resultado;
            })["finally"](function () {
                config.scope.$safeApply();
            });
        })
            .withOption('createdRow', function (row, data, dataIndex) {
            var rowContent = angular.element(row);
            _.forEach(rowContent.find('td'), function (coloumn) {
                coloumn.innerHTML = coloumn.innerHTML === 'null' ? '' : coloumn.innerHTML;
            });
            _this.$compile(rowContent)(config.scope);
        });
        if (config.filtro.ordenacaoCampo) {
            var ordenacaoCampo_1 = config.filtro.ordenacaoCampo;
            var ordenacaoCampoIndex = _.findIndex(config.columns, function (column) { return column.ordenacaoCampo === ordenacaoCampo_1; });
            var ordenacaoDirecao = config.filtro.ordenacaoDirecao;
            optionsBuilder.withOption('order', ordenacaoCampoIndex ? [ordenacaoCampoIndex, ordenacaoDirecao] : null);
        }
        if (config.filtro.quantidadePorPagina) {
            optionsBuilder.withDisplayLength(config.filtro.quantidadePorPagina);
        }
        if (config.filtro.numeroPagina) {
            var numeroPaginaInicial = config.filtro.numeroPagina && config.filtro.quantidadePorPagina
                ? config.filtro.numeroPagina * config.filtro.quantidadePorPagina
                : 0;
            optionsBuilder.withOption('iDisplayStart', numeroPaginaInicial);
        }
        return optionsBuilder;
    };
    DataTablesConfigurationImpl.prototype.reloadData = function (configDTInstance) {
        configDTInstance.DataTable.page('first');
        configDTInstance.DataTable.draw('full-reset');
        configDTInstance.rerender();
    };
    return DataTablesConfigurationImpl;
}());
DataTablesConfigurationImpl.$inject = ['$compile', 'DTColumnBuilder', 'DTOptionsBuilder'];
angular.module('crd').service('DataTablesConfiguration', DataTablesConfigurationImpl);
//# sourceMappingURL=data-tables-configuration-service.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .factory('downloadFileService', downloadFileService);

  downloadFileService.$inject = ['$http', 'Blob', 'FileSaver'];

  function downloadFileService($http, Blob, FileSaver) {
    var service = {
      getFile: getFile
    };

    return service;

    function prepararParaDownload(response, defaultFileName) {
      var filename = defaultFileName || 'resultado';
      var type = response.headers('Content-Type');
      var disposition = response.headers('Content-Disposition');
      if (disposition) {
        var match = disposition.match(/filename="?([^;"]+)"?/);
        if (match[1]) {
          filename = match[1];
        }
      }
      filename = filename.replace(/[<>:"\/\\|?*]+/g, '_');
      var blob = new Blob([response.data], {
        type: type
      });
      FileSaver.saveAs(blob, filename);
    }

    function getFile(url, defaultFileName) {
      return $http.get(url, {
        responseType: 'arraybuffer'
      }).then(successOnDownload);

      function successOnDownload(response) {
        prepararParaDownload(response, defaultFileName);
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .factory('extrairDocumentoMenorPeriodicidadeService', extrairDocumentoMenorPeriodicidadeService);

  extrairDocumentoMenorPeriodicidadeService.$inject = ['$q', 'documentoApiService'];

  var VALOR_MAXIMO = 999999999;

  function extrairDocumentoMenorPeriodicidadeService($q, documentoApiService) {
    return function(documento) {
      var deferred = $q.defer();

      if (angular.isArray(documento)) {
        getDocumentoMenorPeriodicidade(documento, deferred);
      } else if (angular.isObject(documento)) {
        documentoApiService.recuperar(documento.pk).then(function(data) {
          deferred.resolve(data);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    };

    function getDocumentoMenorPeriodicidade(documentos, deferred) {
      var allDocPromeses = _.map(documentos, function(documento) {
        return documentoApiService.recuperar(documento.pk);
      });

      $q.all(allDocPromeses).then(function(documentosFull) {
        deferred.resolve(getMenorPeriodicidade(documentosFull));
      });
    }

    function getMenorPeriodicidade(documentos) {
      var menorPeriodicidade = VALOR_MAXIMO;
      var documentoMenor = null;
      _.forEach(documentos, function(documento) {
        if(!documento){
          return;
        }
        var periodicidade = documento.menorPeriodicidade;
        if (periodicidade.codigo < menorPeriodicidade) {
          menorPeriodicidade = periodicidade.codigo;
          documentoMenor = documento;
        }
      });

      return documentoMenor;
    }
  }
})(angular);
;
(function(angular, FormatoData) {
  'use strict';

  angular
    .module('crd')
    .factory('periodicidadeService', periodicidadeService);

  periodicidadeService.$inject = ['$filter'];

  function periodicidadeService($filter) {
    var OPCAO_PADRAO = FormatoData.DIARIA;
    var extrairDocumentoMenorPeriodicidade = $filter('extrairDocumentoMenorPeriodicidade');

    var service = {
      formatoData: formatoData
    };

    return service;

    function formatoData(documento) {
      var periodicidade;
      var documentoMenorPeriodicidade = extrairDocumentoMenorPeriodicidade(documento);

      if (documentoMenorPeriodicidade) {
        periodicidade = documentoMenorPeriodicidade.menorPeriodicidade;
      }

      if (!periodicidade) {
        return OPCAO_PADRAO;
      }
      return FormatoData.findCodigo(periodicidade.codigo);
    }
  }
})(angular, CRDUtils.FormatoData);
;
(function(angular, localStorage, s) {
  'use strict';

  var DATA_TABLES_PREFIX = 'DataTables';

  angular
    .module('crd')
    .factory('dataTablesStorageService', dataTablesStorageService);

  function dataTablesStorageService() {
    var service = {
      limpar: limpar
    };

    return service;

    function limpar() {
      for (var key in localStorage) {
        if (s.startsWith(key, DATA_TABLES_PREFIX)) {
          localStorage.removeItem(key);
        }
      }
    }
  }
})(angular, localStorage, s);
;
(function(angular, moment, _) {
  'use strict';

  var DURACAO_STORAGE_EM_DIAS = 1;
  var NAO_EXISTE = -1;

  angular
    .module('crd')
    .factory('documentoStorageService', documentoStorageService);

  documentoStorageService.$inject = ['$localStorage'];

  function documentoStorageService($localStorage) {
    $localStorage.$default({
      documento: {
        create: agora(),
        values: []
      }
    });
    var service = {
      add: add,
      addAll: addAll,
      findAtivosBySistemaNegocioPk: findAtivosBySistemaNegocioPk,
      findBySistemaNegocioPk: findBySistemaNegocioPk,
      findBySistemasNegocioPk: findBySistemasNegocioPk,
      getAll: getAll,
      getByCodigo: getByCodigo,
      getByPk: getByPk,
      inicializado: inicializado,
      limpar: limpar
    };

    ativar();

    return service;

    function ativar() {
      if (!estaValido()) {
        limpar();
      }
    }

    function estaValido() {
      var duracao = moment.duration(agora().diff($localStorage.documento.create));
      return duracao.asDays() < DURACAO_STORAGE_EM_DIAS;
    }

    function estaVazio() {
      return $localStorage.documento.values.length === 0;
    }

    function inicializado() {
      return estaValido() && !estaVazio();
    }

    function limpar() {
      $localStorage.documento.values.splice(0, $localStorage.documento.values.length);
      $localStorage.documento.create = agora();
    }

    function add(documento) {
      if (!_.isUndefined(documento.codigo) && !exist(documento.pk)) {
        $localStorage.documento.values.push(documento);
      }
    }

    function addAll(documentos) {
      _.each(documentos, function(documento) {
        add(documento);
      });
    }

    function exist(pk) {
      var documento = getByPk(pk);
      return !_.isUndefined(documento) && !_.isEmpty(documento);
    }

    function getByCodigo(codigo) {
      return _.find($localStorage.documento.values, function(documento) {
        return documento.codigo === codigo;
      });
    }

    function getByPk(pk) {
      var pkInt = parseInt(pk);
      return _.find($localStorage.documento.values, function(documento) {
        return documento.pk === pkInt;
      });
    }

    function getAll() {
      return $localStorage.documento.values;
    }

    function findBySistemaNegocioPk(sistemaNegocioPk) {
      var pk = parseInt(sistemaNegocioPk);
      var documentos = _.filter($localStorage.documento.values, function(documento) {
        return documento.sistemaNegocio.pk === pk;
      });

      return ordenar(documentos);
    }

    function findAtivosBySistemaNegocioPk(sistemaNegocioPk) {
      var pk = parseInt(sistemaNegocioPk);
      var documentos = _.filter($localStorage.documento.values, function(documento) {
        return documento.sistemaNegocio.pk === pk && documento.ativo === true;
      });

      return ordenar(documentos);
    }

    function findBySistemasNegocioPk(sistemasNegocioPks) {
      var snPksNumber = _.map(sistemasNegocioPks, function(value) {
        return parseInt(value);
      });

      var documentos = _.filter($localStorage.documento.values, function(documento) {
        return _.indexOf(snPksNumber, documento.sistemaNegocio.pk) !== NAO_EXISTE;
      });

      return ordenar(documentos);
    }

    function ordenar(documentos) {
      return _.sortBy(documentos, 'codigo');
    }
  }

  function agora() {
    return moment().startOf('day');
  }
})(angular, moment, _);
;
(function(angular, moment, _) {
  'use strict';

  var DURACAO_STORAGE_EM_DIAS = 1;

  angular
    .module('crd')
    .factory('instituicaoStorageService', instituicaoStorageService);

  instituicaoStorageService.$inject = ['$localStorage'];

  function instituicaoStorageService($localStorage) {
    $localStorage.$default({
      instituicao: {
        create: agora(),
        values: []
      }
    });
    var service = {
      add: add,
      addAll: addAll,
      exist: exist,
      getByIdBacen: getByIdBacen,
      inicializado: inicializado,
      limpar: limpar
    };

    ativar();

    return service;

    function ativar() {
      if (!estaValido()) {
        limpar();
      }
    }

    function estaValido() {
      var duracao = moment.duration(agora().diff($localStorage.instituicao.create));
      return duracao.asDays() < DURACAO_STORAGE_EM_DIAS;
    }

    function estaVazio() {
      return $localStorage.instituicao.values.length === 0;
    }

    function inicializado() {
      return estaValido() && !estaVazio();
    }

    function limpar() {
      $localStorage.instituicao.values.splice(0, $localStorage.instituicao.values.length);
      $localStorage.instituicao.create = agora();
    }

    function add(instituicao) {
      if (!_.isUndefined(instituicao.idBacen) && !exist(instituicao.idBacen)) {
        $localStorage.instituicao.values.push(instituicao);
      }
    }

    function addAll(instituicoes) {
      _.each(instituicoes, function(instituicao) {
        add(instituicao);
      });
    }

    function exist(pk) {
      var instituicao = getByIdBacen(pk);
      return !_.isUndefined(instituicao) && !_.isEmpty(instituicao);
    }

    function getByIdBacen(idBacen) {
      return _.find($localStorage.instituicao.values, function findInstituicaoByIdBacen(instituicao) {
        return instituicao.idBacen === idBacen;
      });
    }
  }

  function agora() {
    return moment().startOf('day');
  }
})(angular, moment, _);
;
(function(angular, moment) {
  'use strict';

  var DURACAO_STORAGE_EM_DIAS = 99999;

  angular
    .module('crd')
    .factory('locationStorageService', LocationStorageService);

  LocationStorageService.$inject = ['$localStorage'];

  function LocationStorageService($localStorage) {
    $localStorage.$default({
      locations: {
        create: agora(),
        values: {}
      }
    });
    var service = {
      add: add,
      get: get,
      inicializado: inicializado,
      limpar: limpar
    };

    ativar();

    return service;

    function ativar() {
      if (!estaValido()) {
        limpar();
      }
    }

    function estaValido() {
      var duracao = moment.duration(agora().diff($localStorage.locations.create));
      return duracao.asDays() < DURACAO_STORAGE_EM_DIAS;
    }

    function estaVazio() {
      return $localStorage.locations.values.length === 0;
    }

    function inicializado() {
      return estaValido() && !estaVazio();
    }

    function add(location) {
      var path = location.path();
      var params = location.search();

      if (angular.isDefined(path) && angular.isDefined(params)) {
        $localStorage.locations.values[path] = {
          params: params
        };
      }
    }

    function limpar() {
      for (var entry in $localStorage.locations.values) {
        delete $localStorage.locations.values[entry];
      }
      $localStorage.locations.create = moment().startOf('day');
    }

    function get(path) {
      return $localStorage.locations.values[path];
    }
  }

  function agora() {
    return moment().startOf('day');
  }
})(angular, moment);
;
(function(angular, moment, _) {
  'use strict';

  var DURACAO_STORAGE_EM_DIAS = 5;

  angular
    .module('crd')
    .factory('segmentoStorageService', segmentoStorageService);

  segmentoStorageService.$inject = ['$localStorage'];

  function segmentoStorageService($localStorage) {
    $localStorage.$default({
      segmento: {
        create: agora(),
        values: []
      }
    });
    var service = {
      add: add,
      addAll: addAll,
      getAll: getAll,
      getByCodigo: getByCodigo,
      inicializado: inicializado,
      limpar: limpar
    };

    ativar();

    return service;

    function ativar() {
      if (!estaValido()) {
        limpar();
      }
    }

    function estaValido() {
      var duracao = moment.duration(agora().diff($localStorage.segmento.create));
      return duracao.asDays() < DURACAO_STORAGE_EM_DIAS;
    }

    function estaVazio() {
      return $localStorage.segmento.values.length === 0;
    }

    function inicializado() {
      return estaValido() && !estaVazio();
    }

    function limpar() {
      $localStorage.segmento.values.splice(0, $localStorage.segmento.values.length);
      $localStorage.segmento.create = agora();
    }

    function add(segmento) {
      if (!_.isUndefined(segmento.codigo) && !exist(segmento.codigo)) {
        $localStorage.segmento.values.push(segmento);
      }
    }

    function addAll(segmentos) {
      _.each(segmentos, function(segmento) {
        add(segmento);
      });
    }

    function exist(codigo) {
      var segmento = getByCodigo(codigo);
      return !_.isUndefined(segmento) && !_.isEmpty(segmento);
    }

    function getByCodigo(codigo) {
      return _.find($localStorage.segmento.values, function findSegmentoByCodigo(segmento) {
        return segmento.codigo === codigo;
      });
    }

    function getAll() {
      return $localStorage.segmento.values;
    }
  }

  function agora() {
    return moment().startOf('day');
  }
})(angular, moment, _);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .factory('usuarioService', usuarioService);

  usuarioService.$inject = ['dataTablesStorageService', 'documentoStorageService',
    'instituicaoStorageService', 'locationStorageService', 'segmentoStorageService'
  ];

  function usuarioService(dataTablesStorageService, documentoStorageService,
    instituicaoStorageService, locationStorageService, segmentoStorageService) {
    var service = {
      limparStorage: limparStorage
    };

    return service;

    function limparStorage() {
      dataTablesStorageService.limpar();
      documentoStorageService.limpar();
      instituicaoStorageService.limpar();
      locationStorageService.limpar();
      segmentoStorageService.limpar();
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .value('angularMomentConfig', {
      timezone: 'America/Sao_Paulo'
    });
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('form-validacao', []);
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('form-validacao')
    .constant('fvOptions', {
      fvDecorar: {
        showSuccess: true,
        trigger: 'blur'
      }
    });
})(angular);
;
(function(angular, moment) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataFutura', fvDataFuturaDirective);

  var erData = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

  function fvDataFuturaDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {

      controller.$validators.fvDataFutura = function(modelValue, viewValue) {
        if (viewValue && erData.test(moment.utc(viewValue).format("DD/MM/YYYY"))) {
          var dataAtual = moment.utc();
          if($attributes.fvDataFutura && $attributes.fvDataFutura != "") {
            return !(moment.utc(viewValue).isBefore(dataAtual, 'day') || moment.utc(viewValue).isSame(dataAtual, 'day'));
          } else {
            return !(moment.utc(viewValue).isAfter(dataAtual, 'day') || moment.utc(viewValue).isSame(dataAtual, 'day'));
          }
        }
        return true;
      };

      $attributes.$observe('fvDataFutura', function() {
        controller.$validate();
      });
    }
  }

})(angular, moment);
;
(function(angular, moment) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataMaiorIgual', fvDataPassadaMaiorIgualDirective);

  var erData = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

  function fvDataPassadaMaiorIgualDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      validateAttributes($attributes);

      $scope.$watch($attributes.fvDataMaiorIgual, function(newValue) {
        controller.dataMinima = newValue ? moment.utc(newValue) : null;
        controller.$validate();
      });

      controller.$validators.fvDataMaiorIgual = function(modelValue, viewValue) {
        if (controller.dataMinima && viewValue && erData.test(moment.utc(viewValue).format("DD/MM/YYYY"))) {
          var data = moment.utc(viewValue);
          return data.isSame(controller.dataMinima) || data.isAfter(controller.dataMinima);
        }

        return true;
      };
    }

    function validateAttributes(attributes) {
      if (!attributes.fvDataMaiorIgual) {
        throw Error('Deve ser informado uma data mínima.');
      }
    }
  }

})(angular, moment);
;
(function(angular, moment) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataMaior', fvDataPassadaMaiorDirective);

  var erData = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

  function fvDataPassadaMaiorDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      validateAttributes($attributes);

      $scope.$watch($attributes.fvDataMaior, function(newValue) {
        controller.dataMinima = newValue ? moment.utc(newValue) : null;
        controller.$validate();
      });

      controller.$validators.fvDataMaior = function(modelValue, viewValue) {
        if (controller.dataMinima && viewValue && erData.test(moment.utc(viewValue).format("DD/MM/YYYY"))) {
          var data = moment.utc(viewValue);
          return data.isAfter(controller.dataMinima);
        }

        return true;
      };
    }

    function validateAttributes(attributes) {
      if (!attributes.fvDataMaior) {
        throw Error('Deve ser informado uma data mínima.');
      }
    }
  }

})(angular, moment);
;
(function(angular, moment) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataMenorIgual', fvDataPassadaMenorIgualDirective);

  var erData = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

  function fvDataPassadaMenorIgualDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      validateAttributes($attributes);

      $scope.$watch($attributes.fvDataMenorIgual, function(newValue) {
        controller.dataMaxima = newValue ? moment.utc(newValue) : null;
        controller.$validate();
      });

      controller.$validators.fvDataMenorIgual = function(modelValue, viewValue) {
        if (controller.dataMaxima && viewValue && erData.test(moment.utc(viewValue).format("DD/MM/YYYY"))) {
          var data = moment.utc(viewValue);
          return data.isSame(controller.dataMaxima) || data.isBefore(controller.dataMaxima);
        }

        return true;
      };
    }

    function validateAttributes(attributes) {
      if (!attributes.fvDataMenorIgual) {
        throw Error('Deve ser informado uma data máxima.');
      }
    }
  }

})(angular, moment);
;
(function(angular, moment) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataMenor', fvDataPassadaMenorDirective);

  var erData = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

  function fvDataPassadaMenorDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      validateAttributes($attributes);

      $scope.$watch($attributes.fvDataMenor, function(newValue) {
        controller.dataMaxima = newValue ? moment.utc(newValue) : null;
        controller.$validate();
      });

      controller.$validators.fvDataMenor = function(modelValue, viewValue) {
        if (controller.dataMaxima && viewValue && erData.test(moment.utc(viewValue).format("DD/MM/YYYY"))) {
          var data = moment.utc(viewValue);
          return data.isBefore(controller.dataMaxima);
        }

        return true;
      };
    }

    function validateAttributes(attributes) {
      if (!attributes.fvDataMenor) {
        throw Error('Deve ser informado uma data máxima.');
      }
    }
  }

})(angular, moment);
;
(function(angular, moment) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataPassada', fvDataPassadaDirective);

  var erData = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

  function fvDataPassadaDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {

      controller.$validators.fvDataPassada = function(modelValue, viewValue) {
        if (viewValue && erData.test(moment.utc(viewValue).format("DD/MM/YYYY"))) {
          var dataAtual = moment.utc();
          if($attributes.fvDataPassada && $attributes.fvDataPassada != "") {
            return !(moment.utc(viewValue).isAfter(dataAtual, 'day') || moment.utc(viewValue).isSame(dataAtual, 'day'));
          } else {
            return !(moment.utc(viewValue).isBefore(dataAtual, 'day') || moment.utc(viewValue).isSame(dataAtual, 'day'));
          }
        }
        return true;
      };

      $attributes.$observe('fvDataPassada', function() {
        controller.$validate();
      });
    }
  }

})(angular, moment);
;
(function(angular, moment) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataPassadaComHoje', fvDataPassadaComHojeDirective);

  var erData = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

  function fvDataPassadaComHojeDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {

      controller.$validators.fvDataPassadaComHoje = function(modelValue, viewValue) {
        if (viewValue && erData.test(moment.utc(viewValue).format("DD/MM/YYYY"))) {
          var dataAtual = moment.utc();
          if($attributes.fvDataPassadaComHoje && $attributes.fvDataPassadaComHoje != "") {
            return !(moment.utc(viewValue).isAfter(dataAtual, 'day'));
          } else {
            return !(moment.utc(viewValue).isBefore(dataAtual, 'day'));
          }
        }
        return true;
      };

      $attributes.$observe('fvDataPassadaComHoje', function() {
        controller.$validate();
      });
    }
  }

})(angular, moment);
;
(function(angular) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDataValida', fvDataValidaDirective);

  var erValidarData = /^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
  var erValidarDataMensal = /^(0[1-9]|1[012])\/(\d{4})$/;

  var erDataDiaria = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;
  var erDataMensal = /[0-9]{2}\/[0-9]{4}/;

  function fvDataValidaDirective() {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      // force truthy in case we are on non input element
      $attributes.fvDataValida = true;

      controller.$validators.fvDataValida = function(modelValue, viewValue) {
        if (erDataDiaria.test(viewValue) && !erValidarData.test(viewValue)) {
          return false;
        } else if (erDataMensal.test(viewValue) && !erValidarDataMensal.test(viewValue)) {
          return false;
        }
        return true;
      };

      $attributes.$observe('fvDataValida', function() {
        controller.$validate();
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvDecorar', fvDecorarDirective);

  fvDecorarDirective.$inject = ['$compile', '$timeout', 'fvOptions'];

  function fvDecorarDirective($compile, $timeout, fvOptions) {
    var directive = {
      compile: fvDecorarCompile,
      require: '^form',
      restrict: 'A',
      scope: true
    };

    return directive;

    function fvDecorarCompile(tElement) {
      if (!(tElement.hasClass('form-group') || tElement.hasClass('input-group') || tElement.hasClass('decorar-group'))) {
        throw new Error("fv-decorar deve possuir a CSS class 'form-group' ou 'input-group'.");
      }

      return {
        post: fvDecorarPostLink,
        pre: fvDecorarPreLink
      };
    }

    function fvDecorarPreLink(scope, element, attributes) {
      element.addClass('fv-decorar');

      scope.options = angular.merge(fvOptions.fvDecorar, scope.$eval(attributes.fvDecorar));
      scope.decorar = {};
    }

    function fvDecorarPostLink(scope, element, attributes, formController) {
      if (!formController || !formController.$name) {
        throw new Error('fv-decorar deve possuir um "parent" form com o atributo "name".');
      }

      var olharForm;
      scope.$watch(attributes.fvDecorar, function(newValue) {
        olharForm = newValue;
      });

      var elementInput = element[0].querySelector('[name][ng-model]');
      var input = angular.element(elementInput);

      scope.$watch(formController.$dirty, function() {
        if(olharForm) {
          toggleClasses();
        }
      });

      scope.$watch(formController.$name + '.' + input.attr('name') + '.$dirty', toggleClasses);
      scope.$watch(formController.$name + '.' + input.attr('name') + '.$touched', toggleClasses);
      scope.$watch(formController.$name + '.' + input.attr('name') + '.$invalid', toggleClasses);

      scope.$on('fv-decorar-check-validity', function fvDecorarOnCheckValidity() {
        toggleClasses();
      });

      scope.$on('fv-decorar-reset', function fvDecorarOnReset() {
        return $timeout(function() {
          scope.decorar.visivel = false;
          toggleClasses();
        }, 0, false);
      });

      function toggleClasses() {
        var inputNgModelController = formController[input.attr('name')];

        var dirty = olharForm ? formController.$dirty : inputNgModelController && inputNgModelController.$dirty;
        var prestine = olharForm ? formController.$dirty : inputNgModelController && inputNgModelController.$prestine;
        var invalid = inputNgModelController && (inputNgModelController.$invalid);
        var touched = inputNgModelController && (inputNgModelController.$touched);

        scope.decorar.visivel = touched || dirty;
        if (inputNgModelController && scope.decorar.visivel) {
          scope.decorar.invalid = invalid;
          if (invalid) {
            element.addClass('has-error');
            element.removeClass('has-success');
          } else {
            element.addClass('has-success');
            element.removeClass('has-error');
          }
        } else {
          element.removeClass('has-error');
          element.removeClass('has-success');
        }
      }

      function createIconStatus() {
        var template = '<span class="form-control-feedback fv-decorar-icon animated" ng-show="decorar.visivel"'
        + 'ng-class="{\'fadeIn\' : decorar.visivel, \'fadeOut\' : !decorar.visivel}">'
        + '<i class="fa " ng-class="{\'fa-check-circle-o\' : !decorar.invalid,\'fa-times-circle-o\' : decorar.invalid}"></i>'
        + '</span>';

        var iconStatus = $compile(template)(scope);
        input.after(iconStatus);
      }

      createIconStatus();
    }
  }
})(angular);
;
(function(angular, s) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvExpressao', fvExpressaoDirective);

  fvExpressaoDirective.$inject = ['$parse'];

  function fvExpressaoDirective($parse) {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      validateAttributes($attributes);

      var model = $attributes.ngModel.split('.');
      var isCtrlAsSyntax = s.endsWith(model[0], 'Ctrl');
      $scope.$parent.$watch(watching, fvExpressaoWatcher, true);

      function watching(scope) {
        if (isCtrlAsSyntax) {
          return scope[model[0]][model[1]];
        }
        return scope[model[0]];
      }

      function fvExpressaoWatcher() {
        var isValid = $parse($attributes.fvExpressao)($scope.$parent);
        controller.$setValidity('fvExpressao', isValid);
      }
    }

    function validateAttributes(attributes) {
      if (!attributes.fvExpressao) {
        throw Error('Deve ser informado uma expressão para a diretiva.');
      }
    }
  }
})(angular, s);
;
(function (angular) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvObrigatorio', fvObrigatorioDirective);

  fvObrigatorioDirective.$inject = ['$parse'];

  function fvObrigatorioDirective($parse) {
    var directive = {
      link: postLink,
      require: 'ngModel',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      $scope.obrigatorio = true; // force truthy in case we are on non input element
      var model = $attributes.ngModel.split('.');
      var isCtrlAsSyntax = s.endsWith(model[0], 'Ctrl') || s.endsWith(model[0], 'Controller');

      $scope.$parent.$watch(function (scope) {
        if (isCtrlAsSyntax) {
          return scope[model[0]][model[1]];
        }

        return scope[model[0]];
      }, function fvExpressaoWatcher() {
        if ($attributes.fvObrigatorio && $attributes.fvObrigatorio != "") {
          $scope.obrigatorio = $parse($attributes.fvObrigatorio)($scope.$parent);
          controller.$validate();
        }
      }, true);

      $scope.$parent.$watch(function (scope) {
        return $parse($attributes.fvObrigatorio)($scope.$parent);
      }, function fvExpressaoWatcher() {
        if ($attributes.fvObrigatorio && $attributes.fvObrigatorio != "") {
          $scope.obrigatorio = $parse($attributes.fvObrigatorio)($scope.$parent);
          controller.$validate();
        }
      }, true);

      controller.$validators.fvObrigatorio = function (modelValue, viewValue) {
        return !$scope.obrigatorio || !(controller.$isEmpty(viewValue) || (Array.isArray(viewValue) && viewValue.length === 0));
      };

      $attributes.$observe('fvObrigatorio', function (newValue) {
        controller.$validate();
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('form-validacao')
    .directive('fvSubmit', fvSubmitDirective);

  function fvSubmitDirective() {
    var directive = {
      link: postLink,
      require: '^form',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {
      $element.bind('submit', function onSubmit(event) {
        event.preventDefault();

        $scope.$safeApply(function() {
          controller.submitted = true;
          marcarCamposInvalidosComoTocados(controller);
        });

        if (controller.$invalid) {
          focoNoPrimeiroComponenteComErro();
        } else {
          $scope.$eval($attributes.fvSubmit);
        }

        function focoNoPrimeiroComponenteComErro() {
          var elementos = $element.find('.ng-invalid');
          if (elementos.length !== 0) {
            elementos[0].focus();
          }
        }
      });

      function marcarCamposInvalidosComoTocados(form) {
        angular.forEach(form.$error, function(campos) {
          angular.forEach(campos, function(campo) {
            if (campo.$setTouched) {
              campo.$setTouched();
            } else {
              marcarCamposInvalidosComoTocados(campo);
            }
          });
        });
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui', [
      'ui.bootstrap'
    ]);
})(angular);
;
"use strict";
var UIBooleanDirective = (function () {
    function UIBooleanDirective() {
        this.priority = 0;
        this.restrict = 'E';
        this.scope = {
            value: '='
        };
        this.templateUrl = 'scripts/ui/boolean/ui-boolean-tpl.html';
    }
    UIBooleanDirective.prototype.link = function (scope, element, attributes, controller, transclude) {
    };
    UIBooleanDirective.instance = function () {
        return new UIBooleanDirective();
    };
    return UIBooleanDirective;
}());
UIBooleanDirective.$inject = [];
angular.module('crd').directive('uiBoolean', UIBooleanDirective.instance);
//# sourceMappingURL=ui-boolean-directive.js.map;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiButtonCancelar', uiButtonCancelarDirective);

  function uiButtonCancelarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var existeTexto = !$element.html();

      $element.addClass('btn btn-default icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para cancelar a ação.');

      // $element.append('<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>');

      if (existeTexto) {
        $element.append('Cancelar');
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiButtonExcel', uiButtonExcelDirective);

  function uiButtonExcelDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-primary icon-margin');
      $element.attr('title', $attributes.title || 'Exportar resultados da pesquisa para EXCEL.');
      $element.append('<i class="fa fa-file-excel-o fa-lg" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiButtonPesquisar', uiButtonPesquisarDirective);

  function uiButtonPesquisarDirective() {
    var directive = {
      link: postLink,
      require: '^form',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, $formController) {
      var existeTexto = !$element.html();

      $element.addClass('btn btn-primary icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para realizar a pesquisa utilizando os valores informados.');

      $element.append('<i class="fa fa-search" aria-hidden="true"></i>');

      if (existeTexto) {
        $element.append('Pesquisar');
      }

      $scope.$watch($formController.$name + '.$invalid', function(newValue) {
        $element.attr('disabled', newValue);
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
  .module('ui')
  .directive('uiButtonSalvar', uiButtonSalvarDirective);

  function uiButtonSalvarDirective() {
    var directive = {
      link: postLink,
      require: '^form',
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes, $formController) {
      var existeTexto = !$element.html();

      $scope.$watch(elementDeveEstarDesabilitado, toogleDisabledElement);
      $element.addClass('btn btn-primary icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para salvar o registro com os valores informados.');

      if (existeTexto) {
        $element.append('<i class="fa fa-floppy-o" aria-hidden="true"></i>');
        $element.append('Salvar');
      }

      function elementDeveEstarDesabilitado() {
        var desabilitadoAdicional =$attributes.uiButtonSalvarDesabilitado ? $scope.$eval($attributes.uiButtonSalvarDesabilitado) : false;

        return $formController.$invalid || $formController.$pristine || desabilitadoAdicional;
      }

      function toogleDisabledElement(newValue) {
        $element[0].disabled = !!newValue;
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiButtonText', uiButtonTextDirective);

  function uiButtonTextDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-primary icon-margin');
      $element.attr('title', $attributes.title || 'Exportar resultados da pesquisa para TEXTO.');
      $element.append('<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiButtonVoltar', uiButtonVoltarDirective);

  function uiButtonVoltarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var existeTexto = !$element.html();

      $element.addClass('btn btn-default icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para voltar a tela anterior.');

      $element.append('<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>');

      if (existeTexto) {
        $element.append('Voltar');
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiCaracteresRestantes', uiCaracteresRestantesDirective);

  var PORCENTAGEM_ERROR = 0;
  var PORCENTAGEM_WARNING = 0.1;

  function uiCaracteresRestantesDirective() {
    var directive = {
      link: postLink,
      restrict: 'E',
      templateUrl: 'scripts/ui/caracteres-restantes/ui-caracteres-restantes-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var forElement = angular.element('#' + $attributes.para);
      if (forElement.length !== 1) {
        throw Error('Deve existir um e apenas um elemento com o id ' + $attributes.para);
      }
      $scope.maxlength = forElement.attr('maxlength');
      var ngModel = forElement.attr('ng-model');

      $scope.$parent.$watch(ngModel, function(value) {
        var currentLength = value !== null && angular.isDefined(value) ? value.length : 0;
        $scope.caracteresRestantes = $scope.maxlength - currentLength;
      });

      $scope.$watch('caracteresRestantes', function calcularState(value) {
        if (value <= PORCENTAGEM_ERROR) {
          $scope.state = 'E';
        } else if (value / $scope.maxlength <= PORCENTAGEM_WARNING) {
          $scope.state = 'W';
        } else {
          $scope.state = 'I';
        }
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  var DELAY = 0;

  angular
    .module('ui')
    .factory('feedbackService', feedbackService);

  feedbackService.$inject = ['$rootScope', '$timeout'];

  function feedbackService($rootScope, $timeout) {
    var service = {
      alerta: alerta,
      erro: erro,
      info: info,
      limpar: limpar,
      mensagens: mensagens,
      resultados: resultados,
      sucesso: sucesso,
      violacoes: violacoes
    };

    return service;

    function alerta(mensagem) {
      $timeout(function alertasTimeout() {
        $rootScope.$emit('uiFbAlerta', mensagem);
      }, DELAY);
    }

    function erro(mensagem) {
      $timeout(function errosTimeout() {
        $rootScope.$emit('uiFbErro', mensagem);
      }, DELAY);
    }

    function info(mensagem) {
      $timeout(function informacoesTimeout() {
        $rootScope.$emit('uiFbInfo', mensagem);
      }, DELAY);
    }

    function limpar() {
      $timeout(function clearTimeout() {
        $rootScope.$emit('uiFbLimpar');
      }, DELAY);
    }

    function sucesso(mensagem) {
      $timeout(function successTimeout() {
        $rootScope.$emit('uiFbSucesso', mensagem);
      }, DELAY);
    }

    function violacoes(data) {
      $timeout(function violacoesTimeout() {
        $rootScope.$emit('uiFbViolacoes', data);
      }, DELAY);
    }

    function mensagens(data) {
     $timeout(function mensagensTimeout(){
       $rootScope.$emit('uiFbMensagens', data);
     }, DELAY)
    }

    function resultados(data) {
     $timeout(function mensagensTimeout(){
       $rootScope.$emit('uiFbResultados', data);
     }, DELAY)
    }
  }
})(angular);
;
(function(angular, _) {
  'use strict';

  angular
    .module('ui')
    .controller('UiFeedbackController', UiFeedbackController);

  UiFeedbackController.$inject = ['$rootScope', '$scope', '$timeout'];

  function UiFeedbackController($rootScope, $scope, $timeout) {
    var vm = this;
    vm.mensagens = {
      alerta: [],
      erro: [],
      info: [],
      sucesso: []
    };

    vm.verificarSeDeveExibir = verificarSeDeveExibir;
    vm.limparMensagens = limparMensagens;

    function verificarSeDeveExibir() {
      vm.deveExibirAlerta = !_.isEmpty(vm.mensagens.alerta);
      vm.deveExibirErro = !_.isEmpty(vm.mensagens.erro);
      vm.deveExibirInfo = !_.isEmpty(vm.mensagens.info);
      vm.deveExibirSucesso = !_.isEmpty(vm.mensagens.sucesso);
      vm.deveExibir = vm.deveExibirAlerta || vm.deveExibirErro || vm.deveExibirInfo || vm.deveExibirSucesso;
    }

    function feedback(messageCollection, mensagens) {
      $scope.$apply(function feedbackApply() {
        if (_.isArray(mensagens)) {
          messageCollection.push.apply(messageCollection, _.uniq(mensagens));
        } else {
          messageCollection.push(mensagens);
        }
      });
    }

    function limparMensagens(mensagens) {
      mensagens.length = 0;
    }

    function limpar() {
      $scope.$apply(function() {
        limparMensagens(vm.mensagens.alerta);
        limparMensagens(vm.mensagens.erro);
        limparMensagens(vm.mensagens.info);
        limparMensagens(vm.mensagens.sucesso);
      });
    }

    var uiFbAlerta = $rootScope.$on('uiFbAlerta', function onAlertas(event, alertas) {
      $timeout(function() {
        limpar();
        feedback(vm.mensagens.alerta, alertas);
        verificarSeDeveExibir();
      });
    });

    var uiFbErro = $rootScope.$on('uiFbErro', function onErros(event, erros) {
      $timeout(function() {
        limpar();
        feedback(vm.mensagens.erro, erros);
        verificarSeDeveExibir();
      });
    });

    var uiFbInfo = $rootScope.$on('uiFbInfo', function onInformacoes(event, informacoes) {
      $timeout(function() {
        limpar();
        feedback(vm.mensagens.info, informacoes);
        verificarSeDeveExibir();
      });
    });

    var uiFbLimpar = $rootScope.$on('uiFbLimpar', function onLimparMensagens() {
      $timeout(function() {
        limpar();
        verificarSeDeveExibir();
      });
    });

    var uiFbSucesso = $rootScope.$on('uiFbSucesso', function onInformacoes(event, informacoes) {
      $timeout(function() {
        limpar();
        feedback(vm.mensagens.sucesso, informacoes);
        verificarSeDeveExibir();
      });
    });

    var uiFbMensagens = $rootScope.$on('uiFbMensagens', function onMensagens(event, mensagens){
      $timeout(function(){
        limpar();

        var erros = [];
        var sucessos = [];

        _.each(mensagens, function(mensagem){
          if(mensagem.type === 'SUCCESS'){
            sucessos.push(mensagem.content);
          } else {
            erros.push(mensagem.content);
          }
        });
        if(erros.length > 0){
          feedback(vm.mensagens.erro, erros)
        }
        if(sucessos.length > 0){
          feedback(vm.mensagens.sucesso, sucessos)
        }
      });
    });

      var uiFbResultados = $rootScope.$on('uiFbResultados', function onResultados(event, mensagens){
      $timeout(function(){
        limpar();

        var erros = [];
        var alertas = [];
        var sucessos = [];

        _.each(mensagens, function(mensagem){
          if(mensagem.type === 'SUCCESS'){
            sucessos.push(mensagem.content);
          } else if(mensagem.type == 'WARNING') {    
            alertas.push(mensagem.content);
          } else {
            erros.push(mensagem.content);
          }
        });
        if(erros.length > 0){
          feedback(vm.mensagens.erro, erros)
        }

        if(alertas.length > 0){
          feedback(vm.mensagens.alerta, alertas)
        }
        
        if(sucessos.length > 0){
          feedback(vm.mensagens.sucesso, sucessos)
        }
      });
    });

    var uiFbViolacoes = $rootScope.$on('uiFbViolacoes', function onViolacoes(event, dados) {
      dados = angular.fromJson(dados);
      $timeout(function() {
        limpar();
        if (_.has(dados, 'violacoes')) {
          var violacoes = dados.violacoes;
          var erros = [];
          var alertas = [];

          _.each(violacoes, function(violacao) {
            if (violacao.tipo === 'ALERTA') {
              alertas.push(violacao.mensagem);
            } else {
              erros.push(violacao.mensagem);
            }
          });

          if (erros.length > 0) {
            feedback(vm.mensagens.erro, erros);
          }
          if (alertas.length > 0) {
            feedback(vm.mensagens.alerta, alertas);
          }
        } else {
          $rootScope.$emit('erros', dados);
        }
        verificarSeDeveExibir();
      });

      $scope.$on('$destroy', function() {
        uiFbAlerta();
        uiFbErro();
        uiFbInfo();
        uiFbLimpar();
        uiFbMensagens();
        uiFbResultados();
        uiFbSucesso();
        uiFbViolacoes();
      });
    });
  }
})(angular, _);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiFeedback', uiFeedbackDirective);

  function uiFeedbackDirective() {
    var directive = {
      controller: 'UiFeedbackController',
      controllerAs: 'uiFbCtrl',
      link: postLink,
      require: 'uiFeedback',
      restrict: 'E',
      templateUrl: 'scripts/ui/feedback/ui-feedback-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, $controller) {
      var $body = angular.element('body');

      $scope.$watch(function() {
        return $controller.verificarSeDeveExibir();
      }, function(newValue) {
        if (newValue) {
          $body.animate({
            scrollTop: 0
          }, 'slow');
        }
      });

      $element.on('$destroy', function() {
        $scope.$destroy();
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('helpBlock', helpBlockDirective);

  helpBlockDirective.$inject = [];

  function helpBlockDirective() {
    var directive = {
      compile: compiler,
      require: '^form',
      restrict: 'A'
    };

    return directive;

    function compiler() {
      return {
        post: postLink,
        pre: preLink
      };
    }

    function postLink($scope, $element, $attributes, formController) {
      var olharForm;
      $scope.$watch($attributes.helpBlock, function(newValue) {
        olharForm = newValue;
      });

      var input = angular.element($element.parent().find('[name][ng-model]'));

      $scope.$watch(formController.$name + '.' + input.attr('name') + '.$dirty', toogleVisibility);
      $scope.$watch(formController.$name + '.' + input.attr('name') + '.$touched', toogleVisibility);
      $scope.$watch(formController.$name + '.' + input.attr('name') + '.$invalid', toogleVisibility);

      function toogleVisibility() {
        var inputController = formController[input.attr('name')];

        var dirty = olharForm ? formController.$dirty : inputController && inputController.$dirty;
        var invalid = inputController && (inputController.$invalid);
        var touched = inputController && (inputController.$touched);

        var show = invalid && (touched || dirty);
        if (show) {
          $element.removeClass('ng-hide');
        } else {
          $element.addClass('ng-hide');
        }
      }
    }

    function preLink($scope, $element, $attributes, formController) {
      if (!formController || !formController.$name) {
        throw new Error('help-block deve possuir um "parent" form com o atributo "name".');
      }

      $element.addClass('help-block');
      $element.attr('role', 'alert');
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkAlterar', uiLinkAlterarDirective);

  function uiLinkAlterarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-default btn-xs');
      $element.attr('title', $attributes.title || 'Clique aqui para alterar este registro.');
      $element.append('<i class="fa fa-edit fa-lg text-primary" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular, s) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkbtnAlterar', uiLinkAlterarDirective);

  function uiLinkAlterarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var existeTexto = !s.trim($element.html());

      $element.addClass('btn btn-primary icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para alterar este registro.');
      $element.append('<i class="fa fa-edit" aria-hidden="true"></i>');

      if (existeTexto) {
        $element.append('Alterar');
      }
    }
  }
})(angular, s);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkDesativar', uiLinkDesativarDirective);

  function uiLinkDesativarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-default btn-xs');
      $element.attr('title', $attributes.title || 'Clique aqui para desativar este registro.');
      $element.append('<i class="fa fa-ban fa-lg text-danger" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular, s) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkbtnDesativar', uiLinkDesativarDirective);

  function uiLinkDesativarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var existeTexto = !s.trim($element.html());

      $element.addClass('btn btn-danger icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para desativar este registro.');
      $element.append('<i class="fa fa-ban" aria-hidden="true"></i>');

      if (existeTexto) {
        $element.append('Desativar');
      }
    }
  }
})(angular, s);
;
(function (angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkDetalhar', uiLinkDetalharDirective);

  function uiLinkDetalharDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-default btn-xs');
      $element.attr('title', $attributes.title || 'Clique aqui para detalhar este registro.');
      if ($attributes.iconclass) {
        $element.append('<i class="'+ $attributes.iconclass +'" aria-hidden="true"></i>');
      } else {
        $element.append('<i class="fa fa-file-text-o fa-lg text-primary" aria-hidden="true"></i>');
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkExcluir', uiLinkExcluirDirective);

  function uiLinkExcluirDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-default btn-xs');
      $element.attr('title', $attributes.title || 'Clique aqui para excluir este registro.');
      $element.append('<i class="fa fa-trash-o fa-lg text-danger" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular, s) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkbtnExcluir', uiLinkExcluirDirective);

  function uiLinkExcluirDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var existeTexto = !s.trim($element.html());

      $element.addClass('btn btn-danger icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para excluir este registro.');
      $element.append('<i class="fa fa-trash-o" aria-hidden="true"></i>');

      if (existeTexto) {
        $element.append('Excluir');
      }
    }
  }
})(angular, s);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkNovo', uiLinkNovoDirective);

  function uiLinkNovoDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-primary');
      $element.attr('title', $attributes.title || 'Clique aqui para incluir um novo registro.');
      $element.append('<i class="fa fa-plus-circle" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkOpenModal', uiLinkOpenModalDirective);

  function uiLinkOpenModalDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-default btn-xs');
      $element.attr('title', $attributes.title || 'Clique aqui para abrir um modal com o detalhamento deste registro.');
      $element.append('<i class="fa fa-clipboard fa-lg text-primary" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkVoltar', uiLinkVoltarDirective);

  function uiLinkVoltarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      $element.addClass('btn btn-default btn-xs');
      $element.attr('title', $attributes.title || 'Clique aqui para voltar a tela anterior.');
      $element.append('<i class="fa fa-arrow-circle-left fa-lg text-primary" aria-hidden="true"></i>');
    }
  }
})(angular);
;
(function(angular, s) {
  'use strict';

  angular
    .module('ui')
    .directive('uiLinkbtnVoltar', uiLinkbtnVoltarDirective);

  function uiLinkbtnVoltarDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var existeTexto = !s.trim($element.html());

      $element.addClass('btn btn-default icon-margin pull-right');
      $element.attr('title', $attributes.title || 'Clique aqui para voltar a tela anterior.');
      $element.append('<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>');

      if (existeTexto) {
        $element.append('Voltar');
      }
    }
  }
})(angular, s);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiPossuiItensAtivos', uiPossuiItensAtivosDirective);

  function uiPossuiItensAtivosDirective() {
    var directive = {
      link: postLink,
      restrict: 'A'
    };

    return directive;

    function postLink($scope, $element) {
      var links = $element.find('li');

      $scope.$watch(possuiLinksAtivos, watchPossuiLinksAtivos, true);

      function watchPossuiLinksAtivos(newValue) {
        if (newValue) {
          $element.show();
        } else {
          $element.hide();
        }
      }

      function possuiLinksAtivos() {
        var linksAtivos = links.not('.ng-hide');
        return linksAtivos.length > 0;
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .controller('CrdModalAlertController', CrdModalAlertController);

  CrdModalAlertController.$inject = ['$uibModalInstance'];

  function CrdModalAlertController($uibModalInstance) {
    var vm = this;
    vm.cancel = cancel;

    $uibModalInstance.rendered.then(function() {
      formatarTexto();
    });

    function formatarTexto(){
      vm.textoFormatado = vm.texto
        ? vm.texto
          .replace(/\n/g, '<br>') // substituindo as quebras de linha por tag html <br>.
          .replace(/^[\s]*?<br>/g, '') // removendo as quebras de linha no início do texto.
        : vm.texto;
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('crdModalAlert', crdModalAlert);

  crdModalAlert.$inject = ['$uibModal'];

  function crdModalAlert($uibModal) {
    var directive = {
      link: postLink,
      restrict: 'A',
      scope: {
        texto: '@crdModalAlertTexto',
        titulo: '@crdModalAlertTitulo',
        size: '@crdModalAlertSize',
        tipo: '@crdModalAlertTipo'
    
      }
    };
    return directive;

    function postLink(scope, element) {
      element.bind('click', function() {
        var configuracaoModal = {
          animation: true,
          backdrop: 'static',
          bindToController: true,
          controller: 'CrdModalAlertController',
          controllerAs: 'crdModalAlertCtrl',
          keyboard: false,
          scope: scope,
          size: scope.size,
          templateUrl: 'scripts/ui/modal/crd-modal-alert-tpl.html'
        };

        $uibModal.open(configuracaoModal).result;
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .controller('CrdModalConfirmaController', CrdModalConfirmaController);

  CrdModalConfirmaController.$inject = ['$uibModalInstance'];

  function CrdModalConfirmaController($uibModalInstance) {
    var vm = this;
    vm.ok = ok;
    vm.cancel = cancel;

    function ok() {
      $uibModalInstance.close();
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('crdModalConfirma', crdModalConfirma);

  crdModalConfirma.$inject = ['$uibModal'];

  function crdModalConfirma($uibModal) {
    var directive = {
      link: postLink,
      restrict: 'A',
      scope: {
        item: '=item',
        mensagem: '@crdModalConfirmaMensagem',
        aviso: '@crdModalConfirmaMensagemAviso',
        mensagemDinamica: '=crdModalConfirmaMensagemDinamica',
        metodo: '&crdModalConfirma',
        titulo: '@crdModalConfirmaTitulo'
      }
    };
    return directive;

    function postLink(scope, element) {
      element.bind('click', function() {
        var configuracaoModal = {
          animation: true,
          backdrop: 'static',
          bindToController: true,
          controller: 'CrdModalConfirmaController',
          controllerAs: 'crdModalConfirmaCtrl',
          keyboard: false,
          scope: scope,
          templateUrl: 'scripts/ui/modal/crd-modal-confirma-tpl.html'
        };

        $uibModal.open(configuracaoModal)
          .result
          .then(function() {
            scope.metodo({
              item: scope.item
            });
          });
      });
    }
  }
})(angular);
;
"use strict";
var UIRadioSimNaoController = (function () {
    function UIRadioSimNaoController() {
        this.disabled = false;
        this.readonly = false;
    }
    UIRadioSimNaoController.prototype.observerChange = function ($event, newValue) {
    };
    UIRadioSimNaoController.prototype.$onInit = function () { };
    return UIRadioSimNaoController;
}());
UIRadioSimNaoController.$inject = [];
angular.module('crd').controller('UIRadioSimNaoController', UIRadioSimNaoController);
//# sourceMappingURL=ui-radio-sim-nao-controller.js.map;
"use strict";
var UIRadioSimNaoDirective = (function () {
    function UIRadioSimNaoDirective() {
        this.controller = 'UIRadioSimNaoController';
        this.controllerAs = 'uiRadioSimNaoCtlr';
        this.name = 'uiRadioSimNao';
        this.priority = 0;
        this.require = ['uiRadioSimNao', 'ngModel'];
        this.restrict = 'E';
        this.scope = true;
        this.templateUrl = 'scripts/ui/radio-sim-nao/ui-radio-sim-nao-tpl.html';
    }
    UIRadioSimNaoDirective.prototype.link = function (scope, element, attributes, controller) {
        var uiRadioSimNaoCtlr = controller[0];
        var ngModelCtrl = controller[1];
        ngModelCtrl.$render = function () {
            uiRadioSimNaoCtlr.value = ngModelCtrl.$viewValue;
        };
        scope.$watch('uiRadioSimNaoCtlr.value', function (newValue) {
            ngModelCtrl.$setViewValue(newValue);
        });
        uiRadioSimNaoCtlr.name = attributes.name || (new Date().getTime() + Math.random()).toString();
        scope.$watch(attributes.ngReadonly, function (newValue) {
            uiRadioSimNaoCtlr.readonly = newValue;
        });
        scope.$watch(attributes.ngDisabled, function (newValue) {
            uiRadioSimNaoCtlr.disabled = newValue;
        });
    };
    UIRadioSimNaoDirective.instance = function () {
        return new UIRadioSimNaoDirective();
    };
    return UIRadioSimNaoDirective;
}());
UIRadioSimNaoDirective.$inject = [];
angular.module('crd').directive('uiRadioSimNao', UIRadioSimNaoDirective.instance);
//# sourceMappingURL=ui-radio-sim-nao-directive.js.map;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .component('uiLegendaObrigatorio', {
      restrict: 'E',
      templateUrl: 'scripts/ui/template/legenda-obrigatorio/ui-legenda-obrigatorio-tpl.html'
    });
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .component('uiPaginaModal', {
      restrict: 'E',
      templateUrl: 'scripts/ui/template/pagina-modal/ui-pagina-modal-tpl.html',
      transclude: {
        corpo: 'corpo',
        headerAction: '?headerAction',
        titulo: 'titulo',
        toolbar: '?toolbar'

      }
    });
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiPaginaPesquisa', uiPaginaPesquisaDirective);

  function uiPaginaPesquisaDirective() {
    var directive = {
      link: postLink,
      require: 'ngController',
      restrict: 'E',
      templateUrl: 'scripts/ui/template/pagina-pesquisa/ui-pagina-pesquisa-tpl.html',
      transclude: {
        footer: '?footer',
        formulario: 'formulario',
        resultado: 'resultado',
        titulo: 'titulo',
        toolbar: '?toolbar'
      }
    };

    return directive;

    function postLink($scope, $element, $attributes) {
      var formulario = $element.find('formulario');
      var resultado = $element.find('resultado');

      var mostrar = formulario.attr('mostrar');

      $scope.view = {
        formulario: {
          visivel: true,
          mostrar: mostrar==='true' || mostrar===undefined
        },
        resultado: {
          visivel: false
        }
      };

      $scope.exibirLabelDeObrigatorio = $attributes.exibirLabelDeObrigatorio;

      $scope.$watch(formulario.attr('visivel'), function(value) {
        $scope.view.formulario.visivel = value;
      });

      $scope.$watch(formulario.attr('campo-obrigatorio'), function(value) {
        $scope.view.formulario.campoObrigatorio = value;
      });

      $scope.$watch(resultado.attr('visivel'), function(value) {
        $scope.view.resultado.visivel = value;
      });
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .component('uiTitulo', {
      restrict: 'E',
      templateUrl: 'scripts/ui/template/titulo/ui-titulo-tpl.html',
      transclude: true
    });
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('ui')
    .directive('uiToogleFiltroPesquisa', uiToogleFiltroPesquisaDirective);

  function uiToogleFiltroPesquisaDirective() {
    var directive = {
      link: postLink,
      restrict: 'E',
      scope: {
        isopen: '='
      },
      templateUrl: 'scripts/ui/template/toogle-filtro-pesquisa/ui-toogle-filtro-pesquisa-tpl.html'
    };

    return directive;

    function postLink($scope) {
      $scope.toggleFiltro = function toggleFiltro() {
        $scope.isopen = !$scope.isopen;
      };

      if (angular.isUndefined($scope.isopen)) {
        $scope.isopen = true;
      }
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('app', [
      'ngAnimate',
      'ngLocale',
      'ngMessages',
      'ngResource',
      'ngRoute',
      'ngSanitize',
      'angular-loading-bar',
      'aresLogin',
      'chart.js',
      'crd',
      'datatables',
      'flow',
      'form-validacao',
      'localytics.directives',
      'ngTagsInput',
      'SafeApply',
      'ui',
      'ui.bootstrap',
      'ui.event',
      'ui.indeterminate',
      'ui.mask',
      'ui.scroll',
      'ui.scrollpoint',
      'ui.select',
      'ui.uploader',
      'ui.utils.masks',
      'ui.validate',
      'checklist-model'
    ]);
})(angular);
;
(function(angular) {
  'use strict';

  var LATENCY_THRESHOLD = 30;

  angular
    .module('app')
    .config(appConfiguration);

  appConfiguration.$inject = ['$aresLoginProvider', 'cfpLoadingBarProvider'];

  function appConfiguration($aresLoginProvider, cfpLoadingBarProvider) {
    $aresLoginProvider.carregarUsuarioNaInicialializacaoDaAplicacao = true;
    $aresLoginProvider.rotaUsuarioSemPermissao = '/401';

    cfpLoadingBarProvider.latencyThreshold = LATENCY_THRESHOLD;
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('app')
    .run(appRun);

  appRun.$inject = ['$http', '$timeout', '$window', 'constantes'];

  function appRun($http, $timeout, $window, constantes) {

    var tentouUmaVez = false;
    var redirecionando = false;

    function verificarSessao() {

      if (redirecionando) {
        return;
      }

      $http.get(constantes.ROOT_URL)
        .then(function () {
          // ok
        })
        .catch(function (error) {

          if (!tentouUmaVez) {
            tentouUmaVez = true;
            return $timeout(verificarSessao, 400);
          }

          redirecionando = true;
          console.error("Erro ao buscar as autorizações do usuário", error);
          $window.location.replace('/crd/rest/dologin');
        });
    }

    verificarSessao();
  }
})(angular);
;
'use strict';

(function(window) {

  var aresSeguranca = angular.module('aresLogin', ['ng']);

  aresSeguranca.provider('$aresLogin', function() {
    this.carregarUsuarioNaInicialializacaoDaAplicacao = false;
    this.rotaUsuarioSemPermissao = undefined;

    this.$get = [function() {
      var that = {};
      that.carregarUsuarioNaInicialializacaoDaAplicacao = this.carregarUsuarioNaInicialializacaoDaAplicacao;
      that.rotaUsuarioSemPermissao = this.rotaUsuarioSemPermissao;
      return that;
    }];
  });

  aresSeguranca.config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('SegurancaInterceptador');
  }]);

  aresSeguranca.service('Usuario',
    ['$q', '$http', '$rootScope', function($q, $http, $rootScope) {

      var PREFIXO_ROLE_CRD = 'SCRD';

      var obter = function() {
        var deferred = $q.defer();

        $http.get('/crd/rest/usuario').then(function(resultado) {
          if (semRoleCrd(resultado.data.grantedAuthorities)) {
            redirecionarParaLogin(true);
            deferred.resolve();
            return;
          }
          $rootScope.usuario = resultado.data;
          deferred.resolve();
        }, function() {
          deferred.reject();
        });

        return deferred.promise;
      };

      function semRoleCrd(authorities) {
        var roles = (authorities || []).map(function(a) { return a.authority; });
        return !roles.some(function(role) { return role.indexOf(PREFIXO_ROLE_CRD) === 0; });
      }

      return {
        'obter': obter
      };
    }]
  );

  aresSeguranca.factory('SegurancaInterceptador',
    ['$q', '$log', '$location', '$aresLogin', function($q, $log, $location, $aresLogin) {

      var responseError = function(resposta) {
        if (resposta.status === 401) {
          redirecionarParaLogin(true);
          return $q.reject(resposta);
        }

        if (resposta.status === 403) {
          $log.debug('Acesso negado ao acessar URL ' + resposta.config.method + '/' + resposta.config.url);

          if ($aresLogin.rotaUsuarioSemPermissao) {
            $location.path($aresLogin.rotaUsuarioSemPermissao);
          } else {
            $log.error('Rota padrão para tratar acesso negado não foi configurada');
          }
        }

        return $q.reject(resposta);
      };

      return {
        'responseError': responseError
      };
    }]
  );

  aresSeguranca.run(function($rootScope, $http, $route, $aresLogin, $q, $log, $location, Usuario) {

    if ($aresLogin.carregarUsuarioNaInicialializacaoDaAplicacao) {
      $log.debug('Carregando usuário logado');
      Usuario.obter();
    }

    angular.forEach($route.routes, function(rota) {
      if (rota.seguro) {
        $log.debug('Adicionando resolve a rota ' + rota.originalPath);
        rota.resolve = {
          usuario: Usuario.obter
        };
      }
    });

    $rootScope.$on('logout', function() {
      window.location.replace('/crd/rest/logout');
    });
  });

  var redirecionarParaLogin = function(logout) {
    window.location.href = '/crd/rest/dologin' + (logout ? '?logout=true' : '');
  };

})(window);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AgendaEsApiService = (function (_super) {
    __extends(AgendaEsApiService, _super);
    function AgendaEsApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    AgendaEsApiService.prototype.consultar = function () {
        return this.buscarRecurso('/agenda-es/consultar/').then(function (response) {
            if (!response.data) {
                return response;
            }
            return response.data;
        });
    };
    return AgendaEsApiService;
}(AbstractAPISerivce));
AgendaEsApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('AgendaEsApiService', AgendaEsApiService);
//# sourceMappingURL=agenda-es-api-service.js.map;
"use strict";
var AgendaEsTabelaController = (function () {
    function AgendaEsTabelaController($location, $stateParams, entradaArquivoApiService, feedbackService, $scope, $uibModal) {
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.entradaArquivoApiService = entradaArquivoApiService;
        this.feedbackService = feedbackService;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
    }
    AgendaEsTabelaController.prototype.$onInit = function () { };
    AgendaEsTabelaController.prototype.getitemPeriodoClass = function (subItem) {
        if (subItem.existeEntregaHoje) {
            return 'agenda-es-datalimite-dia-atual';
        }
        return;
    };
    AgendaEsTabelaController.prototype.abrirModalInfoEntradasArquivos = function (itemPeriodo) {
        var _this = this;
        var _self = this;
        var dados = {
            documentoPK: itemPeriodo.documentoPK,
            idBacen: ConverterParameterObjectToUrlUtils.string(itemPeriodo.idBacen),
            dataBase: itemPeriodo.dataBase
        };
        return this.entradaArquivoApiService.buscarEntradasArquivosPorIdenficador(dados).then(function (response) {
            _this.$scope.entradasArquivosPorIdentificador = response;
            _this.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/agenda-es/views/consultar/crd-modal-informacoes-arquivos-entregues/crd-modal-informacoes-arquivos-entregues-tpl.html',
                controller: 'CrdModalInformacoesArquivosController',
                controllerAs: 'crdModalInformacoesArquivosCtrl',
                bindToController: true,
                keyboard: true,
                size: 'lg',
                scope: _this.$scope
            });
        });
    };
    return AgendaEsTabelaController;
}());
AgendaEsTabelaController.$inject = ['$location', '$stateParams', 'EntradaArquivoApiService', 'feedbackService', '$scope', '$uibModal'];
angular.module('crd').controller('AgendaEsTabelaController', AgendaEsTabelaController);
//# sourceMappingURL=agenda-es-tabela-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('agendaEsTabela', AgendaEsTabela);

  function AgendaEsTabela() {
    var directive = {
      controller: 'AgendaEsTabelaController',
      controllerAs: 'agendaEsTabelaCtrl',
      link: postLink,
      restrict: 'E',
      bindToController: true,
      scope: {
        item: '=',
        titulo: '='
      },
      templateUrl: 'views/agenda-es/views/consultar/agenda-es-tabela-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {

    }
  }
})(angular);
;
"use strict";
var CrdModalInformacoesArquivosController = (function () {
    function CrdModalInformacoesArquivosController($location, entradaArquivoApiService, $uibModalInstance, feedbackService) {
        this.$location = $location;
        this.entradaArquivoApiService = entradaArquivoApiService;
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.vmModal = this;
    }
    CrdModalInformacoesArquivosController.prototype.$onInit = function () {
        this.entradasArquivosPorIdentificador = this.vmModal.entradasArquivosPorIdentificador.data;
        this.quantidadeEntregas = this.entradasArquivosPorIdentificador.length;
        this.titulo = "Informações sobre a(s) entrega(s).";
        this.subtitulo = "Há " + this.quantidadeEntregas + " protocolo(s) para este documento e data-base, conforme indicado abaixo:";
    };
    CrdModalInformacoesArquivosController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    return CrdModalInformacoesArquivosController;
}());
CrdModalInformacoesArquivosController.$inject = ['$location', 'EntradaArquivoApiService', '$uibModalInstance', 'feedbackService', '$uibModal'];
angular.module('crd').controller('CrdModalInformacoesArquivosController', CrdModalInformacoesArquivosController);
//# sourceMappingURL=crd-modal-informacoes-arquivos-entregues-controller.js.map;
(function(angular, HttpStatus) {
  'use strict';

  var TAMANHO_PE = 15;
  var TAMANHO_PT = 10;
  var MASCARA_PE = '?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9';
  var MASCARA_PT = '?9?9?9?9?9?9?9?9?9?9';

  angular
    .module('crd')
    .controller('AnotacaoAlterarController', AnotacaoAlterarController);

  AnotacaoAlterarController.$inject = ['$scope', '$location', '$stateParams', 'anotacaoApiService', 'constantes', 'feedbackService'];

  function AnotacaoAlterarController($scope, $location, $stateParams, anotacaoApiService, constantes, feedbackService) {
    var vm = this;
    var self = $scope;

    vm.anexos = [];
    vm.numProcesso = null;
    vm.tamPtPe = TAMANHO_PE;
    vm.refs = constantes.OPCOES_REFERENCIA_ANOTACAO;
    vm.salvar = salvar;
    vm.voltar = voltar;
    vm.pt = false;
    vm.pe = false;
    vm.marcarPt = marcarPt;
    vm.marcarPe = marcarPe;
    vm.isFile = isFile;
    vm.downloadAnexo = downloadAnexo;
    vm.onAnexosAlterados = onAnexosAlterados;
    vm.anexoAlterado = false;
    carregarTela();

    function carregarTela() {
      return anotacaoApiService
        .detalhar($stateParams.id)
        .then(successCarregar);

      function successCarregar(resource) {
        vm.anotacao = resource;
        if (!_.isEmpty(resource.anexos)) {
          vm.anexos = resource.anexos;
        }
        vm.anotacao.idsRefSelecionados = [];

        if (vm.anotacao.numeroPt) {
          vm.pt = true;
          marcarPt();
          vm.numProcesso = vm.anotacao.numeroPt;
        }

        if (vm.anotacao.numeroPe) {
          vm.pe = true;
          marcarPe();
          vm.numProcesso = vm.anotacao.numeroPe;
        }

        vm._links = resource._links;
        var props = _.filter(_.keys(vm.anotacao), function(propriedade) {
          return s.startsWith(propriedade, 'ref');
        });

        _.each(props, function(prop) {
          if (vm.anotacao[prop]) {
            vm.anotacao.idsRefSelecionados.push(prop);
          }
        });
      }
    }

    function onAnexosAlterados() {
      vm.anexoAlterado = true;
    }

    function downloadAnexo(id) {
      var parameters = {
        id: id
      };
      return anotacaoApiService.downloadAnexo(parameters).then(function successOnGerarXLS() {});
    }

    function isFile(elemento) {
      return elemento instanceof File;
    }

    function marcarPt() {
      if (vm.pt) {
        vm.tamPtPe = TAMANHO_PT;
        vm.pe = false;
        vm.mask = MASCARA_PT;
      }
      vm.numProcesso = null;
    }

    function marcarPe() {
      if (vm.pe) {
        vm.tamPtPe = TAMANHO_PE;
        vm.pt = false;
        vm.mask = MASCARA_PE;
      }
      vm.numProcesso = null;
    }

    function salvar() {
      _.each(vm.refs, function(ref) {
        vm.anotacao[ref.id] = _.contains(vm.anotacao.idsRefSelecionados, ref.id);
      });

      var data = {
        numeroPe: vm.pe ? vm.numProcesso : null,
        numeroPt: vm.pt ? vm.numProcesso : null,
        pk: vm.anotacao.pk,
        refOutros: vm.anotacao.refOutros,
        refQualidade: vm.anotacao.refQualidade,
        refTempestividade: vm.anotacao.refTempestividade,
        texto: vm.anotacao.texto
      };

      var arquivos = [];
      var anexos = [];
      _.each(vm.anexos, function(arq) {
        if (isFile(arq)) {
          anexos.push(arq);
        } else {
          arquivos.push(arq);
        }
      });

      return anotacaoApiService
        .alterar(vm._links['anotacoes-alterar'].href, data, anexos, arquivos)
        .then(successAlterar);

      function successAlterar(response) {
        if (response.status === HttpStatus.OK) {
          vm.voltar();
          feedbackService.sucesso('Anotação salva com sucesso!');
        } else {
          feedbackService.violacoes(response.data);
        }
      }
    }

    function voltar() {
      $location.path('/anotacoes');
    }
  }
})(angular, httpStatusCode);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('AnotacaoDetalharController', AnotacaoDetalharController);

  AnotacaoDetalharController.$inject = ['$location', '$state', '$stateParams', 'anotacaoApiService'];

  function AnotacaoDetalharController($location, $state, $stateParams, anotacaoApiService) {
    var vm = this;
    vm.titulo = 'Anotação';

    vm.excluir = excluir;
    vm.voltar = voltar;
    vm.downloadAnexo = downloadAnexo;
    vm.anexos = [];

    carregarTela();

    function carregarTela() {
      return anotacaoApiService.detalhar($stateParams.id).then(successCarregar);

      function successCarregar(resource) {
        vm.anotacao = resource;
        if (!_.isEmpty(resource.anexos)) {
          vm.anexos = resource.anexos;
        }
      }
    }

    function excluir() {
      $location.path('/anotacoes/' + $stateParams.id + '/excluir');
    }

    function voltar() {
      if($stateParams.telaRetorno){
        $location.path('/' + $stateParams.telaRetorno + '/' + vm.anotacao.instituicao.idBacen + '/painel');
      }else{
        $state.go('anotacao-listar');
      }
    }

    function downloadAnexo(id) {
      var parameters = {
        id: id
      };
      return anotacaoApiService.downloadAnexo(parameters).then(function successOnGerarXLS() {});
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('AnotacaoDetalharHistoricoController', AnotacaoDetalharHistoricoController);

  AnotacaoDetalharHistoricoController.$inject = ['$location', '$state', '$stateParams', 'anotacaoApiService'];

  function AnotacaoDetalharHistoricoController($location, $state, $stateParams, anotacaoApiService) {
    var vm = this;
    vm.titulo = 'Anotação - histórico';

    vm.voltar = voltar;
    vm.historico = true;
    vm.idAnotacao = $stateParams.id;
    carregarTela();

    function carregarTela() {
      return anotacaoApiService.detalharHistorico($stateParams.id, $stateParams.historico).then(successCarregar);

      function successCarregar(resource) {
        vm.anotacao = resource;
      }
    }

    function voltar() {
      $location.path('/anotacoes/' + vm.idAnotacao + '/historico');
    }
  }
})(angular);
;
(function(angular, HttpStatus) {
  'use strict';

  angular
    .module('crd')
    .controller('AnotacaoExcluirController', AnotacaoExcluirController);

  AnotacaoExcluirController.$inject = ['$location', '$stateParams', 'anotacaoApiService', 'feedbackService'];

  function AnotacaoExcluirController($location, $stateParams, anotacaoApiService, feedbackService) {
    exlcuir();

    function exlcuir() {
      return anotacaoApiService
        .excluir($stateParams.id)
        .then(successExcluir);

      function successExcluir(response) {
        if (response.status === HttpStatus.NO_CONTENT) {
          $location.path('/anotacoes');
          feedbackService.sucesso('Anotação excluída com sucesso!');
        } else {
          feedbackService.erro('Erro ao excluir anotação!');
        }
      }
    }
  }
})(angular, httpStatusCode);
;
(function(angular, HttpStatus) {
  'use strict';

  var MASCARA_PE = '?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9';
  var MASCARA_PT = '?9?9?9?9?9?9?9?9?9?9';
  var TAMANHO_PE = 15;
  var TAMANHO_PT = 10;


  angular
    .module('crd')
    .controller('AnotacaoIncluirController', AnotacaoIncluirController);

  AnotacaoIncluirController.$inject = ['$scope', '$location', 'anotacaoApiService', 'constantes', 'feedbackService'];

  function AnotacaoIncluirController($scope, $location, anotacaoApiService, constantes, feedbackService) {
    var vm = this;
    var self = $scope;

    vm.anexos = [];
    vm.numProcesso = null;
    vm.pt = false;
    vm.pe = false;
    vm.tamPtPe = TAMANHO_PE;
    vm.refs = constantes.OPCOES_REFERENCIA_ANOTACAO;
    vm.salvar = salvar;
    vm.voltar = voltar;
    vm.marcarPt = marcarPt;
    vm.marcarPe = marcarPe;
    vm.mask = MASCARA_PE;

    carregarTela();

    function marcarPt() {
      if (vm.pt) {
        vm.tamPtPe = TAMANHO_PT;
        vm.pe = false;
        vm.mask = MASCARA_PT;
      }
      vm.numProcesso = null;
    }

    function marcarPe() {
      if (vm.pe) {
        vm.tamPtPe = TAMANHO_PE;
        vm.pt = false;
        vm.mask = MASCARA_PE;
      }
      vm.numProcesso = null;
    }

    function carregarTela() {
      return anotacaoApiService
        .telaCriar()
        .then(successObterDadosTelaInclusao);

      function successObterDadosTelaInclusao(resource) {
        vm.sistemasNegocio = resource._embedded.sistemasNegocio;
        vm._links = resource._links;
      }
    }

    function salvar() {
      var anotacaoNova = {
        documento: vm.anotacao.documento && vm.anotacao.documento.pk ? {
          pk: vm.anotacao.documento.pk
        } : null,
        instituicao: {
          idBacen: vm.anotacao.instituicao.idBacen
        },
        numeroPe: vm.pe ? vm.numProcesso : null,
        numeroPt: vm.pt ? vm.numProcesso : null,
        sistemaNegocio: vm.anotacao.sistemaNegocio,
        texto: vm.anotacao.texto
      };

      _.each(vm.refs, function(ref) {
        anotacaoNova[ref.id] = _.contains(vm.anotacao.idsRefSelecionados, ref.id);
      });

      return anotacaoApiService
        .criar(vm._links['anotacoes-criar'].href, anotacaoNova, vm.anexos)
        .then(successCriar);

      function successCriar(response) {
        if (response.status === HttpStatus.CREATED) {
          $location.path('/anotacoes');
          feedbackService.sucesso('Anotação salva com sucesso!');
        } else {
          feedbackService.violacoes(response.data);
        }
      }
    }

    function voltar() {
      $location.path('/anotacoes');
    }
  }
})(angular, httpStatusCode);
;
(function(angular, moment, $, parametrosUrl) {
  'use strict';

  var COLUNA_REFERENTE = 5;
  var MSG_ERRO_PERIODO = 'A data início deve ser menor ou igual à data fim.';
  var COLUNA_ACOES = 8;

  angular
    .module('crd')
    .controller('AnotacaoListarController', AnotacaoListarController);

  AnotacaoListarController.$inject = [
    '$scope',
    '$location',
    '$stateParams',
    'anotacaoApiService',
    'constantes',
    'DTColumnDefBuilder',
    'feedbackService'
  ];

  function AnotacaoListarController($scope, $location, $stateParams, anotacaoApiService,
    constantes, DTColumnDefBuilder, feedbackService) {
    var vm = this;

    vm.msgPeriodo = '';
    vm.refs = constantes.OPCOES_REFERENCIA_ANOTACAO;
    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.gerarXLSX = gerarXLSX;
    vm.excluir = excluir;
    vm.limparMensagens = limparMensagens;
    vm.esconderResultadoPesquisa = esconderResultadoPesquisa;
    vm.trackByAutor = trackByAutor;
    vm.validaPeriodo = validaPeriodo;

    inicializarView(vm);
    configurarGridResultados();
    carregarTela();

    function configurarGridResultados() {
      ordenarColunaReferenteA();

      vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(COLUNA_REFERENTE).withOption('type', 'custom-type-referente-pre'),
        DTColumnDefBuilder.newColumnDef(COLUNA_ACOES).withOption('bSortable', false)
      ];

      vm.dtOptions = {};
    }

    function trackByAutor(autor) {
      if (autor) {
        return autor.unidade + autor.operador;
      }
      return '';
    }

    function validaPeriodo() {
      if (vm.parametrosPesquisa && periodoInvalido()) {
        vm.msgPeriodo = MSG_ERRO_PERIODO;
        return false;
      }
      vm.msgPeriodo = '';
      return true;
    }

    function periodoInvalido() {
      if (!vm.parametrosPesquisa) {
        return true;
      }
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      var periodoInicio = moment.utc(parameters.dataInicio);
      var periodoFim = moment.utc(parameters.dataFim);
      var fim = vm.parametrosPesquisa.dataFim;
      var inicio = vm.parametrosPesquisa.dataInicio;
      return inicio && fim && periodoInicio.isAfter(periodoFim);
    }

    function carregarTela() {
      return anotacaoApiService
        .telaPesquisar()
        .then(successOnCarregarTelaPesquisar);

      function successOnCarregarTelaPesquisar(resource) {
        vm.sistemasNegocio = resource._embedded.sistemasNegocio;
        vm.autores = resource._embedded.autores;
        vm.podeIncluir = resource._links['anotacoes-tela-criar'];

        preencherParametrosIniciais(resource);
        pesquisar();
      }
    }

    function preencherParametrosIniciais(resource) {
      if (isEmpty($stateParams)) {
        vm.parametrosPesquisa = {
          autor: {
            nome:  resource.autor.nome,
            operador:  resource.autor.operador,
            unidade:  resource.autor.unidade
          },
          dataInicio: moment(resource.dataInicio).toDate()
        };
      } else {
        vm.parametrosPesquisa = extrairParametrosDaUrl($stateParams);

        if (vm.parametrosPesquisa.dataInicio === undefined) {
          vm.parametrosPesquisa.dataInicio = moment(resource.dataInicio).toDate();
        }
      }

      vm.parametrosPesquisa.idsRefSelecionados = preencherCampoReferenteA();
    }

    function preencherCampoReferenteA() {
      var idsRefSelecionados = [];

      var props = _.filter(_.keys(vm.parametrosPesquisa), function(propriedade) {
        return s.startsWith(propriedade, 'ref');
      });

      _.each(props, function(prop) {
        if (vm.parametrosPesquisa[prop]) {
          idsRefSelecionados.push(prop);
        }
      });
      return idsRefSelecionados;
    }

    function pesquisar() {
      var parametros = montarParametrosDaUrl(vm.parametrosPesquisa, vm.refs);

      $location.search(parametros);

      return anotacaoApiService
        .pesquisar(parametros)
        .then(successPesquisar);

      function successPesquisar(resource) {
        vm.resultadoPesquisa = resource._embedded.resultado;
        exibirResultadoPesquisa();
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.sistemaNegocio = undefined;
      vm.parametrosPesquisa.documento = undefined;
      vm.parametrosPesquisa.conglomerado = undefined;
      vm.parametrosPesquisa.instituicao = undefined;
      vm.parametrosPesquisa.idsRefSelecionados = undefined;
      vm.parametrosPesquisa.autor = undefined;
      vm.parametrosPesquisa.dataInicio = undefined;
      vm.parametrosPesquisa.dataFim = undefined;

      limparMensagens();
      esconderResultadoPesquisa();

      FormularioUtils.reset(form, this.$scope); // chamar sempre depois de setar o valor padrão.
    }

    function gerarXLSX() {
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa, vm.refs);
      return anotacaoApiService.gerarXLSX(parameters).then(function successOnGerarXLS() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      });
    }

    function excluir(anotacaoId) {
      $location.path('/anotacoes/' + anotacaoId + '/excluir');
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function exibirResultadoPesquisa() {
      vm.view.resultado.visivel = true;
    }
  }

  function inicializarView(model) {
    model.view = {
      formulario: {
        visivel: true
      },
      resultado: {
        visivel: false
      }
    };
  }

  function extrairParametrosDaUrl($stateParams) {
    var extrator = parametrosUrl.Extrator;
    return {
      autor: $stateParams.operador ? {
        operador: $stateParams.operador,
        unidade: $stateParams.unidade
      } : null,
      conglomerado: extrator.objetoCodigo($stateParams.conglomerado),
      dataFim: extrator.data($stateParams.dataFim),
      dataInicio: extrator.data($stateParams.dataInicio),
      documento: extrator.objetoPk($stateParams.documento),
      instituicao: extrator.objetoIdBacen($stateParams.idBacen),
      refOutros: $stateParams.refOutros,
      refQualidade: $stateParams.refQualidade,
      refTempestividade: $stateParams.refTempestividade,
      sistemaNegocio: extrator.objetoPk($stateParams.sistemaNegocio)
    };
  }

  function montarParametrosDaUrl(paramTela, refs) {
    var criador = parametrosUrl.Criador;

    var parametros = {
      conglomerado: criador.codigo(paramTela.conglomerado),
      dataFim: criador.data(paramTela.dataFim),
      dataInicio: criador.data(paramTela.dataInicio),
      documento: criador.pk(paramTela.documento),
      idBacen: criador.idBacen(paramTela.instituicao),
      operador: paramTela.autor ? paramTela.autor.operador : null,
      refOutros: null,
      refQualidade: null,
      refTempestividade: null,
      sistemaNegocio: criador.pk(paramTela.sistemaNegocio),
      unidade: paramTela.autor ? paramTela.autor.unidade : null
    };


    _.each(refs, function(ref) {
      if (_.contains(paramTela.idsRefSelecionados, ref.id)) {
        parametros[ref.id] = 'true';
      }
    });
    return parametros;
  }

  function ordenarColunaReferenteA() {
    var naoEncontrado = -1;
    $.fn.dataTable.ext.type.order['custom-type-referente-pre'] = function(item) {
      var result = '';
      _.each(item.split('</span>'), function(el) {
        if (el.indexOf('ng-hide') === naoEncontrado) {
          result += el.replace(/<.*?>/g, '').replace(/\s/g, '');
        }
      });
      return result;
    };
  }

  function isEmpty(obj) {
    // null and undefined are "empty"
    if (obj === null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (!angular.isObject(obj)) return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (obj[key]) return false;
    }

    return true;
  }
})(angular, moment, jQuery, CRDUtils.ParametrosUrl);
;
(function(angular, moment, $, parametrosUrl) {
  'use strict';

  var COLUNA_REFERENTE = 5;
  var COLUNA_ACOES = 8;
  var COLUNA_SISTEMA = 0;
  var COLUNA_DOCUMENTO = 1;
  var COLUNA_CONGLOMERADO = 2;
  var COLUNA_CNPJ = 3;
  var COLUNA_NOME = 4;
  var COLUNA_AUTOR = 6;
  var COLUNA_ULTIMA_ACAO = 7;

  angular
    .module('crd')
    .controller('AnotacaoListarHistoricoController', AnotacaoListarHistoricoController);

  AnotacaoListarHistoricoController.$inject = [
    '$location',
    '$stateParams',
    'anotacaoApiService',
    'constantes',
    'DTColumnDefBuilder',
    'feedbackService'
  ];

  function AnotacaoListarHistoricoController($location, $stateParams, anotacaoApiService,
    constantes, DTColumnDefBuilder, feedbackService) {
    var vm = this;
    vm.refs = constantes.OPCOES_REFERENCIA_ANOTACAO;
    vm.limparMensagens = limparMensagens;
    vm.voltar = voltar;
    configurarGridResultados();
    carregarTela();

    function configurarGridResultados() {
      ordenarColunaReferenteA();

      vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(COLUNA_SISTEMA).withOption('bSortable', false),
        DTColumnDefBuilder.newColumnDef(COLUNA_DOCUMENTO).withOption('bSortable', false),
        DTColumnDefBuilder.newColumnDef(COLUNA_CONGLOMERADO).withOption('bSortable', false),
        DTColumnDefBuilder.newColumnDef(COLUNA_CNPJ).withOption('bSortable', false),
        DTColumnDefBuilder.newColumnDef(COLUNA_NOME).withOption('bSortable', false),
        DTColumnDefBuilder.newColumnDef(COLUNA_REFERENTE)
        .withOption('bSortable', false)
        .withOption('type', 'custom-type-referente-pre'),
        DTColumnDefBuilder.newColumnDef(COLUNA_AUTOR).withOption('bSortable', false),
        DTColumnDefBuilder.newColumnDef(COLUNA_ULTIMA_ACAO).withOption('bSortable', false),
        DTColumnDefBuilder.newColumnDef(COLUNA_ACOES).withOption('bSortable', false)
      ];

      vm.dtOptions = {};
    }

    function carregarTela() {
      var id = $stateParams.id ? $stateParams.id : null;
      return anotacaoApiService
        .pesquisarHistorico(id)
        .then(successOnCarregarTelaPesquisar);

      function successOnCarregarTelaPesquisar(resource) {
        vm.resultadoPesquisa = resource._embedded.resultado;
      }
    }

    function voltar() {
      $location.path('/anotacoes');
    }

    function limparMensagens() {
      feedbackService.limpar();
    }
  }



  function ordenarColunaReferenteA() {
    var naoEncontrado = -1;
    $.fn.dataTable.ext.type.order['custom-type-referente-pre'] = function(item) {
      var result = '';
      _.each(item.split('</span>'), function(el) {
        if (el.indexOf('ng-hide') === naoEncontrado) {
          result += el.replace(/<.*?>/g, '').replace(/\s/g, '');
        }
      });
      return result;
    };
  }
})(angular, moment, jQuery, CRDUtils.ParametrosUrl);
;
(function(angular, moment, _, $, parametrosUrl) {
  'use strict';

  angular
    .module('crd')
    .controller('AtrasoSubstituicaoListarController', AtrasoSubstituicaoListarController);

  AtrasoSubstituicaoListarController.$inject = [
    '$timeout',
    '$scope',
    '$location',
    '$sce',
    '$stateParams',
    'AtrasoSubstituicaoAPIService',
    'documentoApiService',
    'feedbackService',
    'sistemaNegocioApiService'
  ];

  function AtrasoSubstituicaoListarController($timeout, $scope, $location, $sce, $stateParams, atrasoSubstituicaoAPIService, documentoApiService, feedbackService, sistemaNegocioApiService) {
    var vm = this;
    var extrairPorSelecionado;
    var periodicidadeSelecionada;

    vm.esconderResultadoPesquisa = esconderResultadoPesquisa;
    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.validarInstituicao = validarInstituicao;
    vm.validarConglomerado = validarConglomerado;
    vm.validarCooperativa = validarCooperativa;
    vm.validarConfederacaoCredito= validarConfederacaoCredito;
    vm.validarPeriodo = validarPeriodo;
    vm.naoExibirResultado = false;
    vm.mascaraData = '99/9999';
    vm.formatoData = 'MM/yyyy';
    vm.placeholderData = 'mm/aaaa';
    vm.checarMudancaExtrairPor = checarMudancaExtrairPor;
    vm.checarMudancaPeriodicidade = checarMudancaPeriodicidade;
    vm.sistemaNegocioConsultaFiltro = {};
    vm.documentoConsultaFiltro = {};

    inicializarView(vm);
    carregarTela();

    function checarMudancaExtrairPor(valor) {
      if (extrairPorSelecionado !== valor) {
        esconderResultadoPesquisa();
      }
      extrairPorSelecionado = valor;
    }

    function preencherSistemaNegocioConsultaFiltro(parametrosPesquisa){
      vm.sistemaNegocioConsultaFiltro.verificaSomenteAutorizado = true;
      vm.sistemaNegocioConsultaFiltro.grupoPeriodicidade = parametrosPesquisa.grupoPeriodicidade;
    }

    function preencherDocumentoConsultaFiltro(parametrosPesquisa){
      vm.documentoConsultaFiltro.grupoPeriodicidade = parametrosPesquisa.grupoPeriodicidade;
      vm.documentoConsultaFiltro.sistemasNegocio = ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.sistemasNegocio);
    }

    function checarMudancaPeriodicidade(valor) {
      if (periodicidadeSelecionada !== valor) {
        onChangeFormatoDataBase(vm.parametrosPesquisa);
        preencherSistemaNegocioConsultaFiltro(vm.parametrosPesquisa);
        preencherDocumentoConsultaFiltro(vm.parametrosPesquisa);

        limparMensagens();
        esconderResultadoPesquisa();
        vm.parametrosPesquisa.sistemasNegocio = null;
        vm.parametrosPesquisa.documentos = null;
        vm.parametrosPesquisa.dataBaseInicio = null;
        vm.parametrosPesquisa.dataBaseFim = null;

        $timeout(function(){vm.parametrosPesquisa.dataBaseInicio = dataInicioPadrao(vm.parametrosPesquisa);});
      }
      periodicidadeSelecionada = valor;
    }

    vm.onChangeSistemaNegocio = function(){
      esconderResultadoPesquisa();
      preencherDocumentoConsultaFiltro(vm.parametrosPesquisa);
    }

    function inicializarView(model) {
      model.view = {
        formulario: {
          visivel: true
        },
        resultado: {
          visivel: false
        }
      };
    }

    function carregarTela() {
      return atrasoSubstituicaoAPIService.paraPesquisar({}).then(function (resource) {
        var parametrosPesquisa = extrairParametrosDaUrl();
        vm.dataAtual = moment(new Date()).format('DD/MM/YYYY');
        vm.cabecalho = resource.data.cabecalhoAtrasoSubstituicao;
        vm.dadosFormularioPadrao = resource.data.dadosFormularioPadrao;
        vm.dadosFormularioPadrao.dataBaseInicio.MENOR_QUE_MENSAL = ConverterParameterUrlToObjectUtils.date(vm.dadosFormularioPadrao.dataBaseInicio.MENOR_QUE_MENSAL)
        vm.dadosFormularioPadrao.dataBaseInicio.MENSAL_OU_MAIOR = ConverterParameterUrlToObjectUtils.date(vm.dadosFormularioPadrao.dataBaseInicio.MENSAL_OU_MAIOR)

        var jaPesquisou = verificarParametroInformado();

        if(!jaPesquisou){
          parametrosPesquisa.extrairPor = vm.dadosFormularioPadrao.extrairPor;
          parametrosPesquisa.grupoPeriodicidade = vm.dadosFormularioPadrao.grupoPeriodicidade;
          parametrosPesquisa.dataBaseInicio = dataInicioPadrao(parametrosPesquisa);
        }

        onChangeFormatoDataBase(parametrosPesquisa);
        $timeout(function(){
          vm.parametrosPesquisa = parametrosPesquisa;

          preencherSistemaNegocioConsultaFiltro(vm.parametrosPesquisa);
          if (vm.parametrosPesquisa.sistemasNegocio
          && !_.isEmpty(vm.parametrosPesquisa.sistemasNegocio)
          && vm.parametrosPesquisa.sistemasNegocio.length > 0) {
            preencherDocumentoConsultaFiltro(vm.parametrosPesquisa);
          }
          if (jaPesquisou) {
            pesquisar();
          }
        });
      });
    }

    function verificarParametroInformado() {
      var conglomerado = $stateParams.conglomerado;
      var cooperativaCentral = $stateParams.cooperativaCentral;
      var confederacaoCredito = $stateParams.confederacaoCredito;
      var dataBaseFim = $stateParams.dataBaseFim;
      var dataBaseInicio = $stateParams.dataBaseInicio;
      var documentos = $stateParams.documentos;
      var extrairPor = $stateParams.extrairPor;
      var instituicao = $stateParams.instituicao;
      var grupoPeriodicidade = $stateParams.grupoPeriodicidade;
      var sistemasNegocio = $stateParams.sistemasNegocio;

      var formaExtracao = angular.isDefined(conglomerado) || angular.isDefined(cooperativaCentral) || angular.isDefined(confederacaoCredito) || angular.isDefined(instituicao);
      var datasOuPeriodicidadeDefinidas = angular.isDefined(dataBaseFim) || angular.isDefined(dataBaseInicio) || angular.isDefined(grupoPeriodicidade);
      var extrairPorOuSistemasNegociosOuDocumentosDefinidos = angular.isDefined(extrairPor) || angular.isDefined(sistemasNegocio) ||
        angular.isDefined(documentos);

      return formaExtracao || datasOuPeriodicidadeDefinidas || extrairPorOuSistemasNegociosOuDocumentosDefinidos;
    }

    vm.relatorioEmExcel = function relatorioEmExcel(parametrosPesquisa) {
      var parametros = prepararDadosParaPesquisa(parametrosPesquisa);
      atrasoSubstituicaoAPIService.relatorioEmExcel(parametros).then(function() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      });
    }

    vm.relatorioEmTexto = function relatorioEmTexto(parametrosPesquisa) {
      var parametros = prepararDadosParaPesquisa(parametrosPesquisa);
      atrasoSubstituicaoAPIService.relatorioEmTexto(parametros).then(function() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      });
    }

    function validarInstituicao(parametrosPesquisa) {
      if (parametrosPesquisa && instituicaoSelecionada(parametrosPesquisa) && !!!parametrosPesquisa.instituicao) {
        return false;
      }
      return true;
    }

    function validarConglomerado(parametrosPesquisa) {
      if (parametrosPesquisa && conglomeradoSelecionado(parametrosPesquisa) && !!!parametrosPesquisa.conglomerado) {
        return false;
      }
      return true;
    }

    function validarCooperativa(parametrosPesquisa) {
      if (parametrosPesquisa && cooperativaCentralSelecionada(parametrosPesquisa) && !!!parametrosPesquisa.cooperativaCentral) {
        return false;
      }
      return true;
    }

    function validarConfederacaoCredito(parametrosPesquisa) {
      if (parametrosPesquisa && confederacaoCreditoSelecionada(parametrosPesquisa) && !!!parametrosPesquisa.confederacaoCredito) {
        return false;
      }
      return true;
    }

    function validarPeriodo(parametrosPesquisa) {
      if (parametrosPesquisa && parametrosPesquisa.dataBaseFim && parametrosPesquisa.dataBaseInicio
          && parseInt(moment(parametrosPesquisa.dataBaseInicio).format('YYYYMMDD'))
          > parseInt(moment(parametrosPesquisa.dataBaseFim).format('YYYYMMDD'))) {
        return false;
      }
      return true;
    }


    function pesquisar() {
      limparMensagens();
      var parametros = prepararDadosParaPesquisa(vm.parametrosPesquisa);

      if (camposParaPesquisaInvalidos(parametros)) {
        exibirResultadoPesquisa();
        return null;
      }

      $location.search(parametros);

      return atrasoSubstituicaoAPIService.pesquisar(parametros).then(function sucessoOnPesquisar(resource) {
        vm.resultadoPesquisa = resource.data;
        exibirResultadoPesquisa();
      });
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.extrairPor = vm.dadosFormularioPadrao.extrairPor;
      vm.parametrosPesquisa.grupoPeriodicidade = vm.dadosFormularioPadrao.grupoPeriodicidade;

      vm.parametrosPesquisa.instituicao = undefined;
      vm.parametrosPesquisa.conglomerado = undefined;
      vm.parametrosPesquisa.cooperativaCentral = undefined;
      vm.parametrosPesquisa.confederacaoCredito = undefined;

      vm.parametrosPesquisa.sistemasNegocio = undefined;
      vm.parametrosPesquisa.documentos = undefined;

      checarMudancaPeriodicidade(vm.parametrosPesquisa.grupoPeriodicidade);

      vm.parametrosPesquisa.dataBaseInicio = dataInicioPadrao(vm.parametrosPesquisa);
      vm.parametrosPesquisa.dataBaseFim = undefined;

      limparMensagens();
      esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function onChangeFormatoDataBase(parametros) {
      if (periodicidadeEhDiaria(parametros.grupoPeriodicidade)) {
        vm.mascaraData = '99/99/9999';
        vm.formatoData = 'dd/MM/yyyy';
        vm.placeholderData = 'dd/mm/aaaa';
      } else {
        vm.mascaraData = '99/9999';
        vm.formatoData = 'MM/yyyy';
        vm.placeholderData = 'mm/aaaa';
      }
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function exibirResultadoPesquisa() {
      vm.view.resultado.visivel = true;
    }

    function camposParaPesquisaInvalidos(parametros) {
      return !validarCamposObrigatoriosPreenchidos(parametros) || datasInvalidas(parametros);
    }

    function validarCamposObrigatoriosPreenchidos(parametros) {
      if (!parametros.dataBaseInicio) {
        return false;
      }

      if (instituicaoSelecionada(parametros) && !parametros.instituicao) {
        feedbackService.erro('A entidade supervisionada não está preenchida.');
        return false;
      }

      if (conglomeradoSelecionado(parametros) && !parametros.conglomerado) {
        feedbackService.erro('O conglomerado não está preenchido.');
        return false;
      }

      if (cooperativaCentralSelecionada(parametros) && !parametros.cooperativaCentral) {
        feedbackService.erro('A cooperativa central não está preenchida.');
        return false;
      }

      if (confederacaoCreditoSelecionada(parametros) && !parametros.confederacaoCredito) {
        feedbackService.erro('A confederação não está preenchida.');
        return false;
      }

      return true;
    }

    function datasInvalidas(parametros) {
      var dataBaseFim = moment.utc(parametros.dataBaseFim);
      var dataBaseInicio = moment.utc(parametros.dataBaseInicio);

      if (dataBaseInicio.isAfter(dataBaseFim)) {
        feedbackService.erro(' Data-base início posterior a Data-base fim.');
        return true;
      }

      if (periodicidadeEhMensal(parametros.grupoPeriodicidade)) {
        var diferencaEntreMeses = dataBaseFim.diff(dataBaseInicio, 'months');
        var diferencaMaximoMeses = 12;
        if (diferencaEntreMeses >= diferencaMaximoMeses) {
          feedbackService.erro('Favor indicar um período menor ou igual a 1 ano.');
          return true;
        }
      } else {
        var diferencaEntreDatas = dataBaseFim.diff(dataBaseInicio, 'months');
        var diferencaMaximoMes = 1;
        if (diferencaEntreDatas >= diferencaMaximoMes) {
          feedbackService.erro('Favor indicar um período menor ou igual a 1 mês.');
          return true;
        }
      }
      return false;
    }

    function extrairParametrosDaUrl() {
      var extrator = parametrosUrl.Extrator;
      var parametrosExtraidos = {};

      parametrosExtraidos.extrairPor = $stateParams.extrairPor;
      parametrosExtraidos.grupoPeriodicidade = $stateParams.grupoPeriodicidade;
      parametrosExtraidos.dataBaseInicio = extrator.data($stateParams.dataBaseInicio);
      parametrosExtraidos.dataBaseFim = extrator.data($stateParams.dataBaseFim);
      parametrosExtraidos.instituicao = extrator.objetoIdBacen($stateParams.instituicao);
      parametrosExtraidos.sistemasNegocio = extrator.arrayObjetoPk($stateParams.sistemasNegocio);
      parametrosExtraidos.documentos = extrator.arrayObjetoPk($stateParams.documentos);
      parametrosExtraidos.conglomerado = extrator.objetoCodigo($stateParams.conglomerado);
      parametrosExtraidos.cooperativaCentral = extrator.objetoIdBacen($stateParams.cooperativaCentral);
      parametrosExtraidos.confederacaoCredito = extrator.objetoIdBacen($stateParams.confederacaoCredito);
      return parametrosExtraidos;
    }

    function dataInicioPadrao(parametros) {
      return vm.dadosFormularioPadrao.dataBaseInicio[parametros.grupoPeriodicidade];
    }
  }

  function montarParametrosDaUrl(parametrosPesquisa) {
    var criador = parametrosUrl.Criador;
    return {
      extrairPor: parametrosPesquisa.extrairPor,
      instituicao: criador.idBacen(parametrosPesquisa.instituicao),
      conglomerado: criador.codigo(parametrosPesquisa.conglomerado),
      cooperativaCentral: criador.idBacen(parametrosPesquisa.cooperativaCentral),
      confederacaoCredito: criador.idBacen(parametrosPesquisa.confederacaoCredito),
      grupoPeriodicidade: parametrosPesquisa.grupoPeriodicidade,
      sistemasNegocio: criador.arrayObjetoPk(parametrosPesquisa.sistemasNegocio),
      documentos: criador.arrayObjetoPk(parametrosPesquisa.documentos),
      dataBaseInicio: criador.data(parametrosPesquisa.dataBaseInicio),
      dataBaseFim: criador.data(parametrosPesquisa.dataBaseFim),
    };
  }

  function prepararDadosParaPesquisa(parametrosPesquisa) {
    var parametros = montarParametrosDaUrl(parametrosPesquisa);
    var snPks = _.map(parametros.sistemasNegocio, function(value) {
      return value.pk;
    });
    parametros.sistemasNegocio = snPks;

    var docsPks = _.map(parametros.documentos, function(value) {
      return value.pk;
    });
    parametros.documentos = docsPks;

    if (instituicaoSelecionada(parametros)) {
      parametros.conglomerado = null;
      parametros.cooperativaCentral = null;
      parametros.confederacaoCredito = null;
    } else if (conglomeradoSelecionado(parametros)) {
      parametros.instituicao = null;
      parametros.cooperativaCentral = null;
      parametros.confederacaoCredito = null;
    } else if (cooperativaCentralSelecionada(parametros)) {
      parametros.instituicao = null;
      parametros.conglomerado = null;
      parametros.confederacaoCredito = null;
    } else if (confederacaoCreditoSelecionada(parametros)) {
      parametros.instituicao = null;
      parametros.cooperativaCentral = null;
      parametros.conglomerado = null;
    }

    if (!parametros.dataBaseFim) {
      if (periodicidadeEhMensal(parametros.grupoPeriodicidade)) {
        parametros.dataBaseFim = preencherDataFimMensal(parametros.CriticaQualidade);
      } else {
        parametros.dataBaseFim = preencherDataFimDiaria(parametros.dataBaseInicio);
      }
    }

    return parametros;
  }

  function preencherDataFimDiaria(dataBaseInicio) {
    var QUANTIDADE_MES_LIMITE = 1;
    var dataBase = moment.utc(dataBaseInicio).add(QUANTIDADE_MES_LIMITE, 'months');
    dataBase = dataBase.subtract(1, 'days');

    var diferencaDasDatasD = hoje().diff(dataBase, 'days');
    if (diferencaDasDatasD > 1) {
      return formatarDataYYYYMMDD(dataBase);
    }
    return formatarDataYYYYMMDD(ontem());
  }

  function preencherDataFimMensal(dataBaseInicio) {
    var QUANTIDADE_ANOS_LIMITE = 1;
    var dataBase = moment.utc(dataBaseInicio).add(QUANTIDADE_ANOS_LIMITE, 'years');
    dataBase = dataBase.subtract(1, 'months');

    var inicioDoMes = primeiroDiaDoMesAtual();
    var diferencaEntreAsDatas = inicioDoMes.diff(dataBase, 'days');
    if (diferencaEntreAsDatas > 1) {
      return formatarDataYYYYMMDD(dataBase);
    }
    var ultimoDiaMesAnterior = primeiroDiaDoMesAtual().subtract(1, 'days');
    return formatarDataYYYYMMDD(ultimoDiaMesAnterior);
  }

  function instituicaoSelecionada(parametros) {
    return parametros.extrairPor === 'INSTITUICAO_FINANCEIRA';
  }

  function conglomeradoSelecionado(parametros) {
    return parametros.extrairPor === 'CONGLOMERADO';
  }

  function cooperativaCentralSelecionada(parametros) {
    return parametros.extrairPor === 'COOPERATIVA_CENTRAL';
  }

  function confederacaoCreditoSelecionada(parametros) {
    return parametros.extrairPor === 'CONFEDERACAO_CREDITO';
  }

  function periodicidadeEhMensal(grupoPeriodicidade) {
    return grupoPeriodicidade === 'MENSAL_OU_MAIOR';
  }

  function periodicidadeEhDiaria(grupoPeriodicidade) {
    return grupoPeriodicidade === 'MENOR_QUE_MENSAL';
  }

  function primeiroDiaDoMesAtual() {
    return moment.utc().startOf('month');
  }

  function hoje() {
    return moment.utc();
  }

  function ontem() {
    return moment.utc().subtract(1, 'days');
  }

  function formatarDataYYYYMMDD(data) {
    return data.format('YYYY-MM-DD');
  }
})(angular, moment, _, jQuery, CRDUtils.ParametrosUrl);
;
(function(angular, moment, parametrosUrl) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdModalAtrasoSubstituicaoDetalheController', CrdModalAtrasoSubstituicaoDetalheController);

  CrdModalAtrasoSubstituicaoDetalheController.$inject = ['$scope', '$uibModalInstance', 'AtrasoSubstituicaoAPIService'];

  function CrdModalAtrasoSubstituicaoDetalheController($scope, $uibModalInstance, atrasoSubstituicaoAPIService) {
    var vm = this;
    vm.cancel = cancel;
    vm.labelEntidadeSupervisionada;
    pesquisar();

    function pesquisar() {
      return atrasoSubstituicaoAPIService.pesquisarDetalhe($scope.filtro).then(function successOnTelaPesquisar(resource) {
        vm.item = resource.data;
      });
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    vm.getitemPeriodoClass = function getitemPeriodoClass(itemPeriodo) {
      if(!itemPeriodo.esperado){
        return 'documento-nao-esperado';
      }

      const cssClass = [];
      if (!itemPeriodo.entregue) {
        cssClass.push('documento-nao-entregue');
      }

      if (itemPeriodo.possuiExcecao) {
        cssClass.push('documento-possui-excecao');
      }

      return cssClass.join(' ');
    }
  }

})(angular, moment, CRDUtils.ParametrosUrl);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdModalAtrasoSubstituicaoDetalhe', CrdModalAtrasoSubstituicaoDetalhe);

  CrdModalAtrasoSubstituicaoDetalhe.$inject = ['$uibModal'];

  function CrdModalAtrasoSubstituicaoDetalhe($uibModal) {
    var directive = {
      link: postLink,
      restrict: 'A',
      scope: {
        filtro: '=',
        parametrosPesquisa: '='
      }
    };

    return directive;

    function postLink($scope, $element) {
      $element.bind('click', function() {
        $uibModal.open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          controller: 'CrdModalAtrasoSubstituicaoDetalheController',
          controllerAs: 'crdModalAtrasoSubstituicaoDetalheCtrl',
          keyboard: false,
          scope: $scope,
          templateUrl: 'views/atraso-substituicao/crd-modal-atraso-substituicao-detalhe-tpl.html'
        });
      });
    }
  }
})(angular);
;
"use strict";
//# sourceMappingURL=atraso-substituicao-consulta-filtro.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AtrasoSubstituicaoAPIService = (function (_super) {
    __extends(AtrasoSubstituicaoAPIService, _super);
    function AtrasoSubstituicaoAPIService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    AtrasoSubstituicaoAPIService.prototype.paraPesquisar = function (atrasoSubstituicaoConsultaFiltro) {
        return this.buscarRecurso('/atraso-substituicao/para-pesquisar', atrasoSubstituicaoConsultaFiltro);
    };
    AtrasoSubstituicaoAPIService.prototype.pesquisar = function (atrasoSubstituicaoConsultaFiltro) {
        return this.pesquisarRecurso('/atraso-substituicao/pesquisar', atrasoSubstituicaoConsultaFiltro);
    };
    AtrasoSubstituicaoAPIService.prototype.pesquisarDetalhe = function (atrasoSubstituicaoConsultaFiltro) {
        return this.buscarRecurso('/atraso-substituicao/pesquisar-detalhe', atrasoSubstituicaoConsultaFiltro);
    };
    AtrasoSubstituicaoAPIService.prototype.relatorioEmExcel = function (atrasoSubstituicaoConsultaFiltro) {
        return this.baixarArquivo('/atraso-substituicao/relatorio-em-excel', atrasoSubstituicaoConsultaFiltro);
    };
    AtrasoSubstituicaoAPIService.prototype.relatorioEmTexto = function (atrasoSubstituicaoConsultaFiltro) {
        return this.baixarArquivo('/atraso-substituicao/relatorio-em-texto', atrasoSubstituicaoConsultaFiltro);
    };
    return AtrasoSubstituicaoAPIService;
}(AbstractAPISerivce));
AtrasoSubstituicaoAPIService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('AtrasoSubstituicaoAPIService', AtrasoSubstituicaoAPIService);
//# sourceMappingURL=atraso-substituicao-api-service.js.map;
"use strict";
var AtrasoSubstituicaoConsultarTabelaController = (function () {
    function AtrasoSubstituicaoConsultarTabelaController() {
    }
    AtrasoSubstituicaoConsultarTabelaController.prototype.$onInit = function () { };
    AtrasoSubstituicaoConsultarTabelaController.prototype.getitemPeriodoClass = function (itemPeriodo) {
        if (itemPeriodo.impedido) {
            return 'documento-situacao-impedido';
        }
        if (!itemPeriodo.esperado) {
            return 'documento-nao-esperado';
        }
        var cssClass = [];
        if (itemPeriodo.impedido) {
            cssClass.push('documento-situacao-impedido');
        }
        else {
            if (!itemPeriodo.entregue) {
                cssClass.push('documento-nao-entregue');
            }
            if (itemPeriodo.possuiExcecao) {
                cssClass.push('documento-possui-excecao');
            }
        }
        return cssClass.join(' ');
    };
    return AtrasoSubstituicaoConsultarTabelaController;
}());
AtrasoSubstituicaoConsultarTabelaController.$inject = [];
angular.module('crd').controller('AtrasoSubstituicaoConsultarTabelaController', AtrasoSubstituicaoConsultarTabelaController);
//# sourceMappingURL=atraso-substituicao-consultar-tabela-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('atrasoSubstituicaoConsultarTabela', AtrasoSubstituicaoConsultarTabela);

  function AtrasoSubstituicaoConsultarTabela() {
    var directive = {
      controller: 'AtrasoSubstituicaoConsultarTabelaController',
      controllerAs: 'atrasoSubstituicaoConsultarTabelaCtrl',
      link: postLink,
      //require: 'AtrasoSubstituicaoConsultarTabelaController',
      restrict: 'E',
      bindToController: true,
      scope: {
        item: '=',
        titulo: '=',
        tipo: '='
      },
      templateUrl: 'views/atraso-substituicao/views/consultar/atraso-substituicao-consultar-tabela-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes, controller) {

    }
  }
})(angular);
;
"use strict";
var AuditoriaObservanciaAlterarController = (function () {
    function AuditoriaObservanciaAlterarController($state, auditoriaObservanciaApiService, feedbackService, $scope) {
        this.$state = $state;
        this.auditoriaObservanciaApiService = auditoriaObservanciaApiService;
        this.feedbackService = feedbackService;
        this.$scope = $scope;
        this.anexoAlterado = false;
        this.dataCriticaHabilitada = true;
        this.dataCriticaObrigatoria = false;
        this.exibirNumeroPE = false;
    }
    AuditoriaObservanciaAlterarController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        return this.auditoriaObservanciaApiService.montarTelaAlterar(pk).then(function (resource) {
            _this.dadosFormulario = resource;
            _this.auditoriaObservancia = resource.auditoriaObservancia;
            _this.anexarArquivoVindoDoBackend();
            _this.onTipoProcedimentoAlterado();
            _this.auditoriaObservancia.dataCriticaObjeto = ConverterParameterUrlToObjectUtils.date(_this.auditoriaObservancia.dataCritica);
            _this.finalizouProcessamentoNaDataDeHoje = _this.dadosFormulario.finalizouProcessamentoNaDataDeHoje;
        });
    };
    AuditoriaObservanciaAlterarController.prototype.anexarArquivoVindoDoBackend = function () {
        if (this.auditoriaObservancia.pdfSumulaAPS) {
            var arquivoFile = AuditoriaObservanciaUtils.blobToFile(AuditoriaObservanciaUtils.gerarArquivoBlob(this.auditoriaObservancia.pdfSumulaAPS), this.auditoriaObservancia.nomeArquivoPDF);
            this.auditoriaObservancia.anexo = {
                pk: null,
                nomeArquivo: this.auditoriaObservancia.nomeArquivoPDF,
                type: "application/pdf",
                size: arquivoFile.size,
                file: arquivoFile
            };
        }
    };
    AuditoriaObservanciaAlterarController.prototype.$onInit = function () {
        var _this = this;
        this.hoje = new Date().toLocaleDateString('pt-BR');
        this.carregarDadosTela(this.$state.params.pk).then(function () {
            _this.escutarCamposParaExibirApontamento();
        });
    };
    AuditoriaObservanciaAlterarController.prototype.escutarCamposParaExibirApontamento = function () {
        var _this = this;
        this.$scope.$watchGroup([
            function () { return _this.auditoriaObservancia.instituicao; },
            function () { return _this.auditoriaObservancia.tipoProcedimento; },
            function () { return _this.auditoriaObservancia.referencias; }
        ], function (novosValores) {
            var instituicao = novosValores[0], tipoProcedimento = novosValores[1], referencias = novosValores[2];
            _this.exibirDadosAPS = AuditoriaObservanciaUtils.deveExibirCamposAPS(instituicao, tipoProcedimento, referencias);
        });
    };
    AuditoriaObservanciaAlterarController.prototype.salvar = function (pao) {
        var _this = this;
        var paoParaSalvar = this.converterParaEnviarServidor(pao);
        if (this.anexoAlterado) {
            AuditoriaObservanciaUtils.fileToBase64(this.auditoriaObservancia.anexo.file, function (_a) {
                var base64 = _a.base64;
                paoParaSalvar.pdfSumulaAPS = base64;
                paoParaSalvar.nomeArquivoPDF = _this.auditoriaObservancia.anexo.nomeArquivo;
                _this.salvarAlteracoes(paoParaSalvar);
            }, function (error) {
                _this.feedbackService.violacoes(["Erro ao fazero o envio do novo PDF!"]);
            });
        }
        else {
            this.limparDadosAPS(paoParaSalvar);
            this.salvarAlteracoes(paoParaSalvar);
        }
    };
    AuditoriaObservanciaAlterarController.prototype.limparDadosAPS = function (paoParaSalvar) {
        if (!this.exibirDadosAPS) {
            paoParaSalvar.acaoSigas = undefined;
            paoParaSalvar.prazoAPS = undefined;
            paoParaSalvar.sumulaAPS = undefined;
            paoParaSalvar.pdfSumulaAPS = undefined;
            paoParaSalvar.nomeArquivoPDF = undefined;
        }
    };
    AuditoriaObservanciaAlterarController.prototype.salvarAlteracoes = function (paoParaSalvar) {
        var _this = this;
        this.auditoriaObservanciaApiService.executarAcao(this.auditoriaObservancia.pk, "ALTERAR", paoParaSalvar).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso('Procedimento da auditoria de observância alterado com sucesso.');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    AuditoriaObservanciaAlterarController.prototype.gerarPdf = function () {
        if (this.exibirDadosAPS) {
            this.anexoAlterado = true;
            this.buscarSumulaApontamentoAPS(this.auditoriaObservancia.instituicao.idBacen);
        }
    };
    AuditoriaObservanciaAlterarController.prototype.buscarSumulaApontamentoAPS = function (idBacen) {
        var _this = this;
        var filtro = this.perpararFiltro(idBacen);
        this.auditoriaObservanciaApiService.buscarSumulaApontamentoAPS(this.montarUrlSumulaAPS(), filtro)
            .then(function (resource) {
            _this.auditoriaObservancia.acaoSigas = resource.data.acaoSigas;
            _this.auditoriaObservancia.prazoAPS = resource.data.prazoAPS;
            _this.auditoriaObservancia.sumulaAPS = resource.data.sumulaAPS;
            _this.auditoriaObservancia.pdfSumulaAPS = resource.data.pdfBase64;
            _this.auditoriaObservancia.nomeArquivoPDF = resource.data.nomeArquivoPDF;
            _this.anexoAlterado = true;
            _this.habilitarBotaoSalvar();
            _this.anexarArquivoVindoDoBackend();
        });
    };
    AuditoriaObservanciaAlterarController.prototype.habilitarBotaoSalvar = function () {
        var _this = this;
        this.$scope.$evalAsync(function () {
            var form = _this.$scope.formAlterarAuditoriaObservancia;
            if (form && form.$setDirty)
                form.$setDirty();
        });
    };
    AuditoriaObservanciaAlterarController.prototype.perpararFiltro = function (idBacen) {
        var inicio = new Date();
        inicio.setFullYear(inicio.getFullYear() - 5);
        return {
            instituicao: idBacen,
            dataBaseFim: new Date().toISOString().split('T')[0],
            dataBaseInicio: inicio.toISOString().split('T')[0]
        };
    };
    AuditoriaObservanciaAlterarController.prototype.montarUrlSumulaAPS = function () {
        return this.dadosFormulario._links['crd-raiz'].href + "atraso-substituicao/relatorio-pdf";
    };
    AuditoriaObservanciaAlterarController.prototype.podeAlterarCamposAPS = function () {
        return this.dadosFormulario.camposEditaveis.indexOf('SUMULA_APS') >= 0;
    };
    AuditoriaObservanciaAlterarController.prototype.converterParaEnviarServidor = function (pao) {
        return {
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(pao.instituicao),
            tipo: ConverterParameterObjectToUrlUtils.atributoEnumName(pao.tipoProcedimento),
            numeroPE: AuditoriaObservanciaUtils.converterNumeroPEParaNumero(pao.numeroPE),
            referencias: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(pao.referencias),
            dataCritica: ConverterParameterObjectToUrlUtils.date(pao.dataCriticaObjeto),
            comentarioAuditor: pao.comentarioAuditor,
            comentarioChefia: pao.comentarioChefia,
            comentarioSupervisor: pao.comentarioSupervisor,
            dadosExecucao: pao.dadosExecucao,
            sumulaApontamento: pao.sumulaApontamento,
            dadosRelatorio: pao.dadosRelatorio,
            acaoSigas: ConverterParameterObjectToUrlUtils.number(pao.acaoSigas),
            prazoAPS: ConverterParameterObjectToUrlUtils.number(pao.prazoAPS),
            sumulaAPS: pao.sumulaAPS,
            pdfSumulaAPS: pao.pdfSumulaAPS,
            nomeArquivoPDF: pao.nomeArquivoPDF
        };
    };
    AuditoriaObservanciaAlterarController.prototype.onAnexosAlterados = function () {
        this.anexoAlterado = true;
        this.atualizarTextoDetalhamentoSumulaAPS();
    };
    AuditoriaObservanciaAlterarController.prototype.atualizarTextoDetalhamentoSumulaAPS = function () {
        this.auditoriaObservancia.sumulaAPS = this.auditoriaObservancia.sumulaAPS.replace(/\(\s*situação verificada em \d{2}\/\d{2}\/\d{4}\s*\)/i, "(situa\u00E7\u00E3o verificada em " + this.hoje + ")");
    };
    AuditoriaObservanciaAlterarController.prototype.onInstituicaoAlterada = function () {
        this.auditoriaObservancia.anexo = undefined;
    };
    AuditoriaObservanciaAlterarController.prototype.onTipoProcedimentoAlterado = function () {
        this.exibirNumeroPE = AuditoriaObservanciaUtils.deveExibirNumeroPE(this.auditoriaObservancia.tipoProcedimento);
        if (!this.exibirNumeroPE) {
            this.auditoriaObservancia.numeroPE = undefined;
        }
        if (!this.auditoriaObservancia.tipoProcedimento) {
            return;
        }
        if (this.auditoriaObservancia.tipoProcedimento.enumName === 'OBSERVAR_POR_UM_PERIODO') {
            this.dataCriticaHabilitada = true;
            this.dataCriticaObrigatoria = true;
        }
        else if (this.auditoriaObservancia.tipoProcedimento.enumName === 'NAO_ADOTAR_PROCEDIMENTO') {
            this.dataCriticaHabilitada = false;
            this.dataCriticaObrigatoria = false;
            this.auditoriaObservancia.dataCriticaObjeto = undefined;
        }
        else {
            this.dataCriticaHabilitada = true;
            this.dataCriticaObrigatoria = false;
        }
    };
    AuditoriaObservanciaAlterarController.prototype.voltar = function () {
        this.$state.go('auditoria-observancia-detalhar', { pk: this.auditoriaObservancia.pk });
    };
    return AuditoriaObservanciaAlterarController;
}());
AuditoriaObservanciaAlterarController.$inject = ['$state', 'AuditoriaObservanciaApiService', 'feedbackService', '$scope'];
angular.module('crd').controller('AuditoriaObservanciaAlterarController', AuditoriaObservanciaAlterarController);
//# sourceMappingURL=auditoria-observancia-alterar-controller.js.map;
"use strict";
var AuditoriaObservanciaDetalheController = (function () {
    function AuditoriaObservanciaDetalheController($state, auditoriaObservanciaApiService, feedbackService, $scope, $uibModal) {
        this.$state = $state;
        this.auditoriaObservanciaApiService = auditoriaObservanciaApiService;
        this.feedbackService = feedbackService;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
    }
    AuditoriaObservanciaDetalheController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.auditoriaObservanciaApiService.montarTelaDetalhe(pk).then(function (resource) {
            _this.auditoriaObservancia = resource;
            _this.exibirNumeroPE = AuditoriaObservanciaUtils.deveExibirNumeroPE(resource.tipoProcedimento);
            _this.aplicarMascaraAcaoSigas(_this.auditoriaObservancia);
            _this.exibirCamposAPS = _this.controlarExibicaoCamposParaApontamentoAPS();
        });
    };
    AuditoriaObservanciaDetalheController.prototype.aplicarMascaraAcaoSigas = function (auditoriaObservancia) {
        var acaoSigas = auditoriaObservancia.acaoSigas;
        if (acaoSigas || acaoSigas === 0) {
            var acaoSigasMascarada = acaoSigas.toString();
            auditoriaObservancia.acaoSigas = acaoSigasMascarada.padStart(9, '0');
        }
    };
    AuditoriaObservanciaDetalheController.prototype.excluir = function (pk) {
        var _this = this;
        return this.auditoriaObservanciaApiService.excluir(pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Procedimento da auditoria de observância excluído com sucesso.');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    AuditoriaObservanciaDetalheController.prototype.voltar = function () {
        this.$state.go('auditoria-observancia-pesquisa');
    };
    AuditoriaObservanciaDetalheController.prototype.resolverAcaoSelecionada = function (tipoAcao) {
        if (tipoAcao === "ENCAMINHAR_ENCERRAMENTO" || tipoAcao === "ENCERRAR") {
            this.openModalSituacaoResolvida(tipoAcao);
        }
        else {
            this.executarAcao(tipoAcao);
        }
    };
    AuditoriaObservanciaDetalheController.prototype.openModalSituacaoResolvida = function (tipoAcao) {
        var _this = this;
        var scope = this.$scope.$new();
        scope.tipoAcao = tipoAcao;
        scope.situacaoRegularizadaProcedimento = this.auditoriaObservancia.situacaoRegularizada;
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: 'views/auditoria-observancia/auditoria-observancia-modal-situacao-regularizada/auditoria-observancia-modal-situacao-regularizada-tpl.html',
            controller: 'AuditoriaObservanciaModalSituacaoRegularizadaController',
            controllerAs: 'ctrl',
            bindToController: true,
            keyboard: true,
            size: 'sm',
            scope: scope
        })
            .result.then(function (situacaoRegularizada) {
            _this.auditoriaObservancia.situacaoRegularizada = situacaoRegularizada;
            var procedimentoAuditoriaObservanciaManutencao = _this.converterParaEnviarServidor(_this.auditoriaObservancia);
            _this.executarAcaoComAlteracao(tipoAcao, procedimentoAuditoriaObservanciaManutencao);
        });
    };
    AuditoriaObservanciaDetalheController.prototype.executarAcao = function (tipoAcao) {
        var _this = this;
        this.auditoriaObservanciaApiService.executarAcao(this.auditoriaObservancia.pk, tipoAcao, {})
            .then(function (resource) {
            if (resource.status === 201) {
                var mensagem = 'Procedimento da auditoria de observância alterado com sucesso.';
                switch (tipoAcao) {
                    case "SUBMETER_COORDENACAO":
                        mensagem = 'Procedimento submetido à coordenação com sucesso!';
                        break;
                    case "ENCAMINHAR_CHEFIA":
                        mensagem = 'Procedimento encaminhado à chefia com sucesso!';
                        break;
                    case "APRESENTAR_SUPERVISAO":
                        mensagem = 'Procedimento apresentado à supervisão com sucesso!';
                        break;
                    case "ENCAMINHAR_DECON":
                        mensagem = "Procedimento encaminhado ao Decon com sucesso!";
                        break;
                    case "CONFIRMAR":
                        mensagem = 'Procedimento confirmado com sucesso!';
                        break;
                    case "REABRIR":
                        mensagem = 'Procedimento reaberto com sucesso!';
                        break;
                    case "DEVOLVER":
                        mensagem = 'Procedimento devolvido com sucesso!';
                        break;
                    case "CANCELAR":
                        mensagem = 'Procedimento cancelado com sucesso!';
                        break;
                    default:
                        mensagem = 'Procedimento da auditoria de observância alterado com sucesso.';
                }
                _this.feedbackService.sucesso(mensagem);
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    AuditoriaObservanciaDetalheController.prototype.executarAcaoComAlteracao = function (tipoAcao, procedimento) {
        var _this = this;
        this.auditoriaObservanciaApiService.executarAcao(this.auditoriaObservancia.pk, tipoAcao, procedimento)
            .then(function (resource) {
            if (resource.status === 201) {
                var mensagem = 'Procedimento da auditoria de observância alterado com sucesso.';
                switch (procedimento.tipoAcao) {
                    case "ENCAMINHAR_ENCERRAMENTO":
                        mensagem = 'Procedimento encaminhado para encerramento com sucesso!';
                        break;
                    case "ENCERRAR":
                        mensagem = 'Procedimento encerrado com sucesso!';
                        break;
                    default:
                        mensagem = 'Procedimento da auditoria de observância alterado com sucesso.';
                }
                _this.feedbackService.sucesso(mensagem);
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    AuditoriaObservanciaDetalheController.prototype.converterParaEnviarServidor = function (pao) {
        return {
            idBacen: pao.instituicao ? pao.instituicao.idBacen : '',
            tipo: ConverterParameterObjectToUrlUtils.atributoEnumName(pao.tipoProcedimento),
            referencias: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(pao.referencias),
            dataCritica: pao.dataCritica,
            comentarioAuditor: pao.comentarioAuditor,
            comentarioChefia: pao.comentarioChefia,
            comentarioSupervisor: pao.comentarioSupervisor,
            dadosExecucao: pao.dadosExecucao,
            sumulaApontamento: pao.sumulaApontamento,
            dadosRelatorio: pao.dadosRelatorio,
            situacaoRegularizada: pao.situacaoRegularizada
        };
    };
    AuditoriaObservanciaDetalheController.prototype.$onInit = function () {
        this.textoConfirmacao = "Deseja confiamar o procedimento?";
        return this.carregarDadosTela(this.$state.params.pk);
    };
    AuditoriaObservanciaDetalheController.prototype.controlarExibicaoCamposParaApontamentoAPS = function () {
        if (!this.auditoriaObservancia)
            return false;
        var _a = this.auditoriaObservancia, tipoProcedimento = _a.tipoProcedimento, referencias = _a.referencias;
        var eTipoApontamentoAPS = tipoProcedimento && tipoProcedimento.nome === 'Apontamento no APS';
        var eArrayComApenas1Referencia = Array.isArray(referencias) && referencias.length === 1;
        var referenciaETempestividade = referencias && referencias.some(function (referencia) { return referencia.nome === 'Tempestividade'; });
        return eTipoApontamentoAPS && eArrayComApenas1Referencia && referenciaETempestividade;
    };
    AuditoriaObservanciaDetalheController.prototype.abrirPdf = function () {
        AuditoriaObservanciaUtils.abrirPdf(this.auditoriaObservancia.pdfSumulaAPS, this.auditoriaObservancia.nomeArquivoPDF);
    };
    return AuditoriaObservanciaDetalheController;
}());
AuditoriaObservanciaDetalheController.$inject = ['$state', 'AuditoriaObservanciaApiService', 'feedbackService', '$scope', '$uibModal'];
angular.module('crd').controller('AuditoriaObservanciaDetalheController', AuditoriaObservanciaDetalheController);
//# sourceMappingURL=auditoria-observancia-detalhe-controller.js.map;
"use strict";
var AuditoriaObservanciaIncluirController = (function () {
    function AuditoriaObservanciaIncluirController($state, auditoriaObservanciaApiService, feedbackService, $scope) {
        this.$state = $state;
        this.auditoriaObservanciaApiService = auditoriaObservanciaApiService;
        this.feedbackService = feedbackService;
        this.$scope = $scope;
        this.dataCriticaHabilitada = true;
        this.dataCriticaObrigatoria = false;
        this.exibirNumeroPE = false;
    }
    AuditoriaObservanciaIncluirController.prototype.$onInit = function () {
        var _this = this;
        return this.auditoriaObservanciaApiService.montarTelaIncluir().then(function (resource) {
            _this.exibirDadosAPS = true;
            _this.dadosFormulario = resource;
            _this.auditoriaObservancia = _this.dadosFormulario.auditoriaObservancia;
            _this.finalizouProcessamentoNaDataDeHoje = _this.dadosFormulario.finalizouProcessamentoNaDataDeHoje;
            _this.hoje = new Date().toLocaleDateString('pt-BR');
            if (_this.$state.params.idbacen) {
                _this.podeAlterarInstituicao = false;
                _this.telaRetorno = _this.$state.params.telaRetorno;
                _this.auditoriaObservancia.instituicao = ConverterParameterUrlToObjectUtils.atributoIdBacen(_this.$state.params.idbacen);
                _this.eSSelecionadaAnteriormente = _this.dadosFormulario.auditoriaObservancia.instituicao.idBacen;
            }
            else {
                _this.podeAlterarInstituicao = true;
            }
            _this.escutarCamposParaExibirApontamento();
        });
    };
    ;
    AuditoriaObservanciaIncluirController.prototype.escutarCamposParaExibirApontamento = function () {
        var _this = this;
        this.$scope.$watchGroup([
            function () { return _this.auditoriaObservancia.instituicao; },
            function () { return _this.auditoriaObservancia.tipoProcedimento; },
            function () { return _this.auditoriaObservancia.referencias; }
        ], function (novosValores) {
            var instituicao = novosValores[0], tipoProcedimento = novosValores[1], referencias = novosValores[2];
            _this.exibirDadosAPS = AuditoriaObservanciaUtils.deveExibirCamposAPS(instituicao, tipoProcedimento, referencias);
        });
    };
    AuditoriaObservanciaIncluirController.prototype.onTipoProcedimentoAlterado = function () {
        this.exibirNumeroPE = AuditoriaObservanciaUtils.deveExibirNumeroPE(this.auditoriaObservancia.tipoProcedimento);
        if (!this.exibirNumeroPE) {
            this.auditoriaObservancia.numeroPE = undefined;
        }
        if (!this.auditoriaObservancia.tipoProcedimento) {
            return;
        }
        if (this.auditoriaObservancia.tipoProcedimento.enumName === 'OBSERVAR_POR_UM_PERIODO') {
            this.dataCriticaHabilitada = true;
            this.dataCriticaObrigatoria = true;
        }
        else if (this.auditoriaObservancia.tipoProcedimento.enumName === 'NAO_ADOTAR_PROCEDIMENTO') {
            this.dataCriticaHabilitada = false;
            this.dataCriticaObrigatoria = false;
            this.auditoriaObservancia.dataCritica = undefined;
        }
        else {
            this.dataCriticaHabilitada = true;
            this.dataCriticaObrigatoria = false;
        }
    };
    AuditoriaObservanciaIncluirController.prototype.salvar = function (pao) {
        var _this = this;
        var paoParaSalvar = this.converterParaEnviarServidor(pao);
        if (this.auditoriaObservancia.anexo) {
            AuditoriaObservanciaUtils.fileToBase64(this.auditoriaObservancia.anexo.file, function (_a) {
                var base64 = _a.base64;
                paoParaSalvar.pdfSumulaAPS = base64;
                paoParaSalvar.nomeArquivoPDF = _this.auditoriaObservancia.anexo.nomeArquivo;
                _this.salvarAlteracoes(paoParaSalvar);
            }, function (error) {
                _this.feedbackService.violacoes(["Erro ao fazero o envio do novo PDF!"]);
            });
        }
        else {
            this.limparDadosAPS(paoParaSalvar);
            this.salvarAlteracoes(paoParaSalvar);
        }
    };
    AuditoriaObservanciaIncluirController.prototype.salvarAlteracoes = function (paoParaSalvar) {
        var _this = this;
        this.auditoriaObservanciaApiService.incluir(this.dadosFormulario._links['crd-auditoria-observancia-incluir'].href, paoParaSalvar).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso('Procedimento da auditoria de observância salvo com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    AuditoriaObservanciaIncluirController.prototype.limparDadosAPS = function (paoParaSalvar) {
        if (!this.exibirDadosAPS) {
            paoParaSalvar.acaoSigas = undefined;
            paoParaSalvar.prazoAPS = undefined;
            paoParaSalvar.sumulaAPS = undefined;
            paoParaSalvar.pdfSumulaAPS = undefined;
            paoParaSalvar.nomeArquivoPDF = undefined;
        }
    };
    AuditoriaObservanciaIncluirController.prototype.perpararFiltro = function (idBacen) {
        var inicio = new Date();
        inicio.setFullYear(inicio.getFullYear() - 5);
        return {
            instituicao: idBacen,
            dataBaseFim: new Date().toISOString().split('T')[0],
            dataBaseInicio: inicio.toISOString().split('T')[0]
        };
    };
    AuditoriaObservanciaIncluirController.prototype.abrirPdf = function () {
        AuditoriaObservanciaUtils.abrirPdf(this.pdfBase64, this.nomeArquivoPDF);
    };
    AuditoriaObservanciaIncluirController.prototype.gerarPdf = function () {
        if (this.exibirDadosAPS) {
            this.buscarSumulaApontamentoAPS(this.auditoriaObservancia.instituicao.idBacen);
        }
    };
    AuditoriaObservanciaIncluirController.prototype.buscarSumulaApontamentoAPS = function (idBacen) {
        var _this = this;
        var filtro = this.perpararFiltro(idBacen);
        this.auditoriaObservanciaApiService.buscarSumulaApontamentoAPS(this.montarUrlPDFSumulaAPS(), filtro)
            .then(function (resource) {
            _this.pdfBase64 = resource.data.pdfBase64;
            _this.nomeArquivoPDF = resource.data.nomeArquivoPDF;
            _this.auditoriaObservancia.sumulaAPS = resource.data.sumulaAPS;
            _this.anexarArquivoVindoDoBackend();
        });
    };
    AuditoriaObservanciaIncluirController.prototype.anexarArquivoVindoDoBackend = function () {
        if (this.pdfBase64) {
            var arquivoFile = AuditoriaObservanciaUtils.blobToFile(AuditoriaObservanciaUtils.gerarArquivoBlob(this.pdfBase64), this.nomeArquivoPDF);
            this.auditoriaObservancia.anexo = {
                pk: null,
                nomeArquivo: this.nomeArquivoPDF,
                type: "application/pdf",
                size: arquivoFile.size,
                file: arquivoFile
            };
        }
    };
    AuditoriaObservanciaIncluirController.prototype.onAnexosAlterados = function () {
        this.atualizarTextoDetalhamentoSumulaAPS();
    };
    AuditoriaObservanciaIncluirController.prototype.atualizarTextoDetalhamentoSumulaAPS = function () {
        this.auditoriaObservancia.sumulaAPS = this.auditoriaObservancia.sumulaAPS
            ? this.auditoriaObservancia.sumulaAPS.replace(/\(\s*situação verificada em \d{2}\/\d{2}\/\d{4}\s*\)/i, "(situa\u00E7\u00E3o verificada em " + this.hoje + ")")
            : "Foram observadas irregularidades na entrega dos documentos listados no arquivo em anexo (situa\u00E7\u00E3o verificada em " + this.hoje + ").";
    };
    AuditoriaObservanciaIncluirController.prototype.montarUrlPDFSumulaAPS = function () {
        return this.dadosFormulario._links['crd-raiz'].href + "atraso-substituicao/relatorio-pdf";
    };
    AuditoriaObservanciaIncluirController.prototype.voltar = function () {
        this.$state.go(this.telaRetorno ? this.telaRetorno : 'auditoria-observancia-pesquisa');
    };
    AuditoriaObservanciaIncluirController.prototype.converterParaEnviarServidor = function (pao) {
        return {
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(pao.instituicao),
            tipo: ConverterParameterObjectToUrlUtils.atributoEnumName(pao.tipoProcedimento),
            numeroPE: AuditoriaObservanciaUtils.converterNumeroPEParaNumero(pao.numeroPE),
            referencias: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(pao.referencias),
            dataCritica: ConverterParameterObjectToUrlUtils.date(pao.dataCritica),
            comentarioAuditor: pao.comentarioAuditor,
            acaoSigas: ConverterParameterObjectToUrlUtils.number(pao.acaoSigas),
            prazoAPS: ConverterParameterObjectToUrlUtils.number(pao.prazoAPS),
            sumulaAPS: pao.sumulaAPS
        };
    };
    return AuditoriaObservanciaIncluirController;
}());
AuditoriaObservanciaIncluirController.$inject = ['$state', 'AuditoriaObservanciaApiService', 'feedbackService', '$scope'];
angular.module('crd').controller('AuditoriaObservanciaIncluirController', AuditoriaObservanciaIncluirController);
//# sourceMappingURL=auditoria-observancia-incluir-controller.js.map;
(function(angular, HttpStatus) {
  'use strict';

  var ENCAMINHAR_ENCERRAMENTO = "ENCAMINHAR_ENCERRAMENTO";
  var ENCERRAR = "ENCERRAR";

  angular.module('crd')
    .controller('AuditoriaObservanciaModalSituacaoRegularizadaController', AuditoriaObservanciaModalSituacaoRegularizadaController);

  AuditoriaObservanciaModalSituacaoRegularizadaController.$inject = ['$uibModalInstance'];

  function AuditoriaObservanciaModalSituacaoRegularizadaController($uibModalInstance) {
    var vm = this;
    vm.cancelar = cancelar;
    vm.confirmar = confirmar;
    vm.situacaoRegularizada = null;

    this.$onInit = function () {
      vm.texto = montarTextoModal();
      preencherSituacaoParaAcaoEncerrar();
    };

    function montarTextoModal() {
      if(vm.tipoAcao === ENCAMINHAR_ENCERRAMENTO) {
        return {
          titulo: "Encaminhar para encerramento",
          mensagem: "Deseja encaminhar o procedimento para encerramento?"
        }
      } else {
        return {
          titulo: "Encerrar",
          mensagem: "Deseja encerrar o procedimento?"
        }
      }
    }

    function preencherSituacaoParaAcaoEncerrar() {
      if(ENCERRAR === vm.tipoAcao) {
        vm.situacaoRegularizada = vm.situacaoRegularizadaProcedimento;
      }
    }

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmar() {
      $uibModalInstance.close(vm.situacaoRegularizada);
    }
  }
})(angular, httpStatusCode);
;
"use strict";
var AuditoriaObservanciaPesquisaController = (function () {
    function AuditoriaObservanciaPesquisaController($location, $scope, $stateParams, auditoriaObservanciaApiService, feedbackService, documentoApiService, moment) {
        this.$location = $location;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.auditoriaObservanciaApiService = auditoriaObservanciaApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.moment = moment;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    AuditoriaObservanciaPesquisaController.prototype.gerarExcel = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.auditoriaObservanciaApiService.gerarExcel(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    AuditoriaObservanciaPesquisaController.prototype.onTipoAlterado = function () {
        if (this.parametrosPesquisa.tipo.enumName === "HOJE") {
            this.preencherValoresDefault();
            this.definirSituacoes();
            this.definirSituacaoDefault();
        }
        else {
            this.parametrosPesquisa.abertoSim = false;
            this.parametrosPesquisa.abertoNao = false;
            this.parametrosPesquisa.situacoes = [];
        }
        this.limparResultadoPesquisa();
    };
    AuditoriaObservanciaPesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    AuditoriaObservanciaPesquisaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    AuditoriaObservanciaPesquisaController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    AuditoriaObservanciaPesquisaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    AuditoriaObservanciaPesquisaController.prototype.limparResultadoPesquisa = function () {
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    AuditoriaObservanciaPesquisaController.prototype.converterUrlParaParametros = function (filtro, tiposDePesquisa) {
        var tipoPesquisaFiltro;
        tiposDePesquisa.forEach(function (tipoPesquisa) {
            if (tipoPesquisa.enumName === filtro.tipo) {
                tipoPesquisaFiltro = tipoPesquisa;
            }
        });
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao),
            jaPesquisado: filtro.jaPesquisado,
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            tipo: tipoPesquisaFiltro,
            abertoSim: ConverterParameterUrlToObjectUtils.atributoBoolean(filtro.abertoSim),
            abertoNao: ConverterParameterUrlToObjectUtils.atributoBoolean(filtro.abertoNao),
            tipos: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.tipos),
            referencias: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.referencias),
            situacoes: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.situacoes),
            periodoAcao: {
                inicio: ConverterParameterUrlToObjectUtils.date(filtro.periodoAcaoInicio),
                fim: ConverterParameterUrlToObjectUtils.date(filtro.periodoAcaoFim)
            },
            dataCritica: {
                inicio: ConverterParameterUrlToObjectUtils.date(filtro.dataCriticaInicio),
                fim: ConverterParameterUrlToObjectUtils.date(filtro.dataCriticaFim)
            }
        };
    };
    AuditoriaObservanciaPesquisaController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var dataCriticaInicio;
        var dataCriticaFim;
        var periodoAcaoInicio;
        var periodoAcaoFim;
        if (parametrosPesquisa.dataCritica) {
            dataCriticaInicio = this.opcoesDeData.normatizar(parametrosPesquisa.dataCritica.inicio);
            dataCriticaFim = this.opcoesDeData.normatizar(parametrosPesquisa.dataCritica.fim);
        }
        if (parametrosPesquisa.periodoAcao) {
            periodoAcaoInicio = this.opcoesDeData.normatizar(parametrosPesquisa.periodoAcao.inicio);
            periodoAcaoFim = this.opcoesDeData.normatizar(parametrosPesquisa.periodoAcao.fim);
        }
        return {
            jaPesquisado: true,
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            tipo: parametrosPesquisa.tipo != null && parametrosPesquisa.tipo.enumName != null ? parametrosPesquisa.tipo.enumName : parametrosPesquisa.tipo,
            abertoSim: parametrosPesquisa.abertoSim + "",
            abertoNao: parametrosPesquisa.abertoNao + "",
            tipos: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.tipos),
            referencias: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.referencias),
            situacoes: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.situacoes),
            periodoAcaoInicio: ConverterParameterObjectToUrlUtils.date(periodoAcaoInicio),
            periodoAcaoFim: ConverterParameterObjectToUrlUtils.date(periodoAcaoFim),
            dataCriticaInicio: ConverterParameterObjectToUrlUtils.date(dataCriticaInicio),
            dataCriticaFim: ConverterParameterObjectToUrlUtils.date(dataCriticaFim)
        };
    };
    AuditoriaObservanciaPesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.periodoAcao = undefined;
        this.parametrosPesquisa.dataCritica = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.referencias = undefined;
        this.parametrosPesquisa.tipos = undefined;
        this.parametrosPesquisa.tipo = this.getTipoDePesquisaDefult();
        this.parametrosPesquisa.abertoSim = false;
        this.parametrosPesquisa.abertoNao = false;
        this.definirSituacoes();
        this.definirSituacaoDefault();
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    AuditoriaObservanciaPesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    AuditoriaObservanciaPesquisaController.prototype.validarDataCritica = function () {
        if (!this.parametrosPesquisa || !this.parametrosPesquisa.dataCritica) {
            return;
        }
        return !(this.parametrosPesquisa && this.parametrosPesquisa.dataCritica.inicio && this.parametrosPesquisa.dataCritica.fim
            && (this.moment.utc(this.parametrosPesquisa.dataCritica.inicio)).isAfter(this.moment.utc(this.parametrosPesquisa.dataCritica.fim), 'day'));
    };
    AuditoriaObservanciaPesquisaController.prototype.validarPeriodoAcao = function () {
        if (!this.parametrosPesquisa || !this.parametrosPesquisa.periodoAcao) {
            return;
        }
        return !(this.parametrosPesquisa && this.parametrosPesquisa.periodoAcao.inicio && this.parametrosPesquisa.periodoAcao.fim
            && (this.moment.utc(this.parametrosPesquisa.periodoAcao.inicio)).isAfter(this.moment.utc(this.parametrosPesquisa.periodoAcao.fim), 'day'));
    };
    AuditoriaObservanciaPesquisaController.prototype.marcarAbertoSim = function () {
        if (this.parametrosPesquisa.abertoSim) {
            this.parametrosPesquisa.abertoNao = false;
        }
        this.definirSituacoes();
        this.definirSituacaoDefault();
    };
    AuditoriaObservanciaPesquisaController.prototype.marcarAbertoNao = function () {
        if (this.parametrosPesquisa.abertoNao) {
            this.parametrosPesquisa.abertoSim = false;
        }
        this.definirSituacoes();
        this.definirSituacaoDefault();
    };
    AuditoriaObservanciaPesquisaController.prototype.excluir = function (pk) {
        var _this = this;
        return this.auditoriaObservanciaApiService.excluir(pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Procedimentos da auditoria de observância excluído com sucesso.');
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    AuditoriaObservanciaPesquisaController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.auditoriaObservanciaApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    AuditoriaObservanciaPesquisaController.prototype.definirSituacoes = function () {
        if (!this.parametrosPesquisa.abertoNao && !this.parametrosPesquisa.abertoSim) {
            this.dadosFormulario.situacoes = this.dadosFormulario.situacoesTodas;
        }
        else if (this.parametrosPesquisa.abertoSim) {
            this.dadosFormulario.situacoes = this.dadosFormulario.situacoesEmAberto;
        }
        else if (this.parametrosPesquisa.abertoNao) {
            this.dadosFormulario.situacoes = this.dadosFormulario.situacoesNaoAberto;
        }
    };
    AuditoriaObservanciaPesquisaController.prototype.definirSituacaoDefault = function () {
        if (!this.parametrosPesquisa.abertoNao && !this.parametrosPesquisa.abertoSim) {
            this.parametrosPesquisa.situacoes = [];
        }
        else if (this.parametrosPesquisa.abertoSim) {
        }
        else if (this.parametrosPesquisa.abertoNao) {
            this.parametrosPesquisa.situacoes = [{ enumName: "ENCERRADO" }];
        }
    };
    AuditoriaObservanciaPesquisaController.prototype.preencherValoresDefault = function () {
        this.parametrosPesquisa.tipo = this.getTipoDePesquisaDefult();
        this.parametrosPesquisa.abertoSim = true;
        this.parametrosPesquisa.abertoNao = false;
    };
    AuditoriaObservanciaPesquisaController.prototype.getTipoDePesquisaDefult = function () {
        var tipoPequisaHoje;
        this.dadosFormulario.tiposDePesquisa.forEach(function (tipo) {
            if (tipo.enumName === 'HOJE') {
                tipoPequisaHoje = tipo;
            }
        });
        return tipoPequisaHoje;
    };
    AuditoriaObservanciaPesquisaController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.auditoriaObservanciaApiService.montarTelaPesquisa().then(function (montarTelaPesquisa) {
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro, montarTelaPesquisa.tiposDePesquisa);
            _this.dadosFormulario = montarTelaPesquisa;
            if (!_this.parametrosPesquisa.jaPesquisado) {
                _this.preencherValoresDefault();
                _this.definirSituacaoDefault();
            }
            _this.definirSituacoes();
            _this.pesquisar(_this.parametrosPesquisa);
            return montarTelaPesquisa;
        });
    };
    AuditoriaObservanciaPesquisaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return AuditoriaObservanciaPesquisaController;
}());
AuditoriaObservanciaPesquisaController.$inject = ['$location', '$scope', '$stateParams', 'AuditoriaObservanciaApiService', 'feedbackService', 'documentoApiService', 'moment'];
angular.module('crd').controller('AuditoriaObservanciaPesquisaController', AuditoriaObservanciaPesquisaController);
//# sourceMappingURL=auditoria-observancia-pesquisa-controller.js.map;
"use strict";
var AuditoriaObservanciaUtils = (function () {
    function AuditoriaObservanciaUtils() {
    }
    AuditoriaObservanciaUtils.abrirPdf = function (pdfSumulaAPS, nomeArquivo) {
        var blob = this.gerarArquivoBlob(pdfSumulaAPS);
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = nomeArquivo;
        link.click();
        setTimeout(function () { return URL.revokeObjectURL(url); }, 10000);
    };
    ;
    AuditoriaObservanciaUtils.gerarArquivoBlob = function (base64Pdf) {
        var byteCharacters = atob(base64Pdf);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    };
    AuditoriaObservanciaUtils.blobToFile = function (blob, filename) {
        try {
            return new File([blob], filename, { type: blob.type || 'application/pdf' });
        }
        catch (error) {
            blob.name = filename;
            return blob;
        }
    };
    AuditoriaObservanciaUtils.fileToBase64 = function (file, onSuccess, onError) {
        var reader = new FileReader();
        reader.onload = function () {
            var dataUrl = reader.result || '';
            var base64 = dataUrl.split(',')[1] || '';
            onSuccess({ dataUrl: dataUrl, base64: base64 });
        };
        reader.onerror = function (err) {
            if (onError)
                onError(err);
        };
        reader.readAsDataURL(file);
    };
    AuditoriaObservanciaUtils.deveExibirCamposAPS = function (instituicao, tipoProcedimento, referencias) {
        return instituicao &&
            tipoProcedimento && tipoProcedimento.enumName == "APONTAMENTO_NO_APS" &&
            referencias && referencias.length == 1 && referencias[0].enumName == "TEMPESTIVIDADE";
    };
    AuditoriaObservanciaUtils.deveExibirNumeroPE = function (tipoProcedimento) {
        if (!tipoProcedimento) {
            return false;
        }
        return tipoProcedimento.enumName === 'MEDIDA_COERCITIVA' || tipoProcedimento.enumName === 'PROPOSTA_DE_PA';
    };
    AuditoriaObservanciaUtils.converterNumeroPEParaNumero = function (numeroPE) {
        if (numeroPE === undefined
            || numeroPE === null
            || numeroPE.trim() === '') {
            return undefined;
        }
        return Number(numeroPE);
    };
    return AuditoriaObservanciaUtils;
}());
//# sourceMappingURL=AuditoriaObservanciaUtils.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('aviso-detalhar', {
        controller: 'AvisoDetalheController',
        controllerAs: 'avisoDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW6002',
            label: 'Aviso',
            titulo: 'Aviso'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/aviso/views/aviso-detalhe/aviso-detalhe-tpl.html',
        url: '/aviso/:id/detalhar'
    })
        .state('aviso-alterar', {
        controller: 'AvisoAlterarController',
        controllerAs: 'avisoAlterarCtrl',
        informacaoPagina: {
            codigo: 'CRDFW6005',
            label: 'Aviso',
            titulo: 'Aviso'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/aviso/views/aviso-alterar/aviso-alterar-tpl.html',
        url: '/aviso/:id/alterar'
    })
        .state('aviso-incluir', {
        controller: 'AvisoInclusaoController',
        controllerAs: 'avisoInclusaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW6004',
            label: 'Aviso',
            titulo: 'Aviso'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/aviso/views/aviso-inclusao/aviso-inclusao-tpl.html',
        params: { avisoId: null },
        url: '/aviso/incluir'
    })
        .state('aviso-consultar', {
        controller: 'AvisoConsultaController',
        controllerAs: 'avisoConsultaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW6003',
            label: 'Aviso',
            titulo: 'Aviso'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/aviso/views/aviso-consulta/aviso-consulta-tpl.html',
        url: '/avisos?numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&sistemasNegocio&documentos&instituicoes&vigenciaInicio&vigenciaFim&segmentos&codigo'
    });
});
//# sourceMappingURL=aviso-route-config.js.map;
"use strict";
var AvisoUtils = (function () {
    function AvisoUtils() {
    }
    AvisoUtils.validarIntervaloDatasBaseFim = function (dadosFormulario) {
        if (!dadosFormulario || !dadosFormulario.dataInicioVigencia || !dadosFormulario.dataFimVigencia) {
            return true;
        }
        var dataInicio = dadosFormulario.dataInicioVigencia;
        var dataFim = dadosFormulario.dataFimVigencia;
        var diferencaTempo = Math.abs(dataFim.getTime() - dataInicio.getTime());
        var diferencaDias = Math.ceil(diferencaTempo / (1000 * 60 * 60 * 24));
        var toleranciaDias = 60;
        return diferencaDias <= toleranciaDias;
    };
    return AvisoUtils;
}());
//# sourceMappingURL=AvisoUtils.js.map;
"use strict";
//# sourceMappingURL=aviso-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=aviso-consulta-resultado-dto.js.map;
"use strict";
//# sourceMappingURL=aviso-detalhe-dto.js.map;
"use strict";
//# sourceMappingURL=aviso-dto.js.map;
"use strict";
//# sourceMappingURL=aviso-para-consultar-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AvisoApiService = (function (_super) {
    __extends(AvisoApiService, _super);
    function AvisoApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    AvisoApiService.prototype.detalhar = function (id) {
        return this.buscarRecurso("/aviso/" + id + "/detalhar", {});
    };
    AvisoApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso("/aviso/incluir", dados);
    };
    AvisoApiService.prototype.alterar = function (id, dados) {
        return this.alterarRecurso("/aviso/" + id + "/alterar", dados);
    };
    AvisoApiService.prototype.paraIncluir = function (id) {
        return this.buscarRecurso('/aviso/para-incluir', { avisoId: id });
    };
    AvisoApiService.prototype.paraAlterar = function (id) {
        return this.buscarRecurso("/aviso/" + id + "/para-alterar", {});
    };
    AvisoApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/aviso/consultar', consultaFiltro);
    };
    AvisoApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/aviso/para-consultar', consultaFiltro);
    };
    AvisoApiService.prototype.relatorioExcel = function (consultaFiltro) {
        return this.baixarArquivo("/aviso/relatorio-em-excel", consultaFiltro);
    };
    AvisoApiService.prototype.encerrar = function (id) {
        return this.alterarRecurso("/aviso/" + id + "/encerrar", {});
    };
    return AvisoApiService;
}(AbstractAPISerivce));
AvisoApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('AvisoApiService', AvisoApiService);
//# sourceMappingURL=aviso-api-service.js.map;
"use strict";
var AvisoAlterarController = (function () {
    function AvisoAlterarController($state, feedbackService, avisoApiService, documentoApiService, moment) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.avisoApiService = avisoApiService;
        this.documentoApiService = documentoApiService;
        this.moment = moment;
    }
    AvisoAlterarController.prototype.$onInit = function () {
        var _this = this;
        return this.avisoApiService.paraAlterar(this.$state.params.id).then(function (response) {
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.dadosFormulario.sistemasNegocio = response.data.dadosFormulario.sistemasNegocioResource;
            _this.dadosFormulario.filtroDocumento = { sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(response.data.dadosFormulario.sistemasNegocioResource) };
            _this.dadosFormulario.documentos = response.data.dadosFormulario.documentos;
            _this.dadosFormulario.dataInicioVigencia = _this.formatarData(_this.dadosFormulario.dataInicioVigencia);
            _this.dadosFormulario.dataFimVigencia = _this.formatarData(_this.dadosFormulario.dataFimVigencia);
            _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
            _this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
            _this.disabledComponenteES = false;
            _this.disabledComponenteSegmento = false;
            _this.documentoObrigatorio = false;
            if (_this.$state.params.id && !_.isEmpty(_this.dadosFormulario.segmentos)) {
                _this.disabledComponenteES = !_this.disabledComponenteES;
            }
            if (_this.$state.params.id && !_.isEmpty(_this.dadosFormulario.instituicoes)) {
                _this.disabledComponenteSegmento = !_this.disabledComponenteSegmento;
            }
        });
    };
    ;
    AvisoAlterarController.prototype.formatarData = function (data) {
        if (!data) {
            return null;
        }
        return this.moment(data, 'YYYY-MM-DD').toDate();
    };
    AvisoAlterarController.prototype.observerChangeSistemaNegocio = function () {
        if (_.isEmpty(this.dadosFormulario.sistemasNegocio)) {
            this.dadosFormulario.filtroDocumento = {};
            this.dadosFormulario.documentos = [];
            this.documentoObrigatorio = false;
            return;
        }
        this.dadosFormulario.filtroDocumento.sistemasNegocio = ConverterParameterObjectToUrlUtils.atributoPKArray(this.dadosFormulario.sistemasNegocio);
        this.documentoObrigatorio = true;
    };
    AvisoAlterarController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(dadosFormulario.segmentos),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.documentos),
            instituicoes: ConverterParameterObjectToUrlUtils.atributoIdBacenArray(dadosFormulario.instituicoes),
            dataInicioVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataInicioVigencia),
            dataFimVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataFimVigencia),
            mensagem: dadosFormulario.mensagem
        };
        return this.avisoApiService.alterar(this.$state.params.id, dados).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Aviso alterado com sucesso.');
                _this.voltar();
            }
        });
    };
    AvisoAlterarController.prototype.disableComponenteES = function () {
        return this.disabledComponenteES;
    };
    AvisoAlterarController.prototype.disableComponenteSegmento = function () {
        return this.disabledComponenteSegmento;
    };
    AvisoAlterarController.prototype.observerSegmento = function () {
        this.disabledComponenteES = !_.isEmpty(this.dadosFormulario.segmentos);
        this.dadosFormulario.instituicoes = [];
    };
    AvisoAlterarController.prototype.observerES = function () {
        this.disabledComponenteSegmento = !_.isEmpty(this.dadosFormulario.instituicoes);
        this.dadosFormulario.segmentos = [];
    };
    AvisoAlterarController.prototype.voltar = function () {
        this.$state.go('aviso-consultar');
    };
    AvisoAlterarController.prototype.validarIntervaloDatasBaseFim = function () {
        return AvisoUtils.validarIntervaloDatasBaseFim(this.dadosFormulario);
    };
    return AvisoAlterarController;
}());
AvisoAlterarController.$inject = ['$state', 'feedbackService', 'AvisoApiService', 'documentoApiService', 'moment'];
angular.module('crd').controller('AvisoAlterarController', AvisoAlterarController);
//# sourceMappingURL=aviso-alterar-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AvisoConsultaController = (function (_super) {
    __extends(AvisoConsultaController, _super);
    function AvisoConsultaController($stateParams, $scope, feedbackService, avisoApiService, moment) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.avisoApiService = avisoApiService;
        _this.moment = moment;
        return _this;
    }
    AvisoConsultaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        return {
            codigo: ConverterParameterObjectToUrlUtils.string(dadosFormulario.codigo),
            sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.sistemasNegocio),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.documentos),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(dadosFormulario.segmentos),
            instituicoes: ConverterParameterObjectToUrlUtils.atributoIdBacenArray(dadosFormulario.instituicoes),
            vigenciaInicio: ConverterParameterObjectToUrlUtils.date(dadosFormulario.vigenciaInicio),
            vigenciaFim: ConverterParameterObjectToUrlUtils.date(dadosFormulario.vigenciaFim)
        };
    };
    AvisoConsultaController.prototype.converterUrlParaConsultaFilro = function (dadosFormulario) {
        dadosFormulario.filtroDocumento = {};
        dadosFormulario.vigenciaInicio = ConverterParameterUrlToObjectUtils.date(this.dadosFormulario.vigenciaInicio);
        dadosFormulario.vigenciaFim = ConverterParameterUrlToObjectUtils.date(this.dadosFormulario.vigenciaFim);
    };
    AvisoConsultaController.prototype.limparDadosFormulario = function (dadosFormulario) {
        this.dadosFormulario.codigo = undefined;
        this.dadosFormulario.sistemasNegocio = undefined;
        this.dadosFormulario.documentos = undefined;
        this.dadosFormulario.segmentos = undefined;
        this.dadosFormulario.instituicoes = undefined;
        this.dadosFormulario.vigenciaInicio = undefined;
        this.dadosFormulario.vigenciaFim = undefined;
    };
    AvisoConsultaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        return this.avisoApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.acao = response.data.acao;
            _this.pagina = response.data.pagina;
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.converterUrlParaConsultaFilro(_this.dadosFormulario);
            return response;
        });
    };
    AvisoConsultaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.avisoApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            _this.exibirResultadoPesquisa();
            return response;
        });
    };
    AvisoConsultaController.prototype.observerSistemaNegocio = function () {
        this.dadosFormulario.filtroDocumento.sistemasNegocio = ConverterParameterObjectToUrlUtils.atributoPKArray(this.dadosFormulario.sistemasNegocio);
    };
    AvisoConsultaController.prototype.validaPeriodoVigencia = function () {
        if (this.dadosFormulario && this.dadosFormulario.vigenciaInicio && this.dadosFormulario.vigenciaFim) {
            var periodoInicio = this.moment.utc(this.dadosFormulario.vigenciaInicio);
            var periodoFim = this.moment.utc(this.dadosFormulario.vigenciaFim);
            return !periodoInicio.isAfter(periodoFim);
        }
        return true;
    };
    AvisoConsultaController.prototype.gerarRelatorioEmExcel = function (dadosFormulario) {
        var _this = this;
        var parametros = this.converterDadosDoFormToConsultaFiltro(dadosFormulario);
        return this.avisoApiService.relatorioExcel(parametros).then(function (response) {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            response;
            return response;
        });
    };
    AvisoConsultaController.prototype.encerrar = function (id) {
        var _this = this;
        return this.avisoApiService.encerrar(id).then(function (response) {
            _super.prototype.consultar.call(_this, _this.dadosFormulario).then(function () { return _this.feedbackService.sucesso('Aviso encerrado com sucesso.'); });
            return response;
        });
    };
    return AvisoConsultaController;
}(AbstractPaginaConsultaController));
AvisoConsultaController.$inject = ['$stateParams', '$scope', 'feedbackService', 'AvisoApiService', 'moment'];
angular.module('crd').controller('AvisoConsultaController', AvisoConsultaController);
//# sourceMappingURL=aviso-consulta-controller.js.map;
"use strict";
var AvisoDetalheController = (function () {
    function AvisoDetalheController($state, feedbackService, avisoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.avisoApiService = avisoApiService;
    }
    AvisoDetalheController.prototype.$onInit = function () {
        var _this = this;
        return this.avisoApiService.detalhar(this.$state.params.id).then(function (response) {
            _this.item = response.data;
        });
    };
    ;
    AvisoDetalheController.prototype.voltar = function () {
        this.$state.go('aviso-consultar');
    };
    AvisoDetalheController.prototype.encerrar = function (id) {
        var _this = this;
        return this.avisoApiService.encerrar(id).then(function (response) {
            if (200 === response.status) {
                _this.feedbackService.sucesso('Aviso encerrado com sucesso.');
                _this.voltar();
            }
            return response;
        });
    };
    return AvisoDetalheController;
}());
AvisoDetalheController.$inject = ['$state', 'feedbackService', 'AvisoApiService'];
angular.module('crd').controller('AvisoDetalheController', AvisoDetalheController);
//# sourceMappingURL=aviso-detalhe-controller.js.map;
"use strict";
var AvisoInclusaoController = (function () {
    function AvisoInclusaoController($state, feedbackService, avisoApiService, documentoApiService, document) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.avisoApiService = avisoApiService;
        this.documentoApiService = documentoApiService;
        this.document = document;
    }
    AvisoInclusaoController.prototype.$onInit = function () {
        var _this = this;
        return this.avisoApiService.paraIncluir(this.$state.params.avisoId).then(function (response) {
            _this.feedbackService.alerta('Será incluído Aviso Geral se não informar Documento ou Segmento ou Entidade supervisionada.');
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
            _this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
            _this.dataAtual = new Date();
            _this.disabledComponenteES = false;
            _this.disabledComponenteSegmento = false;
            _this.documentoObrigatorio = false;
            if (_this.$state.params.avisoId) {
                _this.dadosFormulario.filtroDocumento = { sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(response.data.dadosFormulario.sistemasNegocioResource) };
                _this.dadosFormulario.sistemasNegocio = response.data.dadosFormulario.sistemasNegocioResource;
            }
            else {
                _this.dadosFormulario.filtroDocumento = {};
            }
            if (_this.$state.params.avisoId && !_.isEmpty(_this.dadosFormulario.segmentos)) {
                _this.disabledComponenteES = !_this.disabledComponenteES;
            }
            if (_this.$state.params.avisoId && !_.isEmpty(_this.dadosFormulario.instituicoes)) {
                _this.disabledComponenteSegmento = !_this.disabledComponenteSegmento;
            }
        });
    };
    ;
    AvisoInclusaoController.prototype.observerChangeSistemaNegocio = function () {
        if (_.isEmpty(this.dadosFormulario.sistemasNegocio)) {
            this.dadosFormulario.filtroDocumento = {};
            this.dadosFormulario.documentos = [];
            this.documentoObrigatorio = false;
            return;
        }
        this.dadosFormulario.filtroDocumento.sistemasNegocio = ConverterParameterObjectToUrlUtils.atributoPKArray(this.dadosFormulario.sistemasNegocio);
        this.documentoObrigatorio = true;
    };
    AvisoInclusaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(dadosFormulario.segmentos),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.documentos),
            instituicoes: ConverterParameterObjectToUrlUtils.atributoIdBacenArray(dadosFormulario.instituicoes),
            dataInicioVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataInicioVigencia),
            dataFimVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataFimVigencia),
            mensagem: dadosFormulario.mensagem
        };
        return this.avisoApiService.incluir(dados).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Aviso incluído com sucesso.');
                _this.voltar();
            }
        });
    };
    AvisoInclusaoController.prototype.observerSegmento = function () {
        this.disabledComponenteES = !_.isEmpty(this.dadosFormulario.segmentos);
        this.dadosFormulario.instituicoes = [];
    };
    AvisoInclusaoController.prototype.observerES = function () {
        this.disabledComponenteSegmento = !_.isEmpty(this.dadosFormulario.instituicoes);
        this.dadosFormulario.segmentos = [];
    };
    AvisoInclusaoController.prototype.disableComponenteES = function () {
        return this.disabledComponenteES;
    };
    AvisoInclusaoController.prototype.disableComponenteSegmento = function () {
        return this.disabledComponenteSegmento;
    };
    AvisoInclusaoController.prototype.voltar = function () {
        this.$state.go('aviso-consultar');
    };
    AvisoInclusaoController.prototype.validarIntervaloDatasBaseFim = function () {
        return AvisoUtils.validarIntervaloDatasBaseFim(this.dadosFormulario);
    };
    return AvisoInclusaoController;
}());
AvisoInclusaoController.$inject = ['$state', 'feedbackService', 'AvisoApiService', 'documentoApiService', '$document'];
angular.module('crd').controller('AvisoInclusaoController', AvisoInclusaoController);
//# sourceMappingURL=aviso-inclusao-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var BcCalcladoraApiService = (function (_super) {
    __extends(BcCalcladoraApiService, _super);
    function BcCalcladoraApiService($q, httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.$q = $q;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    BcCalcladoraApiService.prototype.funcao = function () {
        var deferred = this.$q.defer();
        if (localStorage.getItem('crd-bc-calculadora-funcao')) {
            var value = localStorage.getItem('crd-bc-calculadora-funcao');
            deferred.resolve(JSON.parse(value || ""));
        }
        else {
            this.buscarRecurso('/bc-calculadora/funcao', {}, { ignoreLoadingBar: true }).then(function (resource) {
                localStorage.setItem('crd-bc-calculadora-funcao', JSON.stringify(resource.data));
                deferred.resolve(resource.data);
            });
        }
        return deferred.promise;
    };
    return BcCalcladoraApiService;
}(AbstractAPISerivce));
BcCalcladoraApiService.$inject = ['$q', '$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('BcCalcladoraApiService', BcCalcladoraApiService);
//# sourceMappingURL=bc-calculadora-api-service.js.map;
"use strict";
var CampoSituacaoMonitoradaAlterarController = (function () {
    function CampoSituacaoMonitoradaAlterarController($stateParams, campoSituacaoMonitoradaApiService, feedbackService, $location, sistemaNegocioApiService, documentoApiService) {
        this.$stateParams = $stateParams;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.feedbackService = feedbackService;
        this.$location = $location;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.documentoApiService = documentoApiService;
    }
    CampoSituacaoMonitoradaAlterarController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        return this.campoSituacaoMonitoradaApiService.montarTelaAlterar(pk).then(function (resource) {
            _this.campoSituacaoMonitorada = resource.campoSituacaoMonitorada;
            _this.campoSituacaoMonitorada.sistemaNegocio = resource.campoSituacaoMonitorada.documento.sistemaNegocio;
            _this.dadosFormulario = resource;
            _this.carregarDocumentos(resource.campoSituacaoMonitorada.documento.sistemaNegocio);
        });
    };
    CampoSituacaoMonitoradaAlterarController.prototype.observerChangeSistemaNegocio = function (sistemaNegocio) {
        this.campoSituacaoMonitorada.documento = undefined;
        this.carregarDocumentos(sistemaNegocio);
    };
    CampoSituacaoMonitoradaAlterarController.prototype.carregarDocumentos = function (sistemaNegocio) {
        var _this = this;
        if (!sistemaNegocio) {
            return;
        }
        var periodicidade = 'EVENTUAL_DIARIA';
        this.documentoApiService.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(sistemaNegocio.pk, periodicidade).then(function (resource) {
            _this.dadosFormulario.documentos = resource._embedded.resultado;
            return resource;
        });
    };
    CampoSituacaoMonitoradaAlterarController.prototype.salvar = function (csm) {
        var csmParaSalvar = this.converterParaEnviarServidor(csm);
        var _self = this;
        return this.campoSituacaoMonitoradaApiService.alterar(this.campoSituacaoMonitorada.pk, csmParaSalvar).then(function (response) {
            if (response.status === 200) {
                _self.voltar();
                _self.feedbackService.sucesso('Campo salvo com sucesso!');
            }
            else {
                _self.feedbackService.violacoes(response.data);
            }
        });
    };
    CampoSituacaoMonitoradaAlterarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams.pk);
    };
    ;
    CampoSituacaoMonitoradaAlterarController.prototype.voltar = function () {
        this.$location.path('/campo-situacao-monitorada');
    };
    CampoSituacaoMonitoradaAlterarController.prototype.converterParaEnviarServidor = function (csm) {
        return {
            campo: ConverterParameterObjectToUrlUtils.string(csm.campo),
            documento: ConverterParameterObjectToUrlUtils.atributoPK(csm.documento)
        };
    };
    return CampoSituacaoMonitoradaAlterarController;
}());
CampoSituacaoMonitoradaAlterarController.$inject = ['$stateParams', 'CampoSituacaoMonitoradaApiService', 'feedbackService', '$location', 'sistemaNegocioApiService', 'documentoApiService'];
angular.module('crd').controller('CampoSituacaoMonitoradaAlterarController', CampoSituacaoMonitoradaAlterarController);
//# sourceMappingURL=campo-situacao-monitorada-alterar-controller.js.map;
"use strict";
var CampoSituacaoMonitoradaDesativarController = (function () {
    function CampoSituacaoMonitoradaDesativarController($location, $stateParams, campoSituacaoMonitoradaApiService, feedbackService) {
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.feedbackService = feedbackService;
    }
    CampoSituacaoMonitoradaDesativarController.prototype.desativar = function (pk) {
        var _self = this;
        return this.campoSituacaoMonitoradaApiService.desativar(pk).then(function (response) {
            if (response.status === 200) {
                _self.feedbackService.sucesso('Campo desativado com sucesso!');
            }
            else {
                _self.feedbackService.erro('Usu�rio n�o autorizado.');
            }
            _self.$location.path('/campo-situacao-monitorada');
        });
    };
    CampoSituacaoMonitoradaDesativarController.prototype.$onInit = function () {
        return this.desativar(this.$stateParams.pk);
    };
    ;
    return CampoSituacaoMonitoradaDesativarController;
}());
CampoSituacaoMonitoradaDesativarController.$inject = ['$location', '$stateParams', 'CampoSituacaoMonitoradaApiService', 'feedbackService'];
angular.module('crd').controller('CampoSituacaoMonitoradaDesativarController', CampoSituacaoMonitoradaDesativarController);
//# sourceMappingURL=campo-situacao-monitorada-desativar-controller.js.map;
"use strict";
var CampoSituacaoMonitoradaDetalharController = (function () {
    function CampoSituacaoMonitoradaDetalharController($state, campoSituacaoMonitoradaApiService, $location) {
        this.$state = $state;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.$location = $location;
    }
    CampoSituacaoMonitoradaDetalharController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.campoSituacaoMonitoradaApiService.montarTelaDetalhe(pk).then(function (resource) {
            _this.campoSituacaoMonitorada = resource;
        });
    };
    CampoSituacaoMonitoradaDetalharController.prototype.voltar = function () {
        this.$location.path('/campo-situacao-monitorada');
    };
    CampoSituacaoMonitoradaDetalharController.prototype.desativar = function (csmId) {
        this.$location.path('/campo-situacao-monitorada/' + csmId + '/desativar');
    };
    CampoSituacaoMonitoradaDetalharController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.pk);
    };
    ;
    return CampoSituacaoMonitoradaDetalharController;
}());
CampoSituacaoMonitoradaDetalharController.$inject = ['$state', 'CampoSituacaoMonitoradaApiService', '$location'];
angular.module('crd').controller('CampoSituacaoMonitoradaDetalharController', CampoSituacaoMonitoradaDetalharController);
//# sourceMappingURL=campo-situacao-monitorada-detalhe-controller.js.map;
"use strict";
var CampoSituacaoMonitoradaIncluirController = (function () {
    function CampoSituacaoMonitoradaIncluirController($state, campoSituacaoMonitoradaApiService, feedbackService, $location, sistemaNegocioApiService, documentoApiService) {
        this.$state = $state;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.feedbackService = feedbackService;
        this.$location = $location;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.documentoApiService = documentoApiService;
    }
    CampoSituacaoMonitoradaIncluirController.prototype.carregarDadosTela = function () {
        var _this = this;
        return this.campoSituacaoMonitoradaApiService.montarTelaIncluir().then(function (resource) {
            _this.dadosFormulario = resource;
        });
    };
    CampoSituacaoMonitoradaIncluirController.prototype.observerChangeSistemaNegocio = function (sistemaNegocio) {
        this.campoSituacaoMonitorada.documento = undefined;
        this.carregarDocumentos(sistemaNegocio);
    };
    CampoSituacaoMonitoradaIncluirController.prototype.carregarDocumentos = function (sistemaNegocio) {
        var _this = this;
        if (!sistemaNegocio) {
            return;
        }
        var periodicidade = 'EVENTUAL_DIARIA';
        this.documentoApiService.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(sistemaNegocio.pk, periodicidade).then(function (resource) {
            _this.dadosFormulario.documentos = resource._embedded.resultado;
            return resource;
        });
    };
    CampoSituacaoMonitoradaIncluirController.prototype.salvar = function () {
        var csmParaSalvar = this.converterParaEnviarServidor();
        var _self = this;
        return this.campoSituacaoMonitoradaApiService.incluir(csmParaSalvar).then(function (response) {
            if (response.status === 201) {
                _self.voltar();
                _self.feedbackService.sucesso('Campo salvo com sucesso!');
            }
            else {
                _self.feedbackService.violacoes(response.data);
            }
        });
    };
    CampoSituacaoMonitoradaIncluirController.prototype.$onInit = function () {
        return this.carregarDadosTela();
    };
    ;
    CampoSituacaoMonitoradaIncluirController.prototype.voltar = function () {
        this.$location.path('/campo-situacao-monitorada');
    };
    CampoSituacaoMonitoradaIncluirController.prototype.converterParaEnviarServidor = function () {
        return {
            documento: ConverterParameterObjectToUrlUtils.atributoPK(this.campoSituacaoMonitorada.documento),
            campo: ConverterParameterObjectToUrlUtils.string(this.campoSituacaoMonitorada.campo)
        };
    };
    return CampoSituacaoMonitoradaIncluirController;
}());
CampoSituacaoMonitoradaIncluirController.$inject = ['$state', 'CampoSituacaoMonitoradaApiService', 'feedbackService', '$location', 'sistemaNegocioApiService', 'documentoApiService'];
angular.module('crd').controller('CampoSituacaoMonitoradaIncluirController', CampoSituacaoMonitoradaIncluirController);
//# sourceMappingURL=campo-situacao-monitorada-incluir-controller.js.map;
"use strict";
var CampoSituacaoMonitoradaPesquisaController = (function () {
    function CampoSituacaoMonitoradaPesquisaController($scope, $location, $stateParams, campoSituacaoMonitoradaApiService, feedbackService) {
        this.$scope = $scope;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.feedbackService = feedbackService;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
    }
    CampoSituacaoMonitoradaPesquisaController.prototype.gerarExcel = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.campoSituacaoMonitoradaApiService.gerarExcel(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.desativar = function (csmId) {
        this.$location.path('/campo-situacao-monitorada/' + csmId + '/desativar');
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.limparResultadoPesquisa = function () {
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao),
            sistemaNegocio: ConverterParameterUrlToObjectUtils.atributoPK(filtro.sistemaNegocio),
            documento: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documento),
            campo: ConverterParameterUrlToObjectUtils.string(filtro.campo),
            situacao: ConverterParameterUrlToObjectUtils.atributoEnumName(filtro.situacao)
        };
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            jaPesquisado: true,
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.sistemaNegocio),
            documento: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.documento),
            campo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.campo),
            situacao: ConverterParameterObjectToUrlUtils.atributoEnumName(parametrosPesquisa.situacao)
        };
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.sistemaNegocio = undefined;
        this.parametrosPesquisa.documento = undefined;
        this.parametrosPesquisa.campo = undefined;
        this.parametrosPesquisa.situacao = undefined;
        this.limparResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.campoSituacaoMonitoradaApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.campoSituacaoMonitoradaApiService.montarTelaPesquisa().then(function (montarTelaPesquisa) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaPesquisa;
            _this.parametrosPesquisa.sistemasNegocio = _this.dadosFormulario.sistemasNegocio;
            _this.parametrosPesquisa.situacoes = _this.dadosFormulario.situacoes;
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.parametrosPesquisa.situacao = ConverterParameterUrlToObjectUtils.atributoEnumName('ATIVA');
            }
            return montarTelaPesquisa;
        });
    };
    CampoSituacaoMonitoradaPesquisaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    CampoSituacaoMonitoradaPesquisaController.prototype.exibiAcoesPorSituacao = function (enumOpcao) {
        if (enumOpcao.enumName == "ATIVA") {
            return true;
        }
        return false;
    };
    return CampoSituacaoMonitoradaPesquisaController;
}());
CampoSituacaoMonitoradaPesquisaController.$inject = [
    '$scope',
    '$location',
    '$stateParams',
    'CampoSituacaoMonitoradaApiService',
    'feedbackService'
];
angular.module('crd').controller('CampoSituacaoMonitoradaPesquisaController', CampoSituacaoMonitoradaPesquisaController);
//# sourceMappingURL=campo-situacao-monitorada-pesquisa-controller.js.map;
(function(angular, parametrosUrl, HttpStatus) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdModalCobrancaAvulsaDetalheController', CrdModalCobrancaAvulsaDetalheController);

  CrdModalCobrancaAvulsaDetalheController.$inject = ['$uibModalInstance', 'cobrancaApiService', 'feedbackService'];

  function CrdModalCobrancaAvulsaDetalheController($uibModalInstance, cobrancaApiService, feedbackService) {
    var vm = this;
    vm.cancel = cancel;
    vm.gerarCobrancaAvulsa = gerarCobrancaAvulsa;
    vm.emailInvalido = emailInvalido;
    vm.podeEnviar = podeEnviar;
    vm.obrigatorioInvalido = obrigatorioInvalido;
    vm.getClass = getClass;
    vm.emailValido = emailValido;

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function gerarCobrancaAvulsa() {
      var selecionado = {
        documento: vm.documentoNaoEntregue.documento.pk,
        idBacen: vm.documentoNaoEntregue.idBacen
      };

      var filtro = {
        cobranca: vm.parametrosPesquisa.cobranca ? vm.parametrosPesquisa.cobranca.codigo : null,
        documentos: vm.parametrosPesquisa.documentos ?
          _.map(vm.parametrosPesquisa.documentos, function(value) {
            return value.pk;
          }) : null,
        excecoes: vm.parametrosPesquisa.excecoes ? vm.parametrosPesquisa.excecoes : null,
        idBacen: vm.parametrosPesquisa.instituicao ? vm.parametrosPesquisa.instituicao.idBacen : null,
        segmentos: vm.parametrosPesquisa.segmento ?
          _.map(vm.parametrosPesquisa.segmento, function(value) {
            return value.codigo;
          }) : null,
        sistemasNegocio: vm.parametrosPesquisa.sistemasNegocio ?
          _.map(vm.parametrosPesquisa.sistemasNegocio, function(value) {
            return value.pk;
          }) : null,
         pkProcessamento: vm.pkProcessamento
      };

      vm.cancel();

      return cobrancaApiService
        .gerarCobrancaAvulsa(selecionado, filtro, vm.documentoNaoEntregue.destinatariosEmail)
        .then(successOnGerarCobrancaAvulso);

      function successOnGerarCobrancaAvulso(response) {
        if (response.status === HttpStatus.CREATED) {
          vm.geradoAvulsoComSucesso();

          mensagensInformativas(response.data);
        }
      }
    }

    function mensagensInformativas(data) {
      var obj = angular.fromJson(data);
      
      feedbackService.mensagens(obj.mensagens);
    }

    function emailInvalido() {
      if (vm.documentoNaoEntregue.destinatariosEmail === null) {
        return false;
      }

      vm.documentoNaoEntregue.destinatariosEmail = vm.documentoNaoEntregue.destinatariosEmail.split(" ").join("").split(";").join(",");
      if (!vm.obrigatorioInvalido()) {
        var emails = vm.documentoNaoEntregue.destinatariosEmail.split(",");
        for (var i in emails) {
          if (!vm.emailValido(emails[i])) {
            return true;
          }
        }
        return false;
      }
      return true;
    }

    function podeEnviar() {
      return !vm.documentoNaoEntregue.destinatariosEmail || vm.emailInvalido();
    }

    function obrigatorioInvalido() {
      return vm.documentoNaoEntregue.destinatariosEmail !== null && !vm.documentoNaoEntregue.destinatariosEmail;
    }

    function getClass() {
      return vm.emailInvalido() || vm.obrigatorioInvalido() ? 'form-group col-md-12 has-error'
        : 'form-group col-md-12';
    }

    function emailValido(email) {
      var reg = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
      return reg.test(email);
    }
  }
})(angular, CRDUtils.ParametrosUrl, httpStatusCode);
;
(function(angular) {
  'use strict';
  angular
    .module('crd')
    .directive('crdModalCobrancaAvulsaDetalhe', CrdModalCobrancaAvulsaDetalhe);

  CrdModalCobrancaAvulsaDetalhe.$inject = ['$uibModal'];

  function CrdModalCobrancaAvulsaDetalhe($uibModal) {
    var directive = {
      link: postLink,
      restrict: 'A',
      scope: {
        documentoNaoEntregue: '=',
        geradoAvulsoComSucesso: '=',
        pkProcessamento: '=',
        parametrosPesquisa: '='
      }
    };

    return directive;

    function postLink(scope, element) {
      element.bind('click', function() {
        $uibModal.open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          controller: 'CrdModalCobrancaAvulsaDetalheController',
          controllerAs: 'cobrancaAvulsaCtrl',
          keyboard: false,
          scope: scope,
          templateUrl: 'views/cobranca/crd-modal-cobranca-avulsa-detalhe-tpl.html'
        });
      }
      );
    }
  }
})(angular);
;
(function (angular, moment, parametrosUrl, _) {
  'use strict';

  var DRAW = 0;
  var ORDER = 2;
  var START = 3;
  var LENGTH = 4;
  var RETORNO_NEGATIVO = -1;
  var RETORNO_POSITIVO = 1;
  var MSG_ERRO_PERIODO_DATA_BASE = 'A data-base início deve ser menor ou igual à data-base fim.';
  var MSG_ERRO_PERIODO_COMUNICACAO = 'A data início do período da comunicação deve ser menor ou igual à data fim.';

  angular
    .module('crd')
    .controller('ComunicacoesEnviadasListarController', ComunicacoesEnviadasListarController);

  ComunicacoesEnviadasListarController.$inject = [
    '$scope',
    '$compile',
    '$location',
    '$stateParams',
    'comunicacaoApiService',
    'constantes',
    'DTColumnBuilder',
    'DTOptionsBuilder',
    'feedbackService',
    'sistemaNegocioApiService',
    'documentoApiService',
    '$uibModal',
    'instituicaoApiService'
  ];

  function ComunicacoesEnviadasListarController(
    $scope,
    $compile,
    $location,
    $stateParams,
    comunicacaoApiService,
    constantes,
    DTColumnBuilder,
    DTOptionsBuilder,
    feedbackService,
    sistemaNegocioApiService,
    documentoApiService,
    $uibModal,
    instituicaoApiService
  ) {
    var vm = this;
    var self = $scope;
    var tempPeriodicidadeSelecionada;

    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.gerarXLS = gerarXLS;
    vm.abrirModalExcluir = abrirModalExcluir;
    vm.carregarSistemaNegocio = carregarSistemaNegocio;
    vm.limparMensagens = limparMensagens;
    vm.dtInstanceCallback = dtInstanceCallback;
    vm.exibirResultadoPesquisa = exibirResultadoPesquisa;
    vm.esconderResultadoPesquisa = esconderResultadoPesquisa;
    vm.validaPeriodoBaseCalculo = validaPeriodoBaseCalculo;
    vm.validaPeriodoComunicacao = validaPeriodoComunicacao;
    vm.msgPeriodo = '';
    vm.msgComunicacao = '';
    vm.mascaraData = '99/9999';
    vm.formatoData = 'MM/yyyy';
    vm.placeholderData = 'mm/aaaa';
    vm.checarMudancaPeriodicidade = checarMudancaPeriodicidade;
    vm.carregarDocumentos = carregarDocumentos;
    vm.desabilitarCampoSituacao = desabilitarCampoSituacao;
    vm.checarMudancaOrigem = checarMudancaOrigem;
    inicializarView();
    esconderResultadoPesquisa();
    carregarTela();

    function inicializarView() {
      vm.view = {
        formulario: {
          visivel: true
        },
        resultado: {
          visivel: false
        }
      };
      vm.comunicacoes = [];
    }

    function normalizarResultadoPesquisa(comunicacoes) {
      var idx = 1;
      vm.comunicacoes.splice(0, vm.comunicacoes.length);
      comunicacoes.forEach(function (comunicacao) {
        comunicacao.id = idx;
        comunicacao.sistemasNegocioFormatados = [];

        comunicacao.sistemasNegocio.forEach(function (sistemaNegocio) {
          comunicacao.sistemasNegocioFormatados.push(sistemaNegocio.sigla);
        });

        comunicacao.sistemasNegocioFormatados = comunicacao.sistemasNegocioFormatados.join(', ');
        comunicacao.segmentoFormatado = comunicacao.instituicao.segmento ? comunicacao.instituicao.segmento.descricao : '';
        comunicacao.numeroCorreio = comunicacao.numeroCorreio;

        vm.comunicacoes[comunicacao.id] = comunicacao;
        idx += 1;
      });
    }

    function carregarTela() {
      return comunicacaoApiService
        .telaPesquisar()
        .then(successOnCarregarTela);

      function successOnCarregarTela(resource) {
        vm.parametrosPesquisa = extrairParametrosDaUrl($stateParams);

        checarMudancaOrigem(vm.parametrosPesquisa.origem);

        vm.origens = resource._embedded.origens;
        vm.situacoesEnvio = resource._embedded.situacoesEnvio;
        vm.podeExcluir = resource.podeExcluir;

        vm.sistemasNegocio = resource._embedded.sistemasNegocio;

        if ($stateParams.idBacen) {
          vm.parametrosPesquisa.instituicao = null;
          instituicaoApiService.carregar($stateParams.idBacen)
            .then(function(instituicao) {
              vm.parametrosPesquisa.instituicao = instituicao;
              dispararPesquisa(resource);
            })
            .catch(function(response) {
              feedbackService.erro(
                response && response.data && response.data.mensagem
                  ? response.data.mensagem
                  : 'Essa entidade supervisionada não está cadastrada no CRD.'
              );
            });
        } else {
          dispararPesquisa(resource);
        }

        carregarDocumentos();
      }

      function dispararPesquisa(resource) {
        if (!$stateParams.isPesquisaRealizada) {
          if (!_.isEmpty(resource._embedded.sistemasNegocioDoCurador)) {
            vm.parametrosPesquisa.sistemasNegocio = resource._embedded.sistemasNegocioDoCurador;
          }

          if (resource.fazerPesquisaInical) {
            vm.parametrosPesquisa.periodoEnvioComunicacao.inicio = $stateParams.envioInicio ? extrator.data($stateParams.envioInicio) : moment().toDate();
            vm.parametrosPesquisa.periodoEnvioComunicacao.fim = $stateParams.envioFim ? extrator.data($stateParams.envioFim) : moment().toDate();

            vm.pesquisar(vm.parametrosPesquisa);
          }

        } else {
          vm.pesquisar(vm.parametrosPesquisa);
        }
      }
    }

    function gerarXLS() {
      var searchParameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      comunicacaoApiService.gerarXLS(searchParameters).then(function successOnGerarXLS() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      });
    }

    function exibirResultadoPesquisa() {
      vm.view.resultado.visivel = true;
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    ComunicacoesEnviadasListarController.prototype.navegarNaGrid = function (pagination) {
      this.parametrosPesquisa.numeroPagina = pagination.number;
      this.parametrosPesquisa.quantidadePorPagina = pagination.size;
      this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
      this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;

      return this.pesquisar(this.parametrosPesquisa);
    };

    ComunicacoesEnviadasListarController.prototype.realizarPesquisa = function (parametrosPesquisa) {
      parametrosPesquisa.numeroPagina = undefined;
      parametrosPesquisa.ordenacaoCampo = undefined;
      parametrosPesquisa.ordenacaoDirecao = undefined;
      parametrosPesquisa.jaPesquisado = true;

      return this.pesquisar(parametrosPesquisa);
    };

    function pesquisar(parameters) {
      var searchParameters = montarParametrosDaUrl(parameters);

      if (camposParaPesquisaInvalidos(searchParameters)) {
        esconderResultadoPesquisa();
        return;
      }

      $location.search(searchParameters);
      return comunicacaoApiService
        .pesquisar(searchParameters)
        .then(successOnPesquisar);

      function successOnPesquisar(resource) {
        vm.pagina = resource._embedded;
        normalizarResultadoPesquisa(vm.pagina.content);
        exibirResultadoPesquisa();
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
      vm.parametrosPesquisa.sistemasNegocio = undefined;
      vm.parametrosPesquisa.documentos = undefined;
      vm.parametrosPesquisa.segmentos = undefined;
      vm.parametrosPesquisa.instituicao = undefined;
      vm.parametrosPesquisa.periodoEnvioComunicacao.inicio = undefined;
      vm.parametrosPesquisa.periodoEnvioComunicacao.fim = undefined;
      vm.parametrosPesquisa.periodoDataBase.inicio = undefined;
      vm.parametrosPesquisa.periodoDataBase.fim = undefined;
      vm.parametrosPesquisa.origem = undefined;
      vm.parametrosPesquisa.situacao = undefined;

      carregarSistemaNegocio(vm.parametrosPesquisa.grupoPeriodicidade);
      carregarDocumentos();
      vm.limparMensagens();
      vm.esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function camposParaPesquisaInvalidos(parameters) {
      var periodoDataBaseInicio = moment.utc(parameters.dataBaseInicio);
      var periodoDataBaseFim = moment.utc(parameters.dataBaseFim);

      if (angular.isDefined(parameters.dataBaseInicio)
        && angular.isDefined(parameters.dataBaseFim)
        && periodoDataBaseInicio.isAfter(periodoDataBaseFim)) {
        feedbackService.erro('A data-base início deve ser menor ou igual à data-base fim.');
        return true;
      }

      return false;
    }

    function validaPeriodoComunicacao() {
      if (periodoComunicacaoInvalido()) {
        vm.msgComunicacao = MSG_ERRO_PERIODO_COMUNICACAO;
        return false;
      }
      vm.msgComunicacao = '';
      return true;
    }

    function periodoComunicacaoInvalido() {
      if (!vm.parametrosPesquisa) {
        return true;
      }
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      var periodoEnvioComunicacaoInicio = moment.utc(parameters.envioInicio);
      var periodoEnvioComunicacaoFim = moment.utc(parameters.envioFim);
      var fim = vm.parametrosPesquisa.periodoEnvioComunicacao.fim;
      var inicio = vm.parametrosPesquisa.periodoEnvioComunicacao.inicio;
      return inicio && fim && periodoEnvioComunicacaoInicio.isAfter(periodoEnvioComunicacaoFim);
    }

    function validaPeriodoBaseCalculo() {
      if (periodoBaseCalculoInvalido()) {
        vm.msgPeriodo = MSG_ERRO_PERIODO_DATA_BASE;
        return false;
      }
      vm.msgPeriodo = '';
      return true;
    }

    function periodoBaseCalculoInvalido() {
      if (!vm.parametrosPesquisa) {
        return true;
      }
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      var periodoDataBaseInicio = moment.utc(parameters.dataBaseInicio);
      var periodoDataBaseFim = moment.utc(parameters.dataBaseFim);
      var fim = vm.parametrosPesquisa.periodoDataBase.fim;
      var inicio = vm.parametrosPesquisa.periodoDataBase.inicio;
      return inicio && fim && periodoDataBaseInicio.isAfter(periodoDataBaseFim);
    }

    function dtInstanceCallback(dtInstance) {
      vm.dtInstance = dtInstance;
    }

    function periodicidadeEhMensal(grupoPeriodicidade) {
      return grupoPeriodicidade === 'MENSAL_OU_MAIOR';
    }

    function montarParametrosDaUrl(filtro) {
      var criador = parametrosUrl.Criador;

      if (periodicidadeEhMensal(filtro.grupoPeriodicidade) && filtro.periodoDataBase.fim) {
        var newDate = new Date(filtro.periodoDataBase.fim.getFullYear(), filtro.periodoDataBase.fim.getMonth() + 1, 0);
        filtro.periodoDataBase.fim = newDate;
      }

      return {
        dataBaseFim: criador.data(filtro.periodoDataBase.fim),
        dataBaseInicio: criador.data(filtro.periodoDataBase.inicio),
        documentos: criador.arrayPk(filtro.documentos),
        envioFim: criador.data(filtro.periodoEnvioComunicacao.fim),
        envioInicio: criador.data(filtro.periodoEnvioComunicacao.inicio),
        idBacen: criador.idBacen(filtro.instituicao),
        isPesquisaRealizada: true,
        segmentos: criador.arrayCodigo(filtro.segmentos),
        sistemasNegocio: criador.arrayPk(filtro.sistemasNegocio),
        grupoPeriodicidade: filtro.grupoPeriodicidade,
        origem: criador.enumName(filtro.origem),
        situacao: criador.enumName(filtro.situacao),

        numeroPagina: criador.number(filtro.numeroPagina),
        quantidadePorPagina: criador.number(filtro.quantidadePorPagina),
        ordenacaoCampo: criador.string(filtro.ordenacaoCampo),
        ordenacaoDirecao: criador.string(filtro.ordenacaoDirecao)
      };
    }

    function checarMudancaPeriodicidade(valor) {
      if (tempPeriodicidadeSelecionada !== valor) {
        vm.parametrosPesquisa.sistemasNegocio = null;
        vm.parametrosPesquisa.documentos = null;
        vm.documentos = null;
        vm.parametrosPesquisa.periodoDataBase.inicio = null;
        vm.parametrosPesquisa.periodoDataBase.fim = null;

        vm.limparMensagens();
        vm.esconderResultadoPesquisa();
      }
      tempPeriodicidadeSelecionada = valor;
    }

    function carregarSistemaNegocio(grupoPeriodicidade) {
      var parametros = {
        grupoPeriodicidade: grupoPeriodicidade,
        quantidadePorPagina: 99999
      };

      getPeriodicidade(grupoPeriodicidade);

      return sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (resource) {
        vm.sistemasNegocio.length = 0;
        Array.prototype.push.apply(vm.sistemasNegocio, resource.data.content);

        return resource;
      });
    }

    function desabilitarCampoSituacao(value) {
      vm.desabilitarCampoSituacao = value;
    }

    function checarMudancaOrigem(origem) {
      vm.desabilitarCampoSituacao = origem !== undefined && origem !== null && origem.enumName === 'TEMPESTIVIDADE';

      if (origem !== undefined && origem !== null && origem.checked && origem.enumName === 'TEMPESTIVIDADE') {
        var extrator = parametrosUrl.Extrator;
        vm.parametrosPesquisa.situacao = extrator.enumName('ENVIADAS');
      }
    }
    function carregarDocumentos() {
      if (!vm.parametrosPesquisa.sistemasNegocio || _.isEmpty(vm.parametrosPesquisa.sistemasNegocio)) {
        vm.documentos = null;
        return;
      }

      var snPks = _.map(vm.parametrosPesquisa.sistemasNegocio, function (value) {
        return value.pk;
      });

      var parametros = {
        periodicidade: periodicidadeEhMensal(vm.parametrosPesquisa.grupoPeriodicidade) ? 'MENSAL' : 'DIARIA',
        sistemaNegocioPks: snPks
      };

      documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros)
        .then(function sucessoPesquisarSistemasNegocio(resource) {
          vm.documentos = resource.data._embedded.resultado;
        });
    }

    function getPeriodicidade(grupoPeriodicidade) {
      if (periodicidadeEhDiaria(grupoPeriodicidade)) {
        vm.mascaraData = '99/99/9999';
        vm.formatoData = 'dd/MM/yyyy';
        vm.placeholderData = 'dd/mm/aaaa';
      } else {
        vm.mascaraData = '99/9999';
        vm.formatoData = 'MM/yyyy';
        vm.placeholderData = 'mm/aaaa';
      }
    }

    function periodicidadeEhDiaria(grupoPeriodicidade) {
      return grupoPeriodicidade === 'MENOR_QUE_MENSAL';
    }

    function extrairParametrosDaUrl(paramsURL) {
      var extrator = parametrosUrl.Extrator;
      var parametrosExtraidos = {};

      if ($stateParams.grupoPeriodicidade) {
        parametrosExtraidos.grupoPeriodicidade = $stateParams.grupoPeriodicidade;
      } else {
        parametrosExtraidos.grupoPeriodicidade = 'MENSAL_OU_MAIOR';
      }

      getPeriodicidade($stateParams.grupoPeriodicidade);

      parametrosExtraidos.documentos = extrator.arrayObjetoPk(paramsURL.documentos);
      parametrosExtraidos.instituicao = extrator.objetoIdBacen(paramsURL.idBacen);

      parametrosExtraidos.periodoDataBase = {
        inicio: extrator.data(paramsURL.dataBaseInicio),
        fim: extrator.data(paramsURL.dataBaseFim)
      };
      parametrosExtraidos.periodoEnvioComunicacao = {
        inicio: extrator.data(paramsURL.envioInicio),
        fim: extrator.data(paramsURL.envioFim)
      };

      parametrosExtraidos.segmentos = extrator.arrayObjetoCodigo(paramsURL.segmentos);
      parametrosExtraidos.sistemasNegocio = extrator.arrayObjetoPk(paramsURL.sistemasNegocio);

      parametrosExtraidos.origem = extrator.enumName($stateParams.origem);
      parametrosExtraidos.situacao = extrator.enumName($stateParams.situacao);

      parametrosExtraidos.numeroPagina = extrator.number(paramsURL.numeroPagina);
      parametrosExtraidos.quantidadePorPagina = extrator.number(paramsURL.quantidadePorPagina);
      parametrosExtraidos.ordenacaoCampo = extrator.string(paramsURL.ordenacaoCampo);
      parametrosExtraidos.ordenacaoDirecao = extrator.string(paramsURL.ordenacaoDirecao);

      return parametrosExtraidos;
    }

    function abrirModalExcluir(comunicacaoId) {

      return comunicacaoApiService
        .buscarInformacoesComunicacao({ comunicacaoId: comunicacaoId })
        .then(function (response) {

          $uibModal.open({
            templateUrl: 'views/comunicacoes-enviadas/modal-excluir-comunicacao/modal-excluir-comunicacao-tpl.html',
            controller: 'ComunicacoesPendentesModalController',
            controllerAs: 'ComunicacoesPendentesModalCtlr',
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            bindToController: true,
            keyboard: true,
            size: 'lg',
            resolve: {
              comunicacaoId: function () {
                return comunicacaoId;
              },
              informacoes: function () {
                return response; // objeto da API
              }
            },
          }).result.then(function (resultado) {
            if (resultado.deletado) {
              vm.pagina.content = vm.pagina.content.filter(function (c) {
                return c.comunicacaoId !== resultado.comunicacaoId;
              });

            }
          });
        })
    }
  }


})(angular, moment, CRDUtils.ParametrosUrl, _);
;
(function(angular, parametrosUrl) {
  'use strict';

  angular
    .module('crd')
    .controller('CrdModalEmailEnviadoController', CrdModalEmailEnviadoController);

  CrdModalEmailEnviadoController.$inject = ['$uibModalInstance', 'comunicacaoApiService'];

  function CrdModalEmailEnviadoController($uibModalInstance, comunicacaoApiService) {
    var vm = this;
    vm.cancel = cancel;
    pesquisar();

    function pesquisar() {
      var filtro = montarParametrosDaUrl(vm.comunicacao, vm.situacao);
      return comunicacaoApiService
        .detalhar(filtro)
        .then(successOnDetalhar);

      function successOnDetalhar(data) {
        vm.comunicacao = data;
      }
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
  }

  function montarParametrosDaUrl(comunicacao, situacao) {
    var criador = parametrosUrl.Criador;
    return {
      comunicacaoId: comunicacao,
      situacao: situacao.codigo === 'E' ? 'ENVIADAS' : 'PENDENTES'
    };
  }
})(angular, CRDUtils.ParametrosUrl);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdModalEmailEnviado', CrdModalEmailEnviado);

  CrdModalEmailEnviado.$inject = ['$uibModal'];

  function CrdModalEmailEnviado($uibModal) {
    var directive = {
      link: postLink,
      restrict: 'A',
      scope: {
        comunicacao: '=',
        situacao: '='
      }
    };

    return directive;

    function postLink($scope, $element) {
      $element.bind('click', function elementClickFunction() {
        $uibModal.open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          controller: 'CrdModalEmailEnviadoController',
          controllerAs: 'crdModalEmailEnviadoCtrl',
          keyboard: false,
          scope: $scope,
          templateUrl: 'views/comunicacoes-enviadas/crd-modal-email-enviado-tpl.html'
        });
      });
    }
  }
})(angular);
;
(function (angular, HttpStatus) {
    'use strict';

    angular.module('crd')
        .controller('ComunicacoesPendentesModalController', ComunicacoesPendentesModalController);

    ComunicacoesPendentesModalController.$inject = ['$uibModalInstance', 'feedbackService', 'informacoes', 'comunicacaoId', 'comunicacaoApiService'];
    function ComunicacoesPendentesModalController($uibModalInstance, feedbackService, informacoes, comunicacaoId, comunicacaoApiService) {
        var vm = this;
        vm.cancelar = cancelar;
        vm.confirmar = confirmar;
        vm.informacoes = informacoes;
        vm.comunicacaoId = comunicacaoId;

        function cancelar() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmar() {

            var dadosExclusao = {
                textoIndicio: vm.texto,
                justificativa: vm.justificativa,
                rejeitarDocumento: vm.rejeitarDocumento,
                ultimoIndicioEmAberto: vm.informacoes.ultimoIndicioEmAberto,
                indicioId: vm.informacoes.indicioId,
                situacaoIndicio: vm.informacoes.situacaoIndicio,
                entId: vm.informacoes.entId,
                situacaoEntradaArquivo: vm.informacoes.situacaoEntradaArquivo
            };

            comunicacaoApiService.excluir(vm.comunicacaoId, dadosExclusao)
                .then(function (response) {

                    if (response.status === HttpStatus.OK) {
                        feedbackService.sucesso('A comunicação foi excluída com sucesso.');
                        $uibModalInstance.close({ deletado: true, comunicacaoId: vm.comunicacaoId });
                    } else {
                        feedbackService.violacoes(response.data.message);
                    }

                }).catch(function (error) {
                    feedbackService.violacoes(error.data.message);
                });
        }

        vm.$onInit = function () {

        };

    }
})(angular, httpStatusCode);;
(function(angular, HttpStatus, CRDUtils) {
  'use strict';

  var conversor = CRDUtils.Conversor;
  var criador = CRDUtils.ParametrosUrl.Criador;

  angular
    .module('crd')
    .controller('ConformidadeConfirmarInclusaoController', ConformidadeConfirmarInclusaoController);

  ConformidadeConfirmarInclusaoController.$inject = ['$location', '$state', '$stateParams', '$timeout', 'conformidadeApiService', 'feedbackService'];

  function ConformidadeConfirmarInclusaoController($location, $state, $stateParams, $timeout, conformidadeApiService, feedbackService) {
    var vm = this;

    vm.cancelar = cancelar;
    vm.incluir = incluir;
    vm.toogleEmais = toogleEmais;

    iniciar();

    function cancelar() {
      $state.go('conformidade-listar');
    }

    function carregarTela(parametros) {
      if (!(parametros && parametros.dataFinal)) {
        $location.path('/conformidade/incluir').search(parametros);

        return null;
      }

      var parametrosParaConfirmarInclusao = {
        dataFinal: parametros.dataFinal,
        documentos: parametros.documentos
      };

      return conformidadeApiService.montarTelaConfirmacao(parametrosParaConfirmarInclusao)
        .then(function sucessoAoMontarTelaConfirmacao(response) {
          vm.conformidade = response;
          vm.conformidade.dataFinalFormatada = moment(vm.conformidade.dataFinal).format('DD/MM/YYYY');

          return response;
        })
        .catch(function erroAoMontarTelaConfirmacao(response) {
          if (response.httpStatus === HttpStatus.PRECONDITION_FAILED) {
            $location.path('/conformidade/incluir')
              .search(parametros)
              .replace();

            $timeout(function() {
              feedbackService.violacoes(response.body);
            });
          }
        });
    }

    function incluir(conformidade) {
      var dados = tratarDadosParaEnviar(conformidade);

      return conformidadeApiService.incluir(dados)
        .then(function sucessoAoIncluir(response) {
          if (response.status === HttpStatus.CREATED) {
            $state.go('conformidade-listar');
            feedbackService.sucesso('E-mail enviado com sucesso.');
          } else {
            feedbackService.violacoes(response.data);
          }
        });
    }

    function iniciar() {
      carregarTela($stateParams);
    }

    function toogleEmais() {
      vm.mostrarEmails = !vm.mostrarEmails;
    }

    function tratarDadosParaEnviar(conformidade) {
      return {
        dataFinal: conversor.dateToString(conformidade.dataFinal),
        documentos: criador.arrayObjetoPk(conformidade.documentos),
        emails: conformidade.emails,
        emailsEmCopia: conformidade.emailsEmCopia
      };
    }
  }
})(angular, httpStatusCode, CRDUtils);
;
(function(angular, HttpStatus) {
  'use strict';

  angular
    .module('crd')
    .controller('ConformidadeDarConformidadeController', ConformidadeDarConformidadeController);

  ConformidadeDarConformidadeController.$inject = ['$location', '$stateParams', 'conformidadeApiService', 'feedbackService'];

  function ConformidadeDarConformidadeController($location, $stateParams, conformidadeApiService, feedbackService) {
    var vm = this;

    vm.voltar = voltar;
    vm.salvar = salvar;

    carregarTela();

    function carregarTela() {
      carregarDadosConformidade($stateParams.id);
    }

    function carregarDadosConformidade(id) {
      return conformidadeApiService
        .montarTelaDarConformidade(id)
        .then(successOnCarregar);

      function successOnCarregar(resource) {
        vm.conformidade = resource;
      }
    }

    function salvar(conformidade) {
      var darConformidade = { 
        observacao: conformidade.observacaoCurador
      };

      return conformidadeApiService
        .darConformidade($stateParams.id, darConformidade)
        .then(successCriarExcecao);

      function successCriarExcecao(response) {
        if (response.status === HttpStatus.OK) {
          feedbackService.sucesso('Conformidade salva com sucesso.');
          vm.voltar();
        } else {
          feedbackService.violacoes(response.data);
        }
      }
    }

    function voltar() {
      $location.path('/conformidade');
    }
  }
})(angular, httpStatusCode);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('ConformidadeDetalharController', ConformidadeDetalharController);

  ConformidadeDetalharController.$inject = ['$location', '$stateParams', 'conformidadeApiService'];

  function ConformidadeDetalharController($location, $stateParams, conformidadeApiService) {
    var vm = this;

    vm.voltar = voltar;
    vm.darConformidade = darConformidade;

    carregarTela();

    function carregarTela() {
      carregarDadosConformidade($stateParams.id);
    }

    function carregarDadosConformidade(id) {
      return conformidadeApiService
        .detalhar(id)
        .then(successOnCarregar);

      function successOnCarregar(resource) {
        vm.conformidade = resource;
      }
    }

    function voltar() {
      $location.path('/conformidade');
    }

    function darConformidade() {

      $location.path('/conformidade/' + $stateParams.id + '/dar-conformidade');
    }  
  }
})(angular);
;
(function(angular, CRDUtils) {
  'use strict';

  var conversor = CRDUtils.Conversor;
  var criador = CRDUtils.ParametrosUrl.Criador;
  var extrator = CRDUtils.ParametrosUrl.Extrator;

  angular
    .module('crd')
    .controller('ConformidadeIncluirController', ConformidadeIncluirController);

  ConformidadeIncluirController.$inject = ['$location', '$scope', '$stateParams', 'conformidadeApiService', 'feedbackService'];

  function ConformidadeIncluirController($location, $scope, $stateParams, conformidadeApiService, feedbackService) {
    var vm = this;

    vm.voltar = voltar;
    vm.salvar = salvar;

    iniciar();

    function buscarDadosIniciais(parametros) {
      return conformidadeApiService.montarTelaIncluir()
        .then(function sucessoAoCarregarTelaIncluir(resource) {
          vm.dados = resource._embedded;
          vm.dados.inicioData = conversor.stringToDate(vm.dados.inicioData);
          vm.conformidade = {};

          if (parametros && parametros.dataFinal) {
            vm.conformidade.dataFinal = extrator.data(parametros.dataFinal);
            vm.conformidade.documentos = extrator.arrayObjetoPk(parametros.documentos);
            vm.conformidade.sistemasNegocio = extrator.arrayObjetoPk(parametros.sistemasNegocio);
          } else {
            vm.conformidade.documentos = vm.dados.documentos;
            vm.conformidade.sistemasNegocio = vm.dados.sistemasNegocio;
            feedbackService.limpar();
          }

          return resource;
        });
    }

    function iniciar() {
      buscarDadosIniciais($stateParams);
    }

    function salvar(conformidade) {
      var dados = prepararDados(conformidade);

      $location.path('/conformidade/confirmar-inclusao')
        .search(dados)
        .replace();

      $scope.$apply();
    }

    function voltar() {
      $location.path('/conformidade');
    }

    function prepararDados(conformidade) {
      return {
        dataFinal: conversor.dateToString(conformidade.dataFinal),
        documentos: criador.arrayPk(conformidade.documentos),
        sistemasNegocio: criador.arrayPk(conformidade.sistemasNegocio)
      };
    }
  }
})(angular, CRDUtils);
;
(function(angular, moment, $, parametrosUrl) {
  'use strict';

  var DRAW = 0;
  var ORDER = 2;
  var START = 3;
  var LENGTH = 4;
  var RETORNO_NEGATIVO = -1;
  var RETORNO_POSITIVO = 1;
  var DDMMYYYY = 'DD/MM/YYYY';

  angular
    .module('crd')
    .controller('ConformidadeListarController', ConformidadeListarController);

  ConformidadeListarController.$inject = [
    '$compile',
    '$filter',
    '$location',
    '$stateParams',
    '$scope',
    'conformidadeApiService',
    'constantes',
    'DTColumnBuilder',
    'DTOptionsBuilder',
    'feedbackService'
  ];

  function ConformidadeListarController(
    $compile,
    $filter,
    $location,
    $stateParams,
    $scope,
    conformidadeApiService,
    constantes,
    DTColumnBuilder,
    DTOptionsBuilder,
    feedbackService
  ) {
    var vm = this;
    var self = $scope;

    vm.pesquisar = pesquisar;
    vm.dtInstanceCallback = dtInstanceCallback;
    vm.limparMensagens = limparMensagens;
    vm.marcarAberta = marcarAberta;
    vm.marcarFechada = marcarFechada;
    vm.mascaraData = '99/99/9999';
    vm.formatoData = 'dd/MM/yyyy';
    vm.placeholderData = 'dd/mm/aaaa';
    vm.msgPeriodo = '';
    vm.pesquisarExcel = pesquisarExcel;
    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.validaPeriodo = validaPeriodo;
    vm.esconderResultadoPesquisa = esconderResultadoPesquisa;

    inicializar();
    esconderResultadoPesquisa();
    carregarTela();

    function inicializar() {
      vm.view = {
        formulario: {
          visivel: true
        },
        resultado: {
          visivel: false
        }
      };

      vm.parametrosPesquisa = {
        aberta: true,
        documentos: null,
        fechada: null,
        fimConformidadeFim: null,
        fimConformidadeInicio: null,
        sistemasNegocio: null
      };
      vm.conformidades = [];

      vm.dtColumns = criarColunas();
    }

    function criarColunas() {
      var colunaAcoes = DTColumnBuilder
        .newColumn(null)
        .notSortable()
        .renderWith(htmlColunaAcoes)
        .withClass('coluna-acoes');

      return [
        DTColumnBuilder.newColumn('documento.sistemaNegocio.sigla').withClass('text-center'),
        DTColumnBuilder.newColumn('documento.codigo').withClass('text-center'),
        DTColumnBuilder.newColumn('dataFinalFormatada').withClass('text-center'),
        DTColumnBuilder.newColumn('autor.nome').withClass('text-center'),
        DTColumnBuilder.newColumn('dataEmailFormatada').withClass('text-center'),
        DTColumnBuilder.newColumn('responsavel.nome').withClass('text-center').withOption('defaultContent', ''),
        DTColumnBuilder.newColumn('dataConformidadeFormatada').withClass('text-center'),
        colunaAcoes
      ];
    }

    function pesquisarExcel() {
      var parameters = parametrosPesquisa();
      conformidadeApiService.gerarXlsx(parameters).then(sucessoOnGerarXLS);

      function sucessoOnGerarXLS() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      }
    }

    function marcarAberta() {
      if (vm.parametrosPesquisa.aberta) {
        vm.parametrosPesquisa.fechada = false;
      }
    }

    function marcarFechada() {
      if (vm.parametrosPesquisa.fechada) {
        vm.parametrosPesquisa.aberta = false;
      }
    }

    function validaPeriodo() {
      if (vm.parametrosPesquisa.fimConformidadeFim && vm.parametrosPesquisa.fimConformidadeInicio
          && parseInt(moment(vm.parametrosPesquisa.fimConformidadeInicio).format('YYYYMMDD'))
          > parseInt(moment(vm.parametrosPesquisa.fimConformidadeFim).format('YYYYMMDD'))) {
        vm.msgPeriodo = 'Data fim deve ser maior ou igual a Data início.';
        return false;
      }
      return true;
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function carregarTela() {
      return conformidadeApiService
        .montarTelaPesquisar()
        .then(successOnTelaPesquisar);

      function successOnTelaPesquisar(resource) {
        vm.sistemasNegocio = resource._embedded.sistemasNegocio;
        vm.popularSistemaNegocio = resource._embedded.popularSistemaNegocio;
        vm.podeIncluir = resource._links['crd-conformidade-incluir'];

        if (_.compact(_.values($stateParams)).length) {
          extrairParametrosDaUrl($stateParams);
        }

        if (vm.popularSistemaNegocio && !vm.parametrosPesquisa.sistemasNegocio) {
          vm.parametrosPesquisa.sistemasNegocio = resource._embedded.sistemasNegocio;
        }
        pesquisar();
      }
    }

    function pesquisar() {
      var parameters = parametrosPesquisa();

      $location.search(parameters);
      return conformidadeApiService
        .pesquisar(parameters)
        .then(successOnPesquisar);

      function successOnPesquisar(resource) {
        vm.resultadoPesquisa = resource._embedded.resultado;
        prepararGridResultados();
        exibirResultadoPesquisa();
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.sistemasNegocio = undefined;
      vm.parametrosPesquisa.documentos = undefined;
      vm.parametrosPesquisa.fechada = undefined;
      vm.parametrosPesquisa.aberta = undefined;
      vm.parametrosPesquisa.fimConformidadeInicio = undefined;
      vm.parametrosPesquisa.fimConformidadeFim = undefined;

      vm.limparMensagens();
      vm.esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function dtInstanceCallback(dtInstance) {
      vm.dtInstance = dtInstance;
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function prepararGridResultados() {
      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('serverSide', true)
        .withFnServerData(serverData)
        .withDataProp('data')
        .withOption('createdRow', createdRow)
        .withOption('stateSaveParams', function(settings, data) {
          _.each(data.columns, function(column) {
            delete column.visible;
          });
        });
    }

    function exibirResultadoPesquisa() {
      var rows = vm.dtInstance.DataTable.rows();
      rows.invalidate().draw();
      vm.view.resultado.visivel = true;
    }

    function serverData(sSource, aoData, fnCallback) {
      var draw = aoData[DRAW].value;
      var order = aoData[ORDER].value;
      var start = draw === 1 ? 0 : aoData[START].value;
      var length = aoData[LENGTH].value;
      ordenarLista(order);
      var records = {
        data: vm.resultadoPesquisa.slice(start, start + length),
        draw: draw,
        recordsFiltered: vm.resultadoPesquisa.length,
        recordsTotal: vm.resultadoPesquisa.length
      };

      formatarResultadoParaExibicao(records.data);

      fnCallback(records);

      self.$safeApply();
    }

    function elementosColuna() {
      var elementos = [];
      elementos.push({
        descColuna: 'documento.sistemaNegocio.sigla'
      });
      elementos.push({
        descColuna: 'documento.codigo'
      });
      elementos.push({
        descColuna: 'dataFinal'
      });
      elementos.push({
        descColuna: 'autor.nome'
      });
      elementos.push({
        descColuna: 'conformidadeDestinatario.dataEmail'
      });
      elementos.push({
        descColuna: 'responsavel.nome'
      });
      elementos.push({
        descColuna: 'dataConformidade'
      });
      return elementos;
    }

    function ordenarLista(order) {
      if (order.length > 0) {
        var elementos = elementosColuna();
        vm.resultadoPesquisa.sort(sortBy(elementos[order[0].column].descColuna, order[0].dir === 'asc'));
      }
    }

    function sortBy(field, reverse) {
      var reverso = reverse;

      function key(elemento) {
        if (field.split('.').length > 1) {
          var retorno = elemento;
          field.split('.').forEach(function(ind) {
            if (retorno !== null) {
              retorno = retorno[ind];
            }
          });
          return retorno === null ? '' : retorno;
        }
        return elemento[field] === null ? '' : elemento[field];
      }

      reverso = reverso ? RETORNO_NEGATIVO : RETORNO_POSITIVO;

      return function(primeiroCampo, segundoCampo) {
        var primeiroValor = primeiroCampo;
        var segundoValor = segundoCampo;
        primeiroValor = key(primeiroValor);
        segundoValor = key(segundoValor);
        return reverso * ((primeiroValor > segundoValor) - (segundoValor > primeiroValor));
      };
    }

    function formatarResultadoParaExibicao(resultado) {
      var idx = 1;
      vm.conformidades.splice(0, vm.conformidades.length);
      _.each(resultado, function(conformidade) {

        conformidade.dataFinalFormatada = formatarData(conformidade.dataFinal);
        conformidade.dataEmailFormatada = formatarData(conformidade.conformidadeDestinatario.dataEmail);
        conformidade.dataConformidadeFormatada = formatarData(conformidade.dataConformidade);
        vm.conformidades[idx] = conformidade;
        idx += 1;
      });
    }

    function formatarData(data) {
      return data ? moment(data).format(DDMMYYYY) : '';
    }

    function createdRow(row) {
      $compile(angular.element(row).contents())(self);
    }

    function htmlColunaAcoes(conformidade) {
      var html = '';

      if (conformidade._links['crd-conformidade-detalhar']) {
        html += '<a ui-link-detalhar href="#/conformidade/' + conformidade.pk + '/detalhar" title="Detalhar confirmidade"></a>';
      }

      if (conformidade._links['crd-conformidade-dar-conformidade']) {
        html += '<a class="btn btn-default btn-xs" href="#/conformidade/' + conformidade.pk + '/dar-conformidade" title="Dar Conformidade"><i class="fa fa-thumbs-o-up text-primary" aria-hidden="true"></i></a>';
      }

      return html;
    }

    function parametrosPesquisa() {
      var criador = parametrosUrl.Criador;
      return {
        jaPesquisado: true,
        aberta: vm.parametrosPesquisa.aberta,
        dataFim: criador.data(vm.parametrosPesquisa.fimConformidadeFim),
        dataInicio: criador.data(vm.parametrosPesquisa.fimConformidadeInicio),
        documentos: criador.arrayPk(vm.parametrosPesquisa.documentos),
        fechada: vm.parametrosPesquisa.fechada,
        sistemasNegocio: criador.arrayPk(vm.parametrosPesquisa.sistemasNegocio)
      };
    }

    function extrairParametrosDaUrl(paramentrosURL) {
      var extrator = parametrosUrl.Extrator;
      vm.parametrosPesquisa.sistemasNegocio = extrator.arrayObjetoPk(paramentrosURL.sistemasNegocio);
      vm.parametrosPesquisa.documentos = extrator.arrayObjetoPk(paramentrosURL.documentos);
      vm.parametrosPesquisa.aberta = extrator.toBoolean(paramentrosURL.aberta);
      vm.parametrosPesquisa.fechada = extrator.toBoolean(paramentrosURL.fechada);
      vm.parametrosPesquisa.fimConformidadeInicio = extrator.data(paramentrosURL.dataInicio);
      vm.parametrosPesquisa.fimConformidadeFim = extrator.data(paramentrosURL.dataFim);
    }

    self.$watch('conformidadeListarCtrl.parametrosPesquisa', function() {
      esconderResultadoPesquisa();
    }, true);
  }
})(angular, moment, jQuery, CRDUtils.ParametrosUrl);
;
"use strict";
var AbaCritica = (function () {
    function AbaCritica(index, ativado, visivel) {
        if (ativado === void 0) { ativado = false; }
        if (visivel === void 0) { visivel = false; }
        this.index = index;
        this.ativado = ativado;
        this.visivel = visivel;
    }
    AbaCritica.createAbas = function () {
        return new AbasCritica;
    };
    AbaCritica.prototype.visibilidade = function (visivel) {
        this.visivel = visivel;
        this.ativado = false;
    };
    AbaCritica.prototype.ativar = function () {
        if (!this.visivel) {
            this.ativado = false;
            throw "Não é possível ativar esta aba.";
        }
        this.ativado = true;
    };
    return AbaCritica;
}());
var AbasCritica = (function () {
    function AbasCritica() {
        this.DADOS_GERAIS = new AbaCritica(0);
        this.COMPARACAO_DOCUMENTO = new AbaCritica(1);
        this.DADOS_MONITORADOS = new AbaCritica(2);
        this.todasAbas = [this.DADOS_GERAIS, this.COMPARACAO_DOCUMENTO, this.DADOS_MONITORADOS];
    }
    AbasCritica.prototype.ativar = function (aba) {
        _.forEach(this.todasAbas, function (aba) { return aba.ativado = false; });
        aba.ativar();
    };
    return AbasCritica;
}());
var AbasCriticaManual = (function () {
    function AbasCriticaManual() {
        this.DADOS_GERAIS = new AbaCritica(0);
        this.DADOS_MONITORADOS = new AbaCritica(2);
        this.todasAbas = [this.DADOS_GERAIS, this.DADOS_MONITORADOS];
    }
    AbasCriticaManual.prototype.ativar = function (aba) {
        _.forEach(this.todasAbas, function (aba) { return aba.ativado = false; });
        aba.ativar();
    };
    return AbasCriticaManual;
}());
//# sourceMappingURL=aba-critica.js.map;
"use strict";
var CrdArvoreDadoMonitoradoController = (function () {
    function CrdArvoreDadoMonitoradoController() {
    }
    CrdArvoreDadoMonitoradoController.prototype.$onInit = function () { };
    CrdArvoreDadoMonitoradoController.prototype.toogleCollapse = function (node) {
        node.collapse = !node.collapse;
        if (!node.collapse) {
            this.closeNode(node);
        }
    };
    CrdArvoreDadoMonitoradoController.prototype.closeNode = function (node) {
        var _this = this;
        if (!node.children) {
            return;
        }
        node.children.forEach(function (item) {
            item.collapse = false;
            _this.closeNode(item);
        });
    };
    return CrdArvoreDadoMonitoradoController;
}());
CrdArvoreDadoMonitoradoController.$inject = [];
angular.module('crd').controller('CrdArvoreDadoMonitoradoController', CrdArvoreDadoMonitoradoController);
//# sourceMappingURL=arvore-dado-monitorado-controller.js.map;
"use strict";
(function (angular) {
    'use strict';
    angular.module('crd')
        .directive('crdArvoreDadoMonitorado', crdArvoreDadoMonitoradoDirective);
    function crdArvoreDadoMonitoradoDirective() {
        var directive = {
            controller: 'CrdArvoreDadoMonitoradoController',
            controllerAs: 'crdArvoreDadoMonitoradoCtrl',
            link: postLink,
            restrict: 'E',
            templateUrl: 'views/critica-qualidade/arvore-dado-monitorado/arvore-dado-monitorado-tpl.html',
            scope: {
                dadosMonitorados: '=',
                removerSistemaNegocio: '&',
                removerDocumento: '&',
                removerCampo: '&'
            }
        };
        return directive;
        function postLink($scope, $element, $attributes, $controller) {
            $scope.$watchCollection('dadosMonitorados', function (newVal, oldVal) { return $controller.tree = ArvoreDadoMonitorado.toTree(newVal); });
            $controller.podeRemoverSistemaNegocio = !!$attributes.removerSistemaNegocio;
            $controller.podeRemoverDocumento = !!$attributes.removerDocumento;
            $controller.podeRemoverCampo = !!$attributes.removerCampo;
            $controller.removerSistemaNegocio = function (sistemaNegocio) { return $scope.removerSistemaNegocio({ $sistemaNegocio: sistemaNegocio }); };
            $controller.removerDocumento = function (documento) { return $scope.removerDocumento({ $documento: documento }); };
            $controller.removerCampo = function (campo) { return $scope.removerCampo({ $campo: campo }); };
        }
    }
})(angular);
//# sourceMappingURL=arvore-dado-monitorado-directive.js.map;
"use strict";
var ArvoreDadoMonitorado = (function () {
    function ArvoreDadoMonitorado() {
    }
    ArvoreDadoMonitorado.toTree = function (dadosMonitorados) {
        var _this = this;
        var tree = {
            name: 'Dados monitorados',
            active: true,
            collapse: true,
            children: new Array(),
            object: {}
        };
        if (!dadosMonitorados || dadosMonitorados.length <= 0) {
            return tree;
        }
        var treePorSistemaNegocio = {};
        var treePorDocumento = {};
        dadosMonitorados
            .sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(lhs.documento.sistemaNegocio.sigla, rhs.documento.sistemaNegocio.sigla)
            .append(lhs.documento.codigo, rhs.documento.codigo)
            .append(lhs.campo, rhs.campo)
            .build(); })
            .forEach(function (dadoMonitorado) {
            var sistemaNegocio = dadoMonitorado.documento.sistemaNegocio;
            var documento = dadoMonitorado.documento;
            var nodeSistemaNegocio = _this.getNodeSistemaNegocio(tree, treePorSistemaNegocio, sistemaNegocio);
            var nodeDocumento = _this.getNodeDocumento(nodeSistemaNegocio, treePorDocumento, documento);
            nodeDocumento.children.push(dadoMonitorado);
        });
        return tree;
    };
    ArvoreDadoMonitorado.getNodeSistemaNegocio = function (tree, treePorSistemaNegocio, sistemaNegocio) {
        if (!treePorSistemaNegocio[sistemaNegocio.pk]) {
            treePorSistemaNegocio[sistemaNegocio.pk] = {
                name: sistemaNegocio.sigla,
                active: true,
                collapse: true,
                children: new Array(),
                sistemaNegocio: sistemaNegocio
            };
            tree.children.push(treePorSistemaNegocio[sistemaNegocio.pk]);
        }
        return treePorSistemaNegocio[sistemaNegocio.pk];
    };
    ArvoreDadoMonitorado.getNodeDocumento = function (nodeSistemaNegocio, treePorDocumento, documento) {
        if (!treePorDocumento[documento.pk]) {
            treePorDocumento[documento.pk] = {
                name: documento.codigo,
                active: true,
                collapse: true,
                children: new Array(),
                documento: documento
            };
            nodeSistemaNegocio.children.push(treePorDocumento[documento.pk]);
        }
        return treePorDocumento[documento.pk];
    };
    return ArvoreDadoMonitorado;
}());
//# sourceMappingURL=arvore-dado-monitorado.js.map;
"use strict";
var CodigoCriticaQualidade = (function () {
    function CodigoCriticaQualidade() {
    }
    CodigoCriticaQualidade.gerarMascara = function (codigo) {
        if (!codigo) {
            return '';
        }
        return '99999';
    };
    CodigoCriticaQualidade.desconstruir = function (sistemaNegocio, codigo) {
        return sistemaNegocio && sistemaNegocio.sigla && codigo ? codigo.replace(sistemaNegocio.sigla, '') : '';
    };
    CodigoCriticaQualidade.formatarCodigoSiglaDocumentoTela = function (codigoCriticaQualidadeResource) {
        if (codigoCriticaQualidadeResource.siglaDocumento && codigoCriticaQualidadeResource.codigo) {
            return codigoCriticaQualidadeResource.codigo.replace(codigoCriticaQualidadeResource.siglaDocumento, '');
        }
        return '';
    };
    CodigoCriticaQualidade.costruir = function (sistemaNegocio, codigo) {
        return sistemaNegocio ? "" + sistemaNegocio.sigla + codigo : '';
    };
    CodigoCriticaQualidade.formatarCodigoSiglaDocumentoServidor = function (siglaDocumento, codigo) {
        return siglaDocumento && codigo ? "" + siglaDocumento + codigo : '';
    };
    return CodigoCriticaQualidade;
}());
//# sourceMappingURL=codigo-critica-qualidade.js.map;
"use strict";
var CriticaModalIncluirTesteController = (function () {
    function CriticaModalIncluirTesteController(pedidoTesteCriticaService, criticaQualidadeUtils, $uibModalInstance, feedbackService) {
        this.pedidoTesteCriticaService = pedidoTesteCriticaService;
        this.criticaQualidadeUtils = criticaQualidadeUtils;
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
    }
    CriticaModalIncluirTesteController.prototype.converterParametrosParaUrl = function (dadosFormulario) {
        return {
            criticaPk: this.config.criticaPk,
            dataFim: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataFim),
            dataInicio: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataInicio),
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(dadosFormulario.instituicao),
            protocolosRecebimento: dadosFormulario.protocolosRecebimento
        };
    };
    CriticaModalIncluirTesteController.prototype.validarDataInicio = function () {
        if (!this.pedidoTesteCritica.dataInicio
            || !this.pedidoTesteCritica.dataFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.pedidoTesteCritica.dataInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.pedidoTesteCritica.dataFim)) {
            return true;
        }
        if (!DateUtil.isMaiorQue(this.pedidoTesteCritica.dataFim, this.pedidoTesteCritica.dataInicio, true)) {
            this.fvExpressao.dataInicio = "A data-base início deve ser menor ou igual à data-base fim.";
            return false;
        }
        return true;
    };
    CriticaModalIncluirTesteController.prototype.validarDataFim = function () {
        if (!this.pedidoTesteCritica.dataInicio
            || !this.pedidoTesteCritica.dataFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.pedidoTesteCritica.dataInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.pedidoTesteCritica.dataFim)) {
            return true;
        }
        if (!DateUtil.isMaiorQue(this.pedidoTesteCritica.dataFim, this.pedidoTesteCritica.dataInicio, true)) {
            this.fvExpressao.dataFim = "A data-base fim deve ser maior ou igual à data-base início.";
            return false;
        }
        if (!DateUtil.isMenorQue(this.pedidoTesteCritica.dataFim, this.dataBaseAtual, true)) {
            this.fvExpressao.dataFim = "A data-base fim deve ser menor ou igual à data-base atual.";
            return false;
        }
        return true;
    };
    CriticaModalIncluirTesteController.prototype.voltar = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    CriticaModalIncluirTesteController.prototype.$onInit = function () {
        this.documentoMenorPeriodicidade = this.carregarDocumentos();
        if (this.documentoMenorPeriodicidade) {
            this.dataBaseAtual = new Date(this.documentoMenorPeriodicidade.dataBaseAtual);
        }
        else {
            this.dataBaseAtual = DateUtil.calcularDia(new Date(), -1);
        }
        this.pedidoTesteCritica = {
            codigoCritica: this.config.criticaCodigo,
            dataInicio: this.calcularDataInicio(this.documentoMenorPeriodicidade, this.dataBaseAtual),
            dataFim: this.calcularDataFinal(this.documentoMenorPeriodicidade, this.dataBaseAtual)
        };
        this.fvExpressao = {
            dataInicio: '',
            dataFim: ''
        };
    };
    CriticaModalIncluirTesteController.prototype.calcularDataInicio = function (documentoMenorPeriodicidade, dataBaseAtual) {
        var dataInicio = DateUtil.calcularAno(new Date(dataBaseAtual), -2);
        if (documentoMenorPeriodicidade !== undefined && documentoMenorPeriodicidade.menorPeriodicidade.codigo > 5) {
            return DateUtil.calcularMes(dataInicio, +1);
        }
        else {
            return DateUtil.calcularDia(dataInicio, +1);
        }
    };
    CriticaModalIncluirTesteController.prototype.calcularDataFinal = function (documentoMenorPeriodicidade, dataBaseAtual) {
        return new Date(dataBaseAtual);
    };
    CriticaModalIncluirTesteController.prototype.getMenorPeriodicidade = function (documentos) {
        var menorPeriodicidade = 999999999;
        var documentoMenor;
        _.forEach(documentos, function (documento) {
            if (!documento) {
                return;
            }
            var periodicidade;
            periodicidade = documento.menorTipoPeriodicidade;
            if (periodicidade.codigo < menorPeriodicidade) {
                menorPeriodicidade = periodicidade.codigo;
                documentoMenor = documento;
            }
        });
        return documentoMenor;
    };
    CriticaModalIncluirTesteController.prototype.carregarDocumentos = function () {
        if (!this.critica.sistemaNegocio) {
            return;
        }
        return this.getMenorPeriodicidade(this.critica.documentos);
    };
    CriticaModalIncluirTesteController.prototype.confirmar = function () {
        var _this = this;
        var pedidoTesteCriticaInclusaoDTO = this.converterParametrosParaUrl(this.pedidoTesteCritica);
        return this.pedidoTesteCriticaService.incluir(pedidoTesteCriticaInclusaoDTO).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso('Teste de crítica incluído com sucesso.');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    return CriticaModalIncluirTesteController;
}());
CriticaModalIncluirTesteController.$inject = ['PedidoTesteCriticaApiService', 'CriticaQualidadeUtils', '$uibModalInstance', 'feedbackService'];
angular.module('crd').controller('CriticaModalIncluirTesteController', CriticaModalIncluirTesteController);
//# sourceMappingURL=critica-modal-incluir-teste-controlle.js.map;
"use strict";
var CriticaQualidadeAutomaticaAlterarController = (function () {
    function CriticaQualidadeAutomaticaAlterarController($state, criticaQualidadeApiService, feedbackService, moment, $scope, criticaQualidadeUtils, documentoApiService, sistemaNegocioApiService, campoSituacaoMonitoradaApiService, abas, dmSistemaNegocio, dmDocumento, dmCampoMonitorado, dmBaseNormativas, listaDocDadosMonitorados, listaCamposDadosMonitorados) {
        if (abas === void 0) { abas = new AbasCritica(); }
        if (listaDocDadosMonitorados === void 0) { listaDocDadosMonitorados = Array(); }
        if (listaCamposDadosMonitorados === void 0) { listaCamposDadosMonitorados = Array(); }
        this.$state = $state;
        this.criticaQualidadeApiService = criticaQualidadeApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$scope = $scope;
        this.criticaQualidadeUtils = criticaQualidadeUtils;
        this.documentoApiService = documentoApiService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.abas = abas;
        this.dmSistemaNegocio = dmSistemaNegocio;
        this.dmDocumento = dmDocumento;
        this.dmCampoMonitorado = dmCampoMonitorado;
        this.dmBaseNormativas = dmBaseNormativas;
        this.listaDocDadosMonitorados = listaDocDadosMonitorados;
        this.listaCamposDadosMonitorados = listaCamposDadosMonitorados;
        this.codigoMask = '';
        this.abaDadosMonitorados = {
            sistemasNegocio: new Array(),
            documentos: new Array(),
            camposMonitorados: new Array()
        };
    }
    CriticaQualidadeAutomaticaAlterarController.prototype.salvar = function (crq, camposMonitoradosDaCritica) {
        var _this = this;
        var crqParaSalvar = this.converterParaEnviarServidor(crq, camposMonitoradosDaCritica);
        this.criticaQualidadeApiService.alterar(this.criticaQualidade.pk, crqParaSalvar).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Crítica de qualidade salva com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.showBaseNormativa = function () {
        if (!this.criticaQualidade.tipo) {
            return false;
        }
        return !(this.criticaQualidade.tipo.enumName === 'AVULSO'
            || this.criticaQualidade.tipo.enumName === 'DETERMINACAO_SUBSTITUICAO'
            || this.criticaQualidade.tipo.enumName === 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.validarIntervaloDatasBaseFim = function () {
        return !this.criticaQualidade.dataBaseInicio
            || !this.criticaQualidade.dataBaseFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseFim)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataBaseInicio, this.criticaQualidade.dataBaseFim, true);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.validarIntervaloDatasBaseInicio = function () {
        return this.novaDataBaseInicio === this.criticaQualidade.dataBaseInicio ||
            (!this.criticaQualidade.dataBaseFim
                || !this.criticaQualidade.dataBaseInicio
                || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseInicio)
                || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseFim)
                || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataBaseInicio, this.criticaQualidade.dataBaseFim, true));
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.onTipoAlterado = function () {
        if (this.criticaQualidade.tipo && (this.criticaQualidade.tipo.enumName === 'AVISO'
            || this.criticaQualidade.tipo.enumName === 'SINALIZACAO_SIM')) {
            this.criticaQualidade.gravidade = { nome: 'Sem gravidade', codigo: 'S', enumName: 'SEM_GRAVIDADE' };
            this.criticaQualidade.gravidadeAposToler = undefined;
            this.criticaQualidade.numeroDatasBaseTolerancia = undefined;
            this.criticaQualidade.tipoAposTolerancia = undefined;
        }
        else if (this.criticaQualidade.tipo && this.criticaQualidade.tipo.enumName === 'AVULSO') {
            this.criticaQualidade.dataAplicacaoAvulsaOuDeterminacaoSubstituicao = undefined;
            this.criticaQualidade.escopoCritica = undefined;
        }
        else if (this.criticaQualidade.tipo && (this.criticaQualidade.tipo.enumName === 'DETERMINACAO_SUBSTITUICAO'
            || this.criticaQualidade.tipo.enumName === 'QUESTIONAMENTO_AVULSO')) {
            this.criticaQualidade.formula = '1';
            this.criticaQualidade.escopoCritica = undefined;
            this.criticaQualidade.segmentos = undefined;
            this.criticaQualidade.dataBaseInicio = undefined;
            this.criticaQualidade.dataBaseFim = undefined;
            this.criticaQualidade.modeloIdentificador = undefined;
            this.criticaQualidade.dataVigenciaInicio = undefined;
            this.criticaQualidade.dataVigenciaFim = undefined;
            this.criticaQualidade.baseNormativasDaCritica = [];
        }
        else {
            this.criticaQualidade.gravidade = undefined;
        }
        this.resetCodigoCriticaSiglaDocumento(this.criticaQualidade.sistemaNegocio);
        this.criticaQualidade.protocolosRecebimento = undefined;
        this.criticaQualidade.documentos = [];
        this.criticaQualidade.dataVigenciaFim = undefined;
        this.criticaQualidade.dataVigenciaInicio = undefined;
        this.adaptarGravidades();
        this.ativarAba(this.abas.DADOS_GERAIS);
        this.visibilidadeAbaComparacaoDocumento(this.criticaQualidade);
        this.visibilidadeAbaDadosMonitorados(this.criticaQualidade);
        if (this.criticaQualidade.tipo) {
            var tipo = this.criticaQualidade.tipo.enumName;
            if (tipo === 'DETERMINACAO_SUBSTITUICAO' || tipo === 'QUESTIONAMENTO_AVULSO') {
                this.removerValidacaoCampoProtocoloRecebimento();
            }
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.houveAlteracaoDocumentoCodigoCriticaSigladocumento = function () {
        var documentosSelecionados = this.criticaQualidade.documentos;
        if (documentosSelecionados && documentosSelecionados.length > 0 && documentosSelecionados !== undefined) {
            return documentosSelecionados[0].codigo !== this.dadosFormulario.codigoCriticaQualidadeResource.codigoDocumento;
        }
        return false;
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.isDeterminacaoSubstituicao = function () {
        if (this.criticaQualidade === undefined || this.criticaQualidade.tipo === undefined) {
            return true;
        }
        return this.criticaQualidade.tipo.enumName === 'DETERMINACAO_SUBSTITUICAO'
            || this.criticaQualidade.tipo.enumName === 'QUESTIONAMENTO_AVULSO';
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.removerValidacaoCampoProtocoloRecebimento = function () {
        if (this.criticaQualidade.protocolosRecebimento == undefined || this.criticaQualidade.protocolosRecebimento.length < 1) {
            $("#in-protocolos-recebimento").removeClass("ng-invalid");
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.delBaseNormativa = function (base) {
        if (!this.criticaQualidade.baseNormativasDaCritica) {
            return;
        }
        for (var i = 0; i < this.criticaQualidade.baseNormativasDaCritica.length; i++) {
            if (base === this.criticaQualidade.baseNormativasDaCritica[i]) {
                this.criticaQualidade.baseNormativasDaCritica.splice(i, 1);
                this.criticaQualidadeUtils.validarFormulario(this.$scope.formAlterarCriticaQualidade, !this.$scope.formAlterarCriticaQualidade.$invalid);
            }
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.adaptarGravidades = function () {
        if (!this.criticaQualidade.tipo) {
            this.dadosFormulario.gravidades = this.dadosFormulario.gravidadesAutomatico;
            return;
        }
        var tipo = this.criticaQualidade.tipo.enumName;
        if (tipo === 'QUESTIONAMENTO_AVULSO') {
            this.dadosFormulario.gravidades = [
                { nome: 'Sem gravidade', codigo: 'S', enumName: 'SEM_GRAVIDADE' }
            ];
        }
        else if (tipo === 'AVULSO' || tipo === 'DETERMINACAO_SUBSTITUICAO') {
            this.dadosFormulario.gravidades = this.dadosFormulario.gravidadesAvulsoOuDetermincacao;
        }
        else {
            this.dadosFormulario.gravidades = this.dadosFormulario.gravidadesAutomatico;
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.ativarAba = function (aba) {
        this.abas.ativar(aba);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.visibilidadeAbaComparacaoDocumento = function (criticaQualidade) {
        var visibilidade = true;
        if (this.criticaQualidade.automatico !== undefined && !this.criticaQualidade.automatico) {
            visibilidade = false;
        }
        else if (this.criticaQualidade.tipo !== undefined && !this.criticaQualidade.tipo.possuiComparacaoDocumento) {
            visibilidade = false;
        }
        this.abas.COMPARACAO_DOCUMENTO.visibilidade(visibilidade);
        if (!visibilidade) {
            this.resetDocumentoComparado();
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.visibilidadeAbaDadosMonitorados = function (criticaQualidade) {
        var visibilidade = true;
        if (this.criticaQualidade.automatico !== undefined && !this.criticaQualidade.automatico) {
            visibilidade = false;
        }
        else if (this.criticaQualidade.tipo !== undefined && !this.criticaQualidade.tipo.possuiDadosMonitorados) {
            visibilidade = false;
        }
        else if (criticaQualidade.ehEntidadeSupervisionada) {
            visibilidade = false;
        }
        this.abas.DADOS_MONITORADOS.visibilidade(visibilidade);
        if (!visibilidade) {
            this.resetDadosMonitorados();
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.dmBaseNormativas = undefined;
        this.criticaQualidade = {
            pk: 0,
            automatico: true,
            reprocessar: false,
            documentosAcionadores: [],
            baseNormativasDaCritica: [],
            abas: {
                podeVerComparacaoDocumentos: false,
                podeVerDadosMonitorados: false,
                podeVerDadosGerais: false
            },
            unicad: false
        };
        return this.criticaQualidadeApiService.montarTelaAlterar(pk, true).then(function (resource) {
            _this.dadosFormulario = resource;
            _this.criticaQualidade = resource.criticaQualidade;
            if (!_this.criticaQualidade.automatico) {
                _this.$state.go("status-404");
            }
            if (_this.criticaQualidade.codigoCriticaSiglaDocumento) {
                _this.construirCodigoCriticaSiglaDocumento(resource.codigoCriticaQualidadeResource);
                _this.marcadorSiglaDocumento = true;
            }
            else {
                _this.carregarCodigoCriticaSiglaSistemaNegocio(resource.codigoCriticaQualidadeResource);
                _this.marcadorSiglaDocumento = false;
            }
            _this.criticaQualidade.dataBaseInicio = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataBaseInicio);
            _this.criticaQualidade.dataBaseFim = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataBaseFim);
            _this.criticaQualidade.dataVigenciaInicio = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataVigenciaInicio);
            _this.criticaQualidade.dataVigenciaFim = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataVigenciaFim);
            _this.criticaQualidade.dataAplicacaoAvulsaOuDeterminacaoSubstituicao =
                _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataAplicacaoAvulsaOuDeterminacaoSubstituicao);
            _this.criticaQualidade.sistemaNegocioComparado = resource.criticaQualidade.documentoComparado ?
                resource.criticaQualidade.documentoComparado.sistemaNegocio : undefined;
            _this.criticaQualidade.documentoComparado = resource.criticaQualidade.documentoComparado;
            _this.criticaQualidade.reprocessar = resource.criticaQualidade.reprocessarDataBasePosterior;
            _this.novaDataBaseFim = _this.criticaQualidade.dataBaseFim;
            _this.novaDataBaseInicio = _this.criticaQualidade.dataBaseInicio;
            _this.novaDataVigenciaInicio = _this.criticaQualidade.dataVigenciaInicio;
            _this.carregarSistemasNegocioParaComparado();
            _this.carregarDocumentosParaComparado();
            _this.abas.DADOS_GERAIS.visibilidade(_this.criticaQualidade.abas.podeVerDadosGerais);
            _this.abas.COMPARACAO_DOCUMENTO.visibilidade(_this.criticaQualidade.abas.podeVerComparacaoDocumentos);
            _this.abas.DADOS_MONITORADOS.visibilidade(_this.criticaQualidade.abas.podeVerDadosMonitorados);
            _this.ativarAba(_this.abas.DADOS_GERAIS);
            _this.adaptarGravidades();
            _this.camposMonitoradosDaCritica = resource.criticaQualidade.camposMonitorados;
            _this.criticaQualidade.camposMonitorados = undefined;
            _this.criticaQualidade.baseNormativasDaCritica = resource.baseNormativasDaCritica;
            if (_this.dadosFormulario.alertaExclusao) {
                _this.feedbackService.alerta(_this.dadosFormulario.alertaExclusao);
            }
        });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.eventoCheck = function (sistemaNegocio) {
        var _this = this;
        if (this.isCodigoSiglaDocumentoSelecionado()) {
            this.marcadorSiglaDocumento = true;
            if (this.criticaQualidade.codigoCriticaSiglaDocumento && !this.houveAlteracaoDocumentoCodigoCriticaSigladocumento()) {
                this.construirCodigoCriticaSiglaDocumento(this.dadosFormulario.codigoCriticaQualidadeResource);
            }
            else {
                var codigoDocumento = this.criticaQualidade.documentos[0].codigo;
                this.criticaQualidadeApiService.obterCodigoSiglaDocumento(codigoDocumento)
                    .then(function (resource) {
                    var codigoCriticaQualidadeResource = resource.data;
                    if (codigoCriticaQualidadeResource) {
                        _this.construirCodigoCriticaSiglaDocumento(codigoCriticaQualidadeResource);
                    }
                    return;
                });
            }
        }
        else {
            this.marcadorSiglaDocumento = false;
            if (this.criticaQualidade.codigoCriticaSiglaDocumento) {
                this.construirCodigoCriticaSiglaSistemaNegocio(sistemaNegocio);
            }
            else {
                this.carregarCodigoCriticaSiglaSistemaNegocio(this.dadosFormulario.codigos[0]);
            }
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.isCodigoSiglaDocumentoSelecionado = function () {
        return document.getElementById("inSiglaDocumentoAlterar").checked;
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.construirCodigoCriticaSiglaDocumento = function (codigoCriticaQualidadeResource) {
        this.criticaQualidade.codigo = CodigoCriticaQualidade.formatarCodigoSiglaDocumentoTela(codigoCriticaQualidadeResource);
        this.criticaQualidade.siglaCodigo = codigoCriticaQualidadeResource.siglaDocumento;
        this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.carregarCodigoCriticaSiglaSistemaNegocio = function (codigoCriticaQualidadeResource) {
        this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(this.criticaQualidade.sistemaNegocio, codigoCriticaQualidadeResource.codigo);
        this.criticaQualidade.siglaCodigo = codigoCriticaQualidadeResource.siglaSistemaNegocio;
        this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.construirCodigoCriticaSiglaSistemaNegocio = function (sistemaNegocio) {
        if (sistemaNegocio) {
            var codigoCriticaQualidadeResource = _.find(this.dadosFormulario.codigos, function (e) { return e.sistemaNegocioPk === sistemaNegocio.pk; });
            if (codigoCriticaQualidadeResource) {
                this.criticaQualidade.siglaCodigo = sistemaNegocio.sigla;
                this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(sistemaNegocio, codigoCriticaQualidadeResource.codigo);
                this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
            }
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.isChecked = function () {
        return this.criticaQualidade.codigoCriticaSiglaDocumento;
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.deveDesabilitarCheckboxSiglaDocumento = function () {
        if (this.criticaQualidade.documentos === undefined) {
            return true;
        }
        return this.criticaQualidade.documentos.length === 1
            && this.criticaQualidade.documentos[0] !== undefined ? false : true;
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.observerChangeItemDocumento = function (sistemaNegocio, tipo) {
        var somenteUmDocumentoSelecionado = this.criticaQualidade.documentos.length === 1 ? true : false;
        var tipoAvisoOuDeterminacaoSubstituicaoOuQuestionamentoAvulso = tipo === 'AVISO' || tipo === 'DETERMINACAO_SUBSTITUICAO' || tipo === 'QUESTIONAMENTO_AVULSO';
        if (!somenteUmDocumentoSelecionado || tipoAvisoOuDeterminacaoSubstituicaoOuQuestionamentoAvulso) {
            this.resetCodigoCriticaSiglaDocumento(sistemaNegocio);
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.resetCodigoCriticaSiglaDocumento = function (sistemaNegocio) {
        document.getElementById("inSiglaDocumentoAlterar").checked = false;
        this.marcadorSiglaDocumento = false;
        this.construirCodigoCriticaSiglaSistemaNegocio(this.criticaQualidade.sistemaNegocio);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.addBaseNormativa = function (camposBase) {
        console.log("AQUIII >>>>>>>");
        if (camposBase) {
            var adiciona_1;
            adiciona_1 = true;
            if (this.criticaQualidade.baseNormativasDaCritica) {
                this.criticaQualidade.baseNormativasDaCritica.forEach(function (item) {
                    var basekey = ConverterParameterObjectToUrlUtils.atributoEnumName(item.tipo);
                    var campokey = ConverterParameterObjectToUrlUtils.atributoEnumName(camposBase.tipo);
                    var numeroconi = camposBase.numero;
                    var numeroconb = JSON.stringify(item.numero).replace('"', '"');
                    if ((numeroconi === numeroconb) && (basekey === campokey)) {
                        adiciona_1 = false;
                    }
                    if ((camposBase.numero === item.numero) && (basekey === campokey)) {
                        adiciona_1 = false;
                    }
                });
                if (adiciona_1) {
                    this.addBaseDiferente(camposBase);
                }
            }
            this.dmBaseNormativas = undefined;
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.addBaseDiferente = function (base) {
        if (this.criticaQualidade.baseNormativasDaCritica) {
            this.criticaQualidade.baseNormativasDaCritica.push(base);
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.addDocumentoAcionador = function (documento) {
        if (!this.criticaQualidade.documentosAcionadores) {
            return;
        }
        this.criticaQualidade.sistemaNegocioComparado = undefined;
        this.criticaQualidade.documentoComparado = undefined;
        this.dadosFormulario.documentosParaComparado = [];
        for (var i = 0; i < this.criticaQualidade.documentosAcionadores.length; i++) {
            if (this.criticaQualidade.documentosAcionadores[i].pk === documento.pk) {
                return;
            }
        }
        this.criticaQualidade.documentosAcionadores.push(documento);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.delDocumentoAcionador = function (documento) {
        this.$scope.formAlterarCriticaQualidade.$setDirty();
        if (!this.criticaQualidade.documentosAcionadores) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.documentosAcionadores.length; i++) {
            var documentoAcionador = this.criticaQualidade.documentosAcionadores[i];
            if (documentoAcionador.pk === documento.pk) {
                posicao = i;
                break;
            }
        }
        this.criticaQualidade.documentosAcionadores.splice(posicao, 1);
        this.criticaQualidade.sistemaNegocioComparado = undefined;
        this.criticaQualidade.documentoComparado = undefined;
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.addCampoMonitorado = function (campoMonitorado) {
        this.dmCampoMonitorado = undefined;
        if (this.camposMonitoradosDaCritica) {
            for (var i = 0; i < this.camposMonitoradosDaCritica.length; i++) {
                if (this.camposMonitoradosDaCritica[i].pk === campoMonitorado.pk) {
                    return;
                }
            }
            this.camposMonitoradosDaCritica.push(campoMonitorado);
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.removerDadoMonitoradoPorCampo = function (campo) {
        this.$scope.formAlterarCriticaQualidade.$setDirty();
        if (this.camposMonitoradosDaCritica) {
            this.camposMonitoradosDaCritica = _.filter(this.camposMonitoradosDaCritica, function (cm) {
                return cm.pk != campo.pk;
            });
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.removerDadoMonitoradoPorDocumento = function (documento) {
        this.$scope.formAlterarCriticaQualidade.$setDirty();
        if (!this.camposMonitoradosDaCritica) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.camposMonitoradosDaCritica.length;) {
            var campoMonitorado = this.camposMonitoradosDaCritica[i];
            if (campoMonitorado.documento) {
                if (campoMonitorado.documento.pk === documento.pk) {
                    posicao = i;
                    this.camposMonitoradosDaCritica.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.removerDadoMonitoradoPorSistema = function (sistema) {
        this.$scope.formAlterarCriticaQualidade.$setDirty();
        if (!this.camposMonitoradosDaCritica) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.camposMonitoradosDaCritica.length;) {
            var campoMonitorado = this.camposMonitoradosDaCritica[i];
            if (!campoMonitorado.documento) {
                return;
            }
            if (campoMonitorado.documento.sistemaNegocio) {
                if (campoMonitorado.documento.sistemaNegocio.pk === sistema.pk) {
                    posicao = i;
                    this.camposMonitoradosDaCritica.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.carregarSistemasNegocioParaComparado = function () {
        var _this = this;
        this.sistemaNegocioApiService.obterComDocsAtivosPeriodicidadeDiferenteMenorDiaria()
            .then(function (resource) {
            _this.dadosFormulario.sistemasNegocioParaComparado = resource.data._embedded.resultado;
            return resource;
        });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.observerChangeSistemaNegocioParaComparado = function () {
        this.criticaQualidade.documentoComparado = undefined;
        this.carregarDocumentosParaComparado();
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.carregarDadosMonitorados = function () {
        this.dmSistemaNegocio = undefined;
        this.dmDocumento = undefined;
        this.dmCampoMonitorado = undefined;
        this.montarlistaSistemaNegocioDadoComparado();
        this.montarlistaDocumentoDadoComparado();
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.montarlistaDocumentoDadoComparado = function () {
        var docsDadosGerais = !_.isEmpty(this.criticaQualidade.documentos)
            ? this.criticaQualidade.documentos
            : this.dadosFormulario.documentos;
        var docAcionadores = this.criticaQualidade.documentosAcionadores
            ? this.criticaQualidade.documentosAcionadores
            : new Array();
        var documentos = ArrayUtils.joinDistinct('pk', docsDadosGerais, docAcionadores);
        this.abaDadosMonitorados.documentos = documentos.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(lhs.codigo, rhs.codigo)
            .build(); });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.observerChangeSNDadosMonitorados = function (sistemaNegocio) {
        var _this = this;
        this.listaDocDadosMonitorados = [];
        this.abaDadosMonitorados.documentos.forEach(function (doc) {
            if (!doc.sistemaNegocio) {
                return;
            }
            if (doc.sistemaNegocio.pk === sistemaNegocio.pk) {
                _this.listaDocDadosMonitorados.push(doc);
            }
        });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.observerChangeDocDadosMonitorados = function (doc) {
        var _this = this;
        this.listaCamposDadosMonitorados = [];
        var parameters = {
            documentos: [doc.pk]
        };
        this.campoSituacaoMonitoradaApiService.pesquisarAtivos(parameters)
            .then(function (response) { return _this.listaCamposDadosMonitorados = response; })["catch"](function (error) { return _this.feedbackService.error("Erro ao buscar os campos monitorados."); });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.montarlistaSistemaNegocioDadoComparado = function () {
        var sisAcionadores = this.criticaQualidade.documentosAcionadores
            ? _.map(this.criticaQualidade.documentosAcionadores, function (item) { return item.sistemaNegocio; })
            : new Array();
        var sistemaNegocios = ArrayUtils.joinDistinct('pk', new Array(this.criticaQualidade.sistemaNegocio), sisAcionadores);
        this.abaDadosMonitorados.sistemasNegocio = sistemaNegocios.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(lhs.sigla, rhs.sigla)
            .build(); });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.resetDadosMonitorados = function () {
        this.criticaQualidade.observacaoDadosMonitorados = undefined;
        this.camposMonitoradosDaCritica = [];
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.resetDocumentoComparado = function () {
        this.criticaQualidade.sistemaNegocioComparado = undefined;
        this.criticaQualidade.documentoComparado = undefined;
        this.dadosFormulario.documentosParaComparado = [];
        this.criticaQualidade.documentosAcionadores = [];
        this.criticaQualidade.tipoEncaminhamento = { enumName: "PROPRIA_ENTIDADE_SUPERVISIONADA" };
        this.criticaQualidade.reprocessar = false;
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.carregarDocumentosParaComparado = function () {
        var _this = this;
        if (!this.criticaQualidade.sistemaNegocioComparado) {
            return;
        }
        var periodicidade = 'EVENTUAL_DIARIA';
        this.documentoApiService.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(this.criticaQualidade.sistemaNegocioComparado.pk, periodicidade)
            .then(function (resource) {
            _this.dadosFormulario.documentosParaComparado = resource._embedded.resultado;
            return resource;
        });
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.$onInit = function () {
        var _this = this;
        return this.carregarDadosTela(this.$state.params.pk).then(function (callback) {
            _this.criticaQualidadeUtils.validarFormulario(_this.$scope.formAlterarCriticaQualidade, false);
            var teste = document.getElementById("teste");
        });
    };
    ;
    CriticaQualidadeAutomaticaAlterarController.prototype.converterParaEnviarServidor = function (crq, camposMonitoradosDaCritica) {
        var documentos;
        var protocolos;
        if (Array.isArray(crq.documentos)) {
            documentos = crq.documentos;
        }
        else {
            documentos = [crq.documentos];
        }
        if (Array.isArray(crq.protocolosRecebimento)) {
            protocolos = crq.protocolosRecebimento;
        }
        else {
            protocolos = [crq.protocolosRecebimento];
        }
        var codigoSiglaDocumentoSelecionado = this.isCodigoSiglaDocumentoSelecionado();
        var codigo = ConverterParameterObjectToUrlUtils.string(this.getCodigoCritica(codigoSiglaDocumentoSelecionado, crq));
        return {
            automatico: true,
            codigo: codigo,
            codigoSiglaDocumento: codigoSiglaDocumentoSelecionado,
            reprocessar: crq.reprocessar,
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(documentos),
            documentosAcionadores: ConverterParameterObjectToUrlUtils.atributoPKArray(crq.documentosAcionadores),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(crq.segmentos),
            gravidade: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.gravidade),
            gravidadeAposToler: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.gravidadeAposToler),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(crq.sistemaNegocio),
            descricao: ConverterParameterObjectToUrlUtils.string(crq.descricao),
            formula: ConverterParameterObjectToUrlUtils.string(crq.formula),
            disponibilidadeProcessamento: ConverterParameterObjectToUrlUtils.string(crq.disponibilidadeProcessamento),
            modeloMsg: ConverterParameterObjectToUrlUtils.string(crq.modeloMensagem),
            tipo: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipo),
            tipoEncaminhamento: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipoEncaminhamento),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(crq.dataBaseInicio),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(crq.dataBaseFim),
            dataVigenciaInicio: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaInicio),
            dataVigenciaFim: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaFim),
            dataAplicacaoAvulsaOuDeterminacaoSubstituicao: ConverterParameterObjectToUrlUtils.date(crq.dataAplicacaoAvulsaOuDeterminacaoSubstituicao),
            modeloIdentificador: ConverterParameterObjectToUrlUtils.string(crq.modeloIdentificador),
            observacao: ConverterParameterObjectToUrlUtils.string(crq.observacao),
            escopoCritica: ConverterParameterObjectToUrlUtils.string(crq.escopoCritica),
            datasBaseToler: ConverterParameterObjectToUrlUtils.number(crq.numeroDatasBaseTolerancia),
            tipoAposToler: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipoAposTolerancia),
            protocolosRecebimento: crq.protocolosRecebimento,
            observacaoDadosMonitorados: ConverterParameterObjectToUrlUtils.string(crq.observacaoDadosMonitorados),
            baseNormativasDaCritica: this.converterParaEnviarServidorBaseNormativa(crq),
            camposMonitorados: ConverterParameterObjectToUrlUtils.atributoPKArray(camposMonitoradosDaCritica)
        };
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.getCodigoCritica = function (codigoCriticaTipoSiglaDocumento, crq) {
        if (codigoCriticaTipoSiglaDocumento) {
            return CodigoCriticaQualidade.formatarCodigoSiglaDocumentoServidor(crq.siglaCodigo, crq.codigo);
        }
        return CodigoCriticaQualidade.costruir(crq.sistemaNegocio, crq.codigo);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.converterParaEnviarServidorBaseNormativa = function (crq) {
        if (!this.showBaseNormativa()) {
            return [];
        }
        return ConverterParameterObjectToUrlUtils.atributoEnumNameNumero(crq.baseNormativasDaCritica);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.validarDataVigenciaFim = function () {
        var dataOk = !this.criticaQualidade.dataVigenciaFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaFim)
            || !this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataVigenciaFim, new Date(), false);
        if (dataOk) {
            return !this.criticaQualidade.dataVigenciaInicio
                || !this.criticaQualidade.dataVigenciaFim
                || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
                || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaFim)
                || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataVigenciaInicio, this.criticaQualidade.dataVigenciaFim, true);
        }
        else {
            return false;
        }
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.isDataBaseFimRequerida = function () {
        return this.novaDataBaseFim !== this.criticaQualidade.dataBaseFim;
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.isDataBaseFimDesabilitada = function () {
        return this.criticaQualidade.dataBaseFim &&
            this.criticaQualidadeUtils.isFimMaiorQueInicio(this.novaDataBaseFim, new Date(), false);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.validarDataVigenciaInicio = function () {
        if (!this.dadosFormulario || !this.criticaQualidade) {
            return true;
        }
        if (this.novaDataVigenciaInicio === this.criticaQualidade.dataVigenciaInicio) {
            return true;
        }
        return !this.criticaQualidade.dataVigenciaInicio
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(new Date(), this.criticaQualidade.dataVigenciaInicio, false);
    };
    CriticaQualidadeAutomaticaAlterarController.prototype.voltar = function () {
        this.$state.go('critica-qualidade-pesquisa');
    };
    return CriticaQualidadeAutomaticaAlterarController;
}());
CriticaQualidadeAutomaticaAlterarController.$inject = ['$state', 'CriticaQualidadeApiService', 'feedbackService', 'moment', '$scope', 'CriticaQualidadeUtils', 'documentoApiService', 'sistemaNegocioApiService', 'CampoSituacaoMonitoradaApiService'];
angular.module('crd').controller('CriticaQualidadeAutomaticaAlterarController', CriticaQualidadeAutomaticaAlterarController);
//# sourceMappingURL=critica-qualidade-automatica-alterar-controller.js.map;
"use strict";
var CriticaQualidadeManualAlterarController = (function () {
    function CriticaQualidadeManualAlterarController($state, criticaQualidadeApiService, feedbackService, moment, $scope, criticaQualidadeUtils, documentoApiService, sistemaNegocioApiService, campoSituacaoMonitoradaApiService, abas, dmSistemaNegocio, dmDocumento, dmCampoMonitorado, dmBaseNormativas, listaDocDadosMonitorados, listaCamposDadosMonitorados) {
        if (abas === void 0) { abas = new AbasCriticaManual(); }
        if (listaDocDadosMonitorados === void 0) { listaDocDadosMonitorados = Array(); }
        if (listaCamposDadosMonitorados === void 0) { listaCamposDadosMonitorados = Array(); }
        this.$state = $state;
        this.criticaQualidadeApiService = criticaQualidadeApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$scope = $scope;
        this.criticaQualidadeUtils = criticaQualidadeUtils;
        this.documentoApiService = documentoApiService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.abas = abas;
        this.dmSistemaNegocio = dmSistemaNegocio;
        this.dmDocumento = dmDocumento;
        this.dmCampoMonitorado = dmCampoMonitorado;
        this.dmBaseNormativas = dmBaseNormativas;
        this.listaDocDadosMonitorados = listaDocDadosMonitorados;
        this.listaCamposDadosMonitorados = listaCamposDadosMonitorados;
        this.codigoMask = '';
        this.abaDadosMonitorados = {
            sistemasNegocio: new Array(),
            documentos: new Array(),
            camposMonitorados: new Array()
        };
    }
    CriticaQualidadeManualAlterarController.prototype.salvar = function (crq, camposMonitoradosDaCritica) {
        var _this = this;
        var crqParaSalvar = this.converterParaEnviarServidor(crq, camposMonitoradosDaCritica);
        this.criticaQualidadeApiService.alterar(this.criticaQualidade.pk, crqParaSalvar).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Crítica de qualidade salva com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    CriticaQualidadeManualAlterarController.prototype.validarIntervaloDatasBaseFim = function () {
        return !this.criticaQualidade.dataBaseInicio
            || !this.criticaQualidade.dataBaseFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseFim)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataBaseInicio, this.criticaQualidade.dataBaseFim, true);
    };
    CriticaQualidadeManualAlterarController.prototype.validarIntervaloDatasBaseInicio = function () {
        return this.novaDataBaseInicio === this.criticaQualidade.dataBaseInicio ||
            (!this.criticaQualidade.dataBaseFim
                || !this.criticaQualidade.dataBaseInicio
                || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseInicio)
                || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseFim)
                || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataBaseInicio, this.criticaQualidade.dataBaseFim, true));
    };
    CriticaQualidadeManualAlterarController.prototype.onTipoAlterado = function () {
        this.ativarAba(this.abas.DADOS_GERAIS);
        this.visibilidadeAbaDadosMonitorados(this.criticaQualidade);
        if (this.criticaQualidade.tipo) {
            var tipo = this.criticaQualidade.tipo.enumName;
            if (tipo === 'DETERMINACAO_SUBSTITUICAO') {
                this.criticaQualidade.baseNormativasDaCritica = [];
            }
        }
    };
    CriticaQualidadeManualAlterarController.prototype.ativarAba = function (aba) {
        this.abas.ativar(aba);
    };
    CriticaQualidadeManualAlterarController.prototype.visibilidadeAbaDadosMonitorados = function (criticaQualidade) {
        var visibilidade = true;
        this.abas.DADOS_MONITORADOS.visibilidade(visibilidade);
    };
    CriticaQualidadeManualAlterarController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.criticaQualidade = {
            pk: 0,
            automatico: false,
            baseNormativasDaCritica: [],
            abas: {
                podeVerComparacaoDocumentos: false,
                podeVerDadosMonitorados: false,
                podeVerDadosGerais: false
            },
            unicad: false
        };
        return this.criticaQualidadeApiService.montarTelaAlterar(pk, false).then(function (resource) {
            _this.dadosFormulario = resource;
            _this.criticaQualidade = resource.criticaQualidade;
            if (_this.criticaQualidade.automatico) {
                _this.$state.go("status-404");
            }
            if (_this.criticaQualidade.codigoCriticaSiglaDocumento) {
                _this.construirCodigoCriticaSiglaDocumento(resource.codigoCriticaQualidadeResource);
                _this.marcadorSiglaDocumento = true;
            }
            else {
                _this.carregarCodigoCriticaSiglaSistemaNegocio(resource.codigoCriticaQualidadeResource);
                _this.marcadorSiglaDocumento = false;
            }
            _this.criticaQualidade.dataBaseInicio = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataBaseInicio);
            _this.criticaQualidade.dataBaseFim = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataBaseFim);
            _this.criticaQualidade.dataVigenciaInicio = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataVigenciaInicio);
            _this.criticaQualidade.dataVigenciaFim = _this.criticaQualidadeUtils.formatarData(_this.criticaQualidade.dataVigenciaFim);
            _this.novaDataBaseFim = _this.criticaQualidade.dataBaseFim;
            _this.novaDataBaseInicio = _this.criticaQualidade.dataBaseInicio;
            _this.novaDataVigenciaInicio = _this.criticaQualidade.dataVigenciaInicio;
            _this.abas.DADOS_GERAIS.visibilidade(_this.criticaQualidade.abas.podeVerDadosGerais);
            _this.abas.DADOS_MONITORADOS.visibilidade(_this.criticaQualidade.abas.podeVerDadosMonitorados);
            _this.ativarAba(_this.abas.DADOS_GERAIS);
            _this.camposMonitoradosDaCritica = resource.criticaQualidade.camposMonitorados;
            _this.criticaQualidade.camposMonitorados = undefined;
            _this.criticaQualidade.baseNormativasDaCritica = resource.baseNormativasDaCritica;
            if (_this.dadosFormulario.alertaExclusao) {
                _this.feedbackService.alerta(_this.dadosFormulario.alertaExclusao);
            }
            _this.codigoMask = CodigoCriticaQualidade.gerarMascara(_this.criticaQualidade.codigo);
            _this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(_this.criticaQualidade.sistemaNegocio, _this.criticaQualidade.codigo);
        });
    };
    CriticaQualidadeManualAlterarController.prototype.deveDesabilitarCheckboxSiglaDocumento = function () {
        if (this.criticaQualidade.documentos === undefined) {
            return true;
        }
        return this.criticaQualidade.documentos.length === 1
            && this.criticaQualidade.documentos[0] !== undefined ? false : true;
    };
    CriticaQualidadeManualAlterarController.prototype.isCodigoSiglaDocumentoSelecionado = function () {
        return document.getElementById("inSiglaDocumentoAlterarManual").checked;
    };
    CriticaQualidadeManualAlterarController.prototype.isChecked = function () {
        return this.criticaQualidade.codigoCriticaSiglaDocumento;
    };
    CriticaQualidadeManualAlterarController.prototype.eventoCheck = function () {
        var _this = this;
        if (this.isCodigoSiglaDocumentoSelecionado()) {
            this.marcadorSiglaDocumento = true;
            if (this.criticaQualidade.codigoCriticaSiglaDocumento) {
                this.construirCodigoCriticaSiglaDocumento(this.dadosFormulario.codigoCriticaQualidadeResource);
            }
            else {
                var codigoDocumento = this.criticaQualidade.documentos[0].codigo;
                this.criticaQualidadeApiService.obterCodigoSiglaDocumento(codigoDocumento)
                    .then(function (resource) {
                    var codigoCriticaQualidadeResource = resource.data;
                    if (codigoCriticaQualidadeResource) {
                        _this.construirCodigoCriticaSiglaDocumento(codigoCriticaQualidadeResource);
                    }
                    return;
                });
            }
        }
        else {
            this.marcadorSiglaDocumento = false;
            if (this.criticaQualidade.codigoCriticaSiglaDocumento) {
                this.construirCodigoCriticaSiglaSistemaNegocio(this.criticaQualidade.sistemaNegocio);
            }
            else {
                this.carregarCodigoCriticaSiglaSistemaNegocio(this.dadosFormulario.codigos[0]);
            }
        }
    };
    CriticaQualidadeManualAlterarController.prototype.construirCodigoCriticaSiglaSistemaNegocio = function (sistemaNegocio) {
        if (sistemaNegocio) {
            var codigoCriticaQualidadeResource = _.find(this.dadosFormulario.codigos, function (e) { return e.sistemaNegocioPk === sistemaNegocio.pk; });
            if (codigoCriticaQualidadeResource) {
                this.criticaQualidade.siglaCodigo = sistemaNegocio.sigla;
                this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(sistemaNegocio, codigoCriticaQualidadeResource.codigo);
                this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
            }
        }
    };
    CriticaQualidadeManualAlterarController.prototype.construirCodigoCriticaSiglaDocumento = function (codigoCriticaQualidadeResource) {
        this.criticaQualidade.codigo = CodigoCriticaQualidade.formatarCodigoSiglaDocumentoTela(codigoCriticaQualidadeResource);
        this.criticaQualidade.siglaCodigo = codigoCriticaQualidadeResource.siglaDocumento;
        this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
    };
    CriticaQualidadeManualAlterarController.prototype.carregarCodigoCriticaSiglaSistemaNegocio = function (codigoCriticaQualidadeResource) {
        this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(this.criticaQualidade.sistemaNegocio, codigoCriticaQualidadeResource.codigo);
        this.criticaQualidade.siglaCodigo = codigoCriticaQualidadeResource.siglaSistemaNegocio;
        this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
    };
    CriticaQualidadeManualAlterarController.prototype.addBaseNormativa = function (camposBase) {
        if (camposBase) {
            var adiciona_1;
            adiciona_1 = true;
            if (this.criticaQualidade.baseNormativasDaCritica) {
                this.criticaQualidade.baseNormativasDaCritica.forEach(function (item) {
                    var basekey = ConverterParameterObjectToUrlUtils.atributoEnumName(item.tipo);
                    var campokey = ConverterParameterObjectToUrlUtils.atributoEnumName(camposBase.tipo);
                    var numeroconi = camposBase.numero;
                    var numeroconb = JSON.stringify(item.numero).replace('"', '"');
                    if ((numeroconi === numeroconb) && (basekey === campokey)) {
                        adiciona_1 = false;
                    }
                    if ((camposBase.numero === item.numero) && (basekey === campokey)) {
                        adiciona_1 = false;
                    }
                });
                if (adiciona_1) {
                    this.addBaseDiferente(camposBase);
                }
            }
            this.dmBaseNormativas = undefined;
        }
    };
    CriticaQualidadeManualAlterarController.prototype.addBaseDiferente = function (base) {
        if (this.criticaQualidade.baseNormativasDaCritica) {
            this.criticaQualidade.baseNormativasDaCritica.push(base);
        }
    };
    CriticaQualidadeManualAlterarController.prototype.addCampoMonitorado = function (campoMonitorado) {
        this.dmCampoMonitorado = undefined;
        if (this.camposMonitoradosDaCritica) {
            for (var i = 0; i < this.camposMonitoradosDaCritica.length; i++) {
                if (this.camposMonitoradosDaCritica[i].pk === campoMonitorado.pk) {
                    return;
                }
            }
            this.camposMonitoradosDaCritica.push(campoMonitorado);
        }
    };
    CriticaQualidadeManualAlterarController.prototype.removerDadoMonitoradoPorCampo = function (campo) {
        this.$scope.formAlterarCriticaQualidade.$setDirty();
        if (this.camposMonitoradosDaCritica) {
            this.camposMonitoradosDaCritica = _.filter(this.camposMonitoradosDaCritica, function (cm) {
                return cm.pk != campo.pk;
            });
        }
    };
    CriticaQualidadeManualAlterarController.prototype.removerDadoMonitoradoPorDocumento = function (documento) {
        this.$scope.formAlterarCriticaQualidade.$setDirty();
        if (!this.camposMonitoradosDaCritica) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.camposMonitoradosDaCritica.length;) {
            var campoMonitorado = this.camposMonitoradosDaCritica[i];
            if (campoMonitorado.documento) {
                if (campoMonitorado.documento.pk === documento.pk) {
                    posicao = i;
                    this.camposMonitoradosDaCritica.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeManualAlterarController.prototype.removerDadoMonitoradoPorSistema = function (sistema) {
        this.$scope.formAlterarCriticaQualidade.$setDirty();
        if (!this.camposMonitoradosDaCritica) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.camposMonitoradosDaCritica.length;) {
            var campoMonitorado = this.camposMonitoradosDaCritica[i];
            if (!campoMonitorado.documento) {
                return;
            }
            if (campoMonitorado.documento.sistemaNegocio) {
                if (campoMonitorado.documento.sistemaNegocio.pk === sistema.pk) {
                    posicao = i;
                    this.camposMonitoradosDaCritica.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeManualAlterarController.prototype.carregarDadosMonitorados = function () {
        this.dmSistemaNegocio = undefined;
        this.dmDocumento = undefined;
        this.dmCampoMonitorado = undefined;
        this.montarlistaSistemaNegocioDadoComparado();
        this.montarlistaDocumentoDadoComparado();
    };
    CriticaQualidadeManualAlterarController.prototype.observerChangeSNDadosMonitorados = function (sistemaNegocio) {
        var _this = this;
        var periodicidade = 'EVENTUAL_MENOR_QUE_DIARIA';
        this.documentoApiService.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(sistemaNegocio.pk, periodicidade)
            .then(function (resource) {
            _this.listaDocDadosMonitorados = resource._embedded.resultado;
            return resource;
        });
    };
    CriticaQualidadeManualAlterarController.prototype.observerChangeDocDadosMonitorados = function (doc) {
        var _this = this;
        this.listaCamposDadosMonitorados = [];
        var parameters = {
            documentos: [doc.pk]
        };
        this.campoSituacaoMonitoradaApiService.pesquisarAtivos(parameters)
            .then(function (response) { return _this.listaCamposDadosMonitorados = response; })["catch"](function (error) { return _this.feedbackService.error("Erro ao buscar os campos monitorados."); });
    };
    CriticaQualidadeManualAlterarController.prototype.montarlistaSistemaNegocioDadoComparado = function () {
        if (this.dadosFormulario.sistemasNegocioMonitorados) {
            this.abaDadosMonitorados.sistemasNegocio = this.dadosFormulario.sistemasNegocioMonitorados;
        }
    };
    CriticaQualidadeManualAlterarController.prototype.montarlistaDocumentoDadoComparado = function () {
        var docsDadosGerais = !_.isEmpty(this.criticaQualidade.documentos)
            ? this.criticaQualidade.documentos
            : this.dadosFormulario.documentos;
        this.abaDadosMonitorados.documentos = docsDadosGerais.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(lhs.codigo, rhs.codigo)
            .build(); });
    };
    CriticaQualidadeManualAlterarController.prototype.$onInit = function () {
        var _this = this;
        return this.carregarDadosTela(this.$state.params.pk).then(function (callback) {
            _this.criticaQualidadeUtils.validarFormulario(_this.$scope.formAlterarCriticaQualidade, false);
        });
    };
    ;
    CriticaQualidadeManualAlterarController.prototype.delBaseNormativa = function (base) {
        if (!this.criticaQualidade.baseNormativasDaCritica) {
            return;
        }
        for (var i = 0; i < this.criticaQualidade.baseNormativasDaCritica.length; i++) {
            if (base === this.criticaQualidade.baseNormativasDaCritica[i]) {
                this.criticaQualidade.baseNormativasDaCritica.splice(i, 1);
                this.criticaQualidadeUtils.validarFormulario(this.$scope.formAlterarCriticaQualidade, !this.$scope.formAlterarCriticaQualidade.$invalid);
            }
        }
    };
    CriticaQualidadeManualAlterarController.prototype.converterParaEnviarServidor = function (crq, camposMonitoradosDaCritica) {
        var documentos;
        if (Array.isArray(crq.documentos)) {
            documentos = crq.documentos;
        }
        else {
            documentos = [crq.documentos];
        }
        var codigoSiglaDocumentoSelecionado = this.isCodigoSiglaDocumentoSelecionado();
        var codigo = ConverterParameterObjectToUrlUtils.string(this.getCodigoCritica(codigoSiglaDocumentoSelecionado, crq));
        return {
            automatico: false,
            codigo: codigo,
            codigoSiglaDocumento: codigoSiglaDocumentoSelecionado,
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(documentos),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(crq.segmentos),
            gravidade: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.gravidade),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(crq.sistemaNegocio),
            descricao: ConverterParameterObjectToUrlUtils.string(crq.descricao),
            tipo: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipo),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(crq.dataBaseInicio),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(crq.dataBaseFim),
            dataVigenciaInicio: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaInicio),
            dataVigenciaFim: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaFim),
            escopoCritica: ConverterParameterObjectToUrlUtils.string(crq.escopoCritica),
            observacaoDadosMonitorados: ConverterParameterObjectToUrlUtils.string(crq.observacaoDadosMonitorados),
            baseNormativasDaCritica: this.converterParaEnviarServidorBaseNormativa(crq),
            camposMonitorados: ConverterParameterObjectToUrlUtils.atributoPKArray(camposMonitoradosDaCritica)
        };
    };
    CriticaQualidadeManualAlterarController.prototype.getCodigoCritica = function (codigoCriticaTipoSiglaDocumento, crq) {
        if (codigoCriticaTipoSiglaDocumento) {
            return CodigoCriticaQualidade.formatarCodigoSiglaDocumentoServidor(crq.siglaCodigo, crq.codigo);
        }
        return CodigoCriticaQualidade.costruir(crq.sistemaNegocio, crq.codigo);
    };
    CriticaQualidadeManualAlterarController.prototype.converterParaEnviarServidorBaseNormativa = function (crq) {
        return ConverterParameterObjectToUrlUtils.atributoEnumNameNumero(crq.baseNormativasDaCritica);
    };
    CriticaQualidadeManualAlterarController.prototype.validarDataVigenciaFim = function () {
        return !this.criticaQualidade.dataVigenciaInicio
            || !this.criticaQualidade.dataVigenciaFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaFim)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataVigenciaInicio, this.criticaQualidade.dataVigenciaFim, true);
    };
    CriticaQualidadeManualAlterarController.prototype.isDataBaseFimRequerida = function () {
        return this.novaDataBaseFim !== this.criticaQualidade.dataBaseFim;
    };
    CriticaQualidadeManualAlterarController.prototype.isDataBaseFimDesabilitada = function () {
        if (!this.dadosFormulario) {
            return true;
        }
        if (this.isDataBaseFimRequerida() || !this.dadosFormulario.jaGerouIndicio) {
            return false;
        }
        return this.criticaQualidade.dataBaseFim &&
            this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataBaseFim, new Date(), false);
    };
    CriticaQualidadeManualAlterarController.prototype.validarDataVigenciaInicio = function () {
        if (!this.dadosFormulario || !this.criticaQualidade
            || (this.criticaQualidade.tipo !== undefined && (this.criticaQualidade.tipo.enumName === 'AVULSO' || this.criticaQualidade.tipo.enumName === 'DETERMINACAO_SUBSTITUICAO'))) {
            this.criticaQualidade.dataVigenciaFim = this.criticaQualidade.dataVigenciaInicio;
            return true;
        }
        if (this.novaDataVigenciaInicio === this.criticaQualidade.dataVigenciaInicio) {
            return true;
        }
        return !this.criticaQualidade.dataVigenciaInicio
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(new Date(), this.criticaQualidade.dataVigenciaInicio, false);
    };
    CriticaQualidadeManualAlterarController.prototype.voltar = function () {
        this.$state.go('critica-qualidade-pesquisa');
    };
    return CriticaQualidadeManualAlterarController;
}());
CriticaQualidadeManualAlterarController.$inject = ['$state', 'CriticaQualidadeApiService', 'feedbackService', 'moment', '$scope', 'CriticaQualidadeUtils', 'documentoApiService', 'sistemaNegocioApiService', 'CampoSituacaoMonitoradaApiService'];
angular.module('crd').controller('CriticaQualidadeManualAlterarController', CriticaQualidadeManualAlterarController);
//# sourceMappingURL=critica-qualidade-manual-alterar-controller.js.map;
"use strict";
var CriticaQualidadeAutomaticaDetalheController = (function () {
    function CriticaQualidadeAutomaticaDetalheController($state, criticaQualidadeApiService, $uibModal, $scope, feedbackService, abas) {
        if (abas === void 0) { abas = new AbasCritica(); }
        this.$state = $state;
        this.criticaQualidadeApiService = criticaQualidadeApiService;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.abas = abas;
    }
    CriticaQualidadeAutomaticaDetalheController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.criticaQualidadeApiService.montarTelaDetalhe(pk).then(function (resource) {
            _this.criticaQualidade = resource;
            if (!_this.criticaQualidade.automatico) {
                _this.$state.go("status-404");
            }
            _this.abas.DADOS_GERAIS.visibilidade(resource.abas.podeVerDadosGerais);
            _this.abas.COMPARACAO_DOCUMENTO.visibilidade(resource.abas.podeVerComparacaoDocumentos);
            _this.abas.DADOS_MONITORADOS.visibilidade(resource.abas.podeVerDadosMonitorados);
            _this.ativarAba(_this.abas.DADOS_GERAIS);
        });
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.paraTestarCritica = function () {
        var configModal = {
            criticaPk: this.criticaQualidade.pk,
            criticaCodigo: this.criticaQualidade.codigo
        };
        this.openModalAcao(configModal);
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.openModalAcao = function (configModal) {
        var scope = this.$scope.$new();
        scope.config = configModal;
        scope.critica = this.criticaQualidade;
        var _self = this;
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: 'views/critica-qualidade/critica-modal-testar/critica-modal-incluir-teste-tpl.html',
            controller: 'CriticaModalIncluirTesteController',
            controllerAs: 'modalIncluirTesteCriticaCtrl',
            bindToController: true,
            keyboard: true,
            size: 'lg',
            scope: scope
        }).closed.then(function () {
            _self.carregarDadosTela(_self.$state.params.pk);
        });
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.ativarAba = function (aba) {
        this.abas.ativar(aba);
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.excluir = function (pk) {
        var _this = this;
        return this.criticaQualidadeApiService.excluir(pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Crítica de qualidade excluída com sucesso.');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.voltar = function () {
        this.$state.go(this.destinoVoltar);
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.$onInit = function () {
        this.destinoVoltar = this.$state.params.voltar ? this.$state.params.voltar : 'critica-qualidade-pesquisa';
        return this.carregarDadosTela(this.$state.params.pk);
    };
    ;
    CriticaQualidadeAutomaticaDetalheController.prototype.obterTipoEnumName = function () {
        if (!this.criticaQualidade || !this.criticaQualidade.tipo) {
            return '';
        }
        return this.criticaQualidade.tipo.enumName;
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.ehTipo = function () {
        var tiposPermitidos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            tiposPermitidos[_i] = arguments[_i];
        }
        return tiposPermitidos.indexOf(this.obterTipoEnumName()) !== -1;
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.naoEhTipo = function () {
        var tiposBloqueados = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            tiposBloqueados[_i] = arguments[_i];
        }
        return !this.ehTipo.apply(this, tiposBloqueados);
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirSegmento = function () {
        return this.naoEhTipo('DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirProtocoloRecebimento = function () {
        return this.ehTipo('DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirDataBase = function () {
        return this.naoEhTipo('DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirFormula = function () {
        return !this.criticaQualidade.ehEntidadeSupervisionada
            && this.naoEhTipo('DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirModeloIdentificador = function () {
        return !this.criticaQualidade.ehEntidadeSupervisionada
            && this.naoEhTipo('DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirEscopoCritica = function () {
        return !this.criticaQualidade.ehEntidadeSupervisionada
            && this.naoEhTipo('AVULSO', 'DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirVigenciaTradicional = function () {
        return this.naoEhTipo('AVULSO', 'DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaDetalheController.prototype.deveExibirDataAplicacaoCritica = function () {
        return this.ehTipo('AVULSO', 'DETERMINACAO_SUBSTITUICAO', 'QUESTIONAMENTO_AVULSO');
    };
    return CriticaQualidadeAutomaticaDetalheController;
}());
CriticaQualidadeAutomaticaDetalheController.$inject = ['$state', 'CriticaQualidadeApiService', '$uibModal', '$scope', 'feedbackService'];
angular.module('crd').controller('CriticaQualidadeAutomaticaDetalheController', CriticaQualidadeAutomaticaDetalheController);
//# sourceMappingURL=critica-qualidade-automatica-detalhe-controller.js.map;
"use strict";
var CriticaQualidadeManualDetalheController = (function () {
    function CriticaQualidadeManualDetalheController($state, criticaQualidadeApiService, $uibModal, $scope, feedbackService, abas) {
        if (abas === void 0) { abas = new AbasCriticaManual(); }
        this.$state = $state;
        this.criticaQualidadeApiService = criticaQualidadeApiService;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.abas = abas;
    }
    CriticaQualidadeManualDetalheController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.criticaQualidadeApiService.montarTelaDetalhe(pk).then(function (resource) {
            _this.criticaQualidade = resource;
            if (_this.criticaQualidade.automatico) {
                _this.$state.go("status-404");
            }
            _this.abas.DADOS_GERAIS.visibilidade(resource.abas.podeVerDadosGerais);
            _this.abas.DADOS_MONITORADOS.visibilidade(resource.abas.podeVerDadosMonitorados);
            _this.ativarAba(_this.abas.DADOS_GERAIS);
        });
    };
    CriticaQualidadeManualDetalheController.prototype.paraTestarCritica = function () {
        var configModal = {
            criticaPk: this.criticaQualidade.pk,
            criticaCodigo: this.criticaQualidade.codigo
        };
        this.openModalAcao(configModal);
    };
    CriticaQualidadeManualDetalheController.prototype.openModalAcao = function (configModal) {
        var scope = this.$scope.$new();
        scope.config = configModal;
        scope.critica = this.criticaQualidade;
        var _self = this;
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: 'views/critica-qualidade/critica-modal-testar/critica-modal-incluir-teste-tpl.html',
            controller: 'CriticaModalIncluirTesteController',
            controllerAs: 'modalIncluirTesteCriticaCtrl',
            bindToController: true,
            keyboard: true,
            size: 'lg',
            scope: scope
        }).closed.then(function () {
            _self.carregarDadosTela(_self.$state.params.pk);
        });
    };
    CriticaQualidadeManualDetalheController.prototype.ativarAba = function (aba) {
        this.abas.ativar(aba);
    };
    CriticaQualidadeManualDetalheController.prototype.excluir = function (pk) {
        var _this = this;
        return this.criticaQualidadeApiService.excluir(pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Crítica de qualidade excluída com sucesso.');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    CriticaQualidadeManualDetalheController.prototype.voltar = function () {
        this.$state.go(this.destinoVoltar);
    };
    CriticaQualidadeManualDetalheController.prototype.$onInit = function () {
        this.destinoVoltar = this.$state.params.voltar ? this.$state.params.voltar : 'critica-qualidade-pesquisa';
        return this.carregarDadosTela(this.$state.params.pk);
    };
    ;
    return CriticaQualidadeManualDetalheController;
}());
CriticaQualidadeManualDetalheController.$inject = ['$state', 'CriticaQualidadeApiService', '$uibModal', '$scope', 'feedbackService'];
angular.module('crd').controller('CriticaQualidadeManualDetalheController', CriticaQualidadeManualDetalheController);
//# sourceMappingURL=critica-qualidade-manual-detalhe-controller.js.map;
"use strict";
var CriticaQualidadeAutomaticaIncluirController = (function () {
    function CriticaQualidadeAutomaticaIncluirController($state, criticaQualidadeApiService, feedbackService, documentoApiService, $scope, criticaQualidadeUtils, sistemaNegocioApiService, campoSituacaoMonitoradaApiService, abas, listaCamposDadosMonitorados, listaDocDadosMonitorados, dmSistemaNegocio, dmDocumento, dmBaseNormativas, dmCampoMonitorado) {
        if (abas === void 0) { abas = new AbasCritica(); }
        if (listaCamposDadosMonitorados === void 0) { listaCamposDadosMonitorados = Array(); }
        if (listaDocDadosMonitorados === void 0) { listaDocDadosMonitorados = Array(); }
        this.$state = $state;
        this.criticaQualidadeApiService = criticaQualidadeApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.$scope = $scope;
        this.criticaQualidadeUtils = criticaQualidadeUtils;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.abas = abas;
        this.listaCamposDadosMonitorados = listaCamposDadosMonitorados;
        this.listaDocDadosMonitorados = listaDocDadosMonitorados;
        this.dmSistemaNegocio = dmSistemaNegocio;
        this.dmDocumento = dmDocumento;
        this.dmBaseNormativas = dmBaseNormativas;
        this.dmCampoMonitorado = dmCampoMonitorado;
        this.codigoMask = '';
        this.gravidadesAuxiliares = [];
        this.abaDadosMonitorados = {
            sistemasNegocio: new Array(),
            documentos: new Array(),
            camposMonitorados: new Array()
        };
    }
    CriticaQualidadeAutomaticaIncluirController.prototype.onTipoAlterado = function (sistemaNegocio) {
        this.criticaQualidade.formula = undefined;
        this.criticaQualidade.protocolosRecebimento = undefined;
        this.criticaQualidade.documentos = [];
        this.resetCodigoCriticaSiglaDocumento(sistemaNegocio);
        if (this.criticaQualidade.tipo && (this.criticaQualidade.tipo.enumName === 'AVISO'
            || this.criticaQualidade.tipo.enumName === 'SINALIZACAO_SIM'
            || this.criticaQualidade.tipo.enumName === 'QUESTIONAMENTO_AVULSO')) {
            this.criticaQualidade.gravidade = { enumName: 'SEM_GRAVIDADE' };
        }
        else {
            this.criticaQualidade.gravidade = undefined;
        }
        this.adaptarGravidades();
        this.carregarDocumentos();
        this.ativarAba(this.abas.DADOS_GERAIS);
        this.visibilidadeAbaComparacaoDocumento(this.criticaQualidade);
        this.visibilidadeAbaDadosMonitorados(this.criticaQualidade);
        this.removerValidacaoCampoProtocoloRecebimento();
        this.criticaQualidade.formula = undefined;
        if (this.criticaQualidade.tipo) {
            var tipo = this.criticaQualidade.tipo.enumName;
            if (tipo === 'DETERMINACAO_SUBSTITUICAO' || tipo === 'QUESTIONAMENTO_AVULSO') {
                this.criticaQualidade.formula = "1";
                this.criticaQualidade.baseNormativasDaCritica = [];
            }
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.showBaseNormativa = function () {
        if (!this.criticaQualidade.tipo) {
            return false;
        }
        return !(this.criticaQualidade.tipo.enumName === 'AVULSO'
            || this.criticaQualidade.tipo.enumName === 'DETERMINACAO_SUBSTITUICAO'
            || this.criticaQualidade.tipo.enumName === 'QUESTIONAMENTO_AVULSO');
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.isDeterminacaoSubstituicao = function () {
        if (this.criticaQualidade === undefined || this.criticaQualidade.tipo === undefined) {
            return true;
        }
        return this.criticaQualidade.tipo.enumName === 'DETERMINACAO_SUBSTITUICAO'
            || this.criticaQualidade.tipo.enumName === 'QUESTIONAMENTO_AVULSO';
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.adaptarGravidades = function () {
        if (!this.criticaQualidade.tipo) {
            this.dadosFormulario.gravidades = this.dadosFormulario.gravidadesAutomatico;
            return;
        }
        var tipo = this.criticaQualidade.tipo.enumName;
        if (tipo === 'QUESTIONAMENTO_AVULSO') {
            this.dadosFormulario.gravidades = [
                { nome: 'Sem gravidade', codigo: 'S', enumName: 'SEM_GRAVIDADE' }
            ];
        }
        else if (tipo === 'AVULSO' || tipo === 'DETERMINACAO_SUBSTITUICAO') {
            this.dadosFormulario.gravidades = this.dadosFormulario.gravidadesAvulsoOuDetermincacao;
        }
        else {
            this.dadosFormulario.gravidades = this.dadosFormulario.gravidadesAutomatico;
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.adaptarGravidadesAposTolerancia = function () {
        if (this.criticaQualidade.tipoAposTolerancia && (this.criticaQualidade.tipoAposTolerancia.enumName === 'SINALIZACAO_SIM')) {
            this.criticaQualidade.gravidadeAposToler = { nome: 'Sem gravidade', codigo: 'S', enumName: 'SEM_GRAVIDADE' };
            this.gravidadesAuxiliares = this.dadosFormulario.gravidadesAutomatico;
            this.dadosFormulario.gravidadesAutomatico = [this.criticaQualidade.gravidadeAposToler];
        }
        else {
            this.criticaQualidade.gravidadeAposToler = undefined;
            this.dadosFormulario.gravidadesAutomatico = this.dadosFormulario.gravidadesAutomatico.length == 1
                ? this.gravidadesAuxiliares
                : this.dadosFormulario.gravidadesAutomatico;
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.removerValidacaoCampoProtocoloRecebimento = function () {
        if (this.criticaQualidade.protocolosRecebimento == undefined || this.criticaQualidade.protocolosRecebimento.length < 1) {
            $("#in-protocolos-recebimento").removeClass("ng-invalid");
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.ativarAba = function (aba) {
        this.abas.ativar(aba);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.visibilidadeAbaComparacaoDocumento = function (criticaQualidade) {
        var visibilidade = (this.criticaQualidade && this.criticaQualidade.tipo && this.criticaQualidade.tipo.possuiComparacaoDocumento);
        this.abas.COMPARACAO_DOCUMENTO.visibilidade(visibilidade);
        if (!visibilidade) {
            this.resetDocumentoComparado();
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.visibilidadeAbaDadosMonitorados = function (criticaQualidade) {
        var visibilidade = (this.criticaQualidade && this.criticaQualidade.tipo && this.criticaQualidade.tipo.possuiDadosMonitorados);
        this.abas.DADOS_MONITORADOS.visibilidade(visibilidade);
        if (!visibilidade) {
            this.resetDadosMonitorados();
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.onAutomaticaAlterado = function () {
        this.limparFormulario();
        this.visibilidadeAbaComparacaoDocumento(this.criticaQualidade);
        this.visibilidadeAbaDadosMonitorados(this.criticaQualidade);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.validarDataVigenciaInicio = function () {
        return !this.criticaQualidade.dataVigenciaInicio
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(new Date(), this.criticaQualidade.dataVigenciaInicio, false);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.observerChangeSistemaNegocio = function (sistemaNegocio) {
        if (!this.criticaQualidade.documentosAcionadores) {
            return;
        }
        this.carregarDocumentos();
        if (sistemaNegocio) {
            var codigoCriticaQualidadeResource = _.find(this.dadosFormulario.codigos, function (e) { return e.sistemaNegocioPk === sistemaNegocio.pk; });
            if (codigoCriticaQualidadeResource) {
                this.criticaQualidade.siglaCodigo = sistemaNegocio.sigla;
                this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(sistemaNegocio, codigoCriticaQualidadeResource.codigo);
                this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
            }
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.observerChangeDocDadosMonitorados = function (doc) {
        var _this = this;
        this.listaCamposDadosMonitorados = [];
        var parameters = {
            documentos: [doc.pk]
        };
        this.campoSituacaoMonitoradaApiService.pesquisarAtivos(parameters)
            .then(function (response) { return _this.listaCamposDadosMonitorados = response; })["catch"](function (error) { return _this.feedbackService.error("Erro ao buscar os campos monitorados."); });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.eventoCheck = function (sistemaNegocio) {
        var _this = this;
        if (this.isCodigoSiglaDocumentoSelecionado()) {
            var codigoDocumento = this.criticaQualidade.documentos[0].codigo;
            this.criticaQualidadeApiService.obterCodigoSiglaDocumento(codigoDocumento)
                .then(function (resource) {
                var codigoCriticaQualidadeResource = resource.data;
                if (codigoCriticaQualidadeResource) {
                    _this.construirCodigoCriticaSiglaDocumento(codigoCriticaQualidadeResource);
                }
                return;
            });
        }
        else {
            this.construirCodigoCriticaSiglaSistemaNegocio(sistemaNegocio);
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.construirCodigoCriticaSiglaDocumento = function (codigoCriticaQualidadeResource) {
        this.criticaQualidade.codigo = CodigoCriticaQualidade.formatarCodigoSiglaDocumentoTela(codigoCriticaQualidadeResource);
        this.criticaQualidade.siglaCodigo = codigoCriticaQualidadeResource.siglaDocumento;
        this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.construirCodigoCriticaSiglaSistemaNegocio = function (sistemaNegocio) {
        if (sistemaNegocio) {
            var codigoCriticaQualidadeResource = _.find(this.dadosFormulario.codigos, function (e) { return e.sistemaNegocioPk === sistemaNegocio.pk; });
            if (codigoCriticaQualidadeResource) {
                this.criticaQualidade.siglaCodigo = sistemaNegocio.sigla;
                this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(sistemaNegocio, codigoCriticaQualidadeResource.codigo);
                this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
            }
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.observerChangeItemDocumento = function (sistemaNegocio, tipo) {
        var somenteUmDocumentoSelecionado = this.criticaQualidade.documentos.length === 1 ? true : false;
        var tipoAvisoOuDeterminacaoSubstituicao = tipo === 'AVISO' || tipo === 'DETERMINACAO_SUBSTITUICAO' || tipo === 'QUESTIONAMENTO_AVULSO';
        if (!somenteUmDocumentoSelecionado || tipoAvisoOuDeterminacaoSubstituicao) {
            this.resetCodigoCriticaSiglaDocumento(sistemaNegocio);
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.deveDesabilitarCheckboxSiglaDocumento = function () {
        if (this.criticaQualidade.documentos === undefined) {
            return true;
        }
        return this.criticaQualidade.documentos.length === 1
            && this.criticaQualidade.documentos[0] !== undefined ? false : true;
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.resetCodigoCriticaSiglaDocumento = function (sistemaNegocio) {
        document.getElementById("inSiglaDocumento").checked = false;
        this.construirCodigoCriticaSiglaSistemaNegocio(sistemaNegocio);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.observerChangeSNDadosMonitorados = function (sistemaNegocio) {
        var _this = this;
        this.listaDocDadosMonitorados = [];
        this.abaDadosMonitorados.documentos.forEach(function (doc) {
            if (!doc.sistemaNegocio) {
                return;
            }
            if (doc.sistemaNegocio.pk === sistemaNegocio.pk) {
                _this.listaDocDadosMonitorados.push(doc);
            }
        });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.montarlistaDocumentoDadoComparado = function () {
        var docsDadosGerais = !_.isEmpty(this.criticaQualidade.documentos)
            ? this.criticaQualidade.documentos
            : this.dadosFormulario.documentos;
        var docAcionadores = this.criticaQualidade.documentosAcionadores
            ? this.criticaQualidade.documentosAcionadores
            : new Array();
        var documentos = ArrayUtils.joinDistinct('pk', docsDadosGerais, docAcionadores);
        this.abaDadosMonitorados.documentos = documentos.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(lhs.codigo, rhs.codigo)
            .build(); });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.montarlistaSistemaNegocioDadoComparado = function () {
        var sisAcionadores = this.criticaQualidade.documentosAcionadores
            ? _.map(this.criticaQualidade.documentosAcionadores, function (item) { return item.sistemaNegocio; })
            : new Array();
        var sistemaNegocios = ArrayUtils.joinDistinct('pk', new Array(this.criticaQualidade.sistemaNegocio), sisAcionadores);
        this.abaDadosMonitorados.sistemasNegocio = sistemaNegocios.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(lhs.sigla, rhs.sigla)
            .build(); });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.carregarDadosMonitorados = function () {
        this.dmSistemaNegocio = undefined;
        this.dmDocumento = undefined;
        this.dmCampoMonitorado = undefined;
        this.montarlistaSistemaNegocioDadoComparado();
        this.montarlistaDocumentoDadoComparado();
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.resetDadosMonitorados = function () {
        this.criticaQualidade.observacaoDadosMonitorados = undefined;
        this.criticaQualidade.camposMonitorados = [];
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.resetDocumentoComparado = function () {
        this.criticaQualidade.documentosAcionadores = [];
        this.criticaQualidade.tipoEncaminhamento = { enumName: "PROPRIA_ENTIDADE_SUPERVISIONADA" };
        this.criticaQualidade.reprocessar = false;
        this.criticaQualidade.sistemaNegocioComparado = undefined;
        this.criticaQualidade.documentoComparado = undefined;
        this.dadosFormulario.documentosParaComparado = [];
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.observerChangeSistemaNegocioParaComparado = function () {
        this.criticaQualidade.documentoComparado = undefined;
        this.carregarDocumentosParaComparado();
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.validarIntervaloDatasBase = function () {
        return !this.criticaQualidade.dataBaseFim
            || !this.criticaQualidade.dataBaseInicio
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseFim)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataBaseInicio, this.criticaQualidade.dataBaseFim, true);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.validarDataVigenciaFim = function () {
        return !this.criticaQualidade.dataVigenciaInicio ||
            !this.criticaQualidade.dataVigenciaFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaFim)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataVigenciaInicio, this.criticaQualidade.dataVigenciaFim, true);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.limparFormulario = function () {
        this.criticaQualidade = {
            automatico: this.criticaQualidade.automatico,
            reprocessar: false,
            documentosAcionadores: []
        };
        this.dadosFormulario.documentos = [];
        this.$scope.formIncluirCriticaQualidade.$setPristine();
        this.$scope.formIncluirCriticaQualidade.$setUntouched(true);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.salvar = function (inq) {
        var _this = this;
        var crqParaSalvar = this.converterParaEnviarServidor(inq);
        this.criticaQualidadeApiService.incluir(this.dadosFormulario._links['crd-critica-qualidade-incluir'].href, crqParaSalvar).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso('Crítica de qualidade salva com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.$onInit = function () {
        var _this = this;
        var pk = this.$state.params.pk;
        this.abas.DADOS_GERAIS.visibilidade(true);
        this.abas.COMPARACAO_DOCUMENTO.visibilidade(false);
        this.abas.DADOS_MONITORADOS.visibilidade(false);
        return this.carregarDadosTela(pk).then(function (callback) {
            if (pk) {
                _this.criticaQualidadeUtils.validarFormulario(_this.$scope.formIncluirCriticaQualidade, true);
            }
        });
    };
    ;
    CriticaQualidadeAutomaticaIncluirController.prototype.carregarDadosTela = function (pkClone) {
        var _this = this;
        this.dmBaseNormativas = undefined;
        this.criticaQualidade = {
            baseNormativasDaCritica: [],
            automatico: true
        };
        return this.criticaQualidadeApiService.montarTelaIncluir(pkClone, true).then(function (resource) {
            _this.dadosFormulario = resource;
            _this.criticaQualidade = resource.criticaQualidade;
            if (_this.criticaQualidade) {
                if (_this.criticaQualidade.codigoCriticaSiglaDocumento) {
                    _this.construirCodigoCriticaSiglaDocumento(_this.criticaQualidade.codigoCriticaResource);
                    document.getElementById("inSiglaDocumento").checked = true;
                }
                else {
                    _this.construirCodigoCriticaSiglaSistemaNegocio(resource.criticaQualidade.sistemaNegocio);
                }
                _this.criticaQualidade.reprocessar = resource.criticaQualidade.reprocessarDataBasePosterior;
                _this.criticaQualidade.sistemaNegocioComparado = resource.criticaQualidade.documentoComparado ? resource.criticaQualidade.documentoComparado.sistemaNegocio : undefined;
                _this.criticaQualidade.dataBaseInicio = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataBaseInicio);
                _this.criticaQualidade.dataBaseFim = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataBaseFim);
                _this.criticaQualidade.dataVigenciaInicio = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataVigenciaInicio);
                _this.criticaQualidade.dataVigenciaFim = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataVigenciaFim);
                _this.criticaQualidade.dataAplicacaoAvulsaOuDeterminacaoSubstituicao = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataAplicacaoAvulsaOuDeterminacaoSubstituicao);
                _this.aplicarRegrasDoTipoAoCarregarClone();
                _this.criticaQualidade.baseNormativasDaCritica = resource.baseNormativasDaCritica;
                var tipo = resource.criticaQualidade.tipo ? resource.criticaQualidade.tipo.enumName : undefined;
                if (tipo === 'AVULSO' || tipo === 'DETERMINACAO_SUBSTITUICAO' || tipo === 'QUESTIONAMENTO_AVULSO') {
                    _this.criticaQualidade.dataVigenciaInicio = undefined;
                    _this.criticaQualidade.dataVigenciaFim = undefined;
                }
                if (!_this.dadosFormulario.acoes.podeEditarObservacaoDadoMonitorado) {
                    _this.criticaQualidade.observacaoDadosMonitorados = undefined;
                }
                _this.adaptarGravidades();
            }
            _this.carregarDocumentos();
            _this.ativarAba(_this.abas.DADOS_GERAIS);
            _this.carregarSistemasNegocioParaComparado();
            _this.carregarDocumentosParaComparado();
            _this.visibilidadeAbaComparacaoDocumento(_this.criticaQualidade);
            _this.visibilidadeAbaDadosMonitorados(_this.criticaQualidade);
        });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.carregarSistemasNegocioParaComparado = function () {
        var _this = this;
        this.sistemaNegocioApiService.obterComDocsAtivosPeriodicidadeDiferenteMenorDiaria()
            .then(function (resource) {
            _this.dadosFormulario.sistemasNegocioParaComparado = resource._embedded.resultado;
            return resource;
        });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.addCampoMonitorado = function (campoMonitorado) {
        this.dmCampoMonitorado = undefined;
        if (this.criticaQualidade.camposMonitorados) {
            for (var i = 0; i < this.criticaQualidade.camposMonitorados.length; i++) {
                if (this.criticaQualidade.camposMonitorados[i].pk === campoMonitorado.pk) {
                    return;
                }
            }
            this.criticaQualidade.camposMonitorados.push(campoMonitorado);
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.addBaseNormativa = function (camposBase) {
        if (camposBase) {
            var adiciona_1;
            adiciona_1 = true;
            if (this.criticaQualidade.baseNormativasDaCritica) {
                this.criticaQualidade.baseNormativasDaCritica.forEach(function (item) {
                    var basekey = ConverterParameterObjectToUrlUtils.atributoEnumName(item.tipo);
                    var campokey = ConverterParameterObjectToUrlUtils.atributoEnumName(camposBase.tipo);
                    if ((item.numero === camposBase.numero) && (basekey === campokey)) {
                        adiciona_1 = false;
                    }
                });
                if (adiciona_1) {
                    this.addBaseDiferente(camposBase);
                }
            }
            this.dmBaseNormativas = undefined;
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.addBaseDiferente = function (base) {
        if (this.criticaQualidade.baseNormativasDaCritica) {
            this.criticaQualidade.baseNormativasDaCritica.push(base);
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.removerDadoMonitoradoPorCampo = function (campo) {
        if (this.criticaQualidade.camposMonitorados) {
            this.criticaQualidade.camposMonitorados = _.filter(this.criticaQualidade.camposMonitorados, function (cm) {
                return cm.pk != campo.pk;
            });
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.removerDadoMonitoradoPorDocumento = function (documento) {
        if (!this.criticaQualidade.camposMonitorados) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.camposMonitorados.length;) {
            var campoMonitorado = this.criticaQualidade.camposMonitorados[i];
            if (campoMonitorado.documento) {
                if (campoMonitorado.documento.pk === documento.pk) {
                    posicao = i;
                    this.criticaQualidade.camposMonitorados.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.removerDadoMonitoradoPorSistema = function (sistema) {
        if (!this.criticaQualidade.camposMonitorados) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.camposMonitorados.length;) {
            var campoMonitorado = this.criticaQualidade.camposMonitorados[i];
            if (!campoMonitorado.documento) {
                return;
            }
            if (campoMonitorado.documento.sistemaNegocio) {
                if (campoMonitorado.documento.sistemaNegocio.pk === sistema.pk) {
                    posicao = i;
                    this.criticaQualidade.camposMonitorados.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.ajustarNumeroBaseNormativa = function () {
        if (!this.criticaQualidade.tipoBaseNormativa) {
            this.criticaQualidade.numeroBaseNormativa = undefined;
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.addDocumentoAcionador = function (documento) {
        if (!this.criticaQualidade.documentosAcionadores) {
            return;
        }
        if (!documento.sistemaNegocio) {
            return;
        }
        this.criticaQualidade.sistemaNegocioComparado = undefined;
        this.criticaQualidade.documentoComparado = undefined;
        this.dadosFormulario.documentosParaComparado = [];
        for (var i = 0; i < this.criticaQualidade.documentosAcionadores.length; i++) {
            if (this.criticaQualidade.documentosAcionadores[i].pk === documento.pk) {
                return;
            }
        }
        this.criticaQualidade.documentosAcionadores.push(documento);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.delDocumentoAcionador = function (documento) {
        if (!this.criticaQualidade.documentosAcionadores) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.documentosAcionadores.length; i++) {
            var documentoAcionador = this.criticaQualidade.documentosAcionadores[i];
            if (documentoAcionador.pk === documento.pk) {
                posicao = i;
                break;
            }
        }
        this.criticaQualidade.documentosAcionadores.splice(posicao, 1);
        this.criticaQualidade.sistemaNegocioComparado = undefined;
        this.criticaQualidade.documentoComparado = undefined;
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.delBaseNormativa = function (base) {
        if (!this.criticaQualidade.baseNormativasDaCritica) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.baseNormativasDaCritica.length; i++) {
            var baseNorma = this.criticaQualidade.baseNormativasDaCritica[i];
            if (base === this.criticaQualidade.baseNormativasDaCritica[i]) {
                posicao = i;
                break;
            }
        }
        this.criticaQualidade.baseNormativasDaCritica.splice(posicao, 1);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.validaBaseNormmativa = function (base) {
        if (!this.criticaQualidade.baseNormativasDaCritica) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.baseNormativasDaCritica.length; i++) {
            if ((base.numero === this.criticaQualidade.baseNormativasDaCritica[i].numero) &&
                (base.tipo === this.criticaQualidade.baseNormativasDaCritica[i].tipo)) {
                posicao = i;
                this.criticaQualidade.baseNormativasDaCritica.splice(posicao, 1);
                alert(JSON.stringify("Base normativa já cadastrada."));
                break;
            }
        }
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.carregarDocumentos = function () {
        var _this = this;
        if (!this.criticaQualidade.sistemaNegocio) {
            return;
        }
        var periodicidade = this.criticaQualidade.tipo && this.criticaQualidade.tipo.enumName === 'AVISO' ? 'DIARIA' : 'EVENTUAL_DIARIA';
        this.documentoApiService.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(this.criticaQualidade.sistemaNegocio.pk, periodicidade)
            .then(function (resource) {
            _this.dadosFormulario.documentos = resource._embedded.resultado;
            _this.abaDadosMonitorados.documentos = resource;
            return resource;
        });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.carregarDocumentosParaComparado = function () {
        var _this = this;
        if (!this.criticaQualidade.sistemaNegocioComparado) {
            return;
        }
        this.dadosFormulario.documentosParaComparado = [];
        var periodicidade = 'EVENTUAL_DIARIA';
        this.documentoApiService.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(this.criticaQualidade.sistemaNegocioComparado.pk, periodicidade)
            .then(function (resource) {
            _this.dadosFormulario.documentosParaComparado = resource._embedded.resultado;
            return resource;
        });
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.isCodigoSiglaDocumentoSelecionado = function () {
        return document.getElementById("inSiglaDocumento").checked;
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.voltar = function () {
        this.$state.go('critica-qualidade-pesquisa');
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.converterParaEnviarServidor = function (crq) {
        var documentos;
        var protocolos;
        if (Array.isArray(crq.documentos)) {
            documentos = crq.documentos;
        }
        else {
            documentos = [crq.documentos];
        }
        if (Array.isArray(crq.protocolosRecebimento)) {
            protocolos = crq.protocolosRecebimento;
        }
        else {
            protocolos = [crq.protocolosRecebimento];
        }
        var codigoSiglaDocumentoSelecionado = this.isCodigoSiglaDocumentoSelecionado();
        var codigo = ConverterParameterObjectToUrlUtils.string(this.getCodigoCritica(codigoSiglaDocumentoSelecionado, crq));
        var valor = {
            automatico: true,
            codigo: codigo,
            codigoSiglaDocumento: codigoSiglaDocumentoSelecionado,
            reprocessar: crq.reprocessar,
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(documentos),
            documentosAcionadores: ConverterParameterObjectToUrlUtils.atributoPKArray(crq.documentosAcionadores),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(crq.segmentos),
            gravidade: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.gravidade),
            gravidadeAposToler: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.gravidadeAposToler),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(crq.sistemaNegocio),
            descricao: ConverterParameterObjectToUrlUtils.string(crq.descricao),
            formula: ConverterParameterObjectToUrlUtils.string(crq.formula),
            disponibilidadeProcessamento: ConverterParameterObjectToUrlUtils.string(crq.disponibilidadeProcessamento),
            modeloMsg: ConverterParameterObjectToUrlUtils.string(crq.modeloMensagem),
            tipo: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipo),
            tipoEncaminhamento: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipoEncaminhamento),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(crq.dataBaseInicio),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(crq.dataBaseFim),
            dataVigenciaInicio: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaInicio),
            dataVigenciaFim: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaFim),
            dataAplicacaoAvulsaOuDeterminacaoSubstituicao: ConverterParameterObjectToUrlUtils.date(crq.dataAplicacaoAvulsaOuDeterminacaoSubstituicao),
            modeloIdentificador: ConverterParameterObjectToUrlUtils.string(crq.modeloIdentificador),
            observacao: ConverterParameterObjectToUrlUtils.string(crq.observacao),
            escopoCritica: ConverterParameterObjectToUrlUtils.string(crq.escopoCritica),
            datasBaseToler: ConverterParameterObjectToUrlUtils.number(crq.numeroDatasBaseTolerancia),
            tipoAposToler: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipoAposTolerancia),
            protocolosRecebimento: crq.protocolosRecebimento,
            camposMonitorados: ConverterParameterObjectToUrlUtils.atributoPKArray(crq.camposMonitorados),
            baseNormativasDaCritica: this.converterParaEnviarServidorBaseNormativa(crq),
            observacaoDadosMonitorados: ConverterParameterObjectToUrlUtils.string(crq.observacaoDadosMonitorados)
        };
        return valor;
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.getCodigoCritica = function (codigoCriticaTipoSiglaDocumento, crq) {
        if (codigoCriticaTipoSiglaDocumento) {
            return CodigoCriticaQualidade.formatarCodigoSiglaDocumentoServidor(crq.siglaCodigo, crq.codigo);
        }
        return CodigoCriticaQualidade.costruir(crq.sistemaNegocio, crq.codigo);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.converterParaEnviarServidorBaseNormativa = function (crq) {
        if (!this.showBaseNormativa()) {
            return [];
        }
        return ConverterParameterObjectToUrlUtils.atributoEnumNameNumero(crq.baseNormativasDaCritica);
    };
    CriticaQualidadeAutomaticaIncluirController.prototype.aplicarRegrasDoTipoAoCarregarClone = function () {
        if (!this.criticaQualidade || !this.criticaQualidade.tipo) {
            return;
        }
        var tipo = this.criticaQualidade.tipo.enumName;
        if (tipo === 'QUESTIONAMENTO_AVULSO') {
            this.criticaQualidade.gravidade = { nome: 'Sem gravidade', codigo: 'S', enumName: 'SEM_GRAVIDADE' };
            this.criticaQualidade.formula = '1';
            this.criticaQualidade.segmentos = undefined;
            this.criticaQualidade.dataBaseInicio = undefined;
            this.criticaQualidade.dataBaseFim = undefined;
            this.criticaQualidade.modeloIdentificador = undefined;
            this.criticaQualidade.escopoCritica = undefined;
            this.criticaQualidade.dataVigenciaInicio = undefined;
            this.criticaQualidade.dataVigenciaFim = undefined;
            this.criticaQualidade.baseNormativasDaCritica = [];
        }
        if (tipo === 'DETERMINACAO_SUBSTITUICAO') {
            this.criticaQualidade.formula = '1';
            this.criticaQualidade.segmentos = undefined;
            this.criticaQualidade.dataBaseInicio = undefined;
            this.criticaQualidade.dataBaseFim = undefined;
            this.criticaQualidade.modeloIdentificador = undefined;
            this.criticaQualidade.escopoCritica = undefined;
            this.criticaQualidade.dataVigenciaInicio = undefined;
            this.criticaQualidade.dataVigenciaFim = undefined;
            this.criticaQualidade.baseNormativasDaCritica = [];
        }
        this.adaptarGravidades();
    };
    return CriticaQualidadeAutomaticaIncluirController;
}());
CriticaQualidadeAutomaticaIncluirController.$inject = ['$state', 'CriticaQualidadeApiService', 'feedbackService', 'documentoApiService', '$scope',
    'CriticaQualidadeUtils', 'sistemaNegocioApiService', 'CampoSituacaoMonitoradaApiService'];
angular.module('crd').controller('CriticaQualidadeAutomaticaIncluirController', CriticaQualidadeAutomaticaIncluirController);
//# sourceMappingURL=critica-qualidade-automatica-incluir-controller.js.map;
"use strict";
var CriticaQualidadeManualIncluirController = (function () {
    function CriticaQualidadeManualIncluirController($state, criticaQualidadeApiService, feedbackService, documentoApiService, $scope, criticaQualidadeUtils, sistemaNegocioApiService, campoSituacaoMonitoradaApiService, abas, listaCamposDadosMonitorados, listaDocDadosMonitorados, listaBaseNormativas, dmSistemaNegocio, dmDocumento, dmBaseNormativas, dmCampoMonitorado) {
        if (abas === void 0) { abas = new AbasCritica(); }
        if (listaCamposDadosMonitorados === void 0) { listaCamposDadosMonitorados = Array(); }
        if (listaDocDadosMonitorados === void 0) { listaDocDadosMonitorados = Array(); }
        if (listaBaseNormativas === void 0) { listaBaseNormativas = Array(); }
        this.$state = $state;
        this.criticaQualidadeApiService = criticaQualidadeApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.$scope = $scope;
        this.criticaQualidadeUtils = criticaQualidadeUtils;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.abas = abas;
        this.listaCamposDadosMonitorados = listaCamposDadosMonitorados;
        this.listaDocDadosMonitorados = listaDocDadosMonitorados;
        this.listaBaseNormativas = listaBaseNormativas;
        this.dmSistemaNegocio = dmSistemaNegocio;
        this.dmDocumento = dmDocumento;
        this.dmBaseNormativas = dmBaseNormativas;
        this.dmCampoMonitorado = dmCampoMonitorado;
        this.codigoMask = '';
        this.abaDadosMonitorados = {
            sistemasNegocio: new Array(),
            documentos: new Array(),
            camposMonitorados: new Array()
        };
    }
    CriticaQualidadeManualIncluirController.prototype.onTipoAlterado = function () {
        this.carregarDocumentos();
        this.ativarAba(this.abas.DADOS_GERAIS);
        this.visibilidadeAbaDadosMonitorados(this.criticaQualidade);
        if (this.criticaQualidade.tipo) {
            var tipo = this.criticaQualidade.tipo.enumName;
            if (tipo === 'DETERMINACAO_SUBSTITUICAO') {
                this.criticaQualidade.baseNormativasDaCritica = [];
            }
        }
    };
    CriticaQualidadeManualIncluirController.prototype.ativarAba = function (aba) {
        this.abas.ativar(aba);
    };
    CriticaQualidadeManualIncluirController.prototype.visibilidadeAbaDadosMonitorados = function (criticaQualidade) {
        var visibilidade = true;
        this.abas.DADOS_MONITORADOS.visibilidade(visibilidade);
    };
    CriticaQualidadeManualIncluirController.prototype.observerChangeSistemaNegocio = function (sistemaNegocio) {
        if (sistemaNegocio) {
            var codigoCriticaQualidadeResource = _.find(this.dadosFormulario.codigos, function (e) { return e.sistemaNegocioPk === sistemaNegocio.pk; });
            if (codigoCriticaQualidadeResource) {
                this.criticaQualidade.siglaCodigo = sistemaNegocio.sigla;
                this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(sistemaNegocio, codigoCriticaQualidadeResource.codigo);
                this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
            }
        }
        this.carregarDocumentos();
    };
    CriticaQualidadeManualIncluirController.prototype.carregarDadosMonitorados = function () {
        this.dmSistemaNegocio = undefined;
        this.dmDocumento = undefined;
        this.dmCampoMonitorado = undefined;
        this.montarlistaSistemaNegocioDadoComparado();
        this.montarlistaDocumentoDadoComparado();
    };
    CriticaQualidadeManualIncluirController.prototype.montarlistaSistemaNegocioDadoComparado = function () {
        if (this.dadosFormulario.sistemasNegocioMonitorados) {
            this.abaDadosMonitorados.sistemasNegocio = this.dadosFormulario.sistemasNegocioMonitorados;
        }
    };
    CriticaQualidadeManualIncluirController.prototype.montarlistaDocumentoDadoComparado = function () {
        var docsDadosGerais = !_.isEmpty(this.criticaQualidade.documentos)
            ? this.criticaQualidade.documentos
            : this.dadosFormulario.documentos;
        this.abaDadosMonitorados.documentos = docsDadosGerais.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(lhs.codigo, rhs.codigo)
            .build(); });
    };
    CriticaQualidadeManualIncluirController.prototype.observerChangeDocDadosMonitorados = function (doc) {
        var _this = this;
        this.listaCamposDadosMonitorados = [];
        var parameters = {
            documentos: [doc.pk]
        };
        this.campoSituacaoMonitoradaApiService.pesquisarAtivos(parameters)
            .then(function (response) { return _this.listaCamposDadosMonitorados = response; })["catch"](function (error) { return _this.feedbackService.error("Erro ao buscar os campos monitorados."); });
    };
    CriticaQualidadeManualIncluirController.prototype.observarChangeBaseNormativas = function (base) {
        this.listaBaseNormativas = [];
        this.listaBaseNormativas.push(base);
    };
    CriticaQualidadeManualIncluirController.prototype.observerChangeSNDadosMonitorados = function (sistemaNegocio) {
        var _this = this;
        this.carregarDocumentosPorSN(sistemaNegocio.pk, function (resultado) {
            _this.listaDocDadosMonitorados = resultado;
        });
    };
    CriticaQualidadeManualIncluirController.prototype.observerChangeSistemaNegocioParaComparado = function () {
        this.criticaQualidade.documentoComparado = undefined;
    };
    CriticaQualidadeManualIncluirController.prototype.deveDesabilitarCheckboxSiglaDocumento = function () {
        if (this.criticaQualidade.documentos === undefined) {
            return true;
        }
        return this.criticaQualidade.documentos.length === 1
            && this.criticaQualidade.documentos[0] !== undefined ? false : true;
    };
    CriticaQualidadeManualIncluirController.prototype.eventoCheck = function (sistemaNegocio) {
        var _this = this;
        if (this.isCodigoSiglaDocumentoSelecionado()) {
            var codigoDocumento = this.criticaQualidade.documentos[0].codigo;
            this.criticaQualidadeApiService.obterCodigoSiglaDocumento(codigoDocumento)
                .then(function (resource) {
                var codigoCriticaQualidadeResource = resource.data;
                if (codigoCriticaQualidadeResource) {
                    _this.construirCodigoCriticaSiglaDocumento(codigoCriticaQualidadeResource);
                }
                return;
            });
        }
        else {
            this.construirCodigoCriticaSiglaSistemaNegocio(sistemaNegocio);
        }
    };
    CriticaQualidadeManualIncluirController.prototype.isCodigoSiglaDocumentoSelecionado = function () {
        return document.getElementById("inSiglaDocumento").checked;
    };
    CriticaQualidadeManualIncluirController.prototype.construirCodigoCriticaSiglaDocumento = function (codigoCriticaQualidadeResource) {
        this.criticaQualidade.codigo = CodigoCriticaQualidade.formatarCodigoSiglaDocumentoTela(codigoCriticaQualidadeResource);
        this.criticaQualidade.siglaCodigo = codigoCriticaQualidadeResource.siglaDocumento;
        this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
    };
    CriticaQualidadeManualIncluirController.prototype.construirCodigoCriticaSiglaSistemaNegocio = function (sistemaNegocio) {
        if (sistemaNegocio) {
            var codigoCriticaQualidadeResource = _.find(this.dadosFormulario.codigos, function (e) { return e.sistemaNegocioPk === sistemaNegocio.pk; });
            if (codigoCriticaQualidadeResource) {
                this.criticaQualidade.siglaCodigo = sistemaNegocio.sigla;
                this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(sistemaNegocio, codigoCriticaQualidadeResource.codigo);
                this.codigoMask = CodigoCriticaQualidade.gerarMascara(codigoCriticaQualidadeResource.codigo);
            }
        }
    };
    CriticaQualidadeManualIncluirController.prototype.observerChangeItemDocumento = function (sistemaNegocio) {
        var somenteUmDocumentoSelecionado = this.criticaQualidade.documentos.length === 1 ? true : false;
        if (!somenteUmDocumentoSelecionado) {
            this.resetCodigoCriticaSiglaDocumento(sistemaNegocio);
        }
    };
    CriticaQualidadeManualIncluirController.prototype.resetCodigoCriticaSiglaDocumento = function (sistemaNegocio) {
        document.getElementById("inSiglaDocumento").checked = false;
        this.construirCodigoCriticaSiglaSistemaNegocio(sistemaNegocio);
    };
    CriticaQualidadeManualIncluirController.prototype.validarIntervaloDatasBase = function () {
        return !this.criticaQualidade.dataBaseFim
            || !this.criticaQualidade.dataBaseInicio
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataBaseFim)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataBaseInicio, this.criticaQualidade.dataBaseFim, true);
    };
    CriticaQualidadeManualIncluirController.prototype.validarDataVigenciaInicio = function () {
        return !this.criticaQualidade.dataVigenciaInicio
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(new Date(), this.criticaQualidade.dataVigenciaInicio, false);
    };
    CriticaQualidadeManualIncluirController.prototype.validarDataVigenciaFim = function () {
        return !this.criticaQualidade.dataVigenciaInicio ||
            !this.criticaQualidade.dataVigenciaFim
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaInicio)
            || !this.criticaQualidadeUtils.isDataCompleta(this.criticaQualidade.dataVigenciaFim)
            || this.criticaQualidadeUtils.isFimMaiorQueInicio(this.criticaQualidade.dataVigenciaInicio, this.criticaQualidade.dataVigenciaFim, true);
    };
    CriticaQualidadeManualIncluirController.prototype.salvar = function (inq) {
        var _this = this;
        var crqParaSalvar = this.converterParaEnviarServidor(inq);
        this.criticaQualidadeApiService.incluir(this.dadosFormulario._links['crd-critica-qualidade-incluir'].href, crqParaSalvar).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso('Crítica de qualidade salva com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    CriticaQualidadeManualIncluirController.prototype.$onInit = function () {
        var _this = this;
        var pk = this.$state.params.pk;
        this.abas.DADOS_GERAIS.visibilidade(true);
        this.abas.DADOS_MONITORADOS.visibilidade(false);
        return this.carregarDadosTela(pk).then(function (callback) {
            if (pk) {
                _this.criticaQualidadeUtils.validarFormulario(_this.$scope.formIncluirCriticaQualidade, true);
            }
        });
    };
    ;
    CriticaQualidadeManualIncluirController.prototype.carregarDadosTela = function (pkClone) {
        var _this = this;
        this.dmBaseNormativas = undefined;
        this.criticaQualidade = {
            baseNormativasDaCritica: [],
            automatico: false
        };
        return this.criticaQualidadeApiService.montarTelaIncluir(pkClone, false).then(function (resource) {
            _this.dadosFormulario = resource;
            _this.criticaQualidade = resource.criticaQualidade;
            if (pkClone) {
                if (_this.criticaQualidade.codigoCriticaSiglaDocumento) {
                    _this.construirCodigoCriticaSiglaDocumento(_this.criticaQualidade.codigoCriticaResource);
                    document.getElementById("inSiglaDocumento").checked = true;
                }
                else {
                    _this.construirCodigoCriticaSiglaSistemaNegocio(resource.criticaQualidade.sistemaNegocio);
                }
                _this.criticaQualidade.codigo = CodigoCriticaQualidade.desconstruir(resource.criticaQualidade.sistemaNegocio, resource.criticaQualidade.codigo);
                _this.criticaQualidade.sistemaNegocioComparado = resource.criticaQualidade.documentoComparado ? resource.criticaQualidade.documentoComparado.sistemaNegocio : undefined;
                _this.criticaQualidade.dataBaseInicio = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataBaseInicio);
                _this.criticaQualidade.dataBaseFim = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataBaseFim);
                _this.criticaQualidade.dataVigenciaInicio = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataVigenciaInicio);
                _this.criticaQualidade.dataVigenciaFim = _this.criticaQualidadeUtils.formatarData(resource.criticaQualidade.dataVigenciaFim);
                _this.criticaQualidade.baseNormativasDaCritica = resource.baseNormativasDaCritica;
                if (!_this.dadosFormulario.acoes.podeEditarObservacaoDadoMonitorado) {
                    _this.criticaQualidade.observacaoDadosMonitorados = undefined;
                }
            }
            _this.ativarAba(_this.abas.DADOS_GERAIS);
            _this.visibilidadeAbaDadosMonitorados(_this.criticaQualidade);
            _this.carregarDocumentos();
        });
    };
    CriticaQualidadeManualIncluirController.prototype.addCampoMonitorado = function (campoMonitorado) {
        this.dmCampoMonitorado = undefined;
        if (this.criticaQualidade.camposMonitorados) {
            for (var i = 0; i < this.criticaQualidade.camposMonitorados.length; i++) {
                if (this.criticaQualidade.camposMonitorados[i].pk === campoMonitorado.pk) {
                    return;
                }
            }
            this.criticaQualidade.camposMonitorados.push(campoMonitorado);
        }
    };
    CriticaQualidadeManualIncluirController.prototype.addBaseNormativa = function (camposBase) {
        if (camposBase) {
            var adiciona_1;
            adiciona_1 = true;
            if (this.criticaQualidade.baseNormativasDaCritica) {
                this.criticaQualidade.baseNormativasDaCritica.forEach(function (item) {
                    var basekey = ConverterParameterObjectToUrlUtils.atributoEnumName(item.tipo);
                    var campokey = ConverterParameterObjectToUrlUtils.atributoEnumName(camposBase.tipo);
                    if ((item.numero === camposBase.numero) && (basekey === campokey)) {
                        adiciona_1 = false;
                    }
                });
                if (adiciona_1) {
                    this.addBaseDiferente(camposBase);
                }
            }
            this.dmBaseNormativas = undefined;
        }
    };
    CriticaQualidadeManualIncluirController.prototype.addBaseDiferente = function (base) {
        if (this.criticaQualidade.baseNormativasDaCritica) {
            this.criticaQualidade.baseNormativasDaCritica.push(base);
        }
    };
    CriticaQualidadeManualIncluirController.prototype.removerDadoMonitoradoPorCampo = function (campo) {
        if (this.criticaQualidade.camposMonitorados) {
            this.criticaQualidade.camposMonitorados = _.filter(this.criticaQualidade.camposMonitorados, function (cm) {
                return cm.pk != campo.pk;
            });
        }
    };
    CriticaQualidadeManualIncluirController.prototype.delBaseNormativa = function (base) {
        if (!this.criticaQualidade.baseNormativasDaCritica) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.baseNormativasDaCritica.length; i++) {
            var baseNorma = this.criticaQualidade.baseNormativasDaCritica[i];
            if (base === this.criticaQualidade.baseNormativasDaCritica[i]) {
                posicao = i;
                break;
            }
        }
        this.criticaQualidade.baseNormativasDaCritica.splice(posicao, 1);
    };
    CriticaQualidadeManualIncluirController.prototype.removerDadoMonitoradoPorDocumento = function (documento) {
        if (!this.criticaQualidade.camposMonitorados) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.camposMonitorados.length;) {
            var campoMonitorado = this.criticaQualidade.camposMonitorados[i];
            if (campoMonitorado.documento) {
                if (campoMonitorado.documento.pk === documento.pk) {
                    posicao = i;
                    this.criticaQualidade.camposMonitorados.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeManualIncluirController.prototype.removerDadoMonitoradoPorSistema = function (sistema) {
        if (!this.criticaQualidade.camposMonitorados) {
            return;
        }
        var posicao = -1;
        for (var i = 0; i < this.criticaQualidade.camposMonitorados.length;) {
            var campoMonitorado = this.criticaQualidade.camposMonitorados[i];
            if (!campoMonitorado.documento) {
                return;
            }
            if (campoMonitorado.documento.sistemaNegocio) {
                if (campoMonitorado.documento.sistemaNegocio.pk === sistema.pk) {
                    posicao = i;
                    this.criticaQualidade.camposMonitorados.splice(posicao, 1);
                    continue;
                }
                i++;
            }
        }
    };
    CriticaQualidadeManualIncluirController.prototype.ajustarDatabaseFim = function () {
        if (!this.criticaQualidade.dataBaseInicio) {
            this.criticaQualidade.dataBaseFim = undefined;
        }
    };
    CriticaQualidadeManualIncluirController.prototype.carregarDocumentos = function () {
        var _this = this;
        if (!this.criticaQualidade.sistemaNegocio) {
            return;
        }
        this.carregarDocumentosPorSN(this.criticaQualidade.sistemaNegocio.pk, function (resultado) {
            _this.dadosFormulario.documentos = resultado;
        });
    };
    CriticaQualidadeManualIncluirController.prototype.carregarDocumentosPorSN = function (sisPk, callback) {
        var periodicidade = 'EVENTUAL_MENOR_QUE_DIARIA';
        this.documentoApiService.pesquisarAtivosPorPeriodicidadeMinimaESistemaNegocioPk(sisPk, periodicidade)
            .then(function (resource) {
            callback(resource._embedded.resultado);
            return resource;
        });
    };
    CriticaQualidadeManualIncluirController.prototype.voltar = function () {
        this.$state.go('critica-qualidade-pesquisa');
    };
    CriticaQualidadeManualIncluirController.prototype.getCodigoCritica = function (codigoCriticaTipoSiglaDocumento, crq) {
        if (codigoCriticaTipoSiglaDocumento) {
            return CodigoCriticaQualidade.formatarCodigoSiglaDocumentoServidor(crq.siglaCodigo, crq.codigo);
        }
        return CodigoCriticaQualidade.costruir(crq.sistemaNegocio, crq.codigo);
    };
    CriticaQualidadeManualIncluirController.prototype.teste = function () {
        alert("sou um teste");
    };
    CriticaQualidadeManualIncluirController.prototype.converterParaEnviarServidor = function (crq) {
        var documentos;
        if (Array.isArray(crq.documentos)) {
            documentos = crq.documentos;
        }
        else {
            documentos = [crq.documentos];
        }
        var codigoSiglaDocumentoSelecionado = this.isCodigoSiglaDocumentoSelecionado();
        var codigo = ConverterParameterObjectToUrlUtils.string(this.getCodigoCritica(codigoSiglaDocumentoSelecionado, crq));
        return {
            automatico: false,
            codigo: codigo,
            codigoSiglaDocumento: codigoSiglaDocumentoSelecionado,
            tipo: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.tipo),
            gravidade: ConverterParameterObjectToUrlUtils.atributoEnumName(crq.gravidade),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(crq.sistemaNegocio),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(documentos),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(crq.segmentos),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(crq.dataBaseInicio),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(crq.dataBaseFim),
            descricao: ConverterParameterObjectToUrlUtils.string(crq.descricao),
            escopoCritica: ConverterParameterObjectToUrlUtils.string(crq.escopoCritica),
            dataVigenciaInicio: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaInicio),
            dataVigenciaFim: ConverterParameterObjectToUrlUtils.date(crq.dataVigenciaFim),
            camposMonitorados: ConverterParameterObjectToUrlUtils.atributoPKArray(crq.camposMonitorados),
            baseNormativasDaCritica: this.converterParaEnviarServidorBaseNormativa(crq),
            observacaoDadosMonitorados: ConverterParameterObjectToUrlUtils.string(crq.observacaoDadosMonitorados)
        };
    };
    CriticaQualidadeManualIncluirController.prototype.converterParaEnviarServidorBaseNormativa = function (crq) {
        return ConverterParameterObjectToUrlUtils.atributoEnumNameNumero(crq.baseNormativasDaCritica);
    };
    return CriticaQualidadeManualIncluirController;
}());
CriticaQualidadeManualIncluirController.$inject = ['$state', 'CriticaQualidadeApiService', 'feedbackService', 'documentoApiService', '$scope',
    'CriticaQualidadeUtils', 'sistemaNegocioApiService', 'CampoSituacaoMonitoradaApiService'];
angular.module('crd').controller('CriticaQualidadeManualIncluirController', CriticaQualidadeManualIncluirController);
//# sourceMappingURL=critica-qualidade-manual-incluir-controller.js.map;
"use strict";
var CriticaQualidadePesquisaController = (function () {
    function CriticaQualidadePesquisaController($location, $scope, $stateParams, criticaQualidadeApiService, feedbackService, documentoApiService, moment) {
        this.$location = $location;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.criticaQualidadeApiService = criticaQualidadeApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.moment = moment;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    CriticaQualidadePesquisaController.prototype.observerChangeSistemaNegocio = function (sistemasNegocio) {
        this.carregarDocumentos(sistemasNegocio);
    };
    CriticaQualidadePesquisaController.prototype.onAutomaticaSelecionada = function () {
        if (this.parametrosPesquisa.automatica) {
            this.parametrosPesquisa.manual = false;
        }
        this.tipoCriticaList = FiltrarCriticaQualidadeUtil.filtrarTipoCritica(this.dadosFormulario.tipos, this.parametrosPesquisa.automatica === false && this.parametrosPesquisa.manual === false ? undefined : true);
        this.esconderResultadoPesquisa();
    };
    CriticaQualidadePesquisaController.prototype.onManualSelecionada = function () {
        if (this.parametrosPesquisa.manual) {
            this.parametrosPesquisa.automatica = false;
        }
        this.tipoCriticaList = FiltrarCriticaQualidadeUtil.filtrarTipoCritica(this.dadosFormulario.tipos, this.parametrosPesquisa.automatica === false && this.parametrosPesquisa.manual === false ? undefined : false);
        this.esconderResultadoPesquisa();
    };
    CriticaQualidadePesquisaController.prototype.gerarExcel = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.criticaQualidadeApiService.gerarExcel(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    CriticaQualidadePesquisaController.prototype.carregarDocumentos = function (sistemasNegocio) {
        var _this = this;
        if (!sistemasNegocio || _.isEmpty(sistemasNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        var sistemaNegocioPks = _.map(sistemasNegocio, function (value) { return value.pk; });
        this.documentoApiService.buscarPorSistemasNegocio(sistemaNegocioPks).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, resource);
            return resource;
        });
    };
    CriticaQualidadePesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    CriticaQualidadePesquisaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    CriticaQualidadePesquisaController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    CriticaQualidadePesquisaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    CriticaQualidadePesquisaController.prototype.limparResultadoPesquisa = function () {
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    CriticaQualidadePesquisaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao),
            manual: filtro.manual === "true",
            automatica: filtro.automatica === undefined || filtro.automatica === "true",
            criticas: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.criticas),
            sistemasNegocio: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.sistemasNegocio),
            documentos: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documentos),
            segmentos: ConverterParameterUrlToObjectUtils.atributoCodigoArray(filtro.segmentos),
            tipos: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.tipos),
            vigenciaInicio: ConverterParameterUrlToObjectUtils.date(filtro.vigenciaInicio),
            vigenciaFim: ConverterParameterUrlToObjectUtils.date(filtro.vigenciaFim)
        };
    };
    CriticaQualidadePesquisaController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var vigenciaInicio = this.opcoesDeData.normatizar(parametrosPesquisa.vigenciaInicio);
        var vigenciaFim = this.opcoesDeData.normatizar(parametrosPesquisa.vigenciaFim);
        return {
            jaPesquisado: true,
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao),
            manual: parametrosPesquisa.manual + "",
            automatica: parametrosPesquisa.automatica + "",
            criticas: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.criticas),
            sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.sistemasNegocio),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.documentos),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(parametrosPesquisa.segmentos),
            tipos: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.tipos),
            vigenciaInicio: ConverterParameterObjectToUrlUtils.date(vigenciaInicio),
            vigenciaFim: ConverterParameterObjectToUrlUtils.date(vigenciaFim)
        };
    };
    CriticaQualidadePesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.sistemasNegocio = undefined;
        this.parametrosPesquisa.documentos = undefined;
        this.parametrosPesquisa.automatica = true;
        this.parametrosPesquisa.manual = false;
        this.parametrosPesquisa.criticas = undefined;
        this.parametrosPesquisa.segmentos = undefined;
        this.parametrosPesquisa.tipos = undefined;
        this.parametrosPesquisa.vigenciaFim = undefined;
        this.parametrosPesquisa.vigenciaInicio = undefined;
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    CriticaQualidadePesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    CriticaQualidadePesquisaController.prototype.validarVigencia = function () {
        return !(this.parametrosPesquisa && this.parametrosPesquisa.vigenciaInicio && this.parametrosPesquisa.vigenciaFim
            && (this.moment.utc(this.parametrosPesquisa.vigenciaInicio)).isAfter(this.moment.utc(this.parametrosPesquisa.vigenciaFim), 'day'));
    };
    CriticaQualidadePesquisaController.prototype.excluir = function (pk) {
        var _this = this;
        return this.criticaQualidadeApiService.excluir(pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Crítica de qualidade excluída com sucesso.');
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    CriticaQualidadePesquisaController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.criticaQualidadeApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    CriticaQualidadePesquisaController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.criticaQualidadeApiService.montarTelaPesquisa().then(function (montarTelaPesquisa) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaPesquisa;
            _this.carregarDocumentos(_this.parametrosPesquisa.sistemasNegocio);
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            var isTipoAutomatica = undefined;
            if (_this.parametrosPesquisa.automatica && !_this.parametrosPesquisa.manual) {
                isTipoAutomatica = true;
            }
            else if (!_this.parametrosPesquisa.automatica && _this.parametrosPesquisa.manual) {
                isTipoAutomatica = false;
            }
            _this.tipoCriticaList = FiltrarCriticaQualidadeUtil.filtrarTipoCritica(_this.dadosFormulario.tipos, isTipoAutomatica);
            return montarTelaPesquisa;
        });
    };
    CriticaQualidadePesquisaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return CriticaQualidadePesquisaController;
}());
CriticaQualidadePesquisaController.$inject = ['$location', '$scope', '$stateParams', 'CriticaQualidadeApiService', 'feedbackService', 'documentoApiService', 'moment'];
angular.module('crd').controller('CriticaQualidadePesquisaController', CriticaQualidadePesquisaController);
//# sourceMappingURL=critica-qualidade-pesquisa-controller.js.map;
"use strict";
var CriticaQualidadeUtilsImpl = (function () {
    function CriticaQualidadeUtilsImpl(moment) {
        this.moment = moment;
        this.formatoData = 'YYYY-MM-DD';
    }
    CriticaQualidadeUtilsImpl.prototype.isDataCompleta = function (data) {
        if (data === undefined) {
            return true;
        }
        return (data + "").length > 10;
    };
    CriticaQualidadeUtilsImpl.prototype.isFimMaiorQueInicio = function (inicio, fim, podeSerIgual) {
        var formato = 'YYYYMMDD';
        var fimInt = parseInt(this.moment(fim).format(formato));
        var inicioInt = parseInt(this.moment(inicio).format(formato));
        return fimInt > inicioInt || (podeSerIgual && fimInt == inicioInt);
    };
    CriticaQualidadeUtilsImpl.prototype.formatarData = function (data) {
        if (!data) {
            return null;
        }
        return this.moment(data, this.formatoData).toDate();
    };
    CriticaQualidadeUtilsImpl.prototype.habilitarBotaoSalvar = function (formulario) {
        formulario.$invalid = false;
        formulario.$pristine = false;
    };
    CriticaQualidadeUtilsImpl.prototype.validarFormulario = function (formulario, habilitarSalvar) {
        this._validarFormulario(formulario, habilitarSalvar);
    };
    CriticaQualidadeUtilsImpl.prototype._validarFormulario = function (formulario, habilitarSalvar) {
        angular.forEach(formulario, function (field, name) {
            if (typeof name === 'string' && !name.match('^[\$]')) {
                if (field.$pristine) {
                    field.$dirty = true;
                }
            }
        });
        if (habilitarSalvar) {
            this.habilitarBotaoSalvar(formulario);
        }
    };
    return CriticaQualidadeUtilsImpl;
}());
CriticaQualidadeUtilsImpl.$inject = ['moment'];
angular.module('crd').service('CriticaQualidadeUtils', CriticaQualidadeUtilsImpl);
//# sourceMappingURL=critica-qualidade-utils.js.map;
(function(angular, HttpStatus) {
  'use strict';

  angular
    .module('crd')
    .controller('CuradorSistemaNegocioExcluirController', CuradorSistemaNegocioExcluirController);

  CuradorSistemaNegocioExcluirController.$inject = ['$location', '$stateParams', 'curadorSistemaNegocioApiService', 'feedbackService'];

  function CuradorSistemaNegocioExcluirController($location, $stateParams, curadorSistemaNegocioApiService, feedbackService) {
    exlcuir($stateParams.id);

    function exlcuir(id) {
      return curadorSistemaNegocioApiService
        .excluir(id)
        .then(successExcluir);

      function successExcluir(response) {
        if (response.status === HttpStatus.NO_CONTENT) {
          $location.path('/curador-sistema-negocio');
          feedbackService.sucesso('Autorização de agente de curadoria excluída com sucesso!');
        } else {
          feedbackService.erro('Erro ao remover autorização de agente de curadoria!');
        }
      }
    }
  }
})(angular, httpStatusCode);
;
(function(angular, HttpStatus) {
  'use strict';

  angular
    .module('crd')
    .controller('CuradorSistemaNegocioIncluirController', CuradorSistemaNegocioIncluirController);

  CuradorSistemaNegocioIncluirController.$inject = ['$location', 'curadorSistemaNegocioApiService', 'feedbackService'];

  function CuradorSistemaNegocioIncluirController($location, curadorSistemaNegocioApiService, feedbackService) {
    var vm = this;

    vm.pesquisarAgentes = pesquisarAgentes;
    vm.salvar = salvar;
    vm.voltar = voltar;

    iniciar();

    function iniciar() {
      buscarDadosFormulario();
    }

    function buscarDadosFormulario() {
      return curadorSistemaNegocioApiService.montarTelaCriar()
        .then(function(resource) {
          vm.sistemasNegocio = resource._embedded.sistemasNegocio;
          vm.unidadesBacen = resource._embedded.unidadesBacen;
          vm.agentes = resource._embedded.agentesDeCuradoria;

          return resource;
        });
    }

    function voltar() {
      $location.path('/curador-sistema-negocio');
    }

    function salvar(agenteDeCuradoria) {
      var curadorSistemaNegocio = {
        pessoa: {
          nome: agenteDeCuradoria.agente.nome,
          operador: agenteDeCuradoria.agente.operador,
          unidade: agenteDeCuradoria.agente.unidade
        },
        sistemaNegocio: agenteDeCuradoria.sistemaNegocio
      };

      return curadorSistemaNegocioApiService
        .criar(curadorSistemaNegocio)
        .then(successoAoCriar);

      function successoAoCriar(response) {
        if (response.status === HttpStatus.CREATED) {
          voltar();
          feedbackService.sucesso('Autorização de agente de curadoria salva com sucesso!');
        } else {
          feedbackService.violacoes(response.data);
        }
      }
    }

    function pesquisarAgentes(unidadeBacen) {
      return curadorSistemaNegocioApiService
        .pesquisarAgentesPorUnidade(unidadeBacen.unidade)
        .then(successoAoPesquisarAgentes);

      function successoAoPesquisarAgentes(resource) {
        vm.agentes = resource._embedded.resultado;
      }
    }
  }
})(angular, httpStatusCode);
;
(function (angular, parametrosUrl) {
  'use strict';

  var COLUNA_ACOES = 2;

  angular
    .module('crd')
    .controller('CuradorSistemaNegocioListarController', CuradorSistemaNegocioListarController);

  CuradorSistemaNegocioListarController.$inject = ['$scope', '$location', '$stateParams', 'curadorSistemaNegocioApiService', 'DTColumnDefBuilder', 'feedbackService'];

  function CuradorSistemaNegocioListarController($scope, $location, $stateParams, curadorSistemaNegocioApiService, DTColumnDefBuilder, feedbackService) {
    var vm = this;

    vm.esconderResultadoPesquisa = esconderResultadoPesquisa;
    vm.excluir = excluir;
    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.exibirColunaAcoes = exibirColunaAcao;

    vm.view = {
      formulario: {
        visivel: true
      },
      resultado: {
        visivel: true
      }
    };

    iniciar();

    function iniciar() {
      configurarDataTable();

      buscarDadosFormulario()
        .then(function () {
          vm.parametrosPesquisa = extrairParametrosDaUrl($stateParams);
          pesquisar(vm.parametrosPesquisa);
        });
    }

    function exibirResultadoPesquisa() {
      vm.view.resultado.visivel = true;
    }

    function esconderResultadoPesquisa() {
      limparMensagens();
      vm.view.resultado.visivel = false;
    }

    function buscarDadosFormulario() {
      return curadorSistemaNegocioApiService.montarTelaPesquisa()
        .then(function (resource) {
          vm.sistemasNegocio = resource._embedded.sistemasNegocio;
          vm.agentesCuradoria = resource._embedded.agentesDeCuradoria;
          vm._links = resource._links;

          return resource;
        });
    }

    function excluir(curadorSistemaNegocioId) {
      $location.path('/curador-sistema-negocio/' + curadorSistemaNegocioId + '/excluir');
    }

    function pesquisar(parametrosPesquisa) {
      var parametros = montarParametrosParaUrl(parametrosPesquisa);

      $location.search(parametros);

      return curadorSistemaNegocioApiService.pesquisar(parametros)
        .then(function (resource) {
          vm.curadoresSistemaNegocio = resource._embedded.resultado;
          vm.exibirColuna = exibirColunaAcao(vm.curadoresSistemaNegocio);
          exibirResultadoPesquisa();
        });
    }

    function limparParametrosPesquisa(form) {
     vm.parametrosPesquisa.sistemaNegocio = undefined;
     vm.parametrosPesquisa.agenteCuradoria = undefined;

      limparMensagens();
      esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function exibirColunaAcao(resultado) {
      for (var i = 0; i < resultado.length; i++) {
        var index = resultado[i];
        for (var prop in index._links) {
          if (index._links.hasOwnProperty(prop)) {
            if (prop == 'curador-sistema-negocio-excluir') {
              return true;
            }
          }
        }
        return false;
      }
    }

    function montarParametrosParaUrl(parametrosPesquisa) {
      var criador = parametrosUrl.Criador;
      return {
        operador: parametrosPesquisa.agenteCuradoria ? parametrosPesquisa.agenteCuradoria.operador : null,
        sistemaNegocio: criador.pk(parametrosPesquisa.sistemaNegocio),
        unidade: parametrosPesquisa.agenteCuradoria ? parametrosPesquisa.agenteCuradoria.unidade : null
      };
    }

    function extrairParametrosDaUrl(parametros) {
      var extrator = parametrosUrl.Extrator;
      return {
        agenteCuradoria: {
          operador: parametros.operador,
          unidade: parametros.unidade
        },
        sistemaNegocio: extrator.objetoPk(parametros.sistemaNegocio)
      };
    }

    function configurarDataTable() {
      defineTamanhoGridResultado();
      vm.dtOptions = {};
    }

    function defineTamanhoGridResultado() {
      vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(COLUNA_ACOES).withOption('bSortable', false)
      ];
    }

    function limparMensagens() {
      feedbackService.limpar();
    }
  }
})(angular, CRDUtils.ParametrosUrl);
;
"use strict";
var AbaDashboard = (function () {
    function AbaDashboard(index, ativado, visivel) {
        if (ativado === void 0) { ativado = false; }
        if (visivel === void 0) { visivel = false; }
        this.index = index;
        this.ativado = ativado;
        this.visivel = visivel;
    }
    AbaDashboard.createAbas = function () {
        return new AbasDashboard;
    };
    AbaDashboard.prototype.visibilidade = function (visivel) {
        this.visivel = visivel;
        this.ativado = false;
    };
    AbaDashboard.prototype.ativar = function () {
        if (!this.visivel) {
            this.ativado = false;
            throw "Não é possível ativar esta aba.";
        }
        this.ativado = true;
    };
    return AbaDashboard;
}());
var AbasDashboard = (function () {
    function AbasDashboard() {
        this.MURAL_AVISOS = new AbaDashboard(0);
        this.EMAIL_CORPORATIVO = new AbaDashboard(1);
        this.AGENDA_ES = new AbaDashboard(2);
        this.todasAbas = [this.MURAL_AVISOS, this.EMAIL_CORPORATIVO, this.AGENDA_ES];
    }
    AbasDashboard.prototype.ativar = function (aba) {
        _.forEach(this.todasAbas, function (aba) { return aba.ativado = false; });
        aba.ativar();
    };
    return AbasDashboard;
}());
//# sourceMappingURL=aba-dashboard.js.map;
"use strict";
var DashboardController = (function () {
    function DashboardController($state, $rootScope, feedbackService, locationService, dashboardApiService, agendaEsApiService, abas) {
        if (abas === void 0) { abas = new AbasDashboard(); }
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.feedbackService = feedbackService;
        this.locationService = locationService;
        this.dashboardApiService = dashboardApiService;
        this.agendaEsApiService = agendaEsApiService;
        this.abas = abas;
        this.apresentarMensagens = false;
        this.apresentarAvisos = false;
        this.apresentaAgendaES = false;
        this.existeDataLimiteEntregaHoje = false;
    }
    DashboardController.prototype.$onInit = function () {
        this.carregarDadosMuralAvisos();
        this.carregarDadosAbaEmailsCorporativos();
    };
    DashboardController.prototype.carregarDadosMuralAvisos = function () {
        var _this = this;
        this.dashboardApiService.consultar().then(function (response) {
            _this.dto = response;
            if (_this.dto.acao.usuarioTemCredenciamentoSCRD) {
                _this.possuiAuthoritySCRD = _this.dto.acao.usuarioTemCredenciamentoSCRD;
                _this.abas.MURAL_AVISOS.visibilidade(true);
                _this.abas.EMAIL_CORPORATIVO.visibilidade(true);
                _this.ativarAbaMuralAvisos(_this.abas.MURAL_AVISOS);
                _this.apresentarAvisos = _this.dto.avisos.length > 0;
                _this.apresentarMensagens = _this.dto.mensagens.length > 0;
                _this.apresentaAgendaES = _this.dto.acao.podeVisualizarAgendaES;
                _this.carregarDadosAgendaES();
            }
        });
    };
    DashboardController.prototype.carregarDadosAbaEmailsCorporativos = function () {
        var _this = this;
        var consultaIncialFiltro = {
            parametroConsultaTexto: ConverterParameterObjectToUrlUtils.string("")
        };
        this.dashboardApiService.consultarEmailsCorporativosPorSistemaNegocio(consultaIncialFiltro).then(function (response) {
            _this.item = response.data;
            _this.dadosFormulario = {
                texto: _this.$state.params.texto
            };
            _this.navegarNaGridEmailsCorporativos(_this.dadosFormulario, {
                number: ConverterParameterUrlToObjectUtils.number(_this.$state.params.numeroPagina),
                size: ConverterParameterUrlToObjectUtils.number(_this.$state.params.quantidadePorPagina),
                sortField: _this.$state.params.ordenacaoCampo,
                sortDirection: _this.$state.params.ordenacaoDirecao
            });
        });
    };
    DashboardController.prototype.ativarAbaMuralAvisos = function (aba) {
        this.abas.ativar(aba);
    };
    DashboardController.prototype.carregarDadosAgendaES = function () {
        var _this = this;
        if (this.apresentaAgendaES) {
            this.abas.AGENDA_ES.visibilidade(true);
            this.agendaEsApiService.consultar().then(function (response) {
                _this.agendaESResultado = response;
                _this.existeDataLimiteEntregaHoje = _this.agendaESResultado.existeEntregaDiaDeHoje;
            });
        }
    };
    DashboardController.prototype.navegarNaGridEmailsCorporativos = function (dadosFormulario, pagination) {
        var items = this.filterItems(this.item ? this.item.emailsCorporativosPorSistemaNegocio : [], dadosFormulario);
        this.sortItems(items, pagination);
        this.emailsCorporativosPorSistemaNegocio = new Pagina(PaginaUtil.paginaContent(items, pagination), items.length, pagination.number || 0, pagination.size || 10, { direction: pagination.sortDirection, field: pagination.sortField });
    };
    DashboardController.prototype.filterItems = function (items, dadosFormulario) {
        var arrayTexto = dadosFormulario.texto ? dadosFormulario.texto.split(' ') : [];
        return items.filter(function (i) {
            return !dadosFormulario.texto ? true :
                i.documentosAssociados.some(function (doc) {
                    return arrayTexto.some(function (t) {
                        return doc.codigo.match(new RegExp(t, 'gi'));
                    });
                });
        });
    };
    DashboardController.prototype.sortItems = function (items, pagination) {
        var crescente = 'ASC' === pagination.sortDirection;
        var field = pagination.sortField;
        items.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(field ? (crescente ? lhs[field] : rhs[field]) : null, field ? (crescente ? rhs[field] : lhs[field]) : null)
            .append(lhs.siglaSistemaNegocio, rhs.siglaSistemaNegocio)
            .build(); });
    };
    DashboardController.prototype.observerChangeDadosFormulario = function (dadosFormulario) {
        this.navegarNaGridEmailsCorporativos(dadosFormulario, { number: 0, size: this.$state.params.quantidadePorPagina });
    };
    DashboardController.prototype.ativarAbaAgendaEs = function (aba) {
        this.abas.ativar(aba);
    };
    DashboardController.prototype.ativarAbaEmailCorporativo = function (aba) {
        this.abas.ativar(aba);
    };
    return DashboardController;
}());
DashboardController.$inject = ['$state', '$rootScope', 'feedbackService', '$location', 'DashboardApiService', 'AgendaEsApiService'];
angular.module('crd').controller('DashboardController', DashboardController);
//# sourceMappingURL=dashboard-controller.js.map;
"use strict";
//# sourceMappingURL=dashboard-aba-emails-corporativos-dto.js.map;
"use strict";
//# sourceMappingURL=dashboard-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DashboardApiService = (function (_super) {
    __extends(DashboardApiService, _super);
    function DashboardApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    DashboardApiService.prototype.consultar = function () {
        return this.buscarRecurso('/dashboard/mural-avisos').then(function (response) {
            if (!response.data) {
                return response;
            }
            return response.data;
        });
    };
    DashboardApiService.prototype.consultarEmailsCorporativosPorSistemaNegocio = function (consultaFiltro) {
        return this.buscarRecurso("/dashboard/emails-corporativos/", consultaFiltro);
    };
    DashboardApiService.prototype.consultarDadosAgendaES = function () {
        return this.buscarRecurso("/agenda-es/consultar/");
    };
    return DashboardApiService;
}(AbstractAPISerivce));
DashboardApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('DashboardApiService', DashboardApiService);
//# sourceMappingURL=dashboard-api-service.js.map;
"use strict";
var DispensaAlterarController = (function () {
    function DispensaAlterarController($location, $state, dispensaApiService, feedbackService, moment, $uibModal, $scope) {
        this.$location = $location;
        this.$state = $state;
        this.dispensaApiService = dispensaApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.CREATED = 201;
        this.OK = 200;
        this.DATA_BASE = 2;
        this.bloquearDataFim = false;
        this.podeAlterarData = false;
    }
    DispensaAlterarController.prototype.carregarDadosTela = function (id) {
        var _this = this;
        return this.dispensaApiService.detalhar(id).then(function (dispensaResource) {
            _this.dispensa = dispensaResource;
            _this.podeAlterarDataFim(_this.dispensa);
            _this.isBloquearDataFim(_this.dispensa.documento ? _this.dispensa.documento : null);
            return dispensaResource;
        });
    };
    DispensaAlterarController.prototype.isBloquearDataFim = function (documento) {
        if (documento.tipoDispensa.codigo == this.DATA_BASE) {
            this.bloquearDataFim = true;
        }
        else {
            this.bloquearDataFim = false;
        }
    };
    DispensaAlterarController.prototype.podeAlterarDataFim = function (dispensa) {
        if (dispensa.periodo != null && dispensa.periodo.fim == null) {
            this.podeAlterarData = true;
        }
        else {
            this.podeAlterarData = false;
        }
    };
    DispensaAlterarController.prototype.validarDadosEntrada = function (dispensa) {
        var _this = this;
        var dispensaFormatada = this.tratarParametros(dispensa);
        return this.dispensaApiService.validar(dispensaFormatada).then(function (response) {
            if (response.status == _this.OK) {
                _this.feedbackService.limpar();
                _this.open(dispensaFormatada);
            }
            return response;
        });
    };
    DispensaAlterarController.prototype.open = function (dispensaFormatada) {
        this.$scope.dispensa = dispensaFormatada;
        this.$scope.titulo = this.$state.current.informacaoPagina.outros.labelConfirma;
        this.$scope.acao = "alterar";
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'views/dispensa/dispensa-confirmar-dispensa-tpl.html',
            controller: 'DispensaConfirmarDispensaController',
            controllerAs: 'dispensaConfirmarDispensaCtrl',
            bindToController: true,
            keyboard: true,
            scope: this.$scope
        });
    };
    DispensaAlterarController.prototype.tratarParametros = function (dispensa) {
        return {
            pk: dispensa.pk,
            motivo: dispensa.motivo,
            documento: {
                pk: dispensa.documento ? dispensa.documento.pk : undefined
            },
            idBacen: dispensa.idBacen ? dispensa.idBacen : undefined,
            periodo: {
                inicio: dispensa.periodo ? this.moment(dispensa.periodo.inicio).format('YYYY-MM-DD') : undefined,
                fim: this.getDataFim(dispensa.periodo)
            },
            sistemaNegocio: {
                pk: this.getSistemaNegocio(dispensa)
            }
        };
    };
    DispensaAlterarController.prototype.getSistemaNegocio = function (dispensa) {
        if (dispensa.documento != null && dispensa.documento.sistemaNegocio != null) {
            return dispensa.documento.sistemaNegocio.pk;
        }
        return undefined;
    };
    DispensaAlterarController.prototype.getDataFim = function (periodo) {
        if (periodo != null && (periodo.fim != null && periodo.fim != undefined)) {
            return this.moment(periodo.fim).format('YYYY-MM-DD');
        }
        return "";
    };
    DispensaAlterarController.prototype.voltar = function () {
        this.$location.path(this.$state.current.informacaoPagina.outros.acoes.voltar);
    };
    DispensaAlterarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.id);
    };
    ;
    return DispensaAlterarController;
}());
DispensaAlterarController.$inject = ['$location', '$state', 'dispensaApiService', 'feedbackService', 'moment', '$uibModal', '$scope'];
angular.module('crd').controller('DispensaAlterarController', DispensaAlterarController);
//# sourceMappingURL=dispensa-alterar-controller.js.map;
(function(angular, conversor) {
  'use strict';

  angular
    .module('crd')
    .controller('DispensaConfirmarDispensaController', DispensaConfirmarDispensaController);

  DispensaConfirmarDispensaController.$inject = ['$location', '$uibModalInstance', '$state', 'dispensaApiService', 'feedbackService'];

  function DispensaConfirmarDispensaController($location, $uibModalInstance, $state, dispensaApiService, feedbackService) {
    var vm = this;
    var CREATED = 201;
    vm.mensagem = null;
    vm.cancel = cancelar;
    vm.salvar = salvar;
    vm.voltar = voltar;

    init();

    function init() {
      confirmar();
    }

    function confirmar() {

      var dispensaUrl = parametrosUrl(vm.dispensa);

      return dispensaApiService.confirmar(dispensaUrl).then(function(resource) {
        vm.mensagem = resource.confirmacaoDispensa.split("\n");
      });
    }

    function parametrosUrl(dispensa) {
      if (vm.acao === 'desativar') {
        return {
          acao: vm.acao,
          pk: dispensa.pk ? dispensa.pk : null
        };
      }
      return {
        acao: vm.acao,
        dataFim: dispensa.periodo ? conversor.dateToString(dispensa.periodo.fim) : null,
        dataInicio: dispensa.periodo ? conversor.dateToString(dispensa.periodo.inicio) : null,
        documentoPk: dispensa.documento ? dispensa.documento.pk : null,
        instituicao: dispensa.idBacen ? dispensa.idBacen : null,
        pk: dispensa.pk ? dispensa.pk : null,
        sistemaNegocioPk: dispensa.sistemaNegocio ? dispensa.sistemaNegocio.pk : null,
        isDocumentoZerado: $state.current.informacaoPagina.outros.isDocumentoZerado
      };
    }

    function salvar() {

      if (vm.acao === 'incluir') {
        dispensaApiService.incluir(vm.dispensa).then(function(response) {
          if (response.status === CREATED) {
            voltar();
            feedbackService.sucesso('Informação de documento salva com sucesso!');
          } else {
            feedbackService.violacoes(response.data);
          }
        });
      } else if (vm.acao === 'desativar') {
        dispensaApiService.desativar(vm.dispensa.pk).then(function(response) {
          if (response.status === CREATED) {
            $uibModalInstance.close();
            voltar();
            feedbackService.sucesso('Informação de documento desativada com sucesso!');
          } else {
            feedbackService.violacoes(response.data);
          }
        });
      } else if (vm.acao === 'alterar') {
        dispensaApiService.alterar(vm.dispensa.pk, vm.dispensa).then(function(response) {
          if (response.status === CREATED) {
            voltar();
            feedbackService.sucesso('Informação de documento salva com sucesso!');
          } else {
            feedbackService.violacoes(response.data);
          }
        });
      }
    }

    function voltar() {
      $location.path($state.current.informacaoPagina.outros.acoes.voltar);
    }

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})(angular, CRDUtils.Conversor);
;
"use strict";
var DispensaDetalharController = (function () {
    function DispensaDetalharController($location, $state, dispensaApiService, feedbackService, moment, $uibModal, $scope) {
        this.$location = $location;
        this.$state = $state;
        this.dispensaApiService = dispensaApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.bloquearDataFim = false;
        this.DATA_BASE = 2;
    }
    DispensaDetalharController.prototype.carregarDadosTela = function (id) {
        var _this = this;
        return this.dispensaApiService.detalhar(id).then(function (dispensaResource) {
            _this.dispensa = dispensaResource;
            _this.isBloquearDataFim(_this.dispensa.documento ? _this.dispensa.documento : null);
            return dispensaResource;
        });
    };
    DispensaDetalharController.prototype.isBloquearDataFim = function (documento) {
        if (documento.tipoDispensa.codigo == this.DATA_BASE) {
            this.bloquearDataFim = true;
        }
        else {
            this.bloquearDataFim = false;
        }
    };
    DispensaDetalharController.prototype.open = function (dispensaFormatada) {
        this.$scope.dispensa = this.tratarParametros(dispensaFormatada);
        this.$scope.titulo = this.$state.current.informacaoPagina.outros.acoes.desativar;
        this.$scope.acao = "desativar";
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'views/dispensa/dispensa-confirmar-dispensa-tpl.html',
            controller: 'DispensaConfirmarDispensaController',
            controllerAs: 'dispensaConfirmarDispensaCtrl',
            bindToController: true,
            keyboard: true,
            scope: this.$scope
        });
    };
    DispensaDetalharController.prototype.tratarParametros = function (dispensa) {
        var dispensaFormatada = {
            pk: dispensa.pk
        };
        return dispensaFormatada;
    };
    DispensaDetalharController.prototype.isPodeExibirLinkDesativar = function (dispensa) {
        if (dispensa != null && dispensa._links['crd-entidade-supervisionada-dispensada-desativar']) {
            return true;
        }
        return false;
    };
    DispensaDetalharController.prototype.isPodeExibirLinkAlterar = function (dispensa) {
        if (dispensa != null && dispensa._links['crd-entidade-supervisionada-dispensada-alterar']) {
            return true;
        }
        return false;
    };
    DispensaDetalharController.prototype.voltar = function () {
        this.$location.path(this.$state.current.informacaoPagina.outros.acoes.voltar);
    };
    DispensaDetalharController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.id);
    };
    ;
    return DispensaDetalharController;
}());
DispensaDetalharController.$inject = ['$location', '$state', 'dispensaApiService', 'feedbackService', 'moment', '$uibModal', '$scope'];
angular.module('crd').controller('DispensaDetalharController', DispensaDetalharController);
//# sourceMappingURL=dispensa-detalhar-controller.js.map;
"use strict";
var DispensaIncluirController = (function () {
    function DispensaIncluirController($location, $state, dispensaApiService, feedbackService, moment, $uibModal, $scope) {
        this.$location = $location;
        this.$state = $state;
        this.dispensaApiService = dispensaApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.CREATED = 201;
        this.OK = 200;
        this.DATA_BASE = 2;
        this.bloquearDataFim = false;
        this.exibeModal = false;
    }
    DispensaIncluirController.prototype.carregarDadosTela = function () {
        var _this = this;
        var isDocumentoZerado = this.$state.current.name.indexOf('documento-zerado') !== -1;
        return this.dispensaApiService.montarTelaIncluir(isDocumentoZerado).then(function (montarTelaResource) {
            _this.dadosFormulario = montarTelaResource;
            return montarTelaResource;
        });
    };
    DispensaIncluirController.prototype.validarDocumentos = function (dispensa) {
        return this.validarDocumentoOUInstituicaoPreenchido(dispensa);
    };
    DispensaIncluirController.prototype.validarInstituicao = function (dispensa) {
        return this.validarDocumentoOUInstituicaoPreenchido(dispensa);
    };
    DispensaIncluirController.prototype.validarDocumentoOUInstituicaoPreenchido = function (dispensa) {
        if (dispensa != null && (!dispensa.instituicao && !dispensa.documento)) {
            return false;
        }
        return true;
    };
    DispensaIncluirController.prototype.isBloquearDataFim = function (documento) {
        if (documento.tipoDispensa.codigo == this.DATA_BASE) {
            this.bloquearDataFim = true;
        }
        else {
            this.bloquearDataFim = false;
        }
    };
    DispensaIncluirController.prototype.validarDadosEntrada = function (dispensa) {
        var _this = this;
        var dispensaFormatada = this.tratarParametros(dispensa);
        return this.dispensaApiService.validar(dispensaFormatada).then(function (response) {
            if (response.status == _this.OK) {
                _this.feedbackService.limpar();
                _this.open(dispensaFormatada);
            }
            return response;
        });
    };
    DispensaIncluirController.prototype.open = function (dispensaFormatada) {
        this.$scope.dispensa = dispensaFormatada;
        this.$scope.titulo = this.$state.current.informacaoPagina.outros.labelConfirma;
        this.$scope.acao = "incluir";
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'views/dispensa/dispensa-confirmar-dispensa-tpl.html',
            controller: 'DispensaConfirmarDispensaController',
            controllerAs: 'dispensaConfirmarDispensaCtrl',
            bindToController: true,
            keyboard: true,
            scope: this.$scope
        });
    };
    DispensaIncluirController.prototype.tratarParametros = function (dispensa) {
        return {
            motivo: dispensa.motivo,
            documento: {
                pk: dispensa.documento ? dispensa.documento.pk : undefined
            },
            idBacen: dispensa.instituicao ? dispensa.instituicao.idBacen : undefined,
            periodo: {
                inicio: dispensa.periodo ? ConverterParameterObjectToUrlUtils.date(dispensa.periodo.inicio) : null,
                fim: dispensa.periodo ? ConverterParameterObjectToUrlUtils.date(dispensa.periodo.fim) : null
            },
            sistemaNegocio: {
                pk: dispensa.sistemaNegocio ? dispensa.sistemaNegocio.pk : undefined,
                acessoRestrito: dispensa.sistemaNegocio ? dispensa.sistemaNegocio.acessoRestrito : undefined
            },
            isDocumentoZerado: this.$state.current.informacaoPagina.outros.isDocumentoZerado
        };
    };
    DispensaIncluirController.prototype.voltar = function () {
        this.$location.path(this.$state.current.informacaoPagina.outros.acoes.voltar);
    };
    DispensaIncluirController.prototype.$onInit = function () {
        return this.carregarDadosTela();
    };
    ;
    return DispensaIncluirController;
}());
DispensaIncluirController.$inject = ['$location', '$state', 'dispensaApiService', 'feedbackService', 'moment', '$uibModal', '$scope'];
angular.module('crd').controller('DispensaIncluirController', DispensaIncluirController);
//# sourceMappingURL=dispensa-incluir-controller.js.map;
"use strict";
var DispensaListarController = (function () {
    function DispensaListarController($location, $state, dispensaApiService, moment, feedbackService, $uibModal, $scope, sistemaNegocioApiService, documentoApiService) {
        this.$location = $location;
        this.$state = $state;
        this.dispensaApiService = dispensaApiService;
        this.moment = moment;
        this.feedbackService = feedbackService;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.documentoApiService = documentoApiService;
        this.resultadoVisivel = false;
        this.resultadoHasContent = false;
        this.formularioVisivel = true;
        this.podeIncluir = false;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    DispensaListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    DispensaListarController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    DispensaListarController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    DispensaListarController.prototype.validaPeriodo = function () {
        if (this.parametrosPesquisa && this.parametrosPesquisa.dataInicio && this.parametrosPesquisa.dataFim) {
            var periodoInicio = this.moment.utc(this.parametrosPesquisa.dataInicio);
            var periodoFim = this.moment.utc(this.parametrosPesquisa.dataFim);
            return !periodoInicio.isAfter(periodoFim);
        }
        return true;
    };
    DispensaListarController.prototype.gerarXLS = function (parametrosPesquisa) {
        var _this = this;
        var filtro = this.converterParametrosParaUrl(parametrosPesquisa);
        return this.dispensaApiService.gerarXlsx(filtro).then(function (relatorioExcel) {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return relatorioExcel;
        });
    };
    DispensaListarController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.dispensaApiService.montarTelaPesquisar().then(function (montarTelaResource) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            if (!jaPossuiParametrosInformados) {
                _this.parametrosPesquisa.situacaoDispensa = ConverterParameterUrlToObjectUtils.atributoEnumName('ATIVA');
                _this.parametrosPesquisa.grupoPeriodicidade = 'MENSAL_OU_MAIOR';
            }
            _this.dadosFormulario = montarTelaResource;
            _this.podeIncluir = montarTelaResource._links['crd-entidade-supervisionada-dispensada-montar-incluir'];
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            _this.carregarSistemaNegocio(_this.parametrosPesquisa.grupoPeriodicidade);
            _this.carregarDocumentos(_this.parametrosPesquisa.grupoPeriodicidade, _this.parametrosPesquisa.sistemaNegocio);
            return montarTelaResource;
        });
    };
    DispensaListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            dataFim: ConverterParameterUrlToObjectUtils.date(filtro.dataFim),
            dataInicio: ConverterParameterUrlToObjectUtils.date(filtro.dataInicio),
            documento: ConverterParameterUrlToObjectUtils.atributoPK(filtro.documento),
            grupoPeriodicidade: ConverterParameterUrlToObjectUtils.string(filtro.grupoPeriodicidade),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            sistemaNegocio: ConverterParameterUrlToObjectUtils.atributoPK(filtro.sistemaNegocio),
            situacaoDispensa: ConverterParameterUrlToObjectUtils.atributoEnumName(filtro.situacaoDispensa),
            jaPesquisado: ConverterParameterUrlToObjectUtils.boolean(filtro.jaPesquisado),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao),
            isDocumentoZerado: this.$state.current.informacaoPagina.outros.isDocumentoZerado
        };
    };
    DispensaListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var dataFim = this.opcoesDeData.normatizar(parametrosPesquisa.dataFim);
        return {
            dataFim: ConverterParameterObjectToUrlUtils.date(dataFim),
            dataInicio: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataInicio),
            documento: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.documento),
            grupoPeriodicidade: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.grupoPeriodicidade),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.sistemaNegocio),
            situacaoDispensa: ConverterParameterObjectToUrlUtils.atributoEnumName(parametrosPesquisa.situacaoDispensa),
            jaPesquisado: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.jaPesquisado),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao),
            isDocumentoZerado: this.$state.current.informacaoPagina.outros.isDocumentoZerado
        };
    };
    DispensaListarController.prototype.openModalConfirmaDispensa = function (pk) {
        var _this = this;
        this.$scope.dispensa = { pk: pk };
        this.$scope.titulo = this.$state.current.informacaoPagina.outros.acoes.desativar;
        this.$scope.acao = "desativar";
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'views/dispensa/dispensa-confirmar-dispensa-tpl.html',
            controller: 'DispensaConfirmarDispensaController',
            controllerAs: 'dispensaConfirmarDispensaCtrl',
            bindToController: true,
            keyboard: true,
            size: 'md',
            scope: this.$scope
        }).result
            .then(function (resultado) {
            _this.pesquisar(_this.parametrosPesquisa);
        });
    };
    DispensaListarController.prototype.tratarParametros = function (dispensa) {
        return {
            pk: dispensa.pk ? dispensa.pk : undefined
        };
    };
    DispensaListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    DispensaListarController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        parametrosPesquisa.jaPesquisado = true;
        return this.pesquisar(parametrosPesquisa);
    };
    DispensaListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.dispensaApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    DispensaListarController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.grupoPeriodicidade = 'MENSAL_OU_MAIOR';
        this.parametrosPesquisa.sistemaNegocio = undefined;
        this.parametrosPesquisa.documento = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.dataInicio = undefined;
        this.parametrosPesquisa.dataFim = undefined;
        this.parametrosPesquisa.situacaoDispensa = undefined;
        this.checarMudancaPeriodicidade(this.parametrosPesquisa.grupoPeriodicidade);
        this.carregarSistemaNegocio(this.parametrosPesquisa.grupoPeriodicidade);
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    DispensaListarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params);
    };
    ;
    DispensaListarController.prototype.checarMudancaPeriodicidade = function (valor) {
        if (this.tempPeriodicidadeSelecionada !== valor) {
            this.esconderResultadoPesquisa();
            this.parametrosPesquisa.sistemaNegocio = undefined;
            this.parametrosPesquisa.documento = undefined;
            this.dadosFormulario.documentos.length = 0;
            this.parametrosPesquisa.dataInicio = undefined;
            this.parametrosPesquisa.dataFim = undefined;
            this.limparMensagens();
        }
        this.tempPeriodicidadeSelecionada = valor;
    };
    DispensaListarController.prototype.carregarSistemaNegocio = function (grupoPeriodicidade) {
        var _this = this;
        var parametros = {
            grupoPeriodicidade: grupoPeriodicidade,
            quantidadePorPagina: 99999
        };
        this.changeOpcoesDeData(grupoPeriodicidade);
        return this.sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (resource) {
            _this.dadosFormulario.sistemasNegocio.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.sistemasNegocio, resource.data.content);
            return resource;
        });
    };
    DispensaListarController.prototype.carregarDocumentos = function (grupoPeriodicidade, sistemaNegocio) {
        var _this = this;
        if (!sistemaNegocio || _.isEmpty(sistemaNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        var parametros = {
            periodicidade: grupoPeriodicidade === 'MENSAL_OU_MAIOR' ? 'MENSAL' : 'DIARIA',
            sistemaNegocioPks: sistemaNegocio.pk
        };
        this.documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, resource.data._embedded.resultado);
            return resource;
        });
    };
    DispensaListarController.prototype.changeOpcoesDeData = function (grupoPeriodicidade) {
        if (grupoPeriodicidade === 'MENOR_QUE_MENSAL') {
            this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        }
        else {
            this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
        }
    };
    return DispensaListarController;
}());
DispensaListarController.$inject = ['$location', '$state', 'dispensaApiService',
    'moment', 'feedbackService', '$uibModal', '$scope', 'sistemaNegocioApiService', 'documentoApiService'];
angular.module('crd').controller('DispensaListarController', DispensaListarController);
//# sourceMappingURL=dispensa-listar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdListaExcecaoCodigo', CrdListaExcecaoCodigo);

  function CrdListaExcecaoCodigo() {
    var directive = {
      restrict: 'EA',
      scope: {
        crdListaExcecaoCodigo: '='
      },
      templateUrl: 'views/documento-nao-entregue/crd-lista-excecao-codigo-tpl.html',
      terminate: true
    };

    return directive;
  }
})(angular);
;
(function(angular, parametrosUrl) {
  'use strict';

  var SUB_STRING_PREFIX = 2;

  angular
    .module('crd')
    .controller('CrdModalDocumentoNaoEntregueDetalheController', CrdModalDocumentoNaoEntregueDetalheController);

  CrdModalDocumentoNaoEntregueDetalheController.$inject = ['$scope', '$uibModalInstance', 'documentoNaoEntregueApiService'];

  function CrdModalDocumentoNaoEntregueDetalheController($scope, $uibModalInstance, documentoNaoEntregueApiService) {
    var vm = this;
    vm.isDocumentoImpedido = $scope.parametrosPesquisa.situacoesDocumentosEsperados.includes("IMPEDIDO");
    vm.cancel = cancel;
    vm.listaExcecoesFormatada = listaExcecoesFormatada;
    vm.tituloModal =  vm.isDocumentoImpedido ? "Datas-base impedidas" : "Datas-base não entregues";
    vm.textoDataCobranca = vm.isDocumentoImpedido ? "Data do impedimento" : "Data de início de cobrança";
    pesquisar();
    function pesquisar() {
      var parameters = montarParametrosDaUrl($scope.parametrosPesquisa, $scope.documentoNaoEntregue);
      parameters.pkProcessamento = $scope.pkProcessamento;
      return documentoNaoEntregueApiService
        .pesquisarDocumentoNaoEntregueDetalhe(parameters)
        .then(successOnTelaPesquisar);
    }

    function successOnTelaPesquisar(resource) {
      vm.itens = resource._embedded.resultado;
      vm.exibirColunaIdentificadorEventual = _.reduce(resource._embedded.resultado, function(memo, doc) { return memo || !_.isEmpty(doc.identificadorEventual)}, false);
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function listaExcecoesFormatada(atrasoExcecao) {
      var retorno = '';
      for (var i = 0; i < atrasoExcecao.length; i++) {
        retorno = retorno.concat(', ', atrasoExcecao[i].excecao.codigo);
      }
      return retorno.substring(SUB_STRING_PREFIX);
    }
  }

  function montarParametrosDaUrl(parametrosPesquisa, documentoNaoEntregue) {
    var criador = parametrosUrl.Criador;
    return {
      cobranca: parametrosPesquisa.cobranca ? parametrosPesquisa.cobranca.codigo : null,
      documentoPk: documentoNaoEntregue.documento.pk,
      documentos: criador.arrayPk(parametrosPesquisa.documentos),
      excecoes: parametrosPesquisa.excecoes ? parametrosPesquisa.excecoes : null,
      idBacen: documentoNaoEntregue.idBacen,
      segmentos: criador.arrayCodigo(parametrosPesquisa.segmentos),
      sistemasNegocio: criador.arrayPk(parametrosPesquisa.sistemasNegocio)
    };
  }
})(angular, CRDUtils.ParametrosUrl);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('crdModalDocumentoNaoEntregueDetalhe', CrdModalDocumentoNaoEntregueDetalhe);

  CrdModalDocumentoNaoEntregueDetalhe.$inject = ['$uibModal'];

  function CrdModalDocumentoNaoEntregueDetalhe($uibModal) {
    var directive = {
      link: postLink,
      restrict: 'A',
      scope: {
        documentoNaoEntregue: '=',
        pkProcessamento: '=',
        parametrosPesquisa: '='
      }
    };

    return directive;

    function postLink($scope, $element) {
      $element.bind('click', function() {
        $uibModal.open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          controller: 'CrdModalDocumentoNaoEntregueDetalheController',
          controllerAs: 'crdModalDocumentoNaoEntregueDetalheCtrl',
          keyboard: false,
          scope: $scope,
          templateUrl: 'views/documento-nao-entregue/crd-modal-documento-nao-entregue-detalhe-tpl.html'
        });
      });
    }
  }
})(angular);
;
(function(angular, moment, $, parametrosUrl, HttpStatus) {
  'use strict';

  var COLUNA_SELECIONE = 1;
  var COLUNA_ENVIADO_HOJE = 2;
  var DRAW = 0;
  var ORDER = 2;
  var START = 3;
  var LENGTH = 4;
  var RETORNO_NEGATIVO = -1;
  var RETORNO_POSITIVO = 1;
  var DISPLAY_LENGTH = 30;

  angular
    .module('crd')
    .controller('DocumentoNaoEntregueImpedidoListarController', DocumentoNaoEntregueImpedidoListarController);

  DocumentoNaoEntregueImpedidoListarController.$inject = [
    '$compile',
    '$location',
    '$stateParams',
    '$scope',
    'documentoNaoEntregueImpedidoApiService',
    'cobrancaApiService',
    'constantes',
    'DTColumnBuilder',
    'DTOptionsBuilder',
    'feedbackService'
  ];

  function DocumentoNaoEntregueImpedidoListarController(
    $compile,
    $location,
    $stateParams,
    $scope,
    documentoNaoEntregueImpedidoApiService,
    cobrancaApiService,
    constantes,
    DTColumnBuilder,
    DTOptionsBuilder,
    feedbackService
  ) {
    var vm = this;
    var self = $scope;
    var exibeLabelDocNPara = false;
    var exibeLabelESPendCan = false;
    var exibeLabelESCancelada = false;
    const SITUACOES_EXIBIDAS_NA_TELA = ["IMPEDIDO"];


    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.exibeLabelDocNPara = exibeLabelDocNPara;
    vm.exibeLabelESPendCan = exibeLabelESPendCan;
    vm.exibeLabelESCancelada = exibeLabelESCancelada;
    vm.updateSelection = updateSelection;
    vm.isSelected = isSelected;
    vm.isSelectedAll = isSelectedAll;
    vm.selectAll = selectAll;
    vm.dtInstanceCallback = dtInstanceCallback;
    vm.geradoAvulsoComSucesso = geradoAvulsoComSucesso;
    vm.limparMensagens = limparMensagens;
    vm.gerarCobrancaEmLote = gerarCobrancaEmLote;
    vm.pesquisarXLSX = pesquisarXLSX;

    inicializarView();
    reset();
    esconderResultadoPesquisa();
    carregarTela();

    function inicializarView() {
      vm.msgConfirmacao = '';
      vm.view = {
        formulario: {
          visivel: true
        },
        resultado: {
          visivel: false
        }
      };
      vm.simNao = [{
        codigo: true,
        descricao: 'Sim'
      }, {
        codigo: false,
        descricao: 'Não'
      }];
      vm.dtColumns = criarColunas();
    }

    function adicionarMensagemConfirmacao(quantidade) {
      vm.msgConfirmacao =
        quantidade === 1
          ? 'Confirma o envio de correio eletrônico e e-mail para 1 linha selecionada?'
          : 'Confirma o envio de correio eletrônico e e-mail para ' + quantidade + ' linhas selecionadas?';
    }

    function criarColunas() {
      var colunaIndice = DTColumnBuilder
        .newColumn(null)
        .notSortable()
        .renderWith(htmlColunaIndice);

      var colunaEnviadoHoje = DTColumnBuilder
        .newColumn(null)
        .renderWith(htmlColunaCobrancaEnviadaHoje)
        .withClass('text-center');

      var colunaDocumentoCodigo = DTColumnBuilder
        .newColumn(null)
        .renderWith(htmlColunaDocumentoCodigo)
        .withClass('text-center');

      var colunaInstituicao = DTColumnBuilder
        .newColumn(null)
        .renderWith(htmlColunaInstituicao)
        .withClass('text-center');

      var colunaAcoes = DTColumnBuilder
        .newColumn(null)
        .notSortable()
        .renderWith(htmlColunaAcoes)
        .withClass('coluna-acoes');

      return [
        colunaIndice,
        colunaEnviadoHoje,
        DTColumnBuilder.newColumn('siglaSistemaNegocio').withClass('text-center'),
        colunaDocumentoCodigo,
        DTColumnBuilder.newColumn('nomeSegmento'),
        colunaInstituicao,
        DTColumnBuilder.newColumn('instituicao.nome'),
        DTColumnBuilder.newColumn('qtdDataBaseAtraso'),
        colunaAcoes
      ];
    }

    function reset() {
      vm.parametrosPesquisa = {
        cobranca: null,
        documento: [],
        excecoes: [],
        instituicao: null,
        segmento: [],
        sistemasNegocio: [],
        situacoesDocumentosEsperados: SITUACOES_EXIBIDAS_NA_TELA
      };
      vm.documentosNaoEntregues = [];
      vm.selecioneTodos = false;
      vm.selected = [];
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function carregarTela() {
      return documentoNaoEntregueImpedidoApiService
        .telaPesquisar()
        .then(successOnTelaPesquisar);

      function successOnTelaPesquisar(resource) {
        vm.dataAtual = moment(new Date()).format('DD/MM/YYYY');
        vm.sistemasNegocio = resource.dadosFormularioPesquisa.sistemasNegocio;
        vm.segmentos = resource.dadosFormularioPesquisa.segmentos;
        vm.excecoes = resource.dadosFormularioPesquisa.excecoes;
        vm.isCobranca = resource.curadorMaster || resource.curador;

        vm.cabecalho = resource.cabecalhoDocumentoNaoEntregue;
        
        if (_.compact(_.values($stateParams)).length) {
          extrairParametrosDaUrl($stateParams);
          pesquisar(vm.parametrosPesquisa);
        } else {
          preencherParametrosPesquisaInicial(resource.curador, resource.dadosFormularioPesquisa.sistemasNCurador);
          if (!resource.curadorMaster && resource.curador && resource.dadosFormularioPesquisa.sistemasNCurador.length > 0) {
            pesquisar(vm.parametrosPesquisa);
          }
        }
      }
    }

    function pesquisar() {
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);

      $location.search(parameters);
      parameters.pkProcessamento = vm.cabecalho.pkBatchControlarEntrega;
      parameters.situacoesDocumentosEsperados = SITUACOES_EXIBIDAS_NA_TELA
      return documentoNaoEntregueImpedidoApiService
        .pesquisarDocumentoNaoEntregue(parameters)
        .then(successOnPesquisar);

      function successOnPesquisar(resource) {
        vm.resultadoPesquisa = resource._embedded.resultado;
        vm.pseudodocumentoOuDadosAbertos = resource._parameters.pseudodocumentoOuDadosAbertos;
        prepararGridResultados();
        exibirResultadoPesquisa();
        vm.selecioneTodos = false;
        vm.selected = [];
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.sistemasNegocio = undefined;
      vm.parametrosPesquisa.documentos = undefined;
      vm.parametrosPesquisa.segmento = undefined;
      vm.parametrosPesquisa.instituicao = undefined;
      vm.parametrosPesquisa.excecoes = undefined;
      vm.parametrosPesquisa.cobranca = undefined;

      limparMensagens();
      esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function updateSelection($event, documentoNaoEntregue) {
      var checkbox = $event.target;
      var action = checkbox.checked ? 'add' : 'remove';
      if (action === 'add' && vm.selected.indexOf(documentoNaoEntregue) === RETORNO_NEGATIVO) {
        vm.selected.push(documentoNaoEntregue);
      }
      if (action === 'remove' && vm.selected.indexOf(documentoNaoEntregue) !== RETORNO_NEGATIVO) {
        vm.selected.splice(vm.selected.indexOf(documentoNaoEntregue), 1);
        vm.selecioneTodos = false;
      }
      adicionarMensagemConfirmacao(vm.selected.length);
    }

    function isSelected(documentoNaoEntregue) {
      return vm.selected.indexOf(documentoNaoEntregue) !== RETORNO_NEGATIVO;
    }

    function isSelectedAll() {
      return vm.selecioneTodos;
    }

    function selectAll($event) {
      var checkbox = $event.target;
      var action = checkbox.checked ? 'add' : 'remove';

      if (action === 'add') {
        for (var i in vm.resultadoPesquisa) {
          if (vm.selected.indexOf(vm.resultadoPesquisa[i]) === RETORNO_NEGATIVO && vm.resultadoPesquisa[i].cobrancaLote) {
            vm.selected.push(vm.resultadoPesquisa[i]);
          }
        }
        vm.selecioneTodos = true;
      } else if (action === 'remove') {
        vm.selected.splice(0, vm.selected.length);
        vm.selecioneTodos = false;
      }
      adicionarMensagemConfirmacao(vm.selected.length);
    }

    function dtInstanceCallback(dtInstance) {
      vm.dtInstance = dtInstance;
    }

    function geradoAvulsoComSucesso() {
      vm.selected = [];
      vm.pesquisar(vm.parametrosPesquisa);
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function gerarCobrancaEmLote() {
      var cobrancasSelecionadasComDestinatario = [];
      var cobrancasSelecionadasSemDestinatario = [];

      for (var i in vm.selected) {
        if (vm.selected[i].destinatariosEmail === null) {
          cobrancasSelecionadasSemDestinatario.push({
            documento: vm.selected[i].documento.pk,
            idBacen: vm.selected[i].idBacen
          });
        } else {
          cobrancasSelecionadasComDestinatario.push({
            documento: vm.selected[i].documento.pk,
            idBacen: vm.selected[i].idBacen
          });
        }
      }

      var filtro = montarParametrosDaUrl(vm.parametrosPesquisa);
      filtro.pkProcessamento = vm.ultimoBatchGerado.pk;
      filtro.situacoesDocumentosEsperados = SITUACOES_EXIBIDAS_NA_TELA
      return cobrancaApiService
        .gerarCobrancaEmLote(cobrancasSelecionadasComDestinatario, cobrancasSelecionadasSemDestinatario, filtro)
        .then(successOnGerarCobrancaEmLote);

      function successOnGerarCobrancaEmLote(response) {
        if (response.status === HttpStatus.CREATED) {
          vm.selected = [];
          vm.pesquisar(vm.parametrosPesquisa);

          mensagensInformativas(response.data);
        }
      }
    }

    function mensagensInformativas(data) {
      var obj = angular.fromJson(data);
      var erros = [];
      var sucessos = [];

      _.each(obj.mensagens, function(mensagem) {
        if (mensagem.type === 'ERROR') {
          erros.push(mensagem.content);
        } else {
          sucessos.push(mensagem.content);
        }
      });

      if (erros.length > 0) {
        feedbackService.erro(erros);
      } else {
        feedbackService.sucesso(sucessos);
      }
    }

    function pesquisarXLSX() {
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      parameters.pkProcessamento = vm.ultimoBatchGerado.pk;
      parameters.situacoesDocumentosEsperados = SITUACOES_EXIBIDAS_NA_TELA
      return documentoNaoEntregueImpedidoApiService.pesquisarDocumentoNaoEntregueXLSX(parameters).then(function successOnGerarXLS() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      });
    }

    function prepararGridResultados() {
      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('serverSide', true)
        .withFnServerData(serverData)
        .withDataProp('data')
        .withOption('createdRow', createdRow)
        .withDisplayLength(DISPLAY_LENGTH)
        .withOption('stateSaveParams', function(settings, data) {
          _.each(data.columns, function(column) {
            delete column.visible;
          });
        });

      if (!vm.isCobranca) {
        vm.dtColumns[COLUNA_SELECIONE].notVisible();
        vm.dtColumns[COLUNA_ENVIADO_HOJE].notVisible();
      }
    }

    function exibirResultadoPesquisa() {
      if(vm.dtInstance.DataTable){
        var rows = vm.dtInstance.DataTable.rows();
        rows.invalidate().draw();
        vm.view.resultado.visivel = true;
      }
    }

    function serverData(sSource, aoData, fnCallback) {
      var draw = aoData[DRAW].value;
      var order = aoData[ORDER].value;
      var start = draw === 1 ? 0 : aoData[START].value;
      var length = aoData[LENGTH].value;
      ordenarLista(order);
      var records = {
        data: vm.resultadoPesquisa.slice(start, start + length),
        draw: draw,
        recordsFiltered: vm.resultadoPesquisa.length,
        recordsTotal: vm.resultadoPesquisa.length
      };

      vm.exibeLabelDocNPara = false;
      vm.exibeLabelESPendCan = false;
      vm.exibeLabelESCancelada = false;

      formatarResultadoParaExibicao(records.data);

      fnCallback(records);

      self.$safeApply();
    }

    function elementosColuna() {
      var elementos = [];
      elementos.push({
        descColuna: 'sequencial'
      });
      elementos.push({
        descColuna: 'cobrancaLote'
      });
      elementos.push({
        descColuna: 'cobrancaEnviadaHoje'
      });
      elementos.push({
        descColuna: 'siglaSistemaNegocio'
      });
      elementos.push({
        descColuna: 'documento.codigo'
      });
      elementos.push({
        descColuna: 'nomeSegmento'
      });
      elementos.push({
        descColuna: 'instituicao.cnpjFormatado'
      });
      elementos.push({
        descColuna: 'instituicao.nome'
      });
      elementos.push({
        descColuna: 'qtdDataBaseAtraso'
      });
      elementos.push({
        descColuna: 'cobrancaAvulso'
      });
      return elementos;
    }

    function ordenarLista(order) {
      if (order.length > 0) {
        var elementos = elementosColuna();
        vm.resultadoPesquisa.sort(sortBy(elementos[order[0].column].descColuna, order[0].dir === 'asc'));
      }
    }

    function sortBy(field, reverse) {
      var reverso = reverse;

      function key(elemento) {
        if (field.split('.').length > 1) {
          var retorno = elemento;
          field.split('.').forEach(function(ind) {
            if (retorno !== null) {
              retorno = retorno[ind];
            }
          });
          return retorno === null ? '' : retorno;
        }
        return elemento[field] === null ? '' : elemento[field];
      }

      reverso = reverso ? RETORNO_NEGATIVO : RETORNO_POSITIVO;

      return function(primeiroCampo, segundoCampo) {
        var primeiroValor = primeiroCampo;
        var segundoValor = segundoCampo;
        return primeiroValor = key(primeiroValor),
          segundoValor = key(segundoValor), reverso * ((primeiroValor > segundoValor) - (segundoValor > primeiroValor));
      };
    }

    function formatarResultadoParaExibicao(resultado) {
      var idx = 1;

      // limpar as legendas
      vm.pseudodocumentoOuDadosAbertos.forEach(function(elemento) {
        elemento.deveMostrar = false;
      });

      vm.documentosNaoEntregues.splice(0, vm.documentosNaoEntregues.length);
      _.each(resultado, function(documentoNaoEntregue) {
        documentoNaoEntregue.id = idx;
        documentoNaoEntregue.documento.descCodigo = documentoNaoEntregue.documento.codigo;
        documentoNaoEntregue.instituicao.descCnpjFormatado = documentoNaoEntregue.instituicao.cnpjFormatado;

        if (documentoNaoEntregue.parametroCobranca === null) {
          documentoNaoEntregue.documento.descCodigo = s.insert(documentoNaoEntregue.documento.codigo, 0, '** ');
          documentoNaoEntregue.descAutomatica = null;
        } else {
          documentoNaoEntregue.descAutomatica = documentoNaoEntregue.parametroCobranca.automatica ? 'Sim' : 'Não';
        }

        if (documentoNaoEntregue.instituicaoPendenteCancelamento) {
          documentoNaoEntregue.instituicao.descCnpjFormatado = s.insert(documentoNaoEntregue.instituicao.descCnpjFormatado, 0, '* ');
        }

        if (documentoNaoEntregue.instituicaoCancelada) {
          documentoNaoEntregue.instituicao.descCnpjFormatado = s.insert(documentoNaoEntregue.instituicao.descCnpjFormatado, 0, '*** ');
        }

        if (documentoNaoEntregue.destinatariosEmail !== null) {
          documentoNaoEntregue.destinatariosEmail = documentoNaoEntregue.destinatariosEmail.split(',').join(', ');
        }

        // Verificar se essa linha do resultado está contida no parameters (documentos dados abertos ou sistema online)
        // preencher o campo presente na exibição

        if (documentoNaoEntregue.pseudodocumentoOuDadosAbertos) {
          var indice = vm.pseudodocumentoOuDadosAbertos.findIndex(function(elemento) {
            return elemento.pk === documentoNaoEntregue.documento.pk;
          });

          var deveMostrar = indice !== -1 ? true : false;
          vm.pseudodocumentoOuDadosAbertos[indice].deveMostrar = deveMostrar;
        }

        vm.documentosNaoEntregues[documentoNaoEntregue.id] = documentoNaoEntregue;
        idx += 1;
      });
    }

    function createdRow(row) {
      $compile(angular.element(row).contents())(self);
    }

    function htmlColunaIndice(data) {
      return String(data.id);
    }

    function htmlColunaCobrancaEnviadaHoje(data) {
      var html = '<span hidden="true">' + data.cobrancaEnviadaHoje + '</span>';

      if (data.cobrancaEnviadaHoje) {
        html += '<i class="fa fa-check verde" aria-hidden="true"></i>';
      }

      return html;
    }

    function htmlColunaDocumentoCodigo(data) {
      var html = data.documento.descCodigo + ' ';

      if (data.parametroCobranca === null) {
        vm.exibeLabelDocNPara = true;
      }

      return html;
    }

    function htmlColunaInstituicao(data) {
      var html = data.instituicao.descCnpjFormatado + ' ';

      if (data.instituicaoPendenteCancelamento) {
        vm.exibeLabelESPendCan = true;
      }

      if (data.instituicaoCancelada) {
        vm.exibeLabelESCancelada = true;
      }

      return html;
    }

    function htmlColunaAcoes(data) {
      var html = '';
      if (data.cobrancaAvulso && !data.documentoEsperadoEstaImpedido) {
        html += '<a class="btn btn-default btn-xs" title="Enviar comunicação avulsa" ';
        html += 'crd-modal-cobranca-avulsa-detalhe documento-nao-entregue="::documentoNaoEntregueImpedidoListarCtrl.documentosNaoEntregues[' + data.id + ']" ';
        html += 'parametros-pesquisa="::documentoNaoEntregueImpedidoListarCtrl.parametrosPesquisa" ';
        html += 'gerado-avulso-com-sucesso="documentoNaoEntregueImpedidoListarCtrl.geradoAvulsoComSucesso" ';
        html += 'pk-processamento="::documentoNaoEntregueImpedidoListarCtrl.ultimoBatchGerado.pk">';
        html += '<i class="fa fa-envelope-o fa-lg text-primary"></i></a>&nbsp;';
      }
      html += '<a ui-link-open-modal title="Visualizar datas-base" crd-modal-documento-nao-entregue-detalhe ';
      html += 'documento-nao-entregue="::documentoNaoEntregueImpedidoListarCtrl.documentosNaoEntregues[' + data.id + ']" ';
      html += 'parametros-pesquisa="::documentoNaoEntregueImpedidoListarCtrl.parametrosPesquisa" ';
      html += 'pk-processamento="::documentoNaoEntregueImpedidoListarCtrl.ultimoBatchGerado.pk">';
      html += '</a>';

      return html;
    }

    function preencherParametrosPesquisaInicial(curador, sistemasCurador) {
      reset();
      if (curador && sistemasCurador.length > 0) {
        for (var i in sistemasCurador) {
          vm.parametrosPesquisa.sistemasNegocio.push(sistemasCurador[i]);
        }
      }
    }

    function montarParametrosDaUrl(parametrosPesquisa) {
      var criador = parametrosUrl.Criador;

      return {
        cobranca: vm.parametrosPesquisa.cobranca ? vm.parametrosPesquisa.cobranca.codigo : null,
        documentos: criador.arrayPk(parametrosPesquisa.documentos),
        excecoes: vm.parametrosPesquisa.excecoes ? vm.parametrosPesquisa.excecoes : null,
        idBacen: criador.idBacen(parametrosPesquisa.instituicao),
        isPesquisaRealizada: true,
        segmentos: criador.arrayCodigo(parametrosPesquisa.segmento),
        sistemasNegocio: criador.arrayPk(parametrosPesquisa.sistemasNegocio)
      };
    }

    function extrairParametrosDaUrl(routeParams) {
      var extrator = parametrosUrl.Extrator;

      vm.parametrosPesquisa = {
        cobranca: routeParams.cobranca === null ? null : {
          codigo: routeParams.cobranca
        },
        documentos: extrator.arrayObjetoPk(routeParams.documentos),
        excecoes: [],
        instituicao: routeParams.idBacen ? {
          idBacen: routeParams.idBacen
        } : null,
        segmento: extrator.arrayObjetoCodigo(routeParams.segmentos),
        sistemasNegocio: extrator.arrayObjetoPk(routeParams.sistemasNegocio),
        situacoesDocumentosEsperados: SITUACOES_EXIBIDAS_NA_TELA,
      };

      if ($stateParams.excecoes) {
        if (angular.isArray($stateParams.excecoes)) {
          for (var indice in $stateParams.excecoes) {
            vm.parametrosPesquisa.excecoes.push($stateParams.excecoes[indice]);
          }
        } else {
          vm.parametrosPesquisa.excecoes.push($stateParams.excecoes);
        }
      }
    }

    self.$watch('documentoNaoEntregueImpedidoListarCtrl.parametrosPesquisa', function() {
      esconderResultadoPesquisa();
      limparMensagens();
    }, true);
  }
})(angular, moment, jQuery, CRDUtils.ParametrosUrl, httpStatusCode);
;
(function (angular, moment, $, parametrosUrl, HttpStatus) {
  'use strict';

  var COLUNA_SELECIONE = 1;
  var COLUNA_ENVIADO_HOJE = 2;
  var DRAW = 0;
  var ORDER = 2;
  var START = 3;
  var LENGTH = 4;
  var RETORNO_NEGATIVO = -1;
  var RETORNO_POSITIVO = 1;
  var DISPLAY_LENGTH = 30;

  angular
    .module('crd')
    .controller('DocumentoNaoEntregueListarController', DocumentoNaoEntregueListarController);

  DocumentoNaoEntregueListarController.$inject = [
    '$compile',
    '$location',
    '$stateParams',
    '$scope',
    'documentoNaoEntregueApiService',
    'cobrancaApiService',
    'constantes',
    'DTColumnBuilder',
    'DTOptionsBuilder',
    'feedbackService'
  ];

  function DocumentoNaoEntregueListarController(
    $compile,
    $location,
    $stateParams,
    $scope,
    documentoNaoEntregueApiService,
    cobrancaApiService,
    constantes,
    DTColumnBuilder,
    DTOptionsBuilder,
    feedbackService
  ) {
    var vm = this;
    var self = $scope;
    var exibeLabelDocNPara = false;
    var exibeLabelESPendCan = false;
    var exibeLabelESCancelada = false;
    const SITUACOES_EXIBIDAS_NA_TELA = ["ESPERADO", "DISPENSADO"]

    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.exibeLabelDocNPara = exibeLabelDocNPara;
    vm.exibeLabelESPendCan = exibeLabelESPendCan;
    vm.exibeLabelESCancelada = exibeLabelESCancelada;
    vm.updateSelection = updateSelection;
    vm.isSelected = isSelected;
    vm.isSelectedAll = isSelectedAll;
    vm.selectAll = selectAll;
    vm.dtInstanceCallback = dtInstanceCallback;
    vm.geradoAvulsoComSucesso = geradoAvulsoComSucesso;
    vm.limparMensagens = limparMensagens;
    vm.gerarCobrancaEmLote = gerarCobrancaEmLote;
    vm.pesquisarXLSX = pesquisarXLSX;

    inicializarView();
    reset();
    esconderResultadoPesquisa();
    carregarTela();

    function inicializarView() {
      vm.msgConfirmacao = '';
      vm.view = {
        formulario: {
          visivel: true
        },
        resultado: {
          visivel: false
        }
      };
      vm.simNao = [{
        codigo: true,
        descricao: 'Sim'
      }, {
        codigo: false,
        descricao: 'Não'
      }];
      vm.dtColumns = criarColunas();
    }

    function adicionarMensagemConfirmacao(quantidade) {
      vm.msgConfirmacao =
        quantidade === 1
          ? 'Confirma o envio de correio eletrônico e e-mail para 1 linha selecionada?'
          : 'Confirma o envio de correio eletrônico e e-mail para ' + quantidade + ' linhas selecionadas?';
    }

    function criarColunas() {
      var colunaIndice = DTColumnBuilder
        .newColumn(null)
        .notSortable()
        .renderWith(htmlColunaIndice);

      var colunaSelecione = DTColumnBuilder
        .newColumn(null)
        .notSortable()
        .renderWith(htmlColunaSelecionar)
        .withClass('text-center');

      var colunaEnviadoHoje = DTColumnBuilder
        .newColumn(null)
        .renderWith(htmlColunaCobrancaEnviadaHoje)
        .withClass('text-center');

      var colunaDocumentoCodigo = DTColumnBuilder
        .newColumn(null)
        .renderWith(htmlColunaDocumentoCodigo)
        .withClass('text-center');

      var colunaInstituicao = DTColumnBuilder
        .newColumn(null)
        .renderWith(htmlColunaInstituicao)
        .withClass('text-center');

      var colunaAcoes = DTColumnBuilder
        .newColumn(null)
        .notSortable()
        .renderWith(htmlColunaAcoes)
        .withClass('coluna-acoes');

      return [
        colunaIndice,
        colunaSelecione,
        colunaEnviadoHoje,
        DTColumnBuilder.newColumn('siglaSistemaNegocio').withClass('text-center'),
        colunaDocumentoCodigo,
        DTColumnBuilder.newColumn('descAutomatica').withClass('text-center'),
        DTColumnBuilder.newColumn('nomeSegmento'),
        colunaInstituicao,
        DTColumnBuilder.newColumn('instituicao.nome'),
        DTColumnBuilder.newColumn('destinatariosEmail'),
        DTColumnBuilder.newColumn('qtdDataBaseAtraso'),
        colunaAcoes
      ];
    }

    function reset() {
      vm.parametrosPesquisa = {
        cobranca: null,
        documento: [],
        excecoes: [],
        instituicao: null,
        segmento: [],
        sistemasNegocio: [],
        situacoesDocumentosEsperados: SITUACOES_EXIBIDAS_NA_TELA
      };
      vm.documentosNaoEntregues = [];
      vm.selecioneTodos = false;
      vm.selected = [];
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function carregarTela() {
     return documentoNaoEntregueApiService
      .telaPesquisar()
      .then(successOnTelaPesquisar);

      function successOnTelaPesquisar(resource) {
        vm.dataAtual = moment(new Date()).format('DD/MM/YYYY');
        vm.sistemasNegocio = resource.dadosFormularioPesquisa.sistemasNegocio;
        vm.segmentos = resource.dadosFormularioPesquisa.segmentos;
        vm.excecoes = resource.dadosFormularioPesquisa.excecoes;
        vm.isCobranca = resource.curadorMaster || resource.curador;

        vm.documentoEsperadoEstaImpedido = resource.dadosFormularioPesquisa.documentoEsperadoEstaImpedido;
        vm.cabecalho = resource.cabecalhoDocumentoNaoEntregue;

        if (_.compact(_.values($stateParams)).length) {
          extrairParametrosDaUrl($stateParams);
          pesquisar(vm.parametrosPesquisa);
        } else {
          preencherParametrosPesquisaInicial(resource.curador, resource.dadosFormularioPesquisa.sistemasNCurador);
          if (!resource.curadorMaster && resource.curador && resource.dadosFormularioPesquisa.sistemasNCurador.length > 0) {
            pesquisar(vm.parametrosPesquisa);
          }
        }
      }
    }

    function pesquisar() {
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);

      $location.search(parameters);
      parameters.pkProcessamento = vm.cabecalho.pkBatchControlarEntrega;
      parameters.situacoesDocumentosEsperados = SITUACOES_EXIBIDAS_NA_TELA
      return documentoNaoEntregueApiService
        .pesquisarDocumentoNaoEntregue(parameters)
        .then(successOnPesquisar);

      function successOnPesquisar(resource) {
        vm.resultadoPesquisa = resource._embedded.resultado;
        vm.filtroFLuxoCobrancaCurador = resource._embedded.permiteRealizarCobranca;
        vm.pseudodocumentoOuDadosAbertos = resource._parameters.pseudodocumentoOuDadosAbertos;
        prepararGridResultados();
        exibirResultadoPesquisa();
        vm.selecioneTodos = false;
        vm.selected = [];
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.sistemasNegocio = undefined;
      vm.parametrosPesquisa.documentos = undefined;
      vm.parametrosPesquisa.segmento = undefined;
      vm.parametrosPesquisa.instituicao = undefined;
      vm.parametrosPesquisa.excecoes = undefined;
      vm.parametrosPesquisa.cobranca = undefined;

      limparMensagens();
      esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function updateSelection($event, documentoNaoEntregue) {
      var checkbox = $event.target;
      var action = checkbox.checked ? 'add' : 'remove';
      if (action === 'add' && vm.selected.indexOf(documentoNaoEntregue) === RETORNO_NEGATIVO) {
        vm.selected.push(documentoNaoEntregue);
      }
      if (action === 'remove' && vm.selected.indexOf(documentoNaoEntregue) !== RETORNO_NEGATIVO) {
        vm.selected.splice(vm.selected.indexOf(documentoNaoEntregue), 1);
        vm.selecioneTodos = false;
      }
      adicionarMensagemConfirmacao(vm.selected.length);
    }

    function isSelected(documentoNaoEntregue) {
      return vm.selected.indexOf(documentoNaoEntregue) !== RETORNO_NEGATIVO;
    }

    function isSelectedAll() {
      return vm.selecioneTodos;
    }

    function selectAll($event) {
      var checkbox = $event.target;
      var action = checkbox.checked ? 'add' : 'remove';

      if (action === 'add') {
        for (var i in vm.resultadoPesquisa) {
          if (vm.selected.indexOf(vm.resultadoPesquisa[i]) === RETORNO_NEGATIVO && vm.resultadoPesquisa[i].cobrancaLote) {
            vm.selected.push(vm.resultadoPesquisa[i]);
          }
        }
        vm.selecioneTodos = true;
      } else if (action === 'remove') {
        vm.selected.splice(0, vm.selected.length);
        vm.selecioneTodos = false;
      }
      adicionarMensagemConfirmacao(vm.selected.length);
    }

    function dtInstanceCallback(dtInstance) {
      vm.dtInstance = dtInstance;
    }

    function geradoAvulsoComSucesso() {
      limparMensagens();
      vm.selected = [];
      vm.pesquisar(vm.parametrosPesquisa);
    }

    function limparMensagens() {
      feedbackService.limpar();
      vm.mensagens = undefined;
    }

    function gerarCobrancaEmLote() {
      limparMensagens();
      var cobrancasSelecionadasComDestinatario = [];
      var cobrancasSelecionadasSemDestinatario = [];

      for (var i in vm.selected) {
        if (vm.selected[i].destinatariosEmail === null) {
          cobrancasSelecionadasSemDestinatario.push({
            documento: vm.selected[i].documento.pk,
            idBacen: vm.selected[i].idBacen
          });
        } else {
          cobrancasSelecionadasComDestinatario.push({
            documento: vm.selected[i].documento.pk,
            idBacen: vm.selected[i].idBacen
          });
        }
      }

      var filtro = montarParametrosDaUrl(vm.parametrosPesquisa);
      filtro.pkProcessamento = vm.cabecalho.pkBatchControlarEntrega;
      filtro.situacoesDocumentosEsperados = SITUACOES_EXIBIDAS_NA_TELA

      return cobrancaApiService
        .gerarCobrancaEmLote(cobrancasSelecionadasComDestinatario, cobrancasSelecionadasSemDestinatario, filtro)
        .then(successOnGerarCobrancaEmLote);

      function successOnGerarCobrancaEmLote(response) {
        if (response.status === HttpStatus.CREATED) {
          vm.selected = [];
          vm.pesquisar(vm.parametrosPesquisa);

          mensagensInformativas(response.data);
        }
      }
    }

    function mensagensInformativas(data) {
      var obj = angular.fromJson(data);
      vm.mensagens = obj.mensagens;
    }

    function pesquisarXLSX() {
      limparMensagens();
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      parameters.pkProcessamento = vm.cabecalho.pkBatchControlarEntrega;
      return documentoNaoEntregueApiService.pesquisarDocumentoNaoEntregueXLSX(parameters).then(function successOnGerarXLS() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      });
    }

    function prepararGridResultados() {
      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('serverSide', true)
        .withFnServerData(serverData)
        .withDataProp('data')
        .withOption('createdRow', createdRow)
        .withDisplayLength(DISPLAY_LENGTH)
        .withOption('stateSaveParams', function (settings, data) {
          _.each(data.columns, function (column) {
            delete column.visible;
          });
        });

      if (!vm.isCobranca) {
        vm.dtColumns[COLUNA_SELECIONE].notVisible();
        vm.dtColumns[COLUNA_ENVIADO_HOJE].notVisible();
      }
    }

    function exibirResultadoPesquisa() {
      var rows = vm.dtInstance.DataTable.rows();
      rows.invalidate().draw();
      vm.view.resultado.visivel = true;
    }

    function serverData(sSource, aoData, fnCallback) {
      var draw = aoData[DRAW].value;
      var order = aoData[ORDER].value;
      var start = draw === 1 ? 0 : aoData[START].value;
      var length = aoData[LENGTH].value;
      ordenarLista(order);
      var records = {
        data: vm.resultadoPesquisa.slice(start, start + length),
        draw: draw,
        recordsFiltered: vm.resultadoPesquisa.length,
        recordsTotal: vm.resultadoPesquisa.length
      };

      vm.exibeLabelDocNPara = false;
      vm.exibeLabelESPendCan = false;
      vm.exibeLabelESCancelada = false;

      formatarResultadoParaExibicao(records.data);

      fnCallback(records);

      self.$safeApply();
    }

    function elementosColuna() {
      var elementos = [];
      elementos.push({
        descColuna: 'sequencial'
      });
      elementos.push({
        descColuna: 'cobrancaLote'
      });
      elementos.push({
        descColuna: 'cobrancaEnviadaHoje'
      });
      elementos.push({
        descColuna: 'siglaSistemaNegocio'
      });
      elementos.push({
        descColuna: 'documento.codigo'
      });
      elementos.push({
        descColuna: 'parametroCobranca.automatica'
      });
      elementos.push({
        descColuna: 'nomeSegmento'
      });
      elementos.push({
        descColuna: 'instituicao.cnpjFormatado'
      });
      elementos.push({
        descColuna: 'instituicao.nome'
      });
      elementos.push({
        descColuna: 'destinatariosEmail'
      });
      elementos.push({
        descColuna: 'qtdDataBaseAtraso'
      });
      elementos.push({
        descColuna: 'cobrancaAvulso'
      });
      return elementos;
    }

    function ordenarLista(order) {
      if (order.length > 0) {
        var elementos = elementosColuna();
        vm.resultadoPesquisa.sort(sortBy(elementos[order[0].column].descColuna, order[0].dir === 'asc'));
      }
    }

    function sortBy(field, reverse) {
      var reverso = reverse;

      function key(elemento) {
        if (field.split('.').length > 1) {
          var retorno = elemento;
          field.split('.').forEach(function (ind) {
            if (retorno !== null) {
              retorno = retorno[ind];
            }
          });
          return retorno === null ? '' : retorno;
        }
        return elemento[field] === null ? '' : elemento[field];
      }

      reverso = reverso ? RETORNO_NEGATIVO : RETORNO_POSITIVO;

      return function (primeiroCampo, segundoCampo) {
        var primeiroValor = primeiroCampo;
        var segundoValor = segundoCampo;
        return primeiroValor = key(primeiroValor),
          segundoValor = key(segundoValor), reverso * ((primeiroValor > segundoValor) - (segundoValor > primeiroValor));
      };
    }

    function formatarResultadoParaExibicao(resultado) {
      var idx = 1;

      // limpar as legendas
      vm.pseudodocumentoOuDadosAbertos.forEach(function (elemento) {
        elemento.deveMostrar = false;
      });

      vm.documentosNaoEntregues.splice(0, vm.documentosNaoEntregues.length);
      _.each(resultado, function (documentoNaoEntregue) {
        documentoNaoEntregue.id = idx;
        documentoNaoEntregue.documento.descCodigo = documentoNaoEntregue.documento.codigo;
        documentoNaoEntregue.instituicao.descCnpjFormatado = documentoNaoEntregue.instituicao.cnpjFormatado;

        if (documentoNaoEntregue.parametroCobranca === null) {
          documentoNaoEntregue.documento.descCodigo = s.insert(documentoNaoEntregue.documento.codigo, 0, '** ');
          documentoNaoEntregue.descAutomatica = null;
        } else {
          documentoNaoEntregue.descAutomatica = documentoNaoEntregue.parametroCobranca.automatica ? 'Sim' : 'Não';
        }

        if (documentoNaoEntregue.instituicaoPendenteCancelamento) {
          documentoNaoEntregue.instituicao.descCnpjFormatado = s.insert(documentoNaoEntregue.instituicao.descCnpjFormatado, 0, '* ');
        }

        if (documentoNaoEntregue.instituicaoCancelada) {
          documentoNaoEntregue.instituicao.descCnpjFormatado = s.insert(documentoNaoEntregue.instituicao.descCnpjFormatado, 0, '*** ');
        }

        if (documentoNaoEntregue.destinatariosEmail !== null) {
          documentoNaoEntregue.destinatariosEmail = documentoNaoEntregue.destinatariosEmail.split(',').join(', ');
        }

        // Verificar se essa linha do resultado está contida no parameters (documentos dados abertos ou sistema online)
        // preencher o campo presente na exibição

        if (documentoNaoEntregue.pseudodocumentoOuDadosAbertos) {
          var indice = vm.pseudodocumentoOuDadosAbertos.findIndex(function (elemento) {
            return elemento.pk === documentoNaoEntregue.documento.pk;
          });

          var deveMostrar = indice !== -1 ? true : false;
          vm.pseudodocumentoOuDadosAbertos[indice].deveMostrar = deveMostrar;
        }

        vm.documentosNaoEntregues[documentoNaoEntregue.id] = documentoNaoEntregue;
        idx += 1;
      });
    }

    function createdRow(row) {
      $compile(angular.element(row).contents())(self);
    }

    function htmlColunaIndice(data) {
      return String(data.id);
    }

    function htmlColunaSelecionar(data) {
      var html = '';
      if (vm.filtroFLuxoCobrancaCurador && !data.cobrancaEnviadaHoje) { //Valida o usuário logado. Deve ser curador
        if (data.cobrancaLote && !data.documentoEsperadoEstaImpedido) { //Valida se é uma ação em lote e se o documento associado não está impedido
          if (data.parametroCobranca.automatica) { //Valida se a cobrança é automática
            if (vm.isCobranca && data.podeRealizarCobrancaManualParaCobrancaAuto) {
              html += '<input type="checkbox" name="selected" ng-checked="documentoNaoEntregueListarCtrl.isSelected(documentoNaoEntregueListarCtrl.documentosNaoEntregues[' + data.id + '])" ';
              html += ' ng-click="documentoNaoEntregueListarCtrl.updateSelection($event, documentoNaoEntregueListarCtrl.documentosNaoEntregues[' + data.id + '])">';
            }
          } else {
            html += '<input type="checkbox" name="selected" ng-checked="documentoNaoEntregueListarCtrl.isSelected(documentoNaoEntregueListarCtrl.documentosNaoEntregues[' + data.id + '])" ';
            html += ' ng-click="documentoNaoEntregueListarCtrl.updateSelection($event, documentoNaoEntregueListarCtrl.documentosNaoEntregues[' + data.id + '])">';
          }
        }
      }
      return html;
    }

    function htmlColunaCobrancaEnviadaHoje(data) {
      var html = '<span hidden="true">' + data.cobrancaEnviadaHoje + '</span>';

      if (data.cobrancaEnviadaHoje) {
        html += '<i class="fa fa-check verde" aria-hidden="true"></i>';
      }

      return html;
    }

    function htmlColunaDocumentoCodigo(data) {
      var html = data.documento.descCodigo + ' ';

      if (data.parametroCobranca === null) {
        vm.exibeLabelDocNPara = true;
      }

      return html;
    }

    function htmlColunaInstituicao(data) {
      var html = data.instituicao.descCnpjFormatado + ' ';

      if (data.instituicaoPendenteCancelamento) {
        vm.exibeLabelESPendCan = true;
      }

      if (data.instituicaoCancelada) {
        vm.exibeLabelESCancelada = true;
      }

      return html;
    }

    function htmlColunaAcoes(data) {
      var html = '';
      if (data.cobrancaAvulso) {
        html += '<a class="btn btn-default btn-xs" title="Enviar comunicação avulsa" ';
        html += 'crd-modal-cobranca-avulsa-detalhe documento-nao-entregue="::documentoNaoEntregueListarCtrl.documentosNaoEntregues[' + data.id + ']" ';
        html += 'parametros-pesquisa="::documentoNaoEntregueListarCtrl.parametrosPesquisa" ';
        html += 'gerado-avulso-com-sucesso="documentoNaoEntregueListarCtrl.geradoAvulsoComSucesso" ';
        html += 'pk-processamento="::documentoNaoEntregueListarCtrl.vm.cabecalho.pkBatchControlarEntrega;">';
        html += '<i class="fa fa-envelope-o fa-lg text-primary"></i></a>&nbsp;';
      }

      html += '<a ui-link-open-modal title="Visualizar datas-base" crd-modal-documento-nao-entregue-detalhe ';
      html += 'documento-nao-entregue="::documentoNaoEntregueListarCtrl.documentosNaoEntregues[' + data.id + ']" ';
      html += 'parametros-pesquisa="::documentoNaoEntregueListarCtrl.parametrosPesquisa" ';
      html += 'pk-processamento="::documentoNaoEntregueListarCtrl.vm.cabecalho.pkBatchControlarEntrega;">';
      html += '</a>';

      return html;
    }

    function preencherParametrosPesquisaInicial(curador, sistemasCurador) {
      reset();
      if (curador && sistemasCurador.length > 0) {
        for (var i in sistemasCurador) {
          vm.parametrosPesquisa.sistemasNegocio.push(sistemasCurador[i]);
        }
      }
    }

    function montarParametrosDaUrl(parametrosPesquisa) {
      var criador = parametrosUrl.Criador;

      return {
        cobranca: vm.parametrosPesquisa.cobranca ? vm.parametrosPesquisa.cobranca.codigo : null,
        documentos: criador.arrayPk(parametrosPesquisa.documentos),
        excecoes: vm.parametrosPesquisa.excecoes ? vm.parametrosPesquisa.excecoes : null,
        idBacen: criador.idBacen(parametrosPesquisa.instituicao),
        isPesquisaRealizada: true,
        segmentos: criador.arrayCodigo(parametrosPesquisa.segmento),
        sistemasNegocio: criador.arrayPk(parametrosPesquisa.sistemasNegocio),
        situacoesDocumentosEsperados: SITUACOES_EXIBIDAS_NA_TELA
      };
    }

    function extrairParametrosDaUrl(routeParams) {
      var extrator = parametrosUrl.Extrator;

      vm.parametrosPesquisa = {
        cobranca: routeParams.cobranca === null ? null : {
          codigo: routeParams.cobranca
        },
        documentos: extrator.arrayObjetoPk(routeParams.documentos),
        excecoes: [],
        instituicao: routeParams.idBacen ? {
          idBacen: routeParams.idBacen
        } : null,
        segmento: extrator.arrayObjetoCodigo(routeParams.segmentos),
        sistemasNegocio: extrator.arrayObjetoPk(routeParams.sistemasNegocio),
        situacoesDocumentosEsperados: SITUACOES_EXIBIDAS_NA_TELA
      };

      if ($stateParams.excecoes) {
        if (angular.isArray($stateParams.excecoes)) {
          for (var indice in $stateParams.excecoes) {
            vm.parametrosPesquisa.excecoes.push($stateParams.excecoes[indice]);
          }
        } else {
          vm.parametrosPesquisa.excecoes.push($stateParams.excecoes);
        }
      }
    }

    self.$watch('documentoNaoEntregueListarCtrl.parametrosPesquisa', function () {
      esconderResultadoPesquisa();
      limparMensagens();
    }, true);
  }
})(angular, moment, jQuery, CRDUtils.ParametrosUrl, httpStatusCode);
;
"use strict";
var AdministracaoDocumentoDetalharController = (function () {
    function AdministracaoDocumentoDetalharController($state, administracaoDocumentoApiService) {
        this.$state = $state;
        this.administracaoDocumentoApiService = administracaoDocumentoApiService;
    }
    AdministracaoDocumentoDetalharController.prototype.carregarDados = function (documentoPk) {
        var _this = this;
        return this.administracaoDocumentoApiService.detalhar(documentoPk).then(function (resource) {
            if (!resource.pk && resource.podeIncluir) {
                _this.$state.go('documento.administracao-documento-manutencao', { documentoPk: _this.$state.params.documentoPk });
            }
            _this.administracaoDocumento = resource;
        });
    };
    AdministracaoDocumentoDetalharController.prototype.$onInit = function () {
        return this.carregarDados(this.$state.params.documentoPk);
    };
    ;
    return AdministracaoDocumentoDetalharController;
}());
AdministracaoDocumentoDetalharController.$inject = ['$state', 'AdministracaoDocumentoApiService'];
angular.module('crd').controller('AdministracaoDocumentoDetalharController', AdministracaoDocumentoDetalharController);
//# sourceMappingURL=administracao-documento-detalhar-controller.js.map;
"use strict";
var AdministracaoDocumentoManutencaoController = (function () {
    function AdministracaoDocumentoManutencaoController($state, feedbackService, administracaoDocumentoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.administracaoDocumentoApiService = administracaoDocumentoApiService;
    }
    AdministracaoDocumentoManutencaoController.prototype.salvar = function (administracaoDocumento) {
        var _this = this;
        var ado = this.converterParaEnviarServidor(administracaoDocumento);
        return this.administracaoDocumentoApiService.incluir(ado).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso('Dados administrativos do documento salvos com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    AdministracaoDocumentoManutencaoController.prototype.voltar = function () {
        this.$state.go('documento.administracao-documento-detalhar', { documentoPk: this.$state.params.documentoPk });
    };
    AdministracaoDocumentoManutencaoController.prototype.converterParaEnviarServidor = function (administracaoDocumento) {
        return {
            documento: this.$state.params.documentoPk,
            arquivoProcessado: ConverterParameterObjectToUrlUtils.atributoEnumName(administracaoDocumento.arquivoProcessado),
            listaEsperado: ConverterParameterObjectToUrlUtils.atributoEnumName(administracaoDocumento.listaEsperado),
            apiDadosAbertos: this.recuperarApiDadosAbertos(administracaoDocumento),
            descricao: ConverterParameterObjectToUrlUtils.string(administracaoDocumento.descricao)
        };
    };
    AdministracaoDocumentoManutencaoController.prototype.recuperarApiDadosAbertos = function (administracaoDocumento) {
        if (!administracaoDocumento.arquivoProcessado)
            return;
        if (administracaoDocumento.arquivoProcessado.enumName === 'DADOS_ABERTOS') {
            return administracaoDocumento.apiDadosAbertos;
        }
        else
            return undefined;
    };
    AdministracaoDocumentoManutencaoController.prototype.carregarDados = function (documentoPk) {
        var _this = this;
        return this.administracaoDocumentoApiService.montarTelaIncluir(documentoPk).then(function (resource) {
            _this.dadosFormulario = resource;
            _this.administracaoDocumento = resource.administracaoDocumento;
            _this.primeiroADO = !resource.administracaoDocumento;
        });
    };
    AdministracaoDocumentoManutencaoController.prototype.$onInit = function () {
        return this.carregarDados(this.$state.params.documentoPk);
    };
    ;
    return AdministracaoDocumentoManutencaoController;
}());
AdministracaoDocumentoManutencaoController.$inject = ['$state', 'feedbackService', 'AdministracaoDocumentoApiService'];
angular.module('crd').controller('AdministracaoDocumentoManutencaoController', AdministracaoDocumentoManutencaoController);
//# sourceMappingURL=administracao-documento-manutencao-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('documento.configuracao-esperado-por-segmento-consultar', {
        controller: 'ConfiguracaoEsperadoPorSegmentoConsultaController',
        controllerAs: 'configuracaoEsperadoPorSegmentoConsultaCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado por segmento',
            titulo: 'Configuração de esperado por segmento',
            outros: {
                activeTab: 'documento.configuracao-esperado-por-segmento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento/configuracao-esperado-por-segmento/views/configuracao-esperado-por-segmento-consulta/configuracao-esperado-por-segmento-consulta-tpl.html',
        url: '/configuracao-esperado-por-segmento?numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('documento.configuracao-esperado-por-segmento-detalhar', {
        controller: 'ConfiguracaoEsperadoPorSegmentoDetalheController',
        controllerAs: 'configuracaoEsperadoPorSegmentoDetalheCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado por segmento',
            titulo: 'Configuração de esperado por segmento',
            outros: {
                activeTab: 'documento.configuracao-esperado-por-segmento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-esperado-por-segmento/views/configuracao-esperado-por-segmento-detalhe/configuracao-esperado-por-segmento-detalhe-tpl.html',
        url: '/configuracao-esperado-por-segmento/:id/detalhar'
    })
        .state('documento.configuracao-esperado-por-segmento-incluir', {
        controller: 'ConfiguracaoEsperadoPorSegmentoInclusaoController',
        controllerAs: 'configuracaoEsperadoPorSegmentoInclusaoCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado por segmento',
            titulo: 'Configuração de esperado por segmento',
            outros: {
                activeTab: 'documento.configuracao-esperado-por-segmento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-esperado-por-segmento/views/configuracao-esperado-por-segmento-inclusao/configuracao-esperado-por-segmento-inclusao-tpl.html',
        url: '/configuracao-esperado-por-segmento/incluir'
    })
        .state('documento.configuracao-esperado-por-segmento-alterar', {
        controller: 'ConfiguracaoEsperadoPorSegmentoAlteracaoController',
        controllerAs: 'configuracaoEsperadoPorSegmentoAlteracaoCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado por segmento',
            titulo: 'Configuração de esperado por segmento',
            outros: {
                activeTab: 'documento.configuracao-esperado-por-segmento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-esperado-por-segmento/views/configuracao-esperado-por-segmento-alteracao/configuracao-esperado-por-segmento-alteracao-tpl.html',
        url: '/configuracao-esperado-por-segmento/:id/alterar'
    });
});
//# sourceMappingURL=configuracao-esperado-por-segmento-route-config.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-por-segmento-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-por-segmento-consulta-resultado-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-por-segmento-detalhe-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-por-segmento-manutencao-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-por-segmento-para-alterar-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-por-segmento-para-consultar-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-por-segmento-para-incluir-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ConfiguracaoEsperadoPorSegmentoApiService = (function (_super) {
    __extends(ConfiguracaoEsperadoPorSegmentoApiService, _super);
    function ConfiguracaoEsperadoPorSegmentoApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.alterar = function (id, dados) {
        return this.alterarRecurso("/configuracao-esperado-por-segmento/" + id + "/alterar", dados);
    };
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/configuracao-esperado-por-segmento/consultar', consultaFiltro);
    };
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.detalhar = function (id) {
        return this.buscarRecurso("/configuracao-esperado-por-segmento/" + id + "/detalhar", {});
    };
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.excluir = function (id) {
        return this.excluirRecurso("/configuracao-esperado-por-segmento/" + id + "/excluir", {});
    };
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso('/configuracao-esperado-por-segmento/incluir', dados);
    };
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.paraAlterar = function (id) {
        return this.buscarRecurso("/configuracao-esperado-por-segmento/" + id + "/para-alterar", {});
    };
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/configuracao-esperado-por-segmento/para-consultar', consultaFiltro);
    };
    ConfiguracaoEsperadoPorSegmentoApiService.prototype.paraIncluir = function (documentoId) {
        return this.buscarRecurso('/configuracao-esperado-por-segmento/para-incluir', { documentoId: documentoId });
    };
    return ConfiguracaoEsperadoPorSegmentoApiService;
}(AbstractAPISerivce));
ConfiguracaoEsperadoPorSegmentoApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('ConfiguracaoEsperadoPorSegmentoApiService', ConfiguracaoEsperadoPorSegmentoApiService);
//# sourceMappingURL=configuracao-esperado-por-segmento-api-service.js.map;
"use strict";
var ConfiguracaoEsperadoPorSegmentoAlteracaoController = (function () {
    function ConfiguracaoEsperadoPorSegmentoAlteracaoController($state, feedbackService, configuracaoEsperadoPorSegmentoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoEsperadoPorSegmentoApiService = configuracaoEsperadoPorSegmentoApiService;
        this.obrigatorio = {
            formulaEsperado: false,
            formulaPeriodicidade: false,
            formulaDispensa: false
        };
        this.visibilidade = {
            formulaEsperado: false,
            formulaPeriodicidade: false,
            formulaDispensa: false
        };
    }
    ConfiguracaoEsperadoPorSegmentoAlteracaoController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoEsperadoPorSegmentoApiService.paraAlterar(this.$state.params.id).then(function (response) {
            if (response.data) {
                _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
                _this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento);
                _this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento);
                _this.opcoesDeData = FormataDataPeriodicidade.formatoDataPorGrupoPeriodidicade(_this.dadosParaConstruirFormulario.grupoPeriodicidade);
                _this.dadosFormulario = response.data.dadosFormulario;
                _this.dadosFormulario.dataBaseInicioVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseInicioVigencia);
                _this.dadosFormulario.dataBaseFimVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseFimVigencia);
                _this.observerTipoSegmentoEsperado(_this.dadosFormulario.tipoSegmentoEsperado);
                _this.observerPeriodicidade(_this.dadosFormulario.periodicidade);
                _this.observerTipoPermiteDispensa(_this.dadosFormulario.tipoPermiteDispensa);
            }
        });
    };
    ;
    ConfiguracaoEsperadoPorSegmentoAlteracaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            documentoId: this.$state.params.documentoPk,
            codigoSegmento: this.dadosParaConstruirFormulario.segmento.codigo,
            codigoCadoc: ConverterParameterObjectToUrlUtils.string(dadosFormulario.codigoCadoc),
            vigencia: {
                inicio: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseInicioVigencia),
                fim: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseFimVigencia)
            },
            periodicidade: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.periodicidade),
            descricaoFormulaPeriodicidade: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaPeriodicidade),
            formulaPeriodicidade: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaPeriodicidade),
            tipoSegmentoEsperado: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoSegmentoEsperado),
            descricaoFormulaEsperado: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaEsperado),
            formulaEsperado: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaEsperado),
            tipoPermiteDispensa: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoPermiteDispensa),
            descricaoFormulaDispensa: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaDispensa),
            formulaDispensa: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaDispensa)
        };
        return this.configuracaoEsperadoPorSegmentoApiService.alterar(this.$state.params.id, dados).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Configuração de esperado por segmento alterado com sucesso.');
                _this.voltar();
            }
        });
    };
    ConfiguracaoEsperadoPorSegmentoAlteracaoController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-esperado-por-segmento-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    ConfiguracaoEsperadoPorSegmentoAlteracaoController.prototype.observerPeriodicidade = function (periodicidade) {
        if ('REGRA' === ConverterParameterObjectToUrlUtils.atributoEnumName(periodicidade)) {
            this.obrigatorio.formulaPeriodicidade = true;
            this.visibilidade.formulaPeriodicidade = true;
        }
        else {
            this.obrigatorio.formulaPeriodicidade = false;
            this.visibilidade.formulaPeriodicidade = false;
        }
    };
    ConfiguracaoEsperadoPorSegmentoAlteracaoController.prototype.observerTipoPermiteDispensa = function (tipoPermiteDispensa) {
        if ('REGRA' === ConverterParameterObjectToUrlUtils.atributoEnumName(tipoPermiteDispensa)) {
            this.obrigatorio.formulaDispensa = true;
            this.visibilidade.formulaDispensa = true;
        }
        else {
            this.obrigatorio.formulaDispensa = false;
            this.visibilidade.formulaDispensa = false;
        }
    };
    ConfiguracaoEsperadoPorSegmentoAlteracaoController.prototype.observerTipoSegmentoEsperado = function (tipoSegmentoEsperado) {
        if ('REGRA' === ConverterParameterObjectToUrlUtils.atributoEnumName(tipoSegmentoEsperado)) {
            this.obrigatorio.formulaEsperado = true;
            this.visibilidade.formulaEsperado = true;
        }
        else {
            this.obrigatorio.formulaEsperado = false;
            this.visibilidade.formulaEsperado = false;
        }
    };
    return ConfiguracaoEsperadoPorSegmentoAlteracaoController;
}());
ConfiguracaoEsperadoPorSegmentoAlteracaoController.$inject = ['$state', 'feedbackService', 'ConfiguracaoEsperadoPorSegmentoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoPorSegmentoAlteracaoController', ConfiguracaoEsperadoPorSegmentoAlteracaoController);
//# sourceMappingURL=configuracao-esperado-por-segmento-alteracao-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ConfiguracaoEsperadoPorSegmentoConsultaController = (function (_super) {
    __extends(ConfiguracaoEsperadoPorSegmentoConsultaController, _super);
    function ConfiguracaoEsperadoPorSegmentoConsultaController($stateParams, $scope, feedbackService, configuracaoEsperadoPorSegmentoApiService) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.configuracaoEsperadoPorSegmentoApiService = configuracaoEsperadoPorSegmentoApiService;
        return _this;
    }
    ConfiguracaoEsperadoPorSegmentoConsultaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        consultaFiltro.documentos = [this.$stateParams.documentoPk];
        return this.configuracaoEsperadoPorSegmentoApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.acao = response.data.acao;
            _this.pagina = response.data.pagina;
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
            return response;
        });
    };
    ConfiguracaoEsperadoPorSegmentoConsultaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.configuracaoEsperadoPorSegmentoApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            return response;
        });
    };
    ConfiguracaoEsperadoPorSegmentoConsultaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        return {
            documentos: [this.$stateParams.documentoPk]
        };
    };
    ConfiguracaoEsperadoPorSegmentoConsultaController.prototype.limparDadosFormulario = function (dadosFormulario) {
    };
    ConfiguracaoEsperadoPorSegmentoConsultaController.prototype.excluir = function (id) {
        var _this = this;
        return this.configuracaoEsperadoPorSegmentoApiService.excluir(id).then(function (response) {
            _super.prototype.consultar.call(_this, _this.dadosFormulario).then(function () { return _this.feedbackService.sucesso('Configuração de esperado por segmento excluído com sucesso.'); });
            return response;
        });
    };
    return ConfiguracaoEsperadoPorSegmentoConsultaController;
}(AbstractPaginaConsultaController));
ConfiguracaoEsperadoPorSegmentoConsultaController.$inject = ['$stateParams', '$scope', 'feedbackService', 'ConfiguracaoEsperadoPorSegmentoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoPorSegmentoConsultaController', ConfiguracaoEsperadoPorSegmentoConsultaController);
//# sourceMappingURL=configuracao-esperado-por-segmento-consulta-controller.js.map;
"use strict";
var ConfiguracaoEsperadoPorSegmentoDetalheController = (function () {
    function ConfiguracaoEsperadoPorSegmentoDetalheController($state, feedbackService, configuracaoEsperadoPorSegmentoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoEsperadoPorSegmentoApiService = configuracaoEsperadoPorSegmentoApiService;
    }
    ConfiguracaoEsperadoPorSegmentoDetalheController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoEsperadoPorSegmentoApiService.detalhar(this.$state.params.id).then(function (response) {
            _this.item = response.data;
        });
    };
    ;
    ConfiguracaoEsperadoPorSegmentoDetalheController.prototype.excluir = function (id) {
        var _this = this;
        return this.configuracaoEsperadoPorSegmentoApiService.excluir(id).then(function (response) {
            _this.feedbackService.sucesso('Configuração de esperado por segmento excluído com sucesso.');
            _this.voltar();
            return response;
        });
    };
    ConfiguracaoEsperadoPorSegmentoDetalheController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-esperado-por-segmento-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return ConfiguracaoEsperadoPorSegmentoDetalheController;
}());
ConfiguracaoEsperadoPorSegmentoDetalheController.$inject = ['$state', 'feedbackService', 'ConfiguracaoEsperadoPorSegmentoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoPorSegmentoDetalheController', ConfiguracaoEsperadoPorSegmentoDetalheController);
//# sourceMappingURL=configuracao-esperado-por-segmento-detalhe-controller.js.map;
"use strict";
var ConfiguracaoEsperadoPorSegmentoInclusaoController = (function () {
    function ConfiguracaoEsperadoPorSegmentoInclusaoController($state, feedbackService, configuracaoEsperadoPorSegmentoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoEsperadoPorSegmentoApiService = configuracaoEsperadoPorSegmentoApiService;
        this.obrigatorio = {
            formulaEsperado: false,
            formulaPeriodicidade: false,
            formulaDispensa: false
        };
        this.visibilidade = {
            formulaEsperado: false,
            formulaPeriodicidade: false,
            formulaDispensa: false
        };
    }
    ConfiguracaoEsperadoPorSegmentoInclusaoController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoEsperadoPorSegmentoApiService.paraIncluir(this.$state.params.documentoPk).then(function (response) {
            if (response.data) {
                _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
                _this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento);
                _this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento);
                _this.opcoesDeData = FormataDataPeriodicidade.formatoDataPorGrupoPeriodidicade(_this.dadosParaConstruirFormulario.grupoPeriodicidade);
                _this.dadosFormulario = response.data.dadosFormulario;
                _this.dadosFormulario.dataBaseInicioVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseInicioVigencia);
                _this.dadosFormulario.dataBaseFimVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseFimVigencia);
                _this.observerTipoSegmentoEsperado(_this.dadosFormulario.tipoSegmentoEsperado);
                _this.observerPeriodicidade(_this.dadosFormulario.periodicidade);
                _this.observerTipoPermiteDispensa(_this.dadosFormulario.tipoPermiteDispensa);
            }
        });
    };
    ;
    ConfiguracaoEsperadoPorSegmentoInclusaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            documentoId: this.$state.params.documentoPk,
            codigoSegmento: ConverterParameterObjectToUrlUtils.atributoCodigo(dadosFormulario.segmento),
            codigoCadoc: ConverterParameterObjectToUrlUtils.string(dadosFormulario.codigoCadoc),
            vigencia: {
                inicio: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseInicioVigencia),
                fim: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseFimVigencia)
            },
            periodicidade: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.periodicidade),
            descricaoFormulaPeriodicidade: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaPeriodicidade),
            formulaPeriodicidade: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaPeriodicidade),
            tipoSegmentoEsperado: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoSegmentoEsperado),
            descricaoFormulaEsperado: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaEsperado),
            formulaEsperado: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaEsperado),
            tipoPermiteDispensa: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoPermiteDispensa),
            descricaoFormulaDispensa: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaDispensa),
            formulaDispensa: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaDispensa)
        };
        return this.configuracaoEsperadoPorSegmentoApiService.incluir(dados).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Configuração de esperado por segmento incluído com sucesso.');
                _this.voltar();
            }
        });
    };
    ConfiguracaoEsperadoPorSegmentoInclusaoController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-esperado-por-segmento-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    ConfiguracaoEsperadoPorSegmentoInclusaoController.prototype.observerPeriodicidade = function (periodicidade) {
        if ('REGRA' === ConverterParameterObjectToUrlUtils.atributoEnumName(periodicidade)) {
            this.obrigatorio.formulaPeriodicidade = true;
            this.visibilidade.formulaPeriodicidade = true;
        }
        else {
            this.obrigatorio.formulaPeriodicidade = false;
            this.visibilidade.formulaPeriodicidade = false;
        }
    };
    ConfiguracaoEsperadoPorSegmentoInclusaoController.prototype.observerTipoPermiteDispensa = function (tipoPermiteDispensa) {
        if ('REGRA' === ConverterParameterObjectToUrlUtils.atributoEnumName(tipoPermiteDispensa)) {
            this.obrigatorio.formulaDispensa = true;
            this.visibilidade.formulaDispensa = true;
        }
        else {
            this.obrigatorio.formulaDispensa = false;
            this.visibilidade.formulaDispensa = false;
        }
    };
    ConfiguracaoEsperadoPorSegmentoInclusaoController.prototype.observerTipoSegmentoEsperado = function (tipoSegmentoEsperado) {
        if ('REGRA' === ConverterParameterObjectToUrlUtils.atributoEnumName(tipoSegmentoEsperado)) {
            this.obrigatorio.formulaEsperado = true;
            this.visibilidade.formulaEsperado = true;
        }
        else {
            this.obrigatorio.formulaEsperado = false;
            this.visibilidade.formulaEsperado = false;
        }
    };
    return ConfiguracaoEsperadoPorSegmentoInclusaoController;
}());
ConfiguracaoEsperadoPorSegmentoInclusaoController.$inject = ['$state', 'feedbackService', 'ConfiguracaoEsperadoPorSegmentoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoPorSegmentoInclusaoController', ConfiguracaoEsperadoPorSegmentoInclusaoController);
//# sourceMappingURL=configuracao-esperado-por-segmento-inclusao-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('documento.configuracao-esperado-consultar', {
        controller: 'ConfiguracaoEsperadoConsultaController',
        controllerAs: 'configuracaoEsperadoConsultaCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado',
            titulo: 'Configuração de esperado',
            outros: {
                activeTab: 'documento.configuracao-esperado'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento/configuracao-esperado/views/configuracao-esperado-consulta/configuracao-esperado-consulta-tpl.html',
        url: '/configuracao-esperado?numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('documento.configuracao-esperado-detalhar', {
        controller: 'ConfiguracaoEsperadoDetalheController',
        controllerAs: 'configuracaoEsperadoDetalheCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado',
            titulo: 'Configuração de esperado',
            outros: {
                activeTab: 'documento.configuracao-esperado'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-esperado/views/configuracao-esperado-detalhe/configuracao-esperado-detalhe-tpl.html',
        url: '/configuracao-esperado/:id/detalhar'
    })
        .state('documento.configuracao-esperado-incluir', {
        controller: 'ConfiguracaoEsperadoInclusaoController',
        controllerAs: 'configuracaoEsperadoInclusaoCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado',
            titulo: 'Configuração de esperado',
            outros: {
                activeTab: 'documento.configuracao-esperado'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-esperado/views/configuracao-esperado-inclusao/configuracao-esperado-inclusao-tpl.html',
        url: '/configuracao-esperado/incluir'
    })
        .state('documento.configuracao-esperado-alterar', {
        controller: 'ConfiguracaoEsperadoAlteracaoController',
        controllerAs: 'configuracaoEsperadoAlteracaoCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de esperado',
            titulo: 'Configuração de esperado',
            outros: {
                activeTab: 'documento.configuracao-esperado'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-esperado/views/configuracao-esperado-alteracao/configuracao-esperado-alteracao-tpl.html',
        url: '/configuracao-esperado/:id/alterar'
    });
});
//# sourceMappingURL=configuracao-esperado-route-config.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-consulta-resultado-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-detalhe-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-manutencao-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-para-alterar-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-para-consultar-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-esperado-para-incluir-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ConfiguracaoEsperadoApiService = (function (_super) {
    __extends(ConfiguracaoEsperadoApiService, _super);
    function ConfiguracaoEsperadoApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    ConfiguracaoEsperadoApiService.prototype.alterar = function (id, dados) {
        return this.alterarRecurso("/configuracao-esperado/" + id + "/alterar", dados);
    };
    ConfiguracaoEsperadoApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/configuracao-esperado/consultar', consultaFiltro);
    };
    ConfiguracaoEsperadoApiService.prototype.detalhar = function (id) {
        return this.buscarRecurso("/configuracao-esperado/" + id + "/detalhar", {});
    };
    ConfiguracaoEsperadoApiService.prototype.excluir = function (id) {
        return this.excluirRecurso("/configuracao-esperado/" + id + "/excluir", {});
    };
    ConfiguracaoEsperadoApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso('/configuracao-esperado/incluir', dados);
    };
    ConfiguracaoEsperadoApiService.prototype.paraAlterar = function (id) {
        return this.buscarRecurso("/configuracao-esperado/" + id + "/para-alterar", {});
    };
    ConfiguracaoEsperadoApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/configuracao-esperado/para-consultar', consultaFiltro);
    };
    ConfiguracaoEsperadoApiService.prototype.paraIncluir = function (documentoPk) {
        return this.buscarRecurso('/configuracao-esperado/para-incluir', { documentoPk: documentoPk });
    };
    return ConfiguracaoEsperadoApiService;
}(AbstractAPISerivce));
ConfiguracaoEsperadoApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('ConfiguracaoEsperadoApiService', ConfiguracaoEsperadoApiService);
//# sourceMappingURL=configuracao-esperado-api-service.js.map;
"use strict";
var ConfiguracaoEsperadoAlteracaoController = (function () {
    function ConfiguracaoEsperadoAlteracaoController($state, feedbackService, configuracaoEsperadoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoEsperadoApiService = configuracaoEsperadoApiService;
    }
    ConfiguracaoEsperadoAlteracaoController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoEsperadoApiService.paraAlterar(this.$state.params.id).then(function (response) {
            if (response.data) {
                _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
                _this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento);
                _this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento);
                _this.opcoesDeData = FormataDataPeriodicidade.formatoDataPorGrupoPeriodidicade(_this.dadosParaConstruirFormulario.grupoPeriodicidade);
                _this.dadosFormulario = response.data.dadosFormulario;
                _this.dadosFormulario.dataBaseInicioVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseInicioVigencia);
                _this.dadosFormulario.dataBaseFimVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseFimVigencia);
            }
        });
    };
    ;
    ConfiguracaoEsperadoAlteracaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            documentoId: this.$state.params.documentoPk,
            formulaDataLimite: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaDataLimite),
            formulaImpedimentoDaEntrega: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaImpedimentoDaEntrega),
            descricaoFormulaDataLimite: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaDataLimite),
            situacoes: ConverterParameterObjectToUrlUtils.atributoCodigoArray(dadosFormulario.situacoes),
            dataBaseInicioVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseInicioVigencia),
            dataBaseFimVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseFimVigencia)
        };
        return this.configuracaoEsperadoApiService.alterar(this.$state.params.id, dados).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Configuração de esperado alterado com sucesso.');
                _this.voltar();
            }
        });
    };
    ConfiguracaoEsperadoAlteracaoController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-esperado-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return ConfiguracaoEsperadoAlteracaoController;
}());
ConfiguracaoEsperadoAlteracaoController.$inject = ['$state', 'feedbackService', 'ConfiguracaoEsperadoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoAlteracaoController', ConfiguracaoEsperadoAlteracaoController);
//# sourceMappingURL=configuracao-esperado-alteracao-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ConfiguracaoEsperadoConsultaController = (function (_super) {
    __extends(ConfiguracaoEsperadoConsultaController, _super);
    function ConfiguracaoEsperadoConsultaController($stateParams, $scope, feedbackService, configuracaoEsperadoApiService) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.configuracaoEsperadoApiService = configuracaoEsperadoApiService;
        return _this;
    }
    ConfiguracaoEsperadoConsultaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        consultaFiltro.documentos = [this.$stateParams.documentoPk];
        return this.configuracaoEsperadoApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.acao = response.data.acao;
            _this.pagina = response.data.pagina;
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
            return response;
        });
    };
    ConfiguracaoEsperadoConsultaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.configuracaoEsperadoApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            return response;
        });
    };
    ConfiguracaoEsperadoConsultaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        return {
            documentos: [this.$stateParams.documentoPk]
        };
    };
    ConfiguracaoEsperadoConsultaController.prototype.limparDadosFormulario = function (dadosFormulario) {
    };
    ConfiguracaoEsperadoConsultaController.prototype.excluir = function (id) {
        var _this = this;
        return this.configuracaoEsperadoApiService.excluir(id).then(function (response) {
            _super.prototype.consultar.call(_this, _this.dadosFormulario).then(function () { return _this.feedbackService.sucesso('Configuração de esperado excluído com sucesso.'); });
            return response;
        });
    };
    return ConfiguracaoEsperadoConsultaController;
}(AbstractPaginaConsultaController));
ConfiguracaoEsperadoConsultaController.$inject = ['$stateParams', '$scope', 'feedbackService', 'ConfiguracaoEsperadoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoConsultaController', ConfiguracaoEsperadoConsultaController);
//# sourceMappingURL=configuracao-esperado-consulta-controller.js.map;
"use strict";
var ConfiguracaoEsperadoDetalheController = (function () {
    function ConfiguracaoEsperadoDetalheController($state, feedbackService, configuracaoEsperadoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoEsperadoApiService = configuracaoEsperadoApiService;
    }
    ConfiguracaoEsperadoDetalheController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoEsperadoApiService.detalhar(this.$state.params.id).then(function (response) {
            _this.item = response.data;
        });
    };
    ;
    ConfiguracaoEsperadoDetalheController.prototype.excluir = function (id) {
        var _this = this;
        return this.configuracaoEsperadoApiService.excluir(id).then(function (response) {
            _this.feedbackService.sucesso('Configuração de esperado excluído com sucesso.');
            _this.voltar();
            return response;
        });
    };
    ConfiguracaoEsperadoDetalheController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-esperado-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return ConfiguracaoEsperadoDetalheController;
}());
ConfiguracaoEsperadoDetalheController.$inject = ['$state', 'feedbackService', 'ConfiguracaoEsperadoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoDetalheController', ConfiguracaoEsperadoDetalheController);
//# sourceMappingURL=configuracao-esperado-detalhe-controller.js.map;
"use strict";
var ConfiguracaoEsperadoInclusaoController = (function () {
    function ConfiguracaoEsperadoInclusaoController($state, feedbackService, configuracaoEsperadoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoEsperadoApiService = configuracaoEsperadoApiService;
    }
    ConfiguracaoEsperadoInclusaoController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoEsperadoApiService.paraIncluir(this.$state.params.documentoPk).then(function (response) {
            if (response.data) {
                _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
                _this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento);
                _this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento);
                _this.opcoesDeData = FormataDataPeriodicidade.formatoDataPorGrupoPeriodidicade(_this.dadosParaConstruirFormulario.grupoPeriodicidade);
                _this.dadosFormulario = response.data.dadosFormulario;
                _this.dadosFormulario.dataBaseInicioVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseInicioVigencia);
                _this.dadosFormulario.dataBaseFimVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseFimVigencia);
            }
        });
    };
    ;
    ConfiguracaoEsperadoInclusaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            documentoId: this.$state.params.documentoPk,
            formulaDataLimite: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaDataLimite),
            formulaImpedimentoDaEntrega: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formulaImpedimentoDaEntrega),
            descricaoFormulaDataLimite: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricaoFormulaDataLimite),
            situacoes: ConverterParameterObjectToUrlUtils.atributoCodigoArray(dadosFormulario.situacoes),
            dataBaseInicioVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseInicioVigencia),
            dataBaseFimVigencia: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseFimVigencia)
        };
        return this.configuracaoEsperadoApiService.incluir(dados).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Configuração de esperado incluído com sucesso.');
                _this.voltar();
            }
        });
    };
    ConfiguracaoEsperadoInclusaoController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-esperado-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return ConfiguracaoEsperadoInclusaoController;
}());
ConfiguracaoEsperadoInclusaoController.$inject = ['$state', 'feedbackService', 'ConfiguracaoEsperadoApiService'];
angular.module('crd').controller('ConfiguracaoEsperadoInclusaoController', ConfiguracaoEsperadoInclusaoController);
//# sourceMappingURL=configuracao-esperado-inclusao-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('documento.configuracao-pre-processamento-consultar', {
        controller: 'ConfiguracaoPreProcessamentoConsultaController',
        controllerAs: 'configuracaoPreProcessamentoConsultaCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de pré-processamento',
            titulo: 'Configuração de pré-processamento',
            outros: {
                activeTab: 'documento.configuracao-pre-processamento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/documento/configuracao-pre-processamento/views/configuracao-pre-processamento-consulta/configuracao-pre-processamento-consulta-tpl.html',
        url: '/configuracao-pre-processamento?numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('documento.configuracao-pre-processamento-detalhar', {
        controller: 'ConfiguracaoPreProcessamentoDetalheController',
        controllerAs: 'configuracaoPreProcessamentoDetalheCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de pré-processamento',
            titulo: 'Configuração de pré-processamento',
            outros: {
                activeTab: 'documento.configuracao-pre-processamento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-pre-processamento/views/configuracao-pre-processamento-detalhe/configuracao-pre-processamento-detalhe-tpl.html',
        url: '/configuracao-pre-processamento/:id/detalhar'
    })
        .state('documento.configuracao-pre-processamento-incluir', {
        controller: 'ConfiguracaoPreProcessamentoInclusaoController',
        controllerAs: 'configuracaoPreProcessamentoInclusaoCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de pré-processamento',
            titulo: 'Configuração de pré-processamento',
            outros: {
                activeTab: 'documento.configuracao-pre-processamento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-pre-processamento/views/configuracao-pre-processamento-inclusao/configuracao-pre-processamento-inclusao-tpl.html',
        url: '/configuracao-pre-processamento/incluir'
    })
        .state('documento.configuracao-pre-processamento-alterar', {
        controller: 'ConfiguracaoPreProcessamentoAlteracaoController',
        controllerAs: 'configuracaoPreProcessamentoAlteracaoCtrl',
        informacaoPagina: {
            codigo: 'XXXXXX',
            label: 'Configuração de pré-processamento',
            titulo: 'Configuração de pré-processamento',
            outros: {
                activeTab: 'documento.configuracao-pre-processamento'
            }
        },
        parent: 'documento',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/documento/configuracao-pre-processamento/views/configuracao-pre-processamento-alteracao/configuracao-pre-processamento-alteracao-tpl.html',
        url: '/configuracao-pre-processamento/:id/alterar'
    });
});
//# sourceMappingURL=configuracao-pre-processamento-route-config.js.map;
"use strict";
//# sourceMappingURL=configuracao-pre-processamento-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=configuracao-pre-processamento-consulta-resultado-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-pre-processamento-detalhe-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-pre-processamento-manutencao-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-pre-processamento-para-alterar-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-pre-processamento-para-consultar-dto.js.map;
"use strict";
//# sourceMappingURL=configuracao-pre-processamento-para-incluir-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ConfiguracaoPreProcessamentoApiService = (function (_super) {
    __extends(ConfiguracaoPreProcessamentoApiService, _super);
    function ConfiguracaoPreProcessamentoApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    ConfiguracaoPreProcessamentoApiService.prototype.alterar = function (id, dados) {
        return this.alterarRecurso("/configuracao-pre-processamento/" + id + "/alterar", dados);
    };
    ConfiguracaoPreProcessamentoApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/configuracao-pre-processamento/consultar', consultaFiltro);
    };
    ConfiguracaoPreProcessamentoApiService.prototype.detalhar = function (id) {
        return this.buscarRecurso("/configuracao-pre-processamento/" + id + "/detalhar", {});
    };
    ConfiguracaoPreProcessamentoApiService.prototype.excluir = function (id) {
        return this.excluirRecurso("/configuracao-pre-processamento/" + id + "/excluir", {});
    };
    ConfiguracaoPreProcessamentoApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso('/configuracao-pre-processamento/incluir', dados);
    };
    ConfiguracaoPreProcessamentoApiService.prototype.paraAlterar = function (id) {
        return this.buscarRecurso("/configuracao-pre-processamento/" + id + "/para-alterar", {});
    };
    ConfiguracaoPreProcessamentoApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/configuracao-pre-processamento/para-consultar', consultaFiltro);
    };
    ConfiguracaoPreProcessamentoApiService.prototype.paraIncluir = function (documentoId) {
        return this.buscarRecurso('/configuracao-pre-processamento/para-incluir', { documentoId: documentoId });
    };
    return ConfiguracaoPreProcessamentoApiService;
}(AbstractAPISerivce));
ConfiguracaoPreProcessamentoApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('ConfiguracaoPreProcessamentoApiService', ConfiguracaoPreProcessamentoApiService);
//# sourceMappingURL=configuracao-pre-processamento-api-service.js.map;
"use strict";
var ConfiguracaoPreProcessamentoAlteracaoController = (function () {
    function ConfiguracaoPreProcessamentoAlteracaoController($state, feedbackService, configuracaoPreProcessamentoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoPreProcessamentoApiService = configuracaoPreProcessamentoApiService;
    }
    ConfiguracaoPreProcessamentoAlteracaoController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoPreProcessamentoApiService.paraAlterar(this.$state.params.id).then(function (response) {
            if (response.data) {
                _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
                _this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento);
                _this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento);
                _this.opcoesDeData = FormataDataPeriodicidade.formatoDataPorGrupoPeriodidicade(_this.dadosParaConstruirFormulario.grupoPeriodicidade);
                _this.dadosFormulario = response.data.dadosFormulario;
                _this.dadosFormulario.dataBaseInicioVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseInicioVigencia);
                _this.dadosFormulario.dataBaseFimVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseFimVigencia);
            }
        });
    };
    ;
    ConfiguracaoPreProcessamentoAlteracaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            documentoId: this.$state.params.documentoPk,
            validaLeiaute: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.validaLeiaute),
            protocoloUnicoAceitoPorDatabase: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.protocoloUnicoAceitoPorDatabase),
            gerarArquivoResultado: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.gerarArquivoResultado),
            diaReferencia: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.diaReferencia),
            protocoloDeTransferencia: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.protocoloDeTransferencia),
            diretorioNomeArquivo: ConverterParameterObjectToUrlUtils.string(dadosFormulario.diretorioNomeArquivo),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseInicioVigencia),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseFimVigencia),
            validacoesProcessamento: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.validacoes)
        };
        return this.configuracaoPreProcessamentoApiService.alterar(this.$state.params.id, dados).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Configuração de pré-processamento alterado com sucesso.');
                _this.voltar();
            }
        });
    };
    ConfiguracaoPreProcessamentoAlteracaoController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-pre-processamento-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return ConfiguracaoPreProcessamentoAlteracaoController;
}());
ConfiguracaoPreProcessamentoAlteracaoController.$inject = ['$state', 'feedbackService', 'ConfiguracaoPreProcessamentoApiService'];
angular.module('crd').controller('ConfiguracaoPreProcessamentoAlteracaoController', ConfiguracaoPreProcessamentoAlteracaoController);
//# sourceMappingURL=configuracao-pre-processamento-alteracao-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ConfiguracaoPreProcessamentoConsultaController = (function (_super) {
    __extends(ConfiguracaoPreProcessamentoConsultaController, _super);
    function ConfiguracaoPreProcessamentoConsultaController($stateParams, $scope, feedbackService, configuracaoPreProcessamentoApiService) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.configuracaoPreProcessamentoApiService = configuracaoPreProcessamentoApiService;
        return _this;
    }
    ConfiguracaoPreProcessamentoConsultaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        consultaFiltro.documentos = [this.$stateParams.documentoPk];
        return this.configuracaoPreProcessamentoApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.acao = response.data.acao;
            _this.pagina = response.data.pagina;
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
            return response;
        });
    };
    ConfiguracaoPreProcessamentoConsultaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.configuracaoPreProcessamentoApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            return response;
        });
    };
    ConfiguracaoPreProcessamentoConsultaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        return {
            documentos: [this.$stateParams.documentoPk]
        };
    };
    ConfiguracaoPreProcessamentoConsultaController.prototype.limparDadosFormulario = function (dadosFormulario) {
    };
    ConfiguracaoPreProcessamentoConsultaController.prototype.excluir = function (id) {
        var _this = this;
        return this.configuracaoPreProcessamentoApiService.excluir(id).then(function (response) {
            _super.prototype.consultar.call(_this, _this.dadosFormulario).then(function () { return _this.feedbackService.sucesso('Configuração de pré-processamento excluído com sucesso.'); });
            return response;
        });
    };
    return ConfiguracaoPreProcessamentoConsultaController;
}(AbstractPaginaConsultaController));
ConfiguracaoPreProcessamentoConsultaController.$inject = ['$stateParams', '$scope', 'feedbackService', 'ConfiguracaoPreProcessamentoApiService'];
angular.module('crd').controller('ConfiguracaoPreProcessamentoConsultaController', ConfiguracaoPreProcessamentoConsultaController);
//# sourceMappingURL=configuracao-pre-processamento-consulta-controller.js.map;
"use strict";
var ConfiguracaoPreProcessamentoDetalheController = (function () {
    function ConfiguracaoPreProcessamentoDetalheController($state, feedbackService, configuracaoPreProcessamentoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoPreProcessamentoApiService = configuracaoPreProcessamentoApiService;
    }
    ConfiguracaoPreProcessamentoDetalheController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoPreProcessamentoApiService.detalhar(this.$state.params.id).then(function (response) {
            _this.item = response.data;
        });
    };
    ;
    ConfiguracaoPreProcessamentoDetalheController.prototype.excluir = function (id) {
        var _this = this;
        return this.configuracaoPreProcessamentoApiService.excluir(id).then(function (response) {
            _this.feedbackService.sucesso('Configuração de pré-processamento excluído com sucesso.');
            _this.voltar();
            return response;
        });
    };
    ConfiguracaoPreProcessamentoDetalheController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-pre-processamento-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return ConfiguracaoPreProcessamentoDetalheController;
}());
ConfiguracaoPreProcessamentoDetalheController.$inject = ['$state', 'feedbackService', 'ConfiguracaoPreProcessamentoApiService'];
angular.module('crd').controller('ConfiguracaoPreProcessamentoDetalheController', ConfiguracaoPreProcessamentoDetalheController);
//# sourceMappingURL=configuracao-pre-processamento-detalhe-controller.js.map;
"use strict";
var ConfiguracaoPreProcessamentoInclusaoController = (function () {
    function ConfiguracaoPreProcessamentoInclusaoController($state, feedbackService, configuracaoPreProcessamentoApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.configuracaoPreProcessamentoApiService = configuracaoPreProcessamentoApiService;
    }
    ConfiguracaoPreProcessamentoInclusaoController.prototype.$onInit = function () {
        var _this = this;
        return this.configuracaoPreProcessamentoApiService.paraIncluir(this.$state.params.documentoPk).then(function (response) {
            if (response.data) {
                _this.dadosParaConstruirFormulario = response.data.dadosParaConstruirFormulario;
                _this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseInicioVigenciaDocumento);
                _this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseFimVigenciaDocumento);
                _this.opcoesDeData = FormataDataPeriodicidade.formatoDataPorGrupoPeriodidicade(_this.dadosParaConstruirFormulario.grupoPeriodicidade);
                _this.dadosFormulario = response.data.dadosFormulario;
                _this.dadosFormulario.dataBaseInicioVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseInicioVigencia);
                _this.dadosFormulario.dataBaseFimVigencia = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.dataBaseFimVigencia);
            }
        });
    };
    ;
    ConfiguracaoPreProcessamentoInclusaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            documentoId: this.$state.params.documentoPk,
            validaLeiaute: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.validaLeiaute),
            protocoloUnicoAceitoPorDatabase: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.protocoloUnicoAceitoPorDatabase),
            gerarArquivoResultado: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.gerarArquivoResultado),
            diaReferencia: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.diaReferencia),
            protocoloDeTransferencia: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.protocoloDeTransferencia),
            diretorioNomeArquivo: ConverterParameterObjectToUrlUtils.string(dadosFormulario.diretorioNomeArquivo),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseInicioVigencia),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBaseFimVigencia),
            validacoesProcessamento: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.validacoes)
        };
        return this.configuracaoPreProcessamentoApiService.incluir(dados).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Configuração de pré-processamento incluído com sucesso.');
                _this.voltar();
            }
        });
    };
    ConfiguracaoPreProcessamentoInclusaoController.prototype.voltar = function () {
        this.$state.go('documento.configuracao-pre-processamento-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return ConfiguracaoPreProcessamentoInclusaoController;
}());
ConfiguracaoPreProcessamentoInclusaoController.$inject = ['$state', 'feedbackService', 'ConfiguracaoPreProcessamentoApiService'];
angular.module('crd').controller('ConfiguracaoPreProcessamentoInclusaoController', ConfiguracaoPreProcessamentoInclusaoController);
//# sourceMappingURL=configuracao-pre-processamento-inclusao-controller.js.map;
"use strict";
var DocumentoAlterarController = (function () {
    function DocumentoAlterarController($state, documentoApiService, feedbackService) {
        this.$state = $state;
        this.documentoApiService = documentoApiService;
        this.feedbackService = feedbackService;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    DocumentoAlterarController.prototype.observerChangeTipoDispensa = function (tipoDispensa) {
        if (!tipoDispensa.permiteDispensa) {
            this.documento.impactoDispensa = undefined;
        }
    };
    DocumentoAlterarController.prototype.observerChangeTipoDocumento = function (tipodocumento) {
        if (!tipodocumento.preencheAgrupador) {
            this.documento.documentoAgrupador = undefined;
        }
    };
    DocumentoAlterarController.prototype.observerChangeCaptacaoEstruturada = function (captacaoEstruturada) {
        if (captacaoEstruturada) {
            this.documento.fonteInformacaoResource = { "codigo": 1, "enumName": "NORMA", "nome": "Norma" };
            this.documento.instituicaoFornecedoraDeInformacao = undefined;
        }
    };
    DocumentoAlterarController.prototype.observerChangeFonteInformacao = function (fonteInformacao) {
        if (fonteInformacao.enumName != 'CONVENIO') {
            this.documento.instituicaoFornecedoraDeInformacao = undefined;
        }
    };
    DocumentoAlterarController.prototype.observerChangeDocumentoDeConglomerado = function (documentoDeConglomerado) {
        if (!documentoDeConglomerado) {
            this.documento.tipoConglomerado = undefined;
        }
    };
    DocumentoAlterarController.prototype.observerChangePeriodicidades = function (periodicidades) {
        this.opcoesDeData = FormataDataPeriodicidade.formatoPelaMenorPeriodicidade(periodicidades);
    };
    DocumentoAlterarController.prototype.observerWhenTipoDispensaDisabled = function (documento) {
        if (this.documento
            && this.documento.tiposPeriodicidade) {
            var enumNameTiposPeriodicidade = _.map(this.documento.tiposPeriodicidade, function (tipo) { return tipo.enumName; });
            if (_.contains(enumNameTiposPeriodicidade, "EVENTUAL_MENOR_QUE_DIARIA")
                || _.contains(enumNameTiposPeriodicidade, "EVENTUAL_DIARIA")) {
                _.each(this.dadosFormulario.tiposDispensa, function (tipo) {
                    if (tipo.enumName == "NAO_PERMITE_DISPENSA") {
                        documento.tipoDispensa = tipo;
                    }
                });
                return true;
            }
        }
        return false;
    };
    DocumentoAlterarController.prototype.voltar = function () {
        this.$state.go('documento.dados-gerais-detalhar', { documentoPk: this.$state.params.documentoPk });
    };
    DocumentoAlterarController.prototype.salvar = function (documentoAlterar) {
        var _this = this;
        var documento = this.converterParaEnviarServidor(documentoAlterar);
        this.documentoApiService.alterar(this.$state.params.documentoPk, documento).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Documento salvo com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    DocumentoAlterarController.prototype.converterParaEnviarServidor = function (documentoAlterar) {
        documentoAlterar.vigencia.inicio = this.opcoesDeData.normatizar(documentoAlterar.vigencia.inicio);
        return {
            codigo: ConverterParameterObjectToUrlUtils.string(documentoAlterar.codigo),
            codigoConvenio: ConverterParameterObjectToUrlUtils.atributoIdBacen(documentoAlterar.instituicaoFornecedoraDeInformacao),
            conceito: ConverterParameterObjectToUrlUtils.string(documentoAlterar.conceito),
            documentoAgrupador: ConverterParameterObjectToUrlUtils.atributoPK(documentoAlterar.documentoAgrupador),
            documentosMestres: ConverterParameterObjectToUrlUtils.atributoPKArray(documentoAlterar.documentosMestres),
            captacaoEstruturada: ConverterParameterObjectToUrlUtils.boolean(documentoAlterar.captacaoEstruturada),
            documentoDeConglomerado: ConverterParameterObjectToUrlUtils.boolean(documentoAlterar.documentoDeConglomerado),
            fonteInformacao: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoAlterar.fonteInformacaoResource),
            emailCorporativo: documentoAlterar.emailsCorporativo,
            impactoDispensa: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoAlterar.impactoDispensa),
            nome: ConverterParameterObjectToUrlUtils.string(documentoAlterar.nome),
            periodicidades: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(documentoAlterar.tiposPeriodicidade),
            publicaPortal: ConverterParameterObjectToUrlUtils.boolean(documentoAlterar.publicaPortal),
            sigla: ConverterParameterObjectToUrlUtils.string(documentoAlterar.sigla),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(documentoAlterar.sistemaNegocio),
            tipoConglomerado: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoAlterar.tipoConglomerado),
            tipoDispensa: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoAlterar.tipoDispensa),
            tipoDocumento: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoAlterar.tipoDocumento),
            vigencia: {
                inicio: ConverterParameterObjectToUrlUtils.date(documentoAlterar.vigencia.inicio)
            }
        };
    };
    DocumentoAlterarController.prototype.carregarDados = function (documentoPk) {
        var _this = this;
        return this.documentoApiService.montarTelaAlterar(documentoPk).then(function (resource) {
            _this.dadosFormulario = resource;
            _this.documento = resource.documento;
            _this.removerValidacaoCampoEmails();
            _this.documento.vigencia.inicio = ConverterParameterUrlToObjectUtils.date('' + resource.documento.vigencia.inicio);
            _this.observerChangePeriodicidades(_this.documento.tiposPeriodicidade);
            return resource;
        });
    };
    DocumentoAlterarController.prototype.removerValidacaoCampoEmails = function () {
        if (!this.documento.emailsCorporativo || this.documento.emailsCorporativo.length < 1) {
            $("#in-emails-corporativo").removeClass("ng-invalid");
        }
    };
    DocumentoAlterarController.prototype.$onInit = function () {
        return this.carregarDados(this.$state.params.documentoPk);
    };
    ;
    return DocumentoAlterarController;
}());
DocumentoAlterarController.$inject = ['$state', 'documentoApiService', 'feedbackService'];
angular.module('crd').controller('DocumentoAlterarController', DocumentoAlterarController);
//# sourceMappingURL=documento-alterar-controller.js.map;
"use strict";
var DocumentoDetalharController = (function () {
    function DocumentoDetalharController($state, documentoApiService) {
        this.$state = $state;
        this.documentoApiService = documentoApiService;
    }
    DocumentoDetalharController.prototype.carregarDados = function (pk) {
        var _this = this;
        return this.documentoApiService.detalhar(pk).then(function (resource) {
            _this.documento = resource;
        });
    };
    DocumentoDetalharController.prototype.$onInit = function () {
        return this.carregarDados(this.$state.params.documentoPk);
    };
    ;
    return DocumentoDetalharController;
}());
DocumentoDetalharController.$inject = ['$state', 'documentoApiService'];
angular.module('crd').controller('DocumentoDetalharController', DocumentoDetalharController);
//# sourceMappingURL=documento-detalhar-controller.js.map;
"use strict";
var DocumentoEncerrarController = (function () {
    function DocumentoEncerrarController($uibModalInstance, feedbackService, documentoApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
    }
    DocumentoEncerrarController.prototype.cancel = function () {
        this.feedbackService.limpar();
        this.$uibModalInstance.dismiss('cancel');
    };
    DocumentoEncerrarController.prototype.encerrar = function (dadosFormulario) {
        var _this = this;
        var encerrarDocumento = this.converterParametrosParaUrl(dadosFormulario);
        return this.documentoApiService.encerrar(this.dadosIniciais.documento.pk, encerrarDocumento).then(function (resource) {
            if (resource.status === 200) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Documento encerrado com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    DocumentoEncerrarController.prototype.converterParametrosParaUrl = function (dadosFormulario) {
        return {
            dataFim: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataFim),
            motivo: ConverterParameterObjectToUrlUtils.string(dadosFormulario.motivo)
        };
    };
    DocumentoEncerrarController.prototype.$onInit = function () {
        this.encerrarDocumento = {};
    };
    return DocumentoEncerrarController;
}());
DocumentoEncerrarController.$inject = ['$uibModalInstance', 'feedbackService', 'documentoApiService'];
angular.module('crd').controller('DocumentoEncerrarController', DocumentoEncerrarController);
//# sourceMappingURL=documento-encerrar-controller.js.map;
"use strict";
var DocumentoIncluirController = (function () {
    function DocumentoIncluirController($state, documentoApiService, feedbackService) {
        this.$state = $state;
        this.documentoApiService = documentoApiService;
        this.feedbackService = feedbackService;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    DocumentoIncluirController.prototype.carregarDados = function () {
        var _this = this;
        return this.documentoApiService.montarTelaIncluir().then(function (resource) {
            _this.removerValidacaoCampoEmails();
            _this.dadosFormulario = resource;
            return resource;
        });
    };
    DocumentoIncluirController.prototype.removerValidacaoCampoEmails = function () {
        $("#in-emails-corporativo").removeClass("ng-invalid");
    };
    DocumentoIncluirController.prototype.observerChangeTipoDispensa = function (tipoDispensa) {
        if (!tipoDispensa.permiteDispensa) {
            this.documento.impactoDispensa = undefined;
        }
    };
    DocumentoIncluirController.prototype.observerChangeTipoDocumento = function (tipodocumento) {
        if (!tipodocumento.preencheAgrupador) {
            this.documento.documentoAgrupador = undefined;
        }
    };
    DocumentoIncluirController.prototype.observerChangeCaptacaoEstruturada = function (captacaoEstruturada) {
        if (captacaoEstruturada) {
            this.documento.fonteInformacao = { codigo: "1", nome: "Norma", enumName: "NORMA" };
            this.documento.instituicaoFornecedoraDeInformacao = undefined;
        }
        else {
            this.documento.fonteInformacao = undefined;
        }
    };
    DocumentoIncluirController.prototype.observerChangeFonteInformacao = function (fonteInformacao) {
        if (fonteInformacao.enumName != 'CONVENIO') {
            this.documento.instituicaoFornecedoraDeInformacao = undefined;
        }
    };
    DocumentoIncluirController.prototype.observerChangeDocumentoDeConglomerado = function (documentoDeConglomerado) {
        if (!documentoDeConglomerado) {
            this.documento.tipoConglomerado = undefined;
        }
    };
    DocumentoIncluirController.prototype.observerChangePeriodicidades = function (periodicidades) {
        this.opcoesDeData = FormataDataPeriodicidade.formatoPelaMenorPeriodicidade(periodicidades);
    };
    DocumentoIncluirController.prototype.observerWhenTipoDispensaDisabled = function (documento) {
        if (this.documento
            && this.documento.tiposPeriodicidade) {
            var enumNameTiposPeriodicidade = _.map(this.documento.tiposPeriodicidade, function (tipo) { return tipo.enumName; });
            if (_.contains(enumNameTiposPeriodicidade, "EVENTUAL_MENOR_QUE_DIARIA")
                || _.contains(enumNameTiposPeriodicidade, "EVENTUAL_DIARIA")) {
                _.each(this.dadosFormulario.tiposDispensa, function (tipo) {
                    if (tipo.enumName == "NAO_PERMITE_DISPENSA") {
                        documento.tipoDispensa = tipo;
                    }
                });
                return true;
            }
        }
        return false;
    };
    DocumentoIncluirController.prototype.voltar = function () {
        this.$state.go('documento-listar');
    };
    DocumentoIncluirController.prototype.salvar = function (documentoIncluir) {
        var _this = this;
        var documento = this.converterParaEnviarServidor(documentoIncluir);
        this.documentoApiService.criar(documento).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso('Documento salvo com sucesso!');
                _this.$state.go('documento.dados-gerais-detalhar', { documentoPk: angular.fromJson(resource.data).pk });
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    DocumentoIncluirController.prototype.converterParaEnviarServidor = function (documentoIncluir) {
        documentoIncluir.vigencia.inicio = this.opcoesDeData.normatizar(documentoIncluir.vigencia.inicio);
        return {
            codigo: ConverterParameterObjectToUrlUtils.string(documentoIncluir.codigo),
            codigoConvenio: ConverterParameterObjectToUrlUtils.atributoIdBacen(documentoIncluir.instituicaoFornecedoraDeInformacao),
            conceito: ConverterParameterObjectToUrlUtils.string(documentoIncluir.conceito),
            documentoAgrupador: ConverterParameterObjectToUrlUtils.atributoPK(documentoIncluir.documentoAgrupador),
            documentosMestres: ConverterParameterObjectToUrlUtils.atributoPKArray(documentoIncluir.documentosMestres),
            captacaoEstruturada: ConverterParameterObjectToUrlUtils.boolean(documentoIncluir.captacaoEstruturada),
            documentoDeConglomerado: ConverterParameterObjectToUrlUtils.boolean(documentoIncluir.documentoDeConglomerado),
            fonteInformacao: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoIncluir.fonteInformacao),
            emailCorporativo: documentoIncluir.emailsCorporativo,
            impactoDispensa: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoIncluir.impactoDispensa),
            nome: ConverterParameterObjectToUrlUtils.string(documentoIncluir.nome),
            periodicidades: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(documentoIncluir.tiposPeriodicidade),
            publicaPortal: ConverterParameterObjectToUrlUtils.boolean(documentoIncluir.publicaPortal),
            sigla: ConverterParameterObjectToUrlUtils.string(documentoIncluir.sigla),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(documentoIncluir.sistemaNegocio),
            tipoConglomerado: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoIncluir.tipoConglomerado),
            tipoDispensa: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoIncluir.tipoDispensa),
            tipoDocumento: ConverterParameterObjectToUrlUtils.atributoEnumName(documentoIncluir.tipoDocumento),
            vigencia: {
                inicio: ConverterParameterObjectToUrlUtils.date(documentoIncluir.vigencia.inicio)
            }
        };
    };
    DocumentoIncluirController.prototype.$onInit = function () {
        return this.carregarDados();
    };
    ;
    return DocumentoIncluirController;
}());
DocumentoIncluirController.$inject = ['$state', 'documentoApiService', 'feedbackService'];
angular.module('crd').controller('DocumentoIncluirController', DocumentoIncluirController);
//# sourceMappingURL=documento-incluir-controller.js.map;
(function (angular, moment, parametrosUrl) {
  'use strict';

  var FORMATO_DDMMYYYY = 'DD/MM/YYYY';

  angular
    .module('crd')
    .controller('DocumentoListarController', DocumentoListarController);

  DocumentoListarController.$inject = [
    '$scope',
    '$location',
    '$stateParams',
    '$uibModal',
    'documentoApiService',
    'feedbackService',
  ];

  function DocumentoListarController(
    $scope,
    $location,
    $stateParams,
    $uibModal,
    documentoApiService,
    feedbackService
  ) {
    var vm = this;

    vm.view = {
      formulario: {
        visivel: true
      },
      resultado: {
        visivel: false
      }
    };

    vm.limparMensagens = limparMensagens;
    vm.navegarNaGrid = navegarNaGrid;
    vm.realizarPesquisa = realizarPesquisa;
    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.gerarXLS = gerarXLS;
    vm.exibirResultadoPesquisa = exibirResultadoPesquisa;
    vm.esconderResultadoPesquisa = esconderResultadoPesquisa;
    vm.ativar = ativar;
    vm.excluir = excluir;
    vm.abrirModalEncerrar = abrirModalEncerrar;

    carregarTela();

    function carregarTela() {
      return documentoApiService
        .telaPesquisar()
        .then(successOnCarregarTela);

      function successOnCarregarTela(resource) {
        vm.podeIncluir = resource._links['crd-documentos-criar'];
        vm.sistemasNegocio = resource._embedded.sistemasNegocio;
        vm.agentesCuradoria = resource._embedded.agentesDeCuradoria;

        vm.parametrosPesquisa = extrairParametrosDaUrl($stateParams);
        fazerPesquisaInicial(resource);

        pesquisar(vm.parametrosPesquisa);
      }
    }

    function fazerPesquisaInicial(resource) {
      if (!pesquisaRealizada() && resource.fazerPesquisaInicial) {
        vm.parametrosPesquisa = {
          agenteCuradoria: {
            nome:  resource._embedded.agenteDeCuradoria.nome,
            operador:  resource._embedded.agenteDeCuradoria.operador,
            unidade:  resource._embedded.agenteDeCuradoria.unidade
          },
          sistemasNegocio: resource._embedded.sistemasNegocioDoCurador
        }
      }
    }

    function pesquisaRealizada() {
      if (_.compact(_.values($stateParams)).length) {
        return true;
      }
      return false;
    }

    function navegarNaGrid(pagination) {
      vm.parametrosPesquisa.numeroPagina = pagination.number;
      vm.parametrosPesquisa.quantidadePorPagina = pagination.size;
      vm.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
      vm.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;

      return pesquisar(vm.parametrosPesquisa);
    }

    function realizarPesquisa(parametrosPesquisa) {
      parametrosPesquisa.numeroPagina = undefined;
      parametrosPesquisa.ordenacaoCampo = undefined;
      parametrosPesquisa.ordenacaoDirecao = undefined;

      return pesquisar(parametrosPesquisa);
    }

    function pesquisar(parametrosPesquisa) {
      const parametros = montarParametrosDaUrl(parametrosPesquisa);
      $location.search(parametros);

      return documentoApiService.pesquisar(parametros).then(function(resultado) {
        vm.pagina = resultado;
        vm.exibirResultadoPesquisa();

        return resultado;
      });
    }

    function abrirModalEncerrar(documento) {
      const scope = $scope.$new();
      scope.dadosIniciais = {
        documento: documento
      };

      $uibModal.open({
        templateUrl: 'views/documento/documento-encerrar/documento-encerrar-tpl.html',
        controller: 'DocumentoEncerrarController',
        controllerAs: 'docEncerrarCtrl',
        bindToController: true,
        scope: scope,
        size: 'md'
      }).result.then(function () {
        pesquisar(vm.parametrosPesquisa);
      });
    }

    function gerarXLS() {
      var searchParameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      documentoApiService.gerarXLS(searchParameters).then(function successOnGerarXLS() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
      });
    }

    function exibirResultadoPesquisa() {
      vm.view.resultado.visivel = true;
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function ativar(pk) {
      return documentoApiService.ativar(pk).then(function (resource) {
        if (resource.status === 200) {
          feedbackService.sucesso('Documento ativado com sucesso.');
          pesquisar(vm.parametrosPesquisa);
        } else {
          this.feedbackService.violacoes(resource.data);
        }
      });
    }

    function excluir(pk) {
      return documentoApiService.excluir(pk).then(function (resource) {
        if (resource.status === 200) {
          feedbackService.sucesso('Documento excluído com sucesso.');
          pesquisar(vm.parametrosPesquisa);
        } else {
          this.feedbackService.violacoes(resource.data);
        }
      });
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.sistemaNegocio = undefined;
      vm.parametrosPesquisa.documento = undefined;
      vm.parametrosPesquisa.agenteCuradoria = undefined;

      vm.limparMensagens();
      vm.esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }
  }

  function formatarData(data, formato) {
    return moment(data).format(formato);
  }

  function montarParametrosDaUrl(parametrosPesquisa) {
    return {
      documento: parametrosPesquisa.documento,
      sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.sistemaNegocio),
      operador: parametrosPesquisa.agenteCuradoria ? parametrosPesquisa.agenteCuradoria.operador : null,
      unidade: parametrosPesquisa.agenteCuradoria ? parametrosPesquisa.agenteCuradoria.unidade : null,

      numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
      quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
      ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
      ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
    };
  }

  function extrairParametrosDaUrl(paramsURL) {
    var extrator = parametrosUrl.Extrator;
    return {
      documento: paramsURL.documento,
      sistemaNegocio: extrator.objetoPk(paramsURL.sistemaNegocio),
      agenteCuradoria: paramsURL.operador ? {
        operador: paramsURL.operador,
        unidade: paramsURL.unidade
      } : null,
      numeroPagina: ConverterParameterUrlToObjectUtils.number(paramsURL.numeroPagina),
      quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(paramsURL.quantidadePorPagina),
      ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(paramsURL.ordenacaoCampo),
      ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(paramsURL.ordenacaoDirecao)
    };
  }
})(angular, moment, CRDUtils.ParametrosUrl);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('DocumentoTemplateController', DocumentoTemplateController);

  DocumentoTemplateController.$inject = ['$stateParams', 'documentoApiService'];

  function DocumentoTemplateController($stateParams, documentoApiService) {
    var vm = this;
    activate();

    function activate() {
      documentoApiService.montarTelaGeral($stateParams.documentoPk).then(function(resource) {
        vm.documento = resource;
      });
    }
  }
})(angular);
;
"use strict";
var EquipeGestoraDocumentoListarController = (function () {
    function EquipeGestoraDocumentoListarController($scope, $location, $state, $uibModal, equipeGestoraDocumentoApiService, feedbackService) {
        this.$scope = $scope;
        this.$location = $location;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.equipeGestoraDocumentoApiService = equipeGestoraDocumentoApiService;
        this.feedbackService = feedbackService;
    }
    EquipeGestoraDocumentoListarController.prototype.abrirModalAlterar = function (equipeGestoraDocumento) {
        var dados = {
            documentoPk: this.$state.params.documentoPk,
            equipeGestoraDocumentoPk: equipeGestoraDocumento.pk,
            rotulo: equipeGestoraDocumento.rotulo
        };
        this.abrirModalManutencao(dados);
    };
    EquipeGestoraDocumentoListarController.prototype.abrirModalIncluir = function () {
        var dados = {
            documentoPk: this.$state.params.documentoPk
        };
        this.abrirModalManutencao(dados);
    };
    EquipeGestoraDocumentoListarController.prototype.abrirModalManutencao = function (dados) {
        var _this = this;
        var scope = this.$scope.$new();
        scope.dadosIniciais = dados;
        this.$uibModal.open({
            templateUrl: 'views/documento/equipe-gestora-documento/equipe-gestora-documento-manutencao-tpl.html',
            controller: 'EquipeGestoraDocumentoManutencaoController',
            controllerAs: 'egdManutencaoCtrl',
            bindToController: true,
            scope: scope,
            size: 'md'
        }).result.then(function () { return _this.pesquisar(_this.parametrosPesquisa); });
    };
    EquipeGestoraDocumentoListarController.prototype.excluir = function (equipeGestoraDocumentoPk) {
        var _this = this;
        return this.equipeGestoraDocumentoApiService.excluir(equipeGestoraDocumentoPk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Equipe gestora do documento excluída com sucesso!');
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    EquipeGestoraDocumentoListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    EquipeGestoraDocumentoListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(_.omit(parametros, 'documento'));
        return this.equipeGestoraDocumentoApiService.pesquisar(parametros).then(function (resource) {
            _this.pagina = resource._embedded;
            _this.exibirColunaAcoes = _.reduce(resource._embedded.content, function (memo, egd) { return memo || !_.isEmpty(egd._links); }, false);
            return resource;
        });
    };
    EquipeGestoraDocumentoListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    EquipeGestoraDocumentoListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            documento: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.documento),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    EquipeGestoraDocumentoListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    EquipeGestoraDocumentoListarController.prototype.$onInit = function () {
        this.exibirColunaAcoes = true;
        this.parametrosPesquisa = this.converterUrlParaParametros(this.$state.params);
        this.parametrosPesquisa.documento = this.$state.params.documentoPk;
        return this.pesquisar(this.parametrosPesquisa);
    };
    ;
    return EquipeGestoraDocumentoListarController;
}());
EquipeGestoraDocumentoListarController.$inject = ['$scope', '$location', '$state', '$uibModal', 'EquipeGestoraDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('EquipeGestoraDocumentoListarController', EquipeGestoraDocumentoListarController);
//# sourceMappingURL=equipe-gestora-documento-listar-controller.js.map;
"use strict";
var EquipeGestoraDocumentoManutencaoController = (function () {
    function EquipeGestoraDocumentoManutencaoController($uibModalInstance, feedbackService, equipeGestoraDocumentoApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.equipeGestoraDocumentoApiService = equipeGestoraDocumentoApiService;
    }
    EquipeGestoraDocumentoManutencaoController.prototype.cancel = function () {
        this.feedbackService.limpar();
        this.$uibModalInstance.dismiss('cancel');
    };
    EquipeGestoraDocumentoManutencaoController.prototype.salvar = function (equipeGestoraDocumento) {
        var egd = this.converterParametrosParaUrl(equipeGestoraDocumento);
        if (this.dadosIniciais.equipeGestoraDocumentoPk) {
            this.alterar(this.dadosIniciais.equipeGestoraDocumentoPk, egd);
        }
        else {
            this.criar(egd);
        }
    };
    EquipeGestoraDocumentoManutencaoController.prototype.alterar = function (pk, equipeGestoraDocumento) {
        var _this = this;
        return this.equipeGestoraDocumentoApiService.alterar(pk, equipeGestoraDocumento).then(function (resource) {
            if (resource.status === 200) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Equipe gestora do documento salva com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    EquipeGestoraDocumentoManutencaoController.prototype.criar = function (equipeGestoraDocumento) {
        var _this = this;
        return this.equipeGestoraDocumentoApiService.criar(equipeGestoraDocumento).then(function (resource) {
            if (resource.status === 201) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Equipe gestora do documento salva com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    EquipeGestoraDocumentoManutencaoController.prototype.converterParametrosParaUrl = function (dadosFormulario) {
        var rotulo = dadosFormulario.coordenacao ? dadosFormulario.coordenacao.rotulo :
            dadosFormulario.divisao ? dadosFormulario.divisao.rotulo :
                dadosFormulario.gerencia ? dadosFormulario.gerencia.rotulo :
                    dadosFormulario.departamento ? dadosFormulario.departamento.rotulo : undefined;
        return {
            documento: this.dadosIniciais.documentoPk,
            pk: this.dadosIniciais.equipeGestoraDocumentoPk,
            rotulo: ConverterParameterObjectToUrlUtils.string(rotulo)
        };
    };
    EquipeGestoraDocumentoManutencaoController.prototype.observerChangeDepartamento = function (componente) {
        this.equipeGestoraDocumento.gerencia = undefined;
        this.equipeGestoraDocumento.divisao = undefined;
        this.equipeGestoraDocumento.coordenacao = undefined;
    };
    EquipeGestoraDocumentoManutencaoController.prototype.observerChangeGerencia = function (componente) {
        this.equipeGestoraDocumento.divisao = undefined;
        this.equipeGestoraDocumento.coordenacao = undefined;
    };
    EquipeGestoraDocumentoManutencaoController.prototype.observerChangeDivisao = function (componente) {
        this.equipeGestoraDocumento.coordenacao = undefined;
    };
    EquipeGestoraDocumentoManutencaoController.prototype.$onInit = function () {
        var _this = this;
        this.edicao = !!this.dadosIniciais.equipeGestoraDocumentoPk;
        this.equipeGestoraDocumentoApiService.montarTelaManutencao().then(function (result) {
            _this.equipeGestoraDocumento = {};
            _this.dadosFormulario = result;
            var rotulo = _this.dadosIniciais.rotulo ? _this.dadosIniciais.rotulo.split("/") : new Array();
            _this.equipeGestoraDocumento.departamento = rotulo[0] && result.componentes ? _.find(result.componentes, function (componente) { return componente.sigla === rotulo[0]; }) : undefined;
            _this.equipeGestoraDocumento.gerencia = rotulo[1] && _this.equipeGestoraDocumento.departamento ? _.find(_this.equipeGestoraDocumento.departamento.componentes, function (componente) { return componente.sigla === rotulo[1]; }) : undefined;
            _this.equipeGestoraDocumento.divisao = rotulo[2] && _this.equipeGestoraDocumento.gerencia ? _.find(_this.equipeGestoraDocumento.gerencia.componentes, function (componente) { return componente.sigla === rotulo[2]; }) : undefined;
            _this.equipeGestoraDocumento.coordenacao = rotulo[3] && _this.equipeGestoraDocumento.divisao ? _.find(_this.equipeGestoraDocumento.divisao.componentes, function (componente) { return componente.sigla === rotulo[3]; }) : undefined;
        });
    };
    ;
    return EquipeGestoraDocumentoManutencaoController;
}());
EquipeGestoraDocumentoManutencaoController.$inject = ['$uibModalInstance', 'feedbackService', 'EquipeGestoraDocumentoApiService'];
angular.module('crd').controller('EquipeGestoraDocumentoManutencaoController', EquipeGestoraDocumentoManutencaoController);
//# sourceMappingURL=equipe-gestora-documento-manutencao-controller.js.map;
"use strict";
var InformacaoCadastralDocumentoListarController = (function () {
    function InformacaoCadastralDocumentoListarController($scope, $location, $state, $uibModal, informacaoCadastralDocumentoApiService, feedbackService) {
        this.$scope = $scope;
        this.$location = $location;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.informacaoCadastralDocumentoApiService = informacaoCadastralDocumentoApiService;
        this.feedbackService = feedbackService;
    }
    InformacaoCadastralDocumentoListarController.prototype.abrirModalAlterar = function (informacaoCadastralDocumento) {
        var dados = {
            documentoPk: this.$state.params.documentoPk,
            informacaoCadastralDocumentoPk: informacaoCadastralDocumento.pk,
            descricao: informacaoCadastralDocumento.descricao,
            url: informacaoCadastralDocumento.url
        };
        this.abrirModalManutencao(dados);
    };
    InformacaoCadastralDocumentoListarController.prototype.abrirModalIncluir = function () {
        var dados = {
            documentoPk: this.$state.params.documentoPk
        };
        this.abrirModalManutencao(dados);
    };
    InformacaoCadastralDocumentoListarController.prototype.abrirModalManutencao = function (dados) {
        var _this = this;
        var scope = this.$scope.$new();
        scope.dadosIniciais = dados;
        this.$uibModal.open({
            templateUrl: 'views/documento/informacao-cadastral-documento/informacao-cadastral-documento-manutencao-tpl.html',
            controller: 'InformacaoCadastralDocumentoManutencaoController',
            controllerAs: 'incManutencaoCtrl',
            bindToController: true,
            scope: scope,
            size: 'md'
        }).result.then(function () { return _this.pesquisar(_this.parametrosPesquisa); });
    };
    InformacaoCadastralDocumentoListarController.prototype.excluir = function (pk) {
        var _this = this;
        return this.informacaoCadastralDocumentoApiService.excluir(pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Outras informações cadastrais para o documento excluída com sucesso!');
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    InformacaoCadastralDocumentoListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    InformacaoCadastralDocumentoListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(_.omit(parametros, 'documento'));
        return this.informacaoCadastralDocumentoApiService.pesquisar(parametros).then(function (resource) {
            _this.pagina = resource._embedded;
            _this.exibirColunaAcoes = _.reduce(resource._embedded.content, function (memo, inc) { return memo || !_.isEmpty(inc._links); }, false);
            return resource;
        });
    };
    InformacaoCadastralDocumentoListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    InformacaoCadastralDocumentoListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            documento: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.documento),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    InformacaoCadastralDocumentoListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    InformacaoCadastralDocumentoListarController.prototype.$onInit = function () {
        this.exibirColunaAcoes = true;
        this.parametrosPesquisa = this.converterUrlParaParametros(this.$state.params);
        this.parametrosPesquisa.documento = this.$state.params.documentoPk;
        return this.pesquisar(this.parametrosPesquisa);
    };
    ;
    return InformacaoCadastralDocumentoListarController;
}());
InformacaoCadastralDocumentoListarController.$inject = ['$scope', '$location', '$state', '$uibModal', 'InformacaoCadastralDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('InformacaoCadastralDocumentoListarController', InformacaoCadastralDocumentoListarController);
//# sourceMappingURL=informacao-cadastral-documento-listar-controller.js.map;
"use strict";
var InformacaoCadastralDocumentoManutencaoController = (function () {
    function InformacaoCadastralDocumentoManutencaoController($uibModalInstance, feedbackService, informacaoCadastralDocumentoApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.informacaoCadastralDocumentoApiService = informacaoCadastralDocumentoApiService;
    }
    InformacaoCadastralDocumentoManutencaoController.prototype.cancel = function () {
        this.feedbackService.limpar();
        this.$uibModalInstance.dismiss('cancel');
    };
    InformacaoCadastralDocumentoManutencaoController.prototype.salvar = function (informacaoCadastral) {
        var informacaoCadastralDocumento = this.converterParametrosParaUrl(informacaoCadastral);
        if (this.dadosIniciais.informacaoCadastralDocumentoPk) {
            this.alterar(this.dadosIniciais.informacaoCadastralDocumentoPk, informacaoCadastralDocumento);
        }
        else {
            this.criar(informacaoCadastralDocumento);
        }
    };
    InformacaoCadastralDocumentoManutencaoController.prototype.alterar = function (pk, informacaoCadastralDocumento) {
        var _this = this;
        return this.informacaoCadastralDocumentoApiService.alterar(pk, informacaoCadastralDocumento).then(function (resource) {
            if (resource.status === 200) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Outras informações cadastrais para o documento salva com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    InformacaoCadastralDocumentoManutencaoController.prototype.criar = function (informacaoCadastralDocumento) {
        var _this = this;
        return this.informacaoCadastralDocumentoApiService.criar(informacaoCadastralDocumento).then(function (resource) {
            if (resource.status === 201) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Outras informações cadastrais para o documento salva com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    InformacaoCadastralDocumentoManutencaoController.prototype.converterParametrosParaUrl = function (dadosFormulario) {
        return {
            documento: this.dadosIniciais.documentoPk,
            pk: this.dadosIniciais.informacaoCadastralDocumentoPk,
            descricao: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricao),
            url: ConverterParameterObjectToUrlUtils.string(dadosFormulario.url)
        };
    };
    InformacaoCadastralDocumentoManutencaoController.prototype.$onInit = function () {
        this.edicao = !!this.dadosIniciais.informacaoCadastralDocumentoPk;
        this.informacaoCadastralDocumento = {
            descricao: this.dadosIniciais.descricao,
            url: this.dadosIniciais.url
        };
    };
    return InformacaoCadastralDocumentoManutencaoController;
}());
InformacaoCadastralDocumentoManutencaoController.$inject = ['$uibModalInstance', 'feedbackService', 'InformacaoCadastralDocumentoApiService'];
angular.module('crd').controller('InformacaoCadastralDocumentoManutencaoController', InformacaoCadastralDocumentoManutencaoController);
//# sourceMappingURL=informacao-cadastral-documento-manutencao-controller.js.map;
"use strict";
var LeiauteDocumentoFormularioController = (function () {
    function LeiauteDocumentoFormularioController() {
    }
    LeiauteDocumentoFormularioController.prototype.$onInit = function () {
        this.parametros = this.dados.parametros;
        if (this.dados.localizacaoData) {
            this.parametroSelecionado = {
                pk: this.dados.localizacaoData,
                codigoSta: this.dados.codigoSta,
                formatoEnvio: this.dados.formatoEnvio
            };
        }
    };
    LeiauteDocumentoFormularioController.prototype.selecionar = function (parametro) {
        this.dados.localizacaoData = parametro.pk;
    };
    return LeiauteDocumentoFormularioController;
}());
angular.module('crd').component('crdLeiauteDocumentoFormulario', {
    bindings: { dados: '=', salvando: '<' },
    controller: LeiauteDocumentoFormularioController,
    controllerAs: 'ldFormCtrl',
    templateUrl: 'views/documento/leiaute-documento/components/leiaute-documento-formulario-tpl.html'
});
//# sourceMappingURL=leiaute-documento-formulario-controller.js.map;
"use strict";
var LeiauteDocumentoAlteracaoController = (function () {
    function LeiauteDocumentoAlteracaoController($state, leiauteDocumentoApiService, feedbackService) {
        this.$state = $state;
        this.leiauteDocumentoApiService = leiauteDocumentoApiService;
        this.feedbackService = feedbackService;
        this.salvando = false;
    }
    LeiauteDocumentoAlteracaoController.prototype.$onInit = function () {
        var _this = this;
        return this.leiauteDocumentoApiService.paraAlterar(this.$state.params.documentoPk, this.$state.params.leiautePk).then(function (resource) {
            _this.dadosFormulario = resource.dados;
            _this.dadosFormulario.vigenciaInicio = ConverterParameterUrlToObjectUtils.date(resource.dados.vigenciaInicio);
            _this.dadosFormulario.vigenciaFim = ConverterParameterUrlToObjectUtils.date(resource.dados.vigenciaFim);
        }, function (response) { return _this.feedbackService.violacoes(response.data); });
    };
    LeiauteDocumentoAlteracaoController.prototype.salvar = function () {
        var _this = this;
        if (this.salvando) {
            return;
        }
        this.salvando = true;
        return this.leiauteDocumentoApiService.alterar(this.$state.params.documentoPk, this.$state.params.leiautePk, this.dadosFormulario).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Leiaute de entrada alterado com sucesso.');
                return _this.voltar();
            }
            return _this.feedbackService.violacoes(response.data);
        }, function (response) { return _this.feedbackService.violacoes(response.data); })["finally"](function () {
            _this.salvando = false;
        });
    };
    LeiauteDocumentoAlteracaoController.prototype.voltar = function () {
        return this.$state.go('documento.leiautes-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return LeiauteDocumentoAlteracaoController;
}());
LeiauteDocumentoAlteracaoController.$inject = ['$state', 'LeiauteDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('LeiauteDocumentoAlteracaoController', LeiauteDocumentoAlteracaoController);
//# sourceMappingURL=leiaute-documento-alteracao-controller.js.map;
"use strict";
var LeiauteDocumentoDetalheController = (function () {
    function LeiauteDocumentoDetalheController($state, leiauteDocumentoApiService, feedbackService) {
        this.$state = $state;
        this.leiauteDocumentoApiService = leiauteDocumentoApiService;
        this.feedbackService = feedbackService;
        this.permiteAlterar = false;
    }
    LeiauteDocumentoDetalheController.prototype.$onInit = function () {
        var _this = this;
        return this.leiauteDocumentoApiService.detalhar(this.$state.params.documentoPk, this.$state.params.leiautePk).then(function (resource) {
            _this.item = resource.dados;
            _this.permiteAlterar = !!resource._links['crd-leiaute-documento-alterar'];
        }, function (response) { return _this.feedbackService.violacoes(response.data); });
    };
    LeiauteDocumentoDetalheController.prototype.voltar = function () {
        return this.$state.go('documento.leiautes-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return LeiauteDocumentoDetalheController;
}());
LeiauteDocumentoDetalheController.$inject = ['$state', 'LeiauteDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('LeiauteDocumentoDetalheController', LeiauteDocumentoDetalheController);
//# sourceMappingURL=leiaute-documento-detalhe-controller.js.map;
"use strict";
var LeiauteDocumentoInclusaoController = (function () {
    function LeiauteDocumentoInclusaoController($state, leiauteDocumentoApiService, feedbackService) {
        this.$state = $state;
        this.leiauteDocumentoApiService = leiauteDocumentoApiService;
        this.feedbackService = feedbackService;
        this.salvando = false;
    }
    LeiauteDocumentoInclusaoController.prototype.$onInit = function () {
        var _this = this;
        return this.leiauteDocumentoApiService.paraIncluir(this.$state.params.documentoPk).then(function (resource) {
            _this.dadosFormulario = resource.dados;
        }, function (response) { return _this.feedbackService.violacoes(response.data); });
    };
    LeiauteDocumentoInclusaoController.prototype.salvar = function () {
        var _this = this;
        if (this.salvando) {
            return;
        }
        this.salvando = true;
        return this.leiauteDocumentoApiService.incluir(this.$state.params.documentoPk, this.dadosFormulario).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Leiaute de entrada incluído com sucesso.');
                return _this.voltar();
            }
            return _this.feedbackService.violacoes(response.data);
        }, function (response) { return _this.feedbackService.violacoes(response.data); })["finally"](function () {
            _this.salvando = false;
        });
    };
    LeiauteDocumentoInclusaoController.prototype.voltar = function () {
        return this.$state.go('documento.leiautes-consultar', { documentoPk: this.$state.params.documentoPk });
    };
    return LeiauteDocumentoInclusaoController;
}());
LeiauteDocumentoInclusaoController.$inject = ['$state', 'LeiauteDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('LeiauteDocumentoInclusaoController', LeiauteDocumentoInclusaoController);
//# sourceMappingURL=leiaute-documento-inclusao-controller.js.map;
"use strict";
var LeiauteDocumentoListarController = (function () {
    function LeiauteDocumentoListarController($location, $state, leiauteDocumentoApiService, feedbackService) {
        this.$location = $location;
        this.$state = $state;
        this.leiauteDocumentoApiService = leiauteDocumentoApiService;
        this.feedbackService = feedbackService;
        this.excluindo = false;
    }
    LeiauteDocumentoListarController.prototype.abrir = function (acao, pk) {
        return this.$state.go('documento.leiautes-' + acao, {
            documentoPk: this.parametrosPesquisa.documento,
            leiautePk: pk
        });
    };
    LeiauteDocumentoListarController.prototype.excluir = function (pk) {
        var _this = this;
        if (this.excluindo) {
            return;
        }
        this.excluindo = true;
        return this.leiauteDocumentoApiService.excluir(this.$state.params.documentoPk, pk).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Leiaute de entrada excluído com sucesso.');
                if (_this.pagina.content.length === 1 && (_this.parametrosPesquisa.numeroPagina || 0) > 0) {
                    _this.parametrosPesquisa.numeroPagina = (_this.parametrosPesquisa.numeroPagina || 0) - 1;
                }
                return _this.pesquisar(_this.parametrosPesquisa);
            }
            return _this.feedbackService.violacoes(response.data);
        }, function (response) { return _this.feedbackService.violacoes(response.data); })["finally"](function () {
            _this.excluindo = false;
        });
    };
    LeiauteDocumentoListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    LeiauteDocumentoListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(_.omit(parametros, 'documento'));
        return this.leiauteDocumentoApiService.pesquisar(parametros).then(function (resource) {
            _this.pagina = resource._embedded;
            _this.permiteIncluir = !!resource._links['crd-leiaute-documento-formulario'];
            return resource;
        }, function (response) { return _this.feedbackService.violacoes(response.data); });
    };
    LeiauteDocumentoListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    LeiauteDocumentoListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            documento: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.documento),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    LeiauteDocumentoListarController.prototype.$onInit = function () {
        this.parametrosPesquisa = this.converterUrlParaParametros(this.$state.params);
        this.parametrosPesquisa.documento = this.$state.params.documentoPk;
        return this.pesquisar(this.parametrosPesquisa);
    };
    return LeiauteDocumentoListarController;
}());
LeiauteDocumentoListarController.$inject = ['$location', '$state', 'LeiauteDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('LeiauteDocumentoListarController', LeiauteDocumentoListarController);
//# sourceMappingURL=leiaute-documento-listar-controller.js.map;
"use strict";
var NormativoDocumentoListarController = (function () {
    function NormativoDocumentoListarController($scope, $location, $state, $uibModal, normativoDocumentoApiService, feedbackService) {
        this.$scope = $scope;
        this.$location = $location;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.normativoDocumentoApiService = normativoDocumentoApiService;
        this.feedbackService = feedbackService;
    }
    NormativoDocumentoListarController.prototype.abrirModalAlterar = function (normativoDocumento) {
        var dados = {
            documentoPk: this.$state.params.documentoPk,
            normativoDocumentoPk: normativoDocumento.pk,
            descricao: normativoDocumento.descricao,
            url: normativoDocumento.url
        };
        this.abrirModalManutencao(dados);
    };
    NormativoDocumentoListarController.prototype.abrirModalIncluir = function () {
        var dados = {
            documentoPk: this.$state.params.documentoPk
        };
        this.abrirModalManutencao(dados);
    };
    NormativoDocumentoListarController.prototype.abrirModalManutencao = function (dados) {
        var _this = this;
        var scope = this.$scope.$new();
        scope.dadosIniciais = dados;
        this.$uibModal.open({
            templateUrl: 'views/documento/normativo-documento/normativo-documento-manutencao-tpl.html',
            controller: 'NormativoDocumentoManutencaoController',
            controllerAs: 'norManutencaoCtrl',
            bindToController: true,
            scope: scope,
            size: 'md'
        }).result.then(function () { return _this.pesquisar(_this.parametrosPesquisa); });
    };
    NormativoDocumentoListarController.prototype.excluir = function (normativoDocumentoPk) {
        var _this = this;
        return this.normativoDocumentoApiService.excluir(normativoDocumentoPk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Normativo do documento excluído com sucesso!');
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    NormativoDocumentoListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    NormativoDocumentoListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(_.omit(parametros, 'documento'));
        return this.normativoDocumentoApiService.pesquisar(parametros).then(function (resource) {
            _this.pagina = resource._embedded;
            _this.exibirColunaAcoes = _.reduce(resource._embedded.content, function (memo, nor) { return memo || !_.isEmpty(nor._links); }, false);
            if (!_.isEmpty(_this.pagina.mensagens)) {
                _this.feedbackService.alerta(_.pluck(_this.pagina.mensagens, 'content'));
            }
            return resource;
        });
    };
    NormativoDocumentoListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    NormativoDocumentoListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            documento: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.documento),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    NormativoDocumentoListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    NormativoDocumentoListarController.prototype.$onInit = function () {
        this.exibirColunaAcoes = true;
        this.parametrosPesquisa = this.converterUrlParaParametros(this.$state.params);
        this.parametrosPesquisa.documento = this.$state.params.documentoPk;
        return this.pesquisar(this.parametrosPesquisa);
    };
    ;
    return NormativoDocumentoListarController;
}());
NormativoDocumentoListarController.$inject = ['$scope', '$location', '$state', '$uibModal', 'NormativoDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('NormativoDocumentoListarController', NormativoDocumentoListarController);
//# sourceMappingURL=normativo-documento-listar-controller.js.map;
"use strict";
var NormativoDocumentoManutencaoController = (function () {
    function NormativoDocumentoManutencaoController($uibModalInstance, feedbackService, normativoDocumentoApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.normativoDocumentoApiService = normativoDocumentoApiService;
    }
    NormativoDocumentoManutencaoController.prototype.cancel = function () {
        this.feedbackService.limpar();
        this.$uibModalInstance.dismiss('cancel');
    };
    NormativoDocumentoManutencaoController.prototype.salvar = function (normativoDocumento) {
        var normativo = this.converterParametrosParaUrl(normativoDocumento);
        if (this.dadosIniciais.normativoDocumentoPk) {
            this.alterar(this.dadosIniciais.normativoDocumentoPk, normativo);
        }
        else {
            this.criar(normativo);
        }
    };
    NormativoDocumentoManutencaoController.prototype.alterar = function (pk, normativo) {
        var _this = this;
        return this.normativoDocumentoApiService.alterar(pk, normativo).then(function (resource) {
            if (resource.status === 200) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Normativo do documento salvo com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    NormativoDocumentoManutencaoController.prototype.criar = function (normativo) {
        var _this = this;
        return this.normativoDocumentoApiService.criar(normativo).then(function (resource) {
            if (resource.status === 201) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Normativo do documento salvo com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    NormativoDocumentoManutencaoController.prototype.converterParametrosParaUrl = function (dadosFormulario) {
        return {
            documento: this.dadosIniciais.documentoPk,
            pk: this.dadosIniciais.normativoDocumentoPk,
            descricao: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricao),
            url: ConverterParameterObjectToUrlUtils.string(dadosFormulario.url)
        };
    };
    NormativoDocumentoManutencaoController.prototype.$onInit = function () {
        this.edicao = !!this.dadosIniciais.normativoDocumentoPk;
        this.normativoDocumento = {
            descricao: this.dadosIniciais.descricao,
            url: this.dadosIniciais.url
        };
    };
    return NormativoDocumentoManutencaoController;
}());
NormativoDocumentoManutencaoController.$inject = ['$uibModalInstance', 'feedbackService', 'NormativoDocumentoApiService'];
angular.module('crd').controller('NormativoDocumentoManutencaoController', NormativoDocumentoManutencaoController);
//# sourceMappingURL=normativo-documento-manutencao-controller.js.map;
"use strict";
var ParametrosDeCobrancaAlterarController = (function () {
    function ParametrosDeCobrancaAlterarController($state, parametrosCobrancaApiService, feedbackService) {
        this.$state = $state;
        this.parametrosCobrancaApiService = parametrosCobrancaApiService;
        this.feedbackService = feedbackService;
        this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
    }
    ParametrosDeCobrancaAlterarController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        return this.parametrosCobrancaApiService.montarTeladetalhar(pk).then(function (resource) {
            _this.montarTelaAlterarParametroCobrancaResource = resource;
            _this.parametrosDeCobranca = resource.dadosDoFormulario;
            _this.dadosParaConstruirFormulario = resource.dadosParaConstruirFormulario;
            _this.parametrosDeCobranca.documento = resource.dadosParaConstruirFormulario.documento;
            _this.documentoPk = _this.$state.params.documentoPk;
            _this.parametrosDeCobranca.dataBaseInicio = ConverterParameterUrlToObjectUtils.date('' + resource.dadosDoFormulario.dataBaseInicio),
                _this.opcoesDeData = FormataDataPeriodicidade.formatoPelaPeriodicidade(_this.parametrosDeCobranca.documento.menorTipoPeriodicidade);
            _this.dadosParaConstruirFormulario.dataBaseInicioMinima = ConverterParameterUrlToObjectUtils.date('' + resource.dadosParaConstruirFormulario.dataBaseInicioMinima);
        });
    };
    ParametrosDeCobrancaAlterarController.prototype.observerChangePeriodicidades = function (periodicidades) {
        this.opcoesDeData = FormataDataPeriodicidade.formatoPelaMenorPeriodicidade(periodicidades);
    };
    ParametrosDeCobrancaAlterarController.prototype.observerChangePeriodicidadeEnvioCobranca = function (parametrosDeCobranca) {
        if (parametrosDeCobranca.periodicidade.nome !== 'Semanal') {
            this.parametrosDeCobranca.diaDaSemana = undefined;
        }
    };
    ParametrosDeCobrancaAlterarController.prototype.isDataIncompleta = function (data) {
        return !data || (data + "").length < 11;
    };
    ParametrosDeCobrancaAlterarController.prototype.observerChangeAutomatica = function (automatica) {
        if (!automatica) {
            this.parametrosDeCobranca.diaDaSemana = undefined;
            this.parametrosDeCobranca.periodicidade = undefined;
        }
    };
    ParametrosDeCobrancaAlterarController.prototype.converterParaEnviarServidor = function () {
        return {
            automatica: ConverterParameterObjectToUrlUtils.boolean(this.parametrosDeCobranca.automatica),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(this.opcoesDeData.normatizar(this.parametrosDeCobranca.dataBaseInicio)),
            diaDaSemana: ConverterParameterObjectToUrlUtils.atributoEnumName(this.parametrosDeCobranca.diaDaSemana),
            documento: this.$state.params.documentoPk,
            periodicidade: ConverterParameterObjectToUrlUtils.atributoEnumName(this.parametrosDeCobranca.periodicidade),
            prazoDiasUteis: ConverterParameterObjectToUrlUtils.number(this.parametrosDeCobranca.prazoDiasUteis),
            tipoEnvio: ConverterParameterObjectToUrlUtils.atributoEnumName(this.parametrosDeCobranca.tipoEnvio)
        };
    };
    ParametrosDeCobrancaAlterarController.prototype.salvar = function () {
        var _this = this;
        var parCParaSalvar = this.converterParaEnviarServidor();
        this.parametrosCobrancaApiService.alterar(this.$state.params.id, parCParaSalvar).then(function (resource) {
            if (resource.status === 200) {
                _this.voltar();
                _this.feedbackService.sucesso('Parâmetro de cobrança alterado com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    ParametrosDeCobrancaAlterarController.prototype.voltar = function () {
        this.$state.go('documento.parametros-de-cobranca-listar');
    };
    ParametrosDeCobrancaAlterarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.id);
    };
    ;
    return ParametrosDeCobrancaAlterarController;
}());
ParametrosDeCobrancaAlterarController.$inject = ['$state', 'ParametrosCobrancaApiService', 'feedbackService'];
angular.module('crd').controller('ParametrosDeCobrancaAlterarController', ParametrosDeCobrancaAlterarController);
//# sourceMappingURL=parametros-de-cobranca-alterar-controller.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('ParametrosDeCobrancaDetalharController', ParametrosDeCobrancaDetalharController);

  ParametrosDeCobrancaDetalharController.$inject = ['$state', '$location', 'feedbackService', 'ParametrosCobrancaApiService'];

  function ParametrosDeCobrancaDetalharController($state, $location, feedbackService, parametrosCobrancaApiService) {

    var vm = this;
    vm.voltar = voltar;
    vm.excluir = excluir;

    activate();

    function activate() {
      carregar($state.params.id);
      vm.documentoPk = $state.params.documentoPk;
      vm.id = $state.id;
    }

    function excluir(id) {

      return parametrosCobrancaApiService
        .excluir(id)
        .then(successExcluir);

      function successExcluir(response) {
        if (response.status === 200) {
          voltar();
          feedbackService.sucesso('Parâmetro de cobrança excluído com sucesso!');
        } else {
          feedbackService.erro('Erro ao excluir parâmetro de cobrança!');
        }
      }
    }

    function voltar(){
      $location.path('/documento/'+vm.documentoPk+'/parametros-de-cobranca');
    }

    function carregar(id) {
      parametrosCobrancaApiService.detalhar(id).then(successOnDetalharParametrosCobranca);

      function successOnDetalharParametrosCobranca(resource) {
        vm.parametrosCobranca = resource;
      }
    }
  }
})(angular);
;
"use strict";
var ParametrosDeCobrancaIncluirController = (function () {
    function ParametrosDeCobrancaIncluirController($state, parametrosCobrancaApiService, feedbackService) {
        this.$state = $state;
        this.parametrosCobrancaApiService = parametrosCobrancaApiService;
        this.feedbackService = feedbackService;
        this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
    }
    ParametrosDeCobrancaIncluirController.prototype.carregarDadosTela = function () {
        var _this = this;
        return this.parametrosCobrancaApiService.montarTelaIncluir(this.$state.params.documentoPk).then(function (resource) {
            _this.montarTelaIncluirParametroCobrancaResource = resource;
            _this.parametrosDeCobranca = resource.dadosDoFormulario;
            _this.dadosParaConstruirFormulario = resource.dadosParaConstruirFormulario;
            _this.dadosParaConstruirFormulario.dataBaseInicioMinima = ConverterParameterUrlToObjectUtils.date('' + resource.dadosParaConstruirFormulario.dataBaseInicioMinima),
                _this.parametrosDeCobranca.documento = resource.dadosParaConstruirFormulario.documento;
            _this.parametrosDeCobranca.dataBaseInicio = ConverterParameterUrlToObjectUtils.date('' + resource.dadosDoFormulario.dataBaseInicio),
                _this.opcoesDeData = FormataDataPeriodicidade.formatoPelaPeriodicidade(_this.dadosParaConstruirFormulario.documento.menorTipoPeriodicidade);
            _this.parametrosDeCobranca.diaDaSemana = undefined;
            _this.parametrosDeCobranca.periodicidade = undefined;
        });
    };
    ParametrosDeCobrancaIncluirController.prototype.salvar = function () {
        var _this = this;
        var parCParaSalvar = this.converterParaEnviarServidor();
        this.parametrosCobrancaApiService.incluir(parCParaSalvar).then(function (resource) {
            if (resource.status === 201) {
                _this.voltar();
                _this.feedbackService.sucesso('Parâmetro de cobrança salvo com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    ParametrosDeCobrancaIncluirController.prototype.isDataIncompleta = function (data) {
        return !data || (data + "").length < 11;
    };
    ParametrosDeCobrancaIncluirController.prototype.observerChangePeriodicidades = function (periodicidades) {
        this.opcoesDeData = FormataDataPeriodicidade.formatoPelaMenorPeriodicidade(periodicidades);
    };
    ParametrosDeCobrancaIncluirController.prototype.converterParaEnviarServidor = function () {
        return {
            documento: this.$state.params.documentoPk,
            automatica: ConverterParameterObjectToUrlUtils.boolean(this.parametrosDeCobranca.automatica),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(this.opcoesDeData.normatizar(this.parametrosDeCobranca.dataBaseInicio)),
            diaDaSemana: ConverterParameterObjectToUrlUtils.atributoEnumName(this.parametrosDeCobranca.diaDaSemana),
            periodicidade: ConverterParameterObjectToUrlUtils.atributoEnumName(this.parametrosDeCobranca.periodicidade),
            prazoDiasUteis: ConverterParameterObjectToUrlUtils.number(this.parametrosDeCobranca.prazoDiasUteis),
            tipoEnvio: ConverterParameterObjectToUrlUtils.atributoEnumName(this.parametrosDeCobranca.tipoEnvio)
        };
    };
    ParametrosDeCobrancaIncluirController.prototype.observerChangeAutomatica = function (automatica) {
        if (!automatica) {
            this.parametrosDeCobranca.diaDaSemana = undefined;
            this.parametrosDeCobranca.periodicidade = undefined;
        }
    };
    ParametrosDeCobrancaIncluirController.prototype.observerChangePeriodicidadeEnvioCobranca = function (parametrosDeCobranca) {
        if (parametrosDeCobranca.periodicidade.nome !== 'Semanal') {
            this.parametrosDeCobranca.diaDaSemana = undefined;
        }
    };
    ParametrosDeCobrancaIncluirController.prototype.voltar = function () {
        this.$state.go('documento.parametros-de-cobranca-listar');
    };
    ParametrosDeCobrancaIncluirController.prototype.$onInit = function () {
        return this.carregarDadosTela();
    };
    ;
    return ParametrosDeCobrancaIncluirController;
}());
ParametrosDeCobrancaIncluirController.$inject = ['$state', 'ParametrosCobrancaApiService', 'feedbackService'];
angular.module('crd').controller('ParametrosDeCobrancaIncluirController', ParametrosDeCobrancaIncluirController);
//# sourceMappingURL=parametros-de-cobranca-incluir-controller.js.map;
(function(angular) {
  'use strict';

  var COLUNA_DATA_BASE = 0;
  var COLUNA_AUTOMATICA = 1;
  var COLUNA_VIGENCIA = 2;
  var COLUNA_ULTIMA_ACAO = 3;
  var COLUNA_RESPONSAVEL = 4;
  var COLUNA_ACOES = 5;

  angular
    .module('crd')
    .controller('ParametrosDeCobrancaListarController', ParametrosDeCobrancaListarController);

  ParametrosDeCobrancaListarController.$inject = [
    '$state',
    '$location',
    'constantes',
    'feedbackService',
    'documentoApiService',
    'DTColumnDefBuilder',
    'ParametrosCobrancaApiService'
  ];

  function ParametrosDeCobrancaListarController(
    $state,
    $location,
    constantes,
    feedbackService,
    documentoApiService,
    DTColumnDefBuilder,
    parametrosCobrancaApiService) {
    var vm = this;
    vm.voltar = voltar;
    vm.excluir = excluir;

    activate();

    function activate() {
      configurarGridResultados();
      vm.documentoPk = $state.params.documentoPk;
      vm.id = $state.id;
      pesquisar(vm.documentoPk );
    }

    function pesquisar(documentoPk) {
      parametrosCobrancaApiService.pesquisar({documento: documentoPk}).then(onSuccessBuscarPorCodigo);
      function onSuccessBuscarPorCodigo(resource) {
        vm.parametrosCobranca = resource._embedded.resultado;
        vm.deveExibirBotaoIncluir = resource._parameters.deveExibirBotaoIncluir;
        vm.ehDocumentoConvenio = resource._parameters.ehDocumentoConvenio;
      }
    }

    function excluir(id) {

      return parametrosCobrancaApiService
        .excluir(id)
        .then(successExcluir);

      function successExcluir(response) {
        if (response.status === 200) {
          activate();
          feedbackService.sucesso('Parâmetro de cobrança excluído com sucesso!');
        } else {
          feedbackService.erro('Erro ao excluir parâmetro de cobrança!');
        }
      }
    }

    function defineTamanhoGridResultado() {
      vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(COLUNA_DATA_BASE).withOption('width', '6%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_AUTOMATICA).withOption('width', '6%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_VIGENCIA).withOption('width', '10%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_ULTIMA_ACAO).withOption('width', '10%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_RESPONSAVEL).withOption('width', '20%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_ACOES)
          .withOption('width', '6%')
          .withOption('bSortable', false)
      ];
    }

    function voltar(){
      $location.path('/documento/'+vm.documentoPk+'/parametros-de-cobranca');
    }

    function configurarGridResultados() {
      defineTamanhoGridResultado();

      vm.dtOptions = {};
    }
  }
})(angular);
;
"use strict";
var ResponsavelDocumentoListarController = (function () {
    function ResponsavelDocumentoListarController($scope, $location, $state, $uibModal, responsavelDocumentoApiService, feedbackService) {
        this.$scope = $scope;
        this.$location = $location;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.responsavelDocumentoApiService = responsavelDocumentoApiService;
        this.feedbackService = feedbackService;
    }
    ResponsavelDocumentoListarController.prototype.abrirModalAlterar = function (responsavelDocumento) {
        var dados = {
            documentoPk: this.$state.params.documentoPk,
            responsavelDocumentoPk: responsavelDocumento.pk,
            codigoArea: responsavelDocumento.area.codigo,
            codigoCargo: responsavelDocumento.cargo.codigo
        };
        this.abrirModalManutencao(dados);
    };
    ResponsavelDocumentoListarController.prototype.abrirModalIncluir = function () {
        var dados = {
            documentoPk: this.$state.params.documentoPk
        };
        this.abrirModalManutencao(dados);
    };
    ResponsavelDocumentoListarController.prototype.abrirModalManutencao = function (dados) {
        var _this = this;
        var scope = this.$scope.$new();
        scope.dadosIniciais = dados;
        this.$uibModal.open({
            templateUrl: 'views/documento/responsavel-documento/responsavel-documento-manutencao-tpl.html',
            controller: 'ResponsavelDocumentoManutencaoController',
            controllerAs: 'redManutencaoCtrl',
            bindToController: true,
            scope: scope,
            size: 'md'
        }).result.then(function () { return _this.pesquisar(_this.parametrosPesquisa); });
    };
    ResponsavelDocumentoListarController.prototype.excluir = function (responsavelDocumentoPk) {
        var _this = this;
        return this.responsavelDocumentoApiService.excluir(responsavelDocumentoPk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Responsável pelo documento excluído com sucesso!');
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    ResponsavelDocumentoListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    ResponsavelDocumentoListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(_.omit(parametros, 'documento'));
        return this.responsavelDocumentoApiService.pesquisar(parametros).then(function (resource) {
            _this.pagina = resource._embedded;
            _this.exibirColunaAcoes = _.reduce(resource._embedded.content, function (memo, red) { return memo || !_.isEmpty(red._links); }, false);
            return resource;
        });
    };
    ResponsavelDocumentoListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    ResponsavelDocumentoListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            documento: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.documento),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    ResponsavelDocumentoListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    ResponsavelDocumentoListarController.prototype.$onInit = function () {
        this.exibirColunaAcoes = true;
        this.parametrosPesquisa = this.converterUrlParaParametros(this.$state.params);
        this.parametrosPesquisa.documento = this.$state.params.documentoPk;
        return this.pesquisar(this.parametrosPesquisa);
    };
    return ResponsavelDocumentoListarController;
}());
ResponsavelDocumentoListarController.$inject = ['$scope', '$location', '$state', '$uibModal', 'ResponsavelDocumentoApiService', 'feedbackService'];
angular.module('crd').controller('ResponsavelDocumentoListarController', ResponsavelDocumentoListarController);
//# sourceMappingURL=responsavel-documento-listar-controller.js.map;
"use strict";
var ResponsavelDocumentoManutencaoController = (function () {
    function ResponsavelDocumentoManutencaoController($uibModalInstance, feedbackService, responsavelDocumentoApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.responsavelDocumentoApiService = responsavelDocumentoApiService;
    }
    ResponsavelDocumentoManutencaoController.prototype.cancel = function () {
        this.feedbackService.limpar();
        this.$uibModalInstance.dismiss('cancel');
    };
    ResponsavelDocumentoManutencaoController.prototype.observerChangeArea = function (area) {
        this.responsavelDocumento.cargo = undefined;
        if (area) {
            this.dadosFormulario.cargos = _.filter(this.cargos, function (cargo) {
                return cargo.codigoArea === area.codigo;
            });
        }
        else {
            this.dadosFormulario.cargos = [];
        }
    };
    ResponsavelDocumentoManutencaoController.prototype.salvar = function (responsavelDocumento) {
        var red = this.converterParametrosParaUrl(responsavelDocumento);
        if (this.dadosIniciais.responsavelDocumentoPk) {
            this.alterar(this.dadosIniciais.responsavelDocumentoPk, red);
        }
        else {
            this.criar(red);
        }
    };
    ResponsavelDocumentoManutencaoController.prototype.alterar = function (pk, responsavelDocumento) {
        var _this = this;
        return this.responsavelDocumentoApiService.alterar(pk, responsavelDocumento).then(function (resource) {
            if (resource.status === 200) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Responsável pelo documento salvo com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    ResponsavelDocumentoManutencaoController.prototype.criar = function (responsavelDocumento) {
        var _this = this;
        return this.responsavelDocumentoApiService.criar(responsavelDocumento).then(function (resource) {
            if (resource.status === 201) {
                _this.$uibModalInstance.close();
                _this.feedbackService.sucesso('Responsável pelo documento salvo com sucesso!');
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    ResponsavelDocumentoManutencaoController.prototype.converterParametrosParaUrl = function (dadosFormulario) {
        return {
            documento: this.dadosIniciais.documentoPk,
            pk: this.dadosIniciais.responsavelDocumentoPk,
            codigoArea: ConverterParameterObjectToUrlUtils.atributoCodigo(dadosFormulario.area),
            codigoCargo: ConverterParameterObjectToUrlUtils.atributoCodigo(dadosFormulario.cargo)
        };
    };
    ResponsavelDocumentoManutencaoController.prototype.$onInit = function () {
        var _this = this;
        this.edicao = !!this.dadosIniciais.responsavelDocumentoPk;
        return this.responsavelDocumentoApiService.todosResponsaveisPeloEnvioDeInformacoes().then(function (resource) {
            _this.areas = resource.areas;
            _this.cargos = resource.cargos;
            _this.responsavelDocumento = {
                area: _.find(_this.areas, function (area) { return area.codigo == _this.dadosIniciais.codigoArea; }),
                cargo: _.find(_this.cargos, function (cargo) { return cargo.codigo == _this.dadosIniciais.codigoCargo; })
            };
            _this.dadosFormulario = {
                areas: _this.areas,
                cargos: _this.responsavelDocumento.area ? _.filter(_this.cargos, function (cargo) { return cargo.codigoArea === _this.dadosIniciais.codigoArea; }) : []
            };
        });
    };
    ;
    return ResponsavelDocumentoManutencaoController;
}());
ResponsavelDocumentoManutencaoController.$inject = ['$uibModalInstance', 'feedbackService', 'ResponsavelDocumentoApiService'];
angular.module('crd').controller('ResponsavelDocumentoManutencaoController', ResponsavelDocumentoManutencaoController);
//# sourceMappingURL=responsavel-documento-manutencao-controller.js.map;
"use strict";
var EntidadeSupervisionadaControleAlterarController = (function () {
    function EntidadeSupervisionadaControleAlterarController($location, $state, ecoApiService, feedbackService, moment, $uibModal, $scope) {
        this.$location = $location;
        this.$state = $state;
        this.ecoApiService = ecoApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.CREATED = 201;
        this.OK = 200;
        this.isDataInicioVigenciaEditavel = false;
    }
    EntidadeSupervisionadaControleAlterarController.prototype.carregarDadosTela = function (id) {
        var _this = this;
        return this.ecoApiService.montarTelaAlterar(id).then(function (response) {
            _this.dadosFormulario = response.dadosFormulario;
            _this.dadosFormulario.vigencia.inicio = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.vigencia.inicio);
            _this.dadosFormulario.vigencia.fim = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.vigencia.fim);
            _this.dadosParaConstruirFormulario = response.dadosParaConstruirFormulario;
            _this.dadosParaConstruirFormulario.dataBaseAtual = ConverterParameterUrlToObjectUtils.date(_this.dadosParaConstruirFormulario.dataBaseAtual);
            _this.tratarOpcaoData();
            _this.isDataInicioVigenciaEditavel = _this.checaSeDataInicioVigenciaEhEditavel();
            _this.dataInicioAntesEdicao = _this.dadosFormulario.vigencia.inicio;
            return response;
        });
    };
    EntidadeSupervisionadaControleAlterarController.prototype.checaSeDataInicioVigenciaEhEditavel = function () {
        var isDataInicioMaiorQueDataBase = DateUtil.isMaiorQue(this.dadosFormulario.vigencia.inicio, this.dadosParaConstruirFormulario.dataBaseAtual, false);
        return isDataInicioMaiorQueDataBase;
    };
    EntidadeSupervisionadaControleAlterarController.prototype.tratarOpcaoData = function () {
        var periodicidade = this.isTipoInclusao()
            ? this.dadosFormulario.periodicidade
            : this.dadosFormulario.documento.menorPeriodicidade;
        this.opcoesDeData = FormataDataPeriodicidade.formatoPelaPeriodicidade(periodicidade);
    };
    EntidadeSupervisionadaControleAlterarController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = this.createDadosParaServidor(dadosFormulario);
        this.ecoApiService.alterar(this.dadosFormulario.pk, dados).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso(_this.isTipoInclusao() ? 'Inclusão manual salva com sucesso!' : 'Exclusão manual salva com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    EntidadeSupervisionadaControleAlterarController.prototype.createDadosParaServidor = function (dadosFormulario) {
        return {
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(this.opcoesDeData.normatizar(dadosFormulario.vigencia.fim)),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(this.opcoesDeData.normatizar(dadosFormulario.vigencia.inicio)),
            documentoPK: ConverterParameterObjectToUrlUtils.atributoPK(dadosFormulario.documento),
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(dadosFormulario.instituicao),
            motivo: dadosFormulario.motivo,
            tipoControle: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoControle),
            periodicidade: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.periodicidade),
            isDataInicioAlterada: this.verificaAlteracaoNaDataInicio(dadosFormulario.vigencia.inicio),
            alteracaoECO: true
        };
    };
    EntidadeSupervisionadaControleAlterarController.prototype.verificaAlteracaoNaDataInicio = function (dataInicioFormulario) {
        return DateUtil.isDiferente(this.dataInicioAntesEdicao, dataInicioFormulario);
    };
    EntidadeSupervisionadaControleAlterarController.prototype.validaDataBaseFim = function () {
        if (this.dadosFormulario
            && this.dadosFormulario.vigencia
            && this.dadosFormulario.vigencia.fim
            && this.dadosParaConstruirFormulario.dataBaseAtual) {
            var fimDaVigencia = this.moment.utc(this.dadosFormulario.vigencia.fim);
            return fimDaVigencia.isSame(this.dadosParaConstruirFormulario.dataBaseAtual)
                || fimDaVigencia.isAfter(this.dadosParaConstruirFormulario.dataBaseAtual);
        }
        return true;
    };
    EntidadeSupervisionadaControleAlterarController.prototype.isTipoInclusao = function () {
        return this.dadosFormulario
            && this.dadosFormulario.tipoControle
            && this.dadosFormulario.tipoControle.enumName === 'INCLUSAO';
    };
    EntidadeSupervisionadaControleAlterarController.prototype.voltar = function () {
        this.$location.path(this.$state.current.informacaoPagina.outros.acoes.voltar);
    };
    EntidadeSupervisionadaControleAlterarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.pk);
    };
    ;
    return EntidadeSupervisionadaControleAlterarController;
}());
EntidadeSupervisionadaControleAlterarController.$inject = ['$location', '$state', 'entidadeSupervisionadaControleApiService', 'feedbackService', 'moment', '$uibModal', '$scope'];
angular.module('crd').controller('EntidadeSupervisionadaControleAlterarController', EntidadeSupervisionadaControleAlterarController);
//# sourceMappingURL=entidade-supervisionada-controle-alterar-controller.js.map;
"use strict";
var EntidadeSupervisionadaControleDetalharController = (function () {
    function EntidadeSupervisionadaControleDetalharController($location, $state, entidadeSupervisionadaControleApiService, feedbackService, moment, $scope, entidadeSupervisionadaModalParaDesativarServico) {
        this.$location = $location;
        this.$state = $state;
        this.entidadeSupervisionadaControleApiService = entidadeSupervisionadaControleApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$scope = $scope;
        this.entidadeSupervisionadaModalParaDesativarServico = entidadeSupervisionadaModalParaDesativarServico;
    }
    EntidadeSupervisionadaControleDetalharController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        return this.entidadeSupervisionadaControleApiService.detalhar(parseInt(this.$state.params.pk))
            .then(function (entidadeSupervisionadaControleResumoResource) {
            _this.entidadeSupervisionadaControle = entidadeSupervisionadaControleResumoResource;
            return entidadeSupervisionadaControleResumoResource;
        });
    };
    EntidadeSupervisionadaControleDetalharController.prototype.openModalConfirmaDesativacao = function () {
        var _this = this;
        var pk = this.$state.params.pk;
        this.entidadeSupervisionadaModalParaDesativarServico.abrir(pk, this.$scope)
            .then(function () { return _this.carregarDadosTela(pk); });
    };
    ;
    EntidadeSupervisionadaControleDetalharController.prototype.isPodeExibirLinkAlterar = function () {
        return this.entidadeSupervisionadaControle != null
            && this.entidadeSupervisionadaControle._links['crd-entidade-supervisionada-controle-alterar'];
    };
    EntidadeSupervisionadaControleDetalharController.prototype.voltar = function () {
        this.$location.path(this.$state.current.informacaoPagina.outros.acoes.voltar);
    };
    EntidadeSupervisionadaControleDetalharController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.pk);
    };
    ;
    return EntidadeSupervisionadaControleDetalharController;
}());
EntidadeSupervisionadaControleDetalharController.$inject = ['$location', '$state', 'entidadeSupervisionadaControleApiService', 'feedbackService', 'moment', '$scope', 'EntidadeSupervisionadaModalParaDesativarServico'];
angular.module('crd').controller('EntidadeSupervisionadaControleDetalharController', EntidadeSupervisionadaControleDetalharController);
//# sourceMappingURL=entidade-supervisionada-controle-detalhar-controller.js.map;
"use strict";
var EntidadeSupervisionadaModalParaDesativarController = (function () {
    function EntidadeSupervisionadaModalParaDesativarController(entidadeSupervisionadaControleApiService, $uibModalInstance, $state, feedbackService) {
        this.entidadeSupervisionadaControleApiService = entidadeSupervisionadaControleApiService;
        this.$uibModalInstance = $uibModalInstance;
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.vmModal = this;
    }
    EntidadeSupervisionadaModalParaDesativarController.prototype.$onInit = function () {
        this.buscarDadosParaConfirmar();
    };
    EntidadeSupervisionadaModalParaDesativarController.prototype.cancelar = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    EntidadeSupervisionadaModalParaDesativarController.prototype.confirmar = function () {
        var _this = this;
        return this.entidadeSupervisionadaControleApiService.desativar(this.vmModal.pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso("Exclusão manual desativada com sucesso!");
                _this.$uibModalInstance.close();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    EntidadeSupervisionadaModalParaDesativarController.prototype.buscarDadosParaConfirmar = function () {
        var _this = this;
        return this.entidadeSupervisionadaControleApiService.paraDesativar(this.vmModal.pk).then(function (resultado) {
            _this.mensagem = resultado.mensagem;
        });
    };
    return EntidadeSupervisionadaModalParaDesativarController;
}());
EntidadeSupervisionadaModalParaDesativarController.$inject = ['entidadeSupervisionadaControleApiService', '$uibModalInstance', '$state', 'feedbackService'];
angular.module('crd').controller('EntidadeSupervisionadaModalParaDesativarController', EntidadeSupervisionadaModalParaDesativarController);
//# sourceMappingURL=entidade-supervisionada-modal-para-desativar-controller.js.map;
"use strict";
var EntidadeSupervisionadaModalParaDesativarServico = (function () {
    function EntidadeSupervisionadaModalParaDesativarServico($uibModal) {
        this.$uibModal = $uibModal;
    }
    EntidadeSupervisionadaModalParaDesativarServico.prototype.abrir = function (pk, scope) {
        scope.pk = pk;
        return this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: 'views/entidade-supervisionada-controle/entidade-supervisionada-modal/entidade-supervisionada-modal-para-desativar-tpl.html',
            controller: 'EntidadeSupervisionadaModalParaDesativarController',
            controllerAs: 'ecoModalParaDesativarCtrl',
            bindToController: true,
            keyboard: true,
            size: 'lg',
            scope: scope
        }).result;
    };
    return EntidadeSupervisionadaModalParaDesativarServico;
}());
EntidadeSupervisionadaModalParaDesativarServico.$inject = ['$uibModal'];
angular.module('crd').service('EntidadeSupervisionadaModalParaDesativarServico', EntidadeSupervisionadaModalParaDesativarServico);
//# sourceMappingURL=entidade-supervisionada-modal-para-desativar-servico.js.map;
"use strict";
var EntidadeSupervisionadaModalParaIncluirController = (function () {
    function EntidadeSupervisionadaModalParaIncluirController($uibModalInstance) {
        this.$uibModalInstance = $uibModalInstance;
    }
    EntidadeSupervisionadaModalParaIncluirController.prototype.$onInit = function () {
    };
    EntidadeSupervisionadaModalParaIncluirController.prototype.cancelar = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    EntidadeSupervisionadaModalParaIncluirController.prototype.confirmar = function (alterarSituacaoESO) {
        this.$uibModalInstance.close(alterarSituacaoESO);
    };
    return EntidadeSupervisionadaModalParaIncluirController;
}());
EntidadeSupervisionadaModalParaIncluirController.$inject = ['$uibModalInstance'];
angular.module('crd').controller('EntidadeSupervisionadaModalParaIncluirController', EntidadeSupervisionadaModalParaIncluirController);
//# sourceMappingURL=entidade-supervisionada-modal-para-incluir-controller.js.map;
"use strict";
var EntidadeSupervisionadaModalParaIncluirServico = (function () {
    function EntidadeSupervisionadaModalParaIncluirServico(entidadeSupervisionadaControleApiService, $uibModal) {
        this.entidadeSupervisionadaControleApiService = entidadeSupervisionadaControleApiService;
        this.$uibModal = $uibModal;
    }
    EntidadeSupervisionadaModalParaIncluirServico.prototype.abrir = function (dados, scope) {
        var _this = this;
        return this.entidadeSupervisionadaControleApiService.paraIncluir(dados).then(function (resource) {
            if (resource.status === 200) {
                var data = angular.fromJson(resource.data);
                dados.listaEntradaArquivo = data.listaEntradaArquivo;
                dados.status = resource.status;
                if (data.possuiDataBaseDispensada) {
                    return _this.abrirModal(data, scope).then(function (resource) {
                        dados.alterarSituacaoESO = resource;
                        return dados;
                    });
                }
                return dados;
            }
            return resource;
        });
    };
    EntidadeSupervisionadaModalParaIncluirServico.prototype.abrirModal = function (data, scope) {
        scope.mensagem = data.mensagem;
        scope.titulo = data.titulo;
        return this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: 'views/entidade-supervisionada-controle/entidade-supervisionada-modal/entidade-supervisionada-modal-para-incluir-tpl.html',
            controller: 'EntidadeSupervisionadaModalParaIncluirController',
            controllerAs: 'ecoModalParaIncluirCtrl',
            bindToController: true,
            keyboard: true,
            size: 'lg',
            scope: scope
        }).result;
    };
    return EntidadeSupervisionadaModalParaIncluirServico;
}());
EntidadeSupervisionadaModalParaIncluirServico.$inject = ['entidadeSupervisionadaControleApiService', '$uibModal'];
angular.module('crd').service('EntidadeSupervisionadaModalParaIncluirServico', EntidadeSupervisionadaModalParaIncluirServico);
//# sourceMappingURL=entidade-supervisionada-modal-para-incluir-servico.js.map;
"use strict";
var EntidadeSupervisionadaControleIncluirController = (function () {
    function EntidadeSupervisionadaControleIncluirController($location, $state, ecoApiService, entidadeSupervisionadaModalParaIncluirServico, feedbackService, moment, $uibModal, $scope) {
        this.$location = $location;
        this.$state = $state;
        this.ecoApiService = ecoApiService;
        this.entidadeSupervisionadaModalParaIncluirServico = entidadeSupervisionadaModalParaIncluirServico;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
    }
    EntidadeSupervisionadaControleIncluirController.prototype.carregarDadosTela = function () {
        var _this = this;
        this.ecoApiService.montarTelaIncluir().then(function (resource) {
            _this.dadosFormulario = resource.dadosFormulario;
            _this.dadosParaConstruirFormulario = resource.dadosParaConstruirFormulario;
            if (_this.dadosFormulario.vigencia) {
                _this.dadosFormulario.vigencia.inicio = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.vigencia.inicio);
                _this.dadosFormulario.vigencia.fim = ConverterParameterUrlToObjectUtils.date(_this.dadosFormulario.vigencia.fim);
            }
            _this.observerDocumento();
            _this.observerPeriodicidade();
            _this.observerTipoControle();
        });
    };
    EntidadeSupervisionadaControleIncluirController.prototype.observerDocumento = function () {
        this.tratarOpcaoData();
        this.calcularDataBaseAtual();
    };
    EntidadeSupervisionadaControleIncluirController.prototype.observerTipoControle = function () {
        this.tratarOpcaoData();
        this.podeVerPeriodicidade = this.isTipoInclusao();
        this.dataBaseFimObrigatoria = !this.isTipoInclusao();
    };
    EntidadeSupervisionadaControleIncluirController.prototype.observerPeriodicidade = function () {
        this.tratarOpcaoData();
        this.calcularDataBaseAtual();
    };
    EntidadeSupervisionadaControleIncluirController.prototype.isTipoInclusao = function () {
        return this.dadosFormulario
            && this.dadosFormulario.tipoControle
            && this.dadosFormulario.tipoControle.enumName === 'INCLUSAO';
    };
    EntidadeSupervisionadaControleIncluirController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = this.createDadosParaServidor(dadosFormulario);
        return this.entidadeSupervisionadaModalParaIncluirServico.abrir(dados, this.$scope).then(function (resource) {
            if (resource.status == 200) {
                if (_this.dadosFormulario.tipoControle.enumName === 'EXCLUSAO') {
                    _this.listaEntradaArquivo = resource.listaEntradaArquivo;
                    if (_this.listaEntradaArquivo && _this.listaEntradaArquivo.length > 0) {
                        _this.abrirModal(dados, resource);
                    }
                    else {
                        _this.listaEntradaArquivo = null;
                        _this.incluir(resource);
                    }
                }
                else {
                    _this.listaEntradaArquivo = null;
                    _this.incluir(resource);
                }
            }
        });
    };
    EntidadeSupervisionadaControleIncluirController.prototype.incluir = function (resource) {
        var _this = this;
        this.ecoApiService.incluir(resource).then(function (resource) {
            if (resource.status === 201) {
                _this.feedbackService.sucesso(_this.isTipoInclusao() ? 'Inclusão manual salva com sucesso!' : 'Exclusão manual salva com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    EntidadeSupervisionadaControleIncluirController.prototype.abrirModal = function (dados, resource) {
        var _this = this;
        var scope = this.$scope.$new();
        scope.dadosIniciais = dados;
        this.$uibModal.open({
            templateUrl: 'views/entidade-supervisionada-controle/incluir/incluir-exclusao-modal-ents-afetadas/incluir-exclusao-modal-ents-afetadas-tpl.html',
            controller: 'IncluirExclusaoModalEntsAfetadasController',
            controllerAs: 'incluirExclusaoModalEntsAfetadasCtrl',
            bindToController: true,
            scope: scope,
            size: 'md'
        }).result.then(function (salvar) {
            resource.listaEntradaArquivo = null;
            _this.incluir(resource);
        })["catch"](function (cancelar) {
            _this.$uibModal.dismiss();
        });
    };
    EntidadeSupervisionadaControleIncluirController.prototype.createDadosParaServidor = function (dadosFormulario) {
        return {
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(this.opcoesDeData.normatizar(dadosFormulario.vigencia.fim)),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(this.opcoesDeData.normatizar(dadosFormulario.vigencia.inicio)),
            documentoPK: ConverterParameterObjectToUrlUtils.atributoPK(dadosFormulario.documento),
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(dadosFormulario.instituicao),
            motivo: dadosFormulario.motivo,
            tipoControle: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoControle),
            periodicidade: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.periodicidade)
        };
    };
    EntidadeSupervisionadaControleIncluirController.prototype.tratarOpcaoData = function () {
        var periodicidade = this.buscarPeriodicidade();
        this.opcoesDeData = FormataDataPeriodicidade.formatoPelaPeriodicidade(periodicidade);
    };
    EntidadeSupervisionadaControleIncluirController.prototype.calcularDataBaseAtual = function () {
        var data = this.dadosParaConstruirFormulario.dataBaseAtualPorPeriodicidade[this.buscarPeriodicidade().enumName];
        this.dataBaseAtual = ConverterParameterUrlToObjectUtils.date(data);
    };
    EntidadeSupervisionadaControleIncluirController.prototype.validaDataBaseFim = function () {
        if (this.isTipoInclusao()) {
            return true;
        }
        if (this.dadosFormulario
            && this.dadosFormulario.vigencia
            && this.dadosFormulario.vigencia.fim) {
            var fimDaVigencia = this.moment.utc(this.opcoesDeData.normatizar(this.dadosFormulario.vigencia.fim));
            return fimDaVigencia.isSame(this.dataBaseAtual)
                || fimDaVigencia.isBefore(this.dataBaseAtual);
        }
        return true;
    };
    EntidadeSupervisionadaControleIncluirController.prototype.buscarPeriodicidade = function () {
        if (this.isTipoInclusao()) {
            return this.dadosFormulario.periodicidade;
        }
        else if (this.dadosFormulario.documento) {
            return this.dadosFormulario.documento.menorPeriodicidade;
        }
        return { enumName: 'DIARIA', codigo: 3 };
    };
    EntidadeSupervisionadaControleIncluirController.prototype.voltar = function () {
        this.$location.path(this.$state.current.informacaoPagina.outros.acoes.voltar);
    };
    EntidadeSupervisionadaControleIncluirController.prototype.$onInit = function () {
        return this.carregarDadosTela();
    };
    ;
    EntidadeSupervisionadaControleIncluirController.prototype.exibirMensagemSemDocumentosEntregues = function () {
        return this.listaEntradaArquivo == null || this.listaEntradaArquivo.length === 0;
    };
    return EntidadeSupervisionadaControleIncluirController;
}());
EntidadeSupervisionadaControleIncluirController.$inject = ['$location', '$state', 'entidadeSupervisionadaControleApiService', 'EntidadeSupervisionadaModalParaIncluirServico', 'feedbackService', 'moment', '$uibModal', '$scope'];
angular.module('crd').controller('EntidadeSupervisionadaControleIncluirController', EntidadeSupervisionadaControleIncluirController);
//# sourceMappingURL=entidade-supervisionada-controle-incluir-controller.js.map;
"use strict";
var IncluirExclusaoModalEntsAfetadasController = (function () {
    function IncluirExclusaoModalEntsAfetadasController($uibModalInstance) {
        this.$uibModalInstance = $uibModalInstance;
        this.vmModal = this;
    }
    IncluirExclusaoModalEntsAfetadasController.prototype.$onInit = function () {
    };
    IncluirExclusaoModalEntsAfetadasController.prototype.cancelar = function () {
        this.$uibModalInstance.dismiss('cancelar');
    };
    IncluirExclusaoModalEntsAfetadasController.prototype.salvar = function () {
        this.$uibModalInstance.close('salvar');
    };
    return IncluirExclusaoModalEntsAfetadasController;
}());
IncluirExclusaoModalEntsAfetadasController.$inject = ['$uibModalInstance'];
angular.module('crd').controller('IncluirExclusaoModalEntsAfetadasController', IncluirExclusaoModalEntsAfetadasController);
//# sourceMappingURL=incluir-exclusao-modal-ents-afetadas-controller.js.map;
"use strict";
var EntidadeSupervisionadaControlePesquisaController = (function () {
    function EntidadeSupervisionadaControlePesquisaController($scope, $location, $stateParams, entidadeSupervisionadaControleApiService, documentoApiService, sistemaNegocioApiService, feedbackService, moment, $state, entidadeSupervisionadaModalParaDesativarServico) {
        this.$scope = $scope;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.entidadeSupervisionadaControleApiService = entidadeSupervisionadaControleApiService;
        this.documentoApiService = documentoApiService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.$state = $state;
        this.entidadeSupervisionadaModalParaDesativarServico = entidadeSupervisionadaModalParaDesativarServico;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    EntidadeSupervisionadaControlePesquisaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.limparResultadoPesquisa = function () {
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.observerChangeGrupoPeriodicidade = function (grupoPeriodicidade) {
        this.parametrosPesquisa.sistemaNegocio = undefined;
        this.parametrosPesquisa.documento = undefined;
        this.changeOpcoesDeData(grupoPeriodicidade);
        this.carregarSistemaNegocio(grupoPeriodicidade);
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.observerChangeSistemaNegocio = function (grupoPeriodicidade, sistemaNegocio) {
        this.carregarDocumentos(grupoPeriodicidade, sistemaNegocio);
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.carregarSistemaNegocio = function (grupoPeriodicidade) {
        var _this = this;
        var parametros = {
            grupoPeriodicidade: grupoPeriodicidade,
            quantidadePorPagina: 99999
        };
        this.changeOpcoesDeData(grupoPeriodicidade);
        return this.sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (resource) {
            _this.dadosFormulario.sistemasNegocio.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.sistemasNegocio, resource.data.content);
            return resource;
        });
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.carregarDocumentos = function (grupoPeriodicidade, sistemaNegocio) {
        var _this = this;
        if (!sistemaNegocio || _.isEmpty(sistemaNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        var parametros = {
            periodicidade: grupoPeriodicidade === 'MENSAL_OU_MAIOR' ? 'MENSAL' : 'DIARIA',
            sistemaNegocioPks: sistemaNegocio.pk
        };
        this.documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, resource.data._embedded.resultado);
            return resource;
        });
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.changeOpcoesDeData = function (grupoPeriodicidade) {
        if (grupoPeriodicidade === 'MENOR_QUE_MENSAL') {
            this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        }
        else {
            this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
        }
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            grupoPeriodicidade: ConverterParameterUrlToObjectUtils.string(filtro.grupoPeriodicidade),
            dataBaseFim: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseFim),
            dataBaseInicio: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseInicio),
            documento: ConverterParameterUrlToObjectUtils.atributoPK(filtro.documento),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            sistemaNegocio: ConverterParameterUrlToObjectUtils.atributoPK(filtro.sistemaNegocio),
            situacao: ConverterParameterUrlToObjectUtils.atributoEnumName(filtro.situacao),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var dataBaseInicio = this.opcoesDeData.normatizar(parametrosPesquisa.dataBaseInicio);
        var dataBaseFim = this.opcoesDeData.normatizar(parametrosPesquisa.dataBaseFim);
        return {
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dataBaseFim),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(dataBaseInicio),
            documento: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.documento),
            grupoPeriodicidade: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.grupoPeriodicidade),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.sistemaNegocio),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            situacao: ConverterParameterObjectToUrlUtils.atributoEnumName(parametrosPesquisa.situacao),
            jaPesquisado: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.jaPesquisado),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
        this.parametrosPesquisa.sistemaNegocio = undefined;
        this.parametrosPesquisa.documento = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.dataBaseInicio = undefined;
        this.parametrosPesquisa.dataBaseFim = undefined;
        this.parametrosPesquisa.situacao = undefined;
        this.parametrosPesquisa.situacoes = undefined;
        this.carregarSistemaNegocio(this.parametrosPesquisa.grupoPeriodicidade);
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.openModalConfirmaDesativacao = function (pk) {
        var _this = this;
        this.entidadeSupervisionadaModalParaDesativarServico.abrir(pk, this.$scope)
            .then(function () { return _this.pesquisar(_this.parametrosPesquisa); });
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.entidadeSupervisionadaControleApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.periodoDataBaseInvalido = function () {
        return !(this.parametrosPesquisa && this.parametrosPesquisa.dataBaseInicio && this.parametrosPesquisa.dataBaseFim
            && (this.moment.utc(this.parametrosPesquisa.dataBaseInicio)).isAfter(this.moment.utc(this.parametrosPesquisa.dataBaseFim)));
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.gerarExcel = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.entidadeSupervisionadaControleApiService.gerarExcel(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.entidadeSupervisionadaControleApiService.montarTelaPesquisa().then(function (montarTelaPesquisa) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaPesquisa;
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
                _this.parametrosPesquisa.situacao = { enumName: 'ATIVA' };
            }
            _this.carregarSistemaNegocio(_this.parametrosPesquisa.grupoPeriodicidade);
            _this.carregarDocumentos(_this.parametrosPesquisa.grupoPeriodicidade, _this.parametrosPesquisa.sistemaNegocio);
            return montarTelaPesquisa;
        });
    };
    EntidadeSupervisionadaControlePesquisaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return EntidadeSupervisionadaControlePesquisaController;
}());
EntidadeSupervisionadaControlePesquisaController.$inject = ['$scope', '$location', '$stateParams', 'entidadeSupervisionadaControleApiService', 'documentoApiService',
    'sistemaNegocioApiService', 'feedbackService', 'moment', '$state', 'EntidadeSupervisionadaModalParaDesativarServico'];
angular.module('crd').controller('EntidadeSupervisionadaControlePesquisaController', EntidadeSupervisionadaControlePesquisaController);
//# sourceMappingURL=entidade-supervisionada-controle-pesquisa-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('entidade-supervisionada-obrigada-detalhar', {
        controller: 'EntidadeSupervisionadaObrigadaDetalheController',
        controllerAs: 'entidadeSupervisionadaObrigadaDetalheCtrl',
        informacaoPagina: {
            codigo: 'XXX',
            label: 'Documento esperado',
            titulo: 'Documento esperado'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/entidade-supervisionada-obrigada/views/entidade-supervisionada-obrigada-detalhe/entidade-supervisionada-obrigada-detalhe-tpl.html',
        url: '/entidade-supervisionada-obrigada/:id'
    });
});
//# sourceMappingURL=entidade-supervisionada-obrigada-route-config.js.map;
"use strict";
var EntidadeSupervisionadaObrigadaDetalheController = (function () {
    function EntidadeSupervisionadaObrigadaDetalheController($state, sistemaNegocioApiService) {
        this.$state = $state;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
    }
    EntidadeSupervisionadaObrigadaDetalheController.prototype.$onInit = function () {
        this.item = {
            id: 25,
            sistemaNegocio: 'COS',
            documento: '4010',
            instituicao: '00.000.000 - BANCO DO BRASIL S.A.',
            dataBase: '12/2021',
            dataLimite: '15/01/2022',
            situacao: {
                codigo: 1,
                nome: 'Esperado'
            },
            recebidoEAceito: false,
            processados: {
                possuiConteudo: true,
                itens: [
                    {
                        protocolo: 241701561,
                        situacoes: [
                            {
                                codigo: 27,
                                nome: 'Substituído - qualidade fora do CRD'
                            }
                        ]
                    },
                    {
                        protocolo: 241701562,
                        situacao: {
                            codigo: 25,
                            nome: 'Aceito - qualidade fora do CRD'
                        }
                    }
                ]
            }
        };
    };
    ;
    EntidadeSupervisionadaObrigadaDetalheController.prototype.voltar = function () {
        this.$state.go('entidade-supervisionada-obrigada');
    };
    return EntidadeSupervisionadaObrigadaDetalheController;
}());
EntidadeSupervisionadaObrigadaDetalheController.$inject = ['$state', 'SistemaNegocioApiService'];
angular.module('crd').controller('EntidadeSupervisionadaObrigadaDetalheController', EntidadeSupervisionadaObrigadaDetalheController);
//# sourceMappingURL=entidade-supervisionada-obrigada-detalhe-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider;
});
//# sourceMappingURL=entidade-supervisionada-router-config.js.map;
"use strict";
//# sourceMappingURL=entidade-supervisionada-inclusao-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EntidadeSupervisionadaApiService = (function (_super) {
    __extends(EntidadeSupervisionadaApiService, _super);
    function EntidadeSupervisionadaApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    EntidadeSupervisionadaApiService.prototype.pesquisarParaSelecao = function (filtro, ignoreLoadingBar) {
        return this.buscarRecurso('/entidade-supervisionada/pesquisar-para-selecao', filtro, { ignoreLoadingBar: ignoreLoadingBar });
    };
    EntidadeSupervisionadaApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso('/entidade-supervisionada/incluir', dados);
    };
    return EntidadeSupervisionadaApiService;
}(AbstractAPISerivce));
EntidadeSupervisionadaApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('EntidadeSupervisionadaApiService', EntidadeSupervisionadaApiService);
//# sourceMappingURL=entidade-supervisionada-api-service.js.map;
"use strict";
var CrdModalConfirmacaoReprocessamentoController = (function () {
    function CrdModalConfirmacaoReprocessamentoController($location, entradaArquivoApiService, $uibModalInstance, feedbackService) {
        this.$location = $location;
        this.entradaArquivoApiService = entradaArquivoApiService;
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.vmModal = this;
    }
    CrdModalConfirmacaoReprocessamentoController.prototype.$onInit = function () {
        this.titulo = "Reprocessar arquivo";
        this.entradaArquivoPK = this.vmModal.paraReprocessar.data.id;
        this.msgDinamica = this.vmModal.paraReprocessar.data.mensagens;
    };
    CrdModalConfirmacaoReprocessamentoController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    CrdModalConfirmacaoReprocessamentoController.prototype.reprocessar = function () {
        var _this = this;
        this.entradaArquivoApiService.reprocessar(this.entradaArquivoPK).then(function (response) {
            var mensagemReprocessar = response.data && response.data.mensagemReprocessar;
            try {
                if (mensagemReprocessar) {
                    _this.feedbackService.erro(mensagemReprocessar);
                }
                else {
                    _this.feedbackService.sucesso('Favor aguardar a próxima execução da rotina de processamento de arquivos.');
                }
            }
            catch (e) {
                console.error('Erro ao exibir mensagem de feedback:', e);
            }
            _this.$uibModalInstance.dismiss();
            _this.voltar();
        }, function (error) {
            console.error('Erro técnico ao reprocessar entrada de arquivo:', error);
            var mensagem = error.data && error.data.mensagemReprocessar
                ? error.data.mensagemReprocessar
                : 'Não foi possível realizar o reprocessamento. Por favor, tente novamente ou entre em contato com o suporte.';
            try {
                _this.feedbackService.erro(mensagem);
            }
            catch (e) {
                console.error('Erro ao exibir mensagem de feedback:', e);
            }
            _this.$uibModalInstance.dismiss();
            _this.voltar();
        });
    };
    CrdModalConfirmacaoReprocessamentoController.prototype.voltar = function () {
        this.$location.path('/esperados-processados');
    };
    return CrdModalConfirmacaoReprocessamentoController;
}());
CrdModalConfirmacaoReprocessamentoController.$inject = ['$location', 'EntradaArquivoApiService', '$uibModalInstance', 'feedbackService', '$uibModal'];
angular.module('crd').controller('CrdModalConfirmacaoReprocessamentoController', CrdModalConfirmacaoReprocessamentoController);
//# sourceMappingURL=crd-modal-confirmacao-reprocessamento-controller.js.map;
"use strict";
var EsperadosProcessadosDetalharController = (function () {
    function EsperadosProcessadosDetalharController($location, $stateParams, entradaArquivoApiService, feedbackService, $scope, $uibModal) {
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.entradaArquivoApiService = entradaArquivoApiService;
        this.feedbackService = feedbackService;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
    }
    EsperadosProcessadosDetalharController.prototype.carregarDadosTela = function (entradaArquivoPK) {
        var _this = this;
        this.entradaArquivoApiService.detalhar(entradaArquivoPK).then(function (response) {
            _this.item = response.data;
        });
    };
    EsperadosProcessadosDetalharController.prototype.navegarGridOcorrencia = function (pagination) {
        var _this = this;
        var parametros = {
            numeroPagina: pagination.number,
            quantidadePorPagina: pagination.size,
            ordenacaoCampo: pagination.sortField,
            ordenacaoDirecao: pagination.sortDirection
        };
        this.entradaArquivoApiService.detalharOcorrencia(this.$stateParams.entradaArquivoPK, parametros).then(function (response) {
            _this.item.ocorrencias = response.data;
        });
    };
    EsperadosProcessadosDetalharController.prototype.reprocessar = function () {
        var _this = this;
        this.entradaArquivoApiService.reprocessar(this.$stateParams.entradaArquivoPK).then(function (response) {
            if (response.status === 200) {
                console.log('cocozado!!!');
                _this.feedbackService.sucesso('Favor aguardar a próxima execução da rotina de processamento de arquivos.');
                _this.voltar();
            }
            return;
        });
    };
    EsperadosProcessadosDetalharController.prototype.paraReprocessar = function () {
        this.abrirModalParaReprocessar();
    };
    EsperadosProcessadosDetalharController.prototype.abrirModalParaReprocessar = function () {
        var _this = this;
        var _self = this;
        return this.entradaArquivoApiService.paraReprocessar(this.$stateParams.entradaArquivoPK).then(function (response) {
            _this.$scope.paraReprocessar = response;
            _this.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/esperados-processados/detalhamento/crd-modal-confirmacao-reprocessamento/crd-modal-confirmacao-reprocessamento-tpl.html',
                controller: 'CrdModalConfirmacaoReprocessamentoController',
                controllerAs: 'crdModalConfirmacaoReprocessamentoCtrl',
                bindToController: true,
                keyboard: true,
                size: 'md',
                scope: _this.$scope
            });
        });
    };
    EsperadosProcessadosDetalharController.prototype.voltar = function () {
        this.$location.path('/esperados-processados');
    };
    EsperadosProcessadosDetalharController.prototype.$onInit = function () {
        this.carregarDadosTela(this.$stateParams.entradaArquivoPK);
    };
    ;
    return EsperadosProcessadosDetalharController;
}());
EsperadosProcessadosDetalharController.$inject = ['$location', '$stateParams', 'EntradaArquivoApiService', 'feedbackService', '$scope', '$uibModal'];
angular.module('crd').controller('EsperadosProcessadosDetalharController', EsperadosProcessadosDetalharController);
//# sourceMappingURL=esperado-processados-detalhar-controller.js.map;
"use strict";
var EsperadosProcessadosListarController = (function () {
    function EsperadosProcessadosListarController($location, $scope, $uibModal, $stateParams, esperadoProcessadoApiService, feedbackService, documentoApiService, sistemaNegocioApiService, moment) {
        this.$location = $location;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$stateParams = $stateParams;
        this.esperadoProcessadoApiService = esperadoProcessadoApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.moment = moment;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        this.desabilitarCamposParaEsperados = false;
        this.desabilitarCamposParaProcessados = false;
        this.desabilitarCamposParaSituacaoSubstituicao = true;
        this.exibirLegendaESPendenteCancelamento = false;
        this.exibirLegendaESCancelada = false;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        this.protocolosPesquisados = {};
    }
    EsperadosProcessadosListarController.prototype.validarProtocolos = function (tag) {
        var s = tag.text || "";
        if (this.protocolosPesquisados[s]) {
            return false;
        }
        this.protocolosPesquisados[s] = true;
        return true;
    };
    EsperadosProcessadosListarController.prototype.limparProtocolosPesquisados = function (tag) {
        delete this.protocolosPesquisados[tag.text];
    };
    EsperadosProcessadosListarController.prototype.checarMudancaPeriodicidade = function (valor) {
        if (this.tempPeriodicidadeSelecionada !== valor) {
            this.esconderResultadoPesquisa();
            this.parametrosPesquisa.sistemasNegocio = undefined;
            this.parametrosPesquisa.documentos = undefined;
            this.parametrosPesquisa.dataBaseFim = undefined;
            this.parametrosPesquisa.dataBaseInicio = undefined;
            this.dadosFormulario.documentos.length = 0;
            this.limparMensagens();
        }
        this.tempPeriodicidadeSelecionada = valor;
    };
    EsperadosProcessadosListarController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    EsperadosProcessadosListarController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    EsperadosProcessadosListarController.prototype.processarCheckTipoResultado = function (valor) {
        this.desabilitarCamposParaProcessados = false;
        this.desabilitarCamposParaEsperados = false;
        if (valor !== undefined && valor === 'ESPERADOS') {
            this.desabilitarCamposParaEsperados = true;
            this.parametrosPesquisa.gruposSituacaoEntradaArquivo = undefined;
            this.parametrosPesquisa.protocoloRecebimento = [];
            this.parametrosPesquisa.dataInicioDeProcessamento = undefined;
            this.parametrosPesquisa.dataFimDeProcessamento = undefined;
        }
        else if (valor !== undefined && valor === 'PROCESSADOS') {
            this.desabilitarCamposParaProcessados = true;
            this.parametrosPesquisa.situacaoEntidadeObrigada = undefined;
        }
    };
    EsperadosProcessadosListarController.prototype.processarCheckSituacaoProcessamento = function (gruposSituacao) {
        this.desabilitarCamposParaSituacaoSubstituicao = true;
        if (gruposSituacao !== undefined || gruposSituacao) {
            var enumNameGruposSituacao = _.map(gruposSituacao, function (value) { return value.enumName; });
            if (_.contains(enumNameGruposSituacao, "SUBSTITUIDO")) {
                this.desabilitarCamposParaSituacaoSubstituicao = false;
            }
            else {
                this.parametrosPesquisa.situacoesSubstituicao = undefined;
            }
        }
    };
    EsperadosProcessadosListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    EsperadosProcessadosListarController.prototype.validaPeriodo = function () {
        if (this.parametrosPesquisa && this.parametrosPesquisa.dataInicioDeProcessamento && this.parametrosPesquisa.dataFimDeProcessamento) {
            var periodoInicio = this.moment.utc(this.parametrosPesquisa.dataInicioDeProcessamento);
            var periodoFim = this.moment.utc(this.parametrosPesquisa.dataFimDeProcessamento);
            return !periodoInicio.isAfter(periodoFim);
        }
        return true;
    };
    EsperadosProcessadosListarController.prototype.validaPeriodoDataBase = function () {
        if (this.parametrosPesquisa && this.parametrosPesquisa.dataBaseInicio && this.parametrosPesquisa.dataBaseFim) {
            var periodoInicio = this.moment.utc(this.parametrosPesquisa.dataBaseInicio);
            var periodoFim = this.moment.utc(this.parametrosPesquisa.dataBaseFim);
            return !periodoInicio.isAfter(periodoFim);
        }
        return true;
    };
    EsperadosProcessadosListarController.prototype.carregarSistemaNegocio = function (grupoPeriodicidade) {
        var _this = this;
        var parametros = {
            grupoPeriodicidade: grupoPeriodicidade,
            quantidadePorPagina: 99999
        };
        this.changeOpcoesDeData(grupoPeriodicidade);
        return this.sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (resource) {
            _this.dadosFormulario.sistemasNegocio.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.sistemasNegocio, resource.data.content);
            return resource;
        });
    };
    EsperadosProcessadosListarController.prototype.carregarDocumentos = function (grupoPeriodicidade, sistemasNegocio) {
        var _this = this;
        if (!sistemasNegocio || _.isEmpty(sistemasNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        var parametros = {
            periodicidade: grupoPeriodicidade === 'MENSAL_OU_MAIOR' ? 'MENSAL' : 'DIARIA',
            sistemaNegocioPks: _.map(sistemasNegocio, function (value) { return value.pk; })
        };
        this.documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            var data = resource.data._embedded;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, data.resultado);
            return resource;
        });
    };
    EsperadosProcessadosListarController.prototype.changeOpcoesDeData = function (grupoPeriodicidade) {
        if (grupoPeriodicidade === 'MENOR_QUE_MENSAL') {
            this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        }
        else {
            this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
        }
    };
    EsperadosProcessadosListarController.prototype.changeSistemaNegocio = function (grupoPeriodicidade, sistemasNegocio) {
        this.esconderResultadoPesquisa();
        this.parametrosPesquisa.documentos = DocumentoUtil.filtrarPorSistemaNegocio(this.parametrosPesquisa.documentos, sistemasNegocio);
        this.carregarDocumentos(grupoPeriodicidade, sistemasNegocio);
    };
    EsperadosProcessadosListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            dataBaseInicio: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseInicio),
            dataBaseFim: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseFim),
            dataFimDeProcessamento: ConverterParameterUrlToObjectUtils.date(filtro.dataFimDeProcessamento),
            dataInicioDeProcessamento: ConverterParameterUrlToObjectUtils.date(filtro.dataInicioDeProcessamento),
            documentos: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documentos),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            grupoPeriodicidade: ConverterParameterUrlToObjectUtils.string(filtro.grupoPeriodicidade),
            protocoloRecebimento: ConverterParameterUrlToObjectUtils.numberArray(filtro.protocoloRecebimento) || [],
            sistemasNegocio: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.sistemasNegocio),
            situacaoEntidadeObrigada: ConverterParameterUrlToObjectUtils.atributoEnumName(filtro.situacaoEntidadeObrigada),
            tipoResultado: ConverterParameterUrlToObjectUtils.string(filtro.tipoResultado),
            gruposSituacaoEntradaArquivo: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.gruposSituacaoEntradaArquivo),
            situacoesSubstituicao: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.situacoesSubstituicao),
            segmentos: ConverterParameterUrlToObjectUtils.atributoCodigoArray(filtro.segmentos),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    EsperadosProcessadosListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var dataBaseFim = this.opcoesDeData.normatizar(parametrosPesquisa.dataBaseFim);
        return {
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dataBaseFim),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataBaseInicio),
            dataFimDeProcessamento: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataFimDeProcessamento),
            dataInicioDeProcessamento: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataInicioDeProcessamento),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.documentos),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            grupoPeriodicidade: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.grupoPeriodicidade),
            protocoloRecebimento: ConverterParameterObjectToUrlUtils.numberArray(parametrosPesquisa.protocoloRecebimento),
            sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.sistemasNegocio),
            situacaoEntidadeObrigada: ConverterParameterObjectToUrlUtils.atributoEnumName(parametrosPesquisa.situacaoEntidadeObrigada),
            tipoResultado: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.tipoResultado),
            gruposSituacaoEntradaArquivo: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.gruposSituacaoEntradaArquivo),
            situacoesSubstituicao: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.situacoesSubstituicao),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(parametrosPesquisa.segmentos),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    EsperadosProcessadosListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        this.limparSelecionados();
        return this.pesquisar(this.parametrosPesquisa);
    };
    EsperadosProcessadosListarController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.tipoResultado = "PROCESSADOS";
        this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
        this.parametrosPesquisa.sistemasNegocio = undefined;
        this.parametrosPesquisa.documentos = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.dataBaseInicio = undefined;
        this.parametrosPesquisa.dataBaseFim = undefined;
        this.parametrosPesquisa.situacaoEntidadeObrigada = undefined;
        this.parametrosPesquisa.protocoloRecebimento = [];
        this.parametrosPesquisa.dataInicioDeProcessamento = undefined;
        this.parametrosPesquisa.dataFimDeProcessamento = undefined;
        this.parametrosPesquisa.gruposSituacaoEntradaArquivo = undefined;
        this.parametrosPesquisa.situacoesSubstituicao = undefined;
        this.parametrosPesquisa.segmentos = undefined;
        this.protocolosPesquisados = {};
        this.processarCheckTipoResultado(this.parametrosPesquisa.tipoResultado);
        this.processarCheckSituacaoProcessamento(this.parametrosPesquisa.gruposSituacaoEntradaArquivo);
        this.checarMudancaPeriodicidade(this.parametrosPesquisa.grupoPeriodicidade);
        this.carregarSistemaNegocio(this.parametrosPesquisa.grupoPeriodicidade);
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    EsperadosProcessadosListarController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        this.acaoReprocessarEmLote = AcaoReprocessarEmLote.build();
        return this.pesquisar(parametrosPesquisa);
    };
    EsperadosProcessadosListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.esperadoProcessadoApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.formatarTooltipMotivo();
            _this.exibirResultadoPesquisa();
            _this.gerarLegenda();
            if (_this.pagina.hasContent) {
                _this.pagina.content.forEach(function (r) {
                    r.selecionadoParaReprocessarEmLote = (_this.acaoReprocessarEmLote.houveSelecaoDeTodos && !_.contains(_this.acaoReprocessarEmLote.removidoDoTodos, r.entradaArquivoPK))
                        || (_.contains(_this.acaoReprocessarEmLote.selecionados, r.entradaArquivoPK));
                });
                _this.exibirLegendaESPendenteCancelamento = _this.pagina.parameters['exibirLegendaESPendenteCancelamento'] || false;
                _this.exibirLegendaESCancelada = _this.pagina.parameters['exibirLegendaESCancelada'] || false;
            }
            return resultado;
        });
    };
    EsperadosProcessadosListarController.prototype.gerarLegenda = function () {
        this.pseudoDocumentosOuDadosAbertos = this.pagina.parameters.pseudoDocumentosOuDadosAbertos;
    };
    EsperadosProcessadosListarController.prototype.formatarTooltipMotivo = function () {
        _.each(this.pagina.content, function (item) {
            item.motivoFormatado = item.motivoFormatado
                ? item.motivoFormatado
                    .replace(/\n/g, '<br>')
                    .replace(/(Dispensa: |Manual: |Documento zerado:)/g, '<br><b class="tt-origem-motivo">$1</b>')
                    .replace(/^[\s]*?<br>/g, '')
                : item.motivoFormatado;
        });
    };
    EsperadosProcessadosListarController.prototype.gerarXLS = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.esperadoProcessadoApiService.gerarXlsx(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    EsperadosProcessadosListarController.prototype.selecionarTodosParaReprocessamentoEmLote = function () {
        var _this = this;
        this.acaoReprocessarEmLote.houveSelecaoDeTodos = this.acaoReprocessarEmLote.selecionouTodos;
        this.acaoReprocessarEmLote.acaoDesabilitada = !this.acaoReprocessarEmLote.selecionouTodos;
        this.acaoReprocessarEmLote.selecionados = [];
        this.acaoReprocessarEmLote.removidoDoTodos = [];
        this.pagina.content.forEach(function (r) {
            r.selecionadoParaReprocessarEmLote = _this.acaoReprocessarEmLote.selecionouTodos;
        });
    };
    EsperadosProcessadosListarController.prototype.selecionarItensPagina = function () {
        this.acaoReprocessarEmLote.selecionouItens = !this.acaoReprocessarEmLote.selecionouItens;
        for (var index = 0; index < this.qtdItensNaTabela(); index++) {
            this.pagina.content[index].selecionadoParaReprocessarEmLote = this.acaoReprocessarEmLote.selecionouItens;
            this.selecionarEntradaArquivoParaReprocessamentoEmLote(this.pagina.content[index]);
        }
    };
    EsperadosProcessadosListarController.prototype.limparSelecionados = function () {
        this.acaoReprocessarEmLote.selecionouTodos = false;
        this.acaoReprocessarEmLote.houveSelecaoDeTodos = false;
        this.acaoReprocessarEmLote.acaoDesabilitada = true;
        this.acaoReprocessarEmLote.selecionados = [];
        this.acaoReprocessarEmLote.removidoDoTodos = [];
        this.pagina.content.forEach(function (r) { return r.selecionadoParaReprocessarEmLote = false; });
    };
    EsperadosProcessadosListarController.prototype.paraReprocessarEmLote = function () {
        var dadosParaReprocessarEmLote = this.converterParametrosParaReprocessarEmLote();
        return this.abrirModalParaReprocessarEmLote(dadosParaReprocessarEmLote, true);
    };
    EsperadosProcessadosListarController.prototype.converterParametrosParaReprocessarEmLote = function () {
        var dados = this.converterParametrosParaUrl(this.parametrosPesquisa);
        dados.houveSelecaoDeTodos = this.acaoReprocessarEmLote.houveSelecaoDeTodos;
        dados.entradaArquivosPK = this.acaoReprocessarEmLote.houveSelecaoDeTodos ? this.acaoReprocessarEmLote.removidoDoTodos : this.acaoReprocessarEmLote.selecionados;
        return dados;
    };
    EsperadosProcessadosListarController.prototype.qtdItensNaTabela = function () {
        var tableElement = document.getElementById('tbl-resultado-pesquisa-esperado-processado');
        return tableElement.getElementsByTagName('tr').length - 1;
    };
    EsperadosProcessadosListarController.prototype.selecionarEntradaArquivoParaReprocessamentoEmLote = function (esperadoProcessado) {
        if (esperadoProcessado.selecionadoParaReprocessarEmLote) {
            if (!_.contains(this.acaoReprocessarEmLote.selecionados, esperadoProcessado.entradaArquivoPK)) {
                this.acaoReprocessarEmLote.selecionados.push(esperadoProcessado.entradaArquivoPK);
                this.acaoReprocessarEmLote.removidoDoTodos.splice(this.acaoReprocessarEmLote.removidoDoTodos.indexOf(esperadoProcessado.entradaArquivoPK), 1);
            }
        }
        else {
            this.acaoReprocessarEmLote.selecionados.splice(this.acaoReprocessarEmLote.selecionados.indexOf(esperadoProcessado.entradaArquivoPK), 1);
            this.acaoReprocessarEmLote.removidoDoTodos.push(esperadoProcessado.entradaArquivoPK);
            this.acaoReprocessarEmLote.selecionouTodos = false;
        }
        this.acaoReprocessarEmLote.acaoDesabilitada = this.acaoReprocessarEmLote.selecionouTodos || !this.acaoReprocessarEmLote.houveSelecaoDeTodos && this.acaoReprocessarEmLote.selecionados.length === 0;
    };
    EsperadosProcessadosListarController.prototype.abrirModalParaReprocessarEmLote = function (dadosParaReprocessarEmLote, limparDadosAposExecutarAcao) {
        var _this = this;
        var _self = this;
        return this.esperadoProcessadoApiService.paraReprocessarEmLote(dadosParaReprocessarEmLote).then(function (response) {
            if (response === null || (response.arquivosInexistentes < 1
                && response.entsArquivosProcotolosNulos < 1
                && response.entsParaReprocessar < 1
                && response.esperadosImpedidosSituacaoEntNaoPermiteReprocessar < 1)) {
                _self.feedbackService.erro('Não existe existe documento processado para executar esta ação.');
                return;
            }
            _self.limparMensagens();
            _this.$scope.paraReprocessarEmLote = response;
            _this.$scope.filtro = dadosParaReprocessarEmLote;
            _self.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/esperados-processados/esperados-processados-modal-para-reprocessar-em-lote-tpl.html',
                controller: 'EsperadosProcessadosModalParaReprocessarEmLoteController',
                controllerAs: 'esperadosProcessadosModalParaReprocessarEmLoteController',
                bindToController: true,
                keyboard: true,
                size: 'lg',
                feedbackService: _this.feedbackService,
                scope: _this.$scope
            }).result
                .then(function () {
                if (limparDadosAposExecutarAcao) {
                    _this.acaoReprocessarEmLote = AcaoReprocessarEmLote.build();
                }
                return _self.pesquisar(_self.parametrosPesquisa);
            });
        });
    };
    EsperadosProcessadosListarController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.esperadoProcessadoApiService.montarTelaPesquisa().then(function (montarTelaEsperadoProcessadoResource) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaEsperadoProcessadoResource._embedded;
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
                _this.parametrosPesquisa.tipoResultado = "PROCESSADOS";
            }
            _this.acaoReprocessarEmLote = AcaoReprocessarEmLote.build();
            _this.carregarSistemaNegocio(_this.parametrosPesquisa.grupoPeriodicidade);
            _this.carregarDocumentos(_this.parametrosPesquisa.grupoPeriodicidade, _this.parametrosPesquisa.sistemasNegocio);
            _this.processarCheckTipoResultado(_this.parametrosPesquisa.tipoResultado);
            _this.processarCheckSituacaoProcessamento(_this.parametrosPesquisa.gruposSituacaoEntradaArquivo);
            return montarTelaEsperadoProcessadoResource;
        });
    };
    EsperadosProcessadosListarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return EsperadosProcessadosListarController;
}());
EsperadosProcessadosListarController.$inject = ['$location', '$scope', '$uibModal', '$stateParams', 'EsperadoProcessadoApiService', 'feedbackService', 'documentoApiService', 'sistemaNegocioApiService', 'moment'];
var AcaoReprocessarEmLote = (function () {
    function AcaoReprocessarEmLote() {
        this.acaoDesabilitada = true;
        this.selecionados = [];
        this.selecionouTodos = false;
        this.houveSelecaoDeTodos = false;
        this.removidoDoTodos = [];
    }
    AcaoReprocessarEmLote.build = function () {
        return new AcaoReprocessarEmLote();
    };
    return AcaoReprocessarEmLote;
}());
angular.module('crd').controller('EsperadosProcessadosListarController', EsperadosProcessadosListarController);
//# sourceMappingURL=esperados-processados-listar-controller.js.map;
(function(angular, HttpStatus) {
  'use strict';

  angular.module('crd')
    .controller('EsperadosProcessadosModalParaReprocessarEmLoteController', EsperadosProcessadosModalParaReprocessarEmLoteController);

  EsperadosProcessadosModalParaReprocessarEmLoteController.$inject = ['$location', '$uibModalInstance', 'feedbackService', 'EntradaArquivoApiService'];
  
  function EsperadosProcessadosModalParaReprocessarEmLoteController($location, $uibModalInstance, feedbackService, entradaArquivoApiService) {
    var vm = this;
    vm.listaProtocolosArquivosInexistentes = "";
    vm.listaDocumentosProtocolosInexistentes = "";
    vm.listaEsoImpedidoSituacaoNaoPermiteReprocessamento = "";
    vm.cancelar = cancelar;
    vm.confirmar = confirmar;
    vm.deveHabilitarBotaoSalvar = deveHabilitarBotaoSalvar;
    vm.obterEntsASeremReprocessadas = obterEntsASeremReprocessadas;

    this.$onInit = function () {
      carregarAquivosInexistentes();
      carregarAquivosProtocolosNulos();
      carregarESOImpedidoSituacaoPermiteRep();
      verificarSeTodosOsProtocolosEstaoMarcados();
    };

    function carregarAquivosInexistentes(){
      if(vm.paraReprocessarEmLote.deveExibirmensagemArquivosInexistentes){
        const listaArquivosInexistentes = vm.paraReprocessarEmLote.arquivosInexistentes;
        
        var listaTempArquivosInexistentes = [];
        if(listaArquivosInexistentes.length === 1) {
          listaTempArquivosInexistentes.push(listaArquivosInexistentes[0].protocoloRecebimento);
          vm.listaProtocolosArquivosInexistentes = listaTempArquivosInexistentes.join("");
        } else { 
          listaArquivosInexistentes.forEach(function(element) {
            listaTempArquivosInexistentes.push(element.protocoloRecebimento);
          });
          listaTempArquivosInexistentes.sort();
          vm.listaProtocolosArquivosInexistentes = listaTempArquivosInexistentes.join(', ');
        }
      }
    }
    
    function carregarAquivosProtocolosNulos(){
      if(vm.paraReprocessarEmLote.deveExibirmensagemEntsSemProtocolo){
        const listaEntsArquivosProtocolosNulos = vm.paraReprocessarEmLote.entsArquivosProtocolosNulos;
        
        var listaTempProtocolosNulos = [];
        if(listaEntsArquivosProtocolosNulos.length === 1) {
          listaTempProtocolosNulos.push(listaEntsArquivosProtocolosNulos[0].nomeArquivo);
          vm.listaDocumentosProtocolosInexistentes = listaTempProtocolosNulos.join("");
        } else { 
          listaEntsArquivosProtocolosNulos.forEach(function(element) {
            listaTempProtocolosNulos.push(element.nomeArquivo);
          });
          listaTempProtocolosNulos.sort();
          vm.listaDocumentosProtocolosInexistentes = listaTempProtocolosNulos.join(', ');
        }
      }
    }

    function carregarESOImpedidoSituacaoPermiteRep(){
      if(vm.paraReprocessarEmLote.deveExibirmensagemESOImpedidoSitNaoPermiteRepro){
        const listaESOImpedidoSitPermiteRep = vm.paraReprocessarEmLote.esperadosImpedidosSituacaoEntNaoPermiteReprocessar;
        
        var listaTempImpedidosSitNaoRep = [];
        if(listaESOImpedidoSitPermiteRep.length === 1) {
          listaTempImpedidosSitNaoRep.push(listaESOImpedidoSitPermiteRep[0].protocoloRecebimento);
          vm.listaEsoImpedidoSituacaoNaoPermiteReprocessamento = listaTempImpedidosSitNaoRep.join("");
        } else { 
          listaESOImpedidoSitPermiteRep.forEach(function(element){
            listaTempImpedidosSitNaoRep.push(element.protocoloRecebimento);
          });
          listaTempImpedidosSitNaoRep.sort();
          vm.listaEsoImpedidoSituacaoNaoPermiteReprocessamento = listaTempImpedidosSitNaoRep.join(', ');
        }
      }
    }

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmar() {
       var entradasArquivosPK = obterEntsASeremReprocessadas()
    
       entradaArquivoApiService.reprocessarEmLote(entradasArquivosPK).then(function (response) {
        if (response.status === HttpStatus.OK) {
          feedbackService.sucesso('Favor aguardar a próxima execução da rotina de processamento de arquivos.');
          $uibModalInstance.close(response.data);
        } else {
          feedbackService.violacoes(response.data);
        }
      });
    }

    function deveHabilitarBotaoSalvar() {
      var desabilitaSalvar = true;
      vm.paraReprocessarEmLote.entsParaReprocessar.forEach(function (ent) {
        if(ent.reprocessar) {
          desabilitaSalvar = false;
          return;
        }
      });
      return desabilitaSalvar;
    }

    vm.selecionarTodosAsEntradasArquivos = function selecionarTodosAsEntradasArquivos(reprocessar) {
      vm.paraReprocessarEmLote.entsParaReprocessar.forEach(function (ent) {ent.reprocessar = reprocessar});
   
      if(reprocessar) {
        vm.quantidadeProtocolosANaoSerReprocessados = 0;
      } else {
        vm.quantidadeProtocolosANaoSerReprocessados = obterQuantidadeProtocolosDesmarcados();
      }

    }

    vm.onChangeEntReprocessar = function onChangeEntReprocessar(ent) {
      verificarSeTodosOsProtocolosEstaoMarcados();
      vm.quantidadeProtocolosANaoSerReprocessados = obterQuantidadeProtocolosDesmarcados();
    }

    function verificarSeTodosOsProtocolosEstaoMarcados() {
      vm.selecionarTodosModal = vm.paraReprocessarEmLote.entsParaReprocessar
        .map(function (ent) {return ent.reprocessar})
        .reduce( function (accumulador, next) { return accumulador || next}, false);
    }

    function obterQuantidadeProtocolosDesmarcados() {
      var acumulador = 0;
      vm.paraReprocessarEmLote.entsParaReprocessar.forEach(
        function (ent) {
          if(!ent.reprocessar) {
            acumulador++;
          } 
        });

        return acumulador;
    }

    function obterEntsASeremReprocessadas() {
      var listaEntradaArquivoPk = [];
      vm.paraReprocessarEmLote.entsParaReprocessar.forEach(
        function (ent) {
          if(ent.reprocessar) {
            listaEntradaArquivoPk.push(ent.entradaArquivoPK);
          } 
        });

        return listaEntradaArquivoPk;
    }


  }
})(angular, httpStatusCode);
;
"use strict";
var EsperadosListarController = (function () {
    function EsperadosListarController($location, $scope, $stateParams, esperadoProcessadoApiService, feedbackService, documentoApiService, sistemaNegocioApiService, moment) {
        this.$location = $location;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.esperadoProcessadoApiService = esperadoProcessadoApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.moment = moment;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        this.desabilitarCamposParaEsperados = false;
        this.desabilitarCamposParaProcessados = false;
        this.desabilitarCamposParaSituacaoSubstituicao = true;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    EsperadosListarController.prototype.checarMudancaPeriodicidade = function (valor) {
        if (this.tempPeriodicidadeSelecionada !== valor) {
            this.esconderResultadoPesquisa();
            this.parametrosPesquisa.sistemasNegocio = undefined;
            this.parametrosPesquisa.documentos = undefined;
            this.parametrosPesquisa.dataBaseFim = undefined;
            this.parametrosPesquisa.dataBaseInicio = undefined;
            this.dadosFormulario.documentos.length = 0;
            this.limparMensagens();
        }
        this.tempPeriodicidadeSelecionada = valor;
    };
    EsperadosListarController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    EsperadosListarController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    EsperadosListarController.prototype.processarCheckTipoResultado = function (valor) {
        this.desabilitarCamposParaProcessados = false;
        this.desabilitarCamposParaEsperados = false;
        if (valor !== undefined && valor === 'ESPERADOS') {
            this.desabilitarCamposParaEsperados = true;
            this.parametrosPesquisa.gruposSituacaoEntradaArquivo = undefined;
            this.parametrosPesquisa.protocoloRecebimento = [];
            this.parametrosPesquisa.dataInicioDeProcessamento = undefined;
            this.parametrosPesquisa.dataFimDeProcessamento = undefined;
        }
        else if (valor !== undefined && valor === 'PROCESSADOS') {
            this.desabilitarCamposParaProcessados = true;
            this.parametrosPesquisa.situacaoEntidadeObrigada = undefined;
        }
    };
    EsperadosListarController.prototype.processarCheckSituacaoProcessamento = function (gruposSituacao) {
        this.desabilitarCamposParaSituacaoSubstituicao = true;
        if (gruposSituacao !== undefined || gruposSituacao) {
            var enumNameGruposSituacao = _.map(gruposSituacao, function (value) { return value.enumName; });
            if (_.contains(enumNameGruposSituacao, "SUBSTITUIDO")) {
                this.desabilitarCamposParaSituacaoSubstituicao = false;
            }
            else {
                this.parametrosPesquisa.situacoesSubstituicao = undefined;
            }
        }
    };
    EsperadosListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    EsperadosListarController.prototype.validaPeriodo = function () {
        if (this.parametrosPesquisa && this.parametrosPesquisa.dataInicioDeProcessamento && this.parametrosPesquisa.dataFimDeProcessamento) {
            var periodoInicio = this.moment.utc(this.parametrosPesquisa.dataInicioDeProcessamento);
            var periodoFim = this.moment.utc(this.parametrosPesquisa.dataFimDeProcessamento);
            return !periodoInicio.isAfter(periodoFim);
        }
        return true;
    };
    EsperadosListarController.prototype.validaPeriodoDataBase = function () {
        if (this.parametrosPesquisa && this.parametrosPesquisa.dataBaseInicio && this.parametrosPesquisa.dataBaseFim) {
            var periodoInicio = this.moment.utc(this.parametrosPesquisa.dataBaseInicio);
            var periodoFim = this.moment.utc(this.parametrosPesquisa.dataBaseFim);
            return !periodoInicio.isAfter(periodoFim);
        }
        return true;
    };
    EsperadosListarController.prototype.carregarSistemaNegocio = function (grupoPeriodicidade) {
        var _this = this;
        var parametros = {
            grupoPeriodicidade: grupoPeriodicidade,
            quantidadePorPagina: 99999
        };
        this.changeOpcoesDeData(grupoPeriodicidade);
        return this.sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (resource) {
            _this.dadosFormulario.sistemasNegocio.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.sistemasNegocio, resource.data.content);
            return resource;
        });
    };
    EsperadosListarController.prototype.carregarDocumentos = function (grupoPeriodicidade, sistemasNegocio) {
        var _this = this;
        if (!sistemasNegocio || _.isEmpty(sistemasNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        var parametros = {
            periodicidade: grupoPeriodicidade === 'MENSAL_OU_MAIOR' ? 'MENSAL' : 'DIARIA',
            sistemaNegocioPks: _.map(sistemasNegocio, function (value) { return value.pk; })
        };
        this.documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, resource._embedded.resultado);
            return resource;
        });
    };
    EsperadosListarController.prototype.changeOpcoesDeData = function (grupoPeriodicidade) {
        if (grupoPeriodicidade === 'MENOR_QUE_MENSAL') {
            this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        }
        else {
            this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
        }
    };
    EsperadosListarController.prototype.changeSistemaNegocio = function (grupoPeriodicidade, sistemasNegocio) {
        this.esconderResultadoPesquisa();
        this.parametrosPesquisa.documentos = DocumentoUtil.filtrarPorSistemaNegocio(this.parametrosPesquisa.documentos, sistemasNegocio);
        this.carregarDocumentos(grupoPeriodicidade, sistemasNegocio);
    };
    EsperadosListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            dataBaseInicio: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseInicio),
            dataBaseFim: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseFim),
            dataFimDeProcessamento: ConverterParameterUrlToObjectUtils.date(filtro.dataFimDeProcessamento),
            dataInicioDeProcessamento: ConverterParameterUrlToObjectUtils.date(filtro.dataInicioDeProcessamento),
            documentos: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documentos),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            grupoPeriodicidade: ConverterParameterUrlToObjectUtils.string(filtro.grupoPeriodicidade),
            protocoloRecebimento: ConverterParameterUrlToObjectUtils.numberArray(filtro.protocoloRecebimento) || [],
            sistemasNegocio: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.sistemasNegocio),
            situacaoEntidadeObrigada: ConverterParameterUrlToObjectUtils.atributoEnumName(filtro.situacaoEntidadeObrigada),
            tipoResultado: ConverterParameterUrlToObjectUtils.string(filtro.tipoResultado),
            gruposSituacaoEntradaArquivo: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.gruposSituacaoEntradaArquivo),
            situacoesSubstituicao: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.situacoesSubstituicao),
            segmentos: ConverterParameterUrlToObjectUtils.atributoCodigoArray(filtro.segmentos),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    EsperadosListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var dataBaseFim = this.opcoesDeData.normatizar(parametrosPesquisa.dataBaseFim);
        return {
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dataBaseFim),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataBaseInicio),
            dataFimDeProcessamento: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataFimDeProcessamento),
            dataInicioDeProcessamento: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataInicioDeProcessamento),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.documentos),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            grupoPeriodicidade: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.grupoPeriodicidade),
            protocoloRecebimento: ConverterParameterObjectToUrlUtils.numberArray(parametrosPesquisa.protocoloRecebimento),
            sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.sistemasNegocio),
            situacaoEntidadeObrigada: ConverterParameterObjectToUrlUtils.atributoEnumName(parametrosPesquisa.situacaoEntidadeObrigada),
            tipoResultado: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.tipoResultado),
            gruposSituacaoEntradaArquivo: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.gruposSituacaoEntradaArquivo),
            situacoesSubstituicao: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.situacoesSubstituicao),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(parametrosPesquisa.segmentos),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    EsperadosListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    EsperadosListarController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.tipoResultado = "PROCESSADOS";
        this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
        this.parametrosPesquisa.sistemasNegocio = undefined;
        this.parametrosPesquisa.documentos = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.dataBaseInicio = undefined;
        this.parametrosPesquisa.dataBaseFim = undefined;
        this.parametrosPesquisa.situacaoEntidadeObrigada = undefined;
        this.parametrosPesquisa.protocoloRecebimento = [];
        this.parametrosPesquisa.dataInicioDeProcessamento = undefined;
        this.parametrosPesquisa.dataFimDeProcessamento = undefined;
        this.parametrosPesquisa.gruposSituacaoEntradaArquivo = undefined;
        this.parametrosPesquisa.situacoesSubstituicao = undefined;
        this.parametrosPesquisa.segmentos = undefined;
        this.processarCheckTipoResultado(this.parametrosPesquisa.tipoResultado);
        this.processarCheckSituacaoProcessamento(this.parametrosPesquisa.gruposSituacaoEntradaArquivo);
        this.checarMudancaPeriodicidade(this.parametrosPesquisa.grupoPeriodicidade);
        this.carregarSistemaNegocio(this.parametrosPesquisa.grupoPeriodicidade);
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    EsperadosListarController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    EsperadosListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.esperadoProcessadoApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.formatarTooltipMotivo();
            _this.exibirResultadoPesquisa();
            _this.gerarLegenda();
            return resultado;
        });
    };
    EsperadosListarController.prototype.gerarLegenda = function () {
        this.pseudoDocumentosOuDadosAbertos = this.pagina.parameters.pseudoDocumentosOuDadosAbertos;
    };
    EsperadosListarController.prototype.formatarTooltipMotivo = function () {
        _.each(this.pagina.content, function (item) {
            item.motivoFormatado = item.motivoFormatado
                ? item.motivoFormatado
                    .replace(/\n/g, '<br>')
                    .replace(/(Dispensa: |Manual: |Documento zerado:)/g, '<br><b class="tt-origem-motivo">$1</b>')
                    .replace(/^[\s]*?<br>/g, '')
                : item.motivoFormatado;
        });
    };
    EsperadosListarController.prototype.gerarXLS = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.esperadoProcessadoApiService.gerarXlsx(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    EsperadosListarController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.esperadoProcessadoApiService.montarTelaPesquisa().then(function (montarTelaEsperadoProcessadoResource) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaEsperadoProcessadoResource._embedded;
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
                _this.parametrosPesquisa.tipoResultado = "ESPERADOS";
            }
            _this.carregarSistemaNegocio(_this.parametrosPesquisa.grupoPeriodicidade);
            _this.carregarDocumentos(_this.parametrosPesquisa.grupoPeriodicidade, _this.parametrosPesquisa.sistemasNegocio);
            _this.processarCheckTipoResultado(_this.parametrosPesquisa.tipoResultado);
            _this.processarCheckSituacaoProcessamento(_this.parametrosPesquisa.gruposSituacaoEntradaArquivo);
            return montarTelaEsperadoProcessadoResource;
        });
    };
    EsperadosListarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return EsperadosListarController;
}());
EsperadosListarController.$inject = ['$location', '$scope', '$stateParams', 'EsperadoProcessadoApiService', 'feedbackService', 'documentoApiService', 'sistemaNegocioApiService', 'moment'];
angular.module('crd').controller('EsperadosListarController', EsperadosListarController);
//# sourceMappingURL=esperados-listar-controller.js.map;
"use strict";
var ImpedidosListarController = (function () {
    function ImpedidosListarController($location, $scope, $stateParams, esperadoProcessadoApiService, feedbackService, documentoApiService, sistemaNegocioApiService, moment) {
        this.$location = $location;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.esperadoProcessadoApiService = esperadoProcessadoApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
        this.moment = moment;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        this.desabilitarCamposParaEsperados = false;
        this.desabilitarCamposParaProcessados = false;
        this.desabilitarCamposParaSituacaoSubstituicao = true;
        this.situacaoEntidadeObrigadaPadrao = { enumName: 'IMPEDIDO' };
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    ImpedidosListarController.prototype.checarMudancaPeriodicidade = function (valor) {
        if (this.tempPeriodicidadeSelecionada !== valor) {
            this.esconderResultadoPesquisa();
            this.parametrosPesquisa.sistemasNegocio = undefined;
            this.parametrosPesquisa.documentos = undefined;
            this.parametrosPesquisa.dataBaseFim = undefined;
            this.parametrosPesquisa.dataBaseInicio = undefined;
            this.dadosFormulario.documentos.length = 0;
            this.limparMensagens();
        }
        this.tempPeriodicidadeSelecionada = valor;
    };
    ImpedidosListarController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    ImpedidosListarController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    ImpedidosListarController.prototype.processarCheckTipoResultado = function (valor) {
        this.desabilitarCamposParaProcessados = false;
        this.desabilitarCamposParaEsperados = false;
    };
    ImpedidosListarController.prototype.processarCheckSituacaoProcessamento = function (gruposSituacao) {
        this.desabilitarCamposParaSituacaoSubstituicao = true;
        if (gruposSituacao !== undefined || gruposSituacao) {
            var enumNameGruposSituacao = _.map(gruposSituacao, function (value) { return value.enumName; });
            if (_.contains(enumNameGruposSituacao, "SUBSTITUIDO")) {
                this.desabilitarCamposParaSituacaoSubstituicao = false;
            }
            else {
                this.parametrosPesquisa.situacoesSubstituicao = undefined;
            }
        }
    };
    ImpedidosListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    ImpedidosListarController.prototype.carregarSistemaNegocio = function (grupoPeriodicidade) {
        var _this = this;
        var parametros = {
            grupoPeriodicidade: grupoPeriodicidade,
            quantidadePorPagina: 99999
        };
        this.changeOpcoesDeData(grupoPeriodicidade);
        return this.sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (resource) {
            _this.dadosFormulario.sistemasNegocio.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.sistemasNegocio, resource.data.content);
            return resource;
        });
    };
    ImpedidosListarController.prototype.carregarDocumentos = function (grupoPeriodicidade, sistemasNegocio) {
        var _this = this;
        if (!sistemasNegocio || _.isEmpty(sistemasNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        var parametros = {
            periodicidade: grupoPeriodicidade === 'MENSAL_OU_MAIOR' ? 'MENSAL' : 'DIARIA',
            sistemaNegocioPks: _.map(sistemasNegocio, function (value) { return value.pk; })
        };
        this.documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, resource._embedded.resultado);
            return resource;
        });
    };
    ImpedidosListarController.prototype.changeOpcoesDeData = function (grupoPeriodicidade) {
        if (grupoPeriodicidade === 'MENOR_QUE_MENSAL') {
            this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        }
        else {
            this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
        }
    };
    ImpedidosListarController.prototype.changeSistemaNegocio = function (grupoPeriodicidade, sistemasNegocio) {
        this.esconderResultadoPesquisa();
        this.parametrosPesquisa.documentos = DocumentoUtil.filtrarPorSistemaNegocio(this.parametrosPesquisa.documentos, sistemasNegocio);
        this.carregarDocumentos(grupoPeriodicidade, sistemasNegocio);
    };
    ImpedidosListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            dataBaseInicio: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseInicio),
            dataBaseFim: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseFim),
            dataFimDeProcessamento: ConverterParameterUrlToObjectUtils.date(filtro.dataFimDeProcessamento),
            dataInicioDeProcessamento: ConverterParameterUrlToObjectUtils.date(filtro.dataInicioDeProcessamento),
            documentos: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documentos),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            grupoPeriodicidade: ConverterParameterUrlToObjectUtils.string(filtro.grupoPeriodicidade),
            protocoloRecebimento: ConverterParameterUrlToObjectUtils.numberArray(filtro.protocoloRecebimento) || [],
            sistemasNegocio: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.sistemasNegocio),
            situacaoEntidadeObrigada: ConverterParameterUrlToObjectUtils.atributoEnumName(filtro.situacaoEntidadeObrigada),
            tipoResultado: ConverterParameterUrlToObjectUtils.string(filtro.tipoResultado),
            gruposSituacaoEntradaArquivo: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.gruposSituacaoEntradaArquivo),
            situacoesSubstituicao: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.situacoesSubstituicao),
            segmentos: ConverterParameterUrlToObjectUtils.atributoCodigoArray(filtro.segmentos),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    ImpedidosListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var dataBaseFim = this.opcoesDeData.normatizar(parametrosPesquisa.dataBaseFim);
        return {
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dataBaseFim),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataBaseInicio),
            dataFimDeProcessamento: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataFimDeProcessamento),
            dataInicioDeProcessamento: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.dataInicioDeProcessamento),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.documentos),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            grupoPeriodicidade: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.grupoPeriodicidade),
            protocoloRecebimento: ConverterParameterObjectToUrlUtils.numberArray(parametrosPesquisa.protocoloRecebimento),
            sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.sistemasNegocio),
            situacaoEntidadeObrigada: ConverterParameterObjectToUrlUtils.atributoEnumName(parametrosPesquisa.situacaoEntidadeObrigada),
            tipoResultado: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.tipoResultado),
            gruposSituacaoEntradaArquivo: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.gruposSituacaoEntradaArquivo),
            situacoesSubstituicao: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(parametrosPesquisa.situacoesSubstituicao),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(parametrosPesquisa.segmentos),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    ImpedidosListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    ImpedidosListarController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.tipoResultado = "IMPEDIDOS";
        this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
        this.parametrosPesquisa.sistemasNegocio = undefined;
        this.parametrosPesquisa.documentos = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.dataBaseInicio = undefined;
        this.parametrosPesquisa.dataBaseFim = undefined;
        this.parametrosPesquisa.situacaoEntidadeObrigada = undefined;
        this.parametrosPesquisa.protocoloRecebimento = [];
        this.parametrosPesquisa.dataInicioDeProcessamento = undefined;
        this.parametrosPesquisa.dataFimDeProcessamento = undefined;
        this.parametrosPesquisa.gruposSituacaoEntradaArquivo = undefined;
        this.parametrosPesquisa.situacoesSubstituicao = undefined;
        this.parametrosPesquisa.segmentos = undefined;
        this.processarCheckTipoResultado(this.parametrosPesquisa.tipoResultado);
        this.processarCheckSituacaoProcessamento(this.parametrosPesquisa.gruposSituacaoEntradaArquivo);
        this.checarMudancaPeriodicidade(this.parametrosPesquisa.grupoPeriodicidade);
        this.carregarSistemaNegocio(this.parametrosPesquisa.grupoPeriodicidade);
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    ImpedidosListarController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        this.parametrosPesquisa.numeroPagina = undefined;
        this.parametrosPesquisa.ordenacaoCampo = undefined;
        this.parametrosPesquisa.ordenacaoDirecao = undefined;
        this.parametrosPesquisa.tipoResultado = "IMPEDIDOS";
        this.parametrosPesquisa.situacaoEntidadeObrigada = this.situacaoEntidadeObrigadaPadrao;
        return this.pesquisar(parametrosPesquisa);
    };
    ImpedidosListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.esperadoProcessadoApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.formatarTooltipMotivo();
            _this.exibirResultadoPesquisa();
            _this.gerarLegenda();
            return resultado;
        });
    };
    ImpedidosListarController.prototype.gerarLegenda = function () {
        this.pseudoDocumentosOuDadosAbertos = this.pagina.parameters.pseudoDocumentosOuDadosAbertos;
    };
    ImpedidosListarController.prototype.formatarTooltipMotivo = function () {
        _.each(this.pagina.content, function (item) {
            item.motivoFormatado = item.motivoFormatado
                ? item.motivoFormatado
                    .replace(/\n/g, '<br>')
                    .replace(/(Dispensa: |Manual: |Documento zerado:)/g, '<br><b class="tt-origem-motivo">$1</b>')
                    .replace(/^[\s]*?<br>/g, '')
                : item.motivoFormatado;
        });
    };
    ImpedidosListarController.prototype.gerarXLS = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.esperadoProcessadoApiService.gerarXlsx(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    ImpedidosListarController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.esperadoProcessadoApiService.montarTelaPesquisa().then(function (montarTelaEsperadoProcessadoResource) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.parametrosPesquisa.situacaoEntidadeObrigada = _this.situacaoEntidadeObrigadaPadrao;
            _this.dadosFormulario = montarTelaEsperadoProcessadoResource._embedded;
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.parametrosPesquisa.grupoPeriodicidade = "MENSAL_OU_MAIOR";
                _this.parametrosPesquisa.tipoResultado = "IMPEDIDOS";
            }
            _this.carregarSistemaNegocio(_this.parametrosPesquisa.grupoPeriodicidade);
            _this.carregarDocumentos(_this.parametrosPesquisa.grupoPeriodicidade, _this.parametrosPesquisa.sistemasNegocio);
            _this.processarCheckTipoResultado(_this.parametrosPesquisa.tipoResultado);
            _this.processarCheckSituacaoProcessamento(_this.parametrosPesquisa.gruposSituacaoEntradaArquivo);
            return montarTelaEsperadoProcessadoResource;
        });
    };
    ImpedidosListarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return ImpedidosListarController;
}());
ImpedidosListarController.$inject = ['$location', '$scope', '$stateParams', 'EsperadoProcessadoApiService', 'feedbackService', 'documentoApiService', 'sistemaNegocioApiService', 'moment'];
angular.module('crd').controller('ImpedidosListarController', ImpedidosListarController);
//# sourceMappingURL=impedidos-listar-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('esperado-detalhe', {
        controller: 'EsperadosDetalheController',
        controllerAs: 'esoDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5033',
            label: 'Documentos esperados',
            titulo: 'Documentos esperados',
            outros: {
                acoes: {
                    voltar: "/esperados"
                }
            }
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/esperados/views/esperados-detalhe/esperados-detalhe-tpl.html',
        url: '/esperado/:esoPk/detalhe'
    })
        .state('impedido-detalhe', {
        controller: 'EsperadosDetalheController',
        controllerAs: 'esoDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5034',
            label: 'Documentos impedidos',
            titulo: 'Documentos impedidos',
            outros: {
                acoes: {
                    voltar: "/impedidos"
                }
            }
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/esperados/views/esperados-detalhe/esperados-detalhe-tpl.html',
        url: '/impedido/:esoPk/detalhe'
    });
});
//# sourceMappingURL=esperados-route-config.js.map;
"use strict";
//# sourceMappingURL=esperado-detalhe-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EsperadosDetalheApiService = (function (_super) {
    __extends(EsperadosDetalheApiService, _super);
    function EsperadosDetalheApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    EsperadosDetalheApiService.prototype.detalhar = function (pk) {
        return this.buscarRecurso("/documento-esperado/" + pk + "/detalhar", {});
    };
    EsperadosDetalheApiService.prototype.detalharEsoDoProcessado = function (pk) {
        return this.buscarRecurso("/documento-esperado/" + pk + "/detalhar-esperado-processado", {});
    };
    return EsperadosDetalheApiService;
}(AbstractAPISerivce));
EsperadosDetalheApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('EsperadosDetalheApiService', EsperadosDetalheApiService);
//# sourceMappingURL=esperados-detalhe-api-service.js.map;
"use strict";
var EsperadosDetalheController = (function () {
    function EsperadosDetalheController($location, $state, $stateParams, feedbackService, esperadosDetalheApiService) {
        this.$location = $location;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.feedbackService = feedbackService;
        this.esperadosDetalheApiService = esperadosDetalheApiService;
    }
    EsperadosDetalheController.prototype.$onInit = function () {
        var _this = this;
        if (this.$state.params.entradaArquivoPK) {
            return this.esperadosDetalheApiService.detalharEsoDoProcessado(this.$state.params.entradaArquivoPK).then(function (response) {
                _this.item = response.data;
            });
        }
        return this.esperadosDetalheApiService.detalhar(this.$state.params.esoPk).then(function (response) {
            _this.item = response.data;
        });
    };
    EsperadosDetalheController.prototype.voltar = function () {
        window.history.back();
    };
    return EsperadosDetalheController;
}());
EsperadosDetalheController.$inject = ['$location', '$state', '$stateParams', 'feedbackService', 'EsperadosDetalheApiService'];
angular.module('crd').controller('EsperadosDetalheController', EsperadosDetalheController);
//# sourceMappingURL=esperados-detalhe-controller.js.map;
"use strict";
var ExcecaoQualidadeAlterarController = (function () {
    function ExcecaoQualidadeAlterarController($scope, $location, $stateParams, excecaoQualidadeApiService, feedbackService, moment) {
        this.$scope = $scope;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.excecaoQualidadeApiService = excecaoQualidadeApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    ExcecaoQualidadeAlterarController.prototype.isDataIncompleta = function (data) {
        return !data || (data + "").length < 11;
    };
    ExcecaoQualidadeAlterarController.prototype.validarDatabaseFim = function () {
        if (!this.excecaoQualidade) {
            return false;
        }
        if (!this.excecaoQualidade.periodo
            || !this.excecaoQualidade.periodo.fim
            || !this.excecaoQualidade.periodo.inicio
            || this.isDataIncompleta(this.excecaoQualidade.periodo.fim)
            || this.isDataIncompleta(this.excecaoQualidade.periodo.inicio)) {
            return true;
        }
        return !this.excecaoQualidade.periodo.fim || this.excecaoQualidade.periodo.fim >= this.excecaoQualidade.periodo.inicio;
    };
    ExcecaoQualidadeAlterarController.prototype.salvar = function () {
        var _this = this;
        var crqParaSalvar = this.converterParaEnviarServidor();
        this.excecaoQualidadeApiService.alterar(this.excecaoQualidade.pk, crqParaSalvar).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Exceção de qualidade salva com sucesso!');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    ExcecaoQualidadeAlterarController.prototype.stringToDate = function (valor) {
        return valor ? this.moment(valor).toDate() : null;
    };
    ExcecaoQualidadeAlterarController.prototype.carregarDadosTela = function (pk) {
        var _self = this;
        return this.excecaoQualidadeApiService.montarTelaDetalhe(pk).then(function (resource) {
            _self.excecaoQualidade = resource;
            if (_self.excecaoQualidade && _self.excecaoQualidade.periodo) {
                if (_self.excecaoQualidade.periodo.inicio) {
                    _self.excecaoQualidade.periodo.inicio = _self.stringToDate(_self.excecaoQualidade.periodo.inicio);
                }
                if (_self.excecaoQualidade.periodo.fim) {
                    _self.excecaoQualidade.periodo.fim = _self.stringToDate(_self.excecaoQualidade.periodo.fim);
                }
            }
        });
    };
    ExcecaoQualidadeAlterarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams.id);
    };
    ExcecaoQualidadeAlterarController.prototype.converterParaEnviarServidor = function () {
        var dataBaseFim = !this.excecaoQualidade.periodo ? undefined : this.opcoesDeData.normatizar(this.excecaoQualidade.periodo.fim);
        var motivo = this.excecaoQualidade.motivoDesconsiderarExcecao.enumName ? this.excecaoQualidade.motivoDesconsiderarExcecao.enumName
            : this.excecaoQualidade.motivoDesconsiderarEnumname;
        return {
            justificativa: this.excecaoQualidade.justificativa,
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dataBaseFim),
            motivoDesconsiderarExcecao: motivo
        };
    };
    ExcecaoQualidadeAlterarController.prototype.voltar = function () {
        this.$location.path('/excecoes-qualidade');
    };
    return ExcecaoQualidadeAlterarController;
}());
ExcecaoQualidadeAlterarController.$inject = ['$scope', '$location', '$stateParams', 'ExcecaoQualidadeApiService', 'feedbackService', 'moment'];
angular.module('crd').controller('ExcecaoQualidadeAlterarController', ExcecaoQualidadeAlterarController);
//# sourceMappingURL=excecao-qualidade-alterar-controller.js.map;
"use strict";
var ExcecaoQualidadeDesativarController = (function () {
    function ExcecaoQualidadeDesativarController($location, $stateParams, excecaoQualidadeApiService, feedbackService) {
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.excecaoQualidadeApiService = excecaoQualidadeApiService;
        this.feedbackService = feedbackService;
    }
    ExcecaoQualidadeDesativarController.prototype.desativar = function (pk) {
        var _self = this;
        return this.excecaoQualidadeApiService.desativar(pk).then(function (response) {
            if (response.status === 200) {
                _self.$location.path('/excecoes-qualidade');
                _self.feedbackService.sucesso('Exceção de qualidade desativada com sucesso!');
            }
            else {
                _self.feedbackService.erro('Erro ao desativar Exceção de qualidade!');
            }
        });
    };
    ExcecaoQualidadeDesativarController.prototype.$onInit = function () {
        return this.desativar(this.$stateParams.id);
    };
    ;
    return ExcecaoQualidadeDesativarController;
}());
ExcecaoQualidadeDesativarController.$inject = ['$location', '$stateParams', 'ExcecaoQualidadeApiService', 'feedbackService'];
angular.module('crd').controller('ExcecaoQualidadeDesativarController', ExcecaoQualidadeDesativarController);
//# sourceMappingURL=excecao-qualidade-desativar-controller.js.map;
"use strict";
var ExcecaoQualidadeDetalheController = (function () {
    function ExcecaoQualidadeDetalheController($state, excecaoQualidadeApiService, $location) {
        this.$state = $state;
        this.excecaoQualidadeApiService = excecaoQualidadeApiService;
        this.$location = $location;
    }
    ExcecaoQualidadeDetalheController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.excecaoQualidadeApiService.montarTelaDetalhe(pk).then(function (resource) {
            _this.excecao = resource;
        });
    };
    ExcecaoQualidadeDetalheController.prototype.voltar = function () {
        this.$location.path('/excecoes-qualidade');
    };
    ExcecaoQualidadeDetalheController.prototype.desativar = function (excecaoId) {
        this.$location.path('/excecoes-qualidade/' + excecaoId + '/desativar');
    };
    ExcecaoQualidadeDetalheController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.id);
    };
    ;
    return ExcecaoQualidadeDetalheController;
}());
ExcecaoQualidadeDetalheController.$inject = ['$state', 'ExcecaoQualidadeApiService', '$location'];
angular.module('crd').controller('ExcecaoQualidadeDetalheController', ExcecaoQualidadeDetalheController);
//# sourceMappingURL=excecao-qualidade-detalhe-controller.js.map;
"use strict";
var ExcecaoQualidadeIncluirController = (function () {
    function ExcecaoQualidadeIncluirController($state, excecaoQualidadeApiService, feedbackService, documentoApiService, segmentoApiService, moment, criticaQualidadeUtils, $scope, $location) {
        this.$state = $state;
        this.excecaoQualidadeApiService = excecaoQualidadeApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.segmentoApiService = segmentoApiService;
        this.moment = moment;
        this.criticaQualidadeUtils = criticaQualidadeUtils;
        this.$scope = $scope;
        this.$location = $location;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    ExcecaoQualidadeIncluirController.prototype.stringToDate = function (valor) {
        return valor ? this.moment(valor).toDate() : null;
    };
    ExcecaoQualidadeIncluirController.prototype.salvar = function () {
        var crqParaSalvar = this.converterParaEnviarServidor();
        var _self = this;
        return this.excecaoQualidadeApiService.incluir(crqParaSalvar).then(function (response) {
            if (response.status === 201) {
                _self.voltar();
                _self.feedbackService.sucesso('Exceção de qualidade salva com sucesso!');
            }
            else {
                _self.feedbackService.violacoes(response.data);
            }
        });
    };
    ExcecaoQualidadeIncluirController.prototype.$onInit = function () {
        this.destinoVoltar = this.$state.params.voltar ? this.$state.params.voltar : 'excecoes-qualidade-listar';
        if (this.$state.params.voltarParametros) {
            this.destinoVoltarParametros = JSON.parse(this.$state.params.voltarParametros);
        }
        return this.carregarDadosTela(this.$state.params.indicioPk);
    };
    ExcecaoQualidadeIncluirController.prototype.carregarDadosTela = function (indicioPk) {
        var _this = this;
        return this.excecaoQualidadeApiService.montarTelaIncluir({ indicioPk: indicioPk }).then(function (resource) {
            _this.dadosFormulario = resource.dadosParaConstruirForm;
            _this.excecaoQualidade = resource.dadosDoForm;
            _this.excecaoQualidade.periodo.inicio = _this.stringToDate(resource.dadosDoForm.periodo.inicio);
        });
    };
    ExcecaoQualidadeIncluirController.prototype.voltar = function () {
        this.$state.go(this.destinoVoltar, this.destinoVoltarParametros);
    };
    ExcecaoQualidadeIncluirController.prototype.carregarDocumentoPorCritica = function (critica) {
        var _this = this;
        if (!critica) {
            this.dadosFormulario.documentos = [];
            this.excecaoQualidade.sistemaNegocio = null;
            return;
        }
        this.documentoApiService.buscarPorCritica(critica.pk).then(function (documentos) {
            _this.dadosFormulario.documentos = documentos;
            if (_.isEmpty(documentos)) {
                return;
            }
            _this.excecaoQualidade.sistemaNegocio = documentos[0].sistemaNegocio;
        });
    };
    ExcecaoQualidadeIncluirController.prototype.onCriticaSelecionada = function () {
        this.carregarDocumentoPorCritica(this.excecaoQualidade.critica);
        this.excecaoQualidade.documentos = [];
        this.excecaoQualidade.segmentos = [];
        this.excecaoQualidade.instituicao = undefined;
    };
    ExcecaoQualidadeIncluirController.prototype.onInstituicaoAlterada = function () {
        this.excecaoQualidade.segmentos = [];
    };
    ExcecaoQualidadeIncluirController.prototype.onSegmentoAlterado = function () {
        this.excecaoQualidade.instituicao = undefined;
    };
    ExcecaoQualidadeIncluirController.prototype.isDataIncompleta = function (data) {
        return !data || (data + "").length < 11;
    };
    ExcecaoQualidadeIncluirController.prototype.validarDatabaseFim = function () {
        if (!this.excecaoQualidade || !this.excecaoQualidade.periodo
            || !this.excecaoQualidade.periodo.fim
            || !this.excecaoQualidade.periodo.inicio
            || this.isDataIncompleta(this.excecaoQualidade.periodo.fim)
            || this.isDataIncompleta(this.excecaoQualidade.periodo.inicio)) {
            return true;
        }
        return this.excecaoQualidade.periodo.fim >= this.excecaoQualidade.periodo.inicio;
    };
    ExcecaoQualidadeIncluirController.prototype.validarDatabaseInicio = function () {
        if (!this.excecaoQualidade
            || !this.excecaoQualidade.periodo
            || !this.excecaoQualidade.periodo.inicio
            || this.isDataIncompleta(this.excecaoQualidade.periodo.inicio)) {
            return true;
        }
        var isMaiorQueInicio = !this.excecaoQualidade.critica.databaseInicio || this.excecaoQualidade.periodo.inicio >= this.stringToDate(this.excecaoQualidade.critica.databaseInicio);
        var isMenorQueFim = !this.excecaoQualidade.critica.databaseFim
            || this.stringToDate(this.excecaoQualidade.periodo.inicio.toDateString()) <= this.stringToDate(this.excecaoQualidade.critica.databaseFim);
        return isMaiorQueInicio && isMenorQueFim;
    };
    ExcecaoQualidadeIncluirController.prototype.converterParaEnviarServidor = function () {
        var dataInicio = !this.excecaoQualidade.periodo ? undefined : this.opcoesDeData.normatizar(this.excecaoQualidade.periodo.inicio);
        var dataFim = !this.excecaoQualidade.periodo ? undefined : this.opcoesDeData.normatizar(this.excecaoQualidade.periodo.fim);
        return {
            critica: this.excecaoQualidade.critica.pk,
            identificador: this.excecaoQualidade.identificador,
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(this.excecaoQualidade.documentos),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(this.excecaoQualidade.segmentos),
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(this.excecaoQualidade.instituicao),
            periodo: {
                fim: ConverterParameterObjectToUrlUtils.date(dataFim),
                inicio: ConverterParameterObjectToUrlUtils.date(dataInicio)
            },
            justificativa: this.excecaoQualidade.justificativa,
            motivoDesconsiderarExcecao: this.excecaoQualidade.motivoDesconsiderarExcecao.enumName
        };
    };
    return ExcecaoQualidadeIncluirController;
}());
ExcecaoQualidadeIncluirController.$inject = ['$state', 'ExcecaoQualidadeApiService', 'feedbackService', 'documentoApiService', 'segmentoApiService', 'moment', 'CriticaQualidadeUtils', '$scope', '$location'];
angular.module('crd').controller('ExcecaoQualidadeIncluirController', ExcecaoQualidadeIncluirController);
//# sourceMappingURL=excecao-qualidade-incluir-controller.js.map;
"use strict";
var ExcecaoQualidadePesquisaController = (function () {
    function ExcecaoQualidadePesquisaController($scope, $location, $stateParams, excecaoQualidadeApiService, feedbackService) {
        this.$scope = $scope;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.excecaoQualidadeApiService = excecaoQualidadeApiService;
        this.feedbackService = feedbackService;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
    }
    ExcecaoQualidadePesquisaController.prototype.gerarExcel = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.excecaoQualidadeApiService.gerarExcel(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    ExcecaoQualidadePesquisaController.prototype.desativar = function (excecaoId) {
        this.$location.path('/excecoes-qualidade/' + excecaoId + '/desativar');
    };
    ExcecaoQualidadePesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    ExcecaoQualidadePesquisaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    ExcecaoQualidadePesquisaController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    ExcecaoQualidadePesquisaController.prototype.marcarAtiva = function () {
        if (this.parametrosPesquisa.inativa) {
            this.parametrosPesquisa.inativa = false;
        }
    };
    ExcecaoQualidadePesquisaController.prototype.marcarInativa = function () {
        if (this.parametrosPesquisa.ativa) {
            this.parametrosPesquisa.ativa = false;
        }
    };
    ExcecaoQualidadePesquisaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    ExcecaoQualidadePesquisaController.prototype.limparResultadoPesquisa = function () {
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    ExcecaoQualidadePesquisaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao),
            ativa: ConverterParameterUrlToObjectUtils.atributoBoolean(filtro.ativa),
            inativa: ConverterParameterUrlToObjectUtils.atributoBoolean(filtro.inativa),
            excecoes: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.excecoesId),
            critica: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.critica),
            segmento: ConverterParameterUrlToObjectUtils.atributoCodigoArray(filtro.segmento),
            documentos: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documentos),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            sistemaNegocio: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.sistemaNegocio)
        };
    };
    ExcecaoQualidadePesquisaController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            jaPesquisado: true,
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao),
            ativa: ConverterParameterObjectToUrlUtils.atributoBoolean(parametrosPesquisa.ativa),
            inativa: ConverterParameterObjectToUrlUtils.atributoBoolean(parametrosPesquisa.inativa),
            excecoesId: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.excecoes),
            critica: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.critica),
            segmento: ConverterParameterObjectToUrlUtils.atributoCodigoArray(parametrosPesquisa.segmento),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.documentos),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(parametrosPesquisa.sistemaNegocio)
        };
    };
    ExcecaoQualidadePesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.sistemaNegocio = undefined;
        this.parametrosPesquisa.documentos = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.ativa = true;
        this.parametrosPesquisa.inativa = undefined;
        this.parametrosPesquisa.segmento = [];
        this.parametrosPesquisa.critica = undefined;
        this.parametrosPesquisa.excecoes = undefined;
        this.limparResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    ExcecaoQualidadePesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    ExcecaoQualidadePesquisaController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.excecaoQualidadeApiService.pesquisar(parametros).then(function (resource) {
            _this.pagina = resource;
            _this.exibirResultadoPesquisa();
            return resource;
        });
    };
    ExcecaoQualidadePesquisaController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.excecaoQualidadeApiService.montarTelaPesquisa().then(function (montarTelaPesquisa) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaPesquisa;
            if (!jaPossuiParametrosInformados) {
                _this.parametrosPesquisa.ativa = true;
                _this.parametrosPesquisa.inativa = false;
            }
            _this.pesquisar(_this.parametrosPesquisa);
            return montarTelaPesquisa;
        });
    };
    ExcecaoQualidadePesquisaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return ExcecaoQualidadePesquisaController;
}());
ExcecaoQualidadePesquisaController.$inject = [
    '$scope',
    '$location',
    '$stateParams',
    'ExcecaoQualidadeApiService',
    'feedbackService'
];
angular.module('crd').controller('ExcecaoQualidadePesquisaController', ExcecaoQualidadePesquisaController);
//# sourceMappingURL=excecao-qualidade-pesquisa-controller.js.map;
(function(angular, moment, conversor, HttpStatus) {
  'use strict';

  angular
    .module('crd')
    .controller('ExcecaoAlterarController', ExcecaoAlterarController);

  ExcecaoAlterarController.$inject = ['$location', '$stateParams', 'excecaoApiService', 'feedbackService', 'periodicidadeService'];

  function ExcecaoAlterarController($location, $stateParams, excecaoApiService, feedbackService, periodicidadeService) {
    var vm = this;

    vm.voltar = voltar;
    vm.alterar = alterar;
    carregarTela();

    function voltar() {
      $location.path('/excecoes');
    }

    function alterar() {
      var send = tratarDados(vm.excecao);
      return excecaoApiService
        .alterar(vm.excecao.pk, send)
        .then(successOnAlterar);

      function successOnAlterar(response) {
        if (response.status === HttpStatus.OK) {
          vm.voltar();
          feedbackService.sucesso('Exceção de cobrança de atraso salva com sucesso!');
        } else {
          feedbackService.violacoes(response.data);
        }
      }
    }

    function carregarTela() {
      return excecaoApiService
        .detalhar($stateParams.id)
        .then(successOnCarregar);

      function successOnCarregar(resource) {
        vm.excecao = resource;
        vm.excecao.periodo.inicio = conversor.stringToDate(resource.periodo.inicio);
        vm.excecao.periodo.fim = conversor.stringToDate(resource.periodo.fim);
      }
    }
  }

  function tratarDados(excecao) {
    return {
      justificativa: excecao.justificativa,
      periodo: {
        fim: conversor.dateToString(excecao.periodo.fim),
        inicio: conversor.dateToString(excecao.periodo.inicio)
      }
    };
  }
})(angular, moment, CRDUtils.Conversor, httpStatusCode);
;
(function(angular, HttpStatus) {
  'use strict';

  angular
    .module('crd')
    .controller('ExcecaoDesativarController', ExcecaoDesativarController);

  ExcecaoDesativarController.$inject = ['$location', '$stateParams', 'excecaoApiService', 'feedbackService'];

  function ExcecaoDesativarController($location, $stateParams, excecaoApiService, feedbackService) {
    desativar();

    function desativar() {
      return excecaoApiService
        .desativar($stateParams.id)
        .then(successOnDesativar);

      function successOnDesativar(response) {
        if (response.status === HttpStatus.OK) {
          $location.path('/excecoes');
          feedbackService.sucesso('Exceção de cobrança de atraso desativada com sucesso!');
        } else {
          feedbackService.erro('Erro ao desativar Exceção!');
        }
      }
    }
  }
})(angular, httpStatusCode);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('ExcecaoDetalharController', ExcecaoDetalharController);

  ExcecaoDetalharController.$inject = ['$location', '$stateParams', 'excecaoApiService'];

  function ExcecaoDetalharController($location, $stateParams, excecaoApiService) {
    var vm = this;

    carregarTela();
    vm.desativarExcecao = desativar;
    vm.voltar = voltar;

    function carregarTela() {
      return excecaoApiService
        .detalhar($stateParams.id)
        .then(sucessoDetalhar);

      function sucessoDetalhar(resource) {
        vm.excecao = resource;
      }
    }

    function desativar(excecaoId) {
      $location.path('/excecoes/' + excecaoId + '/desativar');
    }

    function voltar() {
      $location.path('/excecoes');
    }
  }
})(angular);
;
(function(angular, CRDUtils, HttpStatus) {
  'use strict';

  var conversor = CRDUtils.Conversor;
  var criador = CRDUtils.ParametrosUrl.Criador;

  angular
    .module('crd')
    .controller('ExcecaoIncluirController', ExcecaoIncluirController);

  ExcecaoIncluirController.$inject = ['$location', 'excecaoApiService', 'feedbackService'];

  function ExcecaoIncluirController($location, excecaoApiService, feedbackService) {
    var vm = this;

    vm.validarDocumentos = validarDocumentos;
    vm.validarInstituicao = validarInstituicao;
    vm.voltar = voltar;
    vm.salvar = salvar;
    vm.excecao = {};
    carregarTela();

    function validarDocumentos(excecao) {
      return validarDocumentoOUInstituicaoPreenchido(excecao);
    }

    function validarInstituicao(excecao) {
      return validarDocumentoOUInstituicaoPreenchido(excecao);
    }

    function voltar() {
      $location.path('/excecoes');
    }

    function salvar() {
      var send = tratarDados(vm.excecao);
      return excecaoApiService
        .criar(send)
        .then(successCriarExcecao);

      function successCriarExcecao(response) {
        if (response.status === HttpStatus.CREATED) {
          vm.voltar();
          feedbackService.sucesso('Exceção de cobrança de atraso salva com sucesso!');
        } else {
          feedbackService.violacoes(response.data);
        }
      }
    }

    function carregarTela() {
      excecaoApiService
        .telaCriar()
        .then(successOnCarregarTela);

      function successOnCarregarTela(resource) {
        vm.sistemasNegocio = resource._embedded.sistemasNegocio;
      }
    }

    function validarDocumentoOUInstituicaoPreenchido(excecao) {
      if (!excecao.instituicao && !excecao.documentos) {
        return false;
      }
      return true;
    }

    function tratarDados(excecao) {
      return {
        documentos: criador.arrayObjetoPk(excecao.documentos),
        idBacen: excecao.instituicao ? excecao.instituicao.idBacen : null,
        justificativa: excecao.justificativa,
        periodo: {
          fim: conversor.dateToString(excecao.periodo.fim),
          inicio: conversor.dateToString(excecao.periodo.inicio)
        },
        sistemaNegocio: {
          pk: excecao.sistemaNegocio.pk,
          sigla: excecao.sistemaNegocio.sigla
        }
      };
    }
  }
})(angular, CRDUtils, httpStatusCode);
;
(function(angular, moment, parametrosUrl) {
  'use strict';

  var COLUNA_CODIGO = 0;
  var COLUNA_DOCUMENTO = 1;
  var COLUNA_CNPJ_INSTITUICAO = 2;
  var COLUNA_NOME_INSTITUICAO = 3;
  var COLUNA_DATABASE_INICIO = 4;
  var COLUNA_DATABASE_FIM = 5;
  var COLUNA_ACOES = 10;

  angular
    .module('crd')
    .controller('ExcecaoListarController', ExcecaoListarController);

  ExcecaoListarController.$inject = [
    '$scope',
    '$location',
    '$stateParams',
    'constantes',
    'DTColumnDefBuilder',
    'excecaoApiService',
    'feedbackService'
  ];

  function ExcecaoListarController($scope, $location, $stateParams,
    constantes, DTColumnDefBuilder, excecaoApiService, feedbackService) {
    var vm = this;

    configurarGridResultados();
    tratarParametrosPadroes();
    carregarTela();

    vm.esconderResultadoPesquisa = esconderResultadoPesquisa;
    vm.gerarXLS = gerarXLS;
    vm.desativarExcecao = desativar;
    vm.limparMensagens = limparMensagens;
    vm.marcarAtiva = marcarAtiva;
    vm.marcarInativa = marcarInativa;
    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;

    vm.view = {
      formulario: {
        visivel: true
      },
      resultado: {
        visivel: false
      }
    };

    function exibirResultadoPesquisa() {
      vm.view.resultado.visivel = true;
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function gerarXLS() {
      var parameters = montarParametrosDaUrl(vm.parametrosPesquisa);
      return excecaoApiService.gerarXLSX(parameters).then(function successOnGerarXLS() {
        feedbackService.sucesso('Relatório gerado com sucesso.');
        return;
      });
    }

    function desativar(excecaoId) {
      $location.path('/excecoes/' + excecaoId + '/desativar');
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function marcarAtiva() {
      if (vm.parametrosPesquisa.inativa) {
        vm.parametrosPesquisa.inativa = false;
      }
    }

    function marcarInativa() {
      if (vm.parametrosPesquisa.ativa) {
        vm.parametrosPesquisa.ativa = false;
      }
    }

    function pesquisar() {
      var parametros = montarParametrosDaUrl(vm.parametrosPesquisa);
      $location.search(parametros);

      return excecaoApiService
        .pesquisar(parametros)
        .then(successOnPesquisar);

      function successOnPesquisar(resource) {
        var excecoes = tratarExcecoesAntesDeApresentarNaTela(resource._embedded.resultado);
        vm.resultadoPesquisa = excecoes;
        exibirResultadoPesquisa();
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.codigos = undefined;
      vm.parametrosPesquisa.sistemaNegocio = undefined;
      vm.parametrosPesquisa.documento = undefined;
      vm.parametrosPesquisa.instituicao = undefined;
      vm.parametrosPesquisa.dataBase = undefined;
      vm.parametrosPesquisa.ativa = undefined;
      vm.parametrosPesquisa.inativa = undefined;

      vm.limparMensagens();
      vm.esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function formatarData(data, formato) {
      return moment(data).format(formato);
    }

    function carregarTela() {
      return excecaoApiService
        .telaPesquisar()
        .then(successOnCarregarTelaPesquisar);

      function successOnCarregarTelaPesquisar(resource) {
        vm.sistemasNegocio = resource._embedded.sistemasNegocio;
        vm.situacoes = resource._embedded.situacoes;
        vm.podeIncluir = resource._links['excecoes-tela-criar'];
        vm.excecoes = resource._embedded.excecoes;

        vm.parametrosPesquisa = extrairParametrosDaUrl($stateParams);
        vm.pesquisar();
      }
    }

    function tratarExcecoesAntesDeApresentarNaTela(excecoes) {
      excecoes.forEach(function(excecao) {
        var format = excecao.documento.menorTipoPeriodicidade.formatoData.formato.toUpperCase();
        excecao.periodo.inicioFmt = formatarData(excecao.periodo.inicio, format);
        if (excecao.periodo.fim) {
          excecao.periodo.fimFmt = formatarData(excecao.periodo.fim, format);
        }
      });
      return excecoes;
    }

    function defineTamanhoGridResultado() {
      vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(COLUNA_CODIGO).withOption('width', '6%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_DOCUMENTO).withOption('width', '6%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_CNPJ_INSTITUICAO).withOption('width', '6%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_NOME_INSTITUICAO).withOption('width', '14%'),
        DTColumnDefBuilder.newColumnDef(COLUNA_DATABASE_INICIO)
          .withOption('width', '9%')
          .withOption('type', 'type-data-base'),
        DTColumnDefBuilder.newColumnDef(COLUNA_DATABASE_FIM)
          .withOption('width', '9%')
          .withOption('type', 'type-data-base'),
        DTColumnDefBuilder.newColumnDef(COLUNA_ACOES).withOption('bSortable', false)
      ];
    }

    function configurarGridResultados() {
      defineTamanhoGridResultado();

      vm.dtOptions = {};
    }

    function tratarParametrosPadroes() {
      if (angular.isUndefined($stateParams.ativa)) {
        $stateParams.ativa = true;
        $stateParams.inativa = false;
      }
    }

    function extrairParametrosDaUrl() {
      var extrator = parametrosUrl.Extrator;
      var codigosExcecao = [];

      if (!$stateParams.codigos || !($stateParams.codigos.constructor === Array)) {
        codigosExcecao.push($stateParams.codigos);
      } else {
        codigosExcecao = $stateParams.codigos;
      }


      return {
        ativa: extrator.toBoolean($stateParams.ativa),
        codigos: codigosExcecao,
        dataBase: extrator.data($stateParams.dataBase),
        documento: extrator.objetoPk($stateParams.documento),
        inativa: extrator.toBoolean($stateParams.inativa),
        instituicao: extrator.objetoIdBacen($stateParams.idBacen),
        sistemaNegocio: extrator.objetoPk($stateParams.sistemaNegocio)
      };
    }

    function montarParametrosDaUrl(parametrosPesquisa) {
      var criador = parametrosUrl.Criador;
      return {
        ativa: parametrosPesquisa.ativa,
        jaPesquisado: true,
        codigos: parametrosPesquisa.codigos,
        dataBase: criador.data(parametrosPesquisa.dataBase),
        documento: criador.pk(parametrosPesquisa.documento),
        idBacen: criador.idBacen(parametrosPesquisa.instituicao),
        inativa: parametrosPesquisa.inativa,
        sistemaNegocio: criador.pk(parametrosPesquisa.sistemaNegocio)
      };
    }
  }
})(angular, moment, CRDUtils.ParametrosUrl);
;
"use strict";
angular.module('crd').config(function ($stateProvider) {
    $stateProvider
        .state('incidente-qualidade-pesquisa', {
        controller: 'IncidenteQualidadeConsultaController',
        controllerAs: 'incidenteQualidadeConsultaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4031',
            label: 'Pesquisa de incidentes de qualidade',
            titulo: 'Pesquisa de incidentes de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/incidente-qualidade/views/incidente-qualidade-consulta/incidente-qualidade-consulta-tpl.html',
        url: '/incidente-qualidade?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&grupoPeriodicidade&documentos&sistemasNegocio&idBacen&dataBaseInicio&dataBaseFim&criticas&gravidades'
    })
        .state('incidente-qualidade-detalhar', {
        controller: 'IncidenteQualidadeDetalheController',
        controllerAs: 'incidenteQualidadeDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4034',
            label: 'Detalhar incidentes de qualidade',
            titulo: 'Detalhar incidentes de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/incidente-qualidade/views/incidente-qualidade-detalhe/incidente-qualidade-detalhe-tpl.html',
        url: '/incidente-qualidade/:pk/detalhar?voltar&voltarParametros'
    })
        .state('incidente-qualidade-alterar', {
        controller: 'IncidenteQualidadeAlteracaoController',
        controllerAs: 'incidenteQualidadeAlteracaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4033',
            label: 'Alterar incidentes de qualidade',
            titulo: 'Alterar incidentes de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/incidente-qualidade/views/incidente-qualidade-alteracao/incidente-qualidade-alteracao-tpl.html',
        url: '/incidente-qualidade/:pk/alterar?voltar&voltarParametros'
    })
        .state('incidente-qualidade-incluir', {
        controller: 'IncidenteQualidadeInclusaoController',
        controllerAs: 'incidenteQualidadeInclusaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4032',
            label: 'Incluir incidentes de qualidade',
            titulo: 'Incluir incidentes de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/incidente-qualidade/views/incidente-qualidade-inclusao/incidente-qualidade-inclusao-tpl.html',
        url: '/incidente-qualidade/incluir?voltar&voltarParametros'
    });
});
//# sourceMappingURL=incidente-qualidade-route-config.js.map;
"use strict";
//# sourceMappingURL=incidente-qualidade-alteracao-dto.js.map;
"use strict";
//# sourceMappingURL=incidente-qualidade-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=incidente-qualidade-detalhe-dto.js.map;
"use strict";
//# sourceMappingURL=incidente-qualidade-inclusao-dto.js.map;
"use strict";
//# sourceMappingURL=incidente-qualidade-manutencao-dto.js.map;
"use strict";
//# sourceMappingURL=incidente-qualidade-para-consultar-dto.js.map;
"use strict";
//# sourceMappingURL=incidente-qualidade-resumo-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var IncidenteQualidadeApiService = (function (_super) {
    __extends(IncidenteQualidadeApiService, _super);
    function IncidenteQualidadeApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    IncidenteQualidadeApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/incidente-qualidade/para-consultar', consultaFiltro);
    };
    IncidenteQualidadeApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/incidente-qualidade/consultar', consultaFiltro);
    };
    IncidenteQualidadeApiService.prototype.paraIncluir = function () {
        return this.buscarRecurso('/incidente-qualidade/para-incluir', {});
    };
    IncidenteQualidadeApiService.prototype.incluir = function (dados, anexosNovos) {
        var payload = this.criarPayload(dados, anexosNovos);
        return this.incluirRecurso('/incidente-qualidade/incluir', payload);
    };
    IncidenteQualidadeApiService.prototype.paraAlterar = function (pk) {
        return this.buscarRecurso("/incidente-qualidade/" + pk + "/para-alterar", {});
    };
    IncidenteQualidadeApiService.prototype.alterar = function (pk, dados, anexosAntigos, anexosNovos) {
        var payload = this.criarPayload(dados, anexosNovos);
        payload.append('anexosAntigos', new Blob([JSON.stringify(anexosAntigos)], { type: 'application/json;charset=UTF-8' }));
        return this.alterarRecurso("/incidente-qualidade/" + pk + "/alterar", payload);
    };
    IncidenteQualidadeApiService.prototype.detalhar = function (pk) {
        return this.buscarRecurso("/incidente-qualidade/" + pk + "/detalhar", {});
    };
    IncidenteQualidadeApiService.prototype.excluir = function (pk) {
        return this.excluirRecurso("/incidente-qualidade/" + pk + "/excluir", {});
    };
    IncidenteQualidadeApiService.prototype.relatorioExcel = function (consultaFiltro) {
        return this.baixarArquivo('/incidente-qualidade/relatorio-em-excel', consultaFiltro);
    };
    IncidenteQualidadeApiService.prototype.downloadAnexo = function (pk) {
        return this.baixarArquivo("/incidente-qualidade/anexo/" + pk + "/download", {});
    };
    IncidenteQualidadeApiService.prototype.criarPayload = function (dados, anexosNovos) {
        var payload = new FormData();
        payload.append('incidenteQualidade', new Blob([JSON.stringify(dados)], { type: 'application/json;charset=UTF-8' }));
        if (anexosNovos && anexosNovos.length > 0) {
            anexosNovos.forEach(function (anexo) { return payload.append('anexosNovos', anexo); });
        }
        return payload;
    };
    return IncidenteQualidadeApiService;
}(AbstractAPISerivce));
IncidenteQualidadeApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('IncidenteQualidadeApiService', IncidenteQualidadeApiService);
//# sourceMappingURL=incidente-qualidade-api-service.js.map;
"use strict";
var IncidenteQualidadeAlteracaoController = (function () {
    function IncidenteQualidadeAlteracaoController($state, incidenteQualidadeApiService, feedbackService) {
        this.$state = $state;
        this.incidenteQualidadeApiService = incidenteQualidadeApiService;
        this.feedbackService = feedbackService;
    }
    IncidenteQualidadeAlteracaoController.prototype.$onInit = function () {
        var _this = this;
        this.destinoVoltar = this.$state.params.voltar || 'incidente-qualidade-pesquisa';
        this.destinoVoltarParametros = this.converterParametrosDeRetorno(this.$state.params.voltarParametros);
        return this.incidenteQualidadeApiService.paraAlterar(this.$state.params.pk).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.incidenteQualidade = response.data.dadosFormulario.incidenteQualidade;
            _this.anexoAlterado = false;
            return response;
        });
    };
    IncidenteQualidadeAlteracaoController.prototype.onAnexosAlterados = function () {
        this.anexoAlterado = true;
    };
    IncidenteQualidadeAlteracaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var anexos = FileUtils.separarAntigosENovos(dadosFormulario.anexos);
        var dados = this.converterParaEnviarServidor(dadosFormulario);
        return this.incidenteQualidadeApiService.alterar(dadosFormulario.pk, dados, anexos.antigos, anexos.novos).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Incidente de qualidade alterado com sucesso.');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(response.data);
            }
            return response;
        });
    };
    IncidenteQualidadeAlteracaoController.prototype.downloadAnexo = function (pk) {
        return this.incidenteQualidadeApiService.downloadAnexo(pk);
    };
    IncidenteQualidadeAlteracaoController.prototype.voltar = function () {
        this.$state.go(this.destinoVoltar, this.destinoVoltarParametros);
    };
    IncidenteQualidadeAlteracaoController.prototype.converterParametrosDeRetorno = function (parametros) {
        return parametros ? JSON.parse(parametros) : undefined;
    };
    IncidenteQualidadeAlteracaoController.prototype.converterParaEnviarServidor = function (dadosFormulario) {
        return {
            gravidade: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.gravidade),
            mensagem: ConverterParameterObjectToUrlUtils.string(dadosFormulario.mensagem),
            solucionado: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.solucionado)
        };
    };
    return IncidenteQualidadeAlteracaoController;
}());
IncidenteQualidadeAlteracaoController.$inject = ['$state', 'IncidenteQualidadeApiService', 'feedbackService'];
angular.module('crd').controller('IncidenteQualidadeAlteracaoController', IncidenteQualidadeAlteracaoController);
//# sourceMappingURL=incidente-qualidade-alteracao-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var IncidenteQualidadeConsultaController = (function (_super) {
    __extends(IncidenteQualidadeConsultaController, _super);
    function IncidenteQualidadeConsultaController($stateParams, $location, $timeout, $scope, feedbackService, incidenteQualidadeApiService, documentoApiService, sistemaNegocioApiService, moment) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.$timeout = $timeout;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.incidenteQualidadeApiService = incidenteQualidadeApiService;
        _this.documentoApiService = documentoApiService;
        _this.sistemaNegocioApiService = sistemaNegocioApiService;
        _this.moment = moment;
        _this.inicializandoPesquisa = true;
        _this.exibirLegendaESPendenteCancelamento = false;
        _this.exibirLegendaESCancelada = false;
        _this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
        return _this;
    }
    IncidenteQualidadeConsultaController.prototype.$onInit = function () {
        var _this = this;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        return this.dadosParaConstruir(this.$stateParams).then(function (response) {
            var possuiParametros = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(_this.$stateParams);
            if (possuiParametros) {
                _this.exibirResultadoPesquisa();
                _this.finalizarInicializacaoPesquisa();
                return;
            }
            _this.parametrosPesquisa.grupoPeriodicidade = 'MENSAL_OU_MAIOR';
            _this.finalizarInicializacaoPesquisa();
            return;
        });
    };
    IncidenteQualidadeConsultaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        return this.incidenteQualidadeApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.acao = response.data.acao;
            _this.pagina = response.data.pagina;
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.dadosFormulario.sistemasNegocio = _this.dadosFormulario.sistemasNegocio || [];
            _this.dadosFormulario.documentos = _this.dadosFormulario.documentos || [];
            _this.parametrosPesquisa = _this.converterUrlParaParametros(consultaFiltro);
            return _this.carregarSistemaNegocio(_this.parametrosPesquisa.grupoPeriodicidade)
                .then(function () { return _this.carregarDocumentos(_this.parametrosPesquisa.grupoPeriodicidade, _this.parametrosPesquisa.sistemasNegocio); })
                .then(function () { return response; });
        });
    };
    IncidenteQualidadeConsultaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.incidenteQualidadeApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            _this.exibirLegendaESPendenteCancelamento = _this.pagina
                && _this.pagina.content
                && _this.pagina.content.some(function (incidente) { return incidente && incidente.exibirLegendaESPendenteCancelamento; }) || false;
            _this.exibirLegendaESCancelada = _this.pagina
                && _this.pagina.content
                && _this.pagina.content.some(function (incidente) { return incidente && incidente.exibirLegendaESCancelada; }) || false;
            return response;
        });
    };
    IncidenteQualidadeConsultaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        var dataBaseInicio = this.opcoesDeData.normatizar(dadosFormulario.dataBaseInicio);
        var dataBaseFim = this.opcoesDeData.normatizar(dadosFormulario.dataBaseFim);
        return {
            grupoPeriodicidade: ConverterParameterObjectToUrlUtils.string(dadosFormulario.grupoPeriodicidade),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.documentos),
            sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.sistemasNegocio),
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(dadosFormulario.instituicao),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(dataBaseInicio),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dataBaseFim),
            criticas: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.criticas),
            gravidades: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(dadosFormulario.gravidades)
        };
    };
    IncidenteQualidadeConsultaController.prototype.limparDadosFormulario = function (dadosFormulario) {
        dadosFormulario.grupoPeriodicidade = 'MENSAL_OU_MAIOR';
        dadosFormulario.sistemasNegocio = [];
        dadosFormulario.documentos = [];
        dadosFormulario.instituicao = undefined;
        dadosFormulario.dataBaseInicio = undefined;
        dadosFormulario.dataBaseFim = undefined;
        dadosFormulario.criticas = undefined;
        dadosFormulario.gravidades = [];
        this.carregarSistemaNegocio(dadosFormulario.grupoPeriodicidade);
    };
    IncidenteQualidadeConsultaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        return this.consultar(parametrosPesquisa);
    };
    IncidenteQualidadeConsultaController.prototype.limparParametrosPesquisa = function (form) {
        return this.resetFormulario(this.parametrosPesquisa, form);
    };
    IncidenteQualidadeConsultaController.prototype.limparResultadoPesquisa = function () {
        if (this.inicializandoPesquisa) {
            return;
        }
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    IncidenteQualidadeConsultaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return _super.prototype.navegarNaGrid.call(this, this.parametrosPesquisa, pagination);
    };
    IncidenteQualidadeConsultaController.prototype.finalizarInicializacaoPesquisa = function () {
        var _this = this;
        this.$timeout(function () {
            _this.inicializandoPesquisa = false;
        }, 0);
    };
    IncidenteQualidadeConsultaController.prototype.observerChangeGrupoPeriodicidade = function (grupoPeriodicidade) {
        this.parametrosPesquisa.sistemasNegocio = [];
        this.parametrosPesquisa.documentos = [];
        this.carregarSistemaNegocio(grupoPeriodicidade);
    };
    IncidenteQualidadeConsultaController.prototype.observerChangeSistemaNegocio = function (grupoPeriodicidade, sistemasNegocio) {
        return this.carregarDocumentos(grupoPeriodicidade, sistemasNegocio);
    };
    IncidenteQualidadeConsultaController.prototype.observerChangeDocumento = function (grupoPeriodicidade, documentos) {
        return;
    };
    IncidenteQualidadeConsultaController.prototype.carregarSistemaNegocio = function (grupoPeriodicidade) {
        var _this = this;
        var parametros = { grupoPeriodicidade: grupoPeriodicidade, quantidadePorPagina: 99999 };
        this.changeOpcoesDeData(grupoPeriodicidade);
        return this.sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (response) {
            _this.dadosFormulario.sistemasNegocio.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.sistemasNegocio, response.data.content);
            return response;
        });
    };
    IncidenteQualidadeConsultaController.prototype.carregarDocumentos = function (grupoPeriodicidade, sistemasNegocio) {
        var _this = this;
        if (!sistemasNegocio || _.isEmpty(sistemasNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return undefined;
        }
        var parametros = {
            periodicidade: grupoPeriodicidade === 'MENSAL_OU_MAIOR' ? 'MENSAL' : 'DIARIA',
            sistemaNegocioPks: _.map(sistemasNegocio, function (value) { return value.pk; })
        };
        return this.documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros).then(function (response) {
            _this.dadosFormulario.documentos.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, response.data._embedded.resultado);
            return response;
        });
    };
    IncidenteQualidadeConsultaController.prototype.periodoDataBaseInvalido = function () {
        return !(this.parametrosPesquisa && this.parametrosPesquisa.dataBaseInicio && this.parametrosPesquisa.dataBaseFim
            && this.moment.utc(this.parametrosPesquisa.dataBaseInicio).isAfter(this.moment.utc(this.parametrosPesquisa.dataBaseFim)));
    };
    IncidenteQualidadeConsultaController.prototype.gerarRelatorioEmExcel = function () {
        var _this = this;
        var filtro = this.converterDadosDoFormToConsultaFiltro(this.parametrosPesquisa);
        return this.incidenteQualidadeApiService.relatorioExcel(filtro).then(function (response) {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return response;
        });
    };
    IncidenteQualidadeConsultaController.prototype.parametrosParaRetorno = function () {
        var parametros = angular.copy(this.$location.search());
        parametros.jaPesquisado = true;
        return JSON.stringify(parametros);
    };
    IncidenteQualidadeConsultaController.prototype.excluir = function (pk) {
        var _this = this;
        return this.incidenteQualidadeApiService.excluir(pk).then(function (response) {
            return _this.consultar(_this.parametrosPesquisa).then(function () {
                _this.feedbackService.sucesso('Incidente de qualidade excluído com sucesso.');
                return response;
            });
        });
    };
    IncidenteQualidadeConsultaController.prototype.changeOpcoesDeData = function (grupoPeriodicidade) {
        this.opcoesDeData = grupoPeriodicidade === 'MENOR_QUE_MENSAL'
            ? FormataDataPeriodicidade.DIA_MES_ANO
            : FormataDataPeriodicidade.MES_ANO;
    };
    IncidenteQualidadeConsultaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            grupoPeriodicidade: ConverterParameterUrlToObjectUtils.string(filtro.grupoPeriodicidade),
            documentos: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documentos),
            sistemasNegocio: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.sistemasNegocio),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.idBacen),
            dataBaseInicio: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseInicio),
            dataBaseFim: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseFim),
            criticas: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.criticas),
            gravidades: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.gravidades)
        };
    };
    return IncidenteQualidadeConsultaController;
}(AbstractPaginaConsultaController));
IncidenteQualidadeConsultaController.$inject = [
    '$stateParams',
    '$location',
    '$timeout',
    '$scope',
    'feedbackService',
    'IncidenteQualidadeApiService',
    'documentoApiService',
    'sistemaNegocioApiService',
    'moment'
];
angular.module('crd').controller('IncidenteQualidadeConsultaController', IncidenteQualidadeConsultaController);
//# sourceMappingURL=incidente-qualidade-consulta-controller.js.map;
"use strict";
var IncidenteQualidadeDetalheController = (function () {
    function IncidenteQualidadeDetalheController($state, incidenteQualidadeApiService, feedbackService) {
        this.$state = $state;
        this.incidenteQualidadeApiService = incidenteQualidadeApiService;
        this.feedbackService = feedbackService;
    }
    IncidenteQualidadeDetalheController.prototype.$onInit = function () {
        var _this = this;
        this.destinoVoltar = this.$state.params.voltar ? this.$state.params.voltar : 'incidente-qualidade-pesquisa';
        if (this.$state.params.voltarParametros) {
            this.destinoVoltarParametros = this.converterParametrosDeRetorno(this.$state.params.voltarParametros);
        }
        return this.incidenteQualidadeApiService.detalhar(this.$state.params.pk).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.incidenteQualidade = response.data;
            _this.incidenteQualidade.automaticoRotulo = response.data.automatico ? 'AUTOMÁTICO' : 'MANUAL';
            return response;
        });
    };
    IncidenteQualidadeDetalheController.prototype.downloadAnexo = function (pk) {
        return this.incidenteQualidadeApiService.downloadAnexo(pk);
    };
    IncidenteQualidadeDetalheController.prototype.excluir = function (pk) {
        var _this = this;
        return this.incidenteQualidadeApiService.excluir(pk).then(function (response) {
            _this.feedbackService.sucesso('Incidente de qualidade excluído com sucesso.');
            _this.voltar();
            return response;
        });
    };
    IncidenteQualidadeDetalheController.prototype.voltar = function () {
        this.$state.go(this.destinoVoltar, this.destinoVoltarParametros);
    };
    IncidenteQualidadeDetalheController.prototype.parametrosParaRetorno = function () {
        return this.$state.params.voltarParametros;
    };
    IncidenteQualidadeDetalheController.prototype.converterParametrosDeRetorno = function (parametros) {
        return parametros ? JSON.parse(parametros) : undefined;
    };
    return IncidenteQualidadeDetalheController;
}());
IncidenteQualidadeDetalheController.$inject = ['$state', 'IncidenteQualidadeApiService', 'feedbackService'];
angular.module('crd').controller('IncidenteQualidadeDetalheController', IncidenteQualidadeDetalheController);
//# sourceMappingURL=incidente-qualidade-detalhe-controller.js.map;
"use strict";
var IncidenteQualidadeInclusaoController = (function () {
    function IncidenteQualidadeInclusaoController($state, incidenteQualidadeApiService, feedbackService) {
        this.$state = $state;
        this.incidenteQualidadeApiService = incidenteQualidadeApiService;
        this.feedbackService = feedbackService;
    }
    IncidenteQualidadeInclusaoController.prototype.$onInit = function () {
        var _this = this;
        this.destinoVoltar = this.$state.params.voltar || 'incidente-qualidade-pesquisa';
        this.destinoVoltarParametros = this.$state.params.voltarParametros
            ? JSON.parse(this.$state.params.voltarParametros)
            : undefined;
        return this.incidenteQualidadeApiService.paraIncluir().then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.incidenteQualidade = response.data.dadosFormulario.incidenteQualidade;
            _this.incidenteQualidade.anexos = _this.incidenteQualidade.anexos || [];
            _this.incidenteQualidade.solucionado = _this.incidenteQualidade.solucionado || false;
            _this.permiteIdentificadorEventual = false;
            _this.filtrosCritica = { automatica: false };
            return response;
        });
    };
    IncidenteQualidadeInclusaoController.prototype.observerChangeSistemaNegocio = function (sistemaNegocio) {
        this.incidenteQualidade.critica = undefined;
        this.filtrosCritica.sistemasNegocio = sistemaNegocio ? [sistemaNegocio.pk] : [];
    };
    IncidenteQualidadeInclusaoController.prototype.observerChangeDocumento = function (documento) {
        this.incidenteQualidade.dataBase = undefined;
        this.incidenteQualidade.dataLimite = undefined;
        this.incidenteQualidade.critica = undefined;
        this.incidenteQualidade.identificadorEventual = undefined;
        this.permiteIdentificadorEventual = !!(documento && documento.menorTipoPeriodicidade
            && documento.menorTipoPeriodicidade.enumName === 'EVENTUAL_MENOR_QUE_DIARIA');
        this.filtrosCritica.documentos = documento ? [documento.pk] : [];
    };
    IncidenteQualidadeInclusaoController.prototype.observerChangeCritica = function (critica) {
        this.incidenteQualidade.gravidade = critica
            ? _.find(this.dadosFormulario.gravidades, function (gravidade) { return gravidade.codigo === critica.gravidade; })
            : undefined;
    };
    IncidenteQualidadeInclusaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = this.converterParaEnviarServidor(dadosFormulario);
        return this.incidenteQualidadeApiService.incluir(dados, dadosFormulario.anexos).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Incidente de qualidade incluído com sucesso.');
                _this.voltar();
            }
            else {
                _this.feedbackService.violacoes(response.data);
            }
            return response;
        });
    };
    IncidenteQualidadeInclusaoController.prototype.voltar = function () {
        this.$state.go(this.destinoVoltar, this.destinoVoltarParametros);
    };
    IncidenteQualidadeInclusaoController.prototype.converterParaEnviarServidor = function (dadosFormulario) {
        return {
            critica: ConverterParameterObjectToUrlUtils.atributoPK(dadosFormulario.critica),
            dataBase: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataBase),
            dataLimite: ConverterParameterObjectToUrlUtils.date(dadosFormulario.dataLimite),
            documento: ConverterParameterObjectToUrlUtils.atributoPK(dadosFormulario.documento),
            gravidade: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.gravidade),
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(dadosFormulario.instituicao),
            identificadorEventual: ConverterParameterObjectToUrlUtils.string(dadosFormulario.identificadorEventual),
            mensagem: ConverterParameterObjectToUrlUtils.string(dadosFormulario.mensagem),
            protocoloRecebimento: ConverterParameterObjectToUrlUtils.number(dadosFormulario.protocoloRecebimento),
            identificadorCritica: ConverterParameterObjectToUrlUtils.string(dadosFormulario.identificadorCritica),
            solucionado: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.solucionado)
        };
    };
    return IncidenteQualidadeInclusaoController;
}());
IncidenteQualidadeInclusaoController.$inject = ['$state', 'IncidenteQualidadeApiService', 'feedbackService'];
angular.module('crd').controller('IncidenteQualidadeInclusaoController', IncidenteQualidadeInclusaoController);
//# sourceMappingURL=incidente-qualidade-inclusao-controller.js.map;
(function(angular, moment, $, parametrosUrl) {
  'use strict';

  var NUM_MES_PERIODO = 11;
  var DRAW = 0;
  var ORDER = 2;
  var START = 3;
  var LENGTH = 4;
  var RETORNO_NEGATIVO = -1;
  var RETORNO_POSITIVO = 1;
  var INI_INDEX_ANO = 0;
  var INI_INDEX_MES = 4;
  var FIM_INDEX_MES = 6;

  angular
    .module('crd')
    .controller('IndiceDesempenhoCaptacaoListarController', IndiceDesempenhoCaptacaoListarController);

  IndiceDesempenhoCaptacaoListarController.$inject = [
    '$compile',
    '$location',
    '$state',
    '$stateParams',
    '$scope',
    'constantes',
    'DTColumnBuilder',
    'DTOptionsBuilder',
    'feedbackService',
    'indiceDesempenhoCaptacaoApiService'
  ];

  function IndiceDesempenhoCaptacaoListarController(
    $compile,
    $location,
    $state,
    $stateParams,
    $scope,
    constantes,
    DTColumnBuilder,
    DTOptionsBuilder,
    feedbackService,
    indiceDesempenhoCaptacaoApiService
  ) {
    var vm = this;
    var self = $scope;

    vm.titulo = $state.current.informacaoPagina.titulo;

    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.dtInstanceCallback = dtInstanceCallback;
    vm.limparMensagens = limparMensagens;
    vm.mascaraData = '99/9999';
    vm.formatoData = 'MM/yyyy';
    vm.placeholderData = 'mm/aaaa';
    vm.pesquisarExcel = pesquisarExcel;
    vm.pesquisarMemoriaExcel = pesquisarMemoriaExcel;
    vm.msgPeriodo = '';
    vm.validaPeriodobaseCalculo = validaPeriodobaseCalculo;

    inicializarView();
    reset();
    vm.view.resultado.visivel = true;
    carregarTela();

    function inicializarView() {
      vm.view = {
        formulario: {
          visivel: true
        },
        resultado: {
          visivel: false
        }
      };
      vm.idciGlobal = '';
      vm.dtColumns = criarColunas();
    }

    function criarColunas() {
      var colunaParticipaGlobal = DTColumnBuilder
        .newColumn('participaGlobal')
        .renderWith(htmlParticipaIDCIGlobal)
        .withClass('text-center');

      var colunaAcoes = DTColumnBuilder
        .newColumn('pk')
        .notSortable()
        .renderWith(htmlColunaAcoes)
        .withClass('text-center');

      return [
        DTColumnBuilder.newColumn('documento.sistemaNegocio.sigla').withClass('text-center'),
        DTColumnBuilder.newColumn('documento.codigo').withClass('text-center'),
        colunaParticipaGlobal,
        DTColumnBuilder.newColumn('valorIdci').withClass('text-center'),
        DTColumnBuilder.newColumn('numeroEntregues').withClass('text-center'),
        DTColumnBuilder.newColumn('numeroEsperados').withClass('text-center'),
        colunaAcoes
      ];
    }

    function reset() {
      vm.parametrosPesquisa = {
        baseCalculo: null
      };
      vm.idcis = [];
    }

    function pesquisarMemoriaExcel(idci) {
      var parameters = {
        idci: idci
      };
      indiceDesempenhoCaptacaoApiService.pesquisarIdciMemoriaExcel(parameters).then(sucessoOnGerarXLS);
    }

    function validaPeriodobaseCalculo() {
      if (vm.baseCalFim === null) {
        vm.msgPeriodo = 'IDCI não disponível.';
        return false;
      }


      if (vm.parametrosPesquisa.baseCalculo
        && (
          parseInt(moment(vm.parametrosPesquisa.baseCalculo).format('YYYYMM')) < vm.baseCalIni
        || parseInt(moment(vm.parametrosPesquisa.baseCalculo).format('YYYYMM')) > vm.baseCalFim)) {
        vm.msgPeriodo = 'IDCI disponível de ' + getStringMMYYYY(vm.baseCalIni) + ' a ' + getStringMMYYYY(vm.baseCalFim) + '.';
        return false;
      }
      vm.msgPeriodoIni = '';
      return true;
    }

    function pesquisarExcel() {
      var parameters = parametrosPesquisa();
      indiceDesempenhoCaptacaoApiService.pesquisarIdciExcel(parameters).then(sucessoOnGerarXLS);
    }

    function sucessoOnGerarXLS() {
      feedbackService.sucesso('Relatório gerado com sucesso.');
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function carregarTela() {

      return indiceDesempenhoCaptacaoApiService
        .tela()
        .then(successOnTelaPesquisar);

      function successOnTelaPesquisar(resource) {
        vm.baseCalIni = resource.baseCalculoInicio;
        vm.baseCalFim = resource.baseCalculoFim;
        if (resource.baseCalculoFim !== null) {
          extrairParametrosDaUrl($stateParams);
          pesquisar();
        }
      }
    }

    function dataYYYYMM(data) {
      var ano = data.toString().substring(INI_INDEX_ANO, INI_INDEX_MES);
      var mes = data.toString().substring(INI_INDEX_MES, FIM_INDEX_MES);
      var anoMesDia = ano + '-' + mes + '-01';
      return parametrosUrl.Extrator.data(anoMesDia);
    }

    function pesquisar() {
      var parameters = parametrosPesquisa();
      $location.search(parameters);
      return indiceDesempenhoCaptacaoApiService
        .pesquisarIdci(parameters)
        .then(successOnPesquisar);
      function successOnPesquisar(resource) {
        vm.baseCalIni = resource.pesquisaObservanciaResource.baseCalculoInicio;
        vm.baseCalFim = resource.pesquisaObservanciaResource.baseCalculoFim;
        vm.idciGlobal = getValorDecima(resource._embedded.indiceDesempenhoCaptacaoGlobalResource.valor.toString());
        vm.resultadoPesquisa = resource._embedded.indiceDesempenhoCaptacaoGlobalResource.indicesDesempenhoCaptacaoPorDocumento;
        prepararGridResultados();
        exibirResultadoPesquisa();
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.baseCalculo = undefined;

      limparMensagens();
      esconderResultadoPesquisa();

      FormularioUtils.reset(form, this.$scope); // chamar sempre depois de setar o valor padrão.
    }

    function dtInstanceCallback(dtInstance) {
      vm.dtInstance = dtInstance;
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function prepararGridResultados() {
      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('serverSide', true)
        .withFnServerData(serverData)
        .withDataProp('data')
        .withOption('createdRow', createdRow)
        .withOption('stateSaveParams', function(settings, data) {
          _.each(data.columns, function(column) {
            delete column.visible;
          });
        });
    }

    function exibirResultadoPesquisa() {
      var rows = vm.dtInstance.DataTable.rows();
      rows.invalidate().draw();
      vm.view.resultado.visivel = true;
    }

    function serverData(sSource, aoData, fnCallback) {
      var draw = aoData[DRAW].value;
      var order = aoData[ORDER].value;
      var start = draw === 1 ? 0 : aoData[START].value;
      var length = aoData[LENGTH].value;
      ordenarLista(order);
      var records = {
        data: vm.resultadoPesquisa.slice(start, start + length),
        draw: draw,
        recordsFiltered: vm.resultadoPesquisa.length,
        recordsTotal: vm.resultadoPesquisa.length
      };

      formatarResultadoParaExibicao(records.data);

      fnCallback(records);

      self.$safeApply();
    }

    function elementosColuna() {
      var elementos = [];
      elementos.push({
        descColuna: 'documento.sistemaNegocio.sigla'
      });
      elementos.push({
        descColuna: 'documento.codigo'
      });
      elementos.push({
        descColuna: 'participaGlobal'
      });
      elementos.push({
        descColuna: 'valor'
      });
      elementos.push({
        descColuna: 'numeroEntregues'
      });
      elementos.push({
        descColuna: 'numeroEsperados'
      });
      return elementos;
    }

    function ordenarLista(order) {
      if (order.length > 0) {
        var elementos = elementosColuna();
        vm.resultadoPesquisa.sort(sortBy(elementos[order[0].column].descColuna, order[0].dir === 'asc'));
      }
    }

    function sortBy(field, reverse) {
      var reverso = reverse;

      function key(elemento) {
        if (field.split('.').length > 1) {
          var retorno = elemento;
          field.split('.').forEach(function(ind) {
            if (retorno !== null) {
              retorno = retorno[ind];
            }
          });
          return retorno === null ? '' : retorno;
        }
        return elemento[field] === null ? '' : elemento[field];
      }

      reverso = reverso ? RETORNO_NEGATIVO : RETORNO_POSITIVO;

      return function(primeiroCampo, segundoCampo) {
        var primeiroValor = primeiroCampo;
        var segundoValor = segundoCampo;
        primeiroValor = key(primeiroValor);
        segundoValor = key(segundoValor);
        return reverso * ((primeiroValor > segundoValor) - (segundoValor > primeiroValor));
      };
    }

    function formatarResultadoParaExibicao(resultado) {
      var idx = 1;
      vm.idcis.splice(0, vm.idcis.length);
      _.each(resultado, function(idci) {
        idci.valorIdci = getValorDecima(idci.valor.toString());
        vm.idcis[idx] = idci;
        idx += 1;
      });
    }

    function getValorDecima(valor) {
      var num = valor.indexOf('.');
      if (num === -1) {
        return valor + ',00';
      }
      var inteiro = valor.substring(0, num);
      var decimal = valor.substring(num + 1, valor.length);
      if (decimal.length === 1) {
        decimal += '0';
      }
      return inteiro + ',' + decimal;
    }

    function getStringMMYYYY(data) {
      if (data) {
        var ano = data.toString().substring(INI_INDEX_ANO, INI_INDEX_MES);
        var mes = data.toString().substring(INI_INDEX_MES, FIM_INDEX_MES);
        return mes + '/' + ano;
      }
      return '';
    }

    function createdRow(row) {
      $compile(angular.element(row).contents())(self);
    }

    function htmlParticipaIDCIGlobal(data) {
      var html = '<span hidden="true">' + data + '</span>';
      if (data) {
        html += '<i class="fa fa-check verde" aria-hidden="true"></i>';
      }
      return html;
    }

    function htmlColunaAcoes(data) {
      var html = '';
      if (data) {
        html += '<a class="btn btn-default btn-xs" title="Exportar memória de cálculo do IDCI"';
        html += ' ng-click="iDCIListarCtrl.pesquisarMemoriaExcel(';
        html += data;
        html += ')">';
        html += '<i class="fa fa-file-excel-o fa-lg text-primary" aria-hidden="true"></i></a>';
      }
      return html;
    }

    function parametrosPesquisa() {
      var criador = parametrosUrl.Criador;
      return {
        baseCalculo: criador.data(vm.parametrosPesquisa.baseCalculo)
      };
    }

    function extrairParametrosDaUrl() {
      var extrator = parametrosUrl.Extrator;
      vm.parametrosPesquisa.baseCalculo = $stateParams.baseCalculo ?
        extrator.data($stateParams.baseCalculo) : dataYYYYMM(vm.baseCalFim);
    }

    self.$watch('iDCIListarCtrl.parametrosPesquisa', function() {
      esconderResultadoPesquisa();
      limparMensagens();
    }, true);
  }
})(angular, moment, jQuery, CRDUtils.ParametrosUrl, httpStatusCode);
;
(function(angular, moment, $, parametrosUrl) {
  'use strict';

  var NUM_MES_PERIODO = 11;
  var DRAW = 0;
  var ORDER = 2;
  var START = 3;
  var LENGTH = 4;
  var RETORNO_NEGATIVO = -1;
  var RETORNO_POSITIVO = 1;
  var INI_INDEX_ANO = 0;
  var INI_INDEX_MES = 4;
  var FIM_INDEX_MES = 6;

  angular
    .module('crd')
    .controller('IndiceDesempenhoFornecedoresListarController', IndiceDesempenhoFornecedoresListarController);

  IndiceDesempenhoFornecedoresListarController.$inject = [
    '$compile',
    '$location',
    '$state',
    '$stateParams',
    '$scope',
    'constantes',
    'DTColumnBuilder',
    'DTOptionsBuilder',
    'feedbackService',
    'indiceDesempenhoFornecedoresApiService'
  ];

  function IndiceDesempenhoFornecedoresListarController(
    $compile,
    $location,
    $state,
    $stateParams,
    $scope,
    constantes,
    DTColumnBuilder,
    DTOptionsBuilder,
    feedbackService,
    indiceDesempenhoFornecedoresApiService
  ) {
    var vm = this;
    var self = $scope;

    vm.titulo = $state.current.informacaoPagina.titulo;

    vm.limparParametrosPesquisa = limparParametrosPesquisa;
    vm.pesquisar = pesquisar;
    vm.dtInstanceCallback = dtInstanceCallback;
    vm.limparMensagens = limparMensagens;
    vm.mascaraData = '99/9999';
    vm.formatoData = 'MM/yyyy';
    vm.placeholderData = 'mm/aaaa';
    vm.pesquisarExcel = pesquisarExcel;
    vm.pesquisarMemoriaExcel = pesquisarMemoriaExcel;
    vm.msgPeriodoIni = '';
    vm.msgPeriodoFim = '';
    vm.validaPeriodobaseCalculoIni = validaPeriodobaseCalculoIni;
    vm.validaPeriodobaseCalculoFim = validaPeriodobaseCalculoFim;

    inicializarView();
    reset();
    vm.view.resultado.visivel = true;
    carregarTela();

    function inicializarView() {
      vm.view = {
        formulario: {
          visivel: true
        },
        resultado: {
          visivel: false
        }
      };
      vm.dtColumns = criarColunas();
    }

    function criarColunas() {
      var colunaAcoesB = DTColumnBuilder
        .newColumn('pk')
        .notSortable()
        .renderWith(htmlColunaAcoesBancaria)
        .withClass('coluna-acoes');

      var colunaAcoesNB = DTColumnBuilder
        .newColumn('pk')
        .notSortable()
        .renderWith(htmlColunaAcoesNaoBancaria)
        .withClass('coluna-acoes');

      return [
        DTColumnBuilder.newColumn('anoMes').withClass('text-center'),
        DTColumnBuilder.newColumn('numeroInstituicoesBancariasIrregulares').withClass('text-center'),
        DTColumnBuilder.newColumn('totalInstituicoesBancarias').withClass('text-center'),
        DTColumnBuilder.newColumn('valorIdfi').withClass('text-center'),
        colunaAcoesB,
        DTColumnBuilder.newColumn('numeroInstituicoesNaoBancariasIrregulares').withClass('text-center'),
        DTColumnBuilder.newColumn('totalInstituicoesNaoBancarias').withClass('text-center'),
        DTColumnBuilder.newColumn('valorIdfiNB').withClass('text-center'),
        colunaAcoesNB
      ];
    }

    function reset() {
      vm.parametrosPesquisa = {
        baseCalculoFim: null,
        baseCalculoInicio: null
      };
      vm.idfis = [];
    }

    function pesquisarMemoriaExcel(idfi, bancaria) {
      var parameters = {
        bancaria: bancaria,
        idfi: idfi
      };
      indiceDesempenhoFornecedoresApiService.pesquisarIdfiMemoriaExcel(parameters).then(sucessoOnGerarXLS);
    }

    function validaPeriodobaseCalculoIni() {
      if (vm.parametrosPesquisa.baseCalculoInicio
        && parseInt(moment(vm.parametrosPesquisa.baseCalculoFim).format('YYYYMM'))
        < parseInt(moment(vm.parametrosPesquisa.baseCalculoInicio).format('YYYYMM'))) {
        vm.msgPeriodoFim = 'Mês base fim deve ser maior ou igual a Mês base início.';
        return false;
      }
      vm.msgPeriodoIni = '';
      return true;
    }

    function validaPeriodobaseCalculoFim() {
      if (vm.baseCalFim === null) {
        vm.msgPeriodoFim = 'IDFI não disponível.';
        return false;
      }


      if (vm.parametrosPesquisa.baseCalculoInicio
        && parseInt(moment(vm.parametrosPesquisa.baseCalculoFim).format('YYYYMM'))
        < parseInt(moment(vm.parametrosPesquisa.baseCalculoInicio).format('YYYYMM'))) {
        vm.msgPeriodoFim = 'Mês base fim deve ser maior ou igual a Mês base início.';
        return false;
      }
      vm.msgPeriodoFim = '';
      return true;
    }

    function pesquisarExcel() {
      var parameters = parametrosPesquisa();
      indiceDesempenhoFornecedoresApiService.pesquisarIdfiExcel(parameters).then(sucessoOnGerarXLS);
    }

    function sucessoOnGerarXLS() {
      feedbackService.sucesso('Relatório gerado com sucesso.');
    }

    function esconderResultadoPesquisa() {
      vm.view.resultado.visivel = false;
    }

    function carregarTela() {
      return indiceDesempenhoFornecedoresApiService
        .telaPesquisar()
        .then(successOnTelaPesquisar);

      function successOnTelaPesquisar(resource) {
        vm.baseCalIni = resource.baseCalculoInicio;
        vm.baseCalFim = resource.baseCalculoFim;
        if (vm.baseCalFim !== null) {
          extrairParametrosDaUrl($stateParams);
          pesquisar();
        }
      }
    }

    function dataYYYYMM(data) {
      var ano = data.toString().substring(INI_INDEX_ANO, INI_INDEX_MES);
      var mes = data.toString().substring(INI_INDEX_MES, FIM_INDEX_MES);
      var anoMesDia = ano + '-' + mes + '-01';
      return parametrosUrl.Extrator.data(anoMesDia);
    }

    function menosOnzeMeses(data) {
      return data.setMonth(data.getMonth() - NUM_MES_PERIODO);
    }

    function pesquisar() {
      var parameters = parametrosPesquisa();
      $location.search(parameters);
      return indiceDesempenhoFornecedoresApiService
        .pesquisarIdfi(parameters)
        .then(successOnPesquisar);
      function successOnPesquisar(resource) {
        var alertaMsgs = [];
        if (vm.parametrosPesquisa.baseCalculoInicio && parseInt(moment(vm.parametrosPesquisa.baseCalculoInicio).format('YYYYMM')) < vm.baseCalIni) {
          alertaMsgs.push('IDFI disponível a partir de ' + getStringMMYYYY(vm.baseCalIni) + '.');
        }

        if (vm.parametrosPesquisa.baseCalculoFim && parseInt(moment(vm.parametrosPesquisa.baseCalculoFim).format('YYYYMM')) > vm.baseCalFim) {
          alertaMsgs.push('IDFI disponível até ' + getStringMMYYYY(vm.baseCalFim) + '.');
        }

        if (alertaMsgs.length > 0) {
          feedbackService.alerta(alertaMsgs);
        }
        vm.resultadoPesquisa = resource._embedded.resultado;
        prepararGridResultados();
        exibirResultadoPesquisa();
      }
    }

    function limparParametrosPesquisa(form) {
      vm.parametrosPesquisa.baseCalculoInicio = undefined;
      vm.parametrosPesquisa.baseCalculoFim = undefined;

      limparMensagens();
      esconderResultadoPesquisa();

      FormularioUtils.reset(form, $scope); // chamar sempre depois de setar o valor padrão.
    }

    function dtInstanceCallback(dtInstance) {
      vm.dtInstance = dtInstance;
    }

    function limparMensagens() {
      feedbackService.limpar();
    }

    function prepararGridResultados() {
      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('serverSide', true)
        .withFnServerData(serverData)
        .withDataProp('data')
        .withOption('createdRow', createdRow)
        .withOption('stateSaveParams', function(settings, data) {
          _.each(data.columns, function(column) {
            delete column.visible;
          });
        });
    }

    function exibirResultadoPesquisa() {
      var rows = vm.dtInstance.DataTable.rows();
      rows.invalidate().draw();
      vm.view.resultado.visivel = true;
    }

    function serverData(sSource, aoData, fnCallback) {
      var draw = aoData[DRAW].value;
      var order = aoData[ORDER].value;
      var start = draw === 1 ? 0 : aoData[START].value;
      var length = aoData[LENGTH].value;
      ordenarLista(order);
      var records = {
        data: vm.resultadoPesquisa.slice(start, start + length),
        draw: draw,
        recordsFiltered: vm.resultadoPesquisa.length,
        recordsTotal: vm.resultadoPesquisa.length
      };

      formatarResultadoParaExibicao(records.data);

      fnCallback(records);

      self.$safeApply();
    }

    function elementosColuna() {
      var elementos = [];
      elementos.push({
        descColuna: 'anoMesBase'
      });
      elementos.push({
        descColuna: 'numeroInstituicoesBancariasIrregulares'
      });
      elementos.push({
        descColuna: 'totalInstituicoesBancarias'
      });
      elementos.push({
        descColuna: 'valorIdfiBancario'
      });
      elementos.push({
        descColuna: 'acoes'
      });
      elementos.push({
        descColuna: 'numeroInstituicoesNaoBancariasIrregulares'
      });
      elementos.push({
        descColuna: 'totalInstituicoesNaoBancarias'
      });
      elementos.push({
        descColuna: 'valorIdfiNaoBancario'
      });
      return elementos;
    }

    function ordenarLista(order) {
      if (order.length > 0) {
        var elementos = elementosColuna();
        vm.resultadoPesquisa.sort(sortBy(elementos[order[0].column].descColuna, order[0].dir === 'asc'));
      }
    }

    function sortBy(field, reverse) {
      var reverso = reverse;

      function key(elemento) {
        if (field.split('.').length > 1) {
          var retorno = elemento;
          field.split('.').forEach(function(ind) {
            if (retorno !== null) {
              retorno = retorno[ind];
            }
          });
          return retorno === null ? '' : retorno;
        }
        return elemento[field] === null ? '' : elemento[field];
      }

      reverso = reverso ? RETORNO_NEGATIVO : RETORNO_POSITIVO;

      return function(primeiroCampo, segundoCampo) {
        var primeiroValor = primeiroCampo;
        var segundoValor = segundoCampo;
        primeiroValor = key(primeiroValor);
        segundoValor = key(segundoValor);
        return reverso * ((primeiroValor > segundoValor) - (segundoValor > primeiroValor));
      };
    }

    function formatarResultadoParaExibicao(resultado) {
      var idx = 1;
      vm.idfis.splice(0, vm.idfis.length);
      _.each(resultado, function(idfi) {
        idfi.valorIdfi = getValorDecima(idfi.valorIdfiBancario.toString());
        idfi.valorIdfiNB = getValorDecima(idfi.valorIdfiNaoBancario.toString());
        idfi.anoMes = getStringMMYYYY(idfi.anoMesBase);
        vm.idfis[idx] = idfi;
        idx += 1;
      });
    }

    function getValorDecima(valor) {
      var num = valor.indexOf('.');
      if (num === -1) {
        return valor + ',00';
      }
      var inteiro = valor.substring(0, num);
      var decimal = valor.substring(num + 1, valor.length);
      if (decimal.length === 1) {
        decimal += '0';
      }
      return inteiro + ',' + decimal;
    }

    function getStringMMYYYY(data) {
      if (data) {
        var ano = data.toString().substring(INI_INDEX_ANO, INI_INDEX_MES);
        var mes = data.toString().substring(INI_INDEX_MES, FIM_INDEX_MES);
        return mes + '/' + ano;
      }
      return '';
    }

    function createdRow(row) {
      $compile(angular.element(row).contents())(self);
    }

    function htmlColunaAcoesBancaria(data) {
      return htmlColunaAcoes(data, true);
    }

    function htmlColunaAcoesNaoBancaria(data) {
      return htmlColunaAcoes(data, false);
    }

    function htmlColunaAcoes(data, bancaria) {
      var html = '';
      if (data) {
        html += '<a class="btn btn-default btn-xs" title="Exportar memória de cálculo do IDFI-';
        if (!bancaria) {
          html += 'N';
        }
        html += 'B"';
        html += ' ng-click="iDFIListarCtrl.pesquisarMemoriaExcel(';
        html += data;
        html += ', ';
        html += bancaria;
        html += ')">';
        html += '<i class="fa fa-file-excel-o fa-lg text-primary" aria-hidden="true"></i></a>';
      }
      return html;
    }

    function parametrosPesquisa() {
      var criador = parametrosUrl.Criador;
      return {
        baseCalculoFim: criador.data(vm.parametrosPesquisa.baseCalculoFim),
        baseCalculoInicio: criador.data(vm.parametrosPesquisa.baseCalculoInicio)
      };
    }

    function extrairParametrosDaUrl() {
      var extrator = parametrosUrl.Extrator;
      vm.parametrosPesquisa.baseCalculoInicio = $stateParams.baseCalculoInicio ?
        extrator.data($stateParams.baseCalculoInicio) :
        $stateParams.baseCalculoFim ?
        null :
        menosOnzeMeses(dataYYYYMM(vm.baseCalFim));
      vm.parametrosPesquisa.baseCalculoFim = $stateParams.baseCalculoFim ?
        extrator.data($stateParams.baseCalculoFim) : dataYYYYMM(vm.baseCalFim);
    }

    self.$watch('iDFIListarCtrl.parametrosPesquisa', function() {
      esconderResultadoPesquisa();
      limparMensagens();
    }, true);
  }
})(angular, moment, jQuery, CRDUtils.ParametrosUrl, httpStatusCode);
;
"use strict";
var IndiceQualidadeFornecimentoDetalheController = (function () {
    function IndiceQualidadeFornecimentoDetalheController($location, $state, $timeout, feedbackService, indiceQualidadeFornecimentoApiService, moment) {
        this.$location = $location;
        this.$state = $state;
        this.$timeout = $timeout;
        this.feedbackService = feedbackService;
        this.indiceQualidadeFornecimentoApiService = indiceQualidadeFornecimentoApiService;
        this.moment = moment;
        this.formularioVisivel = true;
        this.resultadoVisivel = true;
        this.isInsituicao = false;
        this.isConglomerado = false;
        this.mascaraData = '99/9999';
        this.formatoData = 'MM/yyyy';
        this.placeholderData = 'mm/aaaa';
    }
    IndiceQualidadeFornecimentoDetalheController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.validaPeriodoBaseCalculo = function () {
        if (angular.isDefined(this.parametrosPesquisa) && this.parametrosPesquisa.baseCalculoInicio && this.parametrosPesquisa.baseCalculoFim
            && parseInt(this.moment(this.parametrosPesquisa.baseCalculoFim).format('YYYYMM'))
                < parseInt(this.moment(this.parametrosPesquisa.baseCalculoInicio).format('YYYYMM'))) {
            return false;
        }
        return true;
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.carregarDadosTela = function (params, codigoPagina) {
        var _this = this;
        this.isInsituicao = codigoPagina === 'CRDFW8052';
        this.isConglomerado = codigoPagina === 'CRDFW8053';
        var promisse;
        if (this.isConglomerado) {
            promisse = this.indiceQualidadeFornecimentoApiService.telaDetalhePesquisar({ conglomerado: params.conglomerado });
        }
        else {
            promisse = this.indiceQualidadeFornecimentoApiService.telaDetalhePesquisar({ instituicao: params.instituicao });
        }
        promisse.then(function (resultado) {
            _this.dadosTela = resultado;
            _this.parametrosPesquisa = _this.converterUrlParaParametros(params);
            if (!ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(_.omit(params, ['instituicao', 'conglomerado']))) {
                _this.parametrosPesquisa.baseCalculoFim = ConverterParameterUrlToObjectUtils.date(resultado.baseCalculoFimData);
                _this.parametrosPesquisa.baseCalculoInicio = ConverterParameterUrlToObjectUtils.date(resultado.baseCalculoInicioData);
            }
            _this.pesquisar(_this.parametrosPesquisa);
        });
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            conglomerado: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.conglomerado),
            instituicao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.instituicao),
            baseCalculoFim: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.baseCalculoFim),
            baseCalculoInicio: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.baseCalculoInicio),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            conglomerado: ConverterParameterUrlToObjectUtils.string(filtro.conglomerado),
            instituicao: ConverterParameterUrlToObjectUtils.string(filtro.instituicao),
            baseCalculoFim: ConverterParameterUrlToObjectUtils.date(filtro.baseCalculoFim),
            baseCalculoInicio: ConverterParameterUrlToObjectUtils.date(filtro.baseCalculoInicio),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.pesquisarExcel = function () {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        var promisse;
        if (this.isConglomerado) {
            promisse = this.indiceQualidadeFornecimentoApiService.pesquisarIqfiDetalheConglomeradoExcel(parametros);
        }
        else {
            promisse = this.indiceQualidadeFornecimentoApiService.pesquisarIqfiDetalheInstituicaoExcel(parametros);
        }
        return promisse.then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.pesquisarMemoriaExcel = function (pk) {
        var _this = this;
        this.indiceQualidadeFornecimentoApiService.pesquisarIqfiMemoriaExcel(pk).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(_.omit(parametros, ['instituicao', 'conglomerado']));
        var promisse;
        if (this.isConglomerado) {
            promisse = this.indiceQualidadeFornecimentoApiService.pesquisarIqfiDetalheConglomerado(parametros);
        }
        else {
            promisse = this.indiceQualidadeFornecimentoApiService.pesquisarIqfiDetalheInstituicao(parametros);
        }
        return promisse.then(function (resultado) {
            _this.resultadoPesquisa = resultado._embedded;
            _this.exibirResultadoPesquisa();
            if (!_.isEmpty(_this.resultadoPesquisa.mensagens)) {
                _this.feedbackService.alerta(_.pluck(_this.resultadoPesquisa.mensagens, 'content'));
            }
            return resultado;
        });
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.voltar = function () {
        if (this.$state.current.name === 'indice-qualidade-fornecimento-entidade-supervisionada-conglomerado') {
            this.$state.go('indice-qualidade-fornecimento-entidade-supervisionada', { instituicao: this.$state.params.instituicao });
        }
        else {
            this.$state.go('indice-qualidade-fornecimento-listar');
        }
    };
    IndiceQualidadeFornecimentoDetalheController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params, this.$state.current.informacaoPagina.codigo);
    };
    ;
    return IndiceQualidadeFornecimentoDetalheController;
}());
IndiceQualidadeFornecimentoDetalheController.inject = ['$location', '$state', '$timeout', 'feedbackService', 'indiceQualidadeFornecimentoApiService', 'moment'];
angular.module('crd').controller('IndiceQualidadeFornecimentoDetalheController', IndiceQualidadeFornecimentoDetalheController);
//# sourceMappingURL=indice-qualidade-fornecimento-detalhe-controller.js.map;
"use strict";
var IndiceQualidadeFornecimentoListarController = (function () {
    function IndiceQualidadeFornecimentoListarController($location, $stateParams, indiceQualidadeFornecimentoApiService, moment, feedbackService, $scope) {
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.indiceQualidadeFornecimentoApiService = indiceQualidadeFornecimentoApiService;
        this.moment = moment;
        this.feedbackService = feedbackService;
        this.$scope = $scope;
        this.formularioVisivel = true;
        this.resultadoVisivel = true;
        this.mascaraData = '99/9999';
        this.formatoData = 'MM/yyyy';
        this.placeholderData = 'mm/aaaa';
        this.msgBaseCalculo = '';
        this.INI_INDEX_ANO = 0;
        this.INI_INDEX_MES = 4;
        this.FIM_INDEX_MES = 6;
    }
    IndiceQualidadeFornecimentoListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    IndiceQualidadeFornecimentoListarController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    IndiceQualidadeFornecimentoListarController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    IndiceQualidadeFornecimentoListarController.prototype.marcarBancaria = function () {
        if (this.parametrosPesquisa.bancaria) {
            this.parametrosPesquisa.naoBancaria = false;
        }
    };
    IndiceQualidadeFornecimentoListarController.prototype.marcarNaoBancaria = function () {
        if (this.parametrosPesquisa.naoBancaria) {
            this.parametrosPesquisa.bancaria = false;
        }
    };
    IndiceQualidadeFornecimentoListarController.prototype.validaPeriodoBaseCalculo = function () {
        if (this.baseCalIni === null) {
            this.msgBaseCalculo = 'IQFI não disponível.';
            return false;
        }
        if (angular.isDefined(this.parametrosPesquisa) && angular.isDefined(this.parametrosPesquisa.baseCalculo)) {
            var dtBasInt = parseInt(this.moment(this.parametrosPesquisa.baseCalculo).format('YYYYMM'));
            if (dtBasInt < this.baseCalIni || dtBasInt > this.baseCalFim) {
                this.msgBaseCalculo = 'IQFI disponível de ' + this.labelMesAno(this.baseCalIni) + ' a ' + this.labelMesAno(this.baseCalFim) + '.';
                return false;
            }
        }
        return true;
    };
    IndiceQualidadeFornecimentoListarController.prototype.labelMesAno = function (anomes) {
        var ano = anomes.toString().substring(this.INI_INDEX_ANO, this.INI_INDEX_MES);
        var mes = anomes.toString().substring(this.INI_INDEX_MES, this.FIM_INDEX_MES);
        return mes + '/' + ano;
    };
    IndiceQualidadeFornecimentoListarController.prototype.validaIndice = function () {
        if (angular.isDefined(this.parametrosPesquisa) && angular.isDefined(this.parametrosPesquisa.indiceInferior) && angular.isDefined(this.parametrosPesquisa.indiceSuperior)
            && (this.parametrosPesquisa.indiceInferior !== null && this.parametrosPesquisa.indiceSuperior !== null)) {
            var inf = parseFloat(new Number(this.parametrosPesquisa.indiceInferior).toString());
            var sup = parseFloat(new Number(this.parametrosPesquisa.indiceSuperior).toString());
            return inf <= sup;
        }
        return true;
    };
    IndiceQualidadeFornecimentoListarController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.indiceQualidadeFornecimentoApiService.montarTelaPesquisar().then(function (montarTelaResource) {
            var realizarPesquisaInicial = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaResource;
            _this.baseCalIni = _this.dadosFormulario.baseCalculoInicio;
            _this.baseCalFim = _this.dadosFormulario.baseCalculoFim;
            if (!realizarPesquisaInicial) {
                var mes = _this.dadosFormulario.baseCalculoFim.toString().substring(_this.INI_INDEX_MES, _this.FIM_INDEX_MES);
                var ano = _this.dadosFormulario.baseCalculoFim.toString().substring(_this.INI_INDEX_ANO, _this.INI_INDEX_MES);
                _this.parametrosPesquisa.baseCalculo = new Date(parseInt(ano), parseInt(mes) - 1);
            }
            _this.pesquisar(_this.parametrosPesquisa);
            return montarTelaResource;
        });
    };
    IndiceQualidadeFornecimentoListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    IndiceQualidadeFornecimentoListarController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        parametrosPesquisa.jaPesquisado = true;
        return this.pesquisar(parametrosPesquisa);
    };
    IndiceQualidadeFornecimentoListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.indiceQualidadeFornecimentoApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        })["catch"](function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    IndiceQualidadeFornecimentoListarController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.baseCalculo = undefined;
        this.parametrosPesquisa.segmentos = undefined;
        this.parametrosPesquisa.conglomerado = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.bancaria = undefined;
        this.parametrosPesquisa.naoBancaria = undefined;
        this.parametrosPesquisa.indiceInferior = undefined;
        this.parametrosPesquisa.indiceSuperior = undefined;
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    IndiceQualidadeFornecimentoListarController.prototype.gerarXLS = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.indiceQualidadeFornecimentoApiService.gerarXlsx(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceQualidadeFornecimentoListarController.prototype.pesquisarIqfiMemoriaExcel = function (iqfiPk) {
        var _this = this;
        return this.indiceQualidadeFornecimentoApiService.pesquisarIqfiMemoriaExcel(iqfiPk).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceQualidadeFornecimentoListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            baseCalculo: ConverterParameterUrlToObjectUtils.date(filtro.baseCalculo),
            segmentos: ConverterParameterUrlToObjectUtils.atributoCodigoArray(filtro.segmentos),
            conglomerado: ConverterParameterUrlToObjectUtils.atributoCodigo(filtro.conglomerado),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            bancaria: ConverterParameterUrlToObjectUtils.boolean(filtro.bancaria),
            naoBancaria: ConverterParameterUrlToObjectUtils.boolean(filtro.naoBancaria),
            indiceInferior: ConverterParameterUrlToObjectUtils.number(filtro.indiceInferior),
            indiceSuperior: ConverterParameterUrlToObjectUtils.number(filtro.indiceSuperior),
            jaPesquisado: ConverterParameterUrlToObjectUtils.boolean(filtro.jaPesquisado),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    IndiceQualidadeFornecimentoListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            baseCalculo: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.baseCalculo),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(parametrosPesquisa.segmentos),
            conglomerado: ConverterParameterObjectToUrlUtils.atributoCodigo(parametrosPesquisa.conglomerado),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            bancaria: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.bancaria),
            naoBancaria: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.naoBancaria),
            indiceInferior: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.indiceInferior),
            indiceSuperior: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.indiceSuperior),
            jaPesquisado: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.jaPesquisado),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    IndiceQualidadeFornecimentoListarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return IndiceQualidadeFornecimentoListarController;
}());
IndiceQualidadeFornecimentoListarController.$inject = ['$location', '$stateParams', 'indiceQualidadeFornecimentoApiService', 'moment', 'feedbackService', '$scope'];
angular.module('crd').controller('IndiceQualidadeFornecimentoListarController', IndiceQualidadeFornecimentoListarController);
//# sourceMappingURL=indice-qualidade-fornecimento-listar-controller.js.map;
"use strict";
var IndiceRegularidadeFornecimentoDetalheController = (function () {
    function IndiceRegularidadeFornecimentoDetalheController($location, $state, $timeout, feedbackService, indiceRegularidadeFornecimentoApiService, moment) {
        this.$location = $location;
        this.$state = $state;
        this.$timeout = $timeout;
        this.feedbackService = feedbackService;
        this.indiceRegularidadeFornecimentoApiService = indiceRegularidadeFornecimentoApiService;
        this.moment = moment;
        this.formularioVisivel = true;
        this.resultadoVisivel = true;
        this.isInsituicao = false;
        this.isConglomerado = false;
        this.mascaraData = '99/9999';
        this.formatoData = 'MM/yyyy';
        this.placeholderData = 'mm/aaaa';
    }
    IndiceRegularidadeFornecimentoDetalheController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.validaPeriodoBaseCalculo = function () {
        if (angular.isDefined(this.parametrosPesquisa) && this.parametrosPesquisa.baseCalculoInicio && this.parametrosPesquisa.baseCalculoFim
            && parseInt(this.moment(this.parametrosPesquisa.baseCalculoFim).format('YYYYMM'))
                < parseInt(this.moment(this.parametrosPesquisa.baseCalculoInicio).format('YYYYMM'))) {
            return false;
        }
        return true;
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.carregarDadosTela = function (params, codigoPagina) {
        var _this = this;
        this.isInsituicao = codigoPagina === 'CRDFW8022';
        this.isConglomerado = codigoPagina === 'CRDFW8023';
        var promisse;
        if (this.isConglomerado) {
            promisse = this.indiceRegularidadeFornecimentoApiService.telaDetalhePesquisar({ conglomerado: params.conglomerado });
        }
        else {
            promisse = this.indiceRegularidadeFornecimentoApiService.telaDetalhePesquisar({ instituicao: params.instituicao });
        }
        promisse.then(function (resultado) {
            _this.dadosTela = resultado;
            _this.parametrosPesquisa = _this.converterUrlParaParametros(params);
            if (!ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(_.omit(params, ['instituicao', 'conglomerado']))) {
                _this.parametrosPesquisa.baseCalculoFim = ConverterParameterUrlToObjectUtils.date(resultado.baseCalculoFimData);
                _this.parametrosPesquisa.baseCalculoInicio = ConverterParameterUrlToObjectUtils.date(resultado.baseCalculoInicioData);
            }
            _this.pesquisar(_this.parametrosPesquisa);
        });
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            conglomerado: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.conglomerado),
            instituicao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.instituicao),
            baseCalculoFim: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.baseCalculoFim),
            baseCalculoInicio: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.baseCalculoInicio),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            conglomerado: ConverterParameterUrlToObjectUtils.string(filtro.conglomerado),
            instituicao: ConverterParameterUrlToObjectUtils.string(filtro.instituicao),
            baseCalculoFim: ConverterParameterUrlToObjectUtils.date(filtro.baseCalculoFim),
            baseCalculoInicio: ConverterParameterUrlToObjectUtils.date(filtro.baseCalculoInicio),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.pesquisarExcel = function () {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        var promisse;
        if (this.isConglomerado) {
            promisse = this.indiceRegularidadeFornecimentoApiService.pesquisarIrfiDetalheConglomeradoExcel(parametros);
        }
        else {
            promisse = this.indiceRegularidadeFornecimentoApiService.pesquisarIrfiDetalheInstituicaoExcel(parametros);
        }
        return promisse.then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.pesquisarMemoriaExcel = function (pk) {
        var _this = this;
        this.indiceRegularidadeFornecimentoApiService.pesquisarIrfiMemoriaExcel(pk).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(_.omit(parametros, ['instituicao', 'conglomerado']));
        var promisse;
        if (this.isConglomerado) {
            promisse = this.indiceRegularidadeFornecimentoApiService.pesquisarIrfiDetalheConglomerado(parametros);
        }
        else {
            promisse = this.indiceRegularidadeFornecimentoApiService.pesquisarIrfiDetalheInstituicao(parametros);
        }
        return promisse.then(function (resultado) {
            _this.resultadoPesquisa = resultado._embedded;
            _this.exibirResultadoPesquisa();
            if (!_.isEmpty(_this.resultadoPesquisa.mensagens)) {
                _this.feedbackService.alerta(_.pluck(_this.resultadoPesquisa.mensagens, 'content'));
            }
            return resultado;
        });
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.voltar = function () {
        if (this.$state.current.name === 'indice-regularidade-fornecimento-entidade-supervisionada-conglomerado') {
            this.$state.go('indice-regularidade-fornecimento-entidade-supervisionada', { instituicao: this.$state.params.instituicao });
        }
        else {
            this.$state.go('indice-regularidade-fornecimento-listar');
        }
    };
    IndiceRegularidadeFornecimentoDetalheController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params, this.$state.current.informacaoPagina.codigo);
    };
    ;
    return IndiceRegularidadeFornecimentoDetalheController;
}());
IndiceRegularidadeFornecimentoDetalheController.inject = ['$location', '$state', '$timeout', 'feedbackService', 'indiceRegularidadeFornecimentoApiService', 'moment'];
angular.module('crd').controller('IndiceRegularidadeFornecimentoDetalheController', IndiceRegularidadeFornecimentoDetalheController);
//# sourceMappingURL=indice-regularidade-fornecimento-detalhe-controller.js.map;
"use strict";
var IndiceRegularidadeFornecimentoListarController = (function () {
    function IndiceRegularidadeFornecimentoListarController($location, $stateParams, indiceRegularidadeFornecimentoApiService, moment, feedbackService, $scope) {
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.indiceRegularidadeFornecimentoApiService = indiceRegularidadeFornecimentoApiService;
        this.moment = moment;
        this.feedbackService = feedbackService;
        this.$scope = $scope;
        this.formularioVisivel = true;
        this.resultadoVisivel = true;
        this.mascaraData = '99/9999';
        this.formatoData = 'MM/yyyy';
        this.placeholderData = 'mm/aaaa';
        this.msgBaseCalculo = '';
        this.INI_INDEX_ANO = 0;
        this.INI_INDEX_MES = 4;
        this.FIM_INDEX_MES = 6;
    }
    IndiceRegularidadeFornecimentoListarController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    IndiceRegularidadeFornecimentoListarController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    IndiceRegularidadeFornecimentoListarController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    IndiceRegularidadeFornecimentoListarController.prototype.marcarBancaria = function () {
        if (this.parametrosPesquisa.bancaria) {
            this.parametrosPesquisa.naoBancaria = false;
        }
    };
    IndiceRegularidadeFornecimentoListarController.prototype.marcarNaoBancaria = function () {
        if (this.parametrosPesquisa.naoBancaria) {
            this.parametrosPesquisa.bancaria = false;
        }
    };
    IndiceRegularidadeFornecimentoListarController.prototype.validaPeriodoBaseCalculo = function () {
        if (this.baseCalIni === null) {
            this.msgBaseCalculo = 'IRFI não disponível.';
            return false;
        }
        if (angular.isDefined(this.parametrosPesquisa) && angular.isDefined(this.parametrosPesquisa.baseCalculo)) {
            var dtBasInt = parseInt(this.moment(this.parametrosPesquisa.baseCalculo).format('YYYYMM'));
            if (dtBasInt < this.baseCalIni || dtBasInt > this.baseCalFim) {
                this.msgBaseCalculo = 'IRFI disponível de ' + this.labelMesAno(this.baseCalIni) + ' a ' + this.labelMesAno(this.baseCalFim) + '.';
                return false;
            }
        }
        return true;
    };
    IndiceRegularidadeFornecimentoListarController.prototype.labelMesAno = function (anomes) {
        var ano = anomes.toString().substring(this.INI_INDEX_ANO, this.INI_INDEX_MES);
        var mes = anomes.toString().substring(this.INI_INDEX_MES, this.FIM_INDEX_MES);
        return mes + '/' + ano;
    };
    IndiceRegularidadeFornecimentoListarController.prototype.validaIndice = function () {
        if (angular.isDefined(this.parametrosPesquisa) && angular.isDefined(this.parametrosPesquisa.indiceInferior) && angular.isDefined(this.parametrosPesquisa.indiceSuperior)
            && (this.parametrosPesquisa.indiceInferior !== null && this.parametrosPesquisa.indiceSuperior !== null)) {
            var inf = parseFloat(new Number(this.parametrosPesquisa.indiceInferior).toString());
            var sup = parseFloat(new Number(this.parametrosPesquisa.indiceSuperior).toString());
            return inf <= sup;
        }
        return true;
    };
    IndiceRegularidadeFornecimentoListarController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.indiceRegularidadeFornecimentoApiService.montarTelaPesquisar().then(function (montarTelaResource) {
            var realizarPesquisaInicial = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaResource;
            _this.baseCalIni = _this.dadosFormulario.baseCalculoInicio;
            _this.baseCalFim = _this.dadosFormulario.baseCalculoFim;
            if (!realizarPesquisaInicial) {
                var mes = _this.dadosFormulario.baseCalculoFim.toString().substring(_this.INI_INDEX_MES, _this.FIM_INDEX_MES);
                var ano = _this.dadosFormulario.baseCalculoFim.toString().substring(_this.INI_INDEX_ANO, _this.INI_INDEX_MES);
                _this.parametrosPesquisa.baseCalculo = new Date(parseInt(ano), parseInt(mes) - 1);
            }
            _this.pesquisar(_this.parametrosPesquisa);
            return montarTelaResource;
        });
    };
    IndiceRegularidadeFornecimentoListarController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    IndiceRegularidadeFornecimentoListarController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        parametrosPesquisa.jaPesquisado = true;
        return this.pesquisar(parametrosPesquisa);
    };
    IndiceRegularidadeFornecimentoListarController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.indiceRegularidadeFornecimentoApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        })["catch"](function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    IndiceRegularidadeFornecimentoListarController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.baseCalculo = undefined;
        this.parametrosPesquisa.segmentos = undefined;
        this.parametrosPesquisa.conglomerado = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.bancaria = undefined;
        this.parametrosPesquisa.naoBancaria = undefined;
        this.parametrosPesquisa.indiceInferior = undefined;
        this.parametrosPesquisa.indiceSuperior = undefined;
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    IndiceRegularidadeFornecimentoListarController.prototype.gerarXLS = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.indiceRegularidadeFornecimentoApiService.gerarXlsx(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceRegularidadeFornecimentoListarController.prototype.pesquisarIrfiMemoriaExcel = function (irfiPk) {
        var _this = this;
        return this.indiceRegularidadeFornecimentoApiService.pesquisarIrfiMemoriaExcel(irfiPk).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    IndiceRegularidadeFornecimentoListarController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            baseCalculo: ConverterParameterUrlToObjectUtils.date(filtro.baseCalculo),
            segmentos: ConverterParameterUrlToObjectUtils.atributoCodigoArray(filtro.segmentos),
            conglomerado: ConverterParameterUrlToObjectUtils.atributoCodigo(filtro.conglomerado),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            bancaria: ConverterParameterUrlToObjectUtils.boolean(filtro.bancaria),
            naoBancaria: ConverterParameterUrlToObjectUtils.boolean(filtro.naoBancaria),
            indiceInferior: ConverterParameterUrlToObjectUtils.number(filtro.indiceInferior),
            indiceSuperior: ConverterParameterUrlToObjectUtils.number(filtro.indiceSuperior),
            jaPesquisado: ConverterParameterUrlToObjectUtils.boolean(filtro.jaPesquisado),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    IndiceRegularidadeFornecimentoListarController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            baseCalculo: ConverterParameterObjectToUrlUtils.date(parametrosPesquisa.baseCalculo),
            segmentos: ConverterParameterObjectToUrlUtils.atributoCodigoArray(parametrosPesquisa.segmentos),
            conglomerado: ConverterParameterObjectToUrlUtils.atributoCodigo(parametrosPesquisa.conglomerado),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            bancaria: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.bancaria),
            naoBancaria: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.naoBancaria),
            indiceInferior: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.indiceInferior),
            indiceSuperior: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.indiceSuperior),
            jaPesquisado: ConverterParameterObjectToUrlUtils.boolean(parametrosPesquisa.jaPesquisado),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    IndiceRegularidadeFornecimentoListarController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return IndiceRegularidadeFornecimentoListarController;
}());
IndiceRegularidadeFornecimentoListarController.$inject = ['$location', '$stateParams', 'indiceRegularidadeFornecimentoApiService', 'moment', 'feedbackService', '$scope'];
angular.module('crd').controller('IndiceRegularidadeFornecimentoListarController', IndiceRegularidadeFornecimentoListarController);
//# sourceMappingURL=indice-regularidade-fornecimento-listar-controller.js.map;
(function (angular, HttpStatus) {
  'use strict';

  angular.module('crd')
    .controller('IndicioModalAcaoController', IndicioModalAcaoController);

  IndicioModalAcaoController.$inject = ['$location', '$uibModalInstance', 'feedbackService', 'IndicioQualidadeApiService', '$scope', 'emailServidorApiService', '$timeout', '$q'];
  function IndicioModalAcaoController($location, $uibModalInstance, feedbackService, indicioQualidadeApiService, $scope, emailServidorApiService, $timeout, $q) {
    var vm = this;
    var obrigatoriedadeJustificativaOriginal;
    vm.cancelar = cancelar;
    vm.confirmar = confirmar;
    vm.validarDominio = validarDominio;
    vm.onChangeRejeitarDocumento = onChangeRejeitarDocumento;

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
      window.location.reload();
    }

    // Só faz a busca no serivor após parar de digitar, e após 500 milisegundos
    $scope.obterSugestoesDeEmailBcb = function (textoParaBusca) {
      var atrasoParaBusca;
      if (atrasoParaBusca) { // Cancela o atrasoParaBusca anterior se existir
        $timeout.cancel(atrasoParaBusca);
      }

      return $q(function (resolve) { // $q é um serviço do AngularJS para criar, encadear e gerenciar promessas (Promises). Ele é útil quando você quer executar algo assíncrono (como uma chamada de API ou um setTimeout) e esperar que essa operação termine antes de continuar o fluxo do programa.
        atrasoParaBusca = $timeout(function () {
          realizarBusca(textoParaBusca, resolve);
        }, 500); // Tempo do atrasoParaBusca
      });
    };

    function realizarBusca(textoParaBusca, resolve) {
      emailServidorApiService.buscarOpcoesParaSelecaoDoEmailDoServidor(textoParaBusca)
        .then(function (resposta) {

          const sugestoesFormatadas = resposta.data.map(function (usuario) {

            if (!usuario) {
              return {}
            }

            return {
              text: usuario.email, // valor que será inserido no input
              display: usuario.nome + ' - ' + usuario.email // texto visível na sugestão
            };
          });

          resolve(sugestoesFormatadas); // Pega o resultado da promisse e retorna o valor
        })
        .catch(function (erro) {
          console.error("Erro ao buscar sugestões:", erro);
          resolve([]); // Retorna o valor nulo como resultado da promisse
        });
    }

    function confirmar() {
      var dados = {
        texto: vm.texto,
        dataPrazoParaAcaoNova: ConverterParameterObjectToUrlUtils.date(vm.dataPrazoParaAcaoNova),
        rejeitarDocumento: vm.rejeitarDocumento,
        justificativa: vm.justificativa,
        envioEmailCuradorDocumentoComparado: {
          enviar: vm.enviarEmailCuradorDocumentoComparado,
          texto: vm.textoEmailCuradorDocumentoComparado,
        },
        envioEmailEquipeSupervisaoResponsavel: {
          enviar: vm.enviarEmailEquipeSupervisaoResponsavel,
          destinatarios: vm.emailsDestinatarioEquipeSupervisaoResponsavel,
          texto: vm.textoEmailComplementarEquipeSupervisaoResponsavel
        },
        comunicacaoDarCienciaDTO: vm.acoes.podeVerModeloEmailPadraoDarCiencia ? {
          idIncidenteQualidade: vm.pk,
          destinatarios: vm.emailsDigitados.join(","),
          texto: vm.textoInformadorEmailDarCiencia
        } : null,
        motivoDesconsiderarIncidente: vm.desconsideradoPor ? vm.desconsideradoPor.enumName : null,
        voltarSituacaoAnterior: vm.voltarSituacaoAnterior
      };
      var anexos = vm.acoes.podeAdicionarAnexo ? vm.anexos : null;
      indicioQualidadeApiService.executarAcao(vm.pk, vm.acao, dados, anexos).then(function (response) {
        if (response.status === HttpStatus.OK) {
          if (vm.acoes.podeVerModeloEmailPadraoDarCiencia) {
            feedbackService.sucesso('Ação executada com sucesso. Foi agendado um envio de e-mail com cópia para o remetente através do e-mail: ' + vm.usuarioLogado.emailUsuario + '. ');
          } else {
            feedbackService.sucesso('Ação executada com sucesso.');
          }
          $uibModalInstance.close(response.data);
        } else {
          feedbackService.violacoes(response.data);
        }
      });
    }

    function onChangeRejeitarDocumento(rejeitarDocumento) {
       vm.obrigatoriedade.justificativa =obrigatoriedadeJustificativaOriginal && !rejeitarDocumento;
       vm.mensagemQuestionamentoAvulsoRejeicao =rejeitarDocumento? vm.mensagemQuestionamentoAvulsoAoRejeitarDocumento : null;
     }

    this.$onInit = function () {
      obrigatoriedadeJustificativaOriginal =vm.obrigatoriedade && vm.obrigatoriedade.justificativa;
      vm.textoEmailDarCiencia = vm.textoEmailDarCiencia;
      vm.textoEmailComplementarEquipeSupervisaoResponsavel =vm.textoEmailComplementarEquipeSupervisaoResponsavel;
      vm.usuarioIsPerfilES =vm.usuarioLogado ? vm.usuarioLogado.possuiPerfilES : false;
      vm.anexos = new Array();
      vm.dataPrazoParaAcaoNova = ConverterParameterUrlToObjectUtils.date(vm.dataPrazoParaAcaoNova);
      vm.motivoDesconsiderarIncidente = vm.motivoDesconsiderarIncidente;
      vm.enviarEmailEquipeSupervisaoResponsavel = false;
    };

    function validarDominio(emailsDigitados) {
      var DOMINIO = "@bcb.gov.br";
      if (emailsDigitados && emailsDigitados.length) {
        for (var i in emailsDigitados) {
          if (emailsDigitados && emailsDigitados[i] && emailsDigitados[i].indexOf && emailsDigitados[i].indexOf("@") >= 0) {
            if (emailsDigitados[i].substring(emailsDigitados[i].indexOf("@"), emailsDigitados[i].length).toLowerCase() !== DOMINIO) {
              return false;
            }
          }
        }
      }
      return true;
    }

  }
})(angular, httpStatusCode);
;
(function(angular, HttpStatus) {
  'use strict';

  angular.module('crd')
    .controller('IndicioModalDesignarResponsavel', IndicioModalDesignarResponsavel);

  IndicioModalDesignarResponsavel.$inject = ['$location', '$uibModalInstance', 'feedbackService', 'IndicioQualidadeApiService'];
  function IndicioModalDesignarResponsavel($location, $uibModalInstance, feedbackService, indicioQualidadeApiService) {
    var vm = this;
    vm.cancelar = cancelar;
    vm.confirmar = confirmar;

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmar() {
      var curadoresSelecionados = _.filter(vm.data.curadores, function(curador) {
        return curador.selecionado;
      });

      var curadoresResponsaveis = _.map(curadoresSelecionados, function (curador) {
        return curador.login;
      });

      var dados = {
        incidenteQualidadePK: vm.data.incidenteQualidadePK,
        curadores: curadoresResponsaveis
      };

      indicioQualidadeApiService.designarResponsavel(dados).then(function (response) {
        if (response.status === HttpStatus.OK) {
          feedbackService.sucesso('Ação executada com sucesso.');
          $uibModalInstance.close(response.data);
        } else {
          feedbackService.violacoes(response.data);
        }
      });
    }

    this.$onInit = function () {

    };
  }
})(angular, httpStatusCode);
;
(function(angular, HttpStatus) {
  'use strict';

  angular.module('crd')
    .controller('IndicioModalDesignarResponsavelEmLoteController', IndicioModalDesignarResponsavelEmLoteController);

  IndicioModalDesignarResponsavelEmLoteController.$inject = ['$location', '$uibModalInstance', 'feedbackService', 'IndicioQualidadeApiService'];
  function IndicioModalDesignarResponsavelEmLoteController($location, $uibModalInstance, feedbackService, indicioQualidadeApiService) {
    var vm = this;
    vm.cancelar = cancelar;
    vm.confirmar = confirmar;

   
    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmar() {
      var curadoresSelecionados = _.filter(vm.paraDesignarResponsavelEmLote.curadores, function(curador) {
        return curador.selecionado;
      });

      var curadoresResponsaveis = _.map(curadoresSelecionados, function (curador) {
        return curador.login;
      });

      var dados = {
        indiciosSelecionadosPK: vm.paraDesignarResponsavelEmLote.indiciosSelecionadosEmLote,
        curadores: curadoresResponsaveis
      };

      indicioQualidadeApiService.designarResponsavelEmLote(dados).then(function (response) {
        var obj = angular.fromJson(response.data);
        if (response.status === HttpStatus.OK) {
          feedbackService.resultados(obj.mensagens);
          $uibModalInstance.close(response.data);
        } else {
          feedbackService.violacoes(response.data);
        }
      });


    }

    this.$onInit = function () {

    };
  }
})(angular, httpStatusCode);
;
"use strict";
var IndicioModalIncluirExcecaoEmLoteController = (function () {
    function IndicioModalIncluirExcecaoEmLoteController(indicioQualidadeApiService, $uibModalInstance, feedbackService) {
        this.indicioQualidadeApiService = indicioQualidadeApiService;
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.vmModal = this;
        this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
    }
    IndicioModalIncluirExcecaoEmLoteController.prototype.$onInit = function () {
        this.opcoesDeData = FormataDataPeriodicidade.formatoPelaPeriodicidade(this.vmModal.paraIncluir.periodicidade);
    };
    IndicioModalIncluirExcecaoEmLoteController.prototype.cancelar = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    IndicioModalIncluirExcecaoEmLoteController.prototype.salvar = function () {
        var _this = this;
        var dadosSalvar = this.converterParaEnviarServidor(this.dadosForm);
        return this.indicioQualidadeApiService.incluirExcecaoEmLote(this.vmModal.paraIncluir.filtro, dadosSalvar).then(function (resource) {
            if (resource.status === 200) {
                var mensagem = JSON.parse(resource.body).mensagem;
                _this.feedbackService.sucesso(mensagem);
                _this.$uibModalInstance.close();
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
        });
    };
    IndicioModalIncluirExcecaoEmLoteController.prototype.converterParaEnviarServidor = function (dados) {
        var valor = {
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dados.dataBaseFim),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(dados.dataBaseInicio),
            justificativa: ConverterParameterObjectToUrlUtils.string(dados.justificativa),
            motivoDesconsiderarExcecao: ConverterParameterObjectToUrlUtils.atributoEnumName(dados.motivoDesconsiderarExcecao)
        };
        return valor;
    };
    return IndicioModalIncluirExcecaoEmLoteController;
}());
IndicioModalIncluirExcecaoEmLoteController.$inject = ['IndicioQualidadeApiService', '$uibModalInstance', 'feedbackService', '$uibModal'];
angular.module('crd').controller('IndicioModalIncluirExcecaoEmLoteController', IndicioModalIncluirExcecaoEmLoteController);
//# sourceMappingURL=indicio-modal-incluir-excecao-em-lote-controller.js.map;
(function(angular, HttpStatus) {
  'use strict';

  angular.module('crd')
    .controller('IndicioModalMudancaSituacaoLoteController', IndicioModalMudancaSituacaoLoteController);

  IndicioModalMudancaSituacaoLoteController.$inject = ['$location', '$uibModalInstance', 'feedbackService', 'IndicioQualidadeApiService'];
  function IndicioModalMudancaSituacaoLoteController($location, $uibModalInstance, feedbackService, indicioQualidadeApiService) {
    var vm = this;
    vm.cancelar = cancelar;
    vm.confirmar = confirmar;
    vm.formData = {
      texto: null,
      desconsideradoPor: null,
      diasUteisParaProrrogar: null,
      voltarSituacaoAnterior: false
    };

    this.$onInit = function () {
      vm.anexos = new Array();
      verificarSeTodosOsProtocolosEstaoMarcados();
      verificarJustificativaObrigatorio();
      atualizarMensagemQuestionamentoAvulsoRejeicao();
    };

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
      window.location.reload();
    }

    function confirmar() {
      const dados = {
        texto: vm.formData.texto,
        desconsideradoPor: ConverterParameterObjectToUrlUtils.atributoEnumName(vm.formData.desconsideradoPor),
        entradasArquivo: vm.paraMudanca.entradasArquivo.map(function (ent) {return {pk: ent.pk, aceitar: ent.aceitar};}),
        justificativa: vm.formData.justificativa,
        diasUteisParaProrrogar: vm.formData.diasUteisParaProrrogar,
        indiciosPk: vm.filtro.indiciosPk,
        quantidadeIndiciosImpactados: vm.paraMudanca.quantidadeIndiciosImpactados,
        voltarSituacaoAnterior: vm.voltarSituacaoAnterior
      }

      var anexos = vm.paraMudanca.acoes && vm.paraMudanca.acoes.podeAdicionarAnexo ? vm.anexos : null;
      indicioQualidadeApiService.mudarEstadoEmLote(vm.filtro, dados, anexos).then(function (response) {
        if (response.status === HttpStatus.OK) {
          feedbackService.sucesso('Ação executada com sucesso.');
          $uibModalInstance.close(response.data);
        } else {
          feedbackService.violacoes(response.data);
        }
      });
    }

    vm.selecionarTodosAsEntradasArquivos = function selecionarTodosAsEntradasArquivos(aceitar) {
      vm.paraMudanca.entradasArquivo.forEach(function (ent) {ent.aceitar = aceitar});
      verificarJustificativaObrigatorio();
      atualizarMensagemQuestionamentoAvulsoRejeicao();

      if (aceitar) {
        vm.quantidadeProtocolosASeremRejeitados = 0;
      } else {
        vm.quantidadeProtocolosASeremRejeitados = obterQuantidadeProtocolosDesmarcados();
      }
    }

    vm.onChangeEntAceitar = function onChangeEntAceitar(ent) {
      verificarSeTodosOsProtocolosEstaoMarcados();
      verificarJustificativaObrigatorio();
      vm.quantidadeProtocolosASeremRejeitados = obterQuantidadeProtocolosDesmarcados();
      atualizarMensagemQuestionamentoAvulsoRejeicao();
    }

    function verificarSeTodosOsProtocolosEstaoMarcados() {
      vm.selecionarTodos = vm.paraMudanca.entradasArquivo
        .map(function (ent) {return ent.aceitar})
        .reduce( function (accumulador, next) { return accumulador || next}, false);
    }

    function obterQuantidadeProtocolosDesmarcados() {
      var acumulador = 0;
      vm.paraMudanca.entradasArquivo.forEach(
        function (ent) {
          if(!ent.aceitar) {
            acumulador++;
          }
        });

        return acumulador;
    }

    function verificarJustificativaObrigatorio() {
      if (vm.paraMudanca.obrigatoriedade && vm.paraMudanca.obrigatoriedade.justificativaOpcional) {
        vm.justificativaObrigatorio = false;
        return;
      }
      vm.justificativaObrigatorio = vm.paraMudanca.entradasArquivo
        .map(function (ent) {return ent.aceitar})
        .reduce(function (accumulador, next) {
          return accumulador || next;
        }, false);
    }

    function atualizarMensagemQuestionamentoAvulsoRejeicao() {
      vm.exibirMensagemQuestionamentoAvulsoRejeicao = vm.paraMudanca.entradasArquivo.some(function (ent) {
        return !ent.aceitar && ent.possuiQuestionamentoAvulsoAtivo;
      });
    }
  }
})(angular, httpStatusCode);
;
"use strict";
var IndicioQualidadeDetalheController = (function () {
    function IndicioQualidadeDetalheController($state, indicioQualidadeApiService, $uibModal, $scope, feedbackService) {
        this.$state = $state;
        this.indicioQualidadeApiService = indicioQualidadeApiService;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
    }
    IndicioQualidadeDetalheController.prototype.carregarDadosTela = function (pk) {
        var _this = this;
        this.indicioQualidadeApiService.montarTelaDetalhe(pk).then(function (response) {
            if (response.data) {
                _this.indicioQualidade = response.data;
            }
        });
    };
    IndicioQualidadeDetalheController.prototype.downloadAnexo = function (pk) {
        return this.indicioQualidadeApiService.downloadAnexo(pk).then(function (resource) {
        });
    };
    IndicioQualidadeDetalheController.prototype.voltar = function () {
        this.$state.go(this.destinoVoltar, this.destinoVoltarParametros);
    };
    IndicioQualidadeDetalheController.prototype.$onInit = function () {
        this.destinoVoltar = this.$state.params.voltar ? this.$state.params.voltar : 'indicio-qualidade-pesquisa';
        if (this.$state.params.voltarParametros) {
            this.destinoVoltarParametros = typeof this.$state.params.voltarParametros === 'string'
                ? JSON.parse(this.$state.params.voltarParametros)
                : this.$state.params.voltarParametros;
        }
        return this.carregarDadosTela(this.$state.params.pk);
    };
    ;
    IndicioQualidadeDetalheController.prototype.parametrosParaRetorno = function () {
        return this.$state.params.voltarParametros;
    };
    IndicioQualidadeDetalheController.prototype.criarURLParaIncluirExcecaoQualidade = function (indicio) {
        var indicioPk = this.$state.params.pk;
        return {
            indicioPk: indicioPk,
            voltar: 'indicio-qualidade-detalhar',
            voltarParametros: JSON.stringify({ pk: indicioPk })
        };
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipDesconsiderar = function () {
        return 'O indício não será considerado como um problema de qualidade, sendo necessário registrar um comentário para caracterizar esta decisão.\nCaso seja o último indício apurado para o protocolo, o curador poderá decidir se rejeita ou não o documento com base em todos os indícios apurados e avaliados, registrando a justificativa.\nCaso tenha algum documento comparado, poderá ser encaminhado e-mail ao curador do mesmo para providências.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipAceitarResposta = function () {
        return 'O indício não será considerado como um problema de qualidade, sendo necessário registrar um comentário para caracterizar esta decisão.\nCaso seja o último indício apurado para o protocolo, o curador poderá decidir se rejeita ou não o documento com base em todos os indícios apurados e avaliados, registrando a justificativa.\nCaso tenha algum documento comparado, poderá ser encaminhado e-mail ao curador do mesmo para providências.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipQuestionar = function () {
        if (this.indicioQualidade.situacao.codigo === 'V') {
            return 'Será encaminhada uma mensagem à entidade supervisionada (ES) via Correio Eletrônico e e-mail para que visualize e responda a este questionamento no CRD.\nPoderá ser registrado um comentário que caracterize esta decisão, mas que não será visível pela ES, somente pelo público interno ao BC.';
        }
        return '';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipConfirmar = function () {
        return 'O indício será considerado como um problema de qualidade, sendo necessário registrar um comentário para caracterizar esta decisão.\nCaso seja o último indício apurado para o protocolo, o curador poderá decidir se rejeita ou não o documento com base em todos os indícios apurados e avaliados, registrando a justificativa.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipRejeitarResposta = function () {
        return 'O indício será considerado como um problema de qualidade, sendo necessário registrar um comentário para caracterizar esta decisão.\nCaso seja o último indício apurado para o protocolo, o curador poderá decidir se rejeita ou não o documento com base em todos os indícios apurados e avaliados, registrando a justificativa.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipEncaminharValidacao = function () {
        return 'Será habilitado para outro curador validar a análise incial do indício.\nSerá necessário adicionar um comentário, o qual caracterizará a sua análise inicial.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipEncaminharParaRatificacao = function () {
        return 'Será habilitado para outro curador validar a análise do indício.\nSerá necessário adicionar um comentário, o qual caracterizará a sua análise.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipIncluirExcecaoQualidade = function () {
        return 'Será habilitado para outro curador validar a análise do indício.\nSerá necessário adicionar um comentário, o qual caracterizará a sua análise.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipComunicar = function () {
        if (this.indicioQualidade.situacao.codigo === 'R') {
            return 'Será habilitada uma caixa de texto para o Banco Central e a entidade supervisionada se manifestarem, podendo anexar arquivo, caso necessário.';
        }
        return '';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipDarCiencia = function () {
        return 'Será exibida a tela de dar ciência para encaminhar informações sobre o indício a qualquer destinatário de e-mail interno, podendo incluir um texto complementar explicativo e anexar arquivo, caso necessário.';
    };
    IndicioQualidadeDetalheController.prototype.obterToolTipDesignarResponsavel = function () {
        return '';
    };
    IndicioQualidadeDetalheController.prototype.paraAceitarResposta = function () {
        this.openModalAcao("ACEITAR_RESPOSTA");
    };
    IndicioQualidadeDetalheController.prototype.paraComunicar = function () {
        this.openModalAcao("COMUNICAR");
    };
    IndicioQualidadeDetalheController.prototype.paraConfirmar = function () {
        this.openModalAcao("CONFIRMAR");
    };
    IndicioQualidadeDetalheController.prototype.paraDesconsiderar = function () {
        this.openModalAcao("DESCONSIDERAR");
    };
    IndicioQualidadeDetalheController.prototype.paraEncaminharRatificacao = function () {
        this.openModalAcao("ENCAMINHAR_RATIFICACAO");
    };
    IndicioQualidadeDetalheController.prototype.paraEncaminharValidacao = function () {
        this.openModalAcao("ENCAMINHAR_VALIDACAO");
    };
    IndicioQualidadeDetalheController.prototype.paraIncluirResposta = function () {
        this.openModalAcao("INCLUIR_RESPOSTA");
    };
    IndicioQualidadeDetalheController.prototype.paraProrrogar = function () {
        this.openModalAcao("PRORROGAR");
    };
    IndicioQualidadeDetalheController.prototype.paraDarCiencia = function () {
        this.openModalAcao("DAR_CIENCIA");
    };
    IndicioQualidadeDetalheController.prototype.paraQuestionar = function () {
        this.openModalAcao("QUESTIONAR");
    };
    IndicioQualidadeDetalheController.prototype.paraRejeitar = function () {
        this.openModalAcao("REJEITAR_RESPOSTA");
    };
    IndicioQualidadeDetalheController.prototype.paraDesignarResponsavel = function () {
        var _this = this;
        var _self = this;
        return this.indicioQualidadeApiService.paraDesignarResponsavel(this.indicioQualidade.pk).then(function (response) {
            var scope = _this.$scope.$new();
            _.extend(scope, response);
            _this.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/indicio-qualidade/indicio-modal-acoes/indicio-modal-designar-responsavel-tpl.html',
                controller: 'IndicioModalDesignarResponsavel',
                controllerAs: 'indicioModalDesignarResponsavel',
                bindToController: true,
                keyboard: true,
                size: 'lg',
                scope: scope
            }).result
                .then(function (indicioQualidade) { return _self.indicioQualidade = indicioQualidade; });
        });
    };
    IndicioQualidadeDetalheController.prototype.paraEncerrar = function () {
        var _this = this;
        return this.indicioQualidadeApiService.encerrar(this.indicioQualidade.pk).then(function (response) {
            if (response.data) {
                _this.indicioQualidade = response.data;
            }
            _this.feedbackService.sucesso('Indício encerrado com sucesso, teve sua situação alterada para Histórico.');
        });
    };
    IndicioQualidadeDetalheController.prototype.openModalAcao = function (acao) {
        var _this = this;
        var _self = this;
        return this.indicioQualidadeApiService.paraExecutarAcao(this.$state.params.pk, acao).then(function (response) {
            var scope = _this.$scope.$new();
            scope.acao = acao;
            scope.pk = _this.$state.params.pk;
            _.extend(scope, response.data);
            _this.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/indicio-qualidade/indicio-modal-acoes/indicio-modal-acoes-tpl.html',
                controller: 'IndicioModalAcaoController',
                controllerAs: 'indicioModalAcaoCtrl',
                bindToController: true,
                keyboard: true,
                size: 'lg',
                scope: scope
            }).result
                .then(function (indicioQualidade) { return _self.indicioQualidade = indicioQualidade; });
        });
    };
    return IndicioQualidadeDetalheController;
}());
IndicioQualidadeDetalheController.$inject = ['$state', 'IndicioQualidadeApiService', '$uibModal', '$scope', 'feedbackService'];
angular.module('crd').controller('IndicioQualidadeDetalheController', IndicioQualidadeDetalheController);
//# sourceMappingURL=indicio-qualidade-detalhe-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var IndicioQualidadePesquisaController = (function (_super) {
    __extends(IndicioQualidadePesquisaController, _super);
    function IndicioQualidadePesquisaController($stateParams, $location, $timeout, $scope, feedbackService, indicioQualidadeApiService, strategyFactory, documentoApiService, sistemaNegocioApiService, moment) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.$timeout = $timeout;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.indicioQualidadeApiService = indicioQualidadeApiService;
        _this.strategyFactory = strategyFactory;
        _this.documentoApiService = documentoApiService;
        _this.sistemaNegocioApiService = sistemaNegocioApiService;
        _this.moment = moment;
        _this.exibirLegendaESPendenteCancelamento = false;
        _this.exibirLegendaESCancelada = false;
        _this.inicializandoPesquisa = true;
        _this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        _this.protocolosPesquisados = {};
        _this.acaoEmLote = AcaoEmLote.build();
        _this.parametrosPesquisa = {
            grupoPeriodicidade: 'MENSAL_OU_MAIOR'
        };
        return _this;
    }
    IndicioQualidadePesquisaController.prototype.$onInit = function () {
        var _this = this;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        return this.dadosParaConstruir(this.$stateParams).then(function (response) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(_this.$stateParams);
            if (jaPossuiParametrosInformados) {
                return _this.consultarRecurso(_this.converterDadosDoFormToConsultaFiltro(_this.parametrosPesquisa)).then(function () {
                    _this.exibirResultadoPesquisa();
                    _this.finalizarInicializacaoPesquisa();
                });
            }
            _this.parametrosPesquisa.grupoPeriodicidade = 'MENSAL_OU_MAIOR';
            _this.fazerPesquisaInicial();
            _this.finalizarInicializacaoPesquisa();
            return;
        });
    };
    IndicioQualidadePesquisaController.prototype.finalizarInicializacaoPesquisa = function () {
        var _this = this;
        this.$timeout(function () {
            _this.inicializandoPesquisa = false;
        }, 0);
    };
    IndicioQualidadePesquisaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        return this.indicioQualidadeApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.dadosFormulario = response.data;
            _this.dadosFormulario.situacoesFiltrada = [];
            _this.parametrosPesquisa = _this.converterUrlParaParametros(consultaFiltro);
            return _this.carregarSistemaNegocio(_this.parametrosPesquisa.grupoPeriodicidade)
                .then(function () { return _this.carregarDocumentos(_this.parametrosPesquisa.grupoPeriodicidade, _this.parametrosPesquisa.sistemasNegocio); })
                .then(function () {
                _this.carregarSituacaoIncidente(_this.parametrosPesquisa.grupoSituacaoIncidente);
                return response;
            });
        });
    };
    IndicioQualidadePesquisaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.indicioQualidadeApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            _this.exibirLegendaESPendenteCancelamento = _this.pagina
                && _this.pagina.content
                && _this.pagina.content.some(function (indicio) { return indicio && indicio.exibirLegendaESPendenteCancelamento; }) || false;
            _this.exibirLegendaESCancelada = _this.pagina
                && _this.pagina.content
                && _this.pagina.content.some(function (indicio) { return indicio && indicio.exibirLegendaESCancelada; }) || false;
            _this.atualizarSelecaoLoteAposConsulta();
            return response;
        });
    };
    IndicioQualidadePesquisaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        var dataBaseInicio = this.opcoesDeData.normatizar(dadosFormulario.dataBaseInicio);
        var dataBaseFim = this.opcoesDeData.normatizar(dadosFormulario.dataBaseFim);
        var dataBaseFimPeriodoTolerancia = this.opcoesDeData.normatizar(dadosFormulario.dataBaseFimPeriodoTolerancia);
        return {
            grupoPeriodicidade: ConverterParameterObjectToUrlUtils.string(dadosFormulario.grupoPeriodicidade),
            documentos: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.documentos),
            sistemasNegocio: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.sistemasNegocio),
            idBacen: ConverterParameterObjectToUrlUtils.atributoIdBacen(dadosFormulario.instituicao),
            dataBaseInicio: ConverterParameterObjectToUrlUtils.date(dataBaseInicio),
            dataBaseFim: ConverterParameterObjectToUrlUtils.date(dataBaseFim),
            dataBaseFimPeriodoTolerancia: ConverterParameterObjectToUrlUtils.date(dataBaseFimPeriodoTolerancia),
            criticas: ConverterParameterObjectToUrlUtils.atributoPKArray(dadosFormulario.criticas),
            grupoSituacaoIncidente: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.grupoSituacaoIncidente),
            situacoes: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(dadosFormulario.situacoes),
            tipos: ConverterParameterObjectToUrlUtils.atributoEnumNameArray(dadosFormulario.tipos),
            protocoloRecebimento: ConverterParameterObjectToUrlUtils.numberArray(dadosFormulario.protocoloRecebimento),
            numeroPagina: ConverterParameterObjectToUrlUtils.number(dadosFormulario.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(dadosFormulario.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(dadosFormulario.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(dadosFormulario.ordenacaoDirecao)
        };
    };
    IndicioQualidadePesquisaController.prototype.limparDadosFormulario = function (dadosFormulario) {
        dadosFormulario.grupoPeriodicidade = 'MENSAL_OU_MAIOR';
        dadosFormulario.sistemasNegocio = undefined;
        dadosFormulario.documentos = undefined;
        dadosFormulario.instituicao = undefined;
        dadosFormulario.dataBaseInicio = undefined;
        dadosFormulario.dataBaseFim = undefined;
        dadosFormulario.dataBaseFimPeriodoTolerancia = undefined;
        dadosFormulario.criticas = undefined;
        dadosFormulario.situacoes = undefined;
        dadosFormulario.tipos = undefined;
        dadosFormulario.grupoSituacaoIncidente = undefined;
        dadosFormulario.protocoloRecebimento = undefined;
        this.carregarSistemaNegocio(dadosFormulario.grupoPeriodicidade);
        this.limparSelecionados();
    };
    IndicioQualidadePesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        this.acaoEmLote = AcaoEmLote.build();
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.consultar(parametrosPesquisa);
    };
    IndicioQualidadePesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        this.limparSelecionados();
        return _super.prototype.navegarNaGrid.call(this, this.parametrosPesquisa, pagination);
    };
    IndicioQualidadePesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.limparDadosFormulario(this.parametrosPesquisa);
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    IndicioQualidadePesquisaController.prototype.limparResultadoPesquisa = function () {
        if (this.inicializandoPesquisa) {
            return;
        }
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    IndicioQualidadePesquisaController.prototype.gerarExcel = function (parametrosPesquisa) {
        var _this = this;
        var filtro = this.converterDadosDoFormToConsultaFiltro(this.parametrosPesquisa);
        return this.indicioQualidadeApiService.relatorioExcel(filtro).then(function (response) {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return response;
        });
    };
    IndicioQualidadePesquisaController.prototype.parametrosParaRetorno = function () {
        var parametros = angular.copy(this.$location.search());
        parametros.jaPesquisado = true;
        return JSON.stringify(parametros);
    };
    IndicioQualidadePesquisaController.prototype.validarProtocolos = function (tag) {
        var s = tag.text || '';
        if (this.protocolosPesquisados[s]) {
            return false;
        }
        this.protocolosPesquisados[s] = true;
        return true;
    };
    IndicioQualidadePesquisaController.prototype.limparProtocolosPesquisados = function (tag) {
        delete this.protocolosPesquisados[tag.text];
    };
    IndicioQualidadePesquisaController.prototype.periodoDataBaseInvalido = function () {
        return !(this.parametrosPesquisa &&
            this.parametrosPesquisa.dataBaseInicio &&
            this.parametrosPesquisa.dataBaseFim &&
            this.moment
                .utc(this.parametrosPesquisa.dataBaseInicio)
                .isAfter(this.moment.utc(this.parametrosPesquisa.dataBaseFim), 'day'));
    };
    IndicioQualidadePesquisaController.prototype.observerChangeGrupoPeriodicidade = function (grupoPeriodicidade) {
        this.parametrosPesquisa.sistemasNegocio = undefined;
        this.parametrosPesquisa.documentos = undefined;
        this.changeOpcoesDeData(grupoPeriodicidade);
        this.carregarSistemaNegocio(grupoPeriodicidade);
    };
    IndicioQualidadePesquisaController.prototype.observerChangeSistemaNegocio = function (grupoPeriodicidade, sistemasNegocio) {
        this.carregarDocumentos(grupoPeriodicidade, sistemasNegocio);
    };
    IndicioQualidadePesquisaController.prototype.observerChangeDocumento = function (grupoPeriodicidade, documentos) {
    };
    IndicioQualidadePesquisaController.prototype.carregarSistemaNegocio = function (grupoPeriodicidade) {
        var _this = this;
        var parametros = {
            grupoPeriodicidade: grupoPeriodicidade,
            quantidadePorPagina: 99999
        };
        this.changeOpcoesDeData(grupoPeriodicidade);
        return this.sistemaNegocioApiService.pesquisarParaSelecao(parametros, false).then(function (resource) {
            if (_this.dadosFormulario && _this.dadosFormulario.sistemasNegocio) {
                _this.dadosFormulario.sistemasNegocio.length = 0;
                Array.prototype.push.apply(_this.dadosFormulario.sistemasNegocio, resource.data.content);
            }
            return resource;
        });
    };
    IndicioQualidadePesquisaController.prototype.carregarSituacaoIncidente = function (grupo) {
        if (!this.dadosFormulario || !this.dadosFormulario.situacoesFiltrada) {
            return;
        }
        this.dadosFormulario.situacoesFiltrada.length = 0;
        if (grupo) {
            var novos_1 = [];
            _.each(this.dadosFormulario.situacoes, function (situacao) {
                if (situacao.grupo.codigo === grupo.enumName) {
                    novos_1.push(situacao);
                }
            });
            Array.prototype.push.apply(this.dadosFormulario.situacoesFiltrada, novos_1);
        }
        else {
            Array.prototype.push.apply(this.dadosFormulario.situacoesFiltrada, this.dadosFormulario.situacoes);
        }
    };
    IndicioQualidadePesquisaController.prototype.carregarDocumentos = function (grupoPeriodicidade, sistemasNegocio) {
        var _this = this;
        if (!this.dadosFormulario || !this.dadosFormulario.documentos) {
            return;
        }
        if (!sistemasNegocio || _.isEmpty(sistemasNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        var parametros = {
            periodicidade: grupoPeriodicidade === 'MENSAL_OU_MAIOR' ? 'MENSAL' : 'DIARIA',
            sistemaNegocioPks: _.map(sistemasNegocio, function (value) { return value.pk; })
        };
        return this.documentoApiService.pesquisarPorPeriodicidadeESistemaNegocioPk(parametros).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            var data = resource.data._embedded;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, data.resultado);
            return resource;
        });
    };
    IndicioQualidadePesquisaController.prototype.changeOpcoesDeData = function (grupoPeriodicidade) {
        if (grupoPeriodicidade === 'MENOR_QUE_MENSAL') {
            this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
        }
        else {
            this.opcoesDeData = FormataDataPeriodicidade.MES_ANO;
        }
    };
    IndicioQualidadePesquisaController.prototype.fazerPesquisaInicial = function () {
        if (this.dadosFormulario && this.dadosFormulario.fazerPesquisaInicialCurador) {
            this.parametrosPesquisa.sistemasNegocio = this.dadosFormulario.sistemasNegocioCurador;
            this.parametrosPesquisa.grupoSituacaoIncidente = { enumName: 'EM_ABERTO' };
            this.consultar(this.parametrosPesquisa);
        }
    };
    IndicioQualidadePesquisaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            grupoPeriodicidade: ConverterParameterUrlToObjectUtils.string(filtro.grupoPeriodicidade),
            documentos: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.documentos),
            sistemasNegocio: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.sistemasNegocio),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.idBacen),
            dataBaseInicio: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseInicio),
            dataBaseFim: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseFim),
            dataBaseFimPeriodoTolerancia: ConverterParameterUrlToObjectUtils.date(filtro.dataBaseFimPeriodoTolerancia),
            criticas: ConverterParameterUrlToObjectUtils.atributoPKArray(filtro.criticas),
            grupoSituacaoIncidente: ConverterParameterUrlToObjectUtils.atributoEnumName(filtro.grupoSituacaoIncidente),
            situacoes: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.situacoes),
            tipos: ConverterParameterUrlToObjectUtils.atributoEnumNameArray(filtro.tipos),
            protocoloRecebimento: ConverterParameterUrlToObjectUtils.numberArray(filtro.protocoloRecebimento),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    IndicioQualidadePesquisaController.prototype.executarAcaoEmLote = function (tipoAcao) {
        var _this = this;
        var contexto = {
            tipoAcao: tipoAcao,
            filtroConsulta: this.converterDadosDoFormToConsultaFiltro(this.parametrosPesquisa),
            acaoEmLote: this.acaoEmLote,
            itensPagina: this.pagina ? this.pagina.content : []
        };
        var strategy = this.strategyFactory.obterEstrategia(tipoAcao);
        return strategy.executar(contexto).then(function (sucesso) {
            if (sucesso) {
                _this.acaoEmLote = AcaoEmLote.build();
                return _this.consultarRecurso(_this.converterDadosDoFormToConsultaFiltro(_this.parametrosPesquisa)).then(function () {
                    _this.feedbackService.sucesso('Ação executada com sucesso.');
                });
            }
            return undefined;
        });
    };
    IndicioQualidadePesquisaController.prototype.paraQuestionarEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.QUESTIONAR);
    };
    IndicioQualidadePesquisaController.prototype.paraEncaminharParaValidacaoEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.ENCAMINHAR_VALIDACAO);
    };
    IndicioQualidadePesquisaController.prototype.paraEncaminharParaRatificacaoEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.ENCAMINHAR_RATIFICACAO);
    };
    IndicioQualidadePesquisaController.prototype.paraDesconsiderarEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.DESCONSIDERAR);
    };
    IndicioQualidadePesquisaController.prototype.paraDesignarResponsavelEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.DESIGNAR_RESPONSAVEL);
    };
    IndicioQualidadePesquisaController.prototype.paraConfirmarEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.CONFIRMAR);
    };
    IndicioQualidadePesquisaController.prototype.paraComunicarEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.COMUNICAR);
    };
    IndicioQualidadePesquisaController.prototype.paraAceitarRespostaEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.ACEITAR_RESPOSTA);
    };
    IndicioQualidadePesquisaController.prototype.paraProrrogarEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.PRORROGAR);
    };
    IndicioQualidadePesquisaController.prototype.paraRejeitarRespostaEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.REJEITAR_RESPOSTA);
    };
    IndicioQualidadePesquisaController.prototype.paraIncluirExecaoQualidadeEmLote = function () {
        return this.executarAcaoEmLote(TipoIndicioAcaoEmLote.INCLUIR_EXCECAO);
    };
    IndicioQualidadePesquisaController.prototype.atualizarSelecaoLoteAposConsulta = function () {
        var _this = this;
        if (this.pagina && this.pagina.content) {
            this.pagina.content.forEach(function (r) {
                r.selecionadoParaAcaoEmLote =
                    (_this.acaoEmLote.houveSelecaoDeTodos && !_.contains(_this.acaoEmLote.removidoDoTodos, r.pk)) ||
                        _.contains(_this.acaoEmLote.selecionados, r.pk);
            });
        }
    };
    IndicioQualidadePesquisaController.prototype.selecionarTodosParaAcaoEmLote = function () {
        var _this = this;
        this.acaoEmLote.houveSelecaoDeTodos = this.acaoEmLote.selecionouTodos;
        this.acaoEmLote.acaoDesabilitada = !this.acaoEmLote.selecionouTodos;
        this.acaoEmLote.selecionados = [];
        this.acaoEmLote.removidoDoTodos = [];
        if (this.pagina && this.pagina.content) {
            this.pagina.content.forEach(function (r) { return (r.selecionadoParaAcaoEmLote = _this.acaoEmLote.selecionouTodos); });
        }
    };
    IndicioQualidadePesquisaController.prototype.selecionarItensPagina = function () {
        this.acaoEmLote.selecionouItens = !this.acaoEmLote.selecionouItens;
        if (this.pagina && this.pagina.content) {
            for (var index = 0; index < this.qtdItensNaTabela(); index++) {
                if (this.pagina.content[index]) {
                    this.pagina.content[index].selecionadoParaAcaoEmLote = this.acaoEmLote.selecionouItens;
                    this.selecionarIndicioParaAcaoEmLote(this.pagina.content[index]);
                }
            }
        }
    };
    IndicioQualidadePesquisaController.prototype.qtdItensNaTabela = function () {
        var tableElement = document.getElementById('tbl-resultado-pesquisa-indicio-qualidade');
        if (tableElement) {
            return tableElement.getElementsByTagName('tr').length - 1;
        }
        return 0;
    };
    IndicioQualidadePesquisaController.prototype.limparSelecionados = function () {
        this.acaoEmLote.selecionouTodos = false;
        this.acaoEmLote.houveSelecaoDeTodos = false;
        this.acaoEmLote.acaoDesabilitada = true;
        this.acaoEmLote.selecionados = [];
        this.acaoEmLote.removidoDoTodos = [];
        if (this.pagina && this.pagina.content) {
            this.pagina.content.forEach(function (r) { return (r.selecionadoParaAcaoEmLote = false); });
        }
    };
    IndicioQualidadePesquisaController.prototype.selecionarIndicioParaAcaoEmLote = function (indicio) {
        if (indicio.selecionadoParaAcaoEmLote) {
            this.acaoEmLote.selecionados.push(indicio.pk);
            this.acaoEmLote.removidoDoTodos = _.without(this.acaoEmLote.removidoDoTodos, indicio.pk);
        }
        else {
            this.acaoEmLote.selecionados = _.without(this.acaoEmLote.selecionados, indicio.pk);
            this.acaoEmLote.removidoDoTodos.push(indicio.pk);
            this.acaoEmLote.selecionouTodos = false;
        }
        this.acaoEmLote.acaoDesabilitada =
            this.acaoEmLote.selecionouTodos ||
                (!this.acaoEmLote.houveSelecaoDeTodos && this.acaoEmLote.selecionados.length === 0);
    };
    return IndicioQualidadePesquisaController;
}(AbstractPaginaConsultaController));
IndicioQualidadePesquisaController.$inject = [
    '$stateParams',
    '$location',
    '$timeout',
    '$scope',
    'feedbackService',
    'IndicioQualidadeApiService',
    'IndicioAcaoEmLoteStrategyFactory',
    'documentoApiService',
    'sistemaNegocioApiService',
    'moment'
];
var AcaoEmLote = (function () {
    function AcaoEmLote() {
        this.acaoDesabilitada = true;
        this.selecionados = [];
        this.selecionouItens = false;
        this.selecionouTodos = false;
        this.houveSelecaoDeTodos = false;
        this.removidoDoTodos = [];
    }
    AcaoEmLote.build = function () {
        return new AcaoEmLote();
    };
    return AcaoEmLote;
}());
angular.module('crd').controller('IndicioQualidadePesquisaController', IndicioQualidadePesquisaController);
//# sourceMappingURL=indicio-qualidade-pesquisa-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('indicio-qualidade-pesquisa', {
        controller: 'IndicioQualidadePesquisaController',
        controllerAs: 'indPqrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4021',
            label: 'Pesquisa de indícios de qualidade',
            titulo: 'Pesquisa de indícios de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/indicio-qualidade/indicio-qualidade-pesquisa/indicio-qualidade-pesquisa-tpl.html',
        url: '/indicio-qualidade?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo&grupoPeriodicidade&documentos&sistemasNegocio&idBacen&dataBaseInicio&dataBaseFim&dataBaseFimPeriodoTolerancia&criticas&tipos&situacoes&grupoSituacaoIncidente&protocoloRecebimento'
    })
        .state('indicio-qualidade-detalhar', {
        controller: 'IndicioQualidadeDetalheController',
        controllerAs: 'indDtlCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4022',
            label: 'Detalhar indícios de qualidade',
            titulo: 'Detalhar indícios de qualidade'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/indicio-qualidade/indicio-qualidade-detalhe/indicio-qualidade-detalhe-tpl.html',
        url: '/indicio-qualidade/:pk/detalhar?voltar&voltarParametros'
    });
});
//# sourceMappingURL=indicio-qualidade-route-config.js.map;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .directive('indicioQualidadeSituacaoPrazoAcao', crdAuditoriaDataDirective);

  function crdAuditoriaDataDirective() {
    var directive = {
      link: postLink,
      restrict: 'E',
      scope: {
        situacao: '=',
        data: '=',
      },
      templateUrl: 'views/indicio-qualidade/indicio-qualidade-situacao-prazo-acao-tpl.html'
    };

    return directive;

    function postLink($scope, $element, $attributes) {

    }
  }
})(angular);
;
"use strict";
//# sourceMappingURL=indicio-qualidade-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=indicio-qualidade-para-consultar-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var IndicioQualidadeApiService = (function (_super) {
    __extends(IndicioQualidadeApiService, _super);
    function IndicioQualidadeApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    IndicioQualidadeApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/indicio-qualidade/montar-tela-pesquisa', consultaFiltro);
    };
    IndicioQualidadeApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/indicio-qualidade/pesquisar', consultaFiltro);
    };
    IndicioQualidadeApiService.prototype.relatorioExcel = function (consultaFiltro) {
        return this.baixarArquivo('/indicio-qualidade/relatorio-em-excel', consultaFiltro);
    };
    IndicioQualidadeApiService.prototype.detalhar = function (pk) {
        return this.buscarRecurso("/indicio-qualidade/" + pk + "/detalhar", {});
    };
    IndicioQualidadeApiService.prototype.montarTelaDetalhe = function (pk) {
        return this.detalhar(pk);
    };
    IndicioQualidadeApiService.prototype.downloadAnexo = function (pk) {
        return this.baixarArquivo("/indicio-qualidade/download-anexo/" + pk, {});
    };
    IndicioQualidadeApiService.prototype.paraMudancaEstadoEmLote = function (filtro) {
        return this.buscarRecurso('/indicio-qualidade/para-mudanca-situacao-em-lote', filtro);
    };
    IndicioQualidadeApiService.prototype.mudarEstadoEmLote = function (filtro, dados, anexos) {
        var payload = new FormData();
        payload.append('dados', new Blob([JSON.stringify(dados)], { type: 'application/json;charset=UTF-8' }));
        if (anexos && anexos.length > 0) {
            anexos.forEach(function (anexo) {
                payload.append('anexos', anexo);
            });
        }
        return this.incluirRecurso('/indicio-qualidade/mudar-situacao-em-lote', payload, { params: filtro });
    };
    IndicioQualidadeApiService.prototype.paraIncluirExcecaoEmLote = function (filtro) {
        return this.buscarRecurso('/indicio-qualidade/incluir-excecao-qualidade-lote', filtro);
    };
    IndicioQualidadeApiService.prototype.incluirExcecaoEmLote = function (filtro, dados) {
        return this.incluirRecurso('/indicio-qualidade/incluir-excecao-qualidade', dados, { params: filtro });
    };
    IndicioQualidadeApiService.prototype.paraDesignarResponsavelEmLote = function (filtro) {
        return this.buscarRecurso('/indicio-qualidade/para-designar-responsavel-em-lote', filtro);
    };
    IndicioQualidadeApiService.prototype.designarResponsavelEmLote = function (dados) {
        return this.incluirRecurso('/indicio-qualidade/designar-responsavel-em-lote', dados);
    };
    IndicioQualidadeApiService.prototype.paraDesignarResponsavel = function (pk) {
        return this.buscarRecurso("/indicio-qualidade/" + pk + "/para-designar-responsavel", {});
    };
    IndicioQualidadeApiService.prototype.designarResponsavel = function (dados) {
        return this.incluirRecurso('/indicio-qualidade/designar-responsavel', dados);
    };
    IndicioQualidadeApiService.prototype.paraExecutarAcao = function (pk, acao) {
        return this.buscarRecurso("/indicio-qualidade/" + pk + "/para-executar/" + acao, {});
    };
    IndicioQualidadeApiService.prototype.executarAcao = function (pk, acao, dados, anexos) {
        var payload = new FormData();
        payload.append('acaoIndicio', new Blob([JSON.stringify(dados)], { type: 'application/json;charset=UTF-8' }));
        if (anexos && anexos.length > 0) {
            anexos.forEach(function (anexo) {
                payload.append('anexos', anexo);
            });
        }
        return this.incluirRecurso("/indicio-qualidade/" + pk + "/executar/" + acao, payload);
    };
    IndicioQualidadeApiService.prototype.encerrar = function (pk) {
        return this.incluirRecurso("/indicio-qualidade/" + pk + "/encerrar", {});
    };
    return IndicioQualidadeApiService;
}(AbstractAPISerivce));
IndicioQualidadeApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('IndicioQualidadeApiService', IndicioQualidadeApiService);
//# sourceMappingURL=indicio-qualidade-api-service.js.map;
"use strict";
var TipoIndicioAcaoEmLote = {
    QUESTIONAR: 'QUESTIONAR',
    ENCAMINHAR_VALIDACAO: 'ENCAMINHAR_VALIDACAO',
    ENCAMINHAR_RATIFICACAO: 'ENCAMINHAR_RATIFICACAO',
    DESCONSIDERAR: 'DESCONSIDERAR',
    DESIGNAR_RESPONSAVEL: 'DESIGNAR_RESPONSAVEL',
    CONFIRMAR: 'CONFIRMAR',
    COMUNICAR: 'COMUNICAR',
    ACEITAR_RESPOSTA: 'ACEITAR_RESPOSTA',
    PRORROGAR: 'PRORROGAR',
    REJEITAR_RESPOSTA: 'REJEITAR_RESPOSTA',
    INCLUIR_EXCECAO: 'INCLUIR_EXCECAO'
};
//# sourceMappingURL=indicio-acao-em-lote-strategy-contract.js.map;
"use strict";
var IndicioAcaoEmLoteStrategyFactory = (function () {
    function IndicioAcaoEmLoteStrategyFactory(mudancaSituacaoStrategy, incluirExcecaoStrategy, designarResponsavelStrategy) {
        this.mudancaSituacaoStrategy = mudancaSituacaoStrategy;
        this.incluirExcecaoStrategy = incluirExcecaoStrategy;
        this.designarResponsavelStrategy = designarResponsavelStrategy;
    }
    IndicioAcaoEmLoteStrategyFactory.prototype.obterEstrategia = function (tipoAcao) {
        switch (tipoAcao) {
            case TipoIndicioAcaoEmLote.INCLUIR_EXCECAO:
            case 'INCLUIR_EXCECAO':
                return this.incluirExcecaoStrategy;
            case TipoIndicioAcaoEmLote.DESIGNAR_RESPONSAVEL:
            case 'DESIGNAR_RESPONSAVEL':
                return this.designarResponsavelStrategy;
            default:
                return this.mudancaSituacaoStrategy;
        }
    };
    return IndicioAcaoEmLoteStrategyFactory;
}());
IndicioAcaoEmLoteStrategyFactory.$inject = [
    'IndicioMudancaSituacaoLoteStrategy',
    'IndicioIncluirExcecaoLoteStrategy',
    'IndicioDesignarResponsavelLoteStrategy'
];
angular.module('crd').service('IndicioAcaoEmLoteStrategyFactory', IndicioAcaoEmLoteStrategyFactory);
//# sourceMappingURL=indicio-acao-em-lote-strategy-factory.js.map;
"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var IndicioDesignarResponsavelLoteStrategy = (function () {
    function IndicioDesignarResponsavelLoteStrategy($rootScope, $uibModal, indicioQualidadeApiService, feedbackService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.indicioQualidadeApiService = indicioQualidadeApiService;
        this.feedbackService = feedbackService;
    }
    IndicioDesignarResponsavelLoteStrategy.prototype.executar = function (contexto) {
        var _this = this;
        var filtroLote = this.montarFiltroLote(contexto);
        return this.indicioQualidadeApiService.paraDesignarResponsavelEmLote(filtroLote).then(function (response) {
            if (!response.data || response.data.indiciosSelecionadosEmLote < 1) {
                _this.feedbackService.erro('Não existe indício para executar esta ação.');
                return false;
            }
            _this.feedbackService.limpar();
            var modalScope = _this.$rootScope.$new();
            modalScope.paraDesignarResponsavelEmLote = response.data;
            modalScope.filtro = filtroLote;
            return _this.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/indicio-qualidade/indicio-modal-acoes/indicio-modal-designar-responsavel-em-lote-tpl.html',
                controller: 'IndicioModalDesignarResponsavelEmLoteController',
                controllerAs: 'indicioModalDesignarResponsavelEmLoteController',
                bindToController: true,
                keyboard: true,
                size: 'lg',
                scope: modalScope
            }).result.then(function () { return true; }, function () { return false; });
        });
    };
    IndicioDesignarResponsavelLoteStrategy.prototype.montarFiltroLote = function (contexto) {
        var filtro = __assign({}, contexto.filtroConsulta);
        filtro.houveSelecaoDeTodos = contexto.acaoEmLote.houveSelecaoDeTodos;
        filtro.indiciosPk = contexto.acaoEmLote.houveSelecaoDeTodos
            ? contexto.acaoEmLote.removidoDoTodos
            : contexto.acaoEmLote.selecionados;
        return filtro;
    };
    return IndicioDesignarResponsavelLoteStrategy;
}());
IndicioDesignarResponsavelLoteStrategy.$inject = ['$rootScope', '$uibModal', 'IndicioQualidadeApiService', 'feedbackService'];
angular.module('crd').service('IndicioDesignarResponsavelLoteStrategy', IndicioDesignarResponsavelLoteStrategy);
//# sourceMappingURL=indicio-designar-responsavel-lote-strategy.js.map;
"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var IndicioIncluirExcecaoLoteStrategy = (function () {
    function IndicioIncluirExcecaoLoteStrategy($rootScope, $uibModal, indicioQualidadeApiService, feedbackService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.indicioQualidadeApiService = indicioQualidadeApiService;
        this.feedbackService = feedbackService;
    }
    IndicioIncluirExcecaoLoteStrategy.prototype.executar = function (contexto) {
        var _this = this;
        var filtroLote = this.montarFiltroLote(contexto);
        return this.indicioQualidadeApiService.paraIncluirExcecaoEmLote(filtroLote).then(function (response) {
            if (!response.data || response.data.quantidadeIndiciosImpactados < 1) {
                _this.feedbackService.erro('Não existe indício para executar esta ação.');
                return false;
            }
            _this.feedbackService.limpar();
            var modalScope = _this.$rootScope.$new();
            modalScope.paraIncluir = response.data;
            modalScope.paraIncluir.filtro = filtroLote;
            return _this.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/indicio-qualidade/indicio-modal-acoes/indicio-modal-incluir-excecao-em-lote-tpl.html',
                controller: 'IndicioModalIncluirExcecaoEmLoteController',
                controllerAs: 'indicioIncluirExcecaoEmLoteCtrl',
                bindToController: true,
                keyboard: true,
                size: 'lg',
                scope: modalScope
            }).result.then(function () { return true; }, function () { return false; });
        });
    };
    IndicioIncluirExcecaoLoteStrategy.prototype.montarFiltroLote = function (contexto) {
        var filtro = __assign({}, contexto.filtroConsulta);
        filtro.tipoMudanca = 'DESCONSIDERADO';
        filtro.houveSelecaoDeTodos = contexto.acaoEmLote.houveSelecaoDeTodos;
        filtro.indiciosPk = contexto.acaoEmLote.houveSelecaoDeTodos
            ? contexto.acaoEmLote.removidoDoTodos
            : contexto.acaoEmLote.selecionados;
        return filtro;
    };
    return IndicioIncluirExcecaoLoteStrategy;
}());
IndicioIncluirExcecaoLoteStrategy.$inject = ['$rootScope', '$uibModal', 'IndicioQualidadeApiService', 'feedbackService'];
angular.module('crd').service('IndicioIncluirExcecaoLoteStrategy', IndicioIncluirExcecaoLoteStrategy);
//# sourceMappingURL=indicio-incluir-excecao-lote-strategy.js.map;
"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var IndicioMudancaSituacaoLoteStrategy = (function () {
    function IndicioMudancaSituacaoLoteStrategy($rootScope, $uibModal, indicioQualidadeApiService, feedbackService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.indicioQualidadeApiService = indicioQualidadeApiService;
        this.feedbackService = feedbackService;
    }
    IndicioMudancaSituacaoLoteStrategy.prototype.executar = function (contexto) {
        var _this = this;
        var filtroLote = this.montarFiltroLote(contexto);
        return this.indicioQualidadeApiService.paraMudancaEstadoEmLote(filtroLote).then(function (response) {
            if (!response.data || response.data.quantidadeIndiciosImpactados < 1) {
                _this.feedbackService.erro('Não existe indício para executar esta ação.');
                return false;
            }
            _this.feedbackService.limpar();
            var modalScope = _this.$rootScope.$new();
            modalScope.paraMudanca = response.data;
            modalScope.filtro = filtroLote;
            modalScope.indicios = contexto.itensPagina || [];
            return _this.$uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                templateUrl: 'views/indicio-qualidade/indicio-modal-acoes/indicio-modal-mudanca-situacao-lote-tpl.html',
                controller: 'IndicioModalMudancaSituacaoLoteController',
                controllerAs: 'indicioModalMudancaSituacaoLoteController',
                bindToController: true,
                keyboard: true,
                size: 'lg',
                scope: modalScope
            }).result.then(function () { return true; }, function () { return false; });
        });
    };
    IndicioMudancaSituacaoLoteStrategy.prototype.montarFiltroLote = function (contexto) {
        var filtro = __assign({}, contexto.filtroConsulta);
        filtro.tipoMudanca = contexto.tipoAcao;
        filtro.houveSelecaoDeTodos = contexto.acaoEmLote.houveSelecaoDeTodos;
        filtro.indiciosPk = contexto.acaoEmLote.houveSelecaoDeTodos
            ? contexto.acaoEmLote.removidoDoTodos
            : contexto.acaoEmLote.selecionados;
        return filtro;
    };
    return IndicioMudancaSituacaoLoteStrategy;
}());
IndicioMudancaSituacaoLoteStrategy.$inject = ['$rootScope', '$uibModal', 'IndicioQualidadeApiService', 'feedbackService'];
angular.module('crd').service('IndicioMudancaSituacaoLoteStrategy', IndicioMudancaSituacaoLoteStrategy);
//# sourceMappingURL=indicio-mudanca-situacao-lote-strategy.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider.state("nao-autorizado", {
        controller: "NaoAutorizadoCtrl",
        controllerAs: "vm",
        informacaoPagina: {
            codigo: "CRDFW0000",
            label: "Acesso não autorizado",
            titulo: "Acesso não autorizado"
        },
        parent: "admin",
        templateUrl: "views/nao-autorizado/nao-autorizado.html",
        url: "/401"
    });
});
//# sourceMappingURL=nao-autorizado-route-config.js.map;
"use strict";
var NaoAutorizadoCtrl = (function () {
    function NaoAutorizadoCtrl($http, $window, $rootScope) {
        this.$http = $http;
        this.$window = $window;
        this.$rootScope = $rootScope;
    }
    NaoAutorizadoCtrl.prototype.$onInit = function () {
        this.$rootScope['paginaNaoAutorizado'] = true;
    };
    NaoAutorizadoCtrl.prototype.$onDestroy = function () {
        this.$rootScope['paginaNaoAutorizado'] = false;
    };
    NaoAutorizadoCtrl.prototype.sair = function () {
        var _this = this;
        this.$http.post('/crd/logout', null)["finally"](function () {
            _this.$window.location.href = '/crd/rest/dologin';
        });
    };
    NaoAutorizadoCtrl.prototype.voltar = function () {
        this.$window.location.href = '/crd/rest/dologin';
    };
    return NaoAutorizadoCtrl;
}());
NaoAutorizadoCtrl.$inject = ['$http', '$window', '$rootScope'];
angular.module('crd').controller('NaoAutorizadoCtrl', NaoAutorizadoCtrl);
//# sourceMappingURL=NaoAutorizadoCtrl.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('painel-administrativo-deinf', {
        parent: 'admin',
        templateUrl: 'views/painel-administrativo-deinf/views/painel-administrativo-deinf-tpl.html',
        url: '/painel-administrativo-deinf'
    })
        .state('painel-administrativo-deinf.dados-gerais', {
        controller: 'PainelAdministrativoDeinfDadosGeraisController',
        controllerAs: 'painelAdministrativoDeinfDadosGeraisCtrl',
        informacaoPagina: {
            codigo: 'CRD999999',
            label: 'Painel administrativo DEINF',
            titulo: 'Painel administrativo DEINF',
            outros: {
                activeTab: 'painel-administrativo-deinf.dados-gerais'
            }
        },
        parent: 'painel-administrativo-deinf',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-administrativo-deinf/views/painel-administrativo-deinf-dados-gerais-tpl.html',
        url: '/dados-gerais'
    });
});
//# sourceMappingURL=painel-administrativo-deinf-route-config.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var PainelAdministrativoDeinfApiService = (function (_super) {
    __extends(PainelAdministrativoDeinfApiService, _super);
    function PainelAdministrativoDeinfApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    PainelAdministrativoDeinfApiService.prototype.dadosGerais = function (id) {
        return this.buscarRecurso("/painel-administrativo/dados-gerais", {});
    };
    return PainelAdministrativoDeinfApiService;
}(AbstractAPISerivce));
PainelAdministrativoDeinfApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('PainelAdministrativoDeinfApiService', PainelAdministrativoDeinfApiService);
//# sourceMappingURL=painel-administrativo-deinf-api-service.js.map;
"use strict";
var PainelAdministrativoDeinfDadosGeraisController = (function () {
    function PainelAdministrativoDeinfDadosGeraisController($state, painelAdministrativoDeinfApiService) {
        this.$state = $state;
        this.painelAdministrativoDeinfApiService = painelAdministrativoDeinfApiService;
    }
    PainelAdministrativoDeinfDadosGeraisController.prototype.$onInit = function () {
        var _this = this;
        return this.painelAdministrativoDeinfApiService.dadosGerais(this.$state.params.id).then(function (response) {
            _this.item = response.data;
        });
    };
    ;
    return PainelAdministrativoDeinfDadosGeraisController;
}());
PainelAdministrativoDeinfDadosGeraisController.$inject = ['$state', 'PainelAdministrativoDeinfApiService'];
angular.module('crd').controller('PainelAdministrativoDeinfDadosGeraisController', PainelAdministrativoDeinfDadosGeraisController);
//# sourceMappingURL=painel-administrativo-deinf-dados-gerais-controller.js.map;
"use strict";
var PainelAuditoriaObservanciaController = (function () {
    function PainelAuditoriaObservanciaController($location, $scope, $state, painelAuditoriaObservanciaApiService, feedbackService, moment) {
        this.$location = $location;
        this.$scope = $scope;
        this.$state = $state;
        this.painelAuditoriaObservanciaApiService = painelAuditoriaObservanciaApiService;
        this.feedbackService = feedbackService;
        this.moment = moment;
        this.cores = ['#b2d3e6', '#b2d3e6', '#b2d3e6', '#b2d3e6', '#b2d3e6', '#b2d3e6'];
        this.dataAtual = this.moment.utc().format("YYYY-MM-DD");
        this.data3MesesAtras = this.moment.utc().subtract(3, 'months').format("YYYY-MM-DD");
        this.dataInicioUltimos3Meses = this.moment.utc().subtract(3, 'months').format("YYYY-MM-DD");
        this.dataFimUltimos3Meses = this.moment.utc().subtract(1, 'days').format("YYYY-MM-DD");
        this.data11MesesAtras = this.moment.utc().subtract(11, 'months').format("YYYY-MM-DD");
        this.dataInicioUltimos12Meses = this.moment.utc().subtract(12, 'months').startOf('month').format("YYYY-MM-DD");
        this.dataFimUltimos12Meses = this.moment.utc().subtract(1, 'months').endOf('month').format("YYYY-MM-DD");
        this.data13MesesAtras = this.moment.utc().subtract(13, 'months').format("YYYY-MM-DD");
    }
    PainelAuditoriaObservanciaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params.idbacen);
    };
    ;
    PainelAuditoriaObservanciaController.prototype.carregarDadosTela = function (idbacen) {
        var _this = this;
        this.idBacenAtual = idbacen;
        this.telaRetornoPainel = this.$state.params.telaRetornoPainel;
        this.painelAuditoriaObservanciaApiService.montarPainel(idbacen).then(function (painelAuditoriaObservanciaResource) {
            _this.painel = painelAuditoriaObservanciaResource;
            _this.graficos = {
                irfi: _this.transformarDadosGraficoParaIndice(painelAuditoriaObservanciaResource.indicePainelIrfi),
                iqfi: _this.transformarDadosGraficoParaIndice(painelAuditoriaObservanciaResource.indicePainelIqfi),
                atrasoMenorQueMensal: _this.transformarDadosGraficoParaAtraso(painelAuditoriaObservanciaResource.atrasoMenorQueMensal),
                atrasoMensalOuMaior: _this.transformarDadosGraficoParaAtraso(painelAuditoriaObservanciaResource.atrasoMensalOuMaior)
            };
            return painelAuditoriaObservanciaResource;
        });
    };
    PainelAuditoriaObservanciaController.prototype.optionsGraficoLinhaParaIndice = function () {
        return {
            elements: {
                line: {
                    fill: true,
                    tension: 0
                },
                point: {
                    radius: 6,
                    hoverRadius: 4
                }
            },
            scales: {
                yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel: {
                            display: true
                        }
                    }],
                xAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel: {
                            display: true
                        }
                    }]
            },
            tooltips: {
                mode: 'x',
                displayColors: false,
                callbacks: {
                    title: function (tooltipItem, data) { return ""; },
                    label: function (tooltipItem, data) { return tooltipItem.yLabel.toFixed(2); }
                }
            }
        };
    };
    PainelAuditoriaObservanciaController.prototype.transformarDadosGraficoParaIndice = function (indicesPainel) {
        return {
            data: [_.map(indicesPainel, _.property('valor'))],
            labels: _.map(indicesPainel, _.property('dataBaseFormatada')),
            opcoes: this.optionsGraficoLinhaParaIndice(),
            cores: this.cores,
            exibirGrafico: this.possuiRegistros(indicesPainel)
        };
    };
    PainelAuditoriaObservanciaController.prototype.optionsGraficoBarraParaAtraso = function (valorMaximoEixoY, escalaEixoY) {
        return {
            scales: {
                yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            max: valorMaximoEixoY,
                            stepSize: escalaEixoY
                        },
                        scaleLabel: {
                            display: true,
                            labelString: "Quantidade"
                        }
                    }],
                xAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel: {
                            display: true,
                            labelString: "Documentos"
                        }
                    }]
            },
            tooltips: {
                mode: 'x',
                displayColors: false,
                callbacks: {
                    title: function (tooltipItem, data) { return ""; },
                    label: function (tooltipItem, data) { return tooltipItem.yLabel; }
                }
            }
        };
    };
    PainelAuditoriaObservanciaController.prototype.transformarDadosGraficoParaAtraso = function (atrasosPainel) {
        var _this = this;
        var listaQuantidades = _.map(atrasosPainel, 'quantidade');
        var maiorValorColuna = Number(_.max(listaQuantidades) || 0);
        var valorMaximoEixoY = this.obterValorMaximoEixoY(maiorValorColuna);
        var escalaEixoY = this.obterEscalaEixoY(valorMaximoEixoY);
        return {
            data: [listaQuantidades],
            labels: _.map(atrasosPainel, function (atraso) { return _this.obterLabelDocumentoAtraso(atraso); }),
            opcoes: this.optionsGraficoBarraParaAtraso(valorMaximoEixoY, escalaEixoY),
            cores: this.cores,
            exibirGrafico: this.possuiRegistros(atrasosPainel)
        };
    };
    PainelAuditoriaObservanciaController.prototype.obterValorMaximoEixoY = function (maiorValorColuna) {
        if (!maiorValorColuna || maiorValorColuna <= 0) {
            return 1;
        }
        if (maiorValorColuna < 10) {
            return Math.ceil(maiorValorColuna * 11 / 5) * 0.5;
        }
        if (maiorValorColuna < 20) {
            return Math.ceil(maiorValorColuna * 11 / 20) * 2;
        }
        return Math.ceil(maiorValorColuna * 11 / 50) * 5;
    };
    PainelAuditoriaObservanciaController.prototype.obterEscalaEixoY = function (valorMaximoEixoY) {
        if (valorMaximoEixoY < 6) {
            return 0.5;
        }
        if (valorMaximoEixoY < 25) {
            return 2;
        }
        if (valorMaximoEixoY < 50) {
            return 5;
        }
        return 10;
    };
    PainelAuditoriaObservanciaController.prototype.obterLabelDocumentoAtraso = function (atraso) {
        var codigoDocumentoFormatado = this.removerEspacos(atraso.codigoDocumentoFormatado);
        if (codigoDocumentoFormatado) {
            return codigoDocumentoFormatado;
        }
        var siglaSistemaNegocio = this.removerEspacos(atraso.siglaSistemaNegocio);
        var codigoDocumento = this.removerEspacos(atraso.codigoDocumento);
        if (siglaSistemaNegocio && codigoDocumento) {
            return siglaSistemaNegocio + ' - ' + codigoDocumento;
        }
        return codigoDocumento;
    };
    PainelAuditoriaObservanciaController.prototype.removerEspacos = function (valor) {
        return valor ? valor.trim() : '';
    };
    PainelAuditoriaObservanciaController.prototype.formatarData = function (data, formato) {
        return this.moment(data).format(formato);
    };
    PainelAuditoriaObservanciaController.prototype.possuiRegistros = function (lista) {
        return !_.isNull(lista) && _.isArray(lista) && !_.isEmpty(lista);
    };
    PainelAuditoriaObservanciaController.prototype.voltar = function () {
        this.$state.go(this.telaRetornoPainel);
    };
    return PainelAuditoriaObservanciaController;
}());
PainelAuditoriaObservanciaController.$inject = ['$location', '$scope', '$state', 'PainelAuditoriaObservanciaApiService', 'feedbackService', 'moment'];
angular.module('crd').controller('PainelAuditoriaObservanciaController', PainelAuditoriaObservanciaController);
//# sourceMappingURL=painel-auditoria-observancia-controller.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-comunicacoes-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-conglomerado-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-cooperativa-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-dados-gerais-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-diretoria-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-documento-com-qualidade-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-documentos-em-atraso-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-documentos-em-atraso-modal-dar-ciencia-supervisor-dados-para-envio-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-documentos-em-atraso-modal-dar-ciencia-supervisor-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-documentos-em-atraso-modal-detalhe-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-responsaveis-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-aba-supervisao-dto.js.map;
"use strict";
//# sourceMappingURL=painel-entidade-supervisionada-dto.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('painel-entidade-supervisionada', {
        controller: 'PainelEntidadeSupervisionadaController',
        controllerAs: 'painelEntidadeSupervisionadaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Painel entidade supervisionada',
            titulo: 'Painel entidade supervisionada'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-tpl.html',
        url: '/painel-entidade-supervisionada/:idbacen'
    })
        .state('painel-entidade-supervisionada.conglomerado', {
        controller: 'PainelEntidadeSupervisionadaAbaConglomeradoController',
        controllerAs: 'painelEntidadeSupervisionadaAbaConglomeradoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.conglomerado'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-conglomerado-tpl.html',
        url: '/conglomerado'
    })
        .state('painel-entidade-supervisionada.cooperativa', {
        controller: 'PainelEntidadeSupervisionadaAbaCooperativaController',
        controllerAs: 'painelEntidadeSupervisionadaAbaCooperativaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.cooperativa'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-cooperativa-tpl.html',
        url: '/cooperativa'
    })
        .state('painel-entidade-supervisionada.dados-gerais', {
        controller: 'PainelEntidadeSupervisionadaAbaDadosGeraisController',
        controllerAs: 'painelEntidadeSupervisionadaAbaDadosGeraisCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.dados-gerais'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-dados-gerais-tpl.html',
        url: '/dados-gerais'
    })
        .state('painel-entidade-supervisionada.documento-com-qualidade', {
        controller: 'PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController',
        controllerAs: 'painelEntidadeSupervisionadaAbaDocumentoComQualidadeCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.documento-com-qualidade'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-documento-com-qualidade-tpl.html',
        url: '/documento-com-qualidade?texto&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('painel-entidade-supervisionada.supervisao', {
        controller: 'PainelEntidadeSupervisionadaAbaSupervisaoController',
        controllerAs: 'painelEntidadeSupervisionadaAbaSupervisaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.supervisao'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-supervisao-tpl.html',
        url: '/supervisao'
    })
        .state('painel-entidade-supervisionada.diretoria', {
        controller: 'PainelEntidadeSupervisionadaAbaDiretoriaController',
        controllerAs: 'painelEntidadeSupervisionadaAbaDiretoriaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.diretoria'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-diretoria-tpl.html',
        url: '/diretoria'
    })
        .state('painel-entidade-supervisionada.responsaveis', {
        controller: 'PainelEntidadeSupervisionadaAbaResponsaveisController',
        controllerAs: 'painelEntidadeSupervisionadaAbaResponsaveisCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.responsaveis'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-responsaveis-tpl.html',
        url: '/responsaveis?texto&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('painel-entidade-supervisionada.comunicacoes', {
        controller: 'PainelEntidadeSupervisionadaAbaComunicacoesController',
        controllerAs: 'painelEntidadeSupervisionadaAbaComunicacoesCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.comunicacoes'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-comunicacoes-tpl.html',
        url: '/comunicacoes?texto&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('painel-entidade-supervisionada.documentos-em-atraso', {
        controller: 'PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController',
        controllerAs: 'painelEntidadeSupervisionadaAbaDocumentosEmAtrasoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Entidade supervisionada',
            titulo: 'Entidade supervisionada',
            outros: {
                activeTab: 'painel-entidade-supervisionada.documentos-em-atraso'
            }
        },
        parent: 'painel-entidade-supervisionada',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada/painel-entidade-supervisionada-aba-documentos-em-atraso-tpl.html',
        url: '/documentosematraso?texto&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    });
});
//# sourceMappingURL=painel-entidade-supervisionada-router-config.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var PainelEntidadeSupervisionadaApiService = (function (_super) {
    __extends(PainelEntidadeSupervisionadaApiService, _super);
    function PainelEntidadeSupervisionadaApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    PainelEntidadeSupervisionadaApiService.prototype.paraConsultar = function () {
        return this.buscarRecurso('/painel-entidade-supervisionada/para-consultar');
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscar = function (id) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id, {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaConglomerado = function (id) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-conglomerado", {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaCooperativa = function (id) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-cooperativa", {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaDadosGerais = function (id) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-dados-gerais", {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaDiretoria = function (id) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-diretoria", {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaDocumentoComQualidade = function (id, consultaFiltro) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-documento-com-qualidade", consultaFiltro);
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaResponsaveis = function (id) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-responsaveis", {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaSupervisao = function (id) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-supervisao", {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaComunicacoes = function (id, consultaFiltro) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-comunicacoes", consultaFiltro);
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaDocumentosEmAtraso = function (id, consultaFiltro) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-documentos-em-atraso", consultaFiltro);
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarAbaDocumentosEmAtrasoDetalhar = function (id, documentoemAtrasoId) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-documentos-em-atraso/" + documentoemAtrasoId + "/detalhar", {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.buscarModalDocumentosEmAtrasoDarCienciaSupervisor = function (id, resultadoDetalhado) {
        return this.buscarRecurso("/painel-entidade-supervisionada/" + id + "/aba-documentos-em-atraso/para-dar-ciencia-supervisor?resultadoDetalhado=" + resultadoDetalhado, {});
    };
    PainelEntidadeSupervisionadaApiService.prototype.enviarDadosParaDarCienciaSupervisor = function (dadosParaEnvio) {
        return this.incluirRecurso("/painel-entidade-supervisionada/aba-documentos-em-atraso/dar-ciencia-supervisor", dadosParaEnvio);
    };
    return PainelEntidadeSupervisionadaApiService;
}(AbstractAPISerivce));
PainelEntidadeSupervisionadaApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('PainelEntidadeSupervisionadaApiService', PainelEntidadeSupervisionadaApiService);
//# sourceMappingURL=painel-entidade-supervisionada-api-service.js.map;
"use strict";
var CrdModalIncluirNovaEntidadeSupervisionadaController = (function () {
    function CrdModalIncluirNovaEntidadeSupervisionadaController($uibModal) {
        this.$uibModal = $uibModal;
    }
    CrdModalIncluirNovaEntidadeSupervisionadaController.prototype.abrirModal = function () {
        var _self = this;
        this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: this.templateUrl,
            controller: 'CrdModalIncluirNovaEntidadeSupervisionadaModalController',
            controllerAs: 'crdModalIncluirNovaEntidadeSupervisionadaModalCtl',
            bindToController: true,
            keyboard: true,
            size: this.size || 'lg'
        });
    };
    CrdModalIncluirNovaEntidadeSupervisionadaController.prototype.$onInit = function () { };
    return CrdModalIncluirNovaEntidadeSupervisionadaController;
}());
CrdModalIncluirNovaEntidadeSupervisionadaController.$inject = ['$uibModal'];
angular.module('crd').controller('CrdModalIncluirNovaEntidadeSupervisionadaController', CrdModalIncluirNovaEntidadeSupervisionadaController);
//# sourceMappingURL=crd-modal-incluir-nova-entidade-supervisionada-controller.js.map;
"use strict";
var CrdModalIncluirNovaEntidadeSupervisionadaDirective = (function () {
    function CrdModalIncluirNovaEntidadeSupervisionadaDirective() {
        this.controller = 'CrdModalIncluirNovaEntidadeSupervisionadaController';
        this.controllerAs = 'crdModalIncluirNovaEntidadeSupervisionadaCtlr';
        this.name = 'crdModalIncluirNovaEntidadeSupervisionada';
        this.priority = 0;
        this.require = ['crdModalIncluirNovaEntidadeSupervisionada'];
        this.restrict = 'E';
        this.scope = {
            size: '@',
            templateUrl: '@'
        };
        this.bindToController = true;
        this.templateUrl = 'views/painel-entidade-supervisionada/views/crd-modal-incluir-nova-entidade-supervisionada/crd-modal-incluir-nova-entidade-supervisionada-tpl.html';
    }
    CrdModalIncluirNovaEntidadeSupervisionadaDirective.prototype.link = function (scope, element, attributes, controller, transclude) {
        var crdModalIncluirNovaEntidadeSupervisionadaCtlr = controller[0];
    };
    CrdModalIncluirNovaEntidadeSupervisionadaDirective.instance = function () {
        return new CrdModalIncluirNovaEntidadeSupervisionadaDirective();
    };
    return CrdModalIncluirNovaEntidadeSupervisionadaDirective;
}());
CrdModalIncluirNovaEntidadeSupervisionadaDirective.$inject = [];
angular.module('crd').directive('crdModalIncluirNovaEntidadeSupervisionada', CrdModalIncluirNovaEntidadeSupervisionadaDirective.instance);
//# sourceMappingURL=crd-modal-incluir-nova-entidade-supervisionada-directive.js.map;
"use strict";
var CrdModalIncluirNovaEntidadeSupervisionadaModalController = (function () {
    function CrdModalIncluirNovaEntidadeSupervisionadaModalController($uibModalInstance, $state, feedbackService, entidadeSupervisionadaApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.entidadeSupervisionadaApiService = entidadeSupervisionadaApiService;
        this.novaInstituicao = "";
        this.definicoesMascara = {
            maskDefinitions: {
                'A': /[zZ]/
            }
        };
    }
    CrdModalIncluirNovaEntidadeSupervisionadaModalController.prototype.cancelar = function () {
        this.fecharInclusao(false);
        this.limparEFechar();
    };
    CrdModalIncluirNovaEntidadeSupervisionadaModalController.prototype.fecharInclusao = function (deveLimparFeedback) {
        this.novaInstituicao = "";
        if (deveLimparFeedback) {
            this.limparEFechar();
        }
    };
    CrdModalIncluirNovaEntidadeSupervisionadaModalController.prototype.limparEFechar = function () {
        this.feedbackService.limpar();
        this.$uibModalInstance.dismiss('cancel');
    };
    CrdModalIncluirNovaEntidadeSupervisionadaModalController.prototype.salvarNova = function (idBacen) {
        var _this = this;
        if (idBacen === "") {
            return;
        }
        var dados = {
            idBacen: idBacen
        };
        return this.entidadeSupervisionadaApiService.incluir(dados).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Entidade supervisionada incluída com sucesso!');
                _this.fecharInclusao(false);
            }
        });
    };
    CrdModalIncluirNovaEntidadeSupervisionadaModalController.prototype.idBacenInvalido = function () {
        var regex = /([zZ]\d{7})/g;
        return !regex.test(this.novaInstituicao);
    };
    CrdModalIncluirNovaEntidadeSupervisionadaModalController.prototype.$onInit = function () { };
    return CrdModalIncluirNovaEntidadeSupervisionadaModalController;
}());
CrdModalIncluirNovaEntidadeSupervisionadaModalController.$inject = ['$uibModalInstance', '$state', 'feedbackService', 'EntidadeSupervisionadaApiService'];
angular.module('crd').controller('CrdModalIncluirNovaEntidadeSupervisionadaModalController', CrdModalIncluirNovaEntidadeSupervisionadaModalController);
//# sourceMappingURL=crd-modal-incluir-nova-entidade-supervisionada-modal-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaModalDarCienciaSupervisorController = (function () {
    function PainelEntidadeSupervisionadaModalDarCienciaSupervisorController($uibModalInstance, feedbackService, painelEntidadeSupervisionadaApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.feedbackService = feedbackService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
        this.documentoIdsSelecionados = [];
        this.selecionarTodosResumidos = false;
        this.selecionarTodosDetalhados = false;
        this.deveDesabilitarBotaoEnviar = false;
    }
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.$onInit = function () {
        this.tabelaSelecionada = 'RESUMIDO';
        this.buscarDocumentos(this.selecionarTodosDetalhados);
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.buscarDocumentos = function (resultadoDetalhado) {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarModalDocumentosEmAtrasoDarCienciaSupervisor(this.idbacen, resultadoDetalhado)
            .then(function (response) {
            if (response.data) {
                if (_this.item) {
                    _this.item.documentosEmAtrasoDetalhados = response.data.documentosEmAtrasoDetalhados;
                }
                else {
                    _this.item = response.data;
                }
                _this.checarSeVeioDado();
                _this.textoEmailDarCienciaSupervisor = response.data.textoEmailDarCienciaSupervisor;
            }
        })["catch"](function (error) {
            _this.checarSeVeioDado();
            _this.cancel();
            _this.feedbackService.violacoes(error.data);
        });
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.checarSeVeioDado = function () {
        if ((!this.item.documentosEmAtrasoDetalhados || this.item.documentosEmAtrasoDetalhados.size == 0)
            && (!this.item.documentosEmAtrasoResumidos || this.item.documentosEmAtrasoResumidos.size == 0)) {
            this.deveDesabilitarBotaoEnviar = true;
        }
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.submit = function () {
        this.documentoIdsSelecionados = [];
        this.documentoIdsSelecionados = this.filtrarIdsSelecionadosPelaTabelaSelecionada();
        if (this.documentoIdsSelecionados && this.documentoIdsSelecionados.length > 0) {
            this.prepararParaEnvio();
        }
        else {
            this.cancel();
            this.feedbackService.alerta('Selecione pelo menos um documento para dar ciência ao supervisor!');
        }
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.prepararParaEnvio = function () {
        var _this = this;
        var dadosParaEnvio = {
            documentosNaoEntregue: this.documentoIdsSelecionados,
            idBacen: this.idbacen.toString(),
            resultadoDetalhado: this.tabelaSelecionada == 'RESUMIDO' ? false : true,
            textoAdicionalEmail: this.textoAdicionalEmail
        };
        this.painelEntidadeSupervisionadaApiService.enviarDadosParaDarCienciaSupervisor(dadosParaEnvio)
            .then(function (response) {
            _this.cancel();
            _this.feedbackService.sucesso('Comunicação enviada com sucesso ao supervisor!');
        })["catch"](function (error) { _this.feedbackService.error("Erro ao enviar a comunicação ao supervisor."); });
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.filtrarIdsSelecionadosPelaTabelaSelecionada = function () {
        return this.tabelaSelecionada == 'RESUMIDO' ?
            this.filtrarIdsSelecionados(this.item.documentosEmAtrasoResumidos) :
            this.filtrarIdsSelecionados(this.item.documentosEmAtrasoDetalhados);
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.filtrarIdsSelecionados = function (listaItem) {
        return listaItem.filter(function (i) { return i.selecionado; }).map(function (b) { return b.documentoId; });
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.processarCheckTipoResultado = function (valor) {
        this.tabelaSelecionada == valor;
        this.item.resultadoDetalhado = this.tabelaSelecionada == 'RESUMIDO' ? false : true;
        if (this.tabelaSelecionada == 'DETALHADO' && !this.item.documentosEmAtrasoDetalhados) {
            this.buscarDocumentos(this.item.resultadoDetalhado);
        }
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.selecionarTodos = function (itemId) {
        if (this.tabelaSelecionada == "RESUMIDO") {
            this.tratarResumidos();
        }
        else {
            this.tratarDetalhados();
        }
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.tratarResumidos = function () {
        if (this.selecionarTodosResumidos) {
            this.selecionarTodosResumidos = false;
            this.tratarItens(this.item.documentosEmAtrasoResumidos, false);
        }
        else {
            this.selecionarTodosResumidos = true;
            this.tratarItens(this.item.documentosEmAtrasoResumidos, true);
        }
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.tratarDetalhados = function () {
        if (this.selecionarTodosDetalhados) {
            this.selecionarTodosDetalhados = false;
            this.tratarItens(this.item.documentosEmAtrasoDetalhados, false);
        }
        else {
            this.selecionarTodosDetalhados = true;
            this.tratarItens(this.item.documentosEmAtrasoDetalhados, true);
        }
    };
    PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.prototype.tratarItens = function (listaItem, novoValor) {
        listaItem.map(function (i) { return i.selecionado = novoValor; });
    };
    return PainelEntidadeSupervisionadaModalDarCienciaSupervisorController;
}());
PainelEntidadeSupervisionadaModalDarCienciaSupervisorController.$inject = ['$uibModalInstance', 'feedbackService', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaModalDarCienciaSupervisorController', PainelEntidadeSupervisionadaModalDarCienciaSupervisorController);
//# sourceMappingURL=painel-entidade-supervisionada-modal-dar-ciencia-supervisor-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController = (function () {
    function PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController($uibModalInstance, painelEntidadeSupervisionadaApiService) {
        this.$uibModalInstance = $uibModalInstance;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController.prototype.$onInit = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarAbaDocumentosEmAtrasoDetalhar(this.idbacen, this.id).then(function (response) {
            _this.item = response.data;
        });
    };
    PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    return PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController;
}());
PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController.$inject = ['$uibModalInstance', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController', PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController);
//# sourceMappingURL=painel-entidade-supervisionada-modal-detalhe-documentos-em-atraso-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaComunicacoesController = (function () {
    function PainelEntidadeSupervisionadaAbaComunicacoesController($state, $scope, feedbackService, locationService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.locationService = locationService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaComunicacoesController.prototype.$onInit = function () {
        this.dadosFormulario = {
            texto: this.$state.params.texto
        };
        this.navegarNaGrid(this.dadosFormulario, {
            number: ConverterParameterUrlToObjectUtils.number(this.$state.params.numeroPagina),
            size: ConverterParameterUrlToObjectUtils.number(this.$state.params.quantidadePorPagina),
            sortField: this.$state.params.ordenacaoCampo,
            sortDirection: this.$state.params.ordenacaoDirecao
        });
    };
    PainelEntidadeSupervisionadaAbaComunicacoesController.prototype.navegarNaGrid = function (dadosFormulario, pagination) {
        var _this = this;
        var consultaFiltro = {
            texto: ConverterParameterObjectToUrlUtils.string(dadosFormulario.texto),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(pagination.number),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(pagination.size),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(pagination.sortField),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(pagination.sortDirection)
        };
        this.locationService.search(consultaFiltro);
        this.painelEntidadeSupervisionadaApiService.buscarAbaComunicacoes(this.$state.params.idbacen, consultaFiltro).then(function (response) {
            _this.item = response.data;
        });
    };
    PainelEntidadeSupervisionadaAbaComunicacoesController.prototype.observerChangeDadosFormulario = function (dadosFormulario) {
        this.navegarNaGrid(dadosFormulario, { number: 0, size: this.$state.params.quantidadePorPagina });
    };
    return PainelEntidadeSupervisionadaAbaComunicacoesController;
}());
PainelEntidadeSupervisionadaAbaComunicacoesController.$inject = ['$state', '$scope', 'feedbackService', '$location', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaComunicacoesController', PainelEntidadeSupervisionadaAbaComunicacoesController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-comunicacoes-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaConglomeradoController = (function () {
    function PainelEntidadeSupervisionadaAbaConglomeradoController($state, $scope, feedbackService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
        this.exibirTodos = false;
    }
    PainelEntidadeSupervisionadaAbaConglomeradoController.prototype.$onInit = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarAbaConglomerado(this.$state.params.idbacen).then(function (response) {
            _this.item = response.data;
            if (_this.item) {
                _this.item.conglomerados.forEach(function (conglomerado) {
                    _this.navegarNaGridParticipante(conglomerado, {}, { number: 0, size: conglomerado.participantes.length });
                });
            }
        });
    };
    PainelEntidadeSupervisionadaAbaConglomeradoController.prototype.navegarNaGridParticipante = function (conglomerado, dadosFormulario, pagination) {
        this.sortItems(conglomerado.participantes, pagination);
        conglomerado.paginaParticipante = new Pagina(conglomerado.participantes, conglomerado.participantes.length, pagination.number || 0, pagination.size || conglomerado.participantes.length, { direction: pagination.sortDirection, field: pagination.sortField });
    };
    PainelEntidadeSupervisionadaAbaConglomeradoController.prototype.sortItems = function (items, pagination) {
        var crescente = 'ASC' === pagination.sortDirection;
        var field = pagination.sortField;
        items.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(field ? (crescente ? lhs[field] : rhs[field]) : null, field ? (crescente ? rhs[field] : lhs[field]) : null)
            .append(lhs.situacao, rhs.situacao)
            .append(lhs.condicao, rhs.condicao)
            .append(lhs.label, rhs.label)
            .append(rhs.vigencia, lhs.vigencia)
            .build(); });
    };
    return PainelEntidadeSupervisionadaAbaConglomeradoController;
}());
PainelEntidadeSupervisionadaAbaConglomeradoController.$inject = ['$state', '$scope', 'feedbackService', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaConglomeradoController', PainelEntidadeSupervisionadaAbaConglomeradoController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-conglomerado-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaCooperativaController = (function () {
    function PainelEntidadeSupervisionadaAbaCooperativaController($state, $scope, feedbackService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaCooperativaController.prototype.$onInit = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarAbaCooperativa(this.$state.params.idbacen).then(function (response) {
            _this.item = response.data;
        });
    };
    return PainelEntidadeSupervisionadaAbaCooperativaController;
}());
PainelEntidadeSupervisionadaAbaCooperativaController.$inject = ['$state', '$scope', 'feedbackService', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaCooperativaController', PainelEntidadeSupervisionadaAbaCooperativaController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-cooperativa-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaDadosGeraisController = (function () {
    function PainelEntidadeSupervisionadaAbaDadosGeraisController($state, $scope, feedbackService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaDadosGeraisController.prototype.$onInit = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarAbaDadosGerais(this.$state.params.idbacen).then(function (response) {
            _this.item = response.data;
        });
    };
    return PainelEntidadeSupervisionadaAbaDadosGeraisController;
}());
PainelEntidadeSupervisionadaAbaDadosGeraisController.$inject = ['$state', '$scope', 'feedbackService', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaDadosGeraisController', PainelEntidadeSupervisionadaAbaDadosGeraisController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-dados-gerais-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaDiretoriaController = (function () {
    function PainelEntidadeSupervisionadaAbaDiretoriaController($state, $scope, feedbackService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaDiretoriaController.prototype.$onInit = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarAbaDiretoria(this.$state.params.idbacen).then(function (response) {
            _this.item = response.data;
        });
    };
    return PainelEntidadeSupervisionadaAbaDiretoriaController;
}());
PainelEntidadeSupervisionadaAbaDiretoriaController.$inject = ['$state', '$scope', 'feedbackService', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaDiretoriaController', PainelEntidadeSupervisionadaAbaDiretoriaController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-diretoria-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController = (function () {
    function PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController($state, $scope, feedbackService, locationService, $uibModal, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.locationService = locationService;
        this.$uibModal = $uibModal;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController.prototype.$onInit = function () {
        this.dadosFormulario = {
            texto: this.$state.params.texto
        };
        this.navegarNaGrid(this.dadosFormulario, {
            number: ConverterParameterUrlToObjectUtils.number(this.$state.params.numeroPagina),
            size: ConverterParameterUrlToObjectUtils.number(this.$state.params.quantidadePorPagina),
            sortField: this.$state.params.ordenacaoCampo,
            sortDirection: this.$state.params.ordenacaoDirecao
        });
    };
    PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController.prototype.navegarNaGrid = function (dadosFormulario, pagination) {
        var _this = this;
        var consultaFiltro = {
            texto: ConverterParameterObjectToUrlUtils.string(dadosFormulario.texto),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(pagination.number),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(pagination.size),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(pagination.sortField),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(pagination.sortDirection)
        };
        this.locationService.search(consultaFiltro);
        this.painelEntidadeSupervisionadaApiService.buscarAbaDocumentoComQualidade(this.$state.params.idbacen, consultaFiltro).then(function (response) {
            _this.item = response.data;
        });
    };
    PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController.prototype.observerChangeDadosFormulario = function (dadosFormulario) {
        this.navegarNaGrid(dadosFormulario, { number: 0, size: this.$state.params.quantidadePorPagina });
    };
    return PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController;
}());
PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController.$inject = ['$state', '$scope', 'feedbackService', '$location', '$uibModal', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController', PainelEntidadeSupervisionadaAbaDocumentoComQualidadeController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-documento-com-qualidade-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController = (function () {
    function PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController($state, $scope, feedbackService, locationService, $uibModal, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.locationService = locationService;
        this.$uibModal = $uibModal;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController.prototype.$onInit = function () {
        this.dadosFormulario = {
            texto: this.$state.params.texto
        };
        this.navegarNaGrid(this.dadosFormulario, {
            number: ConverterParameterUrlToObjectUtils.number(this.$state.params.numeroPagina),
            size: ConverterParameterUrlToObjectUtils.number(this.$state.params.quantidadePorPagina),
            sortField: this.$state.params.ordenacaoCampo,
            sortDirection: this.$state.params.ordenacaoDirecao
        });
    };
    PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController.prototype.navegarNaGrid = function (dadosFormulario, pagination) {
        var _this = this;
        var consultaFiltro = {
            texto: ConverterParameterObjectToUrlUtils.string(dadosFormulario.texto),
            numeroPagina: ConverterParameterUrlToObjectUtils.number(pagination.number),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(pagination.size),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(pagination.sortField),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(pagination.sortDirection)
        };
        this.locationService.search(consultaFiltro);
        this.painelEntidadeSupervisionadaApiService.buscarAbaDocumentosEmAtraso(this.$state.params.idbacen, consultaFiltro).then(function (response) {
            _this.item = response.data;
        });
    };
    PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController.prototype.observerChangeDadosFormulario = function (dadosFormulario) {
        this.navegarNaGrid(dadosFormulario, { number: 0, size: this.$state.params.quantidadePorPagina });
    };
    PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController.prototype.abrirModalDetalhamento = function (id) {
        var scope = this.$scope.$new();
        scope.idbacen = this.$state.params.idbacen;
        scope.id = id;
        this.$uibModal.open({
            animation: true,
            backdrop: 'static',
            templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada-modal-detalhe-documentos-em-atraso/painel-entidade-supervisionada-modal-detalhe-documentos-em-atraso-tpl.html',
            controller: 'PainelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoController',
            controllerAs: 'painelEntidadeSupervisionadaModalDetalheDocumentosEmAtrasoCtrl',
            bindToController: true,
            scope: scope,
            size: 'lg'
        }).result.then(function () { });
    };
    PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController.prototype.abrirModalDarCienciaSupervisor = function (id) {
        var scope = this.$scope.$new();
        scope.idbacen = this.$state.params.idbacen;
        scope.id = id;
        this.$uibModal.open({
            animation: true,
            backdrop: 'static',
            templateUrl: 'views/painel-entidade-supervisionada/views/painel-entidade-supervisionada-modal-dar-ciencia-supervisor/painel-entidade-supervisionada-modal-dar-ciencia-supervisor-tpl.html',
            controller: 'PainelEntidadeSupervisionadaModalDarCienciaSupervisorController',
            controllerAs: 'painelEntidadeSupervisionadaModalDarCienciaSupervisorController',
            bindToController: true,
            scope: scope,
            size: 'lg'
        }).result.then(function () { });
    };
    return PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController;
}());
PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController.$inject = ['$state', '$scope', 'feedbackService', '$location', '$uibModal', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController', PainelEntidadeSupervisionadaAbaDocumentosEmAtrasoController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-documentos-em-atraso-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaResponsaveisController = (function () {
    function PainelEntidadeSupervisionadaAbaResponsaveisController($state, $scope, feedbackService, locationService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.locationService = locationService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaResponsaveisController.prototype.$onInit = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarAbaResponsaveis(this.$state.params.idbacen).then(function (response) {
            _this.item = response.data;
            _this.dadosFormulario = {
                texto: _this.$state.params.texto
            };
            _this.navegarNaGrid(_this.dadosFormulario, {
                number: ConverterParameterUrlToObjectUtils.number(_this.$state.params.numeroPagina),
                size: ConverterParameterUrlToObjectUtils.number(_this.$state.params.quantidadePorPagina),
                sortField: _this.$state.params.ordenacaoCampo,
                sortDirection: _this.$state.params.ordenacaoDirecao
            });
        });
    };
    PainelEntidadeSupervisionadaAbaResponsaveisController.prototype.navegarNaGrid = function (dadosFormulario, pagination) {
        var items = this.filterItems(this.item ? this.item.porAreaDeAtuacao : [], dadosFormulario);
        this.sortItems(items, pagination);
        this.locationService.search({ texto: dadosFormulario.texto, numeroPagina: pagination.number, quantidadePorPagina: pagination.size });
        this.porAreaDeAtuacao = new Pagina(PaginaUtil.paginaContent(items, pagination), items.length, pagination.number || 0, pagination.size || 10, { direction: pagination.sortDirection, field: pagination.sortField });
    };
    PainelEntidadeSupervisionadaAbaResponsaveisController.prototype.observerChangeDadosFormulario = function (dadosFormulario) {
        this.navegarNaGrid(dadosFormulario, { number: 0, size: this.$state.params.quantidadePorPagina });
    };
    PainelEntidadeSupervisionadaAbaResponsaveisController.prototype.filterItems = function (items, dadosFormulario) {
        return items.filter(function (i) {
            return !dadosFormulario.texto ? true :
                i.area.match(new RegExp(dadosFormulario.texto, 'gi'))
                    || i.cargo.match(new RegExp(dadosFormulario.texto, 'gi'))
                    || i.documentos.some(function (doc) { return doc.codigo.match(new RegExp(dadosFormulario.texto, 'gi')); })
                    || i.responsaveis.some(function (resp) { return resp.nome.match(new RegExp(dadosFormulario.texto, 'gi')); });
        });
    };
    PainelEntidadeSupervisionadaAbaResponsaveisController.prototype.sortItems = function (items, pagination) {
        var crescente = 'ASC' === pagination.sortDirection;
        var field = pagination.sortField;
        items.sort(function (lhs, rhs) { return new CompareToBuilder()
            .append(field ? (crescente ? lhs[field] : rhs[field]) : null, field ? (crescente ? rhs[field] : lhs[field]) : null)
            .append(lhs.area, rhs.area)
            .append(lhs.cargo, rhs.cargo)
            .build(); });
    };
    return PainelEntidadeSupervisionadaAbaResponsaveisController;
}());
PainelEntidadeSupervisionadaAbaResponsaveisController.$inject = ['$state', '$scope', 'feedbackService', '$location', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaResponsaveisController', PainelEntidadeSupervisionadaAbaResponsaveisController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-responsaveis-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaAbaSupervisaoController = (function () {
    function PainelEntidadeSupervisionadaAbaSupervisaoController($state, $scope, feedbackService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaAbaSupervisaoController.prototype.$onInit = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.buscarAbaSupervisao(this.$state.params.idbacen).then(function (response) {
            _this.item = response.data;
        });
    };
    return PainelEntidadeSupervisionadaAbaSupervisaoController;
}());
PainelEntidadeSupervisionadaAbaSupervisaoController.$inject = ['$state', '$scope', 'feedbackService', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaAbaSupervisaoController', PainelEntidadeSupervisionadaAbaSupervisaoController);
//# sourceMappingURL=painel-entidade-supervisionada-aba-supervisao-controller.js.map;
"use strict";
var PainelEntidadeSupervisionadaController = (function () {
    function PainelEntidadeSupervisionadaController($state, $scope, feedbackService, painelEntidadeSupervisionadaApiService) {
        this.$state = $state;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.painelEntidadeSupervisionadaApiService = painelEntidadeSupervisionadaApiService;
    }
    PainelEntidadeSupervisionadaController.prototype.$onInit = function () {
        this.dadosParaConstruir();
    };
    PainelEntidadeSupervisionadaController.prototype.dadosParaConstruir = function () {
        var _this = this;
        this.painelEntidadeSupervisionadaApiService.paraConsultar().then(function (response) {
            _this.item = response.data;
            _this.buscar(_this.$state.params.idbacen);
        });
    };
    PainelEntidadeSupervisionadaController.prototype.selecionar = function (dadosFormulario) {
        this.selecionarAbaDadosGerais(dadosFormulario);
    };
    PainelEntidadeSupervisionadaController.prototype.onChangeEntidadeSupervisionada = function () {
        this.item = undefined;
        if (this.dadosFormulario.entidadeSupervisionada) {
            this.buscar(this.dadosFormulario.entidadeSupervisionada.idBacen);
            this.selecionarAbaDadosGerais(this.dadosFormulario);
        }
    };
    PainelEntidadeSupervisionadaController.prototype.selecionarAbaDadosGerais = function (dadosFormulario) {
        this.$state.go('painel-entidade-supervisionada.dados-gerais', { idbacen: dadosFormulario.entidadeSupervisionada.idBacen });
    };
    PainelEntidadeSupervisionadaController.prototype.buscar = function (id) {
        var _this = this;
        if (!id) {
            return;
        }
        this.painelEntidadeSupervisionadaApiService.buscar(id).then(function (response) {
            _this.item = response.data;
            _this.dadosFormulario = response.data ? response.data.dadosFormulario : null;
        });
    };
    return PainelEntidadeSupervisionadaController;
}());
PainelEntidadeSupervisionadaController.$inject = ['$state', '$scope', 'feedbackService', 'PainelEntidadeSupervisionadaApiService'];
angular.module('crd').controller('PainelEntidadeSupervisionadaController', PainelEntidadeSupervisionadaController);
//# sourceMappingURL=painel-entidade-supervisionada-controller.js.map;
"use strict";
var ParametroIndicadorIDCIServiceImpl = (function () {
    function ParametroIndicadorIDCIServiceImpl(apiService) {
        this.apiService = apiService;
    }
    ParametroIndicadorIDCIServiceImpl.prototype.buscar = function () {
        return this.apiService.getHttp('/parametro-indicador/idci', { params: {} });
    };
    ParametroIndicadorIDCIServiceImpl.prototype.atualizar = function (data) {
        return this.apiService.postHttp('/parametro-indicador/idci', data);
    };
    return ParametroIndicadorIDCIServiceImpl;
}());
ParametroIndicadorIDCIServiceImpl.$inject = ['apiService'];
angular.module('crd').service('ParametroIndicadorIDCIService', ParametroIndicadorIDCIServiceImpl);
//# sourceMappingURL=parametro-indicador-idci-api-service.js.map;
"use strict";
var ParametroIndicadorIDCIController = (function () {
    function ParametroIndicadorIDCIController($state, feedbackService, parametroIndicadorIDCIService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.parametroIndicadorIDCIService = parametroIndicadorIDCIService;
    }
    ParametroIndicadorIDCIController.prototype.$onInit = function () {
        this.feedbackService.limpar();
        this.buscar();
    };
    ParametroIndicadorIDCIController.prototype.cancelar = function () {
        this.feedbackService.limpar();
        this.buscar();
    };
    ParametroIndicadorIDCIController.prototype.salvar = function () {
        var _this = this;
        var data = {
            pesos: this.dadosDoFormulario.pesos.map(function (peso) {
                return {
                    documentoPK: peso.documentoPK
                };
            })
        };
        return this.parametroIndicadorIDCIService.atualizar(data)
            .then(function (resorce) {
            _this.feedbackService.sucesso('Parametrização do indicador IDCI salva com sucesso!');
        });
    };
    ParametroIndicadorIDCIController.prototype.adicionarPeso = function (documento) {
        if (this.dadosDoFormulario.pesos.filter(function (p) { return p.documentoPK === documento.pk; }).length > 0) {
            return;
        }
        this.dadosDoFormulario.pesos.push({
            sistemaNegocioPK: documento.sistemaNegocioPK,
            sistemaNegocio: documento.sistemaNegocio,
            documentoPK: documento.pk,
            documento: documento.codigo
        });
        this.dadosDoFormulario.pesos.sort(function (a, b) { return new CompareToBuilder()
            .append(a.sistemaNegocio, b.sistemaNegocio)
            .append(a.documento, b.documento)
            .build(); });
        this.dadosDoFormulario.documento = null;
    };
    ParametroIndicadorIDCIController.prototype.removerPeso = function (peso) {
        var i = this.dadosDoFormulario.pesos.filter(function (i) { return i.documentoPK !== peso.documentoPK; });
        this.dadosDoFormulario.pesos.length = 0;
        (_a = this.dadosDoFormulario.pesos).push.apply(_a, i);
        var _a;
    };
    ParametroIndicadorIDCIController.prototype.observerSistemaNegocio = function () {
        this.dadosDoFormulario.filtroDocumento.sistemasNegocio = this.dadosDoFormulario.sistemaNegocio
            ? [this.dadosDoFormulario.sistemaNegocio.pk]
            : [];
        this.dadosDoFormulario.documento = null;
    };
    ParametroIndicadorIDCIController.prototype.buscar = function () {
        var _this = this;
        return this.parametroIndicadorIDCIService.buscar()
            .then(function (resorce) {
            _this.acoes = resorce.data.acoes;
            _this.dadosDoFormulario = {
                pesos: resorce.data.pesos,
                filtroDocumento: {
                    sistemasNegocio: []
                }
            };
        });
    };
    return ParametroIndicadorIDCIController;
}());
ParametroIndicadorIDCIController.$inject = ['$state', 'feedbackService', 'ParametroIndicadorIDCIService'];
angular.module('crd').controller('ParametroIndicadorIDCIController', ParametroIndicadorIDCIController);
//# sourceMappingURL=parametro-indicador-idci-controller.js.map;
"use strict";
var ParametroIndicadorIQFIServiceImpl = (function () {
    function ParametroIndicadorIQFIServiceImpl(apiService) {
        this.apiService = apiService;
    }
    ParametroIndicadorIQFIServiceImpl.prototype.buscar = function () {
        return this.apiService.getHttp('/parametro-indicador/iqfi', { params: {} });
    };
    ParametroIndicadorIQFIServiceImpl.prototype.atualizar = function (data) {
        return this.apiService.postHttp('/parametro-indicador/iqfi', data);
    };
    return ParametroIndicadorIQFIServiceImpl;
}());
ParametroIndicadorIQFIServiceImpl.$inject = ['apiService'];
angular.module('crd').service('ParametroIndicadorIQFIService', ParametroIndicadorIQFIServiceImpl);
//# sourceMappingURL=parametro-indicador-iqfi-api-service.js.map;
"use strict";
var ParametroIndicadorIQFIController = (function () {
    function ParametroIndicadorIQFIController($state, feedbackService, parametroIndicadorIQFIService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.parametroIndicadorIQFIService = parametroIndicadorIQFIService;
    }
    ParametroIndicadorIQFIController.prototype.$onInit = function () {
        this.feedbackService.limpar();
        this.buscar();
    };
    ParametroIndicadorIQFIController.prototype.cancelar = function () {
        this.feedbackService.limpar();
        this.buscar();
    };
    ParametroIndicadorIQFIController.prototype.salvar = function () {
        var _this = this;
        var data = {
            pesos: this.dadosDoFormulario.pesos.map(function (peso) {
                return {
                    documentoPK: peso.documentoPK,
                    leve: peso.leve,
                    medio: peso.medio,
                    grave: peso.grave,
                    limiteInferiorX: peso.limiteInferiorX,
                    limiteInferiorY: peso.limiteInferiorY
                };
            })
        };
        return this.parametroIndicadorIQFIService.atualizar(data)
            .then(function (resorce) {
            _this.feedbackService.sucesso('Parametrização do indicador IQFI salva com sucesso!');
        });
    };
    ParametroIndicadorIQFIController.prototype.adicionarPeso = function (documento) {
        if (this.dadosDoFormulario.pesos.filter(function (p) { return p.documentoPK === documento.pk; }).length > 0) {
            return;
        }
        this.dadosDoFormulario.pesos.push({
            sistemaNegocioPK: documento.sistemaNegocioPK,
            sistemaNegocio: documento.sistemaNegocio,
            documentoPK: documento.pk,
            documento: documento.codigo,
            leve: 80,
            medio: 120,
            grave: 180,
            limiteInferiorX: 10,
            limiteInferiorY: 30
        });
        this.dadosDoFormulario.pesos.sort(function (a, b) { return new CompareToBuilder()
            .append(a.sistemaNegocio, b.sistemaNegocio)
            .append(a.documento, b.documento)
            .build(); });
        this.dadosDoFormulario.documento = null;
    };
    ParametroIndicadorIQFIController.prototype.removerPeso = function (peso) {
        var i = this.dadosDoFormulario.pesos.filter(function (i) { return i.documentoPK !== peso.documentoPK; });
        this.dadosDoFormulario.pesos.length = 0;
        (_a = this.dadosDoFormulario.pesos).push.apply(_a, i);
        var _a;
    };
    ParametroIndicadorIQFIController.prototype.observerSistemaNegocio = function () {
        this.dadosDoFormulario.filtroDocumento.sistemasNegocio = this.dadosDoFormulario.sistemaNegocio
            ? [this.dadosDoFormulario.sistemaNegocio.pk]
            : null;
        this.dadosDoFormulario.documento = null;
    };
    ParametroIndicadorIQFIController.prototype.buscar = function () {
        var _this = this;
        return this.parametroIndicadorIQFIService.buscar()
            .then(function (resorce) {
            _this.acoes = resorce.data.acoes;
            _this.dadosDoFormulario = {
                pesos: resorce.data.pesos,
                filtroDocumento: {
                    sistemasNegocio: null
                }
            };
        });
    };
    return ParametroIndicadorIQFIController;
}());
ParametroIndicadorIQFIController.$inject = ['$state', 'feedbackService', 'ParametroIndicadorIQFIService'];
angular.module('crd').controller('ParametroIndicadorIQFIController', ParametroIndicadorIQFIController);
//# sourceMappingURL=parametro-indicador-iqfi-controller.js.map;
"use strict";
var ParametroIndicadorIRFIServiceImpl = (function () {
    function ParametroIndicadorIRFIServiceImpl(apiService) {
        this.apiService = apiService;
    }
    ParametroIndicadorIRFIServiceImpl.prototype.buscar = function () {
        return this.apiService.getHttp('/parametro-indicador/irfi', { params: {} });
    };
    ParametroIndicadorIRFIServiceImpl.prototype.atualizar = function (data) {
        return this.apiService.postHttp('/parametro-indicador/irfi', data);
    };
    return ParametroIndicadorIRFIServiceImpl;
}());
ParametroIndicadorIRFIServiceImpl.$inject = ['apiService'];
angular.module('crd').service('ParametroIndicadorIRFIService', ParametroIndicadorIRFIServiceImpl);
//# sourceMappingURL=parametro-indicador-irfi-api-service.js.map;
"use strict";
var ParametroIndicadorIRFIController = (function () {
    function ParametroIndicadorIRFIController($state, feedbackService, parametroIndicadorIRFIService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.parametroIndicadorIRFIService = parametroIndicadorIRFIService;
    }
    ParametroIndicadorIRFIController.prototype.$onInit = function () {
        this.feedbackService.limpar();
        this.buscar();
    };
    ParametroIndicadorIRFIController.prototype.cancelar = function () {
        this.feedbackService.limpar();
        this.buscar();
    };
    ParametroIndicadorIRFIController.prototype.salvar = function () {
        var _this = this;
        var data = {
            pesos: this.dadosDoFormulario.pesos.map(function (peso) {
                return {
                    documentoPK: peso.documentoPK,
                    leve: peso.leve,
                    medio: peso.medio,
                    grave: peso.grave
                };
            })
        };
        return this.parametroIndicadorIRFIService.atualizar(data)
            .then(function (resorce) {
            _this.feedbackService.sucesso('Parametrização do indicador IRFI salva com sucesso!');
        });
    };
    ParametroIndicadorIRFIController.prototype.adicionarPeso = function (documento) {
        if (this.dadosDoFormulario.pesos.filter(function (p) { return p.documentoPK === documento.pk; }).length > 0) {
            return;
        }
        this.dadosDoFormulario.pesos.push({
            sistemaNegocioPK: documento.sistemaNegocioPK,
            sistemaNegocio: documento.sistemaNegocio,
            documentoPK: documento.pk,
            documento: documento.codigo,
            leve: 80,
            medio: 120,
            grave: 180
        });
        this.dadosDoFormulario.pesos.sort(function (a, b) { return new CompareToBuilder()
            .append(a.sistemaNegocio, b.sistemaNegocio)
            .append(a.documento, b.documento)
            .build(); });
        this.dadosDoFormulario.documento = null;
    };
    ParametroIndicadorIRFIController.prototype.removerPeso = function (peso) {
        var i = this.dadosDoFormulario.pesos.filter(function (i) { return i.documentoPK !== peso.documentoPK; });
        this.dadosDoFormulario.pesos.length = 0;
        (_a = this.dadosDoFormulario.pesos).push.apply(_a, i);
        var _a;
    };
    ParametroIndicadorIRFIController.prototype.observerSistemaNegocio = function () {
        this.dadosDoFormulario.filtroDocumento.sistemasNegocio = this.dadosDoFormulario.sistemaNegocio
            ? [this.dadosDoFormulario.sistemaNegocio.pk]
            : null;
        this.dadosDoFormulario.documento = null;
    };
    ParametroIndicadorIRFIController.prototype.buscar = function () {
        var _this = this;
        return this.parametroIndicadorIRFIService.buscar()
            .then(function (resorce) {
            _this.acoes = resorce.data.acoes;
            _this.dadosDoFormulario = {
                pesos: resorce.data.pesos,
                filtroDocumento: {
                    sistemasNegocio: []
                }
            };
        });
    };
    return ParametroIndicadorIRFIController;
}());
ParametroIndicadorIRFIController.$inject = ['$state', 'feedbackService', 'ParametroIndicadorIRFIService'];
angular.module('crd').controller('ParametroIndicadorIRFIController', ParametroIndicadorIRFIController);
//# sourceMappingURL=parametro-indicador-irfi-controller.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('parametro-indicador', {
        abstract: true,
        parent: 'admin',
        templateUrl: 'views/parametro-indicador/parametro-indicador-tpl.html',
        url: '/parametro-indicador'
    })
        .state('parametro-indicador.idci', {
        controller: 'ParametroIndicadorIDCIController',
        controllerAs: 'parametroIndicadorIDCICtrl',
        informacaoPagina: {
            codigo: 'CRDFW6041',
            label: 'Parâmetros de indicadores',
            titulo: 'Parâmetros de indicadores'
        },
        parent: 'parametro-indicador',
        templateUrl: 'views/parametro-indicador/parametro-indicador-idci-tpl.html',
        url: '/idci'
    })
        .state('parametro-indicador.iqfi', {
        controller: 'ParametroIndicadorIQFIController',
        controllerAs: 'parametroIndicadorIQFICtrl',
        informacaoPagina: {
            codigo: 'CRDFW6041',
            label: 'Parâmetros de indicadores',
            titulo: 'Parâmetros de indicadores'
        },
        parent: 'parametro-indicador',
        templateUrl: 'views/parametro-indicador/parametro-indicador-iqfi-tpl.html',
        url: '/iqfi'
    })
        .state('parametro-indicador.irfi', {
        controller: 'ParametroIndicadorIRFIController',
        controllerAs: 'parametroIndicadorIRFICtrl',
        informacaoPagina: {
            codigo: 'CRDFW6041',
            label: 'Parâmetros de indicadores',
            titulo: 'Parâmetros de indicadores'
        },
        parent: 'parametro-indicador',
        templateUrl: 'views/parametro-indicador/parametro-indicador-irfi-tpl.html',
        url: '/irfi'
    });
});
//# sourceMappingURL=parametro-indicador-route-config.js.map;
"use strict";
var ParametrosDeIndicadoreAbaIDCIController = (function () {
    function ParametrosDeIndicadoreAbaIDCIController($state, feedbackService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
    }
    ParametrosDeIndicadoreAbaIDCIController.prototype.$onInit = function () {
        this.feedbackService.limpar();
        this.acoes = {
            podeAlterar: true
        };
        this.dadosDoFormulario = {
            indicadores: []
        };
        for (var s = 0; s < 2; s++) {
            for (var d = 0; d < 3; d++) {
                this.dadosDoFormulario.indicadores.push({
                    sistemaNegocio: "sis-" + s,
                    documento: "doc-" + s + "-" + d,
                    documentoPK: s + "-" + d
                });
            }
        }
    };
    ;
    ParametrosDeIndicadoreAbaIDCIController.prototype.addDocumento = function (documento) {
        this.dadosDoFormulario.indicadores.push({
            sistemaNegocio: documento.sistemaNegocio.sigla,
            documento: documento.codigo,
            documentoPK: documento.pk
        });
        this.dadosDoFormulario.indicadores.sort(function (a, b) { return new CompareToBuilder()
            .append(a.sistemaNegocio, b.sistemaNegocio)
            .append(a.documento, b.documento)
            .build(); });
        this.dadosDoFormulario.sistemaNegocio = null;
        this.dadosDoFormulario.documento = null;
    };
    ParametrosDeIndicadoreAbaIDCIController.prototype.delDocumento = function (indicador) {
        var i = this.dadosDoFormulario.indicadores.filter(function (i) { return i.documentoPK !== indicador.documentoPK; });
        this.dadosDoFormulario.indicadores.length = 0;
        (_a = this.dadosDoFormulario.indicadores).push.apply(_a, i);
        var _a;
    };
    return ParametrosDeIndicadoreAbaIDCIController;
}());
ParametrosDeIndicadoreAbaIDCIController.$inject = ['$state', 'feedbackService'];
angular.module('crd').controller('ParametrosDeIndicadoreAbaIDCIController', ParametrosDeIndicadoreAbaIDCIController);
//# sourceMappingURL=parametros-de-indicadore-aba-idci-controller.js.map;
"use strict";
//# sourceMappingURL=pedido-teste-critica-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=pedido-teste-critica-consulta-resultado.js.map;
"use strict";
//# sourceMappingURL=pedido-teste-critica-inclusao-dto.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('pedido-teste-critica-pesquisa', {
        controller: 'PedidoTesteCriticaPesquisaController',
        controllerAs: 'ptcPqrCtrl',
        informacaoPagina: {
            codigo: 'CRDFW4061',
            label: 'Teste de crítica',
            titulo: 'Teste de crítica'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/pedido-teste-critica/views/pedido-teste-critica-pesquisa/pedido-teste-critica-pesquisa-tpl.html',
        url: '/pedido-teste-critica?jaPesquisado&numeroPagina&quantidadePorPagina&ordenacaoDirecao&ordenacaoCampo'
    });
});
//# sourceMappingURL=pedido-teste-critica-route-config.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var PedidoTesteCriticaApiService = (function (_super) {
    __extends(PedidoTesteCriticaApiService, _super);
    function PedidoTesteCriticaApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    PedidoTesteCriticaApiService.prototype.pesquisar = function (filtro) {
        return this.pesquisarRecurso('/pedido-teste-critica/pesquisar', filtro);
    };
    PedidoTesteCriticaApiService.prototype.excluir = function (pk) {
        return this.excluirRecurso("/pedido-teste-critica/" + pk + "/excluir", {});
    };
    PedidoTesteCriticaApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso("/pedido-teste-critica/solicitar-teste", dados);
    };
    PedidoTesteCriticaApiService.prototype.gerarExcel = function (pk) {
        return this.baixarArquivo("/pedido-teste-critica/" + pk + "/relatorio-em-excel", {});
    };
    return PedidoTesteCriticaApiService;
}(AbstractAPISerivce));
PedidoTesteCriticaApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('PedidoTesteCriticaApiService', PedidoTesteCriticaApiService);
//# sourceMappingURL=pedido-teste-critica-api-service.js.map;
"use strict";
var PedidoTesteCriticaPesquisaController = (function () {
    function PedidoTesteCriticaPesquisaController($location, $scope, $stateParams, pedidoTesteCriticaApiService, feedbackService) {
        this.$location = $location;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.pedidoTesteCriticaApiService = pedidoTesteCriticaApiService;
        this.feedbackService = feedbackService;
        this.resultadoVisivel = false;
    }
    PedidoTesteCriticaPesquisaController.prototype.gerarExcel = function (pk) {
        var _this = this;
        return this.pedidoTesteCriticaApiService.gerarExcel(pk).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    PedidoTesteCriticaPesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    PedidoTesteCriticaPesquisaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    PedidoTesteCriticaPesquisaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    PedidoTesteCriticaPesquisaController.prototype.limparResultadoPesquisa = function () {
        this.limparMensagens();
    };
    PedidoTesteCriticaPesquisaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao)
        };
    };
    PedidoTesteCriticaPesquisaController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        return {
            jaPesquisado: true,
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao)
        };
    };
    PedidoTesteCriticaPesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.limparResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    PedidoTesteCriticaPesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        this.limparResultadoPesquisa();
        return this.pesquisar(parametrosPesquisa);
    };
    PedidoTesteCriticaPesquisaController.prototype.excluir = function (pk) {
        var _this = this;
        return this.pedidoTesteCriticaApiService.excluir(pk).then(function (resource) {
            if (resource.status === 200) {
                _this.feedbackService.sucesso('Teste de crítica excluída com sucesso.');
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.feedbackService.violacoes(resource.data);
            }
            return resource;
        });
    };
    PedidoTesteCriticaPesquisaController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.pedidoTesteCriticaApiService.pesquisar(parametros).then(function (response) {
            _this.pagina = response.data;
            _this.exibirResultadoPesquisa();
            return response;
        });
    };
    PedidoTesteCriticaPesquisaController.prototype.carregarDadosTela = function (filtro) {
        this.parametrosPesquisa = this.converterUrlParaParametros(filtro);
        this.pesquisar(this.parametrosPesquisa);
    };
    PedidoTesteCriticaPesquisaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return PedidoTesteCriticaPesquisaController;
}());
PedidoTesteCriticaPesquisaController.$inject = ['$location', '$scope', '$stateParams', 'PedidoTesteCriticaApiService', 'feedbackService'];
angular.module('crd').controller('PedidoTesteCriticaPesquisaController', PedidoTesteCriticaPesquisaController);
//# sourceMappingURL=pedido-teste-critica-pesquisa-controller.js.map;
"use strict";
var PortaLateralQualidadeControleDaImportacaoController = (function () {
    function PortaLateralQualidadeControleDaImportacaoController(feedbackService, pltApiService) {
        this.feedbackService = feedbackService;
        this.pltApiService = pltApiService;
    }
    PortaLateralQualidadeControleDaImportacaoController.prototype.gerarExcel = function () {
        var _this = this;
        return this.pltApiService.gerarExcel().then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
        });
    };
    PortaLateralQualidadeControleDaImportacaoController.prototype.$onInit = function () {
        return this.gerarExcel();
    };
    ;
    return PortaLateralQualidadeControleDaImportacaoController;
}());
PortaLateralQualidadeControleDaImportacaoController.$inject = ['feedbackService', 'PortaLateralQualidadeApiService'];
angular.module('crd').controller('PortaLateralQualidadeControleDaImportacaoController', PortaLateralQualidadeControleDaImportacaoController);
//# sourceMappingURL=porta-lateral-qualidade-controle-da-importacao-controller.js.map;
"use strict";
var PortaLateralQualidadeImportacaoController = (function () {
    function PortaLateralQualidadeImportacaoController($uibModal, feedbackService, plqApiService) {
        this.$uibModal = $uibModal;
        this.feedbackService = feedbackService;
        this.plqApiService = plqApiService;
    }
    PortaLateralQualidadeImportacaoController.prototype.abrirAjuda = function () {
        this.$uibModal.open({
            animation: true,
            backdrop: true,
            keyboard: true,
            templateUrl: 'views/porta-lateral-qualidade/porta-lateral-qualidade-importacao-ajuda-tpl.html'
        });
    };
    PortaLateralQualidadeImportacaoController.prototype.carregarTela = function () {
        var _this = this;
        return this.plqApiService.montarTelaImportacao().then(function (response) {
            _this.dadosDaTela = response;
            return response;
        });
    };
    PortaLateralQualidadeImportacaoController.prototype.configuracaoFlow = function () {
        return {
            singleFile: true,
            target: '',
            testChunks: false
        };
    };
    PortaLateralQualidadeImportacaoController.prototype.importar = function (arquivo, $flow) {
        var _this = this;
        var url = this.dadosDaTela._links['crd-porta-lateral-qualidade-importar'].href;
        return this.plqApiService.importar(url, arquivo)
            .then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Importação de fator faixa concluída com sucesso!');
                _this.limparFormulario();
                $flow.cancel();
            }
        })["catch"](function (response) {
            if (response.status === 412) {
                _this.feedbackService.erro('Arquivo com problemas de formato/conteúdo. Detalhamento abaixo.');
                _this.problemas = response.data.violacoes;
            }
        });
    };
    PortaLateralQualidadeImportacaoController.prototype.limparFormulario = function () {
        this.problemas = [];
        this.formatoValido = false;
        this.arquivo = null;
    };
    PortaLateralQualidadeImportacaoController.prototype.onFileSelect = function ($file) {
        this.arquivo = $file.file;
        this.problemas = [];
        this.feedbackService.limpar();
        this.verificarArquivo(this.arquivo);
    };
    PortaLateralQualidadeImportacaoController.prototype.verificarArquivo = function (arquivo) {
        if (arquivo) {
            this.formatoValido = _.contains(this.dadosDaTela.tiposAceitos, arquivo.type);
        }
    };
    PortaLateralQualidadeImportacaoController.prototype.$onInit = function () {
        return this.carregarTela();
    };
    ;
    return PortaLateralQualidadeImportacaoController;
}());
PortaLateralQualidadeImportacaoController.$inject = ['$uibModal', 'feedbackService', 'PortaLateralQualidadeApiService'];
angular.module('crd').controller('PortaLateralQualidadeImportacaoController', PortaLateralQualidadeImportacaoController);
//# sourceMappingURL=porta-lateral-qualidade-importacao-controller.js.map;
"use strict";
var PortaLateralTempestividadeControleDaImportacaoController = (function () {
    function PortaLateralTempestividadeControleDaImportacaoController(feedbackService, pltApiService) {
        this.feedbackService = feedbackService;
        this.pltApiService = pltApiService;
    }
    PortaLateralTempestividadeControleDaImportacaoController.prototype.gerarExcel = function () {
        var _this = this;
        return this.pltApiService.gerarExcel().then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
        });
    };
    PortaLateralTempestividadeControleDaImportacaoController.prototype.$onInit = function () {
        return this.gerarExcel();
    };
    ;
    return PortaLateralTempestividadeControleDaImportacaoController;
}());
PortaLateralTempestividadeControleDaImportacaoController.$inject = ['feedbackService', 'PortaLateralTempestividadeApiService'];
angular.module('crd').controller('PortaLateralTempestividadeControleDaImportacaoController', PortaLateralTempestividadeControleDaImportacaoController);
//# sourceMappingURL=porta-lateral-tempestividade-controle-da-importacao-controller.js.map;
"use strict";
var PortaLateralTempestividadeImportacaoController = (function () {
    function PortaLateralTempestividadeImportacaoController($uibModal, feedbackService, pltApiService) {
        this.$uibModal = $uibModal;
        this.feedbackService = feedbackService;
        this.pltApiService = pltApiService;
    }
    PortaLateralTempestividadeImportacaoController.prototype.abrirAjuda = function () {
        this.$uibModal.open({
            animation: true,
            backdrop: true,
            keyboard: true,
            templateUrl: 'views/porta-lateral-tempestividade/porta-lateral-tempestividade-importacao-ajuda-tpl.html'
        });
    };
    PortaLateralTempestividadeImportacaoController.prototype.carregarTela = function () {
        var _this = this;
        return this.pltApiService.montarTelaImportacao().then(function (response) {
            _this.dadosDaTela = response;
            return response;
        });
    };
    PortaLateralTempestividadeImportacaoController.prototype.configuracaoFlow = function () {
        return {
            singleFile: true,
            target: '',
            testChunks: false
        };
    };
    PortaLateralTempestividadeImportacaoController.prototype.importar = function (arquivo, $flow) {
        var _this = this;
        var url = this.dadosDaTela._links['crd-porta-lateral-tempestividade-importar'].href;
        return this.pltApiService.importar(url, arquivo)
            .then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Importação de fator faixa concluída com sucesso!');
                _this.limparFormulario();
                $flow.cancel();
            }
        })["catch"](function (response) {
            if (response.status === 412) {
                _this.feedbackService.erro('Arquivo com problemas de formato/conteúdo. Detalhamento abaixo.');
                _this.problemas = response.data.violacoes;
            }
        });
    };
    PortaLateralTempestividadeImportacaoController.prototype.limparFormulario = function () {
        this.problemas = [];
        this.formatoValido = false;
        this.arquivo = null;
    };
    PortaLateralTempestividadeImportacaoController.prototype.onFileSelect = function ($file) {
        this.arquivo = $file.file;
        this.problemas = [];
        this.feedbackService.limpar();
        this.verificarArquivo(this.arquivo);
    };
    PortaLateralTempestividadeImportacaoController.prototype.verificarArquivo = function (arquivo) {
        if (arquivo) {
            this.formatoValido = _.contains(this.dadosDaTela.tiposAceitos, arquivo.type);
        }
    };
    PortaLateralTempestividadeImportacaoController.prototype.$onInit = function () {
        return this.carregarTela();
    };
    ;
    return PortaLateralTempestividadeImportacaoController;
}());
PortaLateralTempestividadeImportacaoController.$inject = ['$uibModal', 'feedbackService', 'PortaLateralTempestividadeApiService'];
angular.module('crd').controller('PortaLateralTempestividadeImportacaoController', PortaLateralTempestividadeImportacaoController);
//# sourceMappingURL=porta-lateral-tempestividade-importacao-controller.js.map;
"use strict";
//# sourceMappingURL=sistema-negocio-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=sistema-negocio-detalhe-dto.js.map;
"use strict";
//# sourceMappingURL=sistema-negocio-para-consultar-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SistemaNegocioApiService = (function (_super) {
    __extends(SistemaNegocioApiService, _super);
    function SistemaNegocioApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    SistemaNegocioApiService.prototype.alterar = function (id, dados) {
        return this.alterarRecurso("/sistema-negocio/" + id + "/alterar", dados);
    };
    SistemaNegocioApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/sistema-negocio/consultar', consultaFiltro);
    };
    SistemaNegocioApiService.prototype.detalhar = function (id) {
        return this.buscarRecurso("/sistema-negocio/" + id + "/detalhar", {});
    };
    SistemaNegocioApiService.prototype.excluir = function (id) {
        return this.excluirRecurso("/sistema-negocio/" + id + "/excluir", {});
    };
    SistemaNegocioApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso('/sistema-negocio/incluir', dados);
    };
    SistemaNegocioApiService.prototype.paraAlterar = function (id) {
        return this.buscarRecurso("/sistema-negocio/" + id + "/para-alterar", {});
    };
    SistemaNegocioApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/sistema-negocio/para-consultar', consultaFiltro);
    };
    SistemaNegocioApiService.prototype.paraIncluir = function () {
        return this.buscarRecurso('/sistema-negocio/para-incluir', {});
    };
    SistemaNegocioApiService.prototype.relatorioExcel = function (consultaFiltro) {
        return this.baixarArquivo("/sistema-negocio/relatorio-em-excel", consultaFiltro);
    };
    return SistemaNegocioApiService;
}(AbstractAPISerivce));
SistemaNegocioApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('SistemaNegocioApiService', SistemaNegocioApiService);
//# sourceMappingURL=sistema-negocio-api-service.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('sistema-negocio-consultar', {
        controller: 'SistemaNegocioConsultaController',
        controllerAs: 'sistemaNegocioConsultaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Sistema de negócio',
            titulo: 'Sistema de negócio'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/sistema-negocio/views/sistema-negocio-consulta/sistema-negocio-consulta-tpl.html',
        url: '/sistema-negocio?texto&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('sistema-negocio-detalhar', {
        controller: 'SistemaNegocioDetalheController',
        controllerAs: 'sistemaNegocioDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5072',
            label: 'Sistema de negócio',
            titulo: 'Sistema de negócio'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/sistema-negocio/views/sistema-negocio-detalhe/sistema-negocio-detalhe-tpl.html',
        url: '/sistema-negocio/:id/detalhar'
    })
        .state('sistema-negocio-incluir', {
        controller: 'SistemaNegocioInclusaoController',
        controllerAs: 'sistemaNegocioInclusaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5073',
            label: 'Sistema de negócio',
            titulo: 'Sistema de negócio'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/sistema-negocio/views/sistema-negocio-inclusao/sistema-negocio-inclusao-tpl.html',
        url: '/sistema-negocio/incluir'
    })
        .state('sistema-negocio-alterar', {
        controller: 'SistemaNegocioAlteracaoController',
        controllerAs: 'sistemaNegocioAlteracaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5074',
            label: 'Sistema de negócio',
            titulo: 'Sistema de negócio'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/sistema-negocio/views/sistema-negocio-alteracao/sistema-negocio-alteracao-tpl.html',
        url: '/sistema-negocio/:id/alterar'
    });
});
//# sourceMappingURL=sistema-negocio-route-config.js.map;
"use strict";
var SistemaNegocioAlteracaoController = (function () {
    function SistemaNegocioAlteracaoController($state, feedbackService, sistemaNegocioApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
    }
    SistemaNegocioAlteracaoController.prototype.$onInit = function () {
        var _this = this;
        return this.sistemaNegocioApiService.paraAlterar(this.$state.params.id).then(function (response) {
            _this.dadosFormulario = response.data.dadosFormulario;
        });
    };
    ;
    SistemaNegocioAlteracaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            sigla: ConverterParameterObjectToUrlUtils.string(dadosFormulario.sigla),
            acessoRestrito: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.acessoRestrito),
            numeroPrazoQualidade: ConverterParameterObjectToUrlUtils.number(dadosFormulario.numeroPrazoQualidade),
            nome: ConverterParameterObjectToUrlUtils.string(dadosFormulario.nome),
            url: ConverterParameterObjectToUrlUtils.string(dadosFormulario.url)
        };
        return this.sistemaNegocioApiService.alterar(this.$state.params.id, dados).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Sistema de negócio alterado com sucesso.');
                _this.voltar();
            }
        });
    };
    SistemaNegocioAlteracaoController.prototype.voltar = function () {
        this.$state.go('sistema-negocio-consultar');
    };
    return SistemaNegocioAlteracaoController;
}());
SistemaNegocioAlteracaoController.$inject = ['$state', 'feedbackService', 'SistemaNegocioApiService'];
angular.module('crd').controller('SistemaNegocioAlteracaoController', SistemaNegocioAlteracaoController);
//# sourceMappingURL=sistema-negocio-alteracao-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SistemaNegocioConsultaController = (function (_super) {
    __extends(SistemaNegocioConsultaController, _super);
    function SistemaNegocioConsultaController($stateParams, $scope, feedbackService, sistemaNegocioApiService) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.sistemaNegocioApiService = sistemaNegocioApiService;
        return _this;
    }
    SistemaNegocioConsultaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        return this.sistemaNegocioApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.acao = response.data.acao;
            _this.pagina = response.data.pagina;
            _this.dadosFormulario = response.data.dadosFormulario;
            return response;
        });
    };
    SistemaNegocioConsultaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.sistemaNegocioApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            return response;
        });
    };
    SistemaNegocioConsultaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        return {
            texto: ConverterParameterObjectToUrlUtils.string(dadosFormulario.texto)
        };
    };
    SistemaNegocioConsultaController.prototype.limparDadosFormulario = function (dadosFormulario) {
        dadosFormulario.texto = undefined;
    };
    SistemaNegocioConsultaController.prototype.gerarRelatorioEmExcel = function (dadosFormulario) {
        var _this = this;
        var parametros = this.converterDadosDoFormToConsultaFiltro(dadosFormulario);
        return this.sistemaNegocioApiService.relatorioExcel(parametros).then(function (response) {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            response;
            return response;
        });
    };
    SistemaNegocioConsultaController.prototype.excluir = function (id) {
        var _this = this;
        return this.sistemaNegocioApiService.excluir(id).then(function (response) {
            _super.prototype.consultar.call(_this, _this.dadosFormulario).then(function () { return _this.feedbackService.sucesso('Sistema de negócio excluído com sucesso.'); });
            return response;
        });
    };
    return SistemaNegocioConsultaController;
}(AbstractPaginaConsultaController));
SistemaNegocioConsultaController.$inject = ['$stateParams', '$scope', 'feedbackService', 'SistemaNegocioApiService'];
angular.module('crd').controller('SistemaNegocioConsultaController', SistemaNegocioConsultaController);
//# sourceMappingURL=sistema-negocio-consulta-controller.js.map;
"use strict";
var SistemaNegocioDetalheController = (function () {
    function SistemaNegocioDetalheController($state, feedbackService, sistemaNegocioApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
    }
    SistemaNegocioDetalheController.prototype.$onInit = function () {
        var _this = this;
        return this.sistemaNegocioApiService.detalhar(this.$state.params.id).then(function (response) {
            _this.item = response.data;
        });
    };
    ;
    SistemaNegocioDetalheController.prototype.excluir = function (id) {
        var _this = this;
        return this.sistemaNegocioApiService.excluir(id).then(function (response) {
            _this.feedbackService.sucesso('Sistema de negócio excluído com sucesso.');
            _this.voltar();
            return response;
        });
    };
    SistemaNegocioDetalheController.prototype.voltar = function () {
        this.$state.go('sistema-negocio-consultar');
    };
    return SistemaNegocioDetalheController;
}());
SistemaNegocioDetalheController.$inject = ['$state', 'feedbackService', 'SistemaNegocioApiService'];
angular.module('crd').controller('SistemaNegocioDetalheController', SistemaNegocioDetalheController);
//# sourceMappingURL=sistema-negocio-detalhe-controller.js.map;
"use strict";
var SistemaNegocioInclusaoController = (function () {
    function SistemaNegocioInclusaoController($state, feedbackService, sistemaNegocioApiService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.sistemaNegocioApiService = sistemaNegocioApiService;
    }
    SistemaNegocioInclusaoController.prototype.$onInit = function () {
        var _this = this;
        return this.sistemaNegocioApiService.paraIncluir().then(function (response) {
            _this.dadosFormulario = response.data.dadosFormulario;
        });
    };
    ;
    SistemaNegocioInclusaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            sigla: ConverterParameterObjectToUrlUtils.string(dadosFormulario.sigla),
            acessoRestrito: ConverterParameterObjectToUrlUtils.boolean(dadosFormulario.acessoRestrito),
            numeroPrazoQualidade: ConverterParameterObjectToUrlUtils.number(dadosFormulario.numeroPrazoQualidade),
            nome: ConverterParameterObjectToUrlUtils.string(dadosFormulario.nome),
            url: ConverterParameterObjectToUrlUtils.string(dadosFormulario.url)
        };
        return this.sistemaNegocioApiService.incluir(dados).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Sistema de negócio incluído com sucesso.');
                _this.voltar();
            }
        });
    };
    SistemaNegocioInclusaoController.prototype.voltar = function () {
        this.$state.go('sistema-negocio-consultar');
    };
    return SistemaNegocioInclusaoController;
}());
SistemaNegocioInclusaoController.$inject = ['$state', 'feedbackService', 'SistemaNegocioApiService'];
angular.module('crd').controller('SistemaNegocioInclusaoController', SistemaNegocioInclusaoController);
//# sourceMappingURL=sistema-negocio-inclusao-controller.js.map;
"use strict";
var SituacaoMonitoradaDetalheController = (function () {
    function SituacaoMonitoradaDetalheController($state, situacaoMonitoradaApiService, $scope, feedbackService, abas) {
        if (abas === void 0) { abas = new AbasCritica(); }
        this.$state = $state;
        this.situacaoMonitoradaApiService = situacaoMonitoradaApiService;
        this.$scope = $scope;
        this.feedbackService = feedbackService;
        this.abas = abas;
    }
    SituacaoMonitoradaDetalheController.prototype.carregarDadosTela = function (params) {
        var _this = this;
        var campoPk = params.campoPk;
        var criticaPk = params.criticaPk;
        var database = params.database;
        var instituicao = params.instituicao;
        var documentoPk = params.documentoPk;
        this.situacaoMonitoradaApiService.montarTelaDetalhe(campoPk, criticaPk, database, instituicao, documentoPk).then(function (resource) {
            _this.situacaoMonitorada = resource;
        });
    };
    SituacaoMonitoradaDetalheController.prototype.voltar = function () {
        this.$state.go('situacao-monitorada-pesquisa');
    };
    SituacaoMonitoradaDetalheController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$state.params);
    };
    ;
    SituacaoMonitoradaDetalheController.prototype.criarURLParaDetalharSituacaoMonitorada = function (indicio) {
        var criticaPk = this.$state.params.criticaPk;
        var campoPk = this.$state.params.campoPk;
        var database = this.$state.params.database;
        var instituicao = this.$state.params.instituicao;
        var documentoPk = this.$state.params.documentoPk;
        return {
            pk: indicio.pk,
            voltar: 'situacao-monitorada-detalhar',
            voltarParametros: JSON.stringify({ criticaPk: criticaPk, campoPk: campoPk, database: database, instituicao: instituicao, documentoPk: documentoPk })
        };
    };
    return SituacaoMonitoradaDetalheController;
}());
SituacaoMonitoradaDetalheController.$inject = ['$state', 'SituacaoMonitoradaApiService', '$scope', 'feedbackService'];
angular.module('crd').controller('SituacaoMonitoradaDetalheController', SituacaoMonitoradaDetalheController);
//# sourceMappingURL=situacao-monitorada-detalhe-controller.js.map;
"use strict";
var SituacaoMonitoradaPesquisaController = (function () {
    function SituacaoMonitoradaPesquisaController($location, $scope, $stateParams, situacaoMonitoradaApiService, campoSituacaoMonitoradaApiService, feedbackService, documentoApiService, listaCamposDadosMonitorados) {
        if (listaCamposDadosMonitorados === void 0) { listaCamposDadosMonitorados = Array(); }
        this.$location = $location;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.situacaoMonitoradaApiService = situacaoMonitoradaApiService;
        this.campoSituacaoMonitoradaApiService = campoSituacaoMonitoradaApiService;
        this.feedbackService = feedbackService;
        this.documentoApiService = documentoApiService;
        this.listaCamposDadosMonitorados = listaCamposDadosMonitorados;
        this.resultadoVisivel = false;
        this.formularioVisivel = true;
        this.exibirCamposResultadoPorCampo = false;
        this.exibirColunaAcoes = true;
        this.opcoesDeData = FormataDataPeriodicidade.DIA_MES_ANO;
    }
    SituacaoMonitoradaPesquisaController.prototype.observerChangeSistemaNegocio = function (sistemaNegocio) {
        if (this.parametrosPesquisa.tipoResultado == 'CAMPO') {
            if (sistemaNegocio) {
                this.carregarCampos(sistemaNegocio);
            }
            else {
                this.listaCamposDadosMonitorados = [];
            }
        }
        else {
            this.carregarDocumentos(sistemaNegocio);
        }
    };
    SituacaoMonitoradaPesquisaController.prototype.carregarDocumentos = function (sistemaNegocio) {
        var _this = this;
        if (!sistemaNegocio || _.isEmpty(sistemaNegocio)) {
            this.dadosFormulario.documentos.length = 0;
            return;
        }
        this.documentoApiService.buscarPorSistemaNegocio(sistemaNegocio.pk).then(function (resource) {
            _this.dadosFormulario.documentos.length = 0;
            Array.prototype.push.apply(_this.dadosFormulario.documentos, resource);
            return resource;
        });
    };
    SituacaoMonitoradaPesquisaController.prototype.carregarCampos = function (sistemaNegocio) {
        var _this = this;
        if (sistemaNegocio) {
            this.listaCamposDadosMonitorados = [];
            var parameters = {
                sistemasNegocio: [sistemaNegocio.pk]
            };
            this.campoSituacaoMonitoradaApiService.pesquisarPorSistemaNegocio(parameters)
                .then(function (response) { _this.listaCamposDadosMonitorados = response; })["catch"](function (error) { return _this.feedbackService.error("Erro ao buscar os campos monitorados."); });
        }
    };
    SituacaoMonitoradaPesquisaController.prototype.navegarNaGrid = function (pagination) {
        this.parametrosPesquisa.numeroPagina = pagination.number;
        this.parametrosPesquisa.quantidadePorPagina = pagination.size;
        this.parametrosPesquisa.ordenacaoCampo = pagination.sortField;
        this.parametrosPesquisa.ordenacaoDirecao = pagination.sortDirection;
        return this.pesquisar(this.parametrosPesquisa);
    };
    SituacaoMonitoradaPesquisaController.prototype.exibirResultadoPesquisa = function () {
        this.resultadoVisivel = true;
    };
    SituacaoMonitoradaPesquisaController.prototype.limparResultadoPesquisa = function () {
        this.limparMensagens();
        this.esconderResultadoPesquisa();
    };
    SituacaoMonitoradaPesquisaController.prototype.esconderResultadoPesquisa = function () {
        this.resultadoVisivel = false;
    };
    SituacaoMonitoradaPesquisaController.prototype.limparMensagens = function () {
        this.feedbackService.limpar();
    };
    SituacaoMonitoradaPesquisaController.prototype.converterUrlParaParametros = function (filtro) {
        return {
            numeroPagina: ConverterParameterUrlToObjectUtils.number(filtro.numeroPagina),
            quantidadePorPagina: ConverterParameterUrlToObjectUtils.number(filtro.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterUrlToObjectUtils.string(filtro.ordenacaoDirecao),
            tipoResultado: ConverterParameterUrlToObjectUtils.string(filtro.tipoResultado),
            sistemaNegocio: ConverterParameterUrlToObjectUtils.atributoPK(filtro.sistemaNegocio),
            documento: ConverterParameterUrlToObjectUtils.atributoPK(filtro.documento),
            segmento: ConverterParameterUrlToObjectUtils.atributoCodigo(filtro.segmento),
            database: ConverterParameterUrlToObjectUtils.date(filtro.database),
            instituicao: ConverterParameterUrlToObjectUtils.atributoIdBacen(filtro.instituicao),
            possuiCriticaNao: ConverterParameterUrlToObjectUtils.atributoBoolean(filtro.possuiCriticaNao),
            possuiCriticaSim: ConverterParameterUrlToObjectUtils.atributoBoolean(filtro.possuiCriticaSim),
            campoMonitorado: ConverterParameterUrlToObjectUtils.string(filtro.campoMonitorado)
        };
    };
    SituacaoMonitoradaPesquisaController.prototype.normatizarData = function (data) {
        return ConverterParameterObjectToUrlUtils.date(data);
    };
    SituacaoMonitoradaPesquisaController.prototype.converterParametrosParaUrl = function (parametrosPesquisa) {
        var database = this.opcoesDeData.normatizar(parametrosPesquisa.database);
        return {
            jaPesquisado: true,
            numeroPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.numeroPagina),
            quantidadePorPagina: ConverterParameterObjectToUrlUtils.number(parametrosPesquisa.quantidadePorPagina),
            ordenacaoCampo: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoCampo),
            ordenacaoDirecao: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.ordenacaoDirecao),
            tipoResultado: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.tipoResultado),
            sistemaNegocio: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.sistemaNegocio),
            documento: ConverterParameterObjectToUrlUtils.atributoPK(parametrosPesquisa.documento),
            segmento: ConverterParameterObjectToUrlUtils.atributoCodigo(parametrosPesquisa.segmento),
            instituicao: ConverterParameterObjectToUrlUtils.atributoIdBacen(parametrosPesquisa.instituicao),
            database: ConverterParameterObjectToUrlUtils.date(database),
            possuiCriticaNao: ConverterParameterObjectToUrlUtils.atributoBoolean(parametrosPesquisa.possuiCriticaNao),
            possuiCriticaSim: ConverterParameterObjectToUrlUtils.atributoBoolean(parametrosPesquisa.possuiCriticaSim),
            campoMonitorado: ConverterParameterObjectToUrlUtils.string(parametrosPesquisa.campoMonitorado)
        };
    };
    SituacaoMonitoradaPesquisaController.prototype.exibirCamposRelacionadoCritica = function () {
        if (this.parametrosPesquisa == undefined) {
            return;
        }
        if ((this.parametrosPesquisa.possuiCriticaNao == false && this.parametrosPesquisa.possuiCriticaSim)
            || (this.parametrosPesquisa.possuiCriticaNao == false && this.parametrosPesquisa.possuiCriticaSim == false)) {
            return true;
        }
        else {
            this.parametrosPesquisa.segmento = undefined;
            this.parametrosPesquisa.instituicao = undefined;
            this.parametrosPesquisa.database = undefined;
            return false;
        }
    };
    SituacaoMonitoradaPesquisaController.prototype.limparParametrosPesquisa = function (form) {
        this.parametrosPesquisa.tipoResultado = "DOCUMENTO";
        this.parametrosPesquisa.possuiCriticaSim = true;
        this.parametrosPesquisa.possuiCriticaNao = false;
        this.parametrosPesquisa.sistemaNegocio = undefined;
        this.parametrosPesquisa.documento = undefined;
        this.parametrosPesquisa.segmento = undefined;
        this.parametrosPesquisa.instituicao = undefined;
        this.parametrosPesquisa.database = undefined;
        this.parametrosPesquisa.campoMonitorado = undefined;
        this.processarCheckTipoResultado(this.parametrosPesquisa.tipoResultado);
        this.limparMensagens();
        this.esconderResultadoPesquisa();
        FormularioUtils.reset(form, this.$scope);
    };
    SituacaoMonitoradaPesquisaController.prototype.realizarPesquisa = function (parametrosPesquisa) {
        parametrosPesquisa.numeroPagina = undefined;
        parametrosPesquisa.ordenacaoCampo = undefined;
        parametrosPesquisa.ordenacaoDirecao = undefined;
        return this.pesquisar(parametrosPesquisa);
    };
    SituacaoMonitoradaPesquisaController.prototype.pesquisar = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(parametrosPesquisa);
        this.$location.search(parametros);
        return this.situacaoMonitoradaApiService.pesquisar(parametros).then(function (resultado) {
            _this.pagina = resultado._embedded;
            _this.exibirResultadoPesquisa();
            return resultado;
        });
    };
    SituacaoMonitoradaPesquisaController.prototype.gerarExcel = function (parametrosPesquisa) {
        var _this = this;
        var parametros = this.converterParametrosParaUrl(this.parametrosPesquisa);
        return this.situacaoMonitoradaApiService.gerarExcel(parametros).then(function () {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return;
        });
    };
    SituacaoMonitoradaPesquisaController.prototype.processarCheckTipoResultado = function (valor) {
        if (valor !== undefined && valor === 'CAMPO') {
            this.exibirCamposResultadoPorCampo = true;
            this.parametrosPesquisa.documento = undefined;
            this.parametrosPesquisa.segmento = undefined;
            this.parametrosPesquisa.instituicao = undefined;
            this.parametrosPesquisa.database = undefined;
            this.carregarCampos(this.parametrosPesquisa.sistemaNegocio);
        }
        else {
            this.parametrosPesquisa.campoMonitorado = undefined;
            this.exibirCamposResultadoPorCampo = false;
        }
    };
    SituacaoMonitoradaPesquisaController.prototype.onPossuiCriticaSimSelecionada = function () {
        if (this.parametrosPesquisa.possuiCriticaSim) {
            this.parametrosPesquisa.possuiCriticaNao = false;
        }
        this.esconderResultadoPesquisa();
    };
    SituacaoMonitoradaPesquisaController.prototype.onPossuiCriticaNaoSelecionada = function () {
        if (this.parametrosPesquisa.possuiCriticaNao) {
            this.parametrosPesquisa.possuiCriticaSim = false;
        }
        this.esconderResultadoPesquisa();
    };
    SituacaoMonitoradaPesquisaController.prototype.carregarDadosTela = function (filtro) {
        var _this = this;
        return this.situacaoMonitoradaApiService.montarTelaPesquisa().then(function (montarTelaPesquisa) {
            var jaPossuiParametrosInformados = ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(filtro);
            _this.parametrosPesquisa = _this.converterUrlParaParametros(filtro);
            _this.dadosFormulario = montarTelaPesquisa._embedded;
            if (jaPossuiParametrosInformados) {
                _this.pesquisar(_this.parametrosPesquisa);
            }
            else {
                _this.parametrosPesquisa.tipoResultado = 'DOCUMENTO';
                _this.parametrosPesquisa.possuiCriticaSim = true;
                _this.parametrosPesquisa.possuiCriticaNao = false;
            }
            _this.carregarDocumentos(_this.parametrosPesquisa.sistemaNegocio);
            _this.processarCheckTipoResultado(_this.parametrosPesquisa.tipoResultado);
            return montarTelaPesquisa;
        });
    };
    SituacaoMonitoradaPesquisaController.prototype.$onInit = function () {
        return this.carregarDadosTela(this.$stateParams);
    };
    ;
    return SituacaoMonitoradaPesquisaController;
}());
SituacaoMonitoradaPesquisaController.$inject = ['$location', '$scope', '$stateParams', 'SituacaoMonitoradaApiService', 'CampoSituacaoMonitoradaApiService', 'feedbackService', 'documentoApiService'];
angular.module('crd').controller('SituacaoMonitoradaPesquisaController', SituacaoMonitoradaPesquisaController);
//# sourceMappingURL=situacao-monitorada-pesquisa-controller.js.map;
"use strict";
var SituacaoMonitoradaQualidadeUtilsImpl = (function () {
    function SituacaoMonitoradaQualidadeUtilsImpl(moment) {
        this.moment = moment;
        this.formatoData = 'YYYY-MM-DD';
    }
    SituacaoMonitoradaQualidadeUtilsImpl.prototype.isDataCompleta = function (data) {
        if (data === undefined) {
            return true;
        }
        return (data + "").length > 10;
    };
    SituacaoMonitoradaQualidadeUtilsImpl.prototype.isFimMaiorQueInicio = function (inicio, fim, podeSerIgual) {
        var formato = 'YYYYMMDD';
        var fimInt = parseInt(this.moment(fim).format(formato));
        var inicioInt = parseInt(this.moment(inicio).format(formato));
        return fimInt > inicioInt || (podeSerIgual && fimInt == inicioInt);
    };
    SituacaoMonitoradaQualidadeUtilsImpl.prototype.formatarData = function (data) {
        if (!data) {
            return null;
        }
        return this.moment(data, this.formatoData).toDate();
    };
    SituacaoMonitoradaQualidadeUtilsImpl.prototype.habilitarBotaoSalvar = function (formulario) {
        formulario.$invalid = false;
        formulario.$pristine = false;
    };
    SituacaoMonitoradaQualidadeUtilsImpl.prototype.validarFormulario = function (formulario, habilitarSalvar) {
        this._validarFormulario(formulario, habilitarSalvar);
    };
    SituacaoMonitoradaQualidadeUtilsImpl.prototype._validarFormulario = function (formulario, habilitarSalvar) {
        angular.forEach(formulario, function (field, name) {
            if (typeof name === 'string' && !name.match('^[\$]')) {
                if (field.$pristine) {
                    field.$dirty = true;
                }
            }
        });
        if (habilitarSalvar) {
            this.habilitarBotaoSalvar(formulario);
        }
    };
    return SituacaoMonitoradaQualidadeUtilsImpl;
}());
SituacaoMonitoradaQualidadeUtilsImpl.$inject = ['moment'];
angular.module('crd').service('CriticaQualidadeUtils', CriticaQualidadeUtilsImpl);
//# sourceMappingURL=situacao-monitorada-utils.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SituacaoPJApiService = (function (_super) {
    __extends(SituacaoPJApiService, _super);
    function SituacaoPJApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    SituacaoPJApiService.prototype.pesquisarParaSelecao = function (filtro, ignoreLoadingBar) {
        return this.buscarRecurso('/situacao-pj/pesquisar-para-selecao', filtro, { ignoreLoadingBar: ignoreLoadingBar });
    };
    return SituacaoPJApiService;
}(AbstractAPISerivce));
SituacaoPJApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('SituacaoPJApiService', SituacaoPJApiService);
//# sourceMappingURL=situacao-pj-api-service.js.map;
(function(angular) {
  'use strict';

  var AMBIENTE_PRODUCAO = 'PRODUCAO';

  angular
    .module('crd')
    .controller('AreaUsuarioController', AreaUsuarioController);

  AreaUsuarioController.$inject = ['$http', '$rootScope', '$window', 'appInfoApiService', 'usuarioService'];

  function AreaUsuarioController($http, $rootScope, $window, appInfoApiService, usuarioService) {
    var vm = this;
    vm.logout = logout;
    vm.clear = clear;
    vm.downloadManualAjuda = downloadManualAjuda;

    $onInit();

    function $onInit() {
      obterAmbienteExecucao();
    }

    function obterAmbienteExecucao() {
      appInfoApiService.get().then(function successOnAppInfo(resource) {
        vm.ambiente = resource.ambiente;
        vm.usuario = resource.usuarioLogado;
        vm.showClearStorageButton = vm.ambiente !== AMBIENTE_PRODUCAO;
      });
    }

    function logout() {
      clearStorage();
      if (vm.ambiente !== 'DESCONHECIDO'){
        $window.location.href = '/crd/rest/dologin?logout=true';
      } else {
        $rootScope.$emit('logout');
      }

    }

    function clear() {
      clearStorage();
      clearServerCache();
    }

    function clearServerCache() {
      return $http.post('/crd/rest/limpar-cache');
    }

    function clearStorage() {
      usuarioService.limparStorage();
    }

    function downloadManualAjuda() {
      return appInfoApiService.downloadManualAjuda();
    }
  }
})(angular);
;
(function(angular) {
  'use strict';

  angular
    .module('crd')
    .controller('CabecalhoController', CabecalhoController);

  CabecalhoController.$inject = ['$scope', '$state', '$interval', 'appInfoApiService'];

  function CabecalhoController($scope, $state, $interval, appInfoApiService) {
    var vm = this;

    vm.changelog = changelog;

    $scope.$on('$stateChangeSuccess', routeChangeSuccess);
    activated();

    function activated() {
      atualizarRelogio();
      appInfoApiService.get().then(function successOnAppInfo(resouce) {
        vm.appInfo = resouce;
      });
    }
               
    function atualizarRelogio() {
        vm.currentDate = new Date();
    }

    function changelog() {
      if(vm.appInfo.podeVerChangeLog) {
        $state.go('changelog');
      }
    }

    function routeChangeSuccess(event, toState) {
      // Alterar informações da página, baseado na informação de página presente na rota.
      if (angular.isDefined(toState.informacaoPagina)) {
        vm.informacaoPagina = toState.informacaoPagina;
      }
    }

    $interval(atualizarRelogio, 1000);
  }
})(angular);
;
(function(angular, _) {
  'use strict';

  angular
    .module('crd')
    .controller('MenuController', MenuController);

  MenuController.$inject = ['apiService', 'AplicacaoConfiguracaoApiService'];

  function MenuController(apiService, aplicacaoConfiguracaoApiService) {
    var vm = this;
    var links = {};
    vm.possuiAcesso = possuiAcesso;

    activated();

    function activated() {
      apiService.get(null, null).then(function successOnCarregarRaiz(resource) {
        angular.merge(links, resource._links);
      });
      aplicacaoConfiguracaoApiService.aplicacaoConfiguracao().then(function (response) {
        vm.menuItens = response.data.menuItens;
      });
    }

    function possuiAcesso(link) {
      return _.has(links, link);
    }
  }
})(angular, _);
;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AplicacaoConfiguracaoApiService = (function (_super) {
    __extends(AplicacaoConfiguracaoApiService, _super);
    function AplicacaoConfiguracaoApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    AplicacaoConfiguracaoApiService.prototype.aplicacaoConfiguracao = function () {
        return this.buscarRecurso('/aplicacao-configuracao', {}, {});
    };
    return AplicacaoConfiguracaoApiService;
}(AbstractAPISerivce));
AplicacaoConfiguracaoApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('AplicacaoConfiguracaoApiService', AplicacaoConfiguracaoApiService);
//# sourceMappingURL=aplicacao-configuracao-api-service.js.map;
"use strict";
var Status500Controller = (function () {
    function Status500Controller($rootScope) {
        this.$rootScope = $rootScope;
    }
    Status500Controller.prototype.$onDestroy = function () {
        this.$rootScope.paginaStatus = undefined;
    };
    Status500Controller.prototype.$onInit = function () {
        this.dados = this.$rootScope.paginaStatus;
        if (this.dados && this.dados.data) {
            this.dados.data.mensagem = this.dados.data.mensagem
                ? this.dados.data.mensagem
                    .replace(/\n/g, '<br>')
                    .replace('Por favor,', '<br><br>Por favor,')
                    .replace(/([\d]+)/g, "<b>$1</b>")
                : undefined;
        }
    };
    return Status500Controller;
}());
Status500Controller.$inject = ['$rootScope'];
angular.module('crd').controller('Status500Controller', Status500Controller);
//# sourceMappingURL=status-500-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ValidacaoPreProcessamentoApiService = (function (_super) {
    __extends(ValidacaoPreProcessamentoApiService, _super);
    function ValidacaoPreProcessamentoApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    ValidacaoPreProcessamentoApiService.prototype.pesquisarParaSelecao = function (filtro, ignoreLoadingBar) {
        return this.buscarRecurso('/validacao-pre-processamento/pesquisar-para-selecao', filtro, { ignoreLoadingBar: ignoreLoadingBar });
    };
    ValidacaoPreProcessamentoApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/validacao-pre-processamento/consultar', consultaFiltro);
    };
    return ValidacaoPreProcessamentoApiService;
}(AbstractAPISerivce));
ValidacaoPreProcessamentoApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('ValidacaoPreProcessamentoApiService', ValidacaoPreProcessamentoApiService);
//# sourceMappingURL=validacao-pre-processamento-api-service.js.map;
"use strict";
//# sourceMappingURL=validacao-processamento-consulta-filtro.js.map;
"use strict";
//# sourceMappingURL=validacao-processamento-para-consultar-dto.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ValidacaoProcessamentoApiService = (function (_super) {
    __extends(ValidacaoProcessamentoApiService, _super);
    function ValidacaoProcessamentoApiService(httpService, locationService, Blob, FileSaver) {
        var _this = _super.call(this, httpService, locationService, Blob, FileSaver) || this;
        _this.httpService = httpService;
        _this.locationService = locationService;
        _this.Blob = Blob;
        _this.FileSaver = FileSaver;
        return _this;
    }
    ValidacaoProcessamentoApiService.prototype.consultar = function (consultaFiltro) {
        return this.pesquisarRecurso('/validacao-processamento/consultar', consultaFiltro);
    };
    ValidacaoProcessamentoApiService.prototype.paraConsultar = function (consultaFiltro) {
        return this.buscarRecurso('/validacao-processamento/para-consultar', consultaFiltro);
    };
    ValidacaoProcessamentoApiService.prototype.relatorioExcel = function (consultaFiltro) {
        return this.baixarArquivo("/validacao-processamento/relatorio-em-excel", consultaFiltro);
    };
    ValidacaoProcessamentoApiService.prototype.pesquisarParaSelecao = function (consultaFiltro, ignoreLoadingBar) {
        return this.buscarRecurso('/validacao-processamento/pesquisar-para-selecao', consultaFiltro);
    };
    ValidacaoProcessamentoApiService.prototype.pesquisarParaSelecaoUnico = function (consultaFiltro, ignoreLoadingBar) {
        return this.buscarRecurso('/validacao-processamento/pesquisar-para-selecao-unico', consultaFiltro);
    };
    ValidacaoProcessamentoApiService.prototype.detalhar = function (id) {
        return this.buscarRecurso("/validacao-processamento/" + id + "/detalhar", {});
    };
    ValidacaoProcessamentoApiService.prototype.paraIncluir = function () {
        return this.buscarRecurso('/validacao-processamento/para-incluir');
    };
    ValidacaoProcessamentoApiService.prototype.incluir = function (dados) {
        return this.incluirRecurso('/validacao-processamento/incluir', dados);
    };
    ValidacaoProcessamentoApiService.prototype.paraAlterar = function (id) {
        return this.buscarRecurso("/validacao-processamento/" + id + "/para-alterar");
    };
    ValidacaoProcessamentoApiService.prototype.alterar = function (id, dados) {
        return this.alterarRecurso("/validacao-processamento/" + id + "/alterar", dados);
    };
    return ValidacaoProcessamentoApiService;
}(AbstractAPISerivce));
ValidacaoProcessamentoApiService.$inject = ['$http', '$location', 'Blob', 'FileSaver'];
angular.module('crd').service('ValidacaoProcessamentoApiService', ValidacaoProcessamentoApiService);
//# sourceMappingURL=validacao-processamento-api-service.js.map;
"use strict";
angular.module("crd").config(function ($stateProvider) {
    $stateProvider
        .state('validacao-processamento-consultar', {
        controller: 'ValidacaoProcessamentoConsultaController',
        controllerAs: 'validacaoProcessamentoConsultaCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5071',
            label: 'Validação de processamento',
            titulo: 'Validação de processamento'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: true,
        templateUrl: 'views/validacao-processamento/views/validacao-processamento-consulta/validacao-processamento-consulta-tpl.html',
        url: '/validacao-processamento?texto&codigo&nome&faseExecucao&modoExecucao&tipoExecucao&numeroPagina&quantidadePorPagina&ordenacaoCampo&ordenacaoDirecao'
    })
        .state('validacao-processamento-detalhar', {
        controller: 'ValidacaoProcessamentoDetalheController',
        controllerAs: 'validacaoProcessamentoDetalheCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5072',
            label: 'Validação pré processamento',
            titulo: 'Validação pré processamento'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/validacao-processamento/views/validacao-processamento-detalhe/validacao-processamento-detalhe-tpl.html',
        url: '/validacao-processamento/:id/detalhar'
    })
        .state('validacao-processamento-incluir', {
        controller: 'ValidacaoProcessamentoInclusaoController',
        controllerAs: 'validacaoProcessamentoInclusaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5073',
            label: 'Validação pré processamento',
            titulo: 'Validação pré processamento'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/validacao-processamento/views/validacao-processamento-inclusao/validacao-processamento-inclusao-tpl.html',
        url: '/validacao-processamento/incluir'
    })
        .state('validacao-processamento-alterar', {
        controller: 'ValidacaoProcessamentoAlteracaoController',
        controllerAs: 'validacaoProcessamentoAlteracaoCtrl',
        informacaoPagina: {
            codigo: 'CRDFW5074',
            label: 'Validação pré processamento',
            titulo: 'Validação pré processamento'
        },
        parent: 'admin',
        reloadOnSearch: false,
        searchSave: false,
        templateUrl: 'views/validacao-processamento/views/validacao-processamento-alteracao/validacao-processamento-alteracao-tpl.html',
        url: '/validacao-processamento/:id/alterar'
    });
});
//# sourceMappingURL=validacao-processamento-route-config.js.map;
"use strict";
var ValidacaoProcessamentoAlteracaoController = (function () {
    function ValidacaoProcessamentoAlteracaoController($state, feedbackService, validacaoProcessamentoApiService, locationStorageService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.validacaoProcessamentoApiService = validacaoProcessamentoApiService;
        this.locationStorageService = locationStorageService;
    }
    ValidacaoProcessamentoAlteracaoController.prototype.$onInit = function () {
        var _this = this;
        return this.validacaoProcessamentoApiService.paraAlterar(this.$state.params.id).then(function (response) {
            _this.dadosFormulario = response.data.dadosFormulario;
        });
    };
    ;
    ValidacaoProcessamentoAlteracaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            codigo: ConverterParameterObjectToUrlUtils.string(dadosFormulario.codigo),
            nome: ConverterParameterObjectToUrlUtils.string(dadosFormulario.nome),
            descricao: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricao),
            mensagem: ConverterParameterObjectToUrlUtils.string(dadosFormulario.mensagem),
            faseExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.faseExecucao),
            tipoExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoExecucao),
            modoExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.modoExecucao),
            ordemExecucao: ConverterParameterObjectToUrlUtils.number(dadosFormulario.ordemExecucao),
            formatoEnvio: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formatoEnvio)
        };
        return this.validacaoProcessamentoApiService.alterar(this.$state.params.id, dados).then(function (response) {
            if (response.status === 200) {
                _this.feedbackService.sucesso('Validação de pré-processamento alterada com sucesso.');
                _this.voltar();
            }
        });
    };
    ValidacaoProcessamentoAlteracaoController.prototype.voltar = function () {
        var consultaSalva = this.locationStorageService.get('/validacao-processamento');
        this.$state.go('validacao-processamento-consultar', consultaSalva ? consultaSalva.params : {});
    };
    return ValidacaoProcessamentoAlteracaoController;
}());
ValidacaoProcessamentoAlteracaoController.$inject = ['$state', 'feedbackService', 'ValidacaoProcessamentoApiService', 'locationStorageService'];
angular.module('crd').controller('ValidacaoProcessamentoAlteracaoController', ValidacaoProcessamentoAlteracaoController);
//# sourceMappingURL=validacao-processamento-alteracao-controller.js.map;
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ValidacaoProcessamentoConsultaController = (function (_super) {
    __extends(ValidacaoProcessamentoConsultaController, _super);
    function ValidacaoProcessamentoConsultaController($stateParams, $scope, feedbackService, validacaoProcessamentoApiService) {
        var _this = _super.call(this, $stateParams, $scope, feedbackService) || this;
        _this.$stateParams = $stateParams;
        _this.$scope = $scope;
        _this.feedbackService = feedbackService;
        _this.validacaoProcessamentoApiService = validacaoProcessamentoApiService;
        return _this;
    }
    ValidacaoProcessamentoConsultaController.prototype.dadosParaConstruir = function (consultaFiltro) {
        var _this = this;
        return this.validacaoProcessamentoApiService.paraConsultar(consultaFiltro).then(function (response) {
            if (!response.data) {
                return response;
            }
            _this.pagina = response.data.pagina;
            _this.dadosFormulario = response.data.dadosFormulario;
            _this.acao = response.data.acao;
            _this.restaurarFiltros(consultaFiltro);
            if (ConverterParameterUrlToObjectUtils.possuiParametrosDefinidos(consultaFiltro)) {
                var filtroPesquisa = _this.converterDadosDoFormToConsultaFiltro(_this.dadosFormulario);
                filtroPesquisa.numeroPagina = ConverterParameterUrlToObjectUtils.number(consultaFiltro.numeroPagina);
                filtroPesquisa.quantidadePorPagina = ConverterParameterUrlToObjectUtils.number(consultaFiltro.quantidadePorPagina);
                filtroPesquisa.ordenacaoCampo = consultaFiltro.ordenacaoCampo;
                filtroPesquisa.ordenacaoDirecao = consultaFiltro.ordenacaoDirecao;
                return _this.consultarRecurso(filtroPesquisa).then(function () { return response; });
            }
            return response;
        });
    };
    ValidacaoProcessamentoConsultaController.prototype.restaurarFiltros = function (consultaFiltro) {
        if (consultaFiltro.nome !== undefined) {
            this.dadosFormulario.nome = ConverterParameterUrlToObjectUtils.string(consultaFiltro.nome);
        }
        if (consultaFiltro.codigo !== undefined) {
            this.dadosFormulario.codigo = this.buscarOpcao(this.dadosFormulario.validacoes, consultaFiltro.codigo, 'codigo');
        }
        if (consultaFiltro.faseExecucao !== undefined) {
            this.dadosFormulario.faseExecucao = this.buscarOpcao(this.dadosFormulario.fasesExecucao, consultaFiltro.faseExecucao);
        }
        if (consultaFiltro.modoExecucao !== undefined) {
            this.dadosFormulario.modoExecucao = this.buscarOpcao(this.dadosFormulario.modosExecucao, consultaFiltro.modoExecucao);
        }
        if (consultaFiltro.tipoExecucao !== undefined) {
            this.dadosFormulario.tipoExecucao = this.buscarOpcao(this.dadosFormulario.tiposExecucao, consultaFiltro.tipoExecucao);
        }
    };
    ValidacaoProcessamentoConsultaController.prototype.buscarOpcao = function (opcoes, valor, propriedade) {
        if (propriedade === void 0) { propriedade = 'enumName'; }
        if (!opcoes) {
            return undefined;
        }
        for (var indice = 0; indice < opcoes.length; indice++) {
            if (String(opcoes[indice][propriedade]) === String(valor)) {
                return opcoes[indice];
            }
        }
        return undefined;
    };
    ValidacaoProcessamentoConsultaController.prototype.consultarRecurso = function (consultaFiltro) {
        var _this = this;
        return this.validacaoProcessamentoApiService.consultar(consultaFiltro).then(function (response) {
            _this.pagina = response.data;
            return response;
        });
    };
    ValidacaoProcessamentoConsultaController.prototype.converterDadosDoFormToConsultaFiltro = function (dadosFormulario) {
        return {
            codigo: ConverterParameterObjectToUrlUtils.string(this.dadosFormulario.codigo ? this.dadosFormulario.codigo.codigo : this.dadosFormulario.codigo),
            nome: ConverterParameterObjectToUrlUtils.string(this.dadosFormulario.nome),
            faseExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(this.dadosFormulario.faseExecucao),
            modoExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(this.dadosFormulario.modoExecucao),
            tipoExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(this.dadosFormulario.tipoExecucao)
        };
    };
    ValidacaoProcessamentoConsultaController.prototype.limparDadosFormulario = function (dadosFormulario) {
        dadosFormulario.codigo = undefined;
        dadosFormulario.nome = undefined;
        dadosFormulario.faseExecucao = undefined;
        dadosFormulario.modoExecucao = undefined;
        dadosFormulario.tipoExecucao = undefined;
    };
    ValidacaoProcessamentoConsultaController.prototype.gerarRelatorioEmExcel = function (dadosFormulario) {
        var _this = this;
        var parametros = this.converterDadosDoFormToConsultaFiltro(dadosFormulario);
        return this.validacaoProcessamentoApiService.relatorioExcel(parametros).then(function (response) {
            _this.feedbackService.sucesso('Relatório gerado com sucesso.');
            return response;
        });
    };
    return ValidacaoProcessamentoConsultaController;
}(AbstractPaginaConsultaController));
ValidacaoProcessamentoConsultaController.$inject = ['$stateParams', '$scope', 'feedbackService', 'ValidacaoProcessamentoApiService'];
angular.module('crd').controller('ValidacaoProcessamentoConsultaController', ValidacaoProcessamentoConsultaController);
//# sourceMappingURL=validacao-processamento-consulta-controller.js.map;
"use strict";
var ValidacaoProcessamentoDetalheController = (function () {
    function ValidacaoProcessamentoDetalheController($state, feedbackService, validacaoProcessamentoApiService, locationStorageService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.validacaoProcessamentoApiService = validacaoProcessamentoApiService;
        this.locationStorageService = locationStorageService;
    }
    ValidacaoProcessamentoDetalheController.prototype.$onInit = function () {
        var _this = this;
        return this.validacaoProcessamentoApiService.detalhar(this.$state.params.id).then(function (response) {
            _this.item = response.data;
        });
    };
    ;
    ValidacaoProcessamentoDetalheController.prototype.voltar = function () {
        var consultaSalva = this.locationStorageService.get('/validacao-processamento');
        this.$state.go('validacao-processamento-consultar', consultaSalva ? consultaSalva.params : {});
    };
    return ValidacaoProcessamentoDetalheController;
}());
ValidacaoProcessamentoDetalheController.$inject = ['$state', 'feedbackService', 'ValidacaoProcessamentoApiService', 'locationStorageService'];
angular.module('crd').controller('ValidacaoProcessamentoDetalheController', ValidacaoProcessamentoDetalheController);
//# sourceMappingURL=validacao-processamento-detalhe-controller.js.map;
"use strict";
var ValidacaoProcessamentoInclusaoController = (function () {
    function ValidacaoProcessamentoInclusaoController($state, feedbackService, validacaoProcessamentoApiService, locationStorageService) {
        this.$state = $state;
        this.feedbackService = feedbackService;
        this.validacaoProcessamentoApiService = validacaoProcessamentoApiService;
        this.locationStorageService = locationStorageService;
    }
    ValidacaoProcessamentoInclusaoController.prototype.$onInit = function () {
        var _this = this;
        return this.validacaoProcessamentoApiService.paraIncluir().then(function (response) {
            _this.dadosFormulario = response.data.dadosFormulario;
        });
    };
    ;
    ValidacaoProcessamentoInclusaoController.prototype.salvar = function (dadosFormulario) {
        var _this = this;
        var dados = {
            codigo: ConverterParameterObjectToUrlUtils.string(dadosFormulario.codigo),
            nome: ConverterParameterObjectToUrlUtils.string(dadosFormulario.nome),
            descricao: ConverterParameterObjectToUrlUtils.string(dadosFormulario.descricao),
            mensagem: ConverterParameterObjectToUrlUtils.string(dadosFormulario.mensagem),
            faseExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.faseExecucao),
            tipoExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.tipoExecucao),
            modoExecucao: ConverterParameterObjectToUrlUtils.atributoEnumName(dadosFormulario.modoExecucao),
            ordemExecucao: ConverterParameterObjectToUrlUtils.number(dadosFormulario.ordemExecucao),
            formatoEnvio: ConverterParameterObjectToUrlUtils.string(dadosFormulario.formatoEnvio)
        };
        return this.validacaoProcessamentoApiService.incluir(dados).then(function (response) {
            if (response.status === 201) {
                _this.feedbackService.sucesso('Validação de pré-processamento incluído com sucesso.');
                _this.voltar();
            }
        });
    };
    ValidacaoProcessamentoInclusaoController.prototype.voltar = function () {
        var consultaSalva = this.locationStorageService.get('/validacao-processamento');
        this.$state.go('validacao-processamento-consultar', consultaSalva ? consultaSalva.params : {});
    };
    return ValidacaoProcessamentoInclusaoController;
}());
ValidacaoProcessamentoInclusaoController.$inject = ['$state', 'feedbackService', 'ValidacaoProcessamentoApiService', 'locationStorageService'];
angular.module('crd').controller('ValidacaoProcessamentoInclusaoController', ValidacaoProcessamentoInclusaoController);
//# sourceMappingURL=validacao-processamento-inclusao-controller.js.map